module.exports=[
  {
    "id": 1,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Grays Harbor Health & Rehab Center",
    "latitude": 46.979359,
    "longitude": -123.84617,
    "original_address": "930 Anderson Drive",
    "building_number": 930,
    "street": "Anderson Dr",
    "city": "Aberdeen",
    "zip": 98520,
    "concatenated_address": "930 Anderson Dr, Aberdeen",
    "address": "930 Anderson Drive, Aberdeen"
  },
  {
    "id": 2,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Copper Landing Apartments",
    "latitude": 47.646487,
    "longitude": -117.56103,
    "original_address": "600-800 South Hayford Road",
    "building_number": "",
    "street": "S Hayford Rd",
    "city": "Airway Heights",
    "zip": 99001,
    "concatenated_address": "600-800 South Hayford Road, Airway Heights",
    "address": "600-800 S. Hayford Road, Airway Heights"
  },
  {
    "id": 3,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Fidalgo Care Center Assisted Living",
    "latitude": 48.500304,
    "longitude": -122.61412,
    "original_address": "1105 27th Street",
    "building_number": 1105,
    "street": "27th St",
    "city": "Anacortes",
    "zip": 98221,
    "concatenated_address": "1105 27th St, Anacortes",
    "address": "1105 27th St., Anacortes"
  },
  {
    "id": 4,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "South Village Apartments",
    "latitude": 48.183153,
    "longitude": -122.12707,
    "original_address": "20721 Olympic Pl Ne",
    "building_number": 20721,
    "street": "Olympic Pl",
    "city": "Arlington",
    "zip": 98223,
    "concatenated_address": "20721 Olympic Pl, Arlington",
    "address": "20721 Olympic Place, Arlington"
  },
  {
    "id": 5,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Portage Green",
    "latitude": 48.178818,
    "longitude": -122.12283,
    "original_address": "20227 80th Ave N.E.",
    "building_number": 20227,
    "street": "80th Ave NE",
    "city": "Arlington",
    "zip": 98223,
    "concatenated_address": "20227 80th Ave NE, Arlington",
    "address": "20227 80th Ave. N.E., Arlington"
  },
  {
    "id": 6,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Park 77 Apartments",
    "latitude": 48.180966,
    "longitude": -122.1264,
    "original_address": "20201 77th Avenue Northeast",
    "building_number": 20201,
    "street": "77th Ave NE",
    "city": "Arlington",
    "zip": 98223,
    "concatenated_address": "20201 77th Ave NE, Arlington",
    "address": "20201 77th Ave. N.E., Arlington"
  },
  {
    "id": 7,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Stillaguamish Apartments",
    "latitude": 48.16269,
    "longitude": -122.18306,
    "original_address": "18308 Smokey Point Blvd",
    "building_number": 18308,
    "street": "Smokey Point Blvd",
    "city": "Arlington",
    "zip": 98223,
    "concatenated_address": "18308 Smokey Point Blvd, Arlington",
    "address": "18308 Smokey Point Blvd., Arlington"
  },
  {
    "id": 8,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Olympic Place Retirement And Assisted Living",
    "latitude": 48.185915,
    "longitude": -122.12525,
    "original_address": "20909 Olympic Place",
    "building_number": 20909,
    "street": "Olympic Pl",
    "city": "Arlington",
    "zip": 98223,
    "concatenated_address": "20909 Olympic Pl, Arlington",
    "address": "20909 Olympic Place, Arlington"
  },
  {
    "id": 9,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Affinity At Arlington",
    "latitude": 48.181498,
    "longitude": -121.95947,
    "original_address": "Nec 169th & Smokey Point Blvd",
    "building_number": "",
    "street": "",
    "city": "Arlington",
    "zip": 98223,
    "concatenated_address": "Nec 169th & Smokey Point Blvd, Arlington",
    "address": "3721 169th St. N.E. Arlington"
  },
  {
    "id": 10,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "2922 Southeast M Street",
    "latitude": 47.308286,
    "longitude": -122.21681,
    "original_address": "2922 Se \"M\" St",
    "building_number": "",
    "street": "",
    "city": "Auburn",
    "zip": 98002,
    "concatenated_address": "2922 Se \"M\" St, Auburn",
    "address": "2922 S.E. M St., Auburn"
  },
  {
    "id": 11,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Mill Pond Apartments",
    "latitude": 47.266253,
    "longitude": -122.21939,
    "original_address": "703 47th Street Se",
    "building_number": 703,
    "street": "47th St SE",
    "city": "Auburn",
    "zip": 98092,
    "concatenated_address": "703 47th St SE, Auburn",
    "address": "703 47th St. S.E., Auburn"
  },
  {
    "id": 12,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "I Street Townhouses",
    "latitude": 47.327917,
    "longitude": -122.22031,
    "original_address": "2317-2337 I Street Ne",
    "building_number": 2337,
    "street": "I St NE",
    "city": "Auburn",
    "zip": 98009,
    "concatenated_address": "2337 I St NE, Auburn",
    "address": "2337 I St. N.E., Auburn"
  },
  {
    "id": 13,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Auburn Glen Apartment Homes",
    "latitude": 47.291683,
    "longitude": -122.22826,
    "original_address": "1902 A Street Se",
    "building_number": 1902,
    "street": "A St SE",
    "city": "Auburn",
    "zip": 98002,
    "concatenated_address": "1902 A St SE, Auburn",
    "address": "1902 A St. S.E., Auburn"
  },
  {
    "id": 14,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Skylark Village I And II MHC",
    "latitude": 47.28152,
    "longitude": -122.21692,
    "original_address": "900 29th Street Se And 3105 M Street Se",
    "building_number": 900,
    "street": "29th St SE",
    "city": "Auburn",
    "zip": 98002,
    "concatenated_address": "900 29th St SE, Auburn",
    "address": "900 29th St. S.E., Auburn"
  },
  {
    "id": 15,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Gentry Walk Apartments",
    "latitude": 47.322195,
    "longitude": -122.1722,
    "original_address": "12725 Se 312th Street",
    "building_number": 12725,
    "street": "SE 312th St",
    "city": "Auburn",
    "zip": 98092,
    "concatenated_address": "12725 SE 312th St, Auburn",
    "address": "12725 S.E. 312th St., Auburn"
  },
  {
    "id": 16,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Trek Apartments",
    "latitude": 47.498007,
    "longitude": -121.78255,
    "original_address": "2 East Main Street & 12-16 South Division Street",
    "building_number": "",
    "street": "Main Ave N",
    "city": "North Bend",
    "zip": 98002,
    "concatenated_address": "2 East Main Street & 12-16 South Division Street, North Bend",
    "address": "2 East Main St. & 12-16 S. Division St., North Bend"
  },
  {
    "id": 17,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Amberview Apartments",
    "latitude": 47.31365,
    "longitude": -122.20157,
    "original_address": "32115 105th Place Se",
    "building_number": 32115,
    "street": "105th Pl SE",
    "city": "Auburn",
    "zip": 98092,
    "concatenated_address": "32115 105th Pl SE, Auburn",
    "address": "32115 105th Place S.E., Auburn"
  },
  {
    "id": 18,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Palermo At Lakeland",
    "latitude": 47.243256,
    "longitude": -122.21391,
    "original_address": "7101 Lindsay Avenue Se",
    "building_number": 7101,
    "street": "Lindsay Ave SE",
    "city": "Auburn",
    "zip": 98092,
    "concatenated_address": "7101 Lindsay Ave SE, Auburn",
    "address": "7101 Lindsay Ave. S.E., Auburn"
  },
  {
    "id": 19,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "The Park At Auburn Apartments",
    "latitude": 47.302737,
    "longitude": -122.21166,
    "original_address": "510 M Street Se",
    "building_number": 510,
    "street": "M St SE",
    "city": "Auburn",
    "zip": 98002,
    "concatenated_address": "510 M St SE, Auburn",
    "address": "510 M St. S.E., Auburn"
  },
  {
    "id": 20,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Neely Station",
    "latitude": 47.315768,
    "longitude": -122.21038,
    "original_address": "1451 8th Street Ne",
    "building_number": 1451,
    "street": "8th St NE",
    "city": "Auburn",
    "zip": 98002,
    "concatenated_address": "1451 8th St NE, Auburn",
    "address": "1451 8th St. N.E., Auburn"
  },
  {
    "id": 21,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Auburn Green",
    "latitude": 47.280769,
    "longitude": -122.21973,
    "original_address": "602 29th Street S.E.",
    "building_number": 602,
    "street": "29th St SE",
    "city": "Auburn",
    "zip": 98002,
    "concatenated_address": "602 29th St SE, Auburn",
    "address": "602 29th St. S.E., Auburn"
  },
  {
    "id": 22,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Pasa Fino Apartments",
    "latitude": 47.323448,
    "longitude": -122.17965,
    "original_address": "12110 Se 312th Street",
    "building_number": 12110,
    "street": "SE 312th St",
    "city": "Auburn",
    "zip": 98092,
    "concatenated_address": "12110 SE 312th St, Auburn",
    "address": "12110 S.E. 312th St., Auburn"
  },
  {
    "id": 23,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Four Lakes Apartments",
    "latitude": 47.248491,
    "longitude": -122.19972,
    "original_address": "6821 Udall Place Southeast",
    "building_number": 6821,
    "street": "Udall Pl SE",
    "city": "Auburn",
    "zip": 98092,
    "concatenated_address": "6821 Udall Pl SE, Auburn",
    "address": "6821 Udall Place S.E., Auburn"
  },
  {
    "id": 24,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Sherwood Garden Apartments",
    "latitude": 47.28698,
    "longitude": -122.19085,
    "original_address": "2901 Auburn Way South",
    "building_number": 2901,
    "street": "Auburn Way S",
    "city": "Auburn",
    "zip": 98092,
    "concatenated_address": "2901 Auburn Way S, Auburn",
    "address": "2901 Auburn Way S., Auburn"
  },
  {
    "id": 25,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Belara At Lakeland",
    "latitude": 47.253581,
    "longitude": -122.22473,
    "original_address": "6170 Terrace View Lane Southeast",
    "building_number": 6170,
    "street": "Terrace View Ln SE",
    "city": "Auburn",
    "zip": 98092,
    "concatenated_address": "6170 Terrace View Ln SE, Auburn",
    "address": "6170 Terrace View Lane S.E., Auburn"
  },
  {
    "id": 26,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Parkview Apartments",
    "latitude": 47.314274,
    "longitude": -122.22328,
    "original_address": "502 8th St Ne",
    "building_number": 502,
    "street": "8th St NE",
    "city": "Auburn",
    "zip": 98002,
    "concatenated_address": "502 8th St NE, Auburn",
    "address": "502 8th St. N.E., Auburn"
  },
  {
    "id": 27,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Costa Alegra Apartments",
    "latitude": 47.31203,
    "longitude": -122.22951,
    "original_address": "502 North Division Street",
    "building_number": 502,
    "street": "N Division St",
    "city": "Auburn",
    "zip": 98002,
    "concatenated_address": "502 N Division St, Auburn",
    "address": "502 N. Division St., Auburn"
  },
  {
    "id": 28,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Regency Auburn",
    "latitude": 47.293251,
    "longitude": -122.22362,
    "original_address": "414 17th Street Se",
    "building_number": 414,
    "street": "17th St SE",
    "city": "Auburn",
    "zip": 98002,
    "concatenated_address": "414 17th St SE, Auburn",
    "address": "414 17th St. S.E., Auburn"
  },
  {
    "id": 29,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Island Homestead",
    "latitude": 47.629517,
    "longitude": -122.5193,
    "original_address": "541 Homestead Lane Ne",
    "building_number": 541,
    "street": "Homestead Ln",
    "city": "Bainbridge Island",
    "zip": 98110,
    "concatenated_address": "541 Homestead Ln, Bainbridge Island",
    "address": "541 Homestead Lane, Bainbridge Island"
  },
  {
    "id": 30,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Cooper Apartments",
    "latitude": 47.628321,
    "longitude": -122.52461,
    "original_address": "348-390 Root Path Nw",
    "building_number": 390,
    "street": "Root Path",
    "city": "Bainbridge Island",
    "zip": 98110,
    "concatenated_address": "390 Root Path, Bainbridge Island",
    "address": "390 Root Path, Bainbridge Island"
  },
  {
    "id": 31,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Islander MHP",
    "latitude": 47.62735,
    "longitude": -122.51805,
    "original_address": "204-520 Madrona Way",
    "building_number": 520,
    "street": "Madrona Way",
    "city": "Bainbridge Island",
    "zip": 94110,
    "concatenated_address": "520 Madrona Way, Bainbridge Island",
    "address": "520 Madrona Way, Bainbridge Island"
  },
  {
    "id": 32,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Winslow Manor",
    "latitude": 47.623458,
    "longitude": -122.52347,
    "original_address": "234 Wood Avenue",
    "building_number": 234,
    "street": "Wood Ave",
    "city": "Bainbridge Island",
    "zip": 98110,
    "concatenated_address": "234 Wood Ave, Bainbridge Island",
    "address": "234 Wood Ave., Bainbridge Island"
  },
  {
    "id": 33,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Wyatt House Retirement Center",
    "latitude": 47.628644,
    "longitude": -122.52169,
    "original_address": "186 Wyatt Way Nw",
    "building_number": 186,
    "street": "Wyatt Way NW",
    "city": "Bainbridge Island",
    "zip": 98110,
    "concatenated_address": "186 Wyatt Way NW, Bainbridge Island",
    "address": "186 Wyatt Way N.W., Bainbridge Island"
  },
  {
    "id": 34,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Meadow View Apartments",
    "latitude": 45.785379,
    "longitude": -122.55788,
    "original_address": "611 Nw 20th Avenue",
    "building_number": 611,
    "street": "NW 20th Ave",
    "city": "Battle Ground",
    "zip": 98604,
    "concatenated_address": "611 NW 20th Ave, Battle Ground",
    "address": "611 N.W. 20th Ave., Battle Ground"
  },
  {
    "id": 35,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Mallard Landing",
    "latitude": 45.774909,
    "longitude": -122.52832,
    "original_address": "813 Southeast Clark Avenue",
    "building_number": 813,
    "street": "SE Clark Ave",
    "city": "Battle Ground",
    "zip": 98604,
    "concatenated_address": "813 SE Clark Ave, Battle Ground",
    "address": "813 S.E. Clark Ave., Battle Ground"
  },
  {
    "id": 36,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "The Crossings At Battle Ground Village",
    "latitude": 45.774256,
    "longitude": -122.52517,
    "original_address": "901 Se 11th Place",
    "building_number": 901,
    "street": "SE 11th Pl",
    "city": "Battle Ground",
    "zip": 98604,
    "concatenated_address": "901 SE 11th Pl, Battle Ground",
    "address": "901 S.E. 11th Place, Battle Ground"
  },
  {
    "id": 37,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Westwood Commons",
    "latitude": 45.777933,
    "longitude": -122.55373,
    "original_address": "218 Sw 15th Avenue",
    "building_number": 218,
    "street": "SW 15th Ave",
    "city": "Battle Ground",
    "zip": 98604,
    "concatenated_address": "218 SW 15th Ave, Battle Ground",
    "address": "218 S.W. 15th Ave., Battle Ground"
  },
  {
    "id": 38,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Bellevue Meadows",
    "latitude": 47.649198,
    "longitude": -122.14532,
    "original_address": "4277 148th Avenue N.E.",
    "building_number": 4277,
    "street": "148th Ave NE",
    "city": "Bellevue",
    "zip": 98007,
    "concatenated_address": "4277 148th Ave NE, Bellevue",
    "address": "4277 148th Ave. N.E., Bellevue"
  },
  {
    "id": 39,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "16053 & 16057 Northeast 8th Street Apartments",
    "latitude": 47.616435,
    "longitude": -122.12465,
    "original_address": "16053 Northeast 8th Street16057 Northeast 8th Street",
    "building_number": 16053,
    "street": "NE 8th St",
    "city": "Bellevue",
    "zip": 98008,
    "concatenated_address": "16053 NE 8th St, Bellevue",
    "address": "16053 N.E. 8th St., Bellevue"
  },
  {
    "id": 40,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "The Regent At Bellevue Way",
    "latitude": 47.637151,
    "longitude": -122.1994,
    "original_address": "10600 Ne 29th Street",
    "building_number": 10600,
    "street": "NE 29th St",
    "city": "Bellevue",
    "zip": 98004,
    "concatenated_address": "10600 NE 29th St, Bellevue",
    "address": "10600 N.E. 29th St., Bellevue"
  },
  {
    "id": 41,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Catalina Apartments",
    "latitude": 47.5916,
    "longitude": -122.16338,
    "original_address": "2210 132nd Avenue Se",
    "building_number": 2210,
    "street": "132nd Ave SE",
    "city": "Bellevue",
    "zip": 98005,
    "concatenated_address": "2210 132nd Ave SE, Bellevue",
    "address": "2210 132nd Ave. S.E., Bellevue"
  },
  {
    "id": 42,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Bellevue One Condominium Apartments",
    "latitude": 47.64232,
    "longitude": -122.18811,
    "original_address": "11249 North East 36th Pl",
    "building_number": 11249,
    "street": "NE 36th Pl",
    "city": "Bellevue",
    "zip": 98004,
    "concatenated_address": "11249 NE 36th Pl, Bellevue",
    "address": "11249 N.E. 36th Place, Bellevue"
  },
  {
    "id": 43,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "The Commodore Apartments",
    "latitude": 47.605245,
    "longitude": -122.20178,
    "original_address": "537 Bellevue Way Se",
    "building_number": 537,
    "street": "Bellevue Way SE",
    "city": "Bellevue",
    "zip": 98004,
    "concatenated_address": "537 Bellevue Way SE, Bellevue",
    "address": "537 Bellevue Way S.E., Bellevue"
  },
  {
    "id": 44,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Factoria Villas",
    "latitude": 47.573985,
    "longitude": -122.16791,
    "original_address": "12828 Se 40th Lane",
    "building_number": 12828,
    "street": "SE 40th Ln",
    "city": "Bellevue",
    "zip": 98006,
    "concatenated_address": "12828 SE 40th Ln, Bellevue",
    "address": "12828 S.E. 40th Lane, Bellevue"
  },
  {
    "id": 45,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "The Gardens At Town Square",
    "latitude": 47.618753,
    "longitude": -122.1924,
    "original_address": "933 111th Avenue Ne",
    "building_number": 933,
    "street": "111th Ave NE",
    "city": "Bellevue",
    "zip": 98004,
    "concatenated_address": "933 111th Ave NE, Bellevue",
    "address": "933 111th Ave. N.E., Bellevue"
  },
  {
    "id": 46,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Ashton Bellevue",
    "latitude": 47.61973,
    "longitude": -122.19691,
    "original_address": "10710 Ne 10th Street",
    "building_number": 10710,
    "street": "NE 10th St",
    "city": "Bellevue",
    "zip": 98004,
    "concatenated_address": "10710 NE 10th St, Bellevue",
    "address": "10710 N.E. 10th St., Bellevue"
  },
  {
    "id": 47,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Milano Apartments",
    "latitude": 47.617766,
    "longitude": -122.17749,
    "original_address": "12224 Ne 8th Street",
    "building_number": 12224,
    "street": "NE 8th St",
    "city": "Bellevue",
    "zip": 98005,
    "concatenated_address": "12224 NE 8th St, Bellevue",
    "address": "12224 N.E. 8th St., Bellevue"
  },
  {
    "id": 48,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Adagio Apartments",
    "latitude": 47.643123,
    "longitude": -122.14397,
    "original_address": "3615 147th Place Ne",
    "building_number": 3615,
    "street": "147th Pl NE",
    "city": "Bellevue",
    "zip": 98007,
    "concatenated_address": "3615 147th Pl NE, Bellevue",
    "address": "3615 147th Place N.E., Bellevue"
  },
  {
    "id": 49,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Juniper Ridge",
    "latitude": 47.584244,
    "longitude": -122.1752,
    "original_address": "12112 Se 31st Street",
    "building_number": 12112,
    "street": "SE 31st St",
    "city": "Bellevue",
    "zip": 98005,
    "concatenated_address": "12112 SE 31st St, Bellevue",
    "address": "12112 S.E. 31st St., Bellevue"
  },
  {
    "id": 50,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Colonial Square Apartment Homes",
    "latitude": 47.624416,
    "longitude": -122.13187,
    "original_address": "1616 156th Avenue Ne",
    "building_number": 1616,
    "street": "156th Ave NE",
    "city": "Bellevue",
    "zip": 98007,
    "concatenated_address": "1616 156th Ave NE, Bellevue",
    "address": "1616 156th Ave. N.E., Bellevue"
  },
  {
    "id": 51,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Liv Bel-Red",
    "latitude": 47.629516,
    "longitude": -122.13446,
    "original_address": "2170 Ne Bel-Red Road",
    "building_number": 2168,
    "street": "Bel Red Rd",
    "city": "Bellevue",
    "zip": 98007,
    "concatenated_address": "2168 Bel Red Rd, Bellevue",
    "address": "2168 Bel Red Road, Bellevue"
  },
  {
    "id": 52,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Martine Apartments",
    "latitude": 47.61766,
    "longitude": -122.15564,
    "original_address": "13842 Northeast 8th Street",
    "building_number": 13842,
    "street": "NE 8th St",
    "city": "Bellevue",
    "zip": 98005,
    "concatenated_address": "13842 NE 8th St, Bellevue",
    "address": "13842 N.E. 8th St., Bellevue"
  },
  {
    "id": 53,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Park Metro Apartments",
    "latitude": 47.620734,
    "longitude": -122.19262,
    "original_address": "11101 Ne 12th Street",
    "building_number": 11101,
    "street": "NE 12th St",
    "city": "Bellevue",
    "zip": 98004,
    "concatenated_address": "11101 NE 12th St, Bellevue",
    "address": "11101 N.E. 12th St., Bellevue"
  },
  {
    "id": 54,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Cross Creek Apartments",
    "latitude": 47.571396,
    "longitude": -122.17402,
    "original_address": "4160 124th Avenue Se",
    "building_number": 4160,
    "street": "124th Ave SE",
    "city": "Bellevue",
    "zip": 98006,
    "concatenated_address": "4160 124th Ave SE, Bellevue",
    "address": "4160 124th Ave. S.E., Bellevue"
  },
  {
    "id": 55,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Sequoia Grove Apartments",
    "latitude": 47.584493,
    "longitude": -122.16653,
    "original_address": "13001 Se 28th Place",
    "building_number": 13001,
    "street": "SE 28th Pl",
    "city": "Bellevue",
    "zip": 98005,
    "concatenated_address": "13001 SE 28th Pl, Bellevue",
    "address": "13001 S.E. 28th Place, Bellevue"
  },
  {
    "id": 56,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Kelsey Ridge Apartment Homes",
    "latitude": 47.595286,
    "longitude": -122.1609,
    "original_address": "1680 134th Avenue Se",
    "building_number": 1680,
    "street": "134th Ave SE",
    "city": "Bellevue",
    "zip": 98005,
    "concatenated_address": "1680 134th Ave SE, Bellevue",
    "address": "1680 134th Ave. S.E., Bellevue"
  },
  {
    "id": 57,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Aegis Of Bellevue",
    "latitude": 47.608961,
    "longitude": -122.20323,
    "original_address": "148 102nd Avenue",
    "building_number": 148,
    "street": "102nd Ave SE",
    "city": "Bellevue",
    "zip": 98004,
    "concatenated_address": "148 102nd Ave SE, Bellevue",
    "address": "148 102nd Ave. S.E., Bellevue"
  },
  {
    "id": 58,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Edgewood Park Apartment Homes",
    "latitude": 47.59705,
    "longitude": -122.15116,
    "original_address": "1501 145th Place Se",
    "building_number": 1501,
    "street": "145th Pl SE",
    "city": "Bellevue",
    "zip": 98007,
    "concatenated_address": "1501 145th Pl SE, Bellevue",
    "address": "1501 145th Place S.E., Bellevue"
  },
  {
    "id": 59,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Kamber Ridge Apartments",
    "latitude": 47.594809,
    "longitude": -122.14973,
    "original_address": "14260 Se 18th Street",
    "building_number": 14260,
    "street": "SE 18th St",
    "city": "Bellevue",
    "zip": 98007,
    "concatenated_address": "14260 SE 18th St, Bellevue",
    "address": "14260 S.E. 18th St., Bellevue"
  },
  {
    "id": 60,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "The Fountains At Pacific Regent Bellevue",
    "latitude": 47.615471,
    "longitude": -122.20722,
    "original_address": "923 Avenue Northeast",
    "building_number": "",
    "street": "",
    "city": "Bellevue",
    "zip": 98004,
    "concatenated_address": "923 Avenue Northeast, Bellevue",
    "address": "923 Ave. N.E., Bellevue"
  },
  {
    "id": 61,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Kamber Ridge",
    "latitude": 47.594809,
    "longitude": -122.14973,
    "original_address": "14260 Se 18th Street",
    "building_number": 14260,
    "street": "SE 18th St",
    "city": "Bellevue",
    "zip": 98007,
    "concatenated_address": "14260 SE 18th St, Bellevue",
    "address": "14260 S.E. 18th St., Bellevue"
  },
  {
    "id": 62,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Twelve Central Square Apartments",
    "latitude": 47.621792,
    "longitude": -122.20341,
    "original_address": "10290 Northeast 12th Street",
    "building_number": 10290,
    "street": "NE 12th St",
    "city": "Bellevue",
    "zip": 98004,
    "concatenated_address": "10290 NE 12th St, Bellevue",
    "address": "10290 N.E. 12th St., Bellevue"
  },
  {
    "id": 63,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Central Park East",
    "latitude": 47.6242,
    "longitude": -122.13513,
    "original_address": "15207 Northeast 16th Place",
    "building_number": 15207,
    "street": "NE 16th Pl",
    "city": "Bellevue",
    "zip": 98007,
    "concatenated_address": "15207 NE 16th Pl, Bellevue",
    "address": "15207 N.E. 16th Place, Bellevue"
  },
  {
    "id": 64,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Ten 20",
    "latitude": 47.619833,
    "longitude": -122.19593,
    "original_address": "1020 108th Avenue Northeast",
    "building_number": 1020,
    "street": "108th Ave NE",
    "city": "Bellevue",
    "zip": 98004,
    "concatenated_address": "1020 108th Ave NE, Bellevue",
    "address": "1020 108th Ave. N.E., Bellevue"
  },
  {
    "id": 65,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Meydenbauer Apartments",
    "latitude": 47.60913,
    "longitude": -122.2062,
    "original_address": "10022 Meydenbauer Way Southeast",
    "building_number": 10022,
    "street": "Meydenbauer Way SE",
    "city": "Bellevue",
    "zip": 98004,
    "concatenated_address": "10022 Meydenbauer Way SE, Bellevue",
    "address": "10022 Meydenbauer Way S.E., Bellevue"
  },
  {
    "id": 66,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Avalon Apartments",
    "latitude": 47.609327,
    "longitude": -122.19668,
    "original_address": "125 108th Avenue Se",
    "building_number": 125,
    "street": "108th Ave SE",
    "city": "Bellevue",
    "zip": 98004,
    "concatenated_address": "125 108th Ave SE, Bellevue",
    "address": "125 108th Ave. S.E., Bellevue"
  },
  {
    "id": 67,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "The Standard Bellevue",
    "latitude": 47.620471,
    "longitude": -122.17888,
    "original_address": "2801 2811 And 2821 130th Avenue Se",
    "building_number": "",
    "street": "",
    "city": "Bellevue",
    "zip": 98005,
    "concatenated_address": "2801 2811 And 2821 130th Avenue Se, Bellevue",
    "address": "2801, 2811 and 2821 130th Ave. S.E., Bellevue"
  },
  {
    "id": 68,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Newport Manor",
    "latitude": 47.551771,
    "longitude": -122.14473,
    "original_address": "12205, 12215, 12225, And 12235 Se 60th S",
    "building_number": "",
    "street": "",
    "city": "Bellevue",
    "zip": 98006,
    "concatenated_address": "12205, 12215, 12225, And 12235 Se 60th S, Bellevue",
    "address": "12205, 12215, 12225, and 12235 S.E. 60th S., Bellevue"
  },
  {
    "id": 69,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Soma Towers Phase II",
    "latitude": 47.612141,
    "longitude": -122.19845,
    "original_address": "10608 Northeast 2nd Street",
    "building_number": 10608,
    "street": "NE 2nd St",
    "city": "Bellevue",
    "zip": 98004,
    "concatenated_address": "10608 NE 2nd St, Bellevue",
    "address": "10608 N.E. 2nd St., Bellevue"
  },
  {
    "id": 70,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Redmond Park Apartments",
    "latitude": 47.641766,
    "longitude": -122.14421,
    "original_address": "14700 35th Street",
    "building_number": 14700,
    "street": "NE 35th St",
    "city": "Bellevue",
    "zip": 98007,
    "concatenated_address": "14700 NE 35th St, Bellevue",
    "address": "14700 N.E. 35th St., Bellevue"
  },
  {
    "id": 71,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Patriots Glen",
    "latitude": 47.594953,
    "longitude": -122.14199,
    "original_address": "1640 148th Avenue",
    "building_number": 1640,
    "street": "148th Ave SE",
    "city": "Bellevue",
    "zip": 98007,
    "concatenated_address": "1640 148th Ave SE, Bellevue",
    "address": "1640 148th Ave. S.E., Bellevue"
  },
  {
    "id": 72,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Surrey On Main Flats",
    "latitude": 47.609747,
    "longitude": -122.19669,
    "original_address": "10777 Main Street",
    "building_number": 10777,
    "street": "Main St",
    "city": "Bellevue",
    "zip": 98004,
    "concatenated_address": "10777 Main St, Bellevue",
    "address": "10777 Main St., Bellevue"
  },
  {
    "id": 73,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Northbrook Place Apartments",
    "latitude": 48.78378,
    "longitude": -122.5202,
    "original_address": "3615 Bennett Drive",
    "building_number": 3615,
    "street": "Bennett Dr",
    "city": "Bellingham",
    "zip": 98225,
    "concatenated_address": "3615 Bennett Dr, Bellingham",
    "address": "3615 Bennett Drive, Bellingham"
  },
  {
    "id": 74,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Canterbury Court Apartments",
    "latitude": 48.783657,
    "longitude": -122.52291,
    "original_address": "3790 Canterbury Lane",
    "building_number": 3790,
    "street": "Canterbury Ln",
    "city": "Bellingham",
    "zip": 98225,
    "concatenated_address": "3790 Canterbury Ln, Bellingham",
    "address": "3790 Canterbury Lane, Bellingham"
  },
  {
    "id": 75,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Sunset Pond Apartments",
    "latitude": 48.775282,
    "longitude": -122.456,
    "original_address": "1101-1405 Woodstock Way",
    "building_number": 1405,
    "street": "Woodstock Way",
    "city": "Bellingham",
    "zip": 98226,
    "concatenated_address": "1405 Woodstock Way, Bellingham",
    "address": "1405 Woodstock Way, Bellingham"
  },
  {
    "id": 76,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Maple Park Apartments",
    "latitude": 48.736846,
    "longitude": -122.46407,
    "original_address": "1705 East Maple Street",
    "building_number": 1705,
    "street": "E Maple St",
    "city": "Bellingham",
    "zip": 98229,
    "concatenated_address": "1705 E Maple St, Bellingham",
    "address": "1705 E. Maple St., Bellingham"
  },
  {
    "id": 77,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Solstice Senior Living At Bellingham",
    "latitude": 48.71404,
    "longitude": -122.47982,
    "original_address": "2818 Old Fairhaven Parkway",
    "building_number": 2818,
    "street": "Old Fairhaven Pkwy",
    "city": "Bellingham",
    "zip": 98225,
    "concatenated_address": "2818 Old Fairhaven Pkwy, Bellingham",
    "address": "2818 Old Fairhaven Parkway, Bellingham"
  },
  {
    "id": 78,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Lakeway Mobile Estates",
    "latitude": 48.740158,
    "longitude": -122.46275,
    "original_address": "1200 Lincoln Street",
    "building_number": 1200,
    "street": "Lincoln St",
    "city": "Bellingham",
    "zip": 98229,
    "concatenated_address": "1200 Lincoln St, Bellingham",
    "address": "1200 Lincoln St., Bellingham"
  },
  {
    "id": 79,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Lark Bellingham",
    "latitude": 48.74057,
    "longitude": -122.46618,
    "original_address": "800 Viking Circle",
    "building_number": 800,
    "street": "Viking Cir",
    "city": "Bellingham",
    "zip": 98229,
    "concatenated_address": "800 Viking Cir, Bellingham",
    "address": "800 Viking Circle, Bellingham"
  },
  {
    "id": 80,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Old Mill Village",
    "latitude": 48.757792,
    "longitude": -122.41813,
    "original_address": "2100 Electric Avenue",
    "building_number": 2100,
    "street": "Electric Ave",
    "city": "Bellingham",
    "zip": 98229,
    "concatenated_address": "2100 Electric Ave, Bellingham",
    "address": "2100 Electric Ave., Bellingham"
  },
  {
    "id": 81,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Texas Street Apartments",
    "latitude": 48.76198,
    "longitude": -122.4507,
    "original_address": "1717 Texas Street",
    "building_number": 1717,
    "street": "Texas St",
    "city": "Bellingham",
    "zip": 98229,
    "concatenated_address": "1717 Texas St, Bellingham",
    "address": "1717 Texas St., Bellingham"
  },
  {
    "id": 82,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Happy Valley Apartments",
    "latitude": 48.723141,
    "longitude": -122.48594,
    "original_address": "1021 24th St",
    "building_number": 1021,
    "street": "24th St",
    "city": "Bellingham",
    "zip": 98225,
    "concatenated_address": "1021 24th St, Bellingham",
    "address": "1021 24th St., Bellingham"
  },
  {
    "id": 83,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Barkley Apartments",
    "latitude": 48.77193,
    "longitude": -122.4523,
    "original_address": "3110-3126 Racine Street",
    "building_number": 3126,
    "street": "Racine St",
    "city": "Bellingham",
    "zip": 98226,
    "concatenated_address": "3126 Racine St, Bellingham",
    "address": "3126 Racine St., Bellingham"
  },
  {
    "id": 84,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Maplewood Place Apartments",
    "latitude": 48.775723,
    "longitude": -122.49976,
    "original_address": "2631 W. Maplewood Ave.",
    "building_number": 2631,
    "street": "W Maplewood Ave",
    "city": "Bellingham",
    "zip": 98225,
    "concatenated_address": "2631 W Maplewood Ave, Bellingham",
    "address": "2631 W. Maplewood Ave., Bellingham"
  },
  {
    "id": 85,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Brampton Court Apartments",
    "latitude": 48.776003,
    "longitude": -122.49184,
    "original_address": "1470 Birchwood Avenue",
    "building_number": 1470,
    "street": "Birchwood Ave",
    "city": "Bellingham",
    "zip": 98225,
    "concatenated_address": "1470 Birchwood Ave, Bellingham",
    "address": "1470 Birchwood Ave., Bellingham"
  },
  {
    "id": 86,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Wwu Living Communities",
    "latitude": 48.72622,
    "longitude": -122.4898,
    "original_address": "2110 Bill Mcdonald Parkway 2300 Bill Mcdonald Parkway And 2115 Taylor Avenue",
    "building_number": 2110,
    "street": "Bill Mcdonald Pkwy",
    "city": "Bellingham",
    "zip": 98225,
    "concatenated_address": "2110 Bill Mcdonald Pkwy, Bellingham",
    "address": "2110 Bill Mcdonald Parkway, Bellingham"
  },
  {
    "id": 87,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "The U",
    "latitude": 48.725643,
    "longitude": -122.48591,
    "original_address": "2401 Taylor Avenue",
    "building_number": 2401,
    "street": "Taylor Ave",
    "city": "Bellingham",
    "zip": 98225,
    "concatenated_address": "2401 Taylor Ave, Bellingham",
    "address": "2401 Taylor Ave., Bellingham"
  },
  {
    "id": 88,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Gather Bellingham",
    "latitude": 48.743494,
    "longitude": -122.48189,
    "original_address": "900 North Forest Street",
    "building_number": 900,
    "street": "N Forest St",
    "city": "Bellingham",
    "zip": 98225,
    "concatenated_address": "900 N Forest St, Bellingham",
    "address": "900 N. Forest St., Bellingham"
  },
  {
    "id": 89,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Skyvue Apartments",
    "latitude": 48.732114,
    "longitude": -122.46693,
    "original_address": "600 Lincoln Street",
    "building_number": 600,
    "street": "Lincoln St",
    "city": "Bellingham",
    "zip": 98229,
    "concatenated_address": "600 Lincoln St, Bellingham",
    "address": "600 Lincoln St., Bellingham"
  },
  {
    "id": 90,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Affinity At Bellingham",
    "latitude": 48.783411,
    "longitude": -122.48077,
    "original_address": "3930 Affinity Lane",
    "building_number": 3930,
    "street": "Affinity Ln",
    "city": "Bellingham",
    "zip": 98226,
    "concatenated_address": "3930 Affinity Ln, Bellingham",
    "address": "3930 Affinity Lane, Bellingham"
  },
  {
    "id": 91,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Evergreen Ridge Apartments",
    "latitude": 48.775785,
    "longitude": -122.44583,
    "original_address": "3451 Woburn Street",
    "building_number": 3451,
    "street": "Woburn St",
    "city": "Bellingham",
    "zip": 98226,
    "concatenated_address": "3451 Woburn St, Bellingham",
    "address": "3451 Woburn St., Bellingham"
  },
  {
    "id": 92,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Mckenzie Square",
    "latitude": 48.718943,
    "longitude": -122.50496,
    "original_address": "1440 10th Street",
    "building_number": 1440,
    "street": "10th St",
    "city": "Bellingham",
    "zip": 98225,
    "concatenated_address": "1440 10th St, Bellingham",
    "address": "1440 10th St., Bellingham"
  },
  {
    "id": 93,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Brookdale Fairhaven",
    "latitude": 48.714293,
    "longitude": -122.48311,
    "original_address": "2600 Old Fairhaven Parkway",
    "building_number": 2600,
    "street": "Old Fairhaven Pkwy",
    "city": "Bellingham",
    "zip": 98225,
    "concatenated_address": "2600 Old Fairhaven Pkwy, Bellingham",
    "address": "2600 Old Fairhaven Parkway, Bellingham"
  },
  {
    "id": 94,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Regency Park",
    "latitude": 48.751504,
    "longitude": -122.44916,
    "original_address": "2050 Fraser Street",
    "building_number": 2050,
    "street": "Fraser St",
    "city": "Bellingham",
    "zip": 98229,
    "concatenated_address": "2050 Fraser St, Bellingham",
    "address": "2050 Fraser St., Bellingham"
  },
  {
    "id": 95,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Highgate At Bellingham",
    "latitude": 48.79464,
    "longitude": -122.48315,
    "original_address": "155 East Kellogg Road",
    "building_number": 155,
    "street": "E Kellogg Rd",
    "city": "Bellingham",
    "zip": 98226,
    "concatenated_address": "155 E Kellogg Rd, Bellingham",
    "address": "155 E. Kellogg Road, Bellingham"
  },
  {
    "id": 96,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Monterra Apartments",
    "latitude": 48.7306,
    "longitude": -122.47714,
    "original_address": "301 31st Street",
    "building_number": 301,
    "street": "31st St",
    "city": "Bellingham",
    "zip": 98225,
    "concatenated_address": "301 31st St, Bellingham",
    "address": "301 31st St., Bellingham"
  },
  {
    "id": 97,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Belleau Woods I & II",
    "latitude": 48.78774,
    "longitude": -122.50574,
    "original_address": "4000-4024 Northwest Avenue",
    "building_number": 4024,
    "street": "Northwest Ave",
    "city": "Bellingham",
    "zip": 98226,
    "concatenated_address": "4024 Northwest Ave, Bellingham",
    "address": "4024 Northwest Ave., Bellingham"
  },
  {
    "id": 98,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Village At Baker Creek",
    "latitude": 48.783506,
    "longitude": -122.47558,
    "original_address": "3820-3872 Primrose Lane",
    "building_number": 3820,
    "street": "Primrose Ln",
    "city": "Bellingham",
    "zip": 98226,
    "concatenated_address": "3820 Primrose Ln, Bellingham",
    "address": "3820 Primrose Lane, Bellingham"
  },
  {
    "id": 99,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Spring Creek Retirement & Assisted Living",
    "latitude": 48.788721,
    "longitude": -122.48153,
    "original_address": "223 East Bakerview Road",
    "building_number": 223,
    "street": "E Bakerview Rd",
    "city": "Bellingham",
    "zip": 98226,
    "concatenated_address": "223 E Bakerview Rd, Bellingham",
    "address": "223 E. Bakerview Road, Bellingham"
  },
  {
    "id": 100,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Mount Baker Care Center",
    "latitude": 48.713262,
    "longitude": -122.47994,
    "original_address": "2901 Connelly Avenue",
    "building_number": 2901,
    "street": "Connelly Ave",
    "city": "Bellingham",
    "zip": 98225,
    "concatenated_address": "2901 Connelly Ave, Bellingham",
    "address": "2901 Connelly Ave., Bellingham"
  },
  {
    "id": 101,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Varsity Village",
    "latitude": 48.71873,
    "longitude": -122.48599,
    "original_address": "2400 Mckenzie Avenue",
    "building_number": 2400,
    "street": "McKenzie Ave",
    "city": "Bellingham",
    "zip": 98227,
    "concatenated_address": "2400 McKenzie Ave, Bellingham",
    "address": "2400 McKenzie Ave., Bellingham"
  },
  {
    "id": 102,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Rivercroft Apartments",
    "latitude": 47.755784,
    "longitude": -122.17708,
    "original_address": "12109 Woodinville Drive",
    "building_number": 12109,
    "street": "Woodinville Dr",
    "city": "Bothell",
    "zip": 98011,
    "concatenated_address": "12109 Woodinville Dr, Bothell",
    "address": "12109 Woodinville Drive, Bothell"
  },
  {
    "id": 103,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "The 104 Apartments",
    "latitude": 47.761701,
    "longitude": -122.20089,
    "original_address": "18414 104th Avenue Ne",
    "building_number": 18414,
    "street": "104th Ave NE",
    "city": "Bothell",
    "zip": 98011,
    "concatenated_address": "18414 104th Ave NE, Bothell",
    "address": "18414 104th Ave. N.E., Bothell"
  },
  {
    "id": 104,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Griffis North Creek",
    "latitude": 47.816778,
    "longitude": -122.20117,
    "original_address": "20225 Bothell Everett Hwy.",
    "building_number": 20225,
    "street": "Bothell Everett Hwy",
    "city": "Bothell",
    "zip": 98012,
    "concatenated_address": "20225 Bothell Everett Hwy, Bothell",
    "address": "20225 Bothell Everett Highway, Bothell"
  },
  {
    "id": 105,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Avana 522",
    "latitude": 47.759984,
    "longitude": -122.17283,
    "original_address": "18101 126th Avenue Ne",
    "building_number": 18101,
    "street": "126th Ave NE",
    "city": "Bothell",
    "zip": 98011,
    "concatenated_address": "18101 126th Ave NE, Bothell",
    "address": "18101 126th Ave. N.E., Bothell"
  },
  {
    "id": 106,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Edition",
    "latitude": 47.761659,
    "longitude": -122.20366,
    "original_address": "18420 102nd Avenue Ne",
    "building_number": 18420,
    "street": "102nd Ave NE",
    "city": "Bothell",
    "zip": 98011,
    "concatenated_address": "18420 102nd Ave NE, Bothell",
    "address": "18420 102nd Ave. N.E., Bothell"
  },
  {
    "id": 107,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Saskia At Beardslee Crossing",
    "latitude": 47.76618,
    "longitude": -122.19274,
    "original_address": "19121 112th Avenue Northeast",
    "building_number": 19121,
    "street": "112th Ave NE",
    "city": "Bothell",
    "zip": 98011,
    "concatenated_address": "19121 112th Ave NE, Bothell",
    "address": "19121 112th Ave. N.E., Bothell"
  },
  {
    "id": 108,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "North Creek Heights Apartments",
    "latitude": 47.769967,
    "longitude": -122.1915,
    "original_address": "19701 112th Avenue Northeast",
    "building_number": 19701,
    "street": "112th Ave NE",
    "city": "Bothell",
    "zip": 98011,
    "concatenated_address": "19701 112th Ave NE, Bothell",
    "address": "19701 112th Ave. N.E., Bothell"
  },
  {
    "id": 109,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Bordeaux Apartment Homes",
    "latitude": 47.847913,
    "longitude": -122.237,
    "original_address": "16520 North Road",
    "building_number": 16520,
    "street": "North Rd",
    "city": "Bothell",
    "zip": 98012,
    "concatenated_address": "16520 North Rd, Bothell",
    "address": "16520 North Road, Bothell"
  },
  {
    "id": 110,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "North Creek Heights",
    "latitude": 47.769967,
    "longitude": -122.1915,
    "original_address": "19701 112th Avenue Northeast",
    "building_number": 19701,
    "street": "112th Ave NE",
    "city": "Bothell",
    "zip": 98011,
    "concatenated_address": "19701 112th Ave NE, Bothell",
    "address": "19701 112th Ave. N.E., Bothell"
  },
  {
    "id": 111,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Forest Lane Apartments",
    "latitude": 47.793684,
    "longitude": -122.23925,
    "original_address": "420 224th Street Southwest",
    "building_number": 420,
    "street": "224th St SW",
    "city": "Bothell",
    "zip": 98021,
    "concatenated_address": "420 224th St SW, Bothell",
    "address": "420 224th St. S.W., Bothell"
  },
  {
    "id": 112,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "The Village At Beardslee Crossing",
    "latitude": 47.765862,
    "longitude": -122.19234,
    "original_address": "19115 112th Avenue Northeast",
    "building_number": 19115,
    "street": "112th Ave NE",
    "city": "Bothell",
    "zip": 98011,
    "concatenated_address": "19115 112th Ave NE, Bothell",
    "address": "19115 112th Ave. N.E., Bothell"
  },
  {
    "id": 113,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Vineyard Park At Bothell Landing",
    "latitude": 47.755728,
    "longitude": -122.19982,
    "original_address": "10519 East Riverside Drive",
    "building_number": 10519,
    "street": "E Riverside Dr",
    "city": "Bothell",
    "zip": 98011,
    "concatenated_address": "10519 E Riverside Dr, Bothell",
    "address": "10519 E. Riverside Drive, Bothell"
  },
  {
    "id": 114,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Glen Grove Apartments",
    "latitude": 47.764521,
    "longitude": -122.20385,
    "original_address": "10295 Ne 189th St",
    "building_number": 10295,
    "street": "NE 189th St",
    "city": "Bothell",
    "zip": 98011,
    "concatenated_address": "10295 NE 189th St, Bothell",
    "address": "10295 N.E. 189th St., Bothell"
  },
  {
    "id": 115,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Arterra Woods",
    "latitude": 47.76957,
    "longitude": -122.21138,
    "original_address": "9627 Ne 195th",
    "building_number": 9627,
    "street": "NE 195th Cir",
    "city": "Bothell",
    "zip": 98011,
    "concatenated_address": "9627 NE 195th Cir, Bothell",
    "address": "9627 N.E. 195th Circle, Bothell"
  },
  {
    "id": 116,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Willina Ranch Apts",
    "latitude": 47.744868,
    "longitude": -122.18868,
    "original_address": "15515 Juanita Woodinville Way",
    "building_number": 15515,
    "street": "Juanita Woodinville Way NE",
    "city": "Bothell",
    "zip": 98011,
    "concatenated_address": "15515 Juanita Woodinville Way NE, Bothell",
    "address": "15515 Juanita Woodinville Way N.E., Bothell"
  },
  {
    "id": 117,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Riverside East",
    "latitude": 47.755523,
    "longitude": -122.20195,
    "original_address": "10315 East Riverside Drive",
    "building_number": 10315,
    "street": "E Riverside Dr",
    "city": "Bothell",
    "zip": 98011,
    "concatenated_address": "10315 E Riverside Dr, Bothell",
    "address": "10315 E. Riverside Drive, Bothell"
  },
  {
    "id": 118,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "North Creek Retirement & Assis",
    "latitude": 47.816875,
    "longitude": -122.20669,
    "original_address": "1907 201st Place Se",
    "building_number": 1907,
    "street": "201st Pl SE",
    "city": "Bothell",
    "zip": 98012,
    "concatenated_address": "1907 201st Pl SE, Bothell",
    "address": "1907 201st Place S.E., Bothell"
  },
  {
    "id": 119,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Bothell Health Care",
    "latitude": 47.792223,
    "longitude": -122.24104,
    "original_address": "707 228th Street Sw",
    "building_number": 707,
    "street": "228th St SW",
    "city": "Bothell",
    "zip": 98021,
    "concatenated_address": "707 228th St SW, Bothell",
    "address": "707 228th St. S.W., Bothell"
  },
  {
    "id": 120,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Chateau At Bothell",
    "latitude": 47.756213,
    "longitude": -122.20568,
    "original_address": "17543 102nd Avenue Ne",
    "building_number": 17543,
    "street": "102nd Ave NE",
    "city": "Bothell",
    "zip": 98011,
    "concatenated_address": "17543 102nd Ave NE, Bothell",
    "address": "17543 102nd Ave. N.E., Bothell"
  },
  {
    "id": 121,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Port Madison3-Madrona House",
    "latitude": 47.643209,
    "longitude": -122.51058,
    "original_address": "8812 Ne Casey Street",
    "building_number": "",
    "street": "NE Casey St",
    "city": "Bainbridge Island",
    "zip": 98110,
    "concatenated_address": "8812 Ne Casey Street, Bainbridge Island",
    "address": "8812 N.E. Casey St., Bainbridge Island"
  },
  {
    "id": 122,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "The Cottage",
    "latitude": 47.593355,
    "longitude": -122.64227,
    "original_address": "3210 Rickey Road",
    "building_number": 3210,
    "street": "Rickey Rd",
    "city": "Bremerton",
    "zip": 98310,
    "concatenated_address": "3210 Rickey Rd, Bremerton",
    "address": "3210 Rickey Road, Bremerton"
  },
  {
    "id": 123,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "The Willows",
    "latitude": 47.592729,
    "longitude": -122.64043,
    "original_address": "3201 Pine Road Northeast",
    "building_number": 3201,
    "street": "Pine Rd NE",
    "city": "Bremerton",
    "zip": 98310,
    "concatenated_address": "3201 Pine Rd NE, Bremerton",
    "address": "3201 Pine Road N.E., Bremerton"
  },
  {
    "id": 124,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Ashley Gardens Of Bremerton",
    "latitude": 47.593103,
    "longitude": -122.64041,
    "original_address": "3231 Pine Road Northeast",
    "building_number": 3231,
    "street": "Pine Rd NE",
    "city": "Bremerton",
    "zip": 98310,
    "concatenated_address": "3231 Pine Rd NE, Bremerton",
    "address": "3231 Pine Road N.E., Bremerton"
  },
  {
    "id": 125,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Canyon Park Apartments",
    "latitude": 47.604449,
    "longitude": -122.63978,
    "original_address": "4235 Pine Road Ne",
    "building_number": 4235,
    "street": "Pine Rd NE",
    "city": "Bremerton",
    "zip": 98310,
    "concatenated_address": "4235 Pine Rd NE, Bremerton",
    "address": "4235 Pine Road N.E., Bremerton"
  },
  {
    "id": 126,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Griffin Glen",
    "latitude": 47.609861,
    "longitude": -122.63081,
    "original_address": "5163 Ne Mariah Lane",
    "building_number": 5163,
    "street": "NE Mariah Ln",
    "city": "Bremerton",
    "zip": 98311,
    "concatenated_address": "5163 NE Mariah Ln, Bremerton",
    "address": "5163 N.E. Mariah Lane, Bremerton"
  },
  {
    "id": 127,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Weatherstone Apartments",
    "latitude": 47.633231,
    "longitude": -122.64579,
    "original_address": "263 Weatherstone Lane Ne",
    "building_number": 263,
    "street": "Weatherstone Ln",
    "city": "Bremerton",
    "zip": 98311,
    "concatenated_address": "263 Weatherstone Ln, Bremerton",
    "address": "263 Weatherstone Lane, Bremerton"
  },
  {
    "id": 128,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Kariotis MHC",
    "latitude": 47.621467,
    "longitude": -122.60948,
    "original_address": "3060 Ne Mcwilliams Road",
    "building_number": 3060,
    "street": "NE Mcwilliams Rd",
    "city": "Bremerton",
    "zip": 98311,
    "concatenated_address": "3060 NE Mcwilliams Rd, Bremerton",
    "address": "3060 N.E. McWilliams Road, Bremerton"
  },
  {
    "id": 129,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Steele Creek MHC",
    "latitude": 47.644794,
    "longitude": -122.63242,
    "original_address": "1290 Steele Creek Drive Ne",
    "building_number": 1290,
    "street": "Steele Creek Dr",
    "city": "Bremerton",
    "zip": 98311,
    "concatenated_address": "1290 Steele Creek Dr, Bremerton",
    "address": "1290 Steele Creek Drive, Bremerton"
  },
  {
    "id": 130,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Centennial Apartments",
    "latitude": 47.571727,
    "longitude": -122.64791,
    "original_address": "2127 12th St.",
    "building_number": 2127,
    "street": "12th St",
    "city": "Bremerton",
    "zip": 98312,
    "concatenated_address": "2127 12th St, Bremerton",
    "address": "2127 12th St., Bremerton"
  },
  {
    "id": 131,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Silverdale Estates MHC",
    "latitude": 47.623705,
    "longitude": -122.64768,
    "original_address": "160 Ne Saturn Lane",
    "building_number": 160,
    "street": "NE Saturn Ln",
    "city": "Bremerton",
    "zip": 98311,
    "concatenated_address": "160 NE Saturn Ln, Bremerton",
    "address": "160 N.E. Saturn Lane, Bremerton"
  },
  {
    "id": 132,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Cottage Bay Apartments",
    "latitude": 47.621489,
    "longitude": -122.61784,
    "original_address": "2500 Ne Mcwilliams Road",
    "building_number": 2500,
    "street": "NE Mcwilliams Rd",
    "city": "Bremerton",
    "zip": 98311,
    "concatenated_address": "2500 NE Mcwilliams Rd, Bremerton",
    "address": "2500 N.E. McWilliams Road, Bremerton"
  },
  {
    "id": 133,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "606 Apartments",
    "latitude": 47.565257,
    "longitude": -122.62867,
    "original_address": "606 Burwell Street",
    "building_number": 606,
    "street": "Burwell St",
    "city": "Bremerton",
    "zip": 98337,
    "concatenated_address": "606 Burwell St, Bremerton",
    "address": "606 Burwell St., Bremerton"
  },
  {
    "id": 134,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Pine Ridge Apartment Homes",
    "latitude": 47.593188,
    "longitude": -122.64011,
    "original_address": "3232 Pine Road Ne",
    "building_number": 3232,
    "street": "Pine Rd NE",
    "city": "Bremerton",
    "zip": 98310,
    "concatenated_address": "3232 Pine Rd NE, Bremerton",
    "address": "3232 Pine Road N.E., Bremerton"
  },
  {
    "id": 135,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Bayview West Apartments",
    "latitude": 47.575851,
    "longitude": -122.68884,
    "original_address": "5670 Kitsap Way",
    "building_number": 5670,
    "street": "Kitsap Way",
    "city": "Bremerton",
    "zip": 98312,
    "concatenated_address": "5670 Kitsap Way, Bremerton",
    "address": "5670 Kitsap Way, Bremerton"
  },
  {
    "id": 136,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Reserve At Blueberry Park (formerly known as Manettevilla Apartments)",
    "latitude": 47.593932,
    "longitude": -122.63959,
    "original_address": "3280 Pine Road",
    "building_number": 3280,
    "street": "Pine Rd",
    "city": "Bremerton",
    "zip": 98310,
    "concatenated_address": "3280 Pine Rd, Bremerton",
    "address": "3280 Pine Road, Bremerton"
  },
  {
    "id": 137,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Spyglass Hill Apartments",
    "latitude": 47.568831,
    "longitude": -122.62424,
    "original_address": "646 Highland Avenue",
    "building_number": 646,
    "street": "Highland Ave",
    "city": "Bremerton",
    "zip": 98337,
    "concatenated_address": "646 Highland Ave, Bremerton",
    "address": "646 Highland Ave., Bremerton"
  },
  {
    "id": 138,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Insignia Apartments",
    "latitude": 47.600904,
    "longitude": -122.63164,
    "original_address": "1060 Insignia Loop",
    "building_number": 1060,
    "street": "Insignia Loop",
    "city": "Bremerton",
    "zip": 98310,
    "concatenated_address": "1060 Insignia Loop, Bremerton",
    "address": "1060 Insignia Loop, Bremerton"
  },
  {
    "id": 139,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "The Reserve At Blueberry Park",
    "latitude": 47.593932,
    "longitude": -122.63959,
    "original_address": "3280 Pine Road",
    "building_number": 3280,
    "street": "Pine Rd",
    "city": "Bremerton",
    "zip": 98310,
    "concatenated_address": "3280 Pine Rd, Bremerton",
    "address": "3280 Pine Road, Bremerton"
  },
  {
    "id": 140,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Erlands Point Apartments",
    "latitude": 47.594828,
    "longitude": -122.69617,
    "original_address": "3000 Austin Drive",
    "building_number": 3000,
    "street": "Austin Dr",
    "city": "Bremerton",
    "zip": 98312,
    "concatenated_address": "3000 Austin Dr, Bremerton",
    "address": "3000 Austin Drive, Bremerton"
  },
  {
    "id": 141,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Camelot Mobile Estates",
    "latitude": 47.611326,
    "longitude": -122.63026,
    "original_address": "5307 State Hwy 303 Ne",
    "building_number": 5307,
    "street": "State Hwy 303",
    "city": "Bremerton",
    "zip": 98311,
    "concatenated_address": "5307 State Hwy 303, Bremerton",
    "address": "5307 State Highway 303, Bremerton"
  },
  {
    "id": 142,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Viewcrest Village",
    "latitude": 47.595861,
    "longitude": -122.62779,
    "original_address": "3401 Spruce Avenue",
    "building_number": 3401,
    "street": "Spruce Ave",
    "city": "Bremerton",
    "zip": 98310,
    "concatenated_address": "3401 Spruce Ave, Bremerton",
    "address": "3401 Spruce Ave., Bremerton"
  },
  {
    "id": 143,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Village Fair Apartment Homes",
    "latitude": 47.632126,
    "longitude": -122.6453,
    "original_address": "309 Northeast Fairgrounds Road",
    "building_number": 309,
    "street": "NE Fairgrounds Rd",
    "city": "Bremerton",
    "zip": 98311,
    "concatenated_address": "309 NE Fairgrounds Rd, Bremerton",
    "address": "309 N.E. Fairgrounds Road, Bremerton"
  },
  {
    "id": 144,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "The Panorama",
    "latitude": 47.54617,
    "longitude": -122.6783,
    "original_address": "1617 West Admiralty Heights Lane",
    "building_number": 1617,
    "street": "W Admiralty Heights Ln",
    "city": "Bremerton",
    "zip": 98312,
    "concatenated_address": "1617 W Admiralty Heights Ln, Bremerton",
    "address": "1617 W. Admiralty Heights Lane, Bremerton"
  },
  {
    "id": 145,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Hidden Firs Apartments",
    "latitude": 47.598606,
    "longitude": -122.62635,
    "original_address": "1303 Ivy Road",
    "building_number": 1303,
    "street": "Ivy Rd",
    "city": "Bremerton",
    "zip": 98310,
    "concatenated_address": "1303 Ivy Rd, Bremerton",
    "address": "1303 Ivy Road, Bremerton"
  },
  {
    "id": 146,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "The Vineyards Apartments",
    "latitude": 47.63372,
    "longitude": -122.64887,
    "original_address": "7720 Vineyards Lane Ne",
    "building_number": 7720,
    "street": "Vineyards Ln NE",
    "city": "Bremerton",
    "zip": 98311,
    "concatenated_address": "7720 Vineyards Ln NE, Bremerton",
    "address": "7720 Vineyards Lane N.E., Bremerton"
  },
  {
    "id": 147,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Forest Ridge Health & Rehabilitation",
    "latitude": 47.563148,
    "longitude": -122.66229,
    "original_address": "140 South Marion Avenue",
    "building_number": 140,
    "street": "S Marion Ave",
    "city": "Bremerton",
    "zip": 98312,
    "concatenated_address": "140 S Marion Ave, Bremerton",
    "address": "140 S. Marion Ave., Bremerton"
  },
  {
    "id": 148,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Belmont Terrace",
    "latitude": 47.58327,
    "longitude": -122.63349,
    "original_address": "560 Lebo Blvd",
    "building_number": 560,
    "street": "Lebo Blvd",
    "city": "Bremerton",
    "zip": 98310,
    "concatenated_address": "560 Lebo Blvd, Bremerton",
    "address": "560 Lebo Blvd., Bremerton"
  },
  {
    "id": 149,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Bay Vista Commons",
    "latitude": 47.567562,
    "longitude": -122.67426,
    "original_address": "191 Russell Road",
    "building_number": 191,
    "street": "Russell Rd",
    "city": "Bremerton",
    "zip": 98312,
    "concatenated_address": "191 Russell Rd, Bremerton",
    "address": "191 Russell Road, Bremerton"
  },
  {
    "id": 150,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Brewster Gardens",
    "latitude": 48.096838,
    "longitude": -119.78681,
    "original_address": "309 South 7th Street",
    "building_number": 309,
    "street": "S 7th St",
    "city": "Brewster",
    "zip": 98812,
    "concatenated_address": "309 S 7th St, Brewster",
    "address": "309 S. 7th St., Brewster"
  },
  {
    "id": 151,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Regency Harmony House Rehab",
    "latitude": 48.108033,
    "longitude": -119.77657,
    "original_address": "100 River Plaza",
    "building_number": 100,
    "street": "River Plz",
    "city": "Brewster",
    "zip": 98812,
    "concatenated_address": "100 River Plz, Brewster",
    "address": "100 River Plaza, Brewster"
  },
  {
    "id": 152,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Country Manor MHC",
    "latitude": 45.735601,
    "longitude": -122.53864,
    "original_address": "15619 Northeast Caples Road",
    "building_number": 15619,
    "street": "NE Caples Rd",
    "city": "Brush Prairie",
    "zip": 98606,
    "concatenated_address": "15619 NE Caples Rd, Brush Prairie",
    "address": "15619 N.E. Caples Road, Brush Prairie"
  },
  {
    "id": 153,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Buckley Apartments",
    "latitude": 47.163732,
    "longitude": -122.01603,
    "original_address": "1492 Main Street",
    "building_number": 1492,
    "street": "Main St",
    "city": "Buckley",
    "zip": 98321,
    "concatenated_address": "1492 Main St, Buckley",
    "address": "1492 Main St., Buckley"
  },
  {
    "id": 154,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Caring Places-Heritage House",
    "latitude": 47.159148,
    "longitude": -122.04411,
    "original_address": "28833 Hwy 410 E",
    "building_number": 28833,
    "street": "State Route 410 E",
    "city": "Buckley",
    "zip": 98321,
    "concatenated_address": "28833 State Route 410 E, Buckley",
    "address": "28833 State Route 410 E., Buckley"
  },
  {
    "id": 155,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "15222 10th Avenue Southwest",
    "latitude": 47.465892,
    "longitude": -122.3469,
    "original_address": "15222 10th Avenue Sw",
    "building_number": 15222,
    "street": "10th Ave SW",
    "city": "Seattle",
    "zip": 98166,
    "concatenated_address": "15222 10th Ave SW, Seattle",
    "address": "15222 10th Ave. S.W., Seattle"
  },
  {
    "id": 156,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Fairway Lanai Apartments",
    "latitude": 47.497654,
    "longitude": -122.31047,
    "original_address": "1807 South 118th St",
    "building_number": 1807,
    "street": "S 118th St",
    "city": "Seattle",
    "zip": 98168,
    "concatenated_address": "1807 S 118th St, Seattle",
    "address": "1807 S. 118th St., Seattle"
  },
  {
    "id": 157,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Sherri Arms Apartments",
    "latitude": 47.49043,
    "longitude": -122.34747,
    "original_address": "1010 Sw 126th Street",
    "building_number": 1010,
    "street": "SW 126th St",
    "city": "Seattle",
    "zip": 98146,
    "concatenated_address": "1010 SW 126th St, Seattle",
    "address": "1010 S.W. 126th St., Seattle"
  },
  {
    "id": 158,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Wellington Place",
    "latitude": 47.443791,
    "longitude": -122.33001,
    "original_address": "327 S. 177th Place",
    "building_number": 327,
    "street": "S 177th Pl",
    "city": "Seattle",
    "zip": 98148,
    "concatenated_address": "327 S 177th Pl, Seattle",
    "address": "327 S. 177th Place, Seattle"
  },
  {
    "id": 159,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "The Heights At Burien",
    "latitude": 47.478146,
    "longitude": -122.34809,
    "original_address": "1101 Sw 139th Street",
    "building_number": 1101,
    "street": "SW 139th St",
    "city": "Seattle",
    "zip": 98166,
    "concatenated_address": "1101 SW 139th St, Seattle",
    "address": "1101 S.W. 139th St., Seattle"
  },
  {
    "id": 160,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Alturas At Burien",
    "latitude": 47.478146,
    "longitude": -122.34809,
    "original_address": "1101 Sw 139th Street",
    "building_number": 1101,
    "street": "SW 139th St",
    "city": "Seattle",
    "zip": 98166,
    "concatenated_address": "1101 SW 139th St, Seattle",
    "address": "1101 S.W. 139th St., Seattle"
  },
  {
    "id": 161,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Maple Pointe Apartments",
    "latitude": 47.464441,
    "longitude": -122.32344,
    "original_address": "15421 Des Moines Memorial Drive",
    "building_number": 15421,
    "street": "Des Moines Memorial Dr",
    "city": "Seattle",
    "zip": 98148,
    "concatenated_address": "15421 Des Moines Memorial Dr, Seattle",
    "address": "15421 Des Moines Memorial Drive, Seattle"
  },
  {
    "id": 162,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Discovery Landing",
    "latitude": 47.46498,
    "longitude": -122.32359,
    "original_address": "15405 S. Des Moines Memorial Drive",
    "building_number": 15405,
    "street": "Des Moines Memorial Dr",
    "city": "Seattle",
    "zip": 98148,
    "concatenated_address": "15405 Des Moines Memorial Dr, Seattle",
    "address": "15405 Des Moines Memorial Drive, Seattle"
  },
  {
    "id": 163,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Creekside Apartments",
    "latitude": 47.463515,
    "longitude": -122.34279,
    "original_address": "618 Sw 156th Street",
    "building_number": 618,
    "street": "SW 156th St",
    "city": "Seattle",
    "zip": 98166,
    "concatenated_address": "618 SW 156th St, Seattle",
    "address": "618 S.W. 156th St., Seattle"
  },
  {
    "id": 164,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "The Maverick",
    "latitude": 47.468174,
    "longitude": -122.34072,
    "original_address": "15045 5th Avenue Sw",
    "building_number": 15045,
    "street": "5th Ave SW",
    "city": "Seattle",
    "zip": 98166,
    "concatenated_address": "15045 5th Ave SW, Seattle",
    "address": "15045 5th Ave. S.W., Seattle"
  },
  {
    "id": 165,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Merrill Gardens At Burien",
    "latitude": 47.468394,
    "longitude": -122.34014,
    "original_address": "15020 5th Avenue Sw",
    "building_number": 15020,
    "street": "5th Ave SW",
    "city": "Seattle",
    "zip": 98166,
    "concatenated_address": "15020 5th Ave SW, Seattle",
    "address": "15020 5th Ave. S.W., Seattle"
  },
  {
    "id": 166,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "English Gardens",
    "latitude": 47.466207,
    "longitude": -122.32696,
    "original_address": "515 South 152nd Street",
    "building_number": 515,
    "street": "S 152nd St",
    "city": "Seattle",
    "zip": 98148,
    "concatenated_address": "515 S 152nd St, Seattle",
    "address": "515 S. 152nd St., Seattle"
  },
  {
    "id": 167,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "The Raleigh An Apartment Community",
    "latitude": 47.491355,
    "longitude": -122.35055,
    "original_address": "12415 Ambaum Boulevard Southwes",
    "building_number": 12415,
    "street": "Ambaum Blvd SW",
    "city": "Seattle",
    "zip": 98146,
    "concatenated_address": "12415 Ambaum Blvd SW, Seattle",
    "address": "12415 Ambaum Blvd. S.W., Seattle"
  },
  {
    "id": 168,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Forest View Apartments",
    "latitude": 47.493363,
    "longitude": -122.35048,
    "original_address": "12201 Ambaum Blvd Sw",
    "building_number": 12201,
    "street": "Ambaum Blvd SW",
    "city": "Seattle",
    "zip": 98146,
    "concatenated_address": "12201 Ambaum Blvd SW, Seattle",
    "address": "12201 Ambaum Blvd. S.W., Seattle"
  },
  {
    "id": 169,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Le Chateau Apartments",
    "latitude": 47.445842,
    "longitude": -122.3292,
    "original_address": "17464 Ambaum Blvd S",
    "building_number": 17464,
    "street": "Ambaum Blvd S",
    "city": "Seattle",
    "zip": 98148,
    "concatenated_address": "17464 Ambaum Blvd S, Seattle",
    "address": "17464 Ambaum Blvd. S., Seattle"
  },
  {
    "id": 170,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Garden Pointe Apartments",
    "latitude": 47.503865,
    "longitude": -122.336,
    "original_address": "130 Sw 112th St",
    "building_number": 130,
    "street": "SW 112th St",
    "city": "Seattle",
    "zip": 98146,
    "concatenated_address": "130 SW 112th St, Seattle",
    "address": "130 S.W. 112th St., Seattle"
  },
  {
    "id": 171,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Village Lane",
    "latitude": 47.468107,
    "longitude": -122.33061,
    "original_address": "220 South 152nd Street",
    "building_number": 220,
    "street": "S 152nd St",
    "city": "Seattle",
    "zip": 98148,
    "concatenated_address": "220 S 152nd St, Seattle",
    "address": "220 S. 152nd St., Seattle"
  },
  {
    "id": 172,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "15904, 15906 and 15908 4th Avenue South",
    "latitude": 47.444098,
    "longitude": -122.32486,
    "original_address": "15904, 15906 And 15908 4th Avenue South",
    "building_number": "",
    "street": "",
    "city": "Seattle",
    "zip": 98148,
    "concatenated_address": "15904, 15906 And 15908 4th Avenue South, Seattle",
    "address": "15904, 15906 and 15908 4th Ave. S., Seattle"
  },
  {
    "id": 173,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "The Montrose",
    "latitude": 47.468107,
    "longitude": -122.33061,
    "original_address": "220 South 152nd Street",
    "building_number": 220,
    "street": "S 152nd St",
    "city": "Seattle",
    "zip": 98148,
    "concatenated_address": "220 S 152nd St, Seattle",
    "address": "220 S. 152nd St., Seattle"
  },
  {
    "id": 174,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Evergreen Place Apartments",
    "latitude": 47.467414,
    "longitude": -122.32676,
    "original_address": "446 S 152nd Street",
    "building_number": 446,
    "street": "S 152nd St",
    "city": "Seattle",
    "zip": 98148,
    "concatenated_address": "446 S 152nd St, Seattle",
    "address": "446 S. 152nd St., Seattle"
  },
  {
    "id": 175,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Holly Tree Apartments",
    "latitude": 47.463939,
    "longitude": -122.34267,
    "original_address": "615 Sw 155th Street",
    "building_number": 615,
    "street": "SW 155th St",
    "city": "Seattle",
    "zip": 98166,
    "concatenated_address": "615 SW 155th St, Seattle",
    "address": "615 S.W. 155th St., Seattle"
  },
  {
    "id": 176,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Ambaum Townhomes",
    "latitude": 47.491968,
    "longitude": -122.34982,
    "original_address": "12404 Ambaum Blvd Sw",
    "building_number": 12404,
    "street": "Ambaum Blvd SW",
    "city": "Seattle",
    "zip": 98146,
    "concatenated_address": "12404 Ambaum Blvd SW, Seattle",
    "address": "12404 Ambaum Blvd. S.W., Seattle"
  },
  {
    "id": 177,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Dominique Apartments",
    "latitude": 47.484312,
    "longitude": -122.34792,
    "original_address": "13218 Ambaum Blvd Sw",
    "building_number": 13218,
    "street": "Ambaum Blvd SW",
    "city": "Seattle",
    "zip": 98146,
    "concatenated_address": "13218 Ambaum Blvd SW, Seattle",
    "address": "13218 Ambaum Blvd. S.W., Seattle"
  },
  {
    "id": 178,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Village Montrachet Apartments",
    "latitude": 47.467511,
    "longitude": -122.32857,
    "original_address": "400 South 152nd Street",
    "building_number": 400,
    "street": "S 152nd St",
    "city": "Seattle",
    "zip": 98148,
    "concatenated_address": "400 S 152nd St, Seattle",
    "address": "400 S. 152nd St., Seattle"
  },
  {
    "id": 179,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Burien Manor Apartments",
    "latitude": 47.497179,
    "longitude": -122.33318,
    "original_address": "11822 1st Avenue South",
    "building_number": 11822,
    "street": "1st Ave S",
    "city": "Seattle",
    "zip": 98168,
    "concatenated_address": "11822 1st Ave S, Seattle",
    "address": "11822 1st Ave. S., Seattle"
  },
  {
    "id": 180,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Laru Apartments",
    "latitude": 47.465406,
    "longitude": -122.34017,
    "original_address": "420 Sw 154th St",
    "building_number": 420,
    "street": "SW 154th St",
    "city": "Seattle",
    "zip": 98166,
    "concatenated_address": "420 SW 154th St, Seattle",
    "address": "420 S.W. 154th St., Seattle"
  },
  {
    "id": 181,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Queensview Apartments",
    "latitude": 47.486106,
    "longitude": -122.3505,
    "original_address": "13007 - 13011 12th Avenue Sw",
    "building_number": 13011,
    "street": "12th Ave SW",
    "city": "Seattle",
    "zip": 98146,
    "concatenated_address": "13011 12th Ave SW, Seattle",
    "address": "13011 12th Ave. S.W., Seattle"
  },
  {
    "id": 182,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Sunwood Apartments",
    "latitude": 47.460204,
    "longitude": -122.33867,
    "original_address": "320 Sw 160th St",
    "building_number": 320,
    "street": "SW 160th St",
    "city": "Seattle",
    "zip": 98166,
    "concatenated_address": "320 SW 160th St, Seattle",
    "address": "320 S.W. 160th St., Seattle"
  },
  {
    "id": 183,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Van Lloyd Apartments",
    "latitude": 47.464802,
    "longitude": -122.33884,
    "original_address": "255 Sw 154th Street",
    "building_number": 255,
    "street": "SW 154th St",
    "city": "Seattle",
    "zip": 98166,
    "concatenated_address": "255 SW 154th St, Seattle",
    "address": "255 S.W. 154th St., Seattle"
  },
  {
    "id": 184,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "City's Edge Apartments",
    "latitude": 47.497105,
    "longitude": -122.35369,
    "original_address": "11801 Ambaum Boulevard Southwes",
    "building_number": 11801,
    "street": "Ambaum Blvd SW",
    "city": "Seattle",
    "zip": 98146,
    "concatenated_address": "11801 Ambaum Blvd SW, Seattle",
    "address": "11801 Ambaum Blvd S.W., Seattle"
  },
  {
    "id": 185,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Southwood Apartments",
    "latitude": 47.446969,
    "longitude": -122.33195,
    "original_address": "121 S 174th Street",
    "building_number": 121,
    "street": "S 174th St",
    "city": "Seattle",
    "zip": 98148,
    "concatenated_address": "121 S 174th St, Seattle",
    "address": "121 S. 174th St., Seattle"
  },
  {
    "id": 186,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Heritage Place Apartments",
    "latitude": 48.474414,
    "longitude": -122.34005,
    "original_address": "104-194 Heritage Place",
    "building_number": "104-194",
    "street": "Heritage Pl",
    "city": "Burlington",
    "zip": 98233,
    "concatenated_address": "104-194 Heritage Pl, Burlington",
    "address": "104-194 Heritage Place, Burlington"
  },
  {
    "id": 187,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Cascade Village",
    "latitude": 48.471953,
    "longitude": -122.34492,
    "original_address": "677 Peterson Road",
    "building_number": 677,
    "street": "Peterson Rd",
    "city": "Burlington",
    "zip": 98233,
    "concatenated_address": "677 Peterson Rd, Burlington",
    "address": "677 Peterson Road, Burlington"
  },
  {
    "id": 188,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Cascade Meadows",
    "latitude": 48.459756,
    "longitude": -122.33247,
    "original_address": "310 Cascade Place",
    "building_number": 310,
    "street": "Cascade Pl",
    "city": "Burlington",
    "zip": 98233,
    "concatenated_address": "310 Cascade Pl, Burlington",
    "address": "310 Cascade Place, Burlington"
  },
  {
    "id": 189,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Creekside",
    "latitude": 48.464107,
    "longitude": -122.32896,
    "original_address": "400 Gilkey Road",
    "building_number": 400,
    "street": "Gilkey Rd",
    "city": "Burlington",
    "zip": 98233,
    "concatenated_address": "400 Gilkey Rd, Burlington",
    "address": "400 Gilkey Road, Burlington"
  },
  {
    "id": 190,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "River View Apartments",
    "latitude": 45.589272,
    "longitude": -122.37784,
    "original_address": "3003 Ne 3rd Avenue",
    "building_number": 3003,
    "street": "NE 3rd Ave",
    "city": "Camas",
    "zip": 98607,
    "concatenated_address": "3003 NE 3rd Ave, Camas",
    "address": "3003 N.E. 3rd Ave., Camas"
  },
  {
    "id": 191,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Terrace At River Oaks",
    "latitude": 45.589128,
    "longitude": -122.37619,
    "original_address": "3009 Ne 3rd Avenue",
    "building_number": 3009,
    "street": "NE 3rd Ave",
    "city": "Camas",
    "zip": 98607,
    "concatenated_address": "3009 NE 3rd Ave, Camas",
    "address": "3009 N.E. 3rd Ave., Camas"
  },
  {
    "id": 192,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Trio Pointe",
    "latitude": 45.624684,
    "longitude": -122.47309,
    "original_address": "19600 Northeast 3rd Street",
    "building_number": 19600,
    "street": "NE 3rd St",
    "city": "Camas",
    "zip": 98607,
    "concatenated_address": "19600 NE 3rd St, Camas",
    "address": "19600 N.E. 3rd St., Camas"
  },
  {
    "id": 193,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Logan Place Apartments",
    "latitude": 45.598595,
    "longitude": -122.4238,
    "original_address": "1317-1355 Nw 26th Ave; 2511-2533 Nw Loga",
    "building_number": 1355,
    "street": "NW 26th Ave",
    "city": "Camas",
    "zip": 98607,
    "concatenated_address": "1355 NW 26th Ave, Camas",
    "address": "1355 N.W. 26th Ave., Camas"
  },
  {
    "id": 194,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "7th Avenue Townhomes",
    "latitude": 45.585036,
    "longitude": -122.4171,
    "original_address": "704-710 Nw 7th Ave, 712-718 Nw 6th Ave 6",
    "building_number": 710,
    "street": "NW 7th Ave",
    "city": "Camas",
    "zip": 98607,
    "concatenated_address": "710 NW 7th Ave, Camas",
    "address": "710 N.W. 7th Ave., Camas"
  },
  {
    "id": 195,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Epledalen",
    "latitude": 47.517832,
    "longitude": -120.4814,
    "original_address": "809 Pioneer Avenue",
    "building_number": 809,
    "street": "Pioneer Ave",
    "city": "Cashmere",
    "zip": 98815,
    "concatenated_address": "809 Pioneer Ave, Cashmere",
    "address": "809 Pioneer Ave., Cashmere"
  },
  {
    "id": 196,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Park Center Apartments",
    "latitude": 46.726967,
    "longitude": -122.99142,
    "original_address": "3007 Borst Avenue",
    "building_number": 3007,
    "street": "Borst Ave",
    "city": "Centralia",
    "zip": 98531,
    "concatenated_address": "3007 Borst Ave, Centralia",
    "address": "3007 Borst Ave., Centralia"
  },
  {
    "id": 197,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Russell Road Apartments I And II",
    "latitude": 46.730595,
    "longitude": -122.98836,
    "original_address": "2802 Russell Road",
    "building_number": 2802,
    "street": "Russell Rd",
    "city": "Centralia",
    "zip": 98531,
    "concatenated_address": "2802 Russell Rd, Centralia",
    "address": "2802 Russell Road, Centralia"
  },
  {
    "id": 198,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Harrison Village",
    "latitude": 46.732134,
    "longitude": -122.98547,
    "original_address": "1402 Harrison Avenue",
    "building_number": 1402,
    "street": "Harrison Ave",
    "city": "Centralia",
    "zip": 98531,
    "concatenated_address": "1402 Harrison Ave, Centralia",
    "address": "1402 Harrison Ave., Centralia"
  },
  {
    "id": 199,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Sharon Care Center",
    "latitude": 46.733947,
    "longitude": -122.98927,
    "original_address": "1509 Harrison Avenue",
    "building_number": 1509,
    "street": "Harrison Ave",
    "city": "Centralia",
    "zip": 98531,
    "concatenated_address": "1509 Harrison Ave, Centralia",
    "address": "1509 Harrison Ave., Centralia"
  },
  {
    "id": 200,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Chattaroy Valley Estates MHC",
    "latitude": 47.886847,
    "longitude": -117.36695,
    "original_address": "3110 East Chattaroy Road",
    "building_number": 3110,
    "street": "E Chattaroy Rd",
    "city": "Chattaroy",
    "zip": 99003,
    "concatenated_address": "3110 E Chattaroy Rd, Chattaroy",
    "address": "3110 E. Chattaroy Road, Chattaroy"
  },
  {
    "id": 201,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Chehalis West Assisted Living",
    "latitude": 46.665291,
    "longitude": -122.97432,
    "original_address": "478 Nw Quincy Place",
    "building_number": 478,
    "street": "NW Quincy Pl",
    "city": "Chehalis",
    "zip": 98532,
    "concatenated_address": "478 NW Quincy Pl, Chehalis",
    "address": "478 N.W. Quincy Place, Chehalis"
  },
  {
    "id": 202,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Salnave Glen Apartments",
    "latitude": 47.477528,
    "longitude": -117.59521,
    "original_address": "1048 W. 1st Street",
    "building_number": 1048,
    "street": "W 1st St",
    "city": "Cheney",
    "zip": 99004,
    "concatenated_address": "1048 W 1st St, Cheney",
    "address": "1048 W. 1st St., Cheney"
  },
  {
    "id": 203,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "School House Lofts",
    "latitude": 47.489509,
    "longitude": -117.57773,
    "original_address": "520 4th Street",
    "building_number": 520,
    "street": "4th St",
    "city": "Cheney",
    "zip": 99004,
    "concatenated_address": "520 4th St, Cheney",
    "address": "520 4th St., Cheney"
  },
  {
    "id": 204,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Eagle Point Apartments",
    "latitude": 47.505988,
    "longitude": -117.58376,
    "original_address": "1090 West Betz Road",
    "building_number": 1090,
    "street": "Betz Rd",
    "city": "Cheney",
    "zip": 99004,
    "concatenated_address": "1090 Betz Rd, Cheney",
    "address": "1090 Betz Road, Cheney"
  },
  {
    "id": 205,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Barrington Place Apartments",
    "latitude": 47.507721,
    "longitude": -117.56869,
    "original_address": "201 Betz Road",
    "building_number": 201,
    "street": "Betz Rd",
    "city": "Cheney",
    "zip": 99004,
    "concatenated_address": "201 Betz Rd, Cheney",
    "address": "201 Betz Road, Cheney"
  },
  {
    "id": 206,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "The Boulders Apartments",
    "latitude": 47.503172,
    "longitude": -117.56835,
    "original_address": "210 Simpson Parkway",
    "building_number": 210,
    "street": "Simpson Pkwy",
    "city": "Cheney",
    "zip": 99004,
    "concatenated_address": "210 Simpson Pkwy, Cheney",
    "address": "210 Simpson Pkwy, Cheney"
  },
  {
    "id": 207,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Rock Springs Apartments",
    "latitude": 47.50622,
    "longitude": -117.56838,
    "original_address": "2701 Al Ogdon Way",
    "building_number": 2701,
    "street": "Al Ogdon Way",
    "city": "Cheney",
    "zip": 99004,
    "concatenated_address": "2701 Al Ogdon Way, Cheney",
    "address": "2701 Al Ogdon Way, Cheney"
  },
  {
    "id": 208,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Rock Springs Apartments",
    "latitude": 47.48739,
    "longitude": -117.57576,
    "original_address": "2525, 2701, And 2800 Al Ogdon Way",
    "building_number": "",
    "street": "",
    "city": "Cheney",
    "zip": 99004,
    "concatenated_address": "2525, 2701, And 2800 Al Ogdon Way, Cheney",
    "address": "2525, 2701, And 2800 Al Ogdon Way, Cheney"
  },
  {
    "id": 209,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Cheney Care Center",
    "latitude": 47.50056,
    "longitude": -117.57478,
    "original_address": "2219 North 6th Avenue",
    "building_number": 2219,
    "street": "N 6th St",
    "city": "Cheney",
    "zip": 99004,
    "concatenated_address": "2219 N 6th St, Cheney",
    "address": "2219 N. 6th St., Cheney"
  },
  {
    "id": 210,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Sunset Heights MHC",
    "latitude": 46.3853,
    "longitude": -117.08267,
    "original_address": "2115 6th Avenue",
    "building_number": 2115,
    "street": "6th Ave",
    "city": "Clarkston",
    "zip": 99403,
    "concatenated_address": "2115 6th Ave, Clarkston",
    "address": "2115 6th Ave., Clarkston"
  },
  {
    "id": 211,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Westridge Apartments",
    "latitude": 46.41201,
    "longitude": -117.08177,
    "original_address": "950 Vineland Drive",
    "building_number": 950,
    "street": "Vineland Dr",
    "city": "Clarkston",
    "zip": 99403,
    "concatenated_address": "950 Vineland Dr, Clarkston",
    "address": "950 Vineland Drive, Clarkston"
  },
  {
    "id": 212,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "1620 Chestnut Street Apartments",
    "latitude": 46.41153,
    "longitude": -117.07679,
    "original_address": "1600-1620 Chestnut Street",
    "building_number": 1600,
    "street": "Chestnut St",
    "city": "Clarkston",
    "zip": 99403,
    "concatenated_address": "1600 Chestnut St, Clarkston",
    "address": "1600 Chestnut St., Clarkston"
  },
  {
    "id": 213,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Parkview Retirement",
    "latitude": 48.546231,
    "longitude": -117.88727,
    "original_address": "240 South Silke Road",
    "building_number": 240,
    "street": "N Silke Rd",
    "city": "Colville",
    "zip": 99114,
    "concatenated_address": "240 N Silke Rd, Colville",
    "address": "240 N. Silke Road, Colville"
  },
  {
    "id": 214,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Regency At The Park",
    "latitude": 46.044932,
    "longitude": -118.36669,
    "original_address": "420 Se Myra Rd",
    "building_number": 420,
    "street": "SE Myra Rd",
    "city": "College Place",
    "zip": 99324,
    "concatenated_address": "420 SE Myra Rd, College Place",
    "address": "420 S.E. Myra Road, College Place"
  },
  {
    "id": 215,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Eagle Springs",
    "latitude": 46.049262,
    "longitude": -118.37882,
    "original_address": "20 Southeast Larch Avenue",
    "building_number": 20,
    "street": "SE Larch Ave",
    "city": "College Place",
    "zip": 99324,
    "concatenated_address": "20 SE Larch Ave, College Place",
    "address": "20 S.E. Larch Ave., College Place"
  },
  {
    "id": 216,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Pinewood Terrace Nursing Center",
    "latitude": 48.539521,
    "longitude": -117.89265,
    "original_address": "1000 East Elep Street",
    "building_number": 1000,
    "street": "E Elep Ave",
    "city": "Colville",
    "zip": 99114,
    "concatenated_address": "1000 E Elep Ave, Colville",
    "address": "1000 E. Elep Ave., Colville"
  },
  {
    "id": 217,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Allegro Apartment Homes",
    "latitude": 47.360335,
    "longitude": -122.1127,
    "original_address": "17126 Se 269th Place",
    "building_number": 17126,
    "street": "SE 269th Pl",
    "city": "Kent",
    "zip": 98042,
    "concatenated_address": "17126 SE 269th Pl, Kent",
    "address": "17126 S.E. 269th Place, Kent"
  },
  {
    "id": 218,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Covington Place Senior Apartments",
    "latitude": 47.361201,
    "longitude": -122.11516,
    "original_address": "26902 169th Place Se",
    "building_number": 26902,
    "street": "169th Pl SE",
    "city": "Kent",
    "zip": 98042,
    "concatenated_address": "26902 169th Pl SE, Kent",
    "address": "26902 169th Pl S.E., Kent"
  },
  {
    "id": 219,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Affinity At Covington",
    "latitude": 47.355716,
    "longitude": -122.11313,
    "original_address": "27431 172nd Avenue Southeast",
    "building_number": 27431,
    "street": "172nd Ave SE",
    "city": "Kent",
    "zip": 98042,
    "concatenated_address": "27431 172nd Ave SE, Kent",
    "address": "27431 172nd Ave. S.E., Kent"
  },
  {
    "id": 220,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "El Mirador Apartments",
    "latitude": 47.403792,
    "longitude": -122.32702,
    "original_address": "22022 6th Avenue South",
    "building_number": 22022,
    "street": "6th Ave S",
    "city": "Seattle",
    "zip": 98198,
    "concatenated_address": "22022 6th Ave S, Seattle",
    "address": "22022 6th Ave. S., Seattle"
  },
  {
    "id": 221,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Pine Creek Apartments",
    "latitude": 47.401175,
    "longitude": -122.29999,
    "original_address": "2406 - 2464 S. 224th Street",
    "building_number": 2464,
    "street": "S 224th St",
    "city": "Seattle",
    "zip": 98198,
    "concatenated_address": "2464 S 224th St, Seattle",
    "address": "2464 S. 224th St., Seattle"
  },
  {
    "id": 222,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Saddlebrook",
    "latitude": 47.369562,
    "longitude": -122.30735,
    "original_address": "2100 South 260th Street",
    "building_number": 2100,
    "street": "S 260th St",
    "city": "Seattle",
    "zip": 98198,
    "concatenated_address": "2100 S 260th St, Seattle",
    "address": "2100 S. 260th St., Seattle"
  },
  {
    "id": 223,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Silverwood Park Apartments",
    "latitude": 47.395651,
    "longitude": -122.29304,
    "original_address": "23006 30th Avenue South",
    "building_number": 23006,
    "street": "30th Ave S",
    "city": "Seattle",
    "zip": 98198,
    "concatenated_address": "23006 30th Ave S, Seattle",
    "address": "23006 30th Ave. S., Seattle"
  },
  {
    "id": 224,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Bay Club Apartments",
    "latitude": 47.399959,
    "longitude": -122.29847,
    "original_address": "2701 South 224th Street",
    "building_number": 2701,
    "street": "S 224th St",
    "city": "Seattle",
    "zip": 98198,
    "concatenated_address": "2701 S 224th St, Seattle",
    "address": "2701 S. 224th St., Seattle"
  },
  {
    "id": 225,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Belvedere Apartment Homes",
    "latitude": 47.415948,
    "longitude": -122.28572,
    "original_address": "20998 37th Place South",
    "building_number": 20998,
    "street": "37th Pl S",
    "city": "Seattle",
    "zip": 98198,
    "concatenated_address": "20998 37th Pl S, Seattle",
    "address": "20998 37th Pl S., Seattle"
  },
  {
    "id": 226,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "The Arbors Of Des Moines",
    "latitude": 47.408901,
    "longitude": -122.31749,
    "original_address": "21403-21515 12th Avenue South",
    "building_number": 21515,
    "street": "12th Ave S",
    "city": "Seattle",
    "zip": 98198,
    "concatenated_address": "21515 12th Ave S, Seattle",
    "address": "21515 12th Ave. S., Seattle"
  },
  {
    "id": 227,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Emerald Court Apartments",
    "latitude": 47.408032,
    "longitude": -122.30153,
    "original_address": "21600 24th Avenue South",
    "building_number": 21600,
    "street": "24th Ave S",
    "city": "Seattle",
    "zip": 98198,
    "concatenated_address": "21600 24th Ave S, Seattle",
    "address": "21600 24th Ave. S., Seattle"
  },
  {
    "id": 228,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "The Hidden Harbor House Apartments",
    "latitude": 47.392353,
    "longitude": -122.31289,
    "original_address": "1625 S Kent Des Moines Road",
    "building_number": 1625,
    "street": "S Kent Des Moines Rd",
    "city": "Seattle",
    "zip": 98198,
    "concatenated_address": "1625 S Kent Des Moines Rd, Seattle",
    "address": "1625 S. Kent Des Moines Road, Seattle"
  },
  {
    "id": 229,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Stafford Healthcare Sea Tac",
    "latitude": 47.401803,
    "longitude": -122.29677,
    "original_address": "2800 South 224th Street",
    "building_number": 2800,
    "street": "S 224th St",
    "city": "Seattle",
    "zip": 98198,
    "concatenated_address": "2800 S 224th St, Seattle",
    "address": "2800 S. 224th St., Seattle"
  },
  {
    "id": 230,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Drexel Des Moines Apartments",
    "latitude": 47.407139,
    "longitude": -122.29643,
    "original_address": "21639 29th Avenue South",
    "building_number": 21639,
    "street": "29th Ave S",
    "city": "Seattle",
    "zip": 98168,
    "concatenated_address": "21639 29th Ave S, Seattle",
    "address": "21639 29th Ave. S., Seattle"
  },
  {
    "id": 231,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Trax At Dupont Station",
    "latitude": 47.09097,
    "longitude": -122.64245,
    "original_address": "930 Ross Loop",
    "building_number": 930,
    "street": "Ross Ave",
    "city": "Dupont",
    "zip": 98327,
    "concatenated_address": "930 Ross Ave, Dupont",
    "address": "930 Ross Ave., Dupont"
  },
  {
    "id": 232,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "North River Apartments",
    "latitude": 47.43069,
    "longitude": -120.31637,
    "original_address": "245 5th Street Nebuildings C D & E",
    "building_number": "",
    "street": "5th St",
    "city": "Wenatchee",
    "zip": 98802,
    "concatenated_address": "245 5th Street Nebuildings C D & E, Wenatchee",
    "address": "245 5th St. Nebuildings C D & E., Wenatchee"
  },
  {
    "id": 233,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Colorado Apartments",
    "latitude": 48.168361,
    "longitude": -118.97043,
    "original_address": "245 5th Street Nebuildings A & B",
    "building_number": "",
    "street": "5th St",
    "city": "Nespelem",
    "zip": 98802,
    "concatenated_address": "245 5th Street Nebuildings A & B, Nespelem",
    "address": "245 5th St. Nebuildings A & B, Nespelem"
  },
  {
    "id": 234,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Skyview Apartments",
    "latitude": 47.413786,
    "longitude": -120.28903,
    "original_address": "611-639 North Baker Avenue",
    "building_number": 639,
    "street": "N Baker Ave",
    "city": "East Wenatchee",
    "zip": 98802,
    "concatenated_address": "639 N Baker Ave, East Wenatchee",
    "address": "639 N. Baker Ave., East Wenatchee"
  },
  {
    "id": 235,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Bonaventure Of East Wenatchee",
    "latitude": 47.453286,
    "longitude": -120.29947,
    "original_address": "50 29th Street Nw",
    "building_number": 50,
    "street": "29th St NW",
    "city": "East Wenatchee",
    "zip": 98802,
    "concatenated_address": "50 29th St NW, East Wenatchee",
    "address": "50 29th St. N.W., East Wenatchee"
  },
  {
    "id": 236,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Simons Mill Apartments",
    "latitude": 47.232917,
    "longitude": -122.29285,
    "original_address": "2629 Meridian Avenue East",
    "building_number": 2629,
    "street": "Meridian Ave E",
    "city": "Puyallup",
    "zip": 98371,
    "concatenated_address": "2629 Meridian Ave E, Puyallup",
    "address": "2629 Meridian Ave. E., Puyallup"
  },
  {
    "id": 237,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "The Arbors At Edgewood",
    "latitude": 47.238533,
    "longitude": -122.29291,
    "original_address": "10304 20th Street East",
    "building_number": 10304,
    "street": "20th St E",
    "city": "Puyallup",
    "zip": 98372,
    "concatenated_address": "10304 20th St E, Puyallup",
    "address": "10304 20th St. E., Puyallup"
  },
  {
    "id": 238,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "18614-18730 76th Avenue West",
    "latitude": 47.829465,
    "longitude": -122.33823,
    "original_address": "18614 - 18730 76th Ave W",
    "building_number": 18614,
    "street": "76th Ave W",
    "city": "Edmonds",
    "zip": 98026,
    "concatenated_address": "18614 76th Ave W, Edmonds",
    "address": "18614 76th Ave. W., Edmonds"
  },
  {
    "id": 239,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Woodridge Apartments",
    "latitude": 47.809688,
    "longitude": -122.34508,
    "original_address": "20904 83rd Avenue W21010 83rd Avenue W",
    "building_number": 20904,
    "street": "83rd Ave W",
    "city": "Edmonds",
    "zip": 98026,
    "concatenated_address": "20904 83rd Ave W, Edmonds",
    "address": "20904 83rd Ave. W., Edmonds"
  },
  {
    "id": 240,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Willowbrook Apartments",
    "latitude": 47.784923,
    "longitude": -122.33972,
    "original_address": "7924 236th Street Sw",
    "building_number": 7924,
    "street": "236th St SW",
    "city": "Edmonds",
    "zip": 98026,
    "concatenated_address": "7924 236th St SW, Edmonds",
    "address": "7924 236th St. S.W., Edmonds"
  },
  {
    "id": 241,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Skandi Villa Apartments",
    "latitude": 47.78282,
    "longitude": -122.34568,
    "original_address": "23809 84th Avenue West",
    "building_number": 23809,
    "street": "84th Ave W",
    "city": "Edmonds",
    "zip": 98026,
    "concatenated_address": "23809 84th Ave W, Edmonds",
    "address": "23809 84th Ave. W., Edmonds"
  },
  {
    "id": 242,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Edmonds Gateway Apartments",
    "latitude": 47.780912,
    "longitude": -122.34938,
    "original_address": "8610 240th Street Sw",
    "building_number": 8610,
    "street": "240th St SW",
    "city": "Edmonds",
    "zip": 98026,
    "concatenated_address": "8610 240th St SW, Edmonds",
    "address": "8610 240th St. S.W., Edmonds"
  },
  {
    "id": 243,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Compass Apartments",
    "latitude": 47.789021,
    "longitude": -122.35572,
    "original_address": "23020 Edmonds Way",
    "building_number": 23020,
    "street": "Edmonds Way",
    "city": "Edmonds",
    "zip": 98020,
    "concatenated_address": "23020 Edmonds Way, Edmonds",
    "address": "23020 Edmonds Way, Edmonds"
  },
  {
    "id": 244,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Brackett Apartment Homes",
    "latitude": 47.779509,
    "longitude": -122.35891,
    "original_address": "9501 244th Street Sw",
    "building_number": 9501,
    "street": "244th St SW",
    "city": "Edmonds",
    "zip": 98020,
    "concatenated_address": "9501 244th St SW, Edmonds",
    "address": "9501 244th St. S.W., Edmonds"
  },
  {
    "id": 245,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Edmonds Gateway",
    "latitude": 47.780912,
    "longitude": -122.34938,
    "original_address": "8610 240th Street Sw",
    "building_number": 8610,
    "street": "240th St SW",
    "city": "Edmonds",
    "zip": 98026,
    "concatenated_address": "8610 240th St SW, Edmonds",
    "address": "8610 240th St. S.W., Edmonds"
  },
  {
    "id": 246,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Rosewood Courte Memory Care",
    "latitude": 47.793089,
    "longitude": -122.3717,
    "original_address": "728 Edmonds Way",
    "building_number": 728,
    "street": "Edmonds Way",
    "city": "Edmonds",
    "zip": 98020,
    "concatenated_address": "728 Edmonds Way, Edmonds",
    "address": "728 Edmonds Way, Edmonds"
  },
  {
    "id": 247,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "20810 76th Avenue West",
    "latitude": 47.810333,
    "longitude": -122.33654,
    "original_address": "20810 76th Avenue West",
    "building_number": 20810,
    "street": "76th Ave W",
    "city": "Edmonds",
    "zip": 98026,
    "concatenated_address": "20810 76th Ave W, Edmonds",
    "address": "20810 76th Ave. W., Edmonds"
  },
  {
    "id": 248,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Edmonds Park Apartments",
    "latitude": 47.806613,
    "longitude": -122.38177,
    "original_address": "424 3rd Ave S",
    "building_number": 424,
    "street": "3rd Ave S",
    "city": "Edmonds",
    "zip": 98020,
    "concatenated_address": "424 3rd Ave S, Edmonds",
    "address": "424 3rd Ave. S., Edmonds"
  },
  {
    "id": 249,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Pacific Park Apartments",
    "latitude": 47.788086,
    "longitude": -122.33979,
    "original_address": "23231 Washington 99",
    "building_number": 23231,
    "street": "Pacific Hwy",
    "city": "Edmonds",
    "zip": 98026,
    "concatenated_address": "23231 Pacific Hwy, Edmonds",
    "address": "23231 Pacific Highway, Edmonds"
  },
  {
    "id": 250,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "University Court Apartments",
    "latitude": 47.013504,
    "longitude": -120.53964,
    "original_address": "2102 N. Walnut Street",
    "building_number": 2102,
    "street": "N Walnut St",
    "city": "Ellensburg",
    "zip": 98926,
    "concatenated_address": "2102 N Walnut St, Ellensburg",
    "address": "2102 N. Walnut St., Ellensburg"
  },
  {
    "id": 251,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Meadows Place",
    "latitude": 46.983629,
    "longitude": -120.53181,
    "original_address": "1008 East Mountain View Ave",
    "building_number": 1008,
    "street": "E Mountain View Ave",
    "city": "Ellensburg",
    "zip": 98926,
    "concatenated_address": "1008 E Mountain View Ave, Ellensburg",
    "address": "1008 E. Mountain View Ave., Ellensburg"
  },
  {
    "id": 252,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Timothy Park",
    "latitude": 47.028084,
    "longitude": -120.48998,
    "original_address": "1000 East Brighton Loop And 1000 East Harvest Loop",
    "building_number": "",
    "street": "",
    "city": "Ellensburg",
    "zip": 98926,
    "concatenated_address": "1000 East Brighton Loop And 1000 East Harvest Loop, Ellensburg",
    "address": "1000 East Brighton Loop And 1000 East Harvest Loop, Ellensburg"
  },
  {
    "id": 253,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Briarwood Commons",
    "latitude": 46.983201,
    "longitude": -120.53777,
    "original_address": "1001 S. Chestnut St.",
    "building_number": 1001,
    "street": "S Chestnut St",
    "city": "Ellensburg",
    "zip": 98926,
    "concatenated_address": "1001 S Chestnut St, Ellensburg",
    "address": "1001 S. Chestnut St., Ellensburg"
  },
  {
    "id": 254,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Rosewood Adult Living MHC",
    "latitude": 46.982374,
    "longitude": -120.53397,
    "original_address": "1100 S. Rosewood Drive",
    "building_number": 1100,
    "street": "S Rosewood Dr",
    "city": "Ellensburg",
    "zip": 98926,
    "concatenated_address": "1100 S Rosewood Dr, Ellensburg",
    "address": "1100 S. Rosewood Drive, Ellensburg"
  },
  {
    "id": 255,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "University Park, University Place and University Plaza",
    "latitude": 47.011909,
    "longitude": -120.54369,
    "original_address": "300 East Helena Avenue",
    "building_number": 300,
    "street": "E Helena Ave",
    "city": "Ellensburg",
    "zip": 98926,
    "concatenated_address": "300 E Helena Ave, Ellensburg",
    "address": "300 E. Helena Ave., Ellensburg"
  },
  {
    "id": 256,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "1201 West Main Street",
    "latitude": 47.003638,
    "longitude": -123.41511,
    "original_address": "1201 W. Main Street",
    "building_number": 1201,
    "street": "W Main St",
    "city": "Elma",
    "zip": 98541,
    "concatenated_address": "1201 W Main St, Elma",
    "address": "1201 W. Main St., Elma"
  },
  {
    "id": 257,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Watson Place Apartments",
    "latitude": 47.196205,
    "longitude": -121.97865,
    "original_address": "615 Watson Street North",
    "building_number": 615,
    "street": "Watson St N",
    "city": "Enumclaw",
    "zip": 98022,
    "concatenated_address": "615 Watson St N, Enumclaw",
    "address": "615 Watson St. N., Enumclaw"
  },
  {
    "id": 258,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Aspen Glade Apartments",
    "latitude": 47.197007,
    "longitude": -121.97955,
    "original_address": "750 Watson Street North",
    "building_number": 750,
    "street": "Watson St N",
    "city": "Enumclaw",
    "zip": 98022,
    "concatenated_address": "750 Watson St N, Enumclaw",
    "address": "750 Watson St. N., Enumclaw"
  },
  {
    "id": 259,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Mountain Meadows MHC",
    "latitude": 47.192303,
    "longitude": -121.99797,
    "original_address": "106 Noble Fir Circle",
    "building_number": 106,
    "street": "Noble Fir Cir",
    "city": "Enumclaw",
    "zip": 98022,
    "concatenated_address": "106 Noble Fir Cir, Enumclaw",
    "address": "106 Noble Fir Cir, Enumclaw"
  },
  {
    "id": 260,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Chinook Park Apartments",
    "latitude": 47.210532,
    "longitude": -121.98318,
    "original_address": "320 Chinook Avenue",
    "building_number": 320,
    "street": "Chinook Ave",
    "city": "Enumclaw",
    "zip": 98022,
    "concatenated_address": "320 Chinook Ave, Enumclaw",
    "address": "320 Chinook Ave., Enumclaw"
  },
  {
    "id": 261,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Verandas Apartments",
    "latitude": 47.190949,
    "longitude": -122.00482,
    "original_address": "219 Semanski Street South",
    "building_number": 219,
    "street": "Semanski St S",
    "city": "Enumclaw",
    "zip": 98022,
    "concatenated_address": "219 Semanski St S, Enumclaw",
    "address": "219 Semanski St. S., Enumclaw"
  },
  {
    "id": 262,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Division Street Townhomes",
    "latitude": 47.20002,
    "longitude": -121.99451,
    "original_address": "1055 Division Street",
    "building_number": 1055,
    "street": "Division St",
    "city": "Enumclaw",
    "zip": 98022,
    "concatenated_address": "1055 Division St, Enumclaw",
    "address": "1055 Division St., Enumclaw"
  },
  {
    "id": 263,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Evergreen Of Enumclaw",
    "latitude": 47.209529,
    "longitude": -121.98642,
    "original_address": "2323 Jensen Avenue",
    "building_number": 2323,
    "street": "Jensen St",
    "city": "Enumclaw",
    "zip": 98022,
    "concatenated_address": "2323 Jensen St, Enumclaw",
    "address": "2323 Jensen St., Enumclaw"
  },
  {
    "id": 264,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Living Court Assisted Living Community",
    "latitude": 47.208789,
    "longitude": -121.98622,
    "original_address": "2229 Jensen Street",
    "building_number": 2229,
    "street": "Jensen St",
    "city": "Enumclaw",
    "zip": 98022,
    "concatenated_address": "2229 Jensen St, Enumclaw",
    "address": "2229 Jensen St., Enumclaw"
  },
  {
    "id": 265,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "The Sundowner Apartments",
    "latitude": 47.325625,
    "longitude": -119.5423,
    "original_address": "318 East Street Ne",
    "building_number": 318,
    "street": "E St NE",
    "city": "Ephrata",
    "zip": 98823,
    "concatenated_address": "318 E St NE, Ephrata",
    "address": "318 E. St. N.E., Ephrata"
  },
  {
    "id": 266,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "5615 Highway Place",
    "latitude": 47.946605,
    "longitude": -122.2143,
    "original_address": "5615 Highway Place",
    "building_number": 5615,
    "street": "Highway Pl",
    "city": "Everett",
    "zip": 98203,
    "concatenated_address": "5615 Highway Pl, Everett",
    "address": "5615 Highway Place, Everett"
  },
  {
    "id": 267,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Hangar 128 Apartments",
    "latitude": 47.879598,
    "longitude": -122.24297,
    "original_address": "13031 8th Avenue West",
    "building_number": 13031,
    "street": "8th Ave W",
    "city": "Everett",
    "zip": 98204,
    "concatenated_address": "13031 8th Ave W, Everett",
    "address": "13031 8th Ave. W., Everett"
  },
  {
    "id": 268,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Harleen Court Apartments",
    "latitude": 47.921393,
    "longitude": -122.24207,
    "original_address": "606 West Casino Road",
    "building_number": 606,
    "street": "W Casino Rd",
    "city": "Everett",
    "zip": 98204,
    "concatenated_address": "606 W Casino Rd, Everett",
    "address": "606 W. Casino Road, Everett"
  },
  {
    "id": 269,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Library Place Apartments",
    "latitude": 47.981766,
    "longitude": -122.21011,
    "original_address": "2720 Hoyt Avenue",
    "building_number": 2720,
    "street": "Hoyt Ave",
    "city": "Everett",
    "zip": 98201,
    "concatenated_address": "2720 Hoyt Ave, Everett",
    "address": "2720 Hoyt Ave., Everett"
  },
  {
    "id": 270,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Highgrove Apartments",
    "latitude": 47.884033,
    "longitude": -122.25275,
    "original_address": "12433 Admiralty Way",
    "building_number": 12433,
    "street": "Admiralty Way",
    "city": "Everett",
    "zip": 98204,
    "concatenated_address": "12433 Admiralty Way, Everett",
    "address": "12433 Admiralty Way, Everett"
  },
  {
    "id": 271,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Peninsula Apartments",
    "latitude": 47.975922,
    "longitude": -122.20893,
    "original_address": "3120 Colby Avenue",
    "building_number": 3120,
    "street": "Colby Ave",
    "city": "Everett",
    "zip": 98201,
    "concatenated_address": "3120 Colby Ave, Everett",
    "address": "3120 Colby Ave., Everett"
  },
  {
    "id": 272,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Wildreed Apartments",
    "latitude": 47.907167,
    "longitude": -122.22199,
    "original_address": "10101 7th Avenue Se",
    "building_number": 10101,
    "street": "7th Ave SE",
    "city": "Everett",
    "zip": 98208,
    "concatenated_address": "10101 7th Ave SE, Everett",
    "address": "10101 7th Ave. S.E., Everett"
  },
  {
    "id": 273,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "The Bluffs At Evergreen",
    "latitude": 47.919945,
    "longitude": -122.23367,
    "original_address": "2 West Casino Road",
    "building_number": 2,
    "street": "W Casino Rd",
    "city": "Everett",
    "zip": 98204,
    "concatenated_address": "2 W Casino Rd, Everett",
    "address": "2 W. Casino Road, Everett"
  },
  {
    "id": 274,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Sage Apartments",
    "latitude": 47.895341,
    "longitude": -122.25783,
    "original_address": "1730 112th Street Southwest",
    "building_number": 1730,
    "street": "112th St",
    "city": "Everett",
    "zip": 98204,
    "concatenated_address": "1730 112th St, Everett",
    "address": "1730 112th St., Everett"
  },
  {
    "id": 275,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Avaire Apartments",
    "latitude": 47.91999,
    "longitude": -122.24552,
    "original_address": "824 W. Casino Road",
    "building_number": 824,
    "street": "W Casino Rd",
    "city": "Everett",
    "zip": 98204,
    "concatenated_address": "824 W Casino Rd, Everett",
    "address": "824 W. Casino Road, Everett"
  },
  {
    "id": 276,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "North Creek Apartments",
    "latitude": 47.894316,
    "longitude": -122.22622,
    "original_address": "11401 3rd Avenue Se",
    "building_number": 11401,
    "street": "3rd Ave SE",
    "city": "Everett",
    "zip": 98208,
    "concatenated_address": "11401 3rd Ave SE, Everett",
    "address": "11401 3rd Ave. S.E., Everett"
  },
  {
    "id": 277,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Arterra Apartment Homes",
    "latitude": 47.92266,
    "longitude": -122.24318,
    "original_address": "711 West Casino Road",
    "building_number": 711,
    "street": "W Casino Rd",
    "city": "Everett",
    "zip": 98204,
    "concatenated_address": "711 W Casino Rd, Everett",
    "address": "711 W. Casino Road, Everett"
  },
  {
    "id": 278,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Woodhaven Apartments",
    "latitude": 47.955778,
    "longitude": -122.21977,
    "original_address": "4632 Fowler Avenue",
    "building_number": 4632,
    "street": "Fowler Ave",
    "city": "Everett",
    "zip": 98203,
    "concatenated_address": "4632 Fowler Ave, Everett",
    "address": "4632 Fowler Ave., Everett"
  },
  {
    "id": 279,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Nova North Apartments",
    "latitude": 47.921634,
    "longitude": -122.24894,
    "original_address": "1020 W. Casino Road",
    "building_number": 1020,
    "street": "W Casino Rd",
    "city": "Everett",
    "zip": 98204,
    "concatenated_address": "1020 W Casino Rd, Everett",
    "address": "1020 W. Casino Road, Everett"
  },
  {
    "id": 280,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "West Ridge Apartments",
    "latitude": 47.88073,
    "longitude": -122.24233,
    "original_address": "628 128th Street Sw",
    "building_number": 628,
    "street": "128th St SW",
    "city": "Everett",
    "zip": 98204,
    "concatenated_address": "628 128th St SW, Everett",
    "address": "628 128th St. S.W., Everett"
  },
  {
    "id": 281,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Brisa Apartments",
    "latitude": 47.886475,
    "longitude": -122.25375,
    "original_address": "12402 Admiralty Way",
    "building_number": 12402,
    "street": "Admiralty Way",
    "city": "Everett",
    "zip": 98204,
    "concatenated_address": "12402 Admiralty Way, Everett",
    "address": "12402 Admiralty Way, Everett"
  },
  {
    "id": 282,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "The Lakeside Apartments",
    "latitude": 47.930251,
    "longitude": -122.22267,
    "original_address": "747 75th St Se",
    "building_number": 747,
    "street": "75th St SE",
    "city": "Everett",
    "zip": 98203,
    "concatenated_address": "747 75th St SE, Everett",
    "address": "747 75th St. S.E., Everett"
  },
  {
    "id": 283,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Tessera Apartments",
    "latitude": 47.904193,
    "longitude": -122.2147,
    "original_address": "1304 Bruskrud Road",
    "building_number": 1304,
    "street": "Bruskrud Rd",
    "city": "Everett",
    "zip": 98208,
    "concatenated_address": "1304 Bruskrud Rd, Everett",
    "address": "1304 Bruskrud Road, Everett"
  },
  {
    "id": 284,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Beacon At Center and The Mark On 4th",
    "latitude": 47.888484,
    "longitude": -122.24026,
    "original_address": "12102 4th Avenue West",
    "building_number": 12102,
    "street": "4th Ave W",
    "city": "Everett",
    "zip": 98204,
    "concatenated_address": "12102 4th Ave W, Everett",
    "address": "12102 4th Ave. W., Everett"
  },
  {
    "id": 285,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Charter Club Apartments",
    "latitude": 47.888547,
    "longitude": -122.2109,
    "original_address": "1701 121st Street Southeast",
    "building_number": 1701,
    "street": "121st St SE",
    "city": "Everett",
    "zip": 98208,
    "concatenated_address": "1701 121st St SE, Everett",
    "address": "1701 121st St. S.E., Everett"
  },
  {
    "id": 286,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Millington At Merrill Creek",
    "latitude": 47.945991,
    "longitude": -122.25402,
    "original_address": "1401 Merrill Creek Parkway",
    "building_number": 1401,
    "street": "Merrill Creek Pkwy",
    "city": "Everett",
    "zip": 98203,
    "concatenated_address": "1401 Merrill Creek Pkwy, Everett",
    "address": "1401 Merrill Creek Pkwy, Everett"
  },
  {
    "id": 287,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Mill Pointe",
    "latitude": 47.879177,
    "longitude": -122.18969,
    "original_address": "3111 132nd Street Southeast",
    "building_number": 3111,
    "street": "132nd St SE",
    "city": "Everett",
    "zip": 98208,
    "concatenated_address": "3111 132nd St SE, Everett",
    "address": "3111 132nd St. S.E., Everett"
  },
  {
    "id": 288,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Cascadian Place",
    "latitude": 47.965408,
    "longitude": -122.20725,
    "original_address": "3915 Colby Avenue North",
    "building_number": 3915,
    "street": "Colby Ave",
    "city": "Everett",
    "zip": 98201,
    "concatenated_address": "3915 Colby Ave, Everett",
    "address": "3915 Colby Ave., Everett"
  },
  {
    "id": 289,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Olin Fields",
    "latitude": 47.9049,
    "longitude": -122.24829,
    "original_address": "10115 Holly Drive",
    "building_number": 10115,
    "street": "Holly Dr",
    "city": "Everett",
    "zip": 98204,
    "concatenated_address": "10115 Holly Dr, Everett",
    "address": "10115 Holly Drive, Everett"
  },
  {
    "id": 290,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Fulton's Crossing Apartments",
    "latitude": 47.906504,
    "longitude": -122.22962,
    "original_address": "120 Se Everett Mall Way",
    "building_number": 120,
    "street": "SE Everett Mall Way",
    "city": "Everett",
    "zip": 98208,
    "concatenated_address": "120 SE Everett Mall Way, Everett",
    "address": "120 S.E. Everett Mall Way, Everett"
  },
  {
    "id": 291,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Mirabella Apartments",
    "latitude": 47.897095,
    "longitude": -122.22095,
    "original_address": "805 112th Street Se",
    "building_number": 805,
    "street": "112th St",
    "city": "Everett",
    "zip": 98208,
    "concatenated_address": "805 112th St, Everett",
    "address": "805 112th St., Everett"
  },
  {
    "id": 292,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Saratoga",
    "latitude": 47.890457,
    "longitude": -122.2489,
    "original_address": "11812 East Gibson Road",
    "building_number": 11812,
    "street": "E Gibson Rd",
    "city": "Everett",
    "zip": 98204,
    "concatenated_address": "11812 E Gibson Rd, Everett",
    "address": "11812 E. Gibson Road, Everett"
  },
  {
    "id": 293,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Cascadia Pointe",
    "latitude": 47.918899,
    "longitude": -122.24153,
    "original_address": "8710 5th Avenue West",
    "building_number": 8710,
    "street": "5th Ave W",
    "city": "Everett",
    "zip": 98204,
    "concatenated_address": "8710 5th Ave W, Everett",
    "address": "8710 5th Ave. W., Everett"
  },
  {
    "id": 294,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Copperstone Apartments",
    "latitude": 47.91934,
    "longitude": -122.23973,
    "original_address": "420 85th Place Southwest",
    "building_number": 420,
    "street": "85th Pl SW",
    "city": "Everett",
    "zip": 98204,
    "concatenated_address": "420 85th Pl SW, Everett",
    "address": "420 85th Pl S.W., Everett"
  },
  {
    "id": 295,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Walden Pond Apartments",
    "latitude": 47.908734,
    "longitude": -122.25117,
    "original_address": "9900 12th Avenue West",
    "building_number": 9900,
    "street": "12th Ave W",
    "city": "Everett",
    "zip": 98204,
    "concatenated_address": "9900 12th Ave W, Everett",
    "address": "9900 12th Ave. W., Everett"
  },
  {
    "id": 296,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Garden Court Retirement Community",
    "latitude": 47.89568,
    "longitude": -122.24073,
    "original_address": "520 112th Street Southwest",
    "building_number": 520,
    "street": "112th St",
    "city": "Everett",
    "zip": 98204,
    "concatenated_address": "520 112th St, Everett",
    "address": "520 112th St., Everett"
  },
  {
    "id": 297,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Park 120 Apartment Homes",
    "latitude": 47.919927,
    "longitude": -122.23535,
    "original_address": "120 West Casino Road",
    "building_number": 120,
    "street": "W Casino Rd",
    "city": "Everett",
    "zip": 98204,
    "concatenated_address": "120 W Casino Rd, Everett",
    "address": "120 W. Casino Road, Everett"
  },
  {
    "id": 298,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Washington Oakes Retirement Community",
    "latitude": 47.988661,
    "longitude": -122.1998,
    "original_address": "Rockefel Ave",
    "building_number": "",
    "street": "",
    "city": "Everett",
    "zip": 98201,
    "concatenated_address": "Rockefel Ave, Everett",
    "address": "Rockefel Ave., Everett"
  },
  {
    "id": 299,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Woodbrook Apartments",
    "latitude": 47.896631,
    "longitude": -122.22667,
    "original_address": "525 112th Street Southeast",
    "building_number": 525,
    "street": "112th St SE",
    "city": "Everett",
    "zip": 98208,
    "concatenated_address": "525 112th St SE, Everett",
    "address": "525 112th St. S.E., Everett"
  },
  {
    "id": 300,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Meridian Glen Apartments",
    "latitude": 47.888248,
    "longitude": -122.23326,
    "original_address": "12115 Meridian Avenue South",
    "building_number": 12115,
    "street": "Meridian Ave S",
    "city": "Everett",
    "zip": 98208,
    "concatenated_address": "12115 Meridian Ave S, Everett",
    "address": "12115 Meridian Ave. S., Everett"
  },
  {
    "id": 301,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Shoreside Village",
    "latitude": 47.930214,
    "longitude": -122.22659,
    "original_address": "701 75th Street Southeast",
    "building_number": 701,
    "street": "75th St SE",
    "city": "Everett",
    "zip": 98203,
    "concatenated_address": "701 75th St SE, Everett",
    "address": "701 75th St. S.E., Everett"
  },
  {
    "id": 302,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Bluwater Apartments",
    "latitude": 47.895229,
    "longitude": -122.20038,
    "original_address": "11311 19th Avenue Southeast",
    "building_number": 11311,
    "street": "19th Ave SE",
    "city": "Everett",
    "zip": 98208,
    "concatenated_address": "11311 19th Ave SE, Everett",
    "address": "11311 19th Ave. S.E., Everett"
  },
  {
    "id": 303,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Mirabella",
    "latitude": 47.897095,
    "longitude": -122.22095,
    "original_address": "805 112th Street Southeast",
    "building_number": 805,
    "street": "112th St",
    "city": "Everett",
    "zip": 98208,
    "concatenated_address": "805 112th St, Everett",
    "address": "805 112th St., Everett"
  },
  {
    "id": 304,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Saratoga",
    "latitude": 47.890457,
    "longitude": -122.2489,
    "original_address": "11812 East Gibson Road",
    "building_number": 11812,
    "street": "E Gibson Rd",
    "city": "Everett",
    "zip": 98204,
    "concatenated_address": "11812 E Gibson Rd, Everett",
    "address": "11812 E. Gibson Road, Everett"
  },
  {
    "id": 305,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "The Stinson Apartment Homes",
    "latitude": 47.886774,
    "longitude": -122.22988,
    "original_address": "133 124th Street Southeast",
    "building_number": 133,
    "street": "124th St",
    "city": "Everett",
    "zip": 98208,
    "concatenated_address": "133 124th St, Everett",
    "address": "133 124th St., Everett"
  },
  {
    "id": 306,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Millington At Merrill Creek",
    "latitude": 47.945991,
    "longitude": -122.25402,
    "original_address": "1401 Merrill Creek Parkway",
    "building_number": 1401,
    "street": "Merrill Creek Pkwy",
    "city": "Everett",
    "zip": 98203,
    "concatenated_address": "1401 Merrill Creek Pkwy, Everett",
    "address": "1401 Merrill Creek Pkwy, Everett"
  },
  {
    "id": 307,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Latitude Apartments",
    "latitude": 47.880781,
    "longitude": -122.25027,
    "original_address": "12907 East Gibson Road",
    "building_number": 12907,
    "street": "E Gibson Rd",
    "city": "Everett",
    "zip": 98204,
    "concatenated_address": "12907 E Gibson Rd, Everett",
    "address": "12907 E. Gibson Road, Everett"
  },
  {
    "id": 308,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Brookdale Arbor Place",
    "latitude": 47.881975,
    "longitude": -122.20692,
    "original_address": "12806 Bothell Everett Highway",
    "building_number": 12806,
    "street": "Bothell Everett Hwy",
    "city": "Everett",
    "zip": 98208,
    "concatenated_address": "12806 Bothell Everett Hwy, Everett",
    "address": "12806 Bothell Everett Highway, Everett"
  },
  {
    "id": 309,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Pine View Apartments",
    "latitude": 47.929951,
    "longitude": -122.2227,
    "original_address": "714 75th Street Se",
    "building_number": 714,
    "street": "75th St SE",
    "city": "Everett",
    "zip": 98203,
    "concatenated_address": "714 75th St SE, Everett",
    "address": "714 75th St. S.E., Everett"
  },
  {
    "id": 310,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Rucker II",
    "latitude": 47.989518,
    "longitude": -122.21166,
    "original_address": "2108 Rucker Avenue",
    "building_number": 2108,
    "street": "Rucker Ave",
    "city": "Everett",
    "zip": 98201,
    "concatenated_address": "2108 Rucker Ave, Everett",
    "address": "2108 Rucker Ave., Everett"
  },
  {
    "id": 311,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Vesper Apartments",
    "latitude": 47.954182,
    "longitude": -122.21421,
    "original_address": "4807 Vesper Drive",
    "building_number": 4807,
    "street": "Vesper Dr",
    "city": "Everett",
    "zip": 98203,
    "concatenated_address": "4807 Vesper Dr, Everett",
    "address": "4807 Vesper Drive, Everett"
  },
  {
    "id": 312,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Riverdale East And West Apartments",
    "latitude": 47.988661,
    "longitude": -122.1998,
    "original_address": "1810 And 1811 Chestnut Street",
    "building_number": "",
    "street": "",
    "city": "Everett",
    "zip": 98201,
    "concatenated_address": "1810 And 1811 Chestnut Street, Everett",
    "address": "1810 And 1811 Chestnut St., Everett"
  },
  {
    "id": 313,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Heritage Manor",
    "latitude": 47.984358,
    "longitude": -122.20806,
    "original_address": "2501 Colby Avenue",
    "building_number": 2501,
    "street": "Colby Ave",
    "city": "Everett",
    "zip": 98201,
    "concatenated_address": "2501 Colby Ave, Everett",
    "address": "2501 Colby Ave., Everett"
  },
  {
    "id": 314,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Walnut Street Apartments",
    "latitude": 47.996369,
    "longitude": -122.18958,
    "original_address": "1532 Walnut Street",
    "building_number": 1532,
    "street": "Walnut St",
    "city": "Everett",
    "zip": 98201,
    "concatenated_address": "1532 Walnut St, Everett",
    "address": "1532 Walnut St., Everett"
  },
  {
    "id": 315,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Beverly Heights",
    "latitude": 47.929943,
    "longitude": -122.22348,
    "original_address": "618 75th Street Se",
    "building_number": 618,
    "street": "75th St SE",
    "city": "Everett",
    "zip": 98203,
    "concatenated_address": "618 75th St SE, Everett",
    "address": "618 75th St. S.E., Everett"
  },
  {
    "id": 316,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Gateway Apartments",
    "latitude": 47.879642,
    "longitude": -122.20334,
    "original_address": "13105 21st Drive, Se",
    "building_number": 13105,
    "street": "21st Dr SE",
    "city": "Everett",
    "zip": 98208,
    "concatenated_address": "13105 21st Dr SE, Everett",
    "address": "13105 21st Dr S.E., Everett"
  },
  {
    "id": 317,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Silver Woods Apartments",
    "latitude": 47.899032,
    "longitude": -122.21013,
    "original_address": "10915 16th Avenue Se",
    "building_number": 10915,
    "street": "16th Ave SE",
    "city": "Everett",
    "zip": 98208,
    "concatenated_address": "10915 16th Ave SE, Everett",
    "address": "10915 16th Ave. S.E., Everett"
  },
  {
    "id": 318,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Casablanca Apartments",
    "latitude": 47.900325,
    "longitude": -122.24902,
    "original_address": "10710 Evergreen Way",
    "building_number": 10710,
    "street": "Evergreen Way",
    "city": "Everett",
    "zip": 98204,
    "concatenated_address": "10710 Evergreen Way, Everett",
    "address": "10710 Evergreen Way, Everett"
  },
  {
    "id": 319,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Jackson House At Pacifimic Crest",
    "latitude": 47.976441,
    "longitude": -122.20556,
    "original_address": "1818 Pacific Avenue",
    "building_number": 1818,
    "street": "Pacific Ave",
    "city": "Everett",
    "zip": 98201,
    "concatenated_address": "1818 Pacific Ave, Everett",
    "address": "1818 Pacific Ave., Everett"
  },
  {
    "id": 320,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Family Tree and Lincoln Way Apartments",
    "latitude": 47.905931,
    "longitude": -122.20838,
    "original_address": "10110 19th Ave Se",
    "building_number": 10110,
    "street": "19th Ave SE",
    "city": "Everett",
    "zip": 98208,
    "concatenated_address": "10110 19th Ave SE, Everett",
    "address": "10110 19th Ave. S.E., Everett"
  },
  {
    "id": 321,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Emreritus At Seabrook",
    "latitude": 47.895142,
    "longitude": -122.23816,
    "original_address": "11333 3rd Place West",
    "building_number": 11333,
    "street": "3rd Pl W",
    "city": "Everett",
    "zip": 98204,
    "concatenated_address": "11333 3rd Pl W, Everett",
    "address": "11333 3rd Pl W., Everett"
  },
  {
    "id": 322,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Forest View Transitional Hlth",
    "latitude": 47.949946,
    "longitude": -122.22781,
    "original_address": "5129 Hilltop Road",
    "building_number": 5129,
    "street": "Hilltop Rd",
    "city": "Everett",
    "zip": 98203,
    "concatenated_address": "5129 Hilltop Rd, Everett",
    "address": "5129 Hilltop Road, Everett"
  },
  {
    "id": 323,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Waterfront Place Apartments",
    "latitude": 48.000055,
    "longitude": -122.21388,
    "original_address": "1300 West Marine View Drive",
    "building_number": 1300,
    "street": "W Marine View Dr",
    "city": "Everett",
    "zip": 98201,
    "concatenated_address": "1300 W Marine View Dr, Everett",
    "address": "1300 W. Marine View Drive, Everett"
  },
  {
    "id": 324,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Potala Village Apartments",
    "latitude": 47.977384,
    "longitude": -122.21157,
    "original_address": "3030 Rucker Avenue",
    "building_number": 3030,
    "street": "Rucker Ave",
    "city": "Everett",
    "zip": 98201,
    "concatenated_address": "3030 Rucker Ave, Everett",
    "address": "3030 Rucker Ave., Everett"
  },
  {
    "id": 325,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Trailside Village Apartments",
    "latitude": 47.907271,
    "longitude": -122.21859,
    "original_address": "1300 100th Place Se",
    "building_number": 1300,
    "street": "100th St SE",
    "city": "Everett",
    "zip": 98208,
    "concatenated_address": "1300 100th St SE, Everett",
    "address": "1300 100th St. S.E., Everett"
  },
  {
    "id": 326,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Celebration Park Apartments",
    "latitude": 47.31286,
    "longitude": -122.31941,
    "original_address": "32205 11th Place South",
    "building_number": 32205,
    "street": "11th Pl S",
    "city": "Federal Way",
    "zip": 98003,
    "concatenated_address": "32205 11th Pl S, Federal Way",
    "address": "32205 11th Pl S., Federal Way"
  },
  {
    "id": 327,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Club Palisades Apartment Homes",
    "latitude": 47.357525,
    "longitude": -122.3074,
    "original_address": "2211 South Star Lake Road",
    "building_number": 2211,
    "street": "S Star Lake Rd",
    "city": "Federal Way",
    "zip": 98003,
    "concatenated_address": "2211 S Star Lake Rd, Federal Way",
    "address": "2211 S. Star Lake Road, Federal Way"
  },
  {
    "id": 328,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Brookdale Foundation House",
    "latitude": 47.3125,
    "longitude": -122.33263,
    "original_address": "32290 First Ave S",
    "building_number": 32290,
    "street": "1st Ave S",
    "city": "Federal Way",
    "zip": 98003,
    "concatenated_address": "32290 1st Ave S, Federal Way",
    "address": "32290 1st Ave. S., Federal Way"
  },
  {
    "id": 329,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "The Commons At Federal Way",
    "latitude": 47.299284,
    "longitude": -122.33417,
    "original_address": "101 S. 337th Lane",
    "building_number": 101,
    "street": "S 337th Ln",
    "city": "Federal Way",
    "zip": 98003,
    "concatenated_address": "101 S 337th Ln, Federal Way",
    "address": "101 S. 337th Lane, Federal Way"
  },
  {
    "id": 330,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Commons At Federal Way",
    "latitude": 47.299284,
    "longitude": -122.33417,
    "original_address": "101 S 337th Lane",
    "building_number": 101,
    "street": "S 337th Ln",
    "city": "Federal Way",
    "zip": 98003,
    "concatenated_address": "101 S 337th Ln, Federal Way",
    "address": "101 S. 337th Lane, Federal Way"
  },
  {
    "id": 331,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Lodge At Peasley Canyon",
    "latitude": 47.312603,
    "longitude": -122.2817,
    "original_address": "32200 Military Road South",
    "building_number": 32200,
    "street": "Military Rd S",
    "city": "Auburn",
    "zip": 98001,
    "concatenated_address": "32200 Military Rd S, Auburn",
    "address": "32200 Military Road S., Auburn"
  },
  {
    "id": 332,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Park At Dashpoint",
    "latitude": 47.317455,
    "longitude": -122.39682,
    "original_address": "31736 50th Lane Southwest",
    "building_number": 31736,
    "street": "50th Ln SW",
    "city": "Federal Way",
    "zip": 98023,
    "concatenated_address": "31736 50th Ln SW, Federal Way",
    "address": "31736 50th Lane S.W., Federal Way"
  },
  {
    "id": 333,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Silver Shadow",
    "latitude": 47.354075,
    "longitude": -122.3095,
    "original_address": "27606 Pacific Highway South",
    "building_number": 27606,
    "street": "Pacific Hwy S",
    "city": "Federal Way",
    "zip": 98003,
    "concatenated_address": "27606 Pacific Hwy S, Federal Way",
    "address": "27606 Pacific Highway S., Federal Way"
  },
  {
    "id": 334,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Greystone Meadows Apartments",
    "latitude": 47.322091,
    "longitude": -122.33382,
    "original_address": "31500 1st Avenue S",
    "building_number": 31500,
    "street": "1st Ave S",
    "city": "Federal Way",
    "zip": 98003,
    "concatenated_address": "31500 1st Ave S, Federal Way",
    "address": "31500 1st Ave. S., Federal Way"
  },
  {
    "id": 335,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Brier Woods Apartments",
    "latitude": 47.32207,
    "longitude": -122.30792,
    "original_address": "31224 20th Avenue S",
    "building_number": 31224,
    "street": "20th Ave S",
    "city": "Federal Way",
    "zip": 98003,
    "concatenated_address": "31224 20th Ave S, Federal Way",
    "address": "31224 20th Ave. S., Federal Way"
  },
  {
    "id": 336,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Align Apartments",
    "latitude": 47.28437,
    "longitude": -122.36456,
    "original_address": "35434 25th Avenue Sw",
    "building_number": 35434,
    "street": "25th Ave SW",
    "city": "Federal Way",
    "zip": 98023,
    "concatenated_address": "35434 25th Ave SW, Federal Way",
    "address": "35434 25th Ave. S.W., Federal Way"
  },
  {
    "id": 337,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Soundview Apartments",
    "latitude": 47.346146,
    "longitude": -122.3118,
    "original_address": "28425 18th Avenue South",
    "building_number": 28425,
    "street": "18th Ave S",
    "city": "Federal Way",
    "zip": 98003,
    "concatenated_address": "28425 18th Ave S, Federal Way",
    "address": "28425 18th Ave. S., Federal Way"
  },
  {
    "id": 338,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "The Ridge And Shores Apartments",
    "latitude": 47.316036,
    "longitude": -122.33757,
    "original_address": "31912 3rd Lane Sw And 31700 3rd Place Sw",
    "building_number": 31912,
    "street": "3rd Ln SW",
    "city": "Federal Way",
    "zip": 98023,
    "concatenated_address": "31912 3rd Ln SW, Federal Way",
    "address": "31912 3rd Lane S.W., Federal Way"
  },
  {
    "id": 339,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Bayview Apartment Homes",
    "latitude": 47.324774,
    "longitude": -122.33551,
    "original_address": "30911 1st Avenue S",
    "building_number": 30911,
    "street": "1st Ave S",
    "city": "Federal Way",
    "zip": 98003,
    "concatenated_address": "30911 1st Ave S, Federal Way",
    "address": "30911 1st Ave. S., Federal Way"
  },
  {
    "id": 340,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Avery At The Reserve",
    "latitude": 47.288275,
    "longitude": -122.33731,
    "original_address": "125 Sw Campus Drive",
    "building_number": 125,
    "street": "SW Campus Dr",
    "city": "Federal Way",
    "zip": 98023,
    "concatenated_address": "125 SW Campus Dr, Federal Way",
    "address": "125 S.W. Campus Drive, Federal Way"
  },
  {
    "id": 341,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Pacific Heights Apartment Homes",
    "latitude": 47.302572,
    "longitude": -122.31066,
    "original_address": "33311 18th Lane South",
    "building_number": 33311,
    "street": "18th Ln S",
    "city": "Federal Way",
    "zip": 98003,
    "concatenated_address": "33311 18th Ln S, Federal Way",
    "address": "33311 18th Lane S., Federal Way"
  },
  {
    "id": 342,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Trellis Apartments",
    "latitude": 47.28671,
    "longitude": -122.36164,
    "original_address": "2120 Southwest 352nd Street",
    "building_number": 2120,
    "street": "SW 352nd St",
    "city": "Federal Way",
    "zip": 98023,
    "concatenated_address": "2120 SW 352nd St, Federal Way",
    "address": "2120 S.W. 352nd St., Federal Way"
  },
  {
    "id": 343,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Pinewood Village",
    "latitude": 47.302572,
    "longitude": -122.31066,
    "original_address": "33311 18th Lane South",
    "building_number": 33311,
    "street": "18th Ln S",
    "city": "Federal Way",
    "zip": 98003,
    "concatenated_address": "33311 18th Ln S, Federal Way",
    "address": "33311 18th Lane S., Federal Way"
  },
  {
    "id": 344,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "View At The Lake II",
    "latitude": 47.326787,
    "longitude": -122.31112,
    "original_address": "1650 South 308th Street",
    "building_number": 1650,
    "street": "S 308th St",
    "city": "Federal Way",
    "zip": 98003,
    "concatenated_address": "1650 S 308th St, Federal Way",
    "address": "1650 S. 308th St., Federal Way"
  },
  {
    "id": 345,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "The Retreat At Maple Hill Apartments",
    "latitude": 47.314885,
    "longitude": -122.35896,
    "original_address": "1901 Southwest 320th Street",
    "building_number": 1901,
    "street": "SW 320th St",
    "city": "Federal Way",
    "zip": 98023,
    "concatenated_address": "1901 SW 320th St, Federal Way",
    "address": "1901 S.W. 320th St., Federal Way"
  },
  {
    "id": 346,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Arcadia Townhomes",
    "latitude": 47.299156,
    "longitude": -122.3502,
    "original_address": "1300 Southwest Campus Drive",
    "building_number": 1300,
    "street": "SW Campus Dr",
    "city": "Federal Way",
    "zip": 98023,
    "concatenated_address": "1300 SW Campus Dr, Federal Way",
    "address": "1300 S.W. Campus Drive, Federal Way"
  },
  {
    "id": 347,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Fox Run Apartments",
    "latitude": 47.290894,
    "longitude": -122.333,
    "original_address": "34720 2nd Lane South",
    "building_number": 34720,
    "street": "2nd Ln S",
    "city": "Federal Way",
    "zip": 98003,
    "concatenated_address": "34720 2nd Ln S, Federal Way",
    "address": "34720 2nd Lane S., Federal Way"
  },
  {
    "id": 348,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Westhampton Apartments",
    "latitude": 47.313231,
    "longitude": -122.32964,
    "original_address": "333 South 320th Street",
    "building_number": 333,
    "street": "S 320th St",
    "city": "Federal Way",
    "zip": 98003,
    "concatenated_address": "333 S 320th St, Federal Way",
    "address": "333 S. 320th St., Federal Way"
  },
  {
    "id": 349,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "West Pointe",
    "latitude": 47.285808,
    "longitude": -122.36192,
    "original_address": "2111 Southwest 352nd Street",
    "building_number": 2111,
    "street": "SW 352nd St",
    "city": "Federal Way",
    "zip": 98023,
    "concatenated_address": "2111 SW 352nd St, Federal Way",
    "address": "2111 S.W. 352nd St., Federal Way"
  },
  {
    "id": 350,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "The Cove Apartments",
    "latitude": 47.308141,
    "longitude": -122.33449,
    "original_address": "33015 1st Avenue South",
    "building_number": 33015,
    "street": "1st Ave S",
    "city": "Federal Way",
    "zip": 98003,
    "concatenated_address": "33015 1st Ave S, Federal Way",
    "address": "33015 1st Ave. S., Federal Way"
  },
  {
    "id": 351,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Miro At Dash Point",
    "latitude": 47.323842,
    "longitude": -122.35883,
    "original_address": "31004 19th Place Southwest",
    "building_number": 31004,
    "street": "19th Pl SW",
    "city": "Federal Way",
    "zip": 98023,
    "concatenated_address": "31004 19th Pl SW, Federal Way",
    "address": "31004 19th Pl S.W., Federal Way"
  },
  {
    "id": 352,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Belmor Park MHC",
    "latitude": 47.308364,
    "longitude": -122.30175,
    "original_address": "2101 South 324th Street",
    "building_number": 2101,
    "street": "S 324th St",
    "city": "Federal Way",
    "zip": 98003,
    "concatenated_address": "2101 S 324th St, Federal Way",
    "address": "2101 S. 324th St., Federal Way"
  },
  {
    "id": 353,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Pavilion II Apartment Homes",
    "latitude": 47.302683,
    "longitude": -122.35767,
    "original_address": "1900 Southwest Campus Drive",
    "building_number": 1900,
    "street": "SW Campus Dr",
    "city": "Federal Way",
    "zip": 98023,
    "concatenated_address": "1900 SW Campus Dr, Federal Way",
    "address": "1900 S.W. Campus Drive, Federal Way"
  },
  {
    "id": 354,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Pavilion I Apartment Homes",
    "latitude": 47.302683,
    "longitude": -122.35767,
    "original_address": "1900 Southwest Campus Drive",
    "building_number": 1900,
    "street": "SW Campus Dr",
    "city": "Federal Way",
    "zip": 98023,
    "concatenated_address": "1900 SW Campus Dr, Federal Way",
    "address": "1900 S.W. Campus Drive, Federal Way"
  },
  {
    "id": 355,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "The Argyle Apartment Homes",
    "latitude": 47.319079,
    "longitude": -122.30087,
    "original_address": "2517 South 316th Lane",
    "building_number": 2517,
    "street": "S 316th Ln",
    "city": "Federal Way",
    "zip": 98003,
    "concatenated_address": "2517 S 316th Ln, Federal Way",
    "address": "2517 S. 316th Lane, Federal Way"
  },
  {
    "id": 356,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Glen Park At West Campus",
    "latitude": 47.30155,
    "longitude": -122.34496,
    "original_address": "952 Southwest Campus Drive",
    "building_number": 952,
    "street": "SW Campus Dr",
    "city": "Federal Way",
    "zip": 98023,
    "concatenated_address": "952 SW Campus Dr, Federal Way",
    "address": "952 S.W. Campus Drive, Federal Way"
  },
  {
    "id": 357,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Evergreen Vale",
    "latitude": 47.279317,
    "longitude": -122.3067,
    "original_address": "35929 21st Place South",
    "building_number": 35929,
    "street": "21st Pl S",
    "city": "Federal Way",
    "zip": 98003,
    "concatenated_address": "35929 21st Pl S, Federal Way",
    "address": "35929 21st Pl S., Federal Way"
  },
  {
    "id": 358,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Miro At Dash Point",
    "latitude": 47.323842,
    "longitude": -122.35883,
    "original_address": "31004 19th Place Sw",
    "building_number": 31004,
    "street": "19th Pl SW",
    "city": "Federal Way",
    "zip": 98023,
    "concatenated_address": "31004 19th Pl SW, Federal Way",
    "address": "31004 19th Pl S.W., Federal Way"
  },
  {
    "id": 359,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "The Union An Apartment Community",
    "latitude": 47.285808,
    "longitude": -122.36192,
    "original_address": "2111 Sw 352nd Street",
    "building_number": 2111,
    "street": "SW 352nd St",
    "city": "Federal Way",
    "zip": 98023,
    "concatenated_address": "2111 SW 352nd St, Federal Way",
    "address": "2111 S.W. 352nd St., Federal Way"
  },
  {
    "id": 360,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Cedardale Apartment Homes",
    "latitude": 47.299778,
    "longitude": -122.36499,
    "original_address": "2501 Southwest 336th Street",
    "building_number": 2501,
    "street": "SW 336th St",
    "city": "Federal Way",
    "zip": 98023,
    "concatenated_address": "2501 SW 336th St, Federal Way",
    "address": "2501 S.W. 336th St., Federal Way"
  },
  {
    "id": 361,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "View At The Lake",
    "latitude": 47.327653,
    "longitude": -122.30859,
    "original_address": "30602 Pacific Highway South",
    "building_number": 30602,
    "street": "Pacific Hwy S",
    "city": "Federal Way",
    "zip": 98003,
    "concatenated_address": "30602 Pacific Hwy S, Federal Way",
    "address": "30602 Pacific Highway S., Federal Way"
  },
  {
    "id": 362,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Evergreen Apartment Homes",
    "latitude": 47.279317,
    "longitude": -122.3067,
    "original_address": "35929 21st Place S",
    "building_number": 35929,
    "street": "21st Pl S",
    "city": "Federal Way",
    "zip": 98003,
    "concatenated_address": "35929 21st Pl S, Federal Way",
    "address": "35929 21st Pl S., Federal Way"
  },
  {
    "id": 363,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "The Argyle Apartment Homes",
    "latitude": 47.319079,
    "longitude": -122.30087,
    "original_address": "2517 S 316th Lane",
    "building_number": 2517,
    "street": "S 316th Ln",
    "city": "Federal Way",
    "zip": 98003,
    "concatenated_address": "2517 S 316th Ln, Federal Way",
    "address": "2517 S. 316th Lane, Federal Way"
  },
  {
    "id": 364,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Arcadia Townhomes",
    "latitude": 47.299156,
    "longitude": -122.3502,
    "original_address": "1300 Sw Campus Dr",
    "building_number": 1300,
    "street": "SW Campus Dr",
    "city": "Federal Way",
    "zip": 98023,
    "concatenated_address": "1300 SW Campus Dr, Federal Way",
    "address": "1300 S.W. Campus Drive, Federal Way"
  },
  {
    "id": 365,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Brookdale Federal Way",
    "latitude": 47.324305,
    "longitude": -122.31529,
    "original_address": "31002 14th Avenue South",
    "building_number": 31002,
    "street": "14th Ave S",
    "city": "Federal Way",
    "zip": 98003,
    "concatenated_address": "31002 14th Ave S, Federal Way",
    "address": "31002 14th Ave. S., Federal Way"
  },
  {
    "id": 366,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Providence Landing Apartments",
    "latitude": 47.32189,
    "longitude": -122.29636,
    "original_address": "31220 28th Avenue South",
    "building_number": 31220,
    "street": "28th Ave S",
    "city": "Federal Way",
    "zip": 98003,
    "concatenated_address": "31220 28th Ave S, Federal Way",
    "address": "31220 28th Ave. S., Federal Way"
  },
  {
    "id": 367,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Cedar Gardens Apartments",
    "latitude": 47.299206,
    "longitude": -122.36143,
    "original_address": "2110 Sw 337 Pl",
    "building_number": 2110,
    "street": "SW 337th Pl",
    "city": "Federal Way",
    "zip": 98023,
    "concatenated_address": "2110 SW 337th Pl, Federal Way",
    "address": "2110 S.W. 337th Place, Federal Way"
  },
  {
    "id": 368,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Fircrest",
    "latitude": 47.328137,
    "longitude": -122.31093,
    "original_address": "1737 S 305th Place",
    "building_number": 1737,
    "street": "S 305th Pl",
    "city": "Federal Way",
    "zip": 98003,
    "concatenated_address": "1737 S 305th Pl, Federal Way",
    "address": "1737 S. 305th Place, Federal Way"
  },
  {
    "id": 369,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Village Green Retirement Campus",
    "latitude": 47.284309,
    "longitude": -122.33536,
    "original_address": "35419 First Avenue South",
    "building_number": 35419,
    "street": "1st Ave S",
    "city": "Federal Way",
    "zip": 98003,
    "concatenated_address": "35419 1st Ave S, Federal Way",
    "address": "35419 1st Ave. S., Federal Way"
  },
  {
    "id": 370,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Homestead Apartments",
    "latitude": 47.339797,
    "longitude": -122.30237,
    "original_address": "29225 Military Road South",
    "building_number": 29225,
    "street": "Military Rd S",
    "city": "Federal Way",
    "zip": 98003,
    "concatenated_address": "29225 Military Rd S, Federal Way",
    "address": "29225 Military Road S., Federal Way"
  },
  {
    "id": 371,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Waterbury Park Apartment Homes",
    "latitude": 47.308129,
    "longitude": -122.30914,
    "original_address": "32905 19th Place South",
    "building_number": 32905,
    "street": "19th Pl S",
    "city": "Federal Way",
    "zip": 98003,
    "concatenated_address": "32905 19th Pl S, Federal Way",
    "address": "32905 19th Pl S., Federal Way"
  },
  {
    "id": 372,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Parkway Apartments",
    "latitude": 47.304161,
    "longitude": -122.36266,
    "original_address": "2206 Sw 33Th Place",
    "building_number": 2208,
    "street": "SW 333rd St",
    "city": "Federal Way",
    "zip": 98023,
    "concatenated_address": "2208 SW 333rd St, Federal Way",
    "address": "2208 S.W. 333rd St., Federal Way"
  },
  {
    "id": 373,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Hallmark Manor Life Care Center",
    "latitude": 47.312638,
    "longitude": -122.33386,
    "original_address": "32300 First Ave South",
    "building_number": 32300,
    "street": "1st Ave S",
    "city": "Federal Way",
    "zip": 98003,
    "concatenated_address": "32300 1st Ave S, Federal Way",
    "address": "32300 1st Ave. S., Federal Way"
  },
  {
    "id": 374,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Avalon Care Center In Federal Way",
    "latitude": 47.298758,
    "longitude": -122.33127,
    "original_address": "135 S 336th Street",
    "building_number": 135,
    "street": "S 336th St",
    "city": "Federal Way",
    "zip": 98003,
    "concatenated_address": "135 S 336th St, Federal Way",
    "address": "135 S. 336th St., Federal Way"
  },
  {
    "id": 375,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Life Care Center Of Federal Way",
    "latitude": 47.325439,
    "longitude": -122.3193,
    "original_address": "1045 South 308th Street",
    "building_number": 1045,
    "street": "S 308th St",
    "city": "Federal Way",
    "zip": 98003,
    "concatenated_address": "1045 S 308th St, Federal Way",
    "address": "1045 S. 308th St., Federal Way"
  },
  {
    "id": 376,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Life Care Garden Terrace Healthcare Center",
    "latitude": 47.298112,
    "longitude": -122.32643,
    "original_address": "491 South 338th St.",
    "building_number": 491,
    "street": "S 338th St",
    "city": "Federal Way",
    "zip": 98003,
    "concatenated_address": "491 S 338th St, Federal Way",
    "address": "491 S. 338th St., Federal Way"
  },
  {
    "id": 377,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Louisa Place",
    "latitude": 48.849433,
    "longitude": -122.60347,
    "original_address": "2240 Main Street",
    "building_number": 2240,
    "street": "Main St",
    "city": "Ferndale",
    "zip": 98248,
    "concatenated_address": "2240 Main St, Ferndale",
    "address": "2240 Main St., Ferndale"
  },
  {
    "id": 378,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Beacon Manor",
    "latitude": 48.84677,
    "longitude": -122.60722,
    "original_address": "2306 Douglas Road",
    "building_number": 2306,
    "street": "Douglas Rd",
    "city": "Ferndale",
    "zip": 98248,
    "concatenated_address": "2306 Douglas Rd, Ferndale",
    "address": "2306 Douglas Road, Ferndale"
  },
  {
    "id": 379,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Bella Sonoma Apartments",
    "latitude": 47.232513,
    "longitude": -122.35943,
    "original_address": "2313 And 2415 62nd Avenue East",
    "building_number": "",
    "street": "",
    "city": "Tacoma",
    "zip": 98424,
    "concatenated_address": "2313 And 2415 62nd Avenue East, Tacoma",
    "address": "2313 And 2415 62nd Avenue East, Tacoma"
  },
  {
    "id": 380,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Chateau Rainier Apartments",
    "latitude": 47.242281,
    "longitude": -122.36792,
    "original_address": "4600 16th Street East",
    "building_number": 4600,
    "street": "16th St E",
    "city": "Tacoma",
    "zip": 98424,
    "concatenated_address": "4600 16th St E, Tacoma",
    "address": "4600 16th St. E., Tacoma"
  },
  {
    "id": 381,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Revive Apartments",
    "latitude": 47.235125,
    "longitude": -122.34992,
    "original_address": "2341 58th Ave East",
    "building_number": 2341,
    "street": "58th Ave E",
    "city": "Tacoma",
    "zip": 98424,
    "concatenated_address": "2341 58th Ave E, Tacoma",
    "address": "2341 58th Ave. E., Tacoma"
  },
  {
    "id": 382,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Willow Green Village Apartments",
    "latitude": 47.23922,
    "longitude": -122.3425,
    "original_address": "6501 20th Street E",
    "building_number": 6501,
    "street": "20th St E",
    "city": "Tacoma",
    "zip": 98424,
    "concatenated_address": "6501 20th St E, Tacoma",
    "address": "6501 20th St. E., Tacoma"
  },
  {
    "id": 383,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "The Lakes At Fife",
    "latitude": 47.235911,
    "longitude": -122.3513,
    "original_address": "2301 58th Avenue East",
    "building_number": 2301,
    "street": "58th Ave E",
    "city": "Tacoma",
    "zip": 98424,
    "concatenated_address": "2301 58th Ave E, Tacoma",
    "address": "2301 58th Ave. E., Tacoma"
  },
  {
    "id": 384,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "The Park At Fife Apartments",
    "latitude": 47.237064,
    "longitude": -122.34853,
    "original_address": "2126 62nd Avenue East",
    "building_number": 2126,
    "street": "62nd Ave E",
    "city": "Tacoma",
    "zip": 98424,
    "concatenated_address": "2126 62nd Ave E, Tacoma",
    "address": "2126 62nd Ave. E., Tacoma"
  },
  {
    "id": 385,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Pointe East Apartment Homes",
    "latitude": 47.234062,
    "longitude": -122.34836,
    "original_address": "2524 62nd Avenue East",
    "building_number": 2524,
    "street": "62nd Ave E",
    "city": "Tacoma",
    "zip": 98424,
    "concatenated_address": "2524 62nd Ave E, Tacoma",
    "address": "2524 62nd Ave. E., Tacoma"
  },
  {
    "id": 386,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Astoria Apartment Homes",
    "latitude": 47.236245,
    "longitude": -122.35333,
    "original_address": "5700 23rd Street East",
    "building_number": 5700,
    "street": "23rd St E",
    "city": "Tacoma",
    "zip": 98424,
    "concatenated_address": "5700 23rd St E, Tacoma",
    "address": "5700 23rd St. E., Tacoma"
  },
  {
    "id": 387,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Port Landing At Fife",
    "latitude": 47.232596,
    "longitude": -122.34685,
    "original_address": "2715 62nd Avenue East",
    "building_number": 2715,
    "street": "62nd Ave E",
    "city": "Tacoma",
    "zip": 98424,
    "concatenated_address": "2715 62nd Ave E, Tacoma",
    "address": "2715 62nd Ave. E., Tacoma"
  },
  {
    "id": 388,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Port Landing Apartments",
    "latitude": 47.232596,
    "longitude": -122.34685,
    "original_address": "2715 62nd Ave East",
    "building_number": 2715,
    "street": "62nd Ave E",
    "city": "Tacoma",
    "zip": 98424,
    "concatenated_address": "2715 62nd Ave E, Tacoma",
    "address": "2715 62nd Ave. E., Tacoma"
  },
  {
    "id": 389,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Rainier Pointe Apartments",
    "latitude": 47.239337,
    "longitude": -122.34081,
    "original_address": "6643 20th Street E",
    "building_number": 6643,
    "street": "20th St E",
    "city": "Tacoma",
    "zip": 98424,
    "concatenated_address": "6643 20th St E, Tacoma",
    "address": "6643 20th St. E., Tacoma"
  },
  {
    "id": 390,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Alameda West Apartments",
    "latitude": 47.221273,
    "longitude": -122.51802,
    "original_address": "1086 Arleo Lane",
    "building_number": 1086,
    "street": "Arleo Ln",
    "city": "Tacoma",
    "zip": 98466,
    "concatenated_address": "1086 Arleo Ln, Tacoma",
    "address": "1086 Arleo Lane, Tacoma"
  },
  {
    "id": 391,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Sawyer Trail Apartments",
    "latitude": 47.096988,
    "longitude": -122.37306,
    "original_address": "17412 44th Avenue East",
    "building_number": 17412,
    "street": "44th Ave E",
    "city": "Tacoma",
    "zip": 98446,
    "concatenated_address": "17412 44th Ave E, Tacoma",
    "address": "17412 44th Ave. E., Tacoma"
  },
  {
    "id": 392,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Maple Ridge Assisted Living Community",
    "latitude": 48.011171,
    "longitude": -122.51954,
    "original_address": "1767 Alliance Avenue",
    "building_number": 1767,
    "street": "Alliance Ave",
    "city": "Freeland",
    "zip": 98249,
    "concatenated_address": "1767 Alliance Ave, Freeland",
    "address": "1767 Alliance Ave., Freeland"
  },
  {
    "id": 393,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Stinson Park Apartments",
    "latitude": 47.324855,
    "longitude": -122.59026,
    "original_address": "7314 Stinson Avenue",
    "building_number": 7314,
    "street": "Stinson Ave",
    "city": "Gig Harbor",
    "zip": 98335,
    "concatenated_address": "7314 Stinson Ave, Gig Harbor",
    "address": "7314 Stinson Ave., Gig Harbor"
  },
  {
    "id": 394,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Hillcrest MHP",
    "latitude": 47.353032,
    "longitude": -122.5894,
    "original_address": "10414 Peacock Hill Ave Nw",
    "building_number": 10414,
    "street": "Peacock Hill Ave NW",
    "city": "Gig Harbor",
    "zip": 98332,
    "concatenated_address": "10414 Peacock Hill Ave NW, Gig Harbor",
    "address": "10414 Peacock Hill Ave. N.W., Gig Harbor"
  },
  {
    "id": 395,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Rosedale Village",
    "latitude": 47.330793,
    "longitude": -122.59247,
    "original_address": "4203 Rosedale St Nw",
    "building_number": 4203,
    "street": "Rosedale St NW",
    "city": "Gig Harbor",
    "zip": 98335,
    "concatenated_address": "4203 Rosedale St NW, Gig Harbor",
    "address": "4203 Rosedale St. N.W., Gig Harbor"
  },
  {
    "id": 396,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Harbor Place At Cottesmore",
    "latitude": 47.284715,
    "longitude": -122.55519,
    "original_address": "1016 29th Street Nw",
    "building_number": 1016,
    "street": "29th St NW",
    "city": "Gig Harbor",
    "zip": 98335,
    "concatenated_address": "1016 29th St NW, Gig Harbor",
    "address": "1016 29th St. N.W., Gig Harbor"
  },
  {
    "id": 397,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "The Lakes At Gig Harbor",
    "latitude": 47.389198,
    "longitude": -122.59196,
    "original_address": "4117 144th Street Nw",
    "building_number": 4117,
    "street": "144th St NW",
    "city": "Gig Harbor",
    "zip": 98332,
    "concatenated_address": "4117 144th St NW, Gig Harbor",
    "address": "4117 144th St. N.W., Gig Harbor"
  },
  {
    "id": 398,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Olympic Square",
    "latitude": 47.306601,
    "longitude": -122.57474,
    "original_address": "5287 Olympic Drive Nw",
    "building_number": 5287,
    "street": "Olympic Dr NW",
    "city": "Gig Harbor",
    "zip": 98335,
    "concatenated_address": "5287 Olympic Dr NW, Gig Harbor",
    "address": "5287 Olympic Dr N.W., Gig Harbor"
  },
  {
    "id": 399,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Colvos Terrace Apartments And Fawcett Apartments",
    "latitude": 47.309203,
    "longitude": -122.57431,
    "original_address": "2601 Hollycroft Street Multiple Addresses",
    "building_number": 2601,
    "street": "Hollycroft St",
    "city": "Gig Harbor",
    "zip": 98335,
    "concatenated_address": "2601 Hollycroft St, Gig Harbor",
    "address": "2601 Hollycroft St., Gig Harbor"
  },
  {
    "id": 400,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Cliffside Apartments",
    "latitude": 47.280404,
    "longitude": -122.55651,
    "original_address": "2413 Cliffside Ln Nw",
    "building_number": 2413,
    "street": "Cliffside Ln NW",
    "city": "Gig Harbor",
    "zip": 98335,
    "concatenated_address": "2413 Cliffside Ln NW, Gig Harbor",
    "address": "2413 Cliffside Lane N.W., Gig Harbor"
  },
  {
    "id": 401,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Forest Grove Apartments",
    "latitude": 47.307169,
    "longitude": -122.58645,
    "original_address": "5402 35th Avenue Northwest",
    "building_number": 5402,
    "street": "35th Ave NW",
    "city": "Gig Harbor",
    "zip": 98335,
    "concatenated_address": "5402 35th Ave NW, Gig Harbor",
    "address": "5402 35th Ave. N.W., Gig Harbor"
  },
  {
    "id": 402,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Clare Bridge At Shoreline View",
    "latitude": 47.344064,
    "longitude": -122.58618,
    "original_address": "9324 North Harborview Drive",
    "building_number": 9324,
    "street": "N Harborview Dr",
    "city": "Gig Harbor",
    "zip": 98332,
    "concatenated_address": "9324 N Harborview Dr, Gig Harbor",
    "address": "9324 N. Harborview Drive, Gig Harbor"
  },
  {
    "id": 403,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "The Lodge At Mallard's Landing",
    "latitude": 47.32135,
    "longitude": -122.59253,
    "original_address": "7083 Wagner Way Northwest",
    "building_number": 7083,
    "street": "Wagner Way",
    "city": "Gig Harbor",
    "zip": 98335,
    "concatenated_address": "7083 Wagner Way, Gig Harbor",
    "address": "7083 Wagner Way, Gig Harbor"
  },
  {
    "id": 404,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Peninsula Retirement",
    "latitude": 47.304828,
    "longitude": -122.58523,
    "original_address": "3445 50th Street Court Nw",
    "building_number": 3445,
    "street": "50th St Ct",
    "city": "Gig Harbor",
    "zip": 98335,
    "concatenated_address": "3445 50th St Ct, Gig Harbor",
    "address": "3445 50th St. Ct, Gig Harbor"
  },
  {
    "id": 405,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Harborview East Apartments",
    "latitude": 47.326759,
    "longitude": -122.59403,
    "original_address": "4100 Foster Street",
    "building_number": 4100,
    "street": "Foster St",
    "city": "Gig Harbor",
    "zip": 98335,
    "concatenated_address": "4100 Foster St, Gig Harbor",
    "address": "4100 Foster St., Gig Harbor"
  },
  {
    "id": 406,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "The 4425 Apartment Homes",
    "latitude": 47.29875,
    "longitude": -122.57693,
    "original_address": "4425 Harbor Country Drive",
    "building_number": 4425,
    "street": "Harbor Country Dr",
    "city": "Gig Harbor",
    "zip": 98335,
    "concatenated_address": "4425 Harbor Country Dr, Gig Harbor",
    "address": "4425 Harbor Country Drive, Gig Harbor"
  },
  {
    "id": 407,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Bracera At Gig Harbor",
    "latitude": 47.361159,
    "longitude": -122.59807,
    "original_address": "11400 Olympus Way",
    "building_number": 11400,
    "street": "Olympus Way",
    "city": "Gig Harbor",
    "zip": 98332,
    "concatenated_address": "11400 Olympus Way, Gig Harbor",
    "address": "11400 Olympus Way, Gig Harbor"
  },
  {
    "id": 408,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Azalea Gardens MHP",
    "latitude": 47.078666,
    "longitude": -122.2953,
    "original_address": "19525 100th Avenue Ct E",
    "building_number": 19525,
    "street": "100th Ave Ct E",
    "city": "Graham",
    "zip": 98338,
    "concatenated_address": "19525 100th Ave Ct E, Graham",
    "address": "19525 100th Ave. Ct E., Graham"
  },
  {
    "id": 409,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "The Outlook Apartments",
    "latitude": 47.078553,
    "longitude": -122.29344,
    "original_address": "10234 194th Street East",
    "building_number": 10234,
    "street": "194th St E",
    "city": "Graham",
    "zip": 98338,
    "concatenated_address": "10234 194th St E, Graham",
    "address": "10234 194th St. E., Graham"
  },
  {
    "id": 410,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Coulee Community Hospital",
    "latitude": 47.94154,
    "longitude": -119.00335,
    "original_address": "411 Fortuya Road",
    "building_number": "",
    "street": "",
    "city": "Grand Coulee",
    "zip": 99133,
    "concatenated_address": "411 Fortuya Road, Grand Coulee",
    "address": "411 Fortuya Road, Grand Coulee"
  },
  {
    "id": 411,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Chestnut Cove Apartments",
    "latitude": 48.087719,
    "longitude": -121.96445,
    "original_address": "10008 Mountain Loop Highway",
    "building_number": 10008,
    "street": "Mountain Loop Hwy",
    "city": "Granite Falls",
    "zip": 98252,
    "concatenated_address": "10008 Mountain Loop Hwy, Granite Falls",
    "address": "10008 Mountain Loop Highway, Granite Falls"
  },
  {
    "id": 412,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "South Bayview Apts",
    "latitude": 46.890388,
    "longitude": -124.10933,
    "original_address": "410 Pacific Avenue",
    "building_number": 410,
    "street": "Pacific Ave",
    "city": "Westport",
    "zip": 98595,
    "concatenated_address": "410 Pacific Ave, Westport",
    "address": "410 Pacific Ave., Westport"
  },
  {
    "id": 413,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "University House At Issaquah",
    "latitude": 47.547247,
    "longitude": -122.033,
    "original_address": "22975 Se Black Nugget Road",
    "building_number": 22975,
    "street": "SE Black Nugget Rd",
    "city": "Issaquah",
    "zip": 98029,
    "concatenated_address": "22975 SE Black Nugget Rd, Issaquah",
    "address": "22975 S.E. Black Nugget Road, Issaquah"
  },
  {
    "id": 414,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "The Estates At Cougar Mountain",
    "latitude": 47.530374,
    "longitude": -122.07015,
    "original_address": "2128 Shy Bear Way Nw",
    "building_number": 2128,
    "street": "Shy Bear Way NW",
    "city": "Issaquah",
    "zip": 98027,
    "concatenated_address": "2128 Shy Bear Way NW, Issaquah",
    "address": "2128 Shy Bear Way N.W., Issaquah"
  },
  {
    "id": 415,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Timberlake Park Apartments",
    "latitude": 47.562063,
    "longitude": -122.09138,
    "original_address": "4615 W. Lake Sammamish Parkway Se",
    "building_number": 4615,
    "street": "W Lake Sammamish Pkwy SE",
    "city": "Issaquah",
    "zip": 98027,
    "concatenated_address": "4615 W Lake Sammamish Pkwy SE, Issaquah",
    "address": "4615 W. Lake Sammamish Pkwy S.E., Issaquah"
  },
  {
    "id": 416,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Atlas",
    "latitude": 47.541352,
    "longitude": -122.04646,
    "original_address": "1036 7th Avenue Nw",
    "building_number": 1036,
    "street": "7th Ave NW",
    "city": "Issaquah",
    "zip": 98027,
    "concatenated_address": "1036 7th Ave NW, Issaquah",
    "address": "1036 7th Ave. N.W., Issaquah"
  },
  {
    "id": 417,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Windsong Apartments",
    "latitude": 47.523421,
    "longitude": -122.03385,
    "original_address": "600 Front Street South",
    "building_number": 600,
    "street": "Front St S",
    "city": "Issaquah",
    "zip": 98027,
    "concatenated_address": "600 Front St S, Issaquah",
    "address": "600 Front St. S., Issaquah"
  },
  {
    "id": 418,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Fieldstone Memory Care Of Issaquah",
    "latitude": 47.553788,
    "longitude": -122.02174,
    "original_address": "23845 Se Issaquah-Fall City Road",
    "building_number": 23845,
    "street": "SE Issaquah Fall City Rd",
    "city": "Issaquah",
    "zip": 98029,
    "concatenated_address": "23845 SE Issaquah Fall City Rd, Issaquah",
    "address": "23845 S.E. Issaquah Fall City Road, Issaquah"
  },
  {
    "id": 419,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Issaquah Terrace",
    "latitude": 47.54777,
    "longitude": -122.02041,
    "original_address": "906 Ne Lilac Street",
    "building_number": 906,
    "street": "NE Lilac St",
    "city": "Issaquah",
    "zip": 98029,
    "concatenated_address": "906 NE Lilac St, Issaquah",
    "address": "906 N.E. Lilac St., Issaquah"
  },
  {
    "id": 420,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Discovery Heights II",
    "latitude": 47.538438,
    "longitude": -122.01556,
    "original_address": "942 Discovery Circle Ne",
    "building_number": 942,
    "street": "Discovery Cir NE",
    "city": "Issaquah",
    "zip": 98029,
    "concatenated_address": "942 Discovery Cir NE, Issaquah",
    "address": "942 Discovery Cir N.E., Issaquah"
  },
  {
    "id": 421,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Aegis Of Issaquah",
    "latitude": 47.539926,
    "longitude": -122.04841,
    "original_address": "780 Northwest Juniper Street",
    "building_number": 780,
    "street": "NW Juniper St",
    "city": "Issaquah",
    "zip": 98027,
    "concatenated_address": "780 NW Juniper St, Issaquah",
    "address": "780 N.W. Juniper St., Issaquah"
  },
  {
    "id": 422,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Hutchison House Apartments",
    "latitude": 47.529252,
    "longitude": -122.04128,
    "original_address": "105 Mountain Park Blvd",
    "building_number": 105,
    "street": "Mountain Park Blvd SW",
    "city": "Issaquah",
    "zip": 98027,
    "concatenated_address": "105 Mountain Park Blvd SW, Issaquah",
    "address": "105 Mountain Park Blvd S.W., Issaquah"
  },
  {
    "id": 423,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Columbia Terrace Estates MHC",
    "latitude": 46.02707,
    "longitude": -122.84898,
    "original_address": "5400 Meeker Drive",
    "building_number": 5400,
    "street": "Meeker Dr",
    "city": "Kalama",
    "zip": 98625,
    "concatenated_address": "5400 Meeker Dr, Kalama",
    "address": "5400 Meeker Drive, Kalama"
  },
  {
    "id": 424,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Brookhollow MHC",
    "latitude": 46.144201,
    "longitude": -122.88276,
    "original_address": "2500 Allen Street",
    "building_number": 2500,
    "street": "Allen St",
    "city": "Kelso",
    "zip": 98626,
    "concatenated_address": "2500 Allen St, Kelso",
    "address": "2500 Allen St., Kelso"
  },
  {
    "id": 425,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Tim-Wa MHC",
    "latitude": 46.197923,
    "longitude": -122.91611,
    "original_address": "1965 Westside Highway",
    "building_number": 1965,
    "street": "Westside Hwy",
    "city": "Kelso",
    "zip": 98626,
    "concatenated_address": "1965 Westside Hwy, Kelso",
    "address": "1965 Westside Highway, Kelso"
  },
  {
    "id": 426,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Copper Ridge Apartments",
    "latitude": 46.177653,
    "longitude": -119.21183,
    "original_address": "5501 W. Hildebrand Blvd.",
    "building_number": "",
    "street": "Hildebrand Rd",
    "city": "Kennewick",
    "zip": 99338,
    "concatenated_address": "5501 W. Hildebrand Blvd., Kennewick",
    "address": "5501 W. Hildebrand Blvd., Kennewick"
  },
  {
    "id": 427,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Asteria Place",
    "latitude": 47.756597,
    "longitude": -122.23435,
    "original_address": "17525 80th Avenue Ne",
    "building_number": 17525,
    "street": "80th Ave NE",
    "city": "Kenmore",
    "zip": 98028,
    "concatenated_address": "17525 80th Ave NE, Kenmore",
    "address": "17525 80th Ave. N.E., Kenmore"
  },
  {
    "id": 428,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Northpointe Highlands Apartments",
    "latitude": 47.754705,
    "longitude": -122.22903,
    "original_address": "17512 83rd Place Ne",
    "building_number": 17512,
    "street": "83rd Pl NE",
    "city": "Kenmore",
    "zip": 98028,
    "concatenated_address": "17512 83rd Pl NE, Kenmore",
    "address": "17512 83rd Pl N.E., Kenmore"
  },
  {
    "id": 429,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Inglewood East Shores MHP",
    "latitude": 47.755407,
    "longitude": -122.24418,
    "original_address": "7301 Ne 175th Street",
    "building_number": 7301,
    "street": "NE 175th St",
    "city": "Kenmore",
    "zip": 98028,
    "concatenated_address": "7301 NE 175th St, Kenmore",
    "address": "7301 N.E. 175th St., Kenmore"
  },
  {
    "id": 430,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "17515 and 17527 83rd PL NE",
    "latitude": 47.75732,
    "longitude": -122.24401,
    "original_address": "17515 And 17527 83rd Pl Ne",
    "building_number": "",
    "street": "",
    "city": "Kenmore",
    "zip": 98028,
    "concatenated_address": "17515 And 17527 83rd Pl Ne, Kenmore",
    "address": "17515 And 17527 83rd Pl Ne, Kenmore"
  },
  {
    "id": 431,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Sammamish River Apartments",
    "latitude": 47.75732,
    "longitude": -122.24401,
    "original_address": "7345 And 7339 Ne 175th Street",
    "building_number": "",
    "street": "",
    "city": "Kenmore",
    "zip": 98028,
    "concatenated_address": "7345 And 7339 Ne 175th Street, Kenmore",
    "address": "7345 And 7339 Ne 175th St., Kenmore"
  },
  {
    "id": 432,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Emerald Villa Apartments",
    "latitude": 47.755791,
    "longitude": -122.23105,
    "original_address": "8044 Ne Bothell Way",
    "building_number": 8044,
    "street": "NE Bothell Way",
    "city": "Kenmore",
    "zip": 98028,
    "concatenated_address": "8044 NE Bothell Way, Kenmore",
    "address": "8044 N.E. Bothell Way, Kenmore"
  },
  {
    "id": 433,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Sun Ridge Apartments",
    "latitude": 47.761778,
    "longitude": -122.24491,
    "original_address": "18241 73rd Avenue Northeast",
    "building_number": 18241,
    "street": "73rd Ave NE",
    "city": "Kenmore",
    "zip": 98028,
    "concatenated_address": "18241 73rd Ave NE, Kenmore",
    "address": "18241 73rd Ave. N.E., Kenmore"
  },
  {
    "id": 434,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Chelsea Court Apartments",
    "latitude": 47.75732,
    "longitude": -122.24401,
    "original_address": "7206 And 7208 Ne 182nd Street",
    "building_number": "",
    "street": "",
    "city": "Kenmore",
    "zip": 98028,
    "concatenated_address": "7206 And 7208 Ne 182nd Street, Kenmore",
    "address": "7206 and 7208 N.E. 182nd St., Kenmore"
  },
  {
    "id": 435,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "The Timbers At Kenmore",
    "latitude": 47.765529,
    "longitude": -122.24847,
    "original_address": "18930 68th Avenue Northeast",
    "building_number": 18930,
    "street": "68th Ave NE",
    "city": "Kenmore",
    "zip": 98028,
    "concatenated_address": "18930 68th Ave NE, Kenmore",
    "address": "18930 68th Ave. N.E., Kenmore"
  },
  {
    "id": 436,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Clearwater Square Apartments",
    "latitude": 46.212569,
    "longitude": -119.18969,
    "original_address": "5031 W Clearwater Avenue",
    "building_number": 5031,
    "street": "W Clearwater Ave",
    "city": "Kennewick",
    "zip": 99336,
    "concatenated_address": "5031 W Clearwater Ave, Kennewick",
    "address": "5031 W. Clearwater Ave., Kennewick"
  },
  {
    "id": 437,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Meadow Park Apartments",
    "latitude": 46.205892,
    "longitude": -119.13239,
    "original_address": "1001 W 4th Ave",
    "building_number": 1001,
    "street": "W 4th Ave",
    "city": "Kennewick",
    "zip": 99336,
    "concatenated_address": "1001 W 4th Ave, Kennewick",
    "address": "1001 W. 4th Ave., Kennewick"
  },
  {
    "id": 438,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Park Ridge Apartments",
    "latitude": 46.21579,
    "longitude": -119.16887,
    "original_address": "3523 West Hood Avenue",
    "building_number": 3523,
    "street": "W Hood Ave",
    "city": "Kennewick",
    "zip": 99336,
    "concatenated_address": "3523 W Hood Ave, Kennewick",
    "address": "3523 W. Hood Ave., Kennewick"
  },
  {
    "id": 439,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Parkview Estates",
    "latitude": 46.204044,
    "longitude": -119.22415,
    "original_address": "7820 West 6th Avenue",
    "building_number": 7820,
    "street": "W 6th Ave",
    "city": "Kennewick",
    "zip": 99336,
    "concatenated_address": "7820 W 6th Ave, Kennewick",
    "address": "7820 W. 6th Ave., Kennewick"
  },
  {
    "id": 440,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Herron Lake Apartments",
    "latitude": 46.210219,
    "longitude": -119.19185,
    "original_address": "51 North Edison Street",
    "building_number": 51,
    "street": "N Edison St",
    "city": "Kennewick",
    "zip": 99336,
    "concatenated_address": "51 N Edison St, Kennewick",
    "address": "51 N. Edison St., Kennewick"
  },
  {
    "id": 441,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Solstice Senior Living At Kennewick",
    "latitude": 46.220615,
    "longitude": -119.23306,
    "original_address": "8264 W. Grandridge Blvd",
    "building_number": 8264,
    "street": "W Grandridge Blvd",
    "city": "Kennewick",
    "zip": 99336,
    "concatenated_address": "8264 W Grandridge Blvd, Kennewick",
    "address": "8264 W. Grandridge Blvd., Kennewick"
  },
  {
    "id": 442,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "The Seasons On 4th Avenue Apartments",
    "latitude": 46.206256,
    "longitude": -119.22393,
    "original_address": "8180 West 4th Avenue",
    "building_number": 8180,
    "street": "W 4th Ave",
    "city": "Kennewick",
    "zip": 99336,
    "concatenated_address": "8180 W 4th Ave, Kennewick",
    "address": "8180 W. 4th Ave., Kennewick"
  },
  {
    "id": 443,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Highlander Apartments",
    "latitude": 46.206091,
    "longitude": -119.16251,
    "original_address": "3030 W 4th Avenue",
    "building_number": 3030,
    "street": "W 4th Ave",
    "city": "Kennewick",
    "zip": 99336,
    "concatenated_address": "3030 W 4th Ave, Kennewick",
    "address": "3030 W. 4th Ave., Kennewick"
  },
  {
    "id": 444,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Lewis Country Estates MHC",
    "latitude": 46.207395,
    "longitude": -119.08887,
    "original_address": "90 S Verbena St",
    "building_number": 90,
    "street": "S Verbena St",
    "city": "Kennewick",
    "zip": 99337,
    "concatenated_address": "90 S Verbena St, Kennewick",
    "address": "90 S. Verbena St., Kennewick"
  },
  {
    "id": 445,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Callaway Gardens Alzheimer's Special Care Center",
    "latitude": 46.225561,
    "longitude": -119.1944,
    "original_address": "5505 West Skagit Court",
    "building_number": 5505,
    "street": "W Skagit Ct",
    "city": "Kennewick",
    "zip": 99336,
    "concatenated_address": "5505 W Skagit Ct, Kennewick",
    "address": "5505 W. Skagit Ct, Kennewick"
  },
  {
    "id": 446,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Central Park Apartments",
    "latitude": 46.203833,
    "longitude": -119.13772,
    "original_address": "505 South Olympia Street",
    "building_number": 505,
    "street": "S Olympia St",
    "city": "Kennewick",
    "zip": 99336,
    "concatenated_address": "505 S Olympia St, Kennewick",
    "address": "505 S. Olympia St., Kennewick"
  },
  {
    "id": 447,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Central Park Apartments",
    "latitude": 46.201498,
    "longitude": -119.13789,
    "original_address": "505 S Olympia St And 1326 W 7th Place",
    "building_number": "",
    "street": "S Olympia St",
    "city": "Kennewick",
    "zip": 99336,
    "concatenated_address": "505 S Olympia St And 1326 W 7th Place, Kennewick",
    "address": "505 S. Olympia St. And 1326 W. 7th Place, Kennewick"
  },
  {
    "id": 448,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Hawaiian Village Apartments",
    "latitude": 46.198704,
    "longitude": -119.13564,
    "original_address": "1105 West 10th Avenue",
    "building_number": 1105,
    "street": "W 10th Ave",
    "city": "Kennewick",
    "zip": 99336,
    "concatenated_address": "1105 W 10th Ave, Kennewick",
    "address": "1105 W. 10th Ave., Kennewick"
  },
  {
    "id": 449,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Clearwater Bay Apartments",
    "latitude": 46.21228,
    "longitude": -119.19192,
    "original_address": "5225 West Clearwater Avenue",
    "building_number": 5225,
    "street": "W Clearwater Ave",
    "city": "Kennewick",
    "zip": 99336,
    "concatenated_address": "5225 W Clearwater Ave, Kennewick",
    "address": "5225 W. Clearwater Ave., Kennewick"
  },
  {
    "id": 450,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Aspen Hills Apartments",
    "latitude": 46.198722,
    "longitude": -119.13663,
    "original_address": "1330 West 10th Avenue",
    "building_number": 1330,
    "street": "W 10th Ave",
    "city": "Kennewick",
    "zip": 99336,
    "concatenated_address": "1330 W 10th Ave, Kennewick",
    "address": "1330 W. 10th Ave., Kennewick"
  },
  {
    "id": 451,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Village At Grandridge",
    "latitude": 46.211498,
    "longitude": -119.22575,
    "original_address": "425 North Columbia Center Boulevard",
    "building_number": 425,
    "street": "N Columbia Center Blvd",
    "city": "Kennewick",
    "zip": 99336,
    "concatenated_address": "425 N Columbia Center Blvd, Kennewick",
    "address": "425 N. Columbia Center Blvd., Kennewick"
  },
  {
    "id": 452,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Hawthorne Court",
    "latitude": 46.214205,
    "longitude": -119.15796,
    "original_address": "524 North Ely Street",
    "building_number": 524,
    "street": "N Ely St",
    "city": "Kennewick",
    "zip": 99336,
    "concatenated_address": "524 N Ely St, Kennewick",
    "address": "524 N. Ely St., Kennewick"
  },
  {
    "id": 453,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Affinity At Southridge",
    "latitude": 46.177653,
    "longitude": -119.21183,
    "original_address": "5207 West Hildebrand Boulevard",
    "building_number": "",
    "street": "Hildebrand Rd",
    "city": "Kennewick",
    "zip": 99338,
    "concatenated_address": "5207 West Hildebrand Boulevard, Kennewick",
    "address": "5207 West Hildebrand Boulevard, Kennewick"
  },
  {
    "id": 454,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Hawaiian Village Apartments",
    "latitude": 46.198704,
    "longitude": -119.13564,
    "original_address": "1105 W 10th Avenue",
    "building_number": 1105,
    "street": "W 10th Ave",
    "city": "Kennewick",
    "zip": 99336,
    "concatenated_address": "1105 W 10th Ave, Kennewick",
    "address": "1105 W. 10th Ave., Kennewick"
  },
  {
    "id": 455,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Brookdale Canyon Lake",
    "latitude": 46.17821,
    "longitude": -119.1603,
    "original_address": "2802 West 35th Avenue",
    "building_number": 2802,
    "street": "W 35th Ave",
    "city": "Kennewick",
    "zip": 99337,
    "concatenated_address": "2802 W 35th Ave, Kennewick",
    "address": "2802 W. 35th Ave., Kennewick"
  },
  {
    "id": 456,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Crosspointe Apartments",
    "latitude": 46.212441,
    "longitude": -119.22565,
    "original_address": "7803 West Deschutes Avenue",
    "building_number": 7803,
    "street": "W Deschutes Ave",
    "city": "Kennewick",
    "zip": 99336,
    "concatenated_address": "7803 W Deschutes Ave, Kennewick",
    "address": "7803 W. Deschutes Ave., Kennewick"
  },
  {
    "id": 457,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Red Pines Apartments",
    "latitude": 46.212306,
    "longitude": -119.15567,
    "original_address": "718, 720, 722 North Arthur Street",
    "building_number": "",
    "street": "",
    "city": "Kennewick",
    "zip": 99336,
    "concatenated_address": "718, 720, 722 North Arthur Street, Kennewick",
    "address": "718, 720, 722 North Arthur St., Kennewick"
  },
  {
    "id": 458,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Woodland Park Apartments",
    "latitude": 46.202118,
    "longitude": -119.13359,
    "original_address": "601 South Kent Street",
    "building_number": 601,
    "street": "S Kent St",
    "city": "Kennewick",
    "zip": 99336,
    "concatenated_address": "601 S Kent St, Kennewick",
    "address": "601 S. Kent St., Kennewick"
  },
  {
    "id": 459,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "On The Boulevard",
    "latitude": 46.22739,
    "longitude": -119.24402,
    "original_address": "9202 West Gage Boulevard",
    "building_number": 9202,
    "street": "W Gage Blvd",
    "city": "Kennewick",
    "zip": 99336,
    "concatenated_address": "9202 W Gage Blvd, Kennewick",
    "address": "9202 W. Gage Blvd., Kennewick"
  },
  {
    "id": 460,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Desert Villa Apartments",
    "latitude": 46.202096,
    "longitude": -119.11833,
    "original_address": "635 South Auburn Street",
    "building_number": 635,
    "street": "S Auburn St",
    "city": "Kennewick",
    "zip": 99336,
    "concatenated_address": "635 S Auburn St, Kennewick",
    "address": "635 S. Auburn St., Kennewick"
  },
  {
    "id": 461,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Grandbridge Place",
    "latitude": 46.219569,
    "longitude": -119.23257,
    "original_address": "725 North Center Parkway",
    "building_number": 725,
    "street": "N Center Pkwy",
    "city": "Kennewick",
    "zip": 99336,
    "concatenated_address": "725 N Center Pkwy, Kennewick",
    "address": "725 N. Center Pkwy, Kennewick"
  },
  {
    "id": 462,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Quail Ridge Apartments",
    "latitude": 46.198029,
    "longitude": -119.10289,
    "original_address": "1026 West 10th Avenue",
    "building_number": 1026,
    "street": "W 10th Ave",
    "city": "Kennewick",
    "zip": 98336,
    "concatenated_address": "1026 W 10th Ave, Kennewick",
    "address": "1026 W. 10th Ave., Kennewick"
  },
  {
    "id": 463,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "La Serena At Hansen Park",
    "latitude": 46.206171,
    "longitude": -119.22299,
    "original_address": "7701 West 4th Avenue",
    "building_number": 7701,
    "street": "W 4th Ave",
    "city": "Kennewick",
    "zip": 99336,
    "concatenated_address": "7701 W 4th Ave, Kennewick",
    "address": "7701 W. 4th Ave., Kennewick"
  },
  {
    "id": 464,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Lifecare23-Kennewick",
    "latitude": 46.202333,
    "longitude": -119.1392,
    "original_address": "1508 West 7th Avenue",
    "building_number": 1508,
    "street": "W 7th Ave",
    "city": "Kennewick",
    "zip": 99336,
    "concatenated_address": "1508 W 7th Ave, Kennewick",
    "address": "1508 W. 7th Ave., Kennewick"
  },
  {
    "id": 465,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Regency Canyon Lakes Rehab & Nursing Center",
    "latitude": 46.183864,
    "longitude": -119.1592,
    "original_address": "2702 S. Ely Street",
    "building_number": 2702,
    "street": "S Ely St",
    "city": "Kennewick",
    "zip": 99337,
    "concatenated_address": "2702 S Ely St, Kennewick",
    "address": "2702 S. Ely St., Kennewick"
  },
  {
    "id": 466,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Arbor Village",
    "latitude": 47.385573,
    "longitude": -122.1878,
    "original_address": "24121 116th Avenue Southeast",
    "building_number": 24121,
    "street": "116th Ave SE",
    "city": "Kent",
    "zip": 98030,
    "concatenated_address": "24121 116th Ave SE, Kent",
    "address": "24121 116th Ave. S.E., Kent"
  },
  {
    "id": 467,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Sunrise Estates Apartments",
    "latitude": 47.390253,
    "longitude": -122.20646,
    "original_address": "23612 100th Avenue Se",
    "building_number": 23612,
    "street": "100th Ave SE",
    "city": "Kent",
    "zip": 98031,
    "concatenated_address": "23612 100th Ave SE, Kent",
    "address": "23612 100th Ave. S.E., Kent"
  },
  {
    "id": 468,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Sterling Ridge Apartments",
    "latitude": 47.368875,
    "longitude": -122.18982,
    "original_address": "11328 Se Kent Kangley Road",
    "building_number": 11328,
    "street": "SE Kent Kangley Rd",
    "city": "Kent",
    "zip": 98030,
    "concatenated_address": "11328 SE Kent Kangley Rd, Kent",
    "address": "11328 S.E. Kent Kangley Road, Kent"
  },
  {
    "id": 469,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Washington Park Apartments",
    "latitude": 47.372234,
    "longitude": -122.18987,
    "original_address": "11020 Se Kent Kangley Road",
    "building_number": 11020,
    "street": "SE Kent Kangley Rd",
    "city": "Kent",
    "zip": 98030,
    "concatenated_address": "11020 SE Kent Kangley Rd, Kent",
    "address": "11020 S.E. Kent Kangley Road, Kent"
  },
  {
    "id": 470,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Riverpointe Residences",
    "latitude": 47.37047,
    "longitude": -122.22646,
    "original_address": "25842 87th Avenue South",
    "building_number": 25842,
    "street": "87th Ave S",
    "city": "Kent",
    "zip": 98030,
    "concatenated_address": "25842 87th Ave S, Kent",
    "address": "25842 87th Ave. S., Kent"
  },
  {
    "id": 471,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Easthill Apartments",
    "latitude": 47.37473,
    "longitude": -122.19887,
    "original_address": "25246 106th Avenue South East",
    "building_number": 25246,
    "street": "106th Ave SE",
    "city": "Kent",
    "zip": 98030,
    "concatenated_address": "25246 106th Ave SE, Kent",
    "address": "25246 106th Ave. S.E., Kent"
  },
  {
    "id": 472,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Silver Springs Apartments",
    "latitude": 47.399646,
    "longitude": -122.22079,
    "original_address": "22416 88th Avenue South",
    "building_number": 22416,
    "street": "88th Ave S",
    "city": "Kent",
    "zip": 98031,
    "concatenated_address": "22416 88th Ave S, Kent",
    "address": "22416 88th Ave. S., Kent"
  },
  {
    "id": 473,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Signature Pointe Apartments",
    "latitude": 47.376089,
    "longitude": -122.2552,
    "original_address": "25102 62nd Avenue South",
    "building_number": 25102,
    "street": "62nd Ave S",
    "city": "Kent",
    "zip": 98032,
    "concatenated_address": "25102 62nd Ave S, Kent",
    "address": "25102 62nd Ave. S., Kent"
  },
  {
    "id": 474,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Island Park Apartments",
    "latitude": 47.39002,
    "longitude": -122.2605,
    "original_address": "23529 60th Avenue South",
    "building_number": 23529,
    "street": "60th Ave S",
    "city": "Kent",
    "zip": 98032,
    "concatenated_address": "23529 60th Ave S, Kent",
    "address": "23529 60th Ave. S., Kent"
  },
  {
    "id": 475,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Pantera Lago MHC",
    "latitude": 47.417701,
    "longitude": -122.19013,
    "original_address": "11436 Se 208th Street",
    "building_number": 11436,
    "street": "SE 208th St",
    "city": "Kent",
    "zip": 98031,
    "concatenated_address": "11436 SE 208th St, Kent",
    "address": "11436 S.E. 208th St., Kent"
  },
  {
    "id": 476,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Dwell At Kent Station",
    "latitude": 47.384765,
    "longitude": -122.23665,
    "original_address": "443 Ramsay Way",
    "building_number": 443,
    "street": "Ramsay Way",
    "city": "Kent",
    "zip": 98032,
    "concatenated_address": "443 Ramsay Way, Kent",
    "address": "443 Ramsay Way, Kent"
  },
  {
    "id": 477,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Forest Creek Apartments",
    "latitude": 47.379503,
    "longitude": -122.20834,
    "original_address": "24802 99th Place South",
    "building_number": 24802,
    "street": "99th Pl S",
    "city": "Kent",
    "zip": 98030,
    "concatenated_address": "24802 99th Pl S, Kent",
    "address": "24802 99th Pl S., Kent"
  },
  {
    "id": 478,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Country Glen Apartments",
    "latitude": 47.355879,
    "longitude": -122.16419,
    "original_address": "27400 132nd Avenue Se",
    "building_number": 27400,
    "street": "132nd Ave SE",
    "city": "Kent",
    "zip": 98042,
    "concatenated_address": "27400 132nd Ave SE, Kent",
    "address": "27400 132nd Ave. S.E., Kent"
  },
  {
    "id": 479,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Riverwood Apartments",
    "latitude": 47.384796,
    "longitude": -122.26211,
    "original_address": "24620 Russell Road",
    "building_number": 24620,
    "street": "Russell Rd",
    "city": "Kent",
    "zip": 98032,
    "concatenated_address": "24620 Russell Rd, Kent",
    "address": "24620 Russell Road, Kent"
  },
  {
    "id": 480,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Arbor Chase",
    "latitude": 47.38366,
    "longitude": -122.25284,
    "original_address": "1615 W. Smith Street",
    "building_number": 1615,
    "street": "W Smith St",
    "city": "Kent",
    "zip": 98032,
    "concatenated_address": "1615 W Smith St, Kent",
    "address": "1615 W. Smith St., Kent"
  },
  {
    "id": 481,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Kently Pointe Apartments",
    "latitude": 47.358451,
    "longitude": -122.27311,
    "original_address": "4724 S.272nd Street",
    "building_number": 4724,
    "street": "S 272nd St",
    "city": "Kent",
    "zip": 98032,
    "concatenated_address": "4724 S 272nd St, Kent",
    "address": "4724 S. 272nd St., Kent"
  },
  {
    "id": 482,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Water's Edge Apartments",
    "latitude": 47.387878,
    "longitude": -122.25626,
    "original_address": "6305 S 238th Place",
    "building_number": 6305,
    "street": "S 238th Pl",
    "city": "Kent",
    "zip": 98032,
    "concatenated_address": "6305 S 238th Pl, Kent",
    "address": "6305 S. 238th Place, Kent"
  },
  {
    "id": 483,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Vibe Apartments",
    "latitude": 47.37841,
    "longitude": -122.1964,
    "original_address": "25220-25600 109th Avenue Se",
    "building_number": 25220,
    "street": "110th Ave SE",
    "city": "Kent",
    "zip": 98030,
    "concatenated_address": "25220 110th Ave SE, Kent",
    "address": "25220 110th Ave. S.E., Kent"
  },
  {
    "id": 484,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Lake Meridian Estates",
    "latitude": 47.370816,
    "longitude": -122.16226,
    "original_address": "25739 135th Avenue Se",
    "building_number": 25739,
    "street": "135th Ave SE",
    "city": "Kent",
    "zip": 98042,
    "concatenated_address": "25739 135th Ave SE, Kent",
    "address": "25739 135th Ave. S.E., Kent"
  },
  {
    "id": 485,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Arterra Apartments",
    "latitude": 47.369873,
    "longitude": -122.20664,
    "original_address": "10031 Se 258th Pl",
    "building_number": 10031,
    "street": "SE 258th Pl",
    "city": "Kent",
    "zip": 98030,
    "concatenated_address": "10031 SE 258th Pl, Kent",
    "address": "10031 S.E. 258th Place, Kent"
  },
  {
    "id": 486,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Lake Meridian Shores Apartments",
    "latitude": 47.358805,
    "longitude": -122.15116,
    "original_address": "14200 Se 272nd Street",
    "building_number": 14200,
    "street": "SE 272nd St",
    "city": "Kent",
    "zip": 98042,
    "concatenated_address": "14200 SE 272nd St, Kent",
    "address": "14200 S.E. 272nd St., Kent"
  },
  {
    "id": 487,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Stratford Arms Apartments",
    "latitude": 47.374325,
    "longitude": -122.1924,
    "original_address": "11126 Se 256th Street",
    "building_number": 11126,
    "street": "SE 256th St",
    "city": "Kent",
    "zip": 98030,
    "concatenated_address": "11126 SE 256th St, Kent",
    "address": "11126 S.E. 256th St., Kent"
  },
  {
    "id": 488,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Indigo Springs Apartments",
    "latitude": 47.413383,
    "longitude": -122.19237,
    "original_address": "11101 Se 208th St.",
    "building_number": 11101,
    "street": "SE 208th St",
    "city": "Kent",
    "zip": 98031,
    "concatenated_address": "11101 SE 208th St, Kent",
    "address": "11101 S.E. 208th St., Kent"
  },
  {
    "id": 489,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Redhill Pines",
    "latitude": 47.377296,
    "longitude": -122.21154,
    "original_address": "9626 South 252nd Street",
    "building_number": 9626,
    "street": "S 252nd St",
    "city": "Kent",
    "zip": 98030,
    "concatenated_address": "9626 S 252nd St, Kent",
    "address": "9626 S. 252nd St., Kent"
  },
  {
    "id": 490,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Madison At Ridgegate",
    "latitude": 47.379422,
    "longitude": -122.20628,
    "original_address": "24808 100th Place Southeast",
    "building_number": 24808,
    "street": "100th Pl SE",
    "city": "Kent",
    "zip": 98030,
    "concatenated_address": "24808 100th Pl SE, Kent",
    "address": "24808 100th Pl S.E., Kent"
  },
  {
    "id": 491,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Alderbrook Apartments",
    "latitude": 47.393563,
    "longitude": -122.23024,
    "original_address": "412 East Novak Lane",
    "building_number": 412,
    "street": "E Novak Ln",
    "city": "Kent",
    "zip": 98032,
    "concatenated_address": "412 E Novak Ln, Kent",
    "address": "412 E. Novak Lane, Kent"
  },
  {
    "id": 492,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "The Platform Apartments",
    "latitude": 47.382809,
    "longitude": -122.23639,
    "original_address": "420 West Smith Street",
    "building_number": 420,
    "street": "W Smith St",
    "city": "Kent",
    "zip": 98032,
    "concatenated_address": "420 W Smith St, Kent",
    "address": "420 W. Smith St., Kent"
  },
  {
    "id": 493,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Waterbrook Lofts And Apartments",
    "latitude": 47.377643,
    "longitude": -122.19872,
    "original_address": "10615 Se 250th Place",
    "building_number": 10615,
    "street": "SE 250th Pl",
    "city": "Kent",
    "zip": 98030,
    "concatenated_address": "10615 SE 250th Pl, Kent",
    "address": "10615 S.E. 250th Place, Kent"
  },
  {
    "id": 494,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Apex West Hill",
    "latitude": 47.377711,
    "longitude": -122.2749,
    "original_address": "24849 46th Avenue South",
    "building_number": 24849,
    "street": "46th Ave S",
    "city": "Kent",
    "zip": 98032,
    "concatenated_address": "24849 46th Ave S, Kent",
    "address": "24849 46th Ave. S., Kent"
  },
  {
    "id": 495,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Pembrooke Apartment Homes",
    "latitude": 47.368753,
    "longitude": -122.29756,
    "original_address": "25907 27th Place South",
    "building_number": 25907,
    "street": "27th Pl S",
    "city": "Kent",
    "zip": 98032,
    "concatenated_address": "25907 27th Pl S, Kent",
    "address": "25907 27th Pl S., Kent"
  },
  {
    "id": 496,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "The Wilson Apartments",
    "latitude": 47.37858,
    "longitude": -122.20387,
    "original_address": "24910 103rd Avenue Southeast",
    "building_number": 24910,
    "street": "103rd Ave SE",
    "city": "Kent",
    "zip": 98030,
    "concatenated_address": "24910 103rd Ave SE, Kent",
    "address": "24910 103rd Ave. S.E., Kent"
  },
  {
    "id": 497,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Berkeley Heights Apartments",
    "latitude": 47.397763,
    "longitude": -122.21976,
    "original_address": "22804 90th Way South",
    "building_number": 22804,
    "street": "90th Way S",
    "city": "Kent",
    "zip": 98032,
    "concatenated_address": "22804 90th Way S, Kent",
    "address": "22804 90th Way S., Kent"
  },
  {
    "id": 498,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "The Row",
    "latitude": 47.372271,
    "longitude": -122.20868,
    "original_address": "25426 98th Avenue South",
    "building_number": 25426,
    "street": "98th Ave S",
    "city": "Kent",
    "zip": 98030,
    "concatenated_address": "25426 98th Ave S, Kent",
    "address": "25426 98th Ave. S., Kent"
  },
  {
    "id": 499,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Huntington Woods",
    "latitude": 47.358153,
    "longitude": -122.30483,
    "original_address": "2136 South 272nd Street",
    "building_number": 2136,
    "street": "S 272nd St",
    "city": "Kent",
    "zip": 98032,
    "concatenated_address": "2136 S 272nd St, Kent",
    "address": "2136 S. 272nd St., Kent"
  },
  {
    "id": 500,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Waterbrook Lofts And Apartments",
    "latitude": 47.377643,
    "longitude": -122.19872,
    "original_address": "10615 Southeast 250th Place",
    "building_number": 10615,
    "street": "SE 250th Pl",
    "city": "Kent",
    "zip": 98030,
    "concatenated_address": "10615 SE 250th Pl, Kent",
    "address": "10615 S.E. 250th Place, Kent"
  },
  {
    "id": 501,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "20609 108th Avenue Southeast",
    "latitude": 47.41751,
    "longitude": -122.19829,
    "original_address": "20609 108th Avenue Southeast",
    "building_number": 20609,
    "street": "108th Ave SE",
    "city": "Kent",
    "zip": 98031,
    "concatenated_address": "20609 108th Ave SE, Kent",
    "address": "20609 108th Ave. S.E., Kent"
  },
  {
    "id": 502,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Weatherly Inn At Lake Meridian",
    "latitude": 47.357388,
    "longitude": -122.14038,
    "original_address": "15101 Southeast 272nd Street",
    "building_number": 15101,
    "street": "SE 272nd St",
    "city": "Kent",
    "zip": 98042,
    "concatenated_address": "15101 SE 272nd St, Kent",
    "address": "15101 S.E. 272nd St., Kent"
  },
  {
    "id": 503,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Ventana Apartments",
    "latitude": 47.38452,
    "longitude": -122.2512,
    "original_address": "329 Ridgeview Drive",
    "building_number": 329,
    "street": "Ridgeview Dr",
    "city": "Kent",
    "zip": 98032,
    "concatenated_address": "329 Ridgeview Dr, Kent",
    "address": "329 Ridgeview Drive, Kent"
  },
  {
    "id": 504,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Green Leaf Skyline",
    "latitude": 47.402069,
    "longitude": -122.28979,
    "original_address": "3322 South 222nd Place",
    "building_number": 3322,
    "street": "S 222nd Pl",
    "city": "Kent",
    "zip": 98032,
    "concatenated_address": "3322 S 222nd Pl, Kent",
    "address": "3322 S. 222nd Place, Kent"
  },
  {
    "id": 505,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "The Row An Apartment Community",
    "latitude": 47.372271,
    "longitude": -122.20868,
    "original_address": "25426 98th Avenue South",
    "building_number": 25426,
    "street": "98th Ave S",
    "city": "Kent",
    "zip": 98030,
    "concatenated_address": "25426 98th Ave S, Kent",
    "address": "25426 98th Ave. S., Kent"
  },
  {
    "id": 506,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "The Blvd",
    "latitude": 47.358153,
    "longitude": -122.30483,
    "original_address": "2136 South 272nd Street",
    "building_number": 2136,
    "street": "S 272nd St",
    "city": "Kent",
    "zip": 98032,
    "concatenated_address": "2136 S 272nd St, Kent",
    "address": "2136 S. 272nd St., Kent"
  },
  {
    "id": 507,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "The Village Of Newport",
    "latitude": 47.358875,
    "longitude": -122.30119,
    "original_address": "2500 South 272nd Street",
    "building_number": 2500,
    "street": "S 272nd St",
    "city": "Kent",
    "zip": 98032,
    "concatenated_address": "2500 S 272nd St, Kent",
    "address": "2500 S. 272nd St., Kent"
  },
  {
    "id": 508,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Bryson Square Apartments",
    "latitude": 47.38635,
    "longitude": -122.19645,
    "original_address": "10823 Southeast 240th Street",
    "building_number": 10823,
    "street": "SE 240th Pl",
    "city": "Kent",
    "zip": 98030,
    "concatenated_address": "10823 SE 240th Pl, Kent",
    "address": "10823 S.E. 240th Place, Kent"
  },
  {
    "id": 509,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Meridian Garden",
    "latitude": 47.386443,
    "longitude": -122.16659,
    "original_address": "13101 Southeast 240th Street",
    "building_number": 13101,
    "street": "SE 240th St",
    "city": "Kent",
    "zip": 98031,
    "concatenated_address": "13101 SE 240th St, Kent",
    "address": "13101 S.E. 240th St., Kent"
  },
  {
    "id": 510,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Totem Townhomes",
    "latitude": 47.373457,
    "longitude": -122.20375,
    "original_address": "25449 104th Ave Se",
    "building_number": 25449,
    "street": "104th Ave SE",
    "city": "Kent",
    "zip": 98030,
    "concatenated_address": "25449 104th Ave SE, Kent",
    "address": "25449 104th Ave. S.E., Kent"
  },
  {
    "id": 511,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "The Morgan Townhome Apartments",
    "latitude": 47.415255,
    "longitude": -122.19433,
    "original_address": "20801-20853 110th Avenue Se",
    "building_number": 20853,
    "street": "110th Ave SE",
    "city": "Kent",
    "zip": 98031,
    "concatenated_address": "20853 110th Ave SE, Kent",
    "address": "20853 110th Ave. S.E., Kent"
  },
  {
    "id": 512,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Cityzen Common",
    "latitude": 47.370115,
    "longitude": -122.19492,
    "original_address": "10925 Southeast 259th Street",
    "building_number": 10925,
    "street": "SE 259th St",
    "city": "Kent",
    "zip": 98030,
    "concatenated_address": "10925 SE 259th St, Kent",
    "address": "10925 S.E. 259th St., Kent"
  },
  {
    "id": 513,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "The Lighthouse",
    "latitude": 47.372812,
    "longitude": -122.19763,
    "original_address": "10710 Southeast 256th Street",
    "building_number": 10710,
    "street": "SE 256th St",
    "city": "Kent",
    "zip": 98030,
    "concatenated_address": "10710 SE 256th St, Kent",
    "address": "10710 S.E. 256th St., Kent"
  },
  {
    "id": 514,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Waterford At The Lakes Apartment Homes",
    "latitude": 47.390033,
    "longitude": -122.25791,
    "original_address": "23605 62nd Avenue South",
    "building_number": 23605,
    "street": "62nd Ave S",
    "city": "Kent",
    "zip": 98032,
    "concatenated_address": "23605 62nd Ave S, Kent",
    "address": "23605 62nd Ave. S., Kent"
  },
  {
    "id": 515,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Sun Vista Apartments",
    "latitude": 47.380688,
    "longitude": -122.2177,
    "original_address": "1254 Weiland Street",
    "building_number": 1254,
    "street": "Weiland St",
    "city": "Kent",
    "zip": 98030,
    "concatenated_address": "1254 Weiland St, Kent",
    "address": "1254 Weiland St., Kent"
  },
  {
    "id": 516,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Stafford Suites At Kent",
    "latitude": 47.382045,
    "longitude": -122.22715,
    "original_address": "112 Kennebeck Avenue North",
    "building_number": 112,
    "street": "Kennebeck Ave N",
    "city": "Kent",
    "zip": 98030,
    "concatenated_address": "112 Kennebeck Ave N, Kent",
    "address": "112 Kennebeck Ave. N., Kent"
  },
  {
    "id": 517,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "",
    "latitude": 47.724012,
    "longitude": -122.20498,
    "original_address": "10132 64 Ne 137th Pl",
    "building_number": 10132,
    "street": "NE 137th Pl",
    "city": "Kirkland",
    "zip": 98034,
    "concatenated_address": "10132 NE 137th Pl, Kirkland",
    "address": "10132 N.E. 137th Place, Kirkland"
  },
  {
    "id": 518,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Plum Court",
    "latitude": 47.672574,
    "longitude": -122.19968,
    "original_address": "451 4th Avenue South",
    "building_number": 451,
    "street": "4th Ave S",
    "city": "Kirkland",
    "zip": 98033,
    "concatenated_address": "451 4th Ave S, Kirkland",
    "address": "451 4th Ave. S., Kirkland"
  },
  {
    "id": 519,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Cedar Heights Apartments",
    "latitude": 47.709637,
    "longitude": -122.16412,
    "original_address": "13215 Ne 123rd Street12229 Ne 131st Place",
    "building_number": 13215,
    "street": "NE 123rd St",
    "city": "Kirkland",
    "zip": 98034,
    "concatenated_address": "13215 NE 123rd St, Kirkland",
    "address": "13215 N.E. 123rd St., Kirkland"
  },
  {
    "id": 520,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Bridlewood Apartments",
    "latitude": 47.718834,
    "longitude": -122.21097,
    "original_address": "13210 97th Avenue",
    "building_number": 13210,
    "street": "97th Ave NE",
    "city": "Kirkland",
    "zip": 98034,
    "concatenated_address": "13210 97th Ave NE, Kirkland",
    "address": "13210 97th Ave. N.E., Kirkland"
  },
  {
    "id": 521,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Sancerre Apartments",
    "latitude": 47.731491,
    "longitude": -122.17146,
    "original_address": "12648 Ne 144th Street",
    "building_number": 12648,
    "street": "NE 144th St",
    "city": "Kirkland",
    "zip": 98034,
    "concatenated_address": "12648 NE 144th St, Kirkland",
    "address": "12648 N.E. 144th St., Kirkland"
  },
  {
    "id": 522,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Vue Kirkland Apartments",
    "latitude": 47.717241,
    "longitude": -122.18398,
    "original_address": "11733 Ne 131st Place",
    "building_number": 11733,
    "street": "NE 131st Pl",
    "city": "Kirkland",
    "zip": 98034,
    "concatenated_address": "11733 NE 131st Pl, Kirkland",
    "address": "11733 N.E. 131st Place, Kirkland"
  },
  {
    "id": 523,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Arete",
    "latitude": 47.678763,
    "longitude": -122.20009,
    "original_address": "450 Central Way",
    "building_number": 450,
    "street": "Central Way",
    "city": "Kirkland",
    "zip": 98033,
    "concatenated_address": "450 Central Way, Kirkland",
    "address": "450 Central Way, Kirkland"
  },
  {
    "id": 524,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Tera Apartments",
    "latitude": 47.679255,
    "longitude": -122.19805,
    "original_address": "528 Central Way",
    "building_number": 528,
    "street": "Central Way",
    "city": "Kirkland",
    "zip": 98033,
    "concatenated_address": "528 Central Way, Kirkland",
    "address": "528 Central Way, Kirkland"
  },
  {
    "id": 525,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Aspen Creek Apartments",
    "latitude": 47.699743,
    "longitude": -122.17633,
    "original_address": "11101 123rd Lane Ne",
    "building_number": 11101,
    "street": "123rd Ln NE",
    "city": "Kirkland",
    "zip": 98033,
    "concatenated_address": "11101 123rd Ln NE, Kirkland",
    "address": "11101 123rd Lane N.E., Kirkland"
  },
  {
    "id": 526,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Villa Bonita Apartments",
    "latitude": 47.716732,
    "longitude": -122.20864,
    "original_address": "9823 N.E. 130th Place",
    "building_number": 9823,
    "street": "NE 130th Pl",
    "city": "Kirkland",
    "zip": 98034,
    "concatenated_address": "9823 NE 130th Pl, Kirkland",
    "address": "9823 N.E. 130th Place, Kirkland"
  },
  {
    "id": 527,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Aegis Lodge Of Kirkland",
    "latitude": 47.713726,
    "longitude": -122.18727,
    "original_address": "12629 116th Avenue Ne",
    "building_number": 12629,
    "street": "116th Ave NE",
    "city": "Kirkland",
    "zip": 98034,
    "concatenated_address": "12629 116th Ave NE, Kirkland",
    "address": "12629 116th Ave. N.E., Kirkland"
  },
  {
    "id": 528,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Avana Forbes Creek",
    "latitude": 47.696424,
    "longitude": -122.19267,
    "original_address": "11110 Forbes Creek Drive",
    "building_number": 11110,
    "street": "Forbes Creek Dr",
    "city": "Kirkland",
    "zip": 98033,
    "concatenated_address": "11110 Forbes Creek Dr, Kirkland",
    "address": "11110 Forbes Creek Drive, Kirkland"
  },
  {
    "id": 529,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Totem Lake Heights Apartments",
    "latitude": 47.713981,
    "longitude": -122.17506,
    "original_address": "12414 Northeast 127th Court",
    "building_number": 12414,
    "street": "NE 127th Ct",
    "city": "Kirkland",
    "zip": 98034,
    "concatenated_address": "12414 NE 127th Ct, Kirkland",
    "address": "12414 N.E. 127th Ct, Kirkland"
  },
  {
    "id": 530,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Seagull Apartments",
    "latitude": 47.672304,
    "longitude": -122.20519,
    "original_address": "430 Lake Street South",
    "building_number": 430,
    "street": "Lake St S",
    "city": "Kirkland",
    "zip": 98033,
    "concatenated_address": "430 Lake St S, Kirkland",
    "address": "430 Lake St. S., Kirkland"
  },
  {
    "id": 531,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Life Care Center Of Kirkland",
    "latitude": 47.707296,
    "longitude": -122.2059,
    "original_address": "10101 Ne 120th",
    "building_number": 10101,
    "street": "NE 120th St",
    "city": "Kirkland",
    "zip": 98034,
    "concatenated_address": "10101 NE 120th St, Kirkland",
    "address": "10101 N.E. 120th St., Kirkland"
  },
  {
    "id": 532,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Plum Court Apartments",
    "latitude": 47.672574,
    "longitude": -122.19968,
    "original_address": "451 4th Avenue South",
    "building_number": 451,
    "street": "4th Ave S",
    "city": "Kirkland",
    "zip": 98033,
    "concatenated_address": "451 4th Ave S, Kirkland",
    "address": "451 4th Ave. S., Kirkland"
  },
  {
    "id": 533,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Sunset Gardens",
    "latitude": 47.033311,
    "longitude": -122.79985,
    "original_address": "1410 Alanna Drive Se",
    "building_number": 1410,
    "street": "Alanna Dr SE",
    "city": "Lacey",
    "zip": 98503,
    "concatenated_address": "1410 Alanna Dr SE, Lacey",
    "address": "1410 Alanna Dr S.E., Lacey"
  },
  {
    "id": 534,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Wooded Village MHP",
    "latitude": 47.011629,
    "longitude": -122.82701,
    "original_address": "4401 37th Avenue Se",
    "building_number": 4401,
    "street": "37th Ave SE",
    "city": "Lacey",
    "zip": 98503,
    "concatenated_address": "4401 37th Ave SE, Lacey",
    "address": "4401 37th Ave. S.E., Lacey"
  },
  {
    "id": 535,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Edgelake Mobile Home Park",
    "latitude": 47.031189,
    "longitude": -122.83841,
    "original_address": "3928 21st Ave Se",
    "building_number": 3928,
    "street": "21st Ave SE",
    "city": "Lacey",
    "zip": 98503,
    "concatenated_address": "3928 21st Ave SE, Lacey",
    "address": "3928 21st Ave. S.E., Lacey"
  },
  {
    "id": 536,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Emerald Pointe Apartments",
    "latitude": 47.033252,
    "longitude": -122.80874,
    "original_address": "1405 Clearbrook Drive Southeast",
    "building_number": 1405,
    "street": "Clearbrook Dr SE",
    "city": "Lacey",
    "zip": 98503,
    "concatenated_address": "1405 Clearbrook Dr SE, Lacey",
    "address": "1405 Clearbrook Dr S.E., Lacey"
  },
  {
    "id": 537,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Capitol Club Apartments",
    "latitude": 47.035208,
    "longitude": -122.83766,
    "original_address": "3800 14th Avenue Se",
    "building_number": 3800,
    "street": "14th Ave SE",
    "city": "Lacey",
    "zip": 98503,
    "concatenated_address": "3800 14th Ave SE, Lacey",
    "address": "3800 14th Ave. S.E., Lacey"
  },
  {
    "id": 538,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Olympus Court Apartments",
    "latitude": 47.076561,
    "longitude": -122.75907,
    "original_address": "8700 Hanna Lane Ne",
    "building_number": "",
    "street": "Hanna Ct NE",
    "city": "Olympia",
    "zip": 98516,
    "concatenated_address": "8700 Hanna Lane Ne, Olympia",
    "address": "8700 Hanna Lane N.E., Olympia"
  },
  {
    "id": 539,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Laurel Oaks MHP",
    "latitude": 47.029782,
    "longitude": -122.76787,
    "original_address": "8030 18th Ln Se",
    "building_number": 8030,
    "street": "18th Ln SE",
    "city": "Lacey",
    "zip": 98503,
    "concatenated_address": "8030 18th Ln SE, Lacey",
    "address": "8030 18th Lane S.E., Lacey"
  },
  {
    "id": 540,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Dakota Apartments",
    "latitude": 47.037052,
    "longitude": -122.79883,
    "original_address": "6205 Pacific Avenue Southeast",
    "building_number": 6205,
    "street": "Pacific Ave SE",
    "city": "Lacey",
    "zip": 98503,
    "concatenated_address": "6205 Pacific Ave SE, Lacey",
    "address": "6205 Pacific Ave. S.E., Lacey"
  },
  {
    "id": 541,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Forest Grove Apartments",
    "latitude": 47.020332,
    "longitude": -122.80871,
    "original_address": "5701 30th Avenue Southeast",
    "building_number": 5701,
    "street": "30th Ave SE",
    "city": "Lacey",
    "zip": 98503,
    "concatenated_address": "5701 30th Ave SE, Lacey",
    "address": "5701 30th Ave. S.E., Lacey"
  },
  {
    "id": 542,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "The Marq On Martin",
    "latitude": 47.055272,
    "longitude": -122.75831,
    "original_address": "8515 Litt Drive Southeast",
    "building_number": 8515,
    "street": "Litt Dr SE",
    "city": "Olympia",
    "zip": 98516,
    "concatenated_address": "8515 Litt Dr SE, Olympia",
    "address": "8515 Litt Dr S.E., Olympia"
  },
  {
    "id": 543,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Forest Grove Apartments",
    "latitude": 47.020332,
    "longitude": -122.80871,
    "original_address": "5701 30th Avenue Se",
    "building_number": 5701,
    "street": "30th Ave SE",
    "city": "Lacey",
    "zip": 98503,
    "concatenated_address": "5701 30th Ave SE, Lacey",
    "address": "5701 30th Ave. S.E., Lacey"
  },
  {
    "id": 544,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "College Park Apartments",
    "latitude": 47.016597,
    "longitude": -122.82548,
    "original_address": "3307 College Street Se",
    "building_number": 3307,
    "street": "College St SE",
    "city": "Lacey",
    "zip": 98503,
    "concatenated_address": "3307 College St SE, Lacey",
    "address": "3307 College St. S.E., Lacey"
  },
  {
    "id": 545,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Chambers Crest Apartments",
    "latitude": 47.017143,
    "longitude": -122.82659,
    "original_address": "3301 Se College St",
    "building_number": 3301,
    "street": "College St SE",
    "city": "Lacey",
    "zip": 98503,
    "concatenated_address": "3301 College St SE, Lacey",
    "address": "3301 College St. S.E., Lacey"
  },
  {
    "id": 546,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Carpenter Crest Apartments",
    "latitude": 47.04831,
    "longitude": -122.79763,
    "original_address": "201 Carpenter Road Se",
    "building_number": 201,
    "street": "Carpenter Rd SE",
    "city": "Lacey",
    "zip": 98503,
    "concatenated_address": "201 Carpenter Rd SE, Lacey",
    "address": "201 Carpenter Road S.E., Lacey"
  },
  {
    "id": 547,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "College Glen Apartments",
    "latitude": 46.999277,
    "longitude": -122.8216,
    "original_address": "4870 55th Lane Se",
    "building_number": 4870,
    "street": "55th Ln SE",
    "city": "Lacey",
    "zip": 98503,
    "concatenated_address": "4870 55th Ln SE, Lacey",
    "address": "4870 55th Lane S.E., Lacey"
  },
  {
    "id": 548,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Woodland By Bonaventure",
    "latitude": 46.997622,
    "longitude": -122.83109,
    "original_address": "4532 Intelco Loop Se",
    "building_number": 4532,
    "street": "Intelco Loop SE",
    "city": "Lacey",
    "zip": 98503,
    "concatenated_address": "4532 Intelco Loop SE, Lacey",
    "address": "4532 Intelco Loop S.E., Lacey"
  },
  {
    "id": 549,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Gateway Place Phase I",
    "latitude": 47.069336,
    "longitude": -122.78788,
    "original_address": "6955 Birdseye Ne",
    "building_number": 6955,
    "street": "Birdseye Ave NE",
    "city": "Olympia",
    "zip": 98516,
    "concatenated_address": "6955 Birdseye Ave NE, Olympia",
    "address": "6955 Birdseye Ave. N.E., Olympia"
  },
  {
    "id": 550,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Toscana Apartments Homes",
    "latitude": 47.112575,
    "longitude": -122.77942,
    "original_address": "6955 6961 6967 & 6973 Birdseye",
    "building_number": "",
    "street": "",
    "city": "Olympia",
    "zip": 98516,
    "concatenated_address": "6955 6961 6967 & 6973 Birdseye, Olympia",
    "address": "6955 6961 6967 & 6973 Birdseye, Olympia"
  },
  {
    "id": 551,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Sheridan Beach Terrace",
    "latitude": 47.739718,
    "longitude": -122.28935,
    "original_address": "15330 Bothell Way Northeast",
    "building_number": 15330,
    "street": "Bothell Way NE",
    "city": "Seattle",
    "zip": 98155,
    "concatenated_address": "15330 Bothell Way NE, Seattle",
    "address": "15330 Bothell Way N.E., Seattle"
  },
  {
    "id": 552,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Lake Villa Apartments",
    "latitude": 48.011717,
    "longitude": -122.06211,
    "original_address": "12506 16th Street Ne",
    "building_number": 12506,
    "street": "16th St NE",
    "city": "Lake Stevens",
    "zip": 98258,
    "concatenated_address": "12506 16th St NE, Lake Stevens",
    "address": "12506 16th St. N.E., Lake Stevens"
  },
  {
    "id": 553,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Westview Estates MHC",
    "latitude": 48.002498,
    "longitude": -122.11425,
    "original_address": "704 87th Avenue Ne",
    "building_number": 704,
    "street": "87th Ave NE",
    "city": "Lake Stevens",
    "zip": 98258,
    "concatenated_address": "704 87th Ave NE, Lake Stevens",
    "address": "704 87th Ave. N.E., Lake Stevens"
  },
  {
    "id": 554,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Village Green Community MHC",
    "latitude": 47.180547,
    "longitude": -122.47447,
    "original_address": "2902 S. 84th Street",
    "building_number": 2902,
    "street": "84th St S",
    "city": "Lakewood",
    "zip": 98499,
    "concatenated_address": "2902 84th St S, Lakewood",
    "address": "2902 84th St. S., Lakewood"
  },
  {
    "id": 555,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "7503 Lakewood Drive W Apartments",
    "latitude": 47.189081,
    "longitude": -122.50831,
    "original_address": "7503 Lakewood Drive West",
    "building_number": 7503,
    "street": "Lakewood Dr W",
    "city": "Lakewood",
    "zip": 98499,
    "concatenated_address": "7503 Lakewood Dr W, Lakewood",
    "address": "7503 Lakewood Dr W., Lakewood"
  },
  {
    "id": 556,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Stonegate Apartments",
    "latitude": 47.192853,
    "longitude": -122.52047,
    "original_address": "7119 62nd Avenue Court W.",
    "building_number": 7119,
    "street": "62nd Avenue Ct W",
    "city": "Lakewood",
    "zip": 98499,
    "concatenated_address": "7119 62nd Avenue Ct W, Lakewood",
    "address": "7119 62nd Avenue Ct W., Lakewood"
  },
  {
    "id": 557,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Lakewood Village Apartments",
    "latitude": 47.174611,
    "longitude": -122.50918,
    "original_address": "9100 Lakewood Drive Sw",
    "building_number": 9100,
    "street": "Lakewood Dr SW",
    "city": "Lakewood",
    "zip": 98499,
    "concatenated_address": "9100 Lakewood Dr SW, Lakewood",
    "address": "9100 Lakewood Dr S.W., Lakewood"
  },
  {
    "id": 558,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Citizen & Oake",
    "latitude": 47.18241,
    "longitude": -122.50914,
    "original_address": "5406 82nd Street Sw",
    "building_number": 5406,
    "street": "82nd St SW",
    "city": "Lakewood",
    "zip": 98499,
    "concatenated_address": "5406 82nd St SW, Lakewood",
    "address": "5406 82nd St. S.W., Lakewood"
  },
  {
    "id": 559,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Brighton Place Apartments",
    "latitude": 47.181535,
    "longitude": -122.55205,
    "original_address": "8615 83rd Street Court Southwest",
    "building_number": 8615,
    "street": "83rd St Ct SW",
    "city": "Lakewood",
    "zip": 98498,
    "concatenated_address": "8615 83rd St Ct SW, Lakewood",
    "address": "8615 83rd St. Ct S.W., Lakewood"
  },
  {
    "id": 560,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Village At Seeley Lake",
    "latitude": 47.170755,
    "longitude": -122.51496,
    "original_address": "9501 59th Avenue Sw",
    "building_number": 9501,
    "street": "59th Ave SW",
    "city": "Lakewood",
    "zip": 98499,
    "concatenated_address": "9501 59th Ave SW, Lakewood",
    "address": "9501 59th Ave. S.W., Lakewood"
  },
  {
    "id": 561,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Hidden Lake Apartments",
    "latitude": 47.158465,
    "longitude": -122.50945,
    "original_address": "5419 110th Street Sw",
    "building_number": 5419,
    "street": "110th St SW",
    "city": "Lakewood",
    "zip": 98499,
    "concatenated_address": "5419 110th St SW, Lakewood",
    "address": "5419 110th St. S.W., Lakewood"
  },
  {
    "id": 562,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "The Harrison Apartments",
    "latitude": 47.182033,
    "longitude": -122.54811,
    "original_address": "8311 83rd Street Sw",
    "building_number": 8311,
    "street": "83rd St SW",
    "city": "Lakewood",
    "zip": 98498,
    "concatenated_address": "8311 83rd St SW, Lakewood",
    "address": "8311 83rd St. S.W., Lakewood"
  },
  {
    "id": 563,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Lakeview MHP (formerly known as Rancho Village MHC)",
    "latitude": 47.163836,
    "longitude": -122.49734,
    "original_address": "10302 Lakeview Ave Sw",
    "building_number": 10302,
    "street": "Lakeview Ave SW",
    "city": "Lakewood",
    "zip": 98499,
    "concatenated_address": "10302 Lakeview Ave SW, Lakewood",
    "address": "10302 Lakeview Ave. S.W., Lakewood"
  },
  {
    "id": 564,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Pacific Walk Apartments",
    "latitude": 47.181319,
    "longitude": -122.47625,
    "original_address": "8331 32nd Avenue South",
    "building_number": 8331,
    "street": "32nd Ave S",
    "city": "Lakewood",
    "zip": 98499,
    "concatenated_address": "8331 32nd Ave S, Lakewood",
    "address": "8331 32nd Ave. S., Lakewood"
  },
  {
    "id": 565,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Arbor Pointe Apartments",
    "latitude": 47.15387,
    "longitude": -122.57677,
    "original_address": "11432 105th Ave Sw",
    "building_number": 11432,
    "street": "105th Ave SW",
    "city": "Lakewood",
    "zip": 98498,
    "concatenated_address": "11432 105th Ave SW, Lakewood",
    "address": "11432 105th Ave. S.W., Lakewood"
  },
  {
    "id": 566,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Bellamy Park Apartments",
    "latitude": 47.159367,
    "longitude": -122.58041,
    "original_address": "10819 108th Avenue Sw",
    "building_number": 10819,
    "street": "108th Ave SW",
    "city": "Lakewood",
    "zip": 98498,
    "concatenated_address": "10819 108th Ave SW, Lakewood",
    "address": "10819 108th Ave. S.W., Lakewood"
  },
  {
    "id": 567,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Southern Pines Apartments",
    "latitude": 47.182719,
    "longitude": -122.47456,
    "original_address": "8212 29th Ave Court South",
    "building_number": 8212,
    "street": "29th Ave Ct S",
    "city": "Lakewood",
    "zip": 98499,
    "concatenated_address": "8212 29th Ave Ct S, Lakewood",
    "address": "8212 29th Ave. Ct S., Lakewood"
  },
  {
    "id": 568,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Crown Pointe Apartments",
    "latitude": 47.180872,
    "longitude": -122.47205,
    "original_address": "2611 84th Street Court South",
    "building_number": 2611,
    "street": "84th St Ct S",
    "city": "Lakewood",
    "zip": 98499,
    "concatenated_address": "2611 84th St Ct S, Lakewood",
    "address": "2611 84th St. Ct S., Lakewood"
  },
  {
    "id": 569,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Merrill Creek Apartments",
    "latitude": 47.185322,
    "longitude": -122.51774,
    "original_address": "6022 78th St Ct W",
    "building_number": 6022,
    "street": "78th St Ct W",
    "city": "Lakewood",
    "zip": 98499,
    "concatenated_address": "6022 78th St Ct W, Lakewood",
    "address": "6022 78th St. Ct W., Lakewood"
  },
  {
    "id": 570,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Citizen And Oake",
    "latitude": 47.18241,
    "longitude": -122.50914,
    "original_address": "5406 82nd St Sw",
    "building_number": 5406,
    "street": "82nd St SW",
    "city": "Lakewood",
    "zip": 98499,
    "concatenated_address": "5406 82nd St SW, Lakewood",
    "address": "5406 82nd St. S.W., Lakewood"
  },
  {
    "id": 571,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Morningtree Park Apartments",
    "latitude": 47.183561,
    "longitude": -122.54634,
    "original_address": "8101 83rd Avenue Sw",
    "building_number": 8101,
    "street": "83rd Ave SW",
    "city": "Lakewood",
    "zip": 98498,
    "concatenated_address": "8101 83rd Ave SW, Lakewood",
    "address": "8101 83rd Ave. S.W., Lakewood"
  },
  {
    "id": 572,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Beaumont Grand Apartment Homes",
    "latitude": 47.182436,
    "longitude": -122.55062,
    "original_address": "8504 82nd Street Southwest",
    "building_number": 8504,
    "street": "82nd St SW",
    "city": "Lakewood",
    "zip": 98498,
    "concatenated_address": "8504 82nd St SW, Lakewood",
    "address": "8504 82nd St. S.W., Lakewood"
  },
  {
    "id": 573,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "The James",
    "latitude": 47.144742,
    "longitude": -122.50166,
    "original_address": "4828 123rd Street Southwest",
    "building_number": 4828,
    "street": "123rd St SW",
    "city": "Lakewood",
    "zip": 98499,
    "concatenated_address": "4828 123rd St SW, Lakewood",
    "address": "4828 123rd St. S.W., Lakewood"
  },
  {
    "id": 574,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "4711 and 4801 115th Street Court Southwest",
    "latitude": 47.16772,
    "longitude": -122.50236,
    "original_address": "4711 And 4801 115th Street Court Southwe",
    "building_number": "",
    "street": "",
    "city": "Lakewood",
    "zip": 98499,
    "concatenated_address": "4711 And 4801 115th Street Court Southwe, Lakewood",
    "address": "4711 And 4801 115th St. Court Southwe, Lakewood"
  },
  {
    "id": 575,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Beaumont Grand Apartment Homes",
    "latitude": 47.182436,
    "longitude": -122.55062,
    "original_address": "8504 82nd Street Sw",
    "building_number": 8504,
    "street": "82nd St SW",
    "city": "Lakewood",
    "zip": 98498,
    "concatenated_address": "8504 82nd St SW, Lakewood",
    "address": "8504 82nd St. S.W., Lakewood"
  },
  {
    "id": 576,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "The James Apartment Homes",
    "latitude": 47.144742,
    "longitude": -122.50166,
    "original_address": "4828 123rd Street Sw",
    "building_number": 4828,
    "street": "123rd St SW",
    "city": "Lakewood",
    "zip": 98499,
    "concatenated_address": "4828 123rd St SW, Lakewood",
    "address": "4828 123rd St. S.W., Lakewood"
  },
  {
    "id": 577,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Whispering Pines Apartments",
    "latitude": 47.187222,
    "longitude": -122.51207,
    "original_address": "7715 Douglas Street West",
    "building_number": 7715,
    "street": "Douglas St W",
    "city": "Lakewood",
    "zip": 98499,
    "concatenated_address": "7715 Douglas St W, Lakewood",
    "address": "7715 Douglas St. W., Lakewood"
  },
  {
    "id": 578,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Canterbrook Village Apartments",
    "latitude": 47.120787,
    "longitude": -122.53259,
    "original_address": "7212 150th Street Sw",
    "building_number": 7212,
    "street": "150th St SW",
    "city": "Lakewood",
    "zip": 98439,
    "concatenated_address": "7212 150th St SW, Lakewood",
    "address": "7212 150th St. S.W., Lakewood"
  },
  {
    "id": 579,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Garden Park Apartments",
    "latitude": 47.141863,
    "longitude": -122.51,
    "original_address": "12850 Lincoln Ave Sw",
    "building_number": 12850,
    "street": "Lincoln Ave SW",
    "city": "Lakewood",
    "zip": 98499,
    "concatenated_address": "12850 Lincoln Ave SW, Lakewood",
    "address": "12850 Lincoln Ave. S.W., Lakewood"
  },
  {
    "id": 580,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Evergreen Court",
    "latitude": 47.16772,
    "longitude": -122.50236,
    "original_address": "12805 And 12809 47th Ave Sw",
    "building_number": "",
    "street": "",
    "city": "Lakewood",
    "zip": 98499,
    "concatenated_address": "12805 And 12809 47th Ave Sw, Lakewood",
    "address": "12805 And 12809 47th Ave. S.W., Lakewood"
  },
  {
    "id": 581,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Ladobe Apartments",
    "latitude": 47.148446,
    "longitude": -122.501,
    "original_address": "4801 121st Street Sw",
    "building_number": 4801,
    "street": "121st St SW",
    "city": "Lakewood",
    "zip": 98499,
    "concatenated_address": "4801 121st St SW, Lakewood",
    "address": "4801 121st St. S.W., Lakewood"
  },
  {
    "id": 582,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Colonial Court",
    "latitude": 47.145613,
    "longitude": -122.55931,
    "original_address": "9120 Lawndale Ave Sw, 9119 Kenwood Ave S",
    "building_number": 9120,
    "street": "Lawndale Ave SW",
    "city": "Lakewood",
    "zip": 98498,
    "concatenated_address": "9120 Lawndale Ave SW, Lakewood",
    "address": "9120 Lawndale Ave. S.W., Lakewood"
  },
  {
    "id": 583,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Meadowbrook Apartments",
    "latitude": 47.128671,
    "longitude": -122.51032,
    "original_address": "7511 To 7523 146th St Sw",
    "building_number": "",
    "street": "",
    "city": "Lakewood",
    "zip": 98439,
    "concatenated_address": "7511 To 7523 146th St Sw, Lakewood",
    "address": "7511 To 7523 146th St. S.W., Lakewood"
  },
  {
    "id": 584,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Lakewood Plaza Apartments",
    "latitude": 47.176663,
    "longitude": -122.52032,
    "original_address": "6135 Steilacoom Boulevard",
    "building_number": 6135,
    "street": "Steilacoom Blvd SW",
    "city": "Lakewood",
    "zip": 98499,
    "concatenated_address": "6135 Steilacoom Blvd SW, Lakewood",
    "address": "6135 Steilacoom Blvd S.W., Lakewood"
  },
  {
    "id": 585,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "5501 Chicago Avenue Southwest",
    "latitude": 47.16772,
    "longitude": -122.50236,
    "original_address": "5501 And 5506-5510 Chicago Avenue Sw",
    "building_number": "",
    "street": "",
    "city": "Lakewood",
    "zip": 98499,
    "concatenated_address": "5501 And 5506-5510 Chicago Avenue Sw, Lakewood",
    "address": "5501 And 5506-5510 Chicago Avenue S.W., Lakewood"
  },
  {
    "id": 586,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Tower Court",
    "latitude": 47.12505,
    "longitude": -122.53004,
    "original_address": "14521 70th Avenue Court Sw",
    "building_number": 14521,
    "street": "70th Ave Ct SW",
    "city": "Lakewood",
    "zip": 98439,
    "concatenated_address": "14521 70th Ave Ct SW, Lakewood",
    "address": "14521 70th Ave. Ct S.W., Lakewood"
  },
  {
    "id": 587,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Springtree Apartments",
    "latitude": 47.141688,
    "longitude": -122.50139,
    "original_address": "4810 127th Street Court Sw",
    "building_number": 4810,
    "street": "127th St Ct SW",
    "city": "Lakewood",
    "zip": 98499,
    "concatenated_address": "4810 127th St Ct SW, Lakewood",
    "address": "4810 127th St. Ct S.W., Lakewood"
  },
  {
    "id": 588,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Southcrest Apartments",
    "latitude": 47.16772,
    "longitude": -122.50236,
    "original_address": "5410, 5416, 5420 And 5422 Boston Ave Sw",
    "building_number": "",
    "street": "",
    "city": "Lakewood",
    "zip": 98499,
    "concatenated_address": "5410, 5416, 5420 And 5422 Boston Ave Sw, Lakewood",
    "address": "5410, 5416, 5420 And 5422 Boston Ave. S.W., Lakewood"
  },
  {
    "id": 589,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Greenwood II Apartments",
    "latitude": 47.141376,
    "longitude": -122.51097,
    "original_address": "5529 Boston Avenue Sw",
    "building_number": 5529,
    "street": "Boston Ave SW",
    "city": "Lakewood",
    "zip": 98499,
    "concatenated_address": "5529 Boston Ave SW, Lakewood",
    "address": "5529 Boston Ave. S.W., Lakewood"
  },
  {
    "id": 590,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "L And S Sunrise Apartments",
    "latitude": 47.12431,
    "longitude": -122.54167,
    "original_address": "7902 146th Street Southwest",
    "building_number": 7902,
    "street": "146th St SW",
    "city": "Lakewood",
    "zip": 98439,
    "concatenated_address": "7902 146th St SW, Lakewood",
    "address": "7902 146th St. S.W., Lakewood"
  },
  {
    "id": 591,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Bridgewood Estates",
    "latitude": 47.158683,
    "longitude": -122.50332,
    "original_address": "4910-4918 108th Street Southwest",
    "building_number": 4918,
    "street": "108th St SW",
    "city": "Lakewood",
    "zip": 98499,
    "concatenated_address": "4918 108th St SW, Lakewood",
    "address": "4918 108th St. S.W., Lakewood"
  },
  {
    "id": 592,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Lexington Apartments",
    "latitude": 47.178177,
    "longitude": -122.51459,
    "original_address": "8720 58th Avenue Sw",
    "building_number": 8720,
    "street": "58th Ave SW",
    "city": "Lakewood",
    "zip": 98499,
    "concatenated_address": "8720 58th Ave SW, Lakewood",
    "address": "8720 58th Ave. S.W., Lakewood"
  },
  {
    "id": 593,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Morningtree Park Apartments",
    "latitude": 47.183561,
    "longitude": -122.54634,
    "original_address": "8101 83rd Avenue Southwest",
    "building_number": 8101,
    "street": "83rd Ave SW",
    "city": "Lakewood",
    "zip": 98498,
    "concatenated_address": "8101 83rd Ave SW, Lakewood",
    "address": "8101 83rd Ave. S.W., Lakewood"
  },
  {
    "id": 594,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Oak Terrace Apartments",
    "latitude": 47.181318,
    "longitude": -122.54423,
    "original_address": "42 Thunderbird Parkway Sw",
    "building_number": 42,
    "street": "Thunderbird Pkwy SW",
    "city": "Lakewood",
    "zip": 98498,
    "concatenated_address": "42 Thunderbird Pkwy SW, Lakewood",
    "address": "42 Thunderbird Pkwy S.W., Lakewood"
  },
  {
    "id": 595,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Springbrook Apts",
    "latitude": 47.143382,
    "longitude": -122.5043,
    "original_address": "12623 Bridgeport Way Sw",
    "building_number": 12623,
    "street": "Bridgeport Way SW",
    "city": "Lakewood",
    "zip": 98499,
    "concatenated_address": "12623 Bridgeport Way SW, Lakewood",
    "address": "12623 Bridgeport Way S.W., Lakewood"
  },
  {
    "id": 596,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Mountain Meadows Alf",
    "latitude": 47.594682,
    "longitude": -120.67592,
    "original_address": "320 Park Avenue",
    "building_number": 320,
    "street": "Park Ave",
    "city": "Leavenworth",
    "zip": 98826,
    "concatenated_address": "320 Park Ave, Leavenworth",
    "address": "320 Park Ave., Leavenworth"
  },
  {
    "id": 597,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Courtyards At River District",
    "latitude": 47.676564,
    "longitude": -117.11695,
    "original_address": "21450 East Indiana Ave",
    "building_number": 21450,
    "street": "E Indiana Ave",
    "city": "Liberty Lake",
    "zip": 99016,
    "concatenated_address": "21450 E Indiana Ave, Liberty Lake",
    "address": "21450 E. Indiana Ave., Liberty Lake"
  },
  {
    "id": 598,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Legacy Villas Phase 1",
    "latitude": 47.666264,
    "longitude": -117.11196,
    "original_address": "21900 East Country Vista Drive",
    "building_number": 21900,
    "street": "E Country Vista Dr",
    "city": "Liberty Lake",
    "zip": 99019,
    "concatenated_address": "21900 E Country Vista Dr, Liberty Lake",
    "address": "21900 E. Country Vista Drive, Liberty Lake"
  },
  {
    "id": 599,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Riverside At Trutina",
    "latitude": 47.683522,
    "longitude": -117.10326,
    "original_address": "22495 East Clairmont Lane",
    "building_number": 22495,
    "street": "E Clairmont Ln",
    "city": "Otis Orchards",
    "zip": 99019,
    "concatenated_address": "22495 E Clairmont Ln, Otis Orchards",
    "address": "22495 E. Clairmont Lane, Otis Orchards"
  },
  {
    "id": 600,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Legacy Villas Phase II",
    "latitude": 47.666264,
    "longitude": -117.11196,
    "original_address": "21900 East Country Vista Drive",
    "building_number": 21900,
    "street": "E Country Vista Dr",
    "city": "Liberty Lake",
    "zip": 99019,
    "concatenated_address": "21900 E Country Vista Dr, Liberty Lake",
    "address": "21900 E. Country Vista Drive, Liberty Lake"
  },
  {
    "id": 601,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Bitterroot Lodge Apartments",
    "latitude": 47.675428,
    "longitude": -117.11648,
    "original_address": "21580 East Bitterroot Lane",
    "building_number": 21580,
    "street": "E Bitterroot Ln",
    "city": "Liberty Lake",
    "zip": 99019,
    "concatenated_address": "21580 E Bitterroot Ln, Liberty Lake",
    "address": "21580 E. Bitterroot Lane, Liberty Lake"
  },
  {
    "id": 602,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Big Trout Lodge Apartments",
    "latitude": 47.669385,
    "longitude": -117.10074,
    "original_address": "22809 East Country Vista Drive",
    "building_number": 22809,
    "street": "E Country Vista Dr",
    "city": "Liberty Lake",
    "zip": 99019,
    "concatenated_address": "22809 E Country Vista Dr, Liberty Lake",
    "address": "22809 E. Country Vista Drive, Liberty Lake"
  },
  {
    "id": 603,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Canterbury Inn",
    "latitude": 46.135439,
    "longitude": -122.92169,
    "original_address": "1324 3rd Avenue",
    "building_number": 1324,
    "street": "3rd Ave",
    "city": "Longview",
    "zip": 98632,
    "concatenated_address": "1324 3rd Ave, Longview",
    "address": "1324 3rd Ave., Longview"
  },
  {
    "id": 604,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Delaware Plaza",
    "latitude": 46.129825,
    "longitude": -122.93249,
    "original_address": "926 Delaware Street",
    "building_number": 926,
    "street": "Delaware St",
    "city": "Longview",
    "zip": 98632,
    "concatenated_address": "926 Delaware St, Longview",
    "address": "926 Delaware St., Longview"
  },
  {
    "id": 605,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Canterbury Gardens",
    "latitude": 46.137447,
    "longitude": -122.92221,
    "original_address": "1457 3rd Avenue",
    "building_number": 1457,
    "street": "3rd Ave",
    "city": "Longview",
    "zip": 98632,
    "concatenated_address": "1457 3rd Ave, Longview",
    "address": "1457 3rd Ave., Longview"
  },
  {
    "id": 606,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Hemlock Court Apartments",
    "latitude": 46.136805,
    "longitude": -122.94055,
    "original_address": "1700 Hemlock Street",
    "building_number": 1700,
    "street": "Hemlock St",
    "city": "Longview",
    "zip": 98632,
    "concatenated_address": "1700 Hemlock St, Longview",
    "address": "1700 Hemlock St., Longview"
  },
  {
    "id": 607,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Fir At 17th Apartments",
    "latitude": 46.133169,
    "longitude": -122.94119,
    "original_address": "1000 17th Avenue",
    "building_number": 1000,
    "street": "17th Ave",
    "city": "Longview",
    "zip": 98632,
    "concatenated_address": "1000 17th Ave, Longview",
    "address": "1000 17th Ave., Longview"
  },
  {
    "id": 608,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Mint Place Apartments",
    "latitude": 46.160117,
    "longitude": -122.98275,
    "original_address": "3835 Mint Place",
    "building_number": 3835,
    "street": "Mint Pl",
    "city": "Longview",
    "zip": 98632,
    "concatenated_address": "3835 Mint Pl, Longview",
    "address": "3835 Mint Place, Longview"
  },
  {
    "id": 609,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Del Ray II MHP",
    "latitude": 46.166412,
    "longitude": -123.01773,
    "original_address": "5600 Mt. Solo Road",
    "building_number": 5600,
    "street": "Mt Solo Rd",
    "city": "Longview",
    "zip": 98632,
    "concatenated_address": "5600 Mt Solo Rd, Longview",
    "address": "5600 Mt Solo Road, Longview"
  },
  {
    "id": 610,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Washington Square Village",
    "latitude": 46.133946,
    "longitude": -122.96828,
    "original_address": "825 32nd Ave",
    "building_number": 825,
    "street": "32nd Ave",
    "city": "Longview",
    "zip": 98632,
    "concatenated_address": "825 32nd Ave, Longview",
    "address": "825 32nd Ave., Longview"
  },
  {
    "id": 611,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Fairway Apartments",
    "latitude": 46.166466,
    "longitude": -122.97788,
    "original_address": "3858 Pennsylvania Street",
    "building_number": 3858,
    "street": "Pennsylvania St",
    "city": "Longview",
    "zip": 98632,
    "concatenated_address": "3858 Pennsylvania St, Longview",
    "address": "3858 Pennsylvania St., Longview"
  },
  {
    "id": 612,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Fairways Apartments",
    "latitude": 46.166466,
    "longitude": -122.97788,
    "original_address": "3858 Pennsylvania St",
    "building_number": 3858,
    "street": "Pennsylvania St",
    "city": "Longview",
    "zip": 98632,
    "concatenated_address": "3858 Pennsylvania St, Longview",
    "address": "3858 Pennsylvania St., Longview"
  },
  {
    "id": 613,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Crescent Teraace Apartments",
    "latitude": 46.129414,
    "longitude": -122.93147,
    "original_address": "910 9th Avenue",
    "building_number": 910,
    "street": "9th Ave",
    "city": "Longview",
    "zip": 98632,
    "concatenated_address": "910 9th Ave, Longview",
    "address": "910 9th Ave., Longview"
  },
  {
    "id": 614,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Fremont Village Apartments",
    "latitude": 46.136194,
    "longitude": -122.9215,
    "original_address": "1416 3rd Avenue",
    "building_number": 1416,
    "street": "3rd Ave",
    "city": "Longview",
    "zip": 98632,
    "concatenated_address": "1416 3rd Ave, Longview",
    "address": "1416 3rd Ave., Longview"
  },
  {
    "id": 615,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Somerset Retirement Apartments",
    "latitude": 46.14637,
    "longitude": -122.96857,
    "original_address": "2025 Tibbetts Drive",
    "building_number": 2025,
    "street": "Tibbetts Dr",
    "city": "Longview",
    "zip": 98632,
    "concatenated_address": "2025 Tibbetts Dr, Longview",
    "address": "2025 Tibbetts Drive, Longview"
  },
  {
    "id": 616,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "La Villa Apartments",
    "latitude": 48.932328,
    "longitude": -122.43625,
    "original_address": "1412 La Villa Drive",
    "building_number": "",
    "street": "",
    "city": "Lynden",
    "zip": 98264,
    "concatenated_address": "1412 La Villa Drive, Lynden",
    "address": "1412 La Villa Drive, Lynden"
  },
  {
    "id": 617,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Lynden Manor",
    "latitude": 48.932328,
    "longitude": -122.43625,
    "original_address": "905 Anron Drive",
    "building_number": "",
    "street": "",
    "city": "Lynden",
    "zip": 98264,
    "concatenated_address": "905 Anron Drive, Lynden",
    "address": "905 Anron Drive, Lynden"
  },
  {
    "id": 618,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Bristol Square Apartments",
    "latitude": 47.856285,
    "longitude": -122.2943,
    "original_address": "15700 44th Avenue West",
    "building_number": 15700,
    "street": "44th Ave W",
    "city": "Lynnwood",
    "zip": 98087,
    "concatenated_address": "15700 44th Ave W, Lynnwood",
    "address": "15700 44th Ave. W., Lynnwood"
  },
  {
    "id": 619,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Tamaron Ranch",
    "latitude": 47.867545,
    "longitude": -122.2739,
    "original_address": "14500 Admiralty Way",
    "building_number": 14500,
    "street": "Admiralty Way",
    "city": "Lynnwood",
    "zip": 98087,
    "concatenated_address": "14500 Admiralty Way, Lynnwood",
    "address": "14500 Admiralty Way, Lynnwood"
  },
  {
    "id": 620,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Lynnwood Garden Village",
    "latitude": 47.839031,
    "longitude": -122.29764,
    "original_address": "4816 176th St Sw",
    "building_number": 4816,
    "street": "176th St SW",
    "city": "Lynnwood",
    "zip": 98037,
    "concatenated_address": "4816 176th St SW, Lynnwood",
    "address": "4816 176th St. S.W., Lynnwood"
  },
  {
    "id": 621,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Serra Vista",
    "latitude": 47.857776,
    "longitude": -122.28553,
    "original_address": "15517 40th Avenue West",
    "building_number": 15517,
    "street": "40th Ave W",
    "city": "Lynnwood",
    "zip": 98087,
    "concatenated_address": "15517 40th Ave W, Lynnwood",
    "address": "15517 40th Ave. W., Lynnwood"
  },
  {
    "id": 622,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Spencer Court Townhomes",
    "latitude": 47.839319,
    "longitude": -122.30076,
    "original_address": "5003-5023 176th Street Sw",
    "building_number": 5003,
    "street": "176th St SW",
    "city": "Lynnwood",
    "zip": 98037,
    "concatenated_address": "5003 176th St SW, Lynnwood",
    "address": "5003 176th St. S.W., Lynnwood"
  },
  {
    "id": 623,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Shadow Creek Townhomes",
    "latitude": 47.839227,
    "longitude": -122.28547,
    "original_address": "17425 17427 17429 17433 52nd Avenue West",
    "building_number": "",
    "street": "",
    "city": "Lynnwood",
    "zip": 98037,
    "concatenated_address": "17425 17427 17429 17433 52nd Avenue West, Lynnwood",
    "address": "17425 17427 17429 17433 52nd Avenue West, Lynnwood"
  },
  {
    "id": 624,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Whispering Cedars Apartment Homes",
    "latitude": 47.811343,
    "longitude": -122.32071,
    "original_address": "6501 208th Street Sw",
    "building_number": 6501,
    "street": "208th St SW",
    "city": "Lynnwood",
    "zip": 98036,
    "concatenated_address": "6501 208th St SW, Lynnwood",
    "address": "6501 208th St. S.W., Lynnwood"
  },
  {
    "id": 625,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Poplar Lane Apartments",
    "latitude": 47.813137,
    "longitude": -122.28064,
    "original_address": "3518 204th Street Sw",
    "building_number": 3518,
    "street": "204th St SW",
    "city": "Lynnwood",
    "zip": 98036,
    "concatenated_address": "3518 204th St SW, Lynnwood",
    "address": "3518 204th St. S.W., Lynnwood"
  },
  {
    "id": 626,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Orchard Ridge Apartments",
    "latitude": 47.850578,
    "longitude": -122.28541,
    "original_address": "3805 164th Street Southwest",
    "building_number": 3805,
    "street": "164th St",
    "city": "Lynnwood",
    "zip": 98087,
    "concatenated_address": "3805 164th St, Lynnwood",
    "address": "3805 164th St., Lynnwood"
  },
  {
    "id": 627,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Brittany Place Apartments",
    "latitude": 47.819193,
    "longitude": -122.29782,
    "original_address": "19723 48th Avenue West",
    "building_number": 19723,
    "street": "48th Ave W",
    "city": "Lynnwood",
    "zip": 98036,
    "concatenated_address": "19723 48th Ave W, Lynnwood",
    "address": "19723 48th Ave. W., Lynnwood"
  },
  {
    "id": 628,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Aegis Living Of Lynnwood",
    "latitude": 47.828772,
    "longitude": -122.29302,
    "original_address": "18700 44th Avenue West",
    "building_number": 18700,
    "street": "44th Ave W",
    "city": "Lynnwood",
    "zip": 98037,
    "concatenated_address": "18700 44th Ave W, Lynnwood",
    "address": "18700 44th Ave. W., Lynnwood"
  },
  {
    "id": 629,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Canyon Springs Apartments",
    "latitude": 47.854522,
    "longitude": -122.29414,
    "original_address": "15914 44th Avenue West",
    "building_number": 15914,
    "street": "44th Ave W",
    "city": "Lynnwood",
    "zip": 98087,
    "concatenated_address": "15914 44th Ave W, Lynnwood",
    "address": "15914 44th Ave. W., Lynnwood"
  },
  {
    "id": 630,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Newberry Square Apartments",
    "latitude": 47.853509,
    "longitude": -122.25996,
    "original_address": "16014 Ash Way",
    "building_number": 16014,
    "street": "Ash Way",
    "city": "Lynnwood",
    "zip": 98087,
    "concatenated_address": "16014 Ash Way, Lynnwood",
    "address": "16014 Ash Way, Lynnwood"
  },
  {
    "id": 631,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Bradford Park Apartment Homes",
    "latitude": 47.847977,
    "longitude": -122.29998,
    "original_address": "16604 48th Ave W",
    "building_number": 16604,
    "street": "48th Ave W",
    "city": "Lynnwood",
    "zip": 98037,
    "concatenated_address": "16604 48th Ave W, Lynnwood",
    "address": "16604 48th Ave. W., Lynnwood"
  },
  {
    "id": 632,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Woodcreek Apartments",
    "latitude": 47.865904,
    "longitude": -122.27217,
    "original_address": "14611 Admiralty Way",
    "building_number": 14611,
    "street": "Admiralty Way",
    "city": "Lynnwood",
    "zip": 98087,
    "concatenated_address": "14611 Admiralty Way, Lynnwood",
    "address": "14611 Admiralty Way, Lynnwood"
  },
  {
    "id": 633,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Madison At Alderwood Park",
    "latitude": 47.834128,
    "longitude": -122.27894,
    "original_address": "18031 36th Avenue West",
    "building_number": 18031,
    "street": "36th Ave W",
    "city": "Lynnwood",
    "zip": 98037,
    "concatenated_address": "18031 36th Ave W, Lynnwood",
    "address": "18031 36th Ave. W., Lynnwood"
  },
  {
    "id": 634,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Keeler's Corner Apartments",
    "latitude": 47.852766,
    "longitude": -122.29534,
    "original_address": "4525 164th Street Southwest",
    "building_number": 4525,
    "street": "164th St",
    "city": "Lynnwood",
    "zip": 98087,
    "concatenated_address": "4525 164th St, Lynnwood",
    "address": "4525 164th St., Lynnwood"
  },
  {
    "id": 635,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Nickel Creek",
    "latitude": 47.812601,
    "longitude": -122.28282,
    "original_address": "3702 204th Street Sw",
    "building_number": 3702,
    "street": "204th St SW",
    "city": "Lynnwood",
    "zip": 98036,
    "concatenated_address": "3702 204th St SW, Lynnwood",
    "address": "3702 204th St. S.W., Lynnwood"
  },
  {
    "id": 636,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Avana One Six Four",
    "latitude": 47.852457,
    "longitude": -122.28058,
    "original_address": "3333 164th Street Southwest",
    "building_number": 3333,
    "street": "164th St",
    "city": "Lynnwood",
    "zip": 98087,
    "concatenated_address": "3333 164th St, Lynnwood",
    "address": "3333 164th St., Lynnwood"
  },
  {
    "id": 637,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Alderwood Heights Apartments",
    "latitude": 47.83412,
    "longitude": -122.28194,
    "original_address": "18124 36th Avenue West",
    "building_number": 18124,
    "street": "36th Ave W",
    "city": "Lynnwood",
    "zip": 98037,
    "concatenated_address": "18124 36th Ave W, Lynnwood",
    "address": "18124 36th Ave. W., Lynnwood"
  },
  {
    "id": 638,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Nickel Creek",
    "latitude": 47.812601,
    "longitude": -122.28282,
    "original_address": "3702 204th Street Southwest",
    "building_number": 3702,
    "street": "204th St SW",
    "city": "Lynnwood",
    "zip": 98036,
    "concatenated_address": "3702 204th St SW, Lynnwood",
    "address": "3702 204th St. S.W., Lynnwood"
  },
  {
    "id": 639,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Alderbrooke Apartments",
    "latitude": 47.830748,
    "longitude": -122.28167,
    "original_address": "18505 36th Avenue West",
    "building_number": 18505,
    "street": "36th Ave W",
    "city": "Lynnwood",
    "zip": 98037,
    "concatenated_address": "18505 36th Ave W, Lynnwood",
    "address": "18505 36th Ave. W., Lynnwood"
  },
  {
    "id": 640,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Altia Townhomes And Apartments",
    "latitude": 47.848374,
    "longitude": -122.24794,
    "original_address": "16520 Larch Way",
    "building_number": 16520,
    "street": "Larch Way",
    "city": "Lynnwood",
    "zip": 98037,
    "concatenated_address": "16520 Larch Way, Lynnwood",
    "address": "16520 Larch Way, Lynnwood"
  },
  {
    "id": 641,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "19920 56th Avenue West",
    "latitude": 47.817992,
    "longitude": -122.30931,
    "original_address": "19920 56th Avenue West",
    "building_number": 19920,
    "street": "56th Ave W",
    "city": "Lynnwood",
    "zip": 98036,
    "concatenated_address": "19920 56th Ave W, Lynnwood",
    "address": "19920 56th Ave. W., Lynnwood"
  },
  {
    "id": 642,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Serene Terrace MHC",
    "latitude": 47.86999,
    "longitude": -122.27558,
    "original_address": "14322 Admiralty Way",
    "building_number": 14322,
    "street": "Admiralty Way",
    "city": "Lynnwood",
    "zip": 98087,
    "concatenated_address": "14322 Admiralty Way, Lynnwood",
    "address": "14322 Admiralty Way, Lynnwood"
  },
  {
    "id": 643,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Collins Junction",
    "latitude": 47.818038,
    "longitude": -122.29636,
    "original_address": "4727 200th Street Southwest",
    "building_number": 4727,
    "street": "200th St SW",
    "city": "Lynnwood",
    "zip": 98036,
    "concatenated_address": "4727 200th St SW, Lynnwood",
    "address": "4727 200th St. S.W., Lynnwood"
  },
  {
    "id": 644,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Quail Park Of Lynnwood",
    "latitude": 47.852593,
    "longitude": -122.28778,
    "original_address": "4015 164th Street Southwest",
    "building_number": 4015,
    "street": "164th St",
    "city": "Lynnwood",
    "zip": 98087,
    "concatenated_address": "4015 164th St, Lynnwood",
    "address": "4015 164th St., Lynnwood"
  },
  {
    "id": 645,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Shag Lynnwood City Center Senior Living",
    "latitude": 47.821945,
    "longitude": -122.28655,
    "original_address": "19501 40th Avenue West",
    "building_number": 19501,
    "street": "40th Ave W",
    "city": "Lynnwood",
    "zip": 98036,
    "concatenated_address": "19501 40th Ave W, Lynnwood",
    "address": "19501 40th Ave. W., Lynnwood"
  },
  {
    "id": 646,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Martha Lake Apartments",
    "latitude": 47.847296,
    "longitude": -122.24271,
    "original_address": "16626 6th Avenue West",
    "building_number": 16626,
    "street": "6th Ave W",
    "city": "Lynnwood",
    "zip": 98037,
    "concatenated_address": "16626 6th Ave W, Lynnwood",
    "address": "16626 6th Ave. W., Lynnwood"
  },
  {
    "id": 647,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Station Nine",
    "latitude": 47.846199,
    "longitude": -122.24269,
    "original_address": "16720 6th Avenue West",
    "building_number": 16720,
    "street": "6th Ave W",
    "city": "Lynnwood",
    "zip": 98037,
    "concatenated_address": "16720 6th Ave W, Lynnwood",
    "address": "16720 6th Ave. W., Lynnwood"
  },
  {
    "id": 648,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Bailey Court Townhomes",
    "latitude": 47.84058,
    "longitude": -122.3031,
    "original_address": "17403-17415 52nd Avenue West",
    "building_number": 17415,
    "street": "52nd Ave W",
    "city": "Lynnwood",
    "zip": 98037,
    "concatenated_address": "17415 52nd Ave W, Lynnwood",
    "address": "17415 52nd Ave. W., Lynnwood"
  },
  {
    "id": 649,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Lynnwood Townhouse Apartments",
    "latitude": 47.82182,
    "longitude": -122.32369,
    "original_address": "6707 196th Street Southwest",
    "building_number": 6707,
    "street": "196th St SW",
    "city": "Lynnwood",
    "zip": 98036,
    "concatenated_address": "6707 196th St SW, Lynnwood",
    "address": "6707 196th St. S.W., Lynnwood"
  },
  {
    "id": 650,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Citycenter Apartments",
    "latitude": 47.820782,
    "longitude": -122.28324,
    "original_address": "3720 196th St Sw",
    "building_number": 3720,
    "street": "196th St SW",
    "city": "Lynnwood",
    "zip": 98036,
    "concatenated_address": "3720 196th St SW, Lynnwood",
    "address": "3720 196th St. S.W., Lynnwood"
  },
  {
    "id": 651,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Lynn Woods Senior Apartments",
    "latitude": 47.823333,
    "longitude": -122.29676,
    "original_address": "4705 194th St Sw",
    "building_number": 4705,
    "street": "194th St SW",
    "city": "Lynnwood",
    "zip": 98036,
    "concatenated_address": "4705 194th St SW, Lynnwood",
    "address": "4705 194th St. S.W., Lynnwood"
  },
  {
    "id": 652,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Laurel Terrace Apartments",
    "latitude": 47.814401,
    "longitude": -122.31482,
    "original_address": "6001 204th Street Sw",
    "building_number": 6001,
    "street": "204th St SW",
    "city": "Lynnwood",
    "zip": 98036,
    "concatenated_address": "6001 204th St SW, Lynnwood",
    "address": "6001 204th St. S.W., Lynnwood"
  },
  {
    "id": 653,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Plaza 44 Apartments",
    "latitude": 47.82329,
    "longitude": -122.29408,
    "original_address": "4509 194th Street Sw",
    "building_number": 4509,
    "street": "194th St SW",
    "city": "Lynnwood",
    "zip": 98036,
    "concatenated_address": "4509 194th St SW, Lynnwood",
    "address": "4509 194th St. S.W., Lynnwood"
  },
  {
    "id": 654,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Chateau Pacific Senior Living",
    "latitude": 47.865183,
    "longitude": -122.27959,
    "original_address": "3333 148th Street Sw",
    "building_number": 3333,
    "street": "148th St SW",
    "city": "Lynnwood",
    "zip": 98087,
    "concatenated_address": "3333 148th St SW, Lynnwood",
    "address": "3333 148th St. S.W., Lynnwood"
  },
  {
    "id": 655,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Maple Crossing Apartments",
    "latitude": 47.409304,
    "longitude": -121.96945,
    "original_address": "21800 & 21900 Se Wax Rd",
    "building_number": "",
    "street": "",
    "city": "Maple Valley",
    "zip": 98038,
    "concatenated_address": "21800 & 21900 Se Wax Rd, Maple Valley",
    "address": "21800 & 21900 S.E.Wax Road, Maple Valley"
  },
  {
    "id": 656,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Brandon Place",
    "latitude": 47.38329,
    "longitude": -122.03746,
    "original_address": "24331 228th Avenue Se",
    "building_number": 24331,
    "street": "228th Ave SE",
    "city": "Maple Valley",
    "zip": 98038,
    "concatenated_address": "24331 228th Ave SE, Maple Valley",
    "address": "24331 228th Ave. S.E., Maple Valley"
  },
  {
    "id": 657,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Wilderness Village Apartments",
    "latitude": 47.385803,
    "longitude": -122.03982,
    "original_address": "22435 Southeast 240th Street",
    "building_number": 22435,
    "street": "SE 240th St",
    "city": "Maple Valley",
    "zip": 98038,
    "concatenated_address": "22435 SE 240th St, Maple Valley",
    "address": "22435 S.E. 240th St., Maple Valley"
  },
  {
    "id": 658,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Fountain Court Assisted Living",
    "latitude": 47.385446,
    "longitude": -122.04194,
    "original_address": "24200 224th Avenue Se",
    "building_number": 24200,
    "street": "224th Ave SE",
    "city": "Maple Valley",
    "zip": 98038,
    "concatenated_address": "24200 224th Ave SE, Maple Valley",
    "address": "24200 224th Ave. S.E., Maple Valley"
  },
  {
    "id": 659,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "1724 Grove Street Apartments",
    "latitude": 48.060048,
    "longitude": -122.17079,
    "original_address": "1724 Grove Street",
    "building_number": 1724,
    "street": "Grove St",
    "city": "Marysville",
    "zip": 98270,
    "concatenated_address": "1724 Grove St, Marysville",
    "address": "1724 Grove St., Marysville"
  },
  {
    "id": 660,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Villa Mar Apartments",
    "latitude": 48.059766,
    "longitude": -122.16689,
    "original_address": "7015 47th Avenue Ne",
    "building_number": 7015,
    "street": "NE 47th Ave",
    "city": "Marysville",
    "zip": 98270,
    "concatenated_address": "7015 NE 47th Ave, Marysville",
    "address": "7015 N.E. 47th Ave., Marysville"
  },
  {
    "id": 661,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "The Lodge Apartments",
    "latitude": 48.154489,
    "longitude": -122.19658,
    "original_address": "17500 25th Avenue Ne",
    "building_number": 17500,
    "street": "25th Ave NE",
    "city": "Marysville",
    "zip": 98271,
    "concatenated_address": "17500 25th Ave NE, Marysville",
    "address": "17500 25th Ave. N.E., Marysville"
  },
  {
    "id": 662,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Carrolls Creek Landing Apartments",
    "latitude": 48.161317,
    "longitude": -122.1924,
    "original_address": "18111 25th Avenue Ne",
    "building_number": 18111,
    "street": "25th Ave NE",
    "city": "Marysville",
    "zip": 98271,
    "concatenated_address": "18111 25th Ave NE, Marysville",
    "address": "18111 25th Ave. N.E., Marysville"
  },
  {
    "id": 663,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Oxford Place Apartments",
    "latitude": 48.064409,
    "longitude": -122.18152,
    "original_address": "1288 Beach Avenue",
    "building_number": 1288,
    "street": "Beach Ave",
    "city": "Marysville",
    "zip": 98270,
    "concatenated_address": "1288 Beach Ave, Marysville",
    "address": "1288 Beach Ave., Marysville"
  },
  {
    "id": 664,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Cascadia At The Lodge",
    "latitude": 48.154376,
    "longitude": -122.19673,
    "original_address": "17503 25th Avenue Ne",
    "building_number": 17503,
    "street": "25th Ave NE",
    "city": "Marysville",
    "zip": 98271,
    "concatenated_address": "17503 25th Ave NE, Marysville",
    "address": "17503 25th Ave. N.E., Marysville"
  },
  {
    "id": 665,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Liberty Gardens Apartments",
    "latitude": 48.065961,
    "longitude": -122.1668,
    "original_address": "7629 47th Avenue Ne",
    "building_number": 7629,
    "street": "47th Ave NE",
    "city": "Marysville",
    "zip": 98270,
    "concatenated_address": "7629 47th Ave NE, Marysville",
    "address": "7629 47th Ave. N.E., Marysville"
  },
  {
    "id": 666,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Trailside At The Lodge",
    "latitude": 48.154489,
    "longitude": -122.19658,
    "original_address": "17500 25th Avenue Ne",
    "building_number": 17500,
    "street": "25th Ave NE",
    "city": "Marysville",
    "zip": 98271,
    "concatenated_address": "17500 25th Ave NE, Marysville",
    "address": "17500 25th Ave. N.E., Marysville"
  },
  {
    "id": 667,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Quilceda Gardens Apartments",
    "latitude": 48.049576,
    "longitude": -122.16195,
    "original_address": "1234 And 1248 Cedar Avenue",
    "building_number": "",
    "street": "",
    "city": "Marysville",
    "zip": 98270,
    "concatenated_address": "1234 And 1248 Cedar Avenue, Marysville",
    "address": "1234 And 1248 Cedar Avenue, Marysville"
  },
  {
    "id": 668,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Casita Villa Apartments",
    "latitude": 48.058961,
    "longitude": -122.16694,
    "original_address": "6925 47th Avenue Northeast",
    "building_number": 6925,
    "street": "47th Ave NE",
    "city": "Marysville",
    "zip": 98270,
    "concatenated_address": "6925 47th Ave NE, Marysville",
    "address": "6925 47th Ave. N.E., Marysville"
  },
  {
    "id": 669,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Quilceda Gardens Apartments",
    "latitude": 48.049576,
    "longitude": -122.16195,
    "original_address": "1234 & 1248 Cedar Avenue",
    "building_number": "",
    "street": "",
    "city": "Marysville",
    "zip": 98270,
    "concatenated_address": "1234 & 1248 Cedar Avenue, Marysville",
    "address": "1234 & 1248 Cedar Avenue, Marysville"
  },
  {
    "id": 670,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Life Care Center of Marysville",
    "latitude": 48.061734,
    "longitude": -122.16991,
    "original_address": "1821 Groove St.",
    "building_number": 1821,
    "street": "Grove St",
    "city": "Marysville",
    "zip": 98270,
    "concatenated_address": "1821 Grove St, Marysville",
    "address": "1821 Grove St., Marysville"
  },
  {
    "id": 671,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Shenandoah Forest Park MHP",
    "latitude": 47.793549,
    "longitude": -117.36135,
    "original_address": "3400 East Lane Park Road",
    "building_number": 3400,
    "street": "E Lane Park Rd",
    "city": "Mead",
    "zip": 99021,
    "concatenated_address": "3400 E Lane Park Rd, Mead",
    "address": "3400 E. Lane Park Road, Mead"
  },
  {
    "id": 672,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "77 Central",
    "latitude": 47.587107,
    "longitude": -122.23473,
    "original_address": "2630 77th Avenue Southeast",
    "building_number": 2630,
    "street": "77th Ave SE",
    "city": "Mercer Island",
    "zip": 98040,
    "concatenated_address": "2630 77th Ave SE, Mercer Island",
    "address": "2630 77th Ave. S.E., Mercer Island"
  },
  {
    "id": 673,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Shorewood Heights Apartments",
    "latitude": 47.580572,
    "longitude": -122.2196,
    "original_address": "3209 Shorewood Drive",
    "building_number": 3209,
    "street": "Shorewood Dr",
    "city": "Mercer Island",
    "zip": 98040,
    "concatenated_address": "3209 Shorewood Dr, Mercer Island",
    "address": "3209 Shorewood Drive, Mercer Island"
  },
  {
    "id": 674,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Station At Mill Creek",
    "latitude": 47.856342,
    "longitude": -122.2157,
    "original_address": "1300 156th Street Se",
    "building_number": 1300,
    "street": "156th St SE",
    "city": "Bothell",
    "zip": 98012,
    "concatenated_address": "1300 156th St SE, Bothell",
    "address": "1300 156th St. S.E., Bothell"
  },
  {
    "id": 675,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Monterra In Mill Creek",
    "latitude": 47.877062,
    "longitude": -122.21805,
    "original_address": "13401 Dumas Road",
    "building_number": 13401,
    "street": "Dumas Rd",
    "city": "Bothell",
    "zip": 98012,
    "concatenated_address": "13401 Dumas Rd, Bothell",
    "address": "13401 Dumas Road, Bothell"
  },
  {
    "id": 676,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Station At Mill Creek",
    "latitude": 47.856342,
    "longitude": -122.2157,
    "original_address": "1300 156th Street Southeast",
    "building_number": 1300,
    "street": "156th St SE",
    "city": "Bothell",
    "zip": 98012,
    "concatenated_address": "1300 156th St SE, Bothell",
    "address": "1300 156th St. S.E., Bothell"
  },
  {
    "id": 677,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Heatherwood Apartments",
    "latitude": 47.876256,
    "longitude": -122.22027,
    "original_address": "13510 North Creek Drive",
    "building_number": 13510,
    "street": "N Creek Dr",
    "city": "Bothell",
    "zip": 98012,
    "concatenated_address": "13510 N Creek Dr, Bothell",
    "address": "13510 N. Creek Drive, Bothell"
  },
  {
    "id": 678,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Autumn Village",
    "latitude": 47.24092,
    "longitude": -122.32865,
    "original_address": "2211 6th Avenue",
    "building_number": 2211,
    "street": "6th Ave",
    "city": "Milton",
    "zip": 98354,
    "concatenated_address": "2211 6th Ave, Milton",
    "address": "2211 6th Ave., Milton"
  },
  {
    "id": 679,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Village Concepts Of Milton - Mill Ridge Village",
    "latitude": 47.252199,
    "longitude": -122.29732,
    "original_address": "607 28th Avenue",
    "building_number": 607,
    "street": "28th Ave",
    "city": "Milton",
    "zip": 98354,
    "concatenated_address": "607 28th Ave, Milton",
    "address": "607 28th Ave., Milton"
  },
  {
    "id": 680,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Sundance Apartments",
    "latitude": 47.257009,
    "longitude": -122.29779,
    "original_address": "210 27th Avenue",
    "building_number": 210,
    "street": "27th Ave",
    "city": "Milton",
    "zip": 98354,
    "concatenated_address": "210 27th Ave, Milton",
    "address": "210 27th Ave., Milton"
  },
  {
    "id": 681,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Alder Ridge",
    "latitude": 47.258761,
    "longitude": -122.29786,
    "original_address": "38338 28th Avenue South",
    "building_number": 38338,
    "street": "28th Ave S",
    "city": "Milton",
    "zip": 98354,
    "concatenated_address": "38338 28th Ave S, Milton",
    "address": "38338 28th Ave. S., Milton"
  },
  {
    "id": 682,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Morning Run Apartment Homes",
    "latitude": 47.859467,
    "longitude": -121.98411,
    "original_address": "18463 Blueberry Lane",
    "building_number": 18463,
    "street": "Blueberry Ln",
    "city": "Monroe",
    "zip": 98272,
    "concatenated_address": "18463 Blueberry Ln, Monroe",
    "address": "18463 Blueberry Lane, Monroe"
  },
  {
    "id": 683,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Brookdale Monroe",
    "latitude": 47.856846,
    "longitude": -121.98921,
    "original_address": "15465 179th Avenue Southeast",
    "building_number": 15465,
    "street": "179th Ave SE",
    "city": "Monroe",
    "zip": 98272,
    "concatenated_address": "15465 179th Ave SE, Monroe",
    "address": "15465 179th Ave. S.E., Monroe"
  },
  {
    "id": 684,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Regency At Monroe",
    "latitude": 47.85181,
    "longitude": -121.98867,
    "original_address": "1355 West Main Street",
    "building_number": 1355,
    "street": "W Main St",
    "city": "Monroe",
    "zip": 98272,
    "concatenated_address": "1355 W Main St, Monroe",
    "address": "1355 W. Main St., Monroe"
  },
  {
    "id": 685,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Revera - Montesano Health & Rehabilitation Center",
    "latitude": 46.987908,
    "longitude": -123.5859,
    "original_address": "800 North Medcalf",
    "building_number": 800,
    "street": "Medcalf St",
    "city": "Montesano",
    "zip": 98563,
    "concatenated_address": "800 Medcalf St, Montesano",
    "address": "800 Medcalf St., Montesano"
  },
  {
    "id": 686,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Weston Square Apartments",
    "latitude": 47.139391,
    "longitude": -119.29335,
    "original_address": "901 Nw Sunburst Court",
    "building_number": 901,
    "street": "NW Sunburst Ct",
    "city": "Moses Lake",
    "zip": 98837,
    "concatenated_address": "901 NW Sunburst Ct, Moses Lake",
    "address": "901 N.W. Sunburst Ct, Moses Lake"
  },
  {
    "id": 687,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "The Vintage Apartments",
    "latitude": 47.142474,
    "longitude": -119.29336,
    "original_address": "1001 North Grape Drive",
    "building_number": 1001,
    "street": "N Grape Dr",
    "city": "Moses Lake",
    "zip": 98837,
    "concatenated_address": "1001 N Grape Dr, Moses Lake",
    "address": "1001 N. Grape Drive, Moses Lake"
  },
  {
    "id": 688,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Pioneer Village",
    "latitude": 47.113229,
    "longitude": -119.26415,
    "original_address": "816 East Sharon Avenue",
    "building_number": 816,
    "street": "E Sharon Ave",
    "city": "Moses Lake",
    "zip": 98837,
    "concatenated_address": "816 E Sharon Ave, Moses Lake",
    "address": "816 E. Sharon Ave., Moses Lake"
  },
  {
    "id": 689,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Village Park MHC",
    "latitude": 47.142254,
    "longitude": -119.29565,
    "original_address": "900 North Grape Drive",
    "building_number": 900,
    "street": "N Grape Dr",
    "city": "Moses Lake",
    "zip": 98837,
    "concatenated_address": "900 N Grape Dr, Moses Lake",
    "address": "900 N. Grape Drive, Moses Lake"
  },
  {
    "id": 690,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Harvest Manor Estates",
    "latitude": 47.158214,
    "longitude": -119.32026,
    "original_address": "4815 Airway Drive Ne",
    "building_number": 4815,
    "street": "Airway Dr NE",
    "city": "Moses Lake",
    "zip": 98837,
    "concatenated_address": "4815 Airway Dr NE, Moses Lake",
    "address": "4815 Airway Dr N.E., Moses Lake"
  },
  {
    "id": 691,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "The Lakes Apartments",
    "latitude": 47.119574,
    "longitude": -119.27492,
    "original_address": "1050-S South Division Street",
    "building_number": 1050,
    "street": "S Division St",
    "city": "Moses Lake",
    "zip": 98837,
    "concatenated_address": "1050 S Division St, Moses Lake",
    "address": "1050 S. Division St., Moses Lake"
  },
  {
    "id": 692,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Pioneer Meadows Apartments",
    "latitude": 47.180684,
    "longitude": -119.29898,
    "original_address": "300 East 9th Avenue",
    "building_number": "",
    "street": "",
    "city": "Moses Lake",
    "zip": 98837,
    "concatenated_address": "300 East 9th Avenue, Moses Lake",
    "address": "300 East 9th Avenue, Moses Lake"
  },
  {
    "id": 693,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Summer Wood Alzheimer's Special Care Center",
    "latitude": 47.141063,
    "longitude": -119.29178,
    "original_address": "830 Northwest Sunburst Court",
    "building_number": 830,
    "street": "NW Sunburst Ct",
    "city": "Moses Lake",
    "zip": 98837,
    "concatenated_address": "830 NW Sunburst Ct, Moses Lake",
    "address": "830 N.W. Sunburst Ct, Moses Lake"
  },
  {
    "id": 694,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Brookdale Hearthstone Moses Lake",
    "latitude": 47.12495,
    "longitude": -119.26773,
    "original_address": "905 South Pioneer Way",
    "building_number": 905,
    "street": "S Pioneer Way",
    "city": "Moses Lake",
    "zip": 98837,
    "concatenated_address": "905 S Pioneer Way, Moses Lake",
    "address": "905 S. Pioneer Way, Moses Lake"
  },
  {
    "id": 695,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Ashley Gardens Of Mount Vernon",
    "latitude": 48.436555,
    "longitude": -122.29144,
    "original_address": "3807 East College Way",
    "building_number": 3807,
    "street": "E College Way",
    "city": "Mount Vernon",
    "zip": 98273,
    "concatenated_address": "3807 E College Way, Mount Vernon",
    "address": "3807 E. College Way, Mount Vernon"
  },
  {
    "id": 696,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "210-222 North 15th Street",
    "latitude": 48.42265,
    "longitude": -122.32201,
    "original_address": "210-222 North 15th Street",
    "building_number": 222,
    "street": "N 15th St",
    "city": "Mount Vernon",
    "zip": 98273,
    "concatenated_address": "222 N 15th St, Mount Vernon",
    "address": "222 N. 15th St., Mount Vernon"
  },
  {
    "id": 697,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Mountain Glen",
    "latitude": 48.420264,
    "longitude": -122.31751,
    "original_address": "1810 East Division Street",
    "building_number": 1810,
    "street": "E Division St",
    "city": "Mount Vernon",
    "zip": 98274,
    "concatenated_address": "1810 E Division St, Mount Vernon",
    "address": "1810 E. Division St., Mount Vernon"
  },
  {
    "id": 698,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Summerglen",
    "latitude": 48.432789,
    "longitude": -122.30784,
    "original_address": "1630 North 26th Street",
    "building_number": 1630,
    "street": "N 26th St",
    "city": "Mount Vernon",
    "zip": 98273,
    "concatenated_address": "1630 N 26th St, Mount Vernon",
    "address": "1630 N. 26th St., Mount Vernon"
  },
  {
    "id": 699,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Arbor Park Apartments",
    "latitude": 48.419152,
    "longitude": -122.31308,
    "original_address": "200 South Laventure Road",
    "building_number": 200,
    "street": "S Laventure Rd",
    "city": "Mount Vernon",
    "zip": 98274,
    "concatenated_address": "200 S Laventure Rd, Mount Vernon",
    "address": "200 S. Laventure Road, Mount Vernon"
  },
  {
    "id": 700,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Colonial Mobile Home Park",
    "latitude": 48.419948,
    "longitude": -122.30767,
    "original_address": "2600 East Division Street",
    "building_number": 2600,
    "street": "E Division St",
    "city": "Mount Vernon",
    "zip": 98274,
    "concatenated_address": "2600 E Division St, Mount Vernon",
    "address": "2600 E. Division St., Mount Vernon"
  },
  {
    "id": 701,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Ashley Gardens Of Mount Vernon",
    "latitude": 48.436555,
    "longitude": -122.29144,
    "original_address": "3807 East College Way",
    "building_number": 3807,
    "street": "E College Way",
    "city": "Mount Vernon",
    "zip": 98273,
    "concatenated_address": "3807 E College Way, Mount Vernon",
    "address": "3807 E. College Way, Mount Vernon"
  },
  {
    "id": 702,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Somerset Apartments",
    "latitude": 48.435243,
    "longitude": -122.31689,
    "original_address": "1516 N 19th St",
    "building_number": 1516,
    "street": "N 19th St",
    "city": "Mount Vernon",
    "zip": 98273,
    "concatenated_address": "1516 N 19th St, Mount Vernon",
    "address": "1516 N. 19th St., Mount Vernon"
  },
  {
    "id": 703,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Lcc & Bridge At Mount Vernon",
    "latitude": 48.420287,
    "longitude": -122.314,
    "original_address": "2120East Division Street",
    "building_number": 2120,
    "street": "E Division St",
    "city": "Mount Vernon",
    "zip": 98274,
    "concatenated_address": "2120 E Division St, Mount Vernon",
    "address": "2120 E. Division St., Mount Vernon"
  },
  {
    "id": 704,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Lakeside Apartments",
    "latitude": 47.802026,
    "longitude": -122.31696,
    "original_address": "6102 Saint Albion Way",
    "building_number": 6102,
    "street": "St Albion Way",
    "city": "Mountlake Terrace",
    "zip": 98043,
    "concatenated_address": "6102 St Albion Way, Mountlake Terrace",
    "address": "6102 St. Albion Way, Mountlake Terrace"
  },
  {
    "id": 705,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Arbor Village",
    "latitude": 47.784445,
    "longitude": -122.30773,
    "original_address": "23601 56th Avenue West",
    "building_number": 23601,
    "street": "56th Ave W",
    "city": "Mountlake Terrace",
    "zip": 98043,
    "concatenated_address": "23601 56th Ave W, Mountlake Terrace",
    "address": "23601 56th Ave. W., Mountlake Terrace"
  },
  {
    "id": 706,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Maple Court Apartments",
    "latitude": 47.783874,
    "longitude": -122.30795,
    "original_address": "23609 56th Avenue W",
    "building_number": 23609,
    "street": "56th Ave W",
    "city": "Mountlake Terrace",
    "zip": 98043,
    "concatenated_address": "23609 56th Ave W, Mountlake Terrace",
    "address": "23609 56th Ave. W., Mountlake Terrace"
  },
  {
    "id": 707,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Maple Glen Apartments",
    "latitude": 47.805385,
    "longitude": -122.30567,
    "original_address": "5402 212th Street Sw",
    "building_number": 5402,
    "street": "212th St SW",
    "city": "Mountlake Terrace",
    "zip": 98043,
    "concatenated_address": "5402 212th St SW, Mountlake Terrace",
    "address": "5402 212th St. S.W., Mountlake Terrace"
  },
  {
    "id": 708,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Terrace Heights Apartments",
    "latitude": 47.803039,
    "longitude": -122.29695,
    "original_address": "4713 216th Street Sw",
    "building_number": 4713,
    "street": "216th St SW",
    "city": "Mountlake Terrace",
    "zip": 98043,
    "concatenated_address": "4713 216th St SW, Mountlake Terrace",
    "address": "4713 216th St. S.W., Mountlake Terrace"
  },
  {
    "id": 709,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Vineyard Park At Mountlake Terrace",
    "latitude": 47.789826,
    "longitude": -122.30886,
    "original_address": "23008 56th Avenue W",
    "building_number": 23008,
    "street": "56th Ave W",
    "city": "Mountlake Terrace",
    "zip": 98043,
    "concatenated_address": "23008 56th Ave W, Mountlake Terrace",
    "address": "23008 56th Ave. W., Mountlake Terrace"
  },
  {
    "id": 710,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Quartz Creek Apartments",
    "latitude": 47.805976,
    "longitude": -122.29635,
    "original_address": "4710 212th Street Sw",
    "building_number": 4710,
    "street": "212th St SW",
    "city": "Mountlake Terrace",
    "zip": 98043,
    "concatenated_address": "4710 212th St SW, Mountlake Terrace",
    "address": "4710 212th St. S.W., Mountlake Terrace"
  },
  {
    "id": 711,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Arbor Village",
    "latitude": 47.784445,
    "longitude": -122.30773,
    "original_address": "23601 56th Avenue West",
    "building_number": 23601,
    "street": "56th Ave W",
    "city": "Mountlake Terrace",
    "zip": 98043,
    "concatenated_address": "23601 56th Ave W, Mountlake Terrace",
    "address": "23601 56th Ave. W., Mountlake Terrace"
  },
  {
    "id": 712,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Little Mountain Estates",
    "latitude": 48.413447,
    "longitude": -122.30622,
    "original_address": "2610 East Section Street",
    "building_number": 2610,
    "street": "E Section St",
    "city": "Mount Vernon",
    "zip": 98274,
    "concatenated_address": "2610 E Section St, Mount Vernon",
    "address": "2610 E. Section St., Mount Vernon"
  },
  {
    "id": 713,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Bella Terra Apartments",
    "latitude": 47.887659,
    "longitude": -122.29771,
    "original_address": "12101 Greenhaven",
    "building_number": 12101,
    "street": "Greenhaven",
    "city": "Mukilteo",
    "zip": 98275,
    "concatenated_address": "12101 Greenhaven, Mukilteo",
    "address": "12101 Greenhaven, Mukilteo"
  },
  {
    "id": 714,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Courtyard Apartments",
    "latitude": 47.921443,
    "longitude": -122.302,
    "original_address": "5010 84th Street Sw",
    "building_number": 5010,
    "street": "84th St SW",
    "city": "Mukilteo",
    "zip": 98275,
    "concatenated_address": "5010 84th St SW, Mukilteo",
    "address": "5010 84th St. S.W., Mukilteo"
  },
  {
    "id": 715,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "On The Green At Harbour Pointe",
    "latitude": 47.886978,
    "longitude": -122.30589,
    "original_address": "12303 Harbour Pointe Boulevard",
    "building_number": 12303,
    "street": "Harbour Point Blvd",
    "city": "Mukilteo",
    "zip": 98275,
    "concatenated_address": "12303 Harbour Point Blvd, Mukilteo",
    "address": "12303 Harbour Point Blvd., Mukilteo"
  },
  {
    "id": 716,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Old Town Mukilteo",
    "latitude": 47.946812,
    "longitude": -122.30247,
    "original_address": "716 3rd Street",
    "building_number": 716,
    "street": "3rd St",
    "city": "Mukilteo",
    "zip": 98275,
    "concatenated_address": "716 3rd St, Mukilteo",
    "address": "716 3rd St., Mukilteo"
  },
  {
    "id": 717,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Regency Newcastle",
    "latitude": 47.534824,
    "longitude": -122.16269,
    "original_address": "7454 Newcastle Golf Club Road",
    "building_number": 7454,
    "street": "Newcastle Golf Club Rd",
    "city": "Renton",
    "zip": 98059,
    "concatenated_address": "7454 Newcastle Golf Club Rd, Renton",
    "address": "7454 Newcastle Golf Club Road, Renton"
  },
  {
    "id": 718,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Newport Crossing Apartments",
    "latitude": 47.536996,
    "longitude": -122.16581,
    "original_address": "7311 Coal Creek Parkway Se",
    "building_number": 7311,
    "street": "Coal Creek Pkwy SE",
    "city": "Renton",
    "zip": 98059,
    "concatenated_address": "7311 Coal Creek Pkwy SE, Renton",
    "address": "7311 Coal Creek Pkwy S.E., Renton"
  },
  {
    "id": 719,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Karbon Apartments",
    "latitude": 47.538594,
    "longitude": -122.16619,
    "original_address": "6800 Coal Creek Parkway Se",
    "building_number": 6800,
    "street": "Coal Creek Pkwy SE",
    "city": "Renton",
    "zip": 98059,
    "concatenated_address": "6800 Coal Creek Pkwy SE, Renton",
    "address": "6800 Coal Creek Pkwy S.E., Renton"
  },
  {
    "id": 720,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Royal Arms Villa",
    "latitude": 47.440379,
    "longitude": -122.33706,
    "original_address": "133 Sw Normandy Road",
    "building_number": 133,
    "street": "SW Normandy Rd",
    "city": "Seattle",
    "zip": 98166,
    "concatenated_address": "133 SW Normandy Rd, Seattle",
    "address": "133 S.W. Normandy Road, Seattle"
  },
  {
    "id": 721,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Solstice Senior Living At Normandy Park",
    "latitude": 47.444725,
    "longitude": -122.33517,
    "original_address": "17623 1st Avenue South",
    "building_number": 17623,
    "street": "1st Ave S",
    "city": "Seattle",
    "zip": 98148,
    "concatenated_address": "17623 1st Ave S, Seattle",
    "address": "17623 1st Ave. S., Seattle"
  },
  {
    "id": 722,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Normandy Duke",
    "latitude": 47.4414,
    "longitude": -122.33671,
    "original_address": "160 Sw Normandy Road",
    "building_number": 160,
    "street": "SW Normandy Rd",
    "city": "Seattle",
    "zip": 98166,
    "concatenated_address": "160 SW Normandy Rd, Seattle",
    "address": "160 S.W. Normandy Road, Seattle"
  },
  {
    "id": 723,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Normandy Park Assisted Living",
    "latitude": 47.452974,
    "longitude": -122.33583,
    "original_address": "16625 1st Avenue South",
    "building_number": 16625,
    "street": "1st Ave S",
    "city": "Seattle",
    "zip": 98148,
    "concatenated_address": "16625 1st Ave S, Seattle",
    "address": "16625 1st Ave. S., Seattle"
  },
  {
    "id": 724,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Arrive North Bend",
    "latitude": 47.487871,
    "longitude": -121.80078,
    "original_address": "1525 Rock Creek Ridge Boulevard Southwest",
    "building_number": 1525,
    "street": "Rock Creek Ridge Blvd SW",
    "city": "North Bend",
    "zip": 98045,
    "concatenated_address": "1525 Rock Creek Ridge Blvd SW, North Bend",
    "address": "1525 Rock Creek Ridge Blvd S.W., North Bend"
  },
  {
    "id": 725,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Sno Ridge Apartments",
    "latitude": 47.491696,
    "longitude": -121.78661,
    "original_address": "401 Stow Avenue South",
    "building_number": 401,
    "street": "Stow Ave S",
    "city": "North Bend",
    "zip": 98045,
    "concatenated_address": "401 Stow Ave S, North Bend",
    "address": "401 Stow Ave. S., North Bend"
  },
  {
    "id": 726,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Summer Hill Assisted Living",
    "latitude": 48.292086,
    "longitude": -122.65993,
    "original_address": "165 Sw 6th Avenue",
    "building_number": 165,
    "street": "SW 6th Ave",
    "city": "Oak Harbor",
    "zip": 98277,
    "concatenated_address": "165 SW 6th Ave, Oak Harbor",
    "address": "165 S.W. 6th Ave., Oak Harbor"
  },
  {
    "id": 727,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Cove Apartments",
    "latitude": 48.301338,
    "longitude": -122.65775,
    "original_address": "460 N Oak Harbor Street",
    "building_number": 460,
    "street": "N Oak Harbor St",
    "city": "Oak Harbor",
    "zip": 98277,
    "concatenated_address": "460 N Oak Harbor St, Oak Harbor",
    "address": "460 N. Oak Harbor St., Oak Harbor"
  },
  {
    "id": 728,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Seabreeze Apartments",
    "latitude": 48.323451,
    "longitude": -122.65573,
    "original_address": "3125 North Oak Harbor Road",
    "building_number": 3125,
    "street": "N Oak Harbor Rd",
    "city": "Oak Harbor",
    "zip": 98277,
    "concatenated_address": "3125 N Oak Harbor Rd, Oak Harbor",
    "address": "3125 N. Oak Harbor Road, Oak Harbor"
  },
  {
    "id": 729,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Regency At Whidbey",
    "latitude": 48.284991,
    "longitude": -122.66909,
    "original_address": "1040 Southwest Kimball Drive",
    "building_number": 1040,
    "street": "SW Kimball Dr",
    "city": "Oak Harbor",
    "zip": 98277,
    "concatenated_address": "1040 SW Kimball Dr, Oak Harbor",
    "address": "1040 S.W. Kimball Drive, Oak Harbor"
  },
  {
    "id": 730,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Parkwood Manor MHP",
    "latitude": 48.309527,
    "longitude": -122.6675,
    "original_address": "700 Northwest Crosby Avenue",
    "building_number": 700,
    "street": "NW Crosby Ave",
    "city": "Oak Harbor",
    "zip": 98277,
    "concatenated_address": "700 NW Crosby Ave, Oak Harbor",
    "address": "700 N.W. Crosby Ave., Oak Harbor"
  },
  {
    "id": 731,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Regency Golden Sands",
    "latitude": 46.495565,
    "longitude": -124.04039,
    "original_address": "21608 O Lane",
    "building_number": "",
    "street": "",
    "city": "Ocean Park",
    "zip": 98640,
    "concatenated_address": "21608 O Lane, Ocean Park",
    "address": "21608 O Lane, Ocean Park"
  },
  {
    "id": 732,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Walnut Estates",
    "latitude": 47.058416,
    "longitude": -122.94042,
    "original_address": "3102-3120 14th Avenue Nw",
    "building_number": 3102,
    "street": "14th Ave NW",
    "city": "Olympia",
    "zip": 98502,
    "concatenated_address": "3102 14th Ave NW, Olympia",
    "address": "3102 14th Ave. N.W., Olympia"
  },
  {
    "id": 733,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Concordia West Apartments",
    "latitude": 47.04836,
    "longitude": -122.8427,
    "original_address": "122 Lilly Road Ne",
    "building_number": 122,
    "street": "Lilly Rd NE",
    "city": "Olympia",
    "zip": 98506,
    "concatenated_address": "122 Lilly Rd NE, Olympia",
    "address": "122 Lilly Road N.E., Olympia"
  },
  {
    "id": 734,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Talisman Apartments",
    "latitude": 47.051362,
    "longitude": -122.84108,
    "original_address": "3724 Ensign Road Ne",
    "building_number": 3724,
    "street": "Ensign Rd NE",
    "city": "Olympia",
    "zip": 98506,
    "concatenated_address": "3724 Ensign Rd NE, Olympia",
    "address": "3724 Ensign Road N.E., Olympia"
  },
  {
    "id": 735,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Olympia Village Apartments",
    "latitude": 47.041771,
    "longitude": -122.87499,
    "original_address": "900 Fairview Street Se",
    "building_number": 900,
    "street": "Fairview St SE",
    "city": "Olympia",
    "zip": 98501,
    "concatenated_address": "900 Fairview St SE, Olympia",
    "address": "900 Fairview St. S.E., Olympia"
  },
  {
    "id": 736,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Summers Manor",
    "latitude": 46.997232,
    "longitude": -122.83394,
    "original_address": "4001-4047 56th Trail Se4000-4046 57th Trail Se",
    "building_number": 4047,
    "street": "56th Trl SE",
    "city": "Olympia",
    "zip": 98501,
    "concatenated_address": "4047 56th Trl SE, Olympia",
    "address": "4047 56th Trl S.E., Olympia"
  },
  {
    "id": 737,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Sherwood Glen Apartments",
    "latitude": 47.029985,
    "longitude": -122.91876,
    "original_address": "1221 Evergreen Park Drive Sw",
    "building_number": 1221,
    "street": "Evergreen Park Dr SW",
    "city": "Olympia",
    "zip": 98502,
    "concatenated_address": "1221 Evergreen Park Dr SW, Olympia",
    "address": "1221 Evergreen Park Dr S.W., Olympia"
  },
  {
    "id": 738,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Capital Park Apartments",
    "latitude": 47.048272,
    "longitude": -122.93662,
    "original_address": "2900 Limited Lane Nw",
    "building_number": 2900,
    "street": "Limited Ln NW",
    "city": "Olympia",
    "zip": 98502,
    "concatenated_address": "2900 Limited Ln NW, Olympia",
    "address": "2900 Limited Lane N.W., Olympia"
  },
  {
    "id": 739,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Cooper Point Village Apartments",
    "latitude": 47.040869,
    "longitude": -122.95389,
    "original_address": "4125 Capital Mall Drive Sw",
    "building_number": 4125,
    "street": "Capital Mall Dr SW",
    "city": "Olympia",
    "zip": 98502,
    "concatenated_address": "4125 Capital Mall Dr SW, Olympia",
    "address": "4125 Capital Mall Dr S.W., Olympia"
  },
  {
    "id": 740,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Ensign II Apartments",
    "latitude": 47.104227,
    "longitude": -122.87004,
    "original_address": "424 And 425 Ensign Road Ne",
    "building_number": "",
    "street": "",
    "city": "Olympia",
    "zip": 98506,
    "concatenated_address": "424 And 425 Ensign Road Ne, Olympia",
    "address": "424 And 425 Ensign Road Ne, Olympia"
  },
  {
    "id": 741,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Yauger Park Villas",
    "latitude": 47.104269,
    "longitude": -123.05515,
    "original_address": "322 Lachman Lane Sw",
    "building_number": "",
    "street": "",
    "city": "Olympia",
    "zip": 98502,
    "concatenated_address": "322 Lachman Lane Sw, Olympia",
    "address": "322 Lachman Lane S.W., Olympia"
  },
  {
    "id": 742,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Westlakes Apartments",
    "latitude": 47.02948,
    "longitude": -122.91698,
    "original_address": "1919 Evergreen Park Dr. Sw",
    "building_number": 1919,
    "street": "Evergreen Park Dr SW",
    "city": "Olympia",
    "zip": 98502,
    "concatenated_address": "1919 Evergreen Park Dr SW, Olympia",
    "address": "1919 Evergreen Park Dr S.W., Olympia"
  },
  {
    "id": 743,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Country Club Villas",
    "latitude": 46.997571,
    "longitude": -122.84374,
    "original_address": "3625 Yelm Hwy Se",
    "building_number": 3625,
    "street": "Yelm Hwy SE",
    "city": "Olympia",
    "zip": 98501,
    "concatenated_address": "3625 Yelm Hwy SE, Olympia",
    "address": "3625 Yelm Highway S.E., Olympia"
  },
  {
    "id": 744,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "8 Hundred West Apartments",
    "latitude": 47.040499,
    "longitude": -122.94343,
    "original_address": "800 Alta Street Sw",
    "building_number": 800,
    "street": "Alta St SW",
    "city": "Olympia",
    "zip": 98502,
    "concatenated_address": "800 Alta St SW, Olympia",
    "address": "800 Alta St. S.W., Olympia"
  },
  {
    "id": 745,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Little Tuscany Apartments",
    "latitude": 47.038561,
    "longitude": -122.92707,
    "original_address": "1000 Fern Street Sw",
    "building_number": 1000,
    "street": "Fern St SW",
    "city": "Olympia",
    "zip": 98502,
    "concatenated_address": "1000 Fern St SW, Olympia",
    "address": "1000 Fern St. S.W., Olympia"
  },
  {
    "id": 746,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Courtside Apartments",
    "latitude": 47.041508,
    "longitude": -122.94742,
    "original_address": "515 Courtside Street Sw",
    "building_number": 515,
    "street": "Courtside St SW",
    "city": "Olympia",
    "zip": 98502,
    "concatenated_address": "515 Courtside St SW, Olympia",
    "address": "515 Courtside St. S.W., Olympia"
  },
  {
    "id": 747,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Heritage Park Apartments",
    "latitude": 47.031342,
    "longitude": -122.91559,
    "original_address": "1818 Evergreen Park Drive Sw",
    "building_number": 1818,
    "street": "Evergreen Park Dr SW",
    "city": "Olympia",
    "zip": 98502,
    "concatenated_address": "1818 Evergreen Park Dr SW, Olympia",
    "address": "1818 Evergreen Park Dr S.W., Olympia"
  },
  {
    "id": 748,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Polo Club Apartment Homes",
    "latitude": 47.000269,
    "longitude": -122.84739,
    "original_address": "3512 Landview Drive Se",
    "building_number": 3512,
    "street": "Landview Dr SE",
    "city": "Olympia",
    "zip": 98501,
    "concatenated_address": "3512 Landview Dr SE, Olympia",
    "address": "3512 Landview Dr S.E., Olympia"
  },
  {
    "id": 749,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Garden Courte Memory Care",
    "latitude": 47.055249,
    "longitude": -122.84357,
    "original_address": "626 Lilly Rd Ne",
    "building_number": 626,
    "street": "Lilly Rd NE",
    "city": "Olympia",
    "zip": 98506,
    "concatenated_address": "626 Lilly Rd NE, Olympia",
    "address": "626 Lilly Road N.E., Olympia"
  },
  {
    "id": 750,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Campus Lofts",
    "latitude": 46.984767,
    "longitude": -122.86908,
    "original_address": "510 And 512 12th Avenue Se",
    "building_number": "",
    "street": "",
    "city": "Olympia",
    "zip": 98501,
    "concatenated_address": "510 And 512 12th Avenue Se, Olympia",
    "address": "510 And 512 12th Avenue S.E., Olympia"
  },
  {
    "id": 751,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Black Lake Apartments",
    "latitude": 47.030625,
    "longitude": -122.94254,
    "original_address": "1900 Black Lake Boulevard Sw",
    "building_number": 1900,
    "street": "Black Lake Blvd SW",
    "city": "Olympia",
    "zip": 98512,
    "concatenated_address": "1900 Black Lake Blvd SW, Olympia",
    "address": "1900 Black Lake Blvd S.W., Olympia"
  },
  {
    "id": 752,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "123 Fourth Avenue Apartments",
    "latitude": 47.044722,
    "longitude": -122.90184,
    "original_address": "123 4th Avenue West",
    "building_number": 123,
    "street": "4th Ave W",
    "city": "Olympia",
    "zip": 98501,
    "concatenated_address": "123 4th Ave W, Olympia",
    "address": "123 4th Ave. W., Olympia"
  },
  {
    "id": 753,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Ultris Abbey Rowe",
    "latitude": 47.062224,
    "longitude": -122.74294,
    "original_address": "9320 Windsor Lane Northeast",
    "building_number": "",
    "street": "Windsor Ln NE",
    "city": "Olympia",
    "zip": 98516,
    "concatenated_address": "9320 Windsor Lane Northeast, Olympia",
    "address": "9320 Windsor Lane Northeast, Olympia"
  },
  {
    "id": 754,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Bellwether Apartments",
    "latitude": 47.036505,
    "longitude": -122.84695,
    "original_address": "1400 Fones Road Southeast",
    "building_number": 1400,
    "street": "Fones Rd SE",
    "city": "Olympia",
    "zip": 98501,
    "concatenated_address": "1400 Fones Rd SE, Olympia",
    "address": "1400 Fones Road S.E., Olympia"
  },
  {
    "id": 755,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Arbor Square",
    "latitude": 47.055299,
    "longitude": -122.84054,
    "original_address": "606 Lilly Road Northeast",
    "building_number": 606,
    "street": "Lilly Rd NE",
    "city": "Olympia",
    "zip": 98506,
    "concatenated_address": "606 Lilly Rd NE, Olympia",
    "address": "606 Lilly Road N.E., Olympia"
  },
  {
    "id": 756,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Fern Ridge",
    "latitude": 47.035513,
    "longitude": -122.93125,
    "original_address": "1309 Fern Street Sw",
    "building_number": 1309,
    "street": "Fern St SW",
    "city": "Olympia",
    "zip": 98502,
    "concatenated_address": "1309 Fern St SW, Olympia",
    "address": "1309 Fern St. S.W., Olympia"
  },
  {
    "id": 757,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "The Firs",
    "latitude": 47.052577,
    "longitude": -122.84099,
    "original_address": "426 Lilly Road Ne",
    "building_number": 426,
    "street": "Lilly Rd NE",
    "city": "Olympia",
    "zip": 98501,
    "concatenated_address": "426 Lilly Rd NE, Olympia",
    "address": "426 Lilly Road N.E., Olympia"
  },
  {
    "id": 758,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Apple Park Apartments",
    "latitude": 47.041189,
    "longitude": -122.94225,
    "original_address": "3200 Capital Mall Drive Southwest",
    "building_number": 3200,
    "street": "Capital Mall Dr SW",
    "city": "Olympia",
    "zip": 98502,
    "concatenated_address": "3200 Capital Mall Dr SW, Olympia",
    "address": "3200 Capital Mall Dr S.W., Olympia"
  },
  {
    "id": 759,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Affinity At Olympia",
    "latitude": 47.05427,
    "longitude": -122.82086,
    "original_address": "4701 7th Avenue Southwest",
    "building_number": 4701,
    "street": "NE 7th Ave",
    "city": "Olympia",
    "zip": 98502,
    "concatenated_address": "4701 NE 7th Ave, Olympia",
    "address": "4701 N.E. 7th Ave., Olympia"
  },
  {
    "id": 760,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Stuart Place",
    "latitude": 47.043504,
    "longitude": -122.901,
    "original_address": "110 Legion Way Southeast",
    "building_number": 110,
    "street": "Legion Way SE",
    "city": "Olympia",
    "zip": 98501,
    "concatenated_address": "110 Legion Way SE, Olympia",
    "address": "110 Legion Way S.E., Olympia"
  },
  {
    "id": 761,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Brookdale Olympia East",
    "latitude": 47.055374,
    "longitude": -122.84251,
    "original_address": "616 Lilly Road Northeast",
    "building_number": 616,
    "street": "Lilly Rd NE",
    "city": "Olympia",
    "zip": 98506,
    "concatenated_address": "616 Lilly Rd NE, Olympia",
    "address": "616 Lilly Road N.E., Olympia"
  },
  {
    "id": 762,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "The Park At Cooper Point Apartments",
    "latitude": 47.041189,
    "longitude": -122.94225,
    "original_address": "3200 Capital Mall Drive Sw",
    "building_number": 3200,
    "street": "Capital Mall Dr SW",
    "city": "Olympia",
    "zip": 98502,
    "concatenated_address": "3200 Capital Mall Dr SW, Olympia",
    "address": "3200 Capital Mall Dr S.W., Olympia"
  },
  {
    "id": 763,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Arbor Square Apartments",
    "latitude": 47.055299,
    "longitude": -122.84054,
    "original_address": "606 Lilly Road Northeast",
    "building_number": 606,
    "street": "Lilly Rd NE",
    "city": "Olympia",
    "zip": 98506,
    "concatenated_address": "606 Lilly Rd NE, Olympia",
    "address": "606 Lilly Road N.E., Olympia"
  },
  {
    "id": 764,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Ultris The Madison",
    "latitude": 46.993897,
    "longitude": -122.74302,
    "original_address": "105 Newberry Lane Southeast",
    "building_number": "",
    "street": "",
    "city": "Olympia",
    "zip": 98513,
    "concatenated_address": "105 Newberry Lane Southeast, Olympia",
    "address": "105 Newberry Lane Southeast, Olympia"
  },
  {
    "id": 765,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Brookdale Olympia West",
    "latitude": 47.04538,
    "longitude": -122.94855,
    "original_address": "420 Yauger Way Southwest",
    "building_number": 420,
    "street": "Yauger Way SW",
    "city": "Olympia",
    "zip": 98502,
    "concatenated_address": "420 Yauger Way SW, Olympia",
    "address": "420 Yauger Way S.W., Olympia"
  },
  {
    "id": 766,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "The Lilly Apartments (formerly known as Lilly Road 510)",
    "latitude": 47.046365,
    "longitude": -122.84273,
    "original_address": "510 Lilly Road Se",
    "building_number": 510,
    "street": "Lilly Rd SE",
    "city": "Olympia",
    "zip": 98501,
    "concatenated_address": "510 Lilly Rd SE, Olympia",
    "address": "510 Lilly Road S.E., Olympia"
  },
  {
    "id": 767,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Capitol House Apartments",
    "latitude": 47.043808,
    "longitude": -122.91411,
    "original_address": "420 Sherman Street Sw",
    "building_number": 420,
    "street": "Sherman St SW",
    "city": "Olympia",
    "zip": 98502,
    "concatenated_address": "420 Sherman St SW, Olympia",
    "address": "420 Sherman St. S.W., Olympia"
  },
  {
    "id": 768,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Evergreen Nursing",
    "latitude": 47.053143,
    "longitude": -122.84176,
    "original_address": "430 Lilly Road Ne",
    "building_number": 430,
    "street": "Lilly Rd NE",
    "city": "Olympia",
    "zip": 98506,
    "concatenated_address": "430 Lilly Rd NE, Olympia",
    "address": "430 Lilly Road N.E., Olympia"
  },
  {
    "id": 769,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Puget Sound Healthcare",
    "latitude": 47.041048,
    "longitude": -122.95231,
    "original_address": "4001 Capital Mall Drive Sw",
    "building_number": 4001,
    "street": "Capital Mall Dr SW",
    "city": "Olympia",
    "zip": 98502,
    "concatenated_address": "4001 Capital Mall Dr SW, Olympia",
    "address": "4001 Capital Mall Dr S.W., Olympia"
  },
  {
    "id": 770,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Ashwood Downs Apartments",
    "latitude": 47.031342,
    "longitude": -122.84882,
    "original_address": "1900 Ashwood Downs Lane",
    "building_number": 1900,
    "street": "Ashwood Downs Ln SE",
    "city": "Olympia",
    "zip": 98502,
    "concatenated_address": "1900 Ashwood Downs Ln SE, Olympia",
    "address": "1900 Ashwood Downs Lane S.E., Olympia"
  },
  {
    "id": 771,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Parkview Apts At Briggs Village",
    "latitude": 47.005517,
    "longitude": -122.88394,
    "original_address": "4523 Briggs Drive Se",
    "building_number": 4513,
    "street": "Briggs Dr SE",
    "city": "Olympia",
    "zip": 98501,
    "concatenated_address": "4513 Briggs Dr SE, Olympia",
    "address": "4513 Briggs Dr S.E., Olympia"
  },
  {
    "id": 772,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Apple Springs Retirement & Assisted Living",
    "latitude": 48.423349,
    "longitude": -119.5058,
    "original_address": "1001 Senna Street",
    "building_number": 1001,
    "street": "Senna St",
    "city": "Omak",
    "zip": 98841,
    "concatenated_address": "1001 Senna St, Omak",
    "address": "1001 Senna St., Omak"
  },
  {
    "id": 773,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Mountain View Estates MHC",
    "latitude": 47.089825,
    "longitude": -122.19717,
    "original_address": "836 Harman Way South",
    "building_number": 836,
    "street": "Harman Way S",
    "city": "Orting",
    "zip": 98360,
    "concatenated_address": "836 Harman Way S, Orting",
    "address": "836 Harman Way S., Orting"
  },
  {
    "id": 774,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Timberline MHC",
    "latitude": 47.700641,
    "longitude": -117.14025,
    "original_address": "19625 East Wellesley Avenue",
    "building_number": 19625,
    "street": "E Wellesley Ave",
    "city": "Otis Orchards",
    "zip": 99027,
    "concatenated_address": "19625 E Wellesley Ave, Otis Orchards",
    "address": "19625 E. Wellesley Ave., Otis Orchards"
  },
  {
    "id": 775,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Pleasant View Mobile Home Court",
    "latitude": 47.700592,
    "longitude": -117.1082,
    "original_address": "22105 East Wellesley Ave.",
    "building_number": 22105,
    "street": "E Wellesley Ave",
    "city": "Otis Orchards",
    "zip": 99027,
    "concatenated_address": "22105 E Wellesley Ave, Otis Orchards",
    "address": "22105 E. Wellesley Ave., Otis Orchards"
  },
  {
    "id": 776,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Bona Vista MHC",
    "latitude": 47.701769,
    "longitude": -117.11298,
    "original_address": "21725 East Wellesley Avenue",
    "building_number": 21725,
    "street": "E Wellesley Ave",
    "city": "Otis Orchards",
    "zip": 99027,
    "concatenated_address": "21725 E Wellesley Ave, Otis Orchards",
    "address": "21725 E. Wellesley Ave., Otis Orchards"
  },
  {
    "id": 777,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Cobble Court Apartments",
    "latitude": 47.27154,
    "longitude": -122.23916,
    "original_address": "345 Pacific Avenue North",
    "building_number": 345,
    "street": "Pacific Ave N",
    "city": "Pacific",
    "zip": 98047,
    "concatenated_address": "345 Pacific Ave N, Pacific",
    "address": "345 Pacific Ave. N., Pacific"
  },
  {
    "id": 778,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Rainier Vista Apartments",
    "latitude": 47.263452,
    "longitude": -122.24756,
    "original_address": "134 3rd Avenue Se",
    "building_number": 134,
    "street": "3rd Ave SE",
    "city": "Pacific",
    "zip": 98047,
    "concatenated_address": "134 3rd Ave SE, Pacific",
    "address": "134 3rd Ave. S.E., Pacific"
  },
  {
    "id": 779,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Navigator Villas",
    "latitude": 46.284246,
    "longitude": -119.18944,
    "original_address": "6212 Road 68",
    "building_number": 6212,
    "street": "Road 68",
    "city": "Pasco",
    "zip": 99301,
    "concatenated_address": "6212 Road 68, Pasco",
    "address": "6212 Road 68, Pasco"
  },
  {
    "id": 780,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Carriage Square Apartments",
    "latitude": 46.240175,
    "longitude": -119.12172,
    "original_address": "1327 N 24th Avenue",
    "building_number": 1327,
    "street": "N 24th Ave",
    "city": "Pasco",
    "zip": 99301,
    "concatenated_address": "1327 N 24th Ave, Pasco",
    "address": "1327 N. 24th Ave., Pasco"
  },
  {
    "id": 781,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "The Crossings At Chapel Hill",
    "latitude": 46.260386,
    "longitude": -119.17752,
    "original_address": "6626 Chapel Hill Boulevard",
    "building_number": 6626,
    "street": "Chapel Hill Blvd",
    "city": "Pasco",
    "zip": 99301,
    "concatenated_address": "6626 Chapel Hill Blvd, Pasco",
    "address": "6626 Chapel Hill Blvd., Pasco"
  },
  {
    "id": 782,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Avalon Health Rehabilitaion Center",
    "latitude": 46.247101,
    "longitude": -119.12043,
    "original_address": "2004 N 22nd Avenue",
    "building_number": 2004,
    "street": "N 22nd Ave",
    "city": "Pasco",
    "zip": 99301,
    "concatenated_address": "2004 N 22nd Ave, Pasco",
    "address": "2004 N. 22nd Ave., Pasco"
  },
  {
    "id": 783,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Broadmoor Apartments",
    "latitude": 46.272198,
    "longitude": -119.226,
    "original_address": "10305 Chapel Hill",
    "building_number": 10305,
    "street": "Chapel Hill Blvd",
    "city": "Pasco",
    "zip": 99301,
    "concatenated_address": "10305 Chapel Hill Blvd, Pasco",
    "address": "10305 Chapel Hill Blvd., Pasco"
  },
  {
    "id": 784,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Highland Commons I And II",
    "latitude": 48.099315,
    "longitude": -123.40627,
    "original_address": "1702 Melody Circle",
    "building_number": 1702,
    "street": "Melody Cir",
    "city": "Port Angeles",
    "zip": 98362,
    "concatenated_address": "1702 Melody Cir, Port Angeles",
    "address": "1702 Melody Cir, Port Angeles"
  },
  {
    "id": 785,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Olympic Peninsula Apartments",
    "latitude": 48.125282,
    "longitude": -123.49314,
    "original_address": "2202 West 16th Street",
    "building_number": 2202,
    "street": "W 16th St",
    "city": "Port Angeles",
    "zip": 98363,
    "concatenated_address": "2202 W 16th St, Port Angeles",
    "address": "2202 W. 16th St., Port Angeles"
  },
  {
    "id": 786,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Park View Villas",
    "latitude": 48.055733,
    "longitude": -123.91784,
    "original_address": "1430 1435 1445 Park View Lane 800 S. G Street 1406 1408 1414 1416 1422 W. Eighth Street",
    "building_number": "",
    "street": "",
    "city": "Port Angeles",
    "zip": 98363,
    "concatenated_address": "1430 1435 1445 Park View Lane 800 S. G Street 1406 1408 1414 1416 1422 W. Eighth Street, Port Angeles",
    "address": "1430 1435 1445 Park View Lane 800 S. G St. 1406 1408 1414 1416 1422 W. Eighth St., Port Angeles"
  },
  {
    "id": 787,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Crestwood Convalescent Center",
    "latitude": 48.1031,
    "longitude": -123.41964,
    "original_address": "1116 East Lauridsen Blvd",
    "building_number": 1116,
    "street": "E Lauridsen Blvd",
    "city": "Port Angeles",
    "zip": 98362,
    "concatenated_address": "1116 E Lauridsen Blvd, Port Angeles",
    "address": "1116 E. Lauridsen Blvd., Port Angeles"
  },
  {
    "id": 788,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Pointe West Apartments",
    "latitude": 47.512254,
    "longitude": -122.61048,
    "original_address": "3159 Se Salmonberry Rd.",
    "building_number": 3159,
    "street": "SE Salmonberry Rd",
    "city": "Port Orchard",
    "zip": 98366,
    "concatenated_address": "3159 SE Salmonberry Rd, Port Orchard",
    "address": "3159 S.E. Salmonberry Road, Port Orchard"
  },
  {
    "id": 789,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Mariner's Glen",
    "latitude": 47.521683,
    "longitude": -122.60536,
    "original_address": "3418 Se Navigation Lane",
    "building_number": 3418,
    "street": "SE Navigation Ln",
    "city": "Port Orchard",
    "zip": 98366,
    "concatenated_address": "3418 SE Navigation Ln, Port Orchard",
    "address": "3418 S.E. Navigation Lane, Port Orchard"
  },
  {
    "id": 790,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Lund Village Apartments",
    "latitude": 47.519677,
    "longitude": -122.62549,
    "original_address": "1900 Se Lund Ave.1906 1912 Se Lund Ave.",
    "building_number": 1900,
    "street": "SE Lund Ave",
    "city": "Port Orchard",
    "zip": 98366,
    "concatenated_address": "1900 SE Lund Ave, Port Orchard",
    "address": "1900 S.E. Lund Ave., Port Orchard"
  },
  {
    "id": 791,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "The Sinclair Apartment Homes",
    "latitude": 47.496478,
    "longitude": -122.65351,
    "original_address": "414 Sw Hayworth Drive",
    "building_number": 414,
    "street": "Hayworth Dr",
    "city": "Port Orchard",
    "zip": 98367,
    "concatenated_address": "414 Hayworth Dr, Port Orchard",
    "address": "414 Hayworth Drive, Port Orchard"
  },
  {
    "id": 792,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "The Sidney Apartments",
    "latitude": 47.498852,
    "longitude": -122.65543,
    "original_address": "487 Mansfield Ct Sw",
    "building_number": 487,
    "street": "Mansfield Ct",
    "city": "Port Orchard",
    "zip": 98367,
    "concatenated_address": "487 Mansfield Ct, Port Orchard",
    "address": "487 Mansfield Ct, Port Orchard"
  },
  {
    "id": 793,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Atlas Apartment Homes",
    "latitude": 47.52242,
    "longitude": -122.6467,
    "original_address": "1800 Sidney Avenue",
    "building_number": 1800,
    "street": "Sidney Ave",
    "city": "Port Orchard",
    "zip": 98366,
    "concatenated_address": "1800 Sidney Ave, Port Orchard",
    "address": "1800 Sidney Ave., Port Orchard"
  },
  {
    "id": 794,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "South Park Greens Apartments",
    "latitude": 47.531118,
    "longitude": -122.59555,
    "original_address": "1916 Southeast Larch Lane",
    "building_number": 1916,
    "street": "SE Larch Ln",
    "city": "Port Orchard",
    "zip": 98366,
    "concatenated_address": "1916 SE Larch Ln, Port Orchard",
    "address": "1916 S.E. Larch Lane, Port Orchard"
  },
  {
    "id": 795,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Enlivant - Liberty Place",
    "latitude": 47.518432,
    "longitude": -122.65224,
    "original_address": "155 West Lippert",
    "building_number": 155,
    "street": "W Lippert Dr",
    "city": "Port Orchard",
    "zip": 98366,
    "concatenated_address": "155 W Lippert Dr, Port Orchard",
    "address": "155 W. Lippert Drive, Port Orchard"
  },
  {
    "id": 796,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Orchard Pointe",
    "latitude": 47.521991,
    "longitude": -122.65295,
    "original_address": "300 South Kitsap Boulevard",
    "building_number": 300,
    "street": "S Kitsap Blvd",
    "city": "Port Orchard",
    "zip": 98366,
    "concatenated_address": "300 S Kitsap Blvd, Port Orchard",
    "address": "300 S. Kitsap Blvd., Port Orchard"
  },
  {
    "id": 797,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Ridgemont Terrace Apartments",
    "latitude": 47.515649,
    "longitude": -122.65157,
    "original_address": "2049 Pottery Avenue",
    "building_number": 2049,
    "street": "Pottery Ave",
    "city": "Port Orchard",
    "zip": 98366,
    "concatenated_address": "2049 Pottery Ave, Port Orchard",
    "address": "2049 Pottery Ave., Port Orchard"
  },
  {
    "id": 798,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "The Communitas Group",
    "latitude": 47.542664,
    "longitude": -122.5871,
    "original_address": "1436 & 1438 West Street",
    "building_number": "",
    "street": "",
    "city": "Port Orchard",
    "zip": 98366,
    "concatenated_address": "1436 & 1438 West Street, Port Orchard",
    "address": "1436 & 1438 West St., Port Orchard"
  },
  {
    "id": 799,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Olympic Pointe I & II Apartments",
    "latitude": 47.537305,
    "longitude": -122.60699,
    "original_address": "3100 Se Orlando Street",
    "building_number": 3100,
    "street": "SE Orlando St",
    "city": "Port Orchard",
    "zip": 98366,
    "concatenated_address": "3100 SE Orlando St, Port Orchard",
    "address": "3100 S.E. Orlando St., Port Orchard"
  },
  {
    "id": 800,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Stafford Suites At Port Orchard",
    "latitude": 47.522018,
    "longitude": -122.65153,
    "original_address": "1761 Pottery Avenue",
    "building_number": 1761,
    "street": "Pottery Ave",
    "city": "Port Orchard",
    "zip": 98366,
    "concatenated_address": "1761 Pottery Ave, Port Orchard",
    "address": "1761 Pottery Ave., Port Orchard"
  },
  {
    "id": 801,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Ridgemont Terrace Skilled Nursing",
    "latitude": 47.51516,
    "longitude": -122.65126,
    "original_address": "2051 Pottery Avenue",
    "building_number": 2051,
    "street": "Pottery Ave",
    "city": "Port Orchard",
    "zip": 98366,
    "concatenated_address": "2051 Pottery Ave, Port Orchard",
    "address": "2051 Pottery Ave., Port Orchard"
  },
  {
    "id": 802,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Life Care Center Of Port Orchard",
    "latitude": 47.516982,
    "longitude": -122.65162,
    "original_address": "2031 Pottery Avenue",
    "building_number": 2031,
    "street": "Pottery Ave",
    "city": "Port Orchard",
    "zip": 98366,
    "concatenated_address": "2031 Pottery Ave, Port Orchard",
    "address": "2031 Pottery Ave., Port Orchard"
  },
  {
    "id": 803,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Park Vista Retirement & Assisted Living",
    "latitude": 47.519278,
    "longitude": -122.61472,
    "original_address": "2944 Se Lund Ave.",
    "building_number": 2944,
    "street": "SE Lund Ave",
    "city": "Port Orchard",
    "zip": 98366,
    "concatenated_address": "2944 SE Lund Ave, Port Orchard",
    "address": "2944 S.E. Lund Ave., Port Orchard"
  },
  {
    "id": 804,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "San Juan Commons",
    "latitude": 48.124485,
    "longitude": -122.77763,
    "original_address": "3300 San Juan Avenue",
    "building_number": 3300,
    "street": "San Juan Ave",
    "city": "Port Townsend",
    "zip": 98368,
    "concatenated_address": "3300 San Juan Ave, Port Townsend",
    "address": "3300 San Juan Ave., Port Townsend"
  },
  {
    "id": 805,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Avamere At Port Townsend",
    "latitude": 48.107963,
    "longitude": -122.79471,
    "original_address": "1201 Hancock Street",
    "building_number": 1201,
    "street": "Hancock St",
    "city": "Port Townsend",
    "zip": 98368,
    "concatenated_address": "1201 Hancock St, Port Townsend",
    "address": "1201 Hancock St., Port Townsend"
  },
  {
    "id": 806,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Enlivant - Victoria Place",
    "latitude": 48.118828,
    "longitude": -122.78222,
    "original_address": "491 Discovery Rd",
    "building_number": 491,
    "street": "Discovery Rd",
    "city": "Port Townsend",
    "zip": 98368,
    "concatenated_address": "491 Discovery Rd, Port Townsend",
    "address": "491 Discovery Road, Port Townsend"
  },
  {
    "id": 807,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Caring Places San Juan Villa",
    "latitude": 48.125431,
    "longitude": -122.77756,
    "original_address": "112 Castellano Way",
    "building_number": 112,
    "street": "Castellano Way",
    "city": "Port Townsend",
    "zip": 98368,
    "concatenated_address": "112 Castellano Way, Port Townsend",
    "address": "112 Castellano Way, Port Townsend"
  },
  {
    "id": 808,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Valley View Apartments",
    "latitude": 47.738396,
    "longitude": -122.64398,
    "original_address": "19310 4th Ave Ne",
    "building_number": 19310,
    "street": "4th Ave NE",
    "city": "Poulsbo",
    "zip": 98370,
    "concatenated_address": "19310 4th Ave NE, Poulsbo",
    "address": "19310 4th Ave. N.E., Poulsbo"
  },
  {
    "id": 809,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Scandia Knolls Apartments",
    "latitude": 47.747859,
    "longitude": -122.64826,
    "original_address": "20283 1st Avenue Ne",
    "building_number": 20283,
    "street": "1st Ave NE",
    "city": "Poulsbo",
    "zip": 98370,
    "concatenated_address": "20283 1st Ave NE, Poulsbo",
    "address": "20283 1st Ave. N.E., Poulsbo"
  },
  {
    "id": 810,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Liberty Shores Assisted Living And Harbor House Memory Care Facility",
    "latitude": 47.739505,
    "longitude": -122.65903,
    "original_address": "19360 Viking Ave Nw",
    "building_number": 19360,
    "street": "Viking Ave NW",
    "city": "Poulsbo",
    "zip": 98370,
    "concatenated_address": "19360 Viking Ave NW, Poulsbo",
    "address": "19360 Viking Ave. N.W., Poulsbo"
  },
  {
    "id": 811,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Viking Park Mobile Home Park",
    "latitude": 47.737101,
    "longitude": -122.62278,
    "original_address": "1754 Ne Mesford Street",
    "building_number": 1754,
    "street": "NE Mesford St",
    "city": "Poulsbo",
    "zip": 98370,
    "concatenated_address": "1754 NE Mesford St, Poulsbo",
    "address": "1754 N.E. Mesford St., Poulsbo"
  },
  {
    "id": 812,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Woodcreek Apartments",
    "latitude": 47.733793,
    "longitude": -122.62377,
    "original_address": "2122 Ne Hostmark Street",
    "building_number": 2122,
    "street": "NE Hostmark St",
    "city": "Poulsbo",
    "zip": 98370,
    "concatenated_address": "2122 NE Hostmark St, Poulsbo",
    "address": "2122 N.E. Hostmark St., Poulsbo"
  },
  {
    "id": 813,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "20043 Winton Lane Northwest",
    "latitude": 47.745223,
    "longitude": -122.65874,
    "original_address": "20043 Winton Lane Northwest",
    "building_number": 20043,
    "street": "Winton Ln NW",
    "city": "Poulsbo",
    "zip": 98370,
    "concatenated_address": "20043 Winton Ln NW, Poulsbo",
    "address": "20043 Winton Lane N.W., Poulsbo"
  },
  {
    "id": 814,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Martha And Mary Nursing Home",
    "latitude": 47.73651,
    "longitude": -122.64932,
    "original_address": "19160 Front Street Ne",
    "building_number": 19160,
    "street": "Front St NE",
    "city": "Poulsbo",
    "zip": 98370,
    "concatenated_address": "19160 Front St NE, Poulsbo",
    "address": "19160 Front St. N.E., Poulsbo"
  },
  {
    "id": 815,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Hillview MHC",
    "latitude": 46.209477,
    "longitude": -119.74314,
    "original_address": "835 Higdon Road",
    "building_number": 835,
    "street": "Higdon Rd",
    "city": "Prosser",
    "zip": 99350,
    "concatenated_address": "835 Higdon Rd, Prosser",
    "address": "835 Higdon Road, Prosser"
  },
  {
    "id": 816,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Sun Terrace At Prosser",
    "latitude": 46.209909,
    "longitude": -119.77173,
    "original_address": "2131 Wine Country Road",
    "building_number": "",
    "street": "Wine Country Rd",
    "city": "Prosser",
    "zip": 99350,
    "concatenated_address": "2131 Wine Country Road, Prosser",
    "address": "2131 Wine Country Road, Prosser"
  },
  {
    "id": 817,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Courtyard Heights Apartments",
    "latitude": 46.736835,
    "longitude": -117.16799,
    "original_address": "1020 Ne B Street1045 Ne Harvey Road",
    "building_number": 1020,
    "street": "NE B St",
    "city": "Pullman",
    "zip": 99163,
    "concatenated_address": "1020 NE B St, Pullman",
    "address": "1020 N.E. B St., Pullman"
  },
  {
    "id": 818,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Cornerstone Apartments",
    "latitude": 46.731449,
    "longitude": -117.17706,
    "original_address": "322 Ne Maple Street",
    "building_number": 322,
    "street": "NE Maple St",
    "city": "Pullman",
    "zip": 99163,
    "concatenated_address": "322 NE Maple St, Pullman",
    "address": "322 N.E. Maple St., Pullman"
  },
  {
    "id": 819,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Ridgeview Apartments",
    "latitude": 46.731979,
    "longitude": -117.17569,
    "original_address": "422 Ne Maiden Lane",
    "building_number": 422,
    "street": "NE Maiden Ln",
    "city": "Pullman",
    "zip": 99163,
    "concatenated_address": "422 NE Maiden Ln, Pullman",
    "address": "422 N.E. Maiden Lane, Pullman"
  },
  {
    "id": 820,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "A Street Apartments",
    "latitude": 46.734506,
    "longitude": -117.16868,
    "original_address": "822 Ne A Street",
    "building_number": 822,
    "street": "NE A St",
    "city": "Pullman",
    "zip": 99163,
    "concatenated_address": "822 NE A St, Pullman",
    "address": "822 N.E. A St., Pullman"
  },
  {
    "id": 821,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "The Residence At Whispering Hills",
    "latitude": 46.730745,
    "longitude": -117.20916,
    "original_address": "640 Sw Golden Hills Drive",
    "building_number": "",
    "street": "Golden Hills Dr",
    "city": "Pullman",
    "zip": 99163,
    "concatenated_address": "640 Sw Golden Hills Drive, Pullman",
    "address": "640 S.W. Golden Hills Drive, Pullman"
  },
  {
    "id": 822,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Cougar Crest Apartments",
    "latitude": 46.74672,
    "longitude": -117.1564,
    "original_address": "2055 Ne Skyview Drive",
    "building_number": 2055,
    "street": "NE Skyview Dr",
    "city": "Pullman",
    "zip": 99163,
    "concatenated_address": "2055 NE Skyview Dr, Pullman",
    "address": "2055 N.E. Skyview Drive, Pullman"
  },
  {
    "id": 823,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Residence At Whispering Hills West",
    "latitude": 46.730745,
    "longitude": -117.20916,
    "original_address": "635 Sw Golden Hills Drive",
    "building_number": "",
    "street": "Golden Hills Dr",
    "city": "Pullman",
    "zip": 99163,
    "concatenated_address": "635 Sw Golden Hills Drive, Pullman",
    "address": "635 S.W. Golden Hills Drive, Pullman"
  },
  {
    "id": 824,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Wil-Ru Apartments",
    "latitude": 46.720599,
    "longitude": -117.16138,
    "original_address": "1615 Se Bleasner Drive",
    "building_number": 1615,
    "street": "SE Bleasner Dr",
    "city": "Pullman",
    "zip": 99163,
    "concatenated_address": "1615 SE Bleasner Dr, Pullman",
    "address": "1615 S.E. Bleasner Drive, Pullman"
  },
  {
    "id": 825,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Birch Hills Apartments",
    "latitude": 46.747469,
    "longitude": -117.14789,
    "original_address": "2200 Ne Westwood Drive",
    "building_number": 2200,
    "street": "NE Westwood Dr",
    "city": "Pullman",
    "zip": 99163,
    "concatenated_address": "2200 NE Westwood Dr, Pullman",
    "address": "2200 N.E. Westwood Drive, Pullman"
  },
  {
    "id": 826,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Cougar Ridge Apartments",
    "latitude": 46.730331,
    "longitude": -117.21803,
    "original_address": "2024 Ne Terre View Drive",
    "building_number": "",
    "street": "",
    "city": "Pullman",
    "zip": 99163,
    "concatenated_address": "2024 Ne Terre View Drive, Pullman",
    "address": "2024 Ne Terre View Drive, Pullman"
  },
  {
    "id": 827,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Willow Place",
    "latitude": 46.739233,
    "longitude": -117.16467,
    "original_address": "1125 Ne Valley Road",
    "building_number": 1125,
    "street": "NE Valley Rd",
    "city": "Pullman",
    "zip": 99163,
    "concatenated_address": "1125 NE Valley Rd, Pullman",
    "address": "1125 N.E. Valley Road, Pullman"
  },
  {
    "id": 828,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Clarke Terrace Apartments",
    "latitude": 46.730331,
    "longitude": -117.21803,
    "original_address": "Northwest 100 Terre View Drive",
    "building_number": "",
    "street": "",
    "city": "Pullman",
    "zip": 99163,
    "concatenated_address": "Northwest 100 Terre View Drive, Pullman",
    "address": "Northwest 100 Terre View Drive, Pullman"
  },
  {
    "id": 829,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Campus Ridge",
    "latitude": 46.730331,
    "longitude": -117.21803,
    "original_address": "Various",
    "building_number": "",
    "street": "",
    "city": "Pullman",
    "zip": 99163,
    "concatenated_address": "Various, Pullman",
    "address": "Various, Pullman"
  },
  {
    "id": 830,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Providence Court",
    "latitude": 46.840699,
    "longitude": -117.11645,
    "original_address": "880 Ne Valley Road",
    "building_number": 880,
    "street": "Viola Rd",
    "city": "Pullman",
    "zip": 99163,
    "concatenated_address": "880 Viola Rd, Pullman",
    "address": "880 Viola Road, Pullman"
  },
  {
    "id": 831,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Churchill Downs Apartments",
    "latitude": 46.741085,
    "longitude": -117.16496,
    "original_address": "1365 Ne Brandi Way",
    "building_number": 1365,
    "street": "NE Brandi Way",
    "city": "Pullman",
    "zip": 99163,
    "concatenated_address": "1365 NE Brandi Way, Pullman",
    "address": "1365 N.E. Brandi Way, Pullman"
  },
  {
    "id": 832,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Pimlico Apartments",
    "latitude": 46.741088,
    "longitude": -117.16512,
    "original_address": "1455 Ne Brandi Way",
    "building_number": "",
    "street": "NE Brandi Way",
    "city": "Pullman",
    "zip": 99163,
    "concatenated_address": "1455 Ne Brandi Way, Pullman",
    "address": "1455 Ne Brandi Way, Pullman"
  },
  {
    "id": 833,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Pioneer Square",
    "latitude": 46.728763,
    "longitude": -117.18013,
    "original_address": "220 Se Kamiaken Street",
    "building_number": 220,
    "street": "SE Kamiaken St",
    "city": "Pullman",
    "zip": 99163,
    "concatenated_address": "220 SE Kamiaken St, Pullman",
    "address": "220 S.E. Kamiaken St., Pullman"
  },
  {
    "id": 834,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Aspen Village - Pullman",
    "latitude": 46.744849,
    "longitude": -117.14688,
    "original_address": "1620 Ne Northwood Dr",
    "building_number": 1620,
    "street": "Northwood Dr",
    "city": "Pullman",
    "zip": 99163,
    "concatenated_address": "1620 Northwood Dr, Pullman",
    "address": "1620 Northwood Drive, Pullman"
  },
  {
    "id": 835,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Kenwood Square Apartments",
    "latitude": 46.739222,
    "longitude": -117.17466,
    "original_address": "1225 Nw Nye St",
    "building_number": 1225,
    "street": "NW Nye St",
    "city": "Pullman",
    "zip": 99163,
    "concatenated_address": "1225 NW Nye St, Pullman",
    "address": "1225 N.W. Nye St., Pullman"
  },
  {
    "id": 836,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Viking Estates MHC",
    "latitude": 47.116422,
    "longitude": -122.26583,
    "original_address": "15401 122nd Avenue East",
    "building_number": 15401,
    "street": "122nd Ave Ct E",
    "city": "Puyallup",
    "zip": 98374,
    "concatenated_address": "15401 122nd Ave Ct E, Puyallup",
    "address": "15401 122nd Ave. Ct E., Puyallup"
  },
  {
    "id": 837,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Canterbury Apartments",
    "latitude": 47.136739,
    "longitude": -122.29497,
    "original_address": "13118 Meridian East",
    "building_number": 13118,
    "street": "Meridian E",
    "city": "Puyallup",
    "zip": 98373,
    "concatenated_address": "13118 Meridian E, Puyallup",
    "address": "13118 Meridian E., Puyallup"
  },
  {
    "id": 838,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Country Gables Apartments",
    "latitude": 47.181334,
    "longitude": -122.28331,
    "original_address": "1112 9th Street Se",
    "building_number": 1112,
    "street": "9th St SE",
    "city": "Puyallup",
    "zip": 98372,
    "concatenated_address": "1112 9th St SE, Puyallup",
    "address": "1112 9th St. S.E., Puyallup"
  },
  {
    "id": 839,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Mountain Park Townhomes",
    "latitude": 47.11059,
    "longitude": -122.30139,
    "original_address": "9506-9533 160th Street Court E.",
    "building_number": 9533,
    "street": "160th St Ct E",
    "city": "Puyallup",
    "zip": 98375,
    "concatenated_address": "9533 160th St Ct E, Puyallup",
    "address": "9533 160th St. Ct E., Puyallup"
  },
  {
    "id": 840,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "The Highlands At South Hill",
    "latitude": 47.150882,
    "longitude": -122.28749,
    "original_address": "502 43rd Avenue Se",
    "building_number": 502,
    "street": "43rd Ave SE",
    "city": "Puyallup",
    "zip": 98374,
    "concatenated_address": "502 43rd Ave SE, Puyallup",
    "address": "502 43rd Ave. S.E., Puyallup"
  },
  {
    "id": 841,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Meridian Firs Apartments",
    "latitude": 47.163777,
    "longitude": -122.2928,
    "original_address": "2923 South Meridian Street",
    "building_number": 2923,
    "street": "S Meridian",
    "city": "Puyallup",
    "zip": 98373,
    "concatenated_address": "2923 S Meridian, Puyallup",
    "address": "2923 S. Meridian, Puyallup"
  },
  {
    "id": 842,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Willow Hill Apartments",
    "latitude": 47.137181,
    "longitude": -122.29094,
    "original_address": "13011 Meridian East",
    "building_number": 13011,
    "street": "Meridian E",
    "city": "Puyallup",
    "zip": 98373,
    "concatenated_address": "13011 Meridian E, Puyallup",
    "address": "13011 Meridian E., Puyallup"
  },
  {
    "id": 843,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Riverside Park Apartments",
    "latitude": 47.195219,
    "longitude": -122.25562,
    "original_address": "2800 5th Avenue",
    "building_number": 2800,
    "street": "5th Ave NE",
    "city": "Puyallup",
    "zip": 98372,
    "concatenated_address": "2800 5th Ave NE, Puyallup",
    "address": "2800 5th Ave. N.E., Puyallup"
  },
  {
    "id": 844,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Canyon Park Apartments",
    "latitude": 47.154841,
    "longitude": -122.35424,
    "original_address": "5605 112th Street E",
    "building_number": 5605,
    "street": "112th St E",
    "city": "Puyallup",
    "zip": 98373,
    "concatenated_address": "5605 112th St E, Puyallup",
    "address": "5605 112th St. E., Puyallup"
  },
  {
    "id": 845,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Crestview Mobile Manor Viewcrest Mobile Home Park",
    "latitude": 47.184566,
    "longitude": -122.34829,
    "original_address": "6111 80th Street East And 7800 62nd Avenue East",
    "building_number": 6111,
    "street": "80th St E",
    "city": "Puyallup",
    "zip": 98371,
    "concatenated_address": "6111 80th St E, Puyallup",
    "address": "6111 80th St. E., Puyallup"
  },
  {
    "id": 846,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Bella On Canyon",
    "latitude": 47.127951,
    "longitude": -122.35729,
    "original_address": "14115 Canyon Road E.",
    "building_number": 14115,
    "street": "Canyon Rd E",
    "city": "Puyallup",
    "zip": 98373,
    "concatenated_address": "14115 Canyon Rd E, Puyallup",
    "address": "14115 Canyon Road E., Puyallup"
  },
  {
    "id": 847,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Brookdale Courtyard Puyallup",
    "latitude": 47.148322,
    "longitude": -122.28601,
    "original_address": "4610 6th Street Place Southeast",
    "building_number": 4610,
    "street": "6th St Pl SE",
    "city": "Puyallup",
    "zip": 98374,
    "concatenated_address": "4610 6th St Pl SE, Puyallup",
    "address": "4610 6th St. Pl S.E., Puyallup"
  },
  {
    "id": 848,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Alderra Apartment Homes",
    "latitude": 47.133462,
    "longitude": -122.29655,
    "original_address": "13507 99th Avenue East",
    "building_number": 13507,
    "street": "99th Ave E",
    "city": "Puyallup",
    "zip": 98373,
    "concatenated_address": "13507 99th Ave E, Puyallup",
    "address": "13507 99th Ave. E., Puyallup"
  },
  {
    "id": 849,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Aspen Creek",
    "latitude": 47.1427,
    "longitude": -122.28934,
    "original_address": "12724 104th Avenue Court E",
    "building_number": 12724,
    "street": "104th Ave Ct E",
    "city": "Puyallup",
    "zip": 98374,
    "concatenated_address": "12724 104th Ave Ct E, Puyallup",
    "address": "12724 104th Ave. Ct E., Puyallup"
  },
  {
    "id": 850,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Harvest Gate MHC",
    "latitude": 47.176081,
    "longitude": -122.34832,
    "original_address": "6101 89th Street Ct E.",
    "building_number": 6101,
    "street": "89th St Ct E",
    "city": "Puyallup",
    "zip": 98371,
    "concatenated_address": "6101 89th St Ct E, Puyallup",
    "address": "6101 89th St. Ct E., Puyallup"
  },
  {
    "id": 851,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Julian Estates",
    "latitude": 47.136141,
    "longitude": -122.30246,
    "original_address": "13305 94th Avenue E",
    "building_number": 13305,
    "street": "94th Ave E",
    "city": "Puyallup",
    "zip": 98373,
    "concatenated_address": "13305 94th Ave E, Puyallup",
    "address": "13305 94th Ave. E., Puyallup"
  },
  {
    "id": 852,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Cambridge Apartments",
    "latitude": 47.185583,
    "longitude": -122.28437,
    "original_address": "737 7th Street Se",
    "building_number": 737,
    "street": "7th St SE",
    "city": "Puyallup",
    "zip": 98372,
    "concatenated_address": "737 7th St SE, Puyallup",
    "address": "737 7th St. S.E., Puyallup"
  },
  {
    "id": 853,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Sherwood Apartments",
    "latitude": 47.144166,
    "longitude": -122.25715,
    "original_address": "12815-12821 123rd Street Court East",
    "building_number": 12821,
    "street": "123rd St Ct E",
    "city": "Puyallup",
    "zip": 98374,
    "concatenated_address": "12821 123rd St Ct E, Puyallup",
    "address": "12821 123rd St. Ct E., Puyallup"
  },
  {
    "id": 854,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "6608 106th Street",
    "latitude": 47.159418,
    "longitude": -122.34042,
    "original_address": "6608 106th Street Court East",
    "building_number": 6608,
    "street": "106th St Ct E",
    "city": "Puyallup",
    "zip": 98373,
    "concatenated_address": "6608 106th St Ct E, Puyallup",
    "address": "6608 106th St. Ct E., Puyallup"
  },
  {
    "id": 855,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Southridge Apartments",
    "latitude": 47.165404,
    "longitude": -122.29361,
    "original_address": "2700 South Meridian",
    "building_number": 2700,
    "street": "S Meridian",
    "city": "Puyallup",
    "zip": 98373,
    "concatenated_address": "2700 S Meridian, Puyallup",
    "address": "2700 S. Meridian, Puyallup"
  },
  {
    "id": 856,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Wynstone Townhomes",
    "latitude": 47.145414,
    "longitude": -122.35479,
    "original_address": "5502 121st Street Court East",
    "building_number": 5502,
    "street": "121st St Ct E",
    "city": "Puyallup",
    "zip": 98373,
    "concatenated_address": "5502 121st St Ct E, Puyallup",
    "address": "5502 121st St. Ct E., Puyallup"
  },
  {
    "id": 857,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Meridian West Apartments",
    "latitude": 47.167663,
    "longitude": -122.29441,
    "original_address": "2580 South Meridian",
    "building_number": 2580,
    "street": "S Meridian",
    "city": "Puyallup",
    "zip": 98373,
    "concatenated_address": "2580 S Meridian, Puyallup",
    "address": "2580 S. Meridian, Puyallup"
  },
  {
    "id": 858,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "318 10th Avenue Southeast",
    "latitude": 47.182373,
    "longitude": -122.28981,
    "original_address": "318 10th Avenue Southeast",
    "building_number": 318,
    "street": "10th Ave SE",
    "city": "Puyallup",
    "zip": 98372,
    "concatenated_address": "318 10th Ave SE, Puyallup",
    "address": "318 10th Ave. S.E., Puyallup"
  },
  {
    "id": 859,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "River Trail Apartments",
    "latitude": 47.192012,
    "longitude": -122.2718,
    "original_address": "1617 East Main Avenue",
    "building_number": 1617,
    "street": "E Main Ave",
    "city": "Puyallup",
    "zip": 98372,
    "concatenated_address": "1617 E Main Ave, Puyallup",
    "address": "1617 E. Main Ave., Puyallup"
  },
  {
    "id": 860,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Brookstone At Edgewater",
    "latitude": 47.095709,
    "longitude": -122.32923,
    "original_address": "7513 177th Street Court East",
    "building_number": 7513,
    "street": "177th St Ct E",
    "city": "Puyallup",
    "zip": 98375,
    "concatenated_address": "7513 177th St Ct E, Puyallup",
    "address": "7513 177th St. Ct E., Puyallup"
  },
  {
    "id": 861,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Vanessa View Estates",
    "latitude": 47.145817,
    "longitude": -122.3097,
    "original_address": "5606 And 5608 And 5610 And 5612 112th St",
    "building_number": "",
    "street": "",
    "city": "Puyallup",
    "zip": 98373,
    "concatenated_address": "5606 And 5608 And 5610 And 5612 112th St, Puyallup",
    "address": "5606 And 5608 And 5610 And 5612 112th St., Puyallup"
  },
  {
    "id": 862,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Fairview Apartments",
    "latitude": 47.18421,
    "longitude": -122.29032,
    "original_address": "322 9th Avenue Se",
    "building_number": 322,
    "street": "9th Ave SE",
    "city": "Puyallup",
    "zip": 98372,
    "concatenated_address": "322 9th Ave SE, Puyallup",
    "address": "322 9th Ave. S.E., Puyallup"
  },
  {
    "id": 863,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Prestige Townhomes",
    "latitude": 47.194962,
    "longitude": -122.2889,
    "original_address": "425 4th Street Ne",
    "building_number": 425,
    "street": "4th St NE",
    "city": "Puyallup",
    "zip": 98372,
    "concatenated_address": "425 4th St NE, Puyallup",
    "address": "425 4th St. N.E., Puyallup"
  },
  {
    "id": 864,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Fruitland Apartments",
    "latitude": 47.187304,
    "longitude": -122.32669,
    "original_address": "2205 7th Avenue Southwest",
    "building_number": 2205,
    "street": "7th Ave SW",
    "city": "Puyallup",
    "zip": 98371,
    "concatenated_address": "2205 7th Ave SW, Puyallup",
    "address": "2205 7th Ave. S.W., Puyallup"
  },
  {
    "id": 865,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Royal Arms",
    "latitude": 47.193866,
    "longitude": -122.29177,
    "original_address": "319 2nd Street Ne",
    "building_number": 319,
    "street": "2nd St NE",
    "city": "Puyallup",
    "zip": 98372,
    "concatenated_address": "319 2nd St NE, Puyallup",
    "address": "319 2nd St. N.E., Puyallup"
  },
  {
    "id": 866,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Shadow Park Apartments",
    "latitude": 47.196479,
    "longitude": -122.30711,
    "original_address": "521 11th St Nw",
    "building_number": 521,
    "street": "11th St NW",
    "city": "Puyallup",
    "zip": 98371,
    "concatenated_address": "521 11th St NW, Puyallup",
    "address": "521 11th St. N.W., Puyallup"
  },
  {
    "id": 867,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Redwood Village Townhomes",
    "latitude": 47.193388,
    "longitude": -122.29055,
    "original_address": "303-307 2nd Avenue Ne",
    "building_number": 307,
    "street": "2nd Ave NE",
    "city": "Puyallup",
    "zip": 98372,
    "concatenated_address": "307 2nd Ave NE, Puyallup",
    "address": "307 2nd Ave. N.E., Puyallup"
  },
  {
    "id": 868,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Twana Apartments",
    "latitude": 47.195652,
    "longitude": -122.29154,
    "original_address": "219 5th Ave Ne",
    "building_number": 219,
    "street": "5th Ave NE",
    "city": "Puyallup",
    "zip": 98372,
    "concatenated_address": "219 5th Ave NE, Puyallup",
    "address": "219 5th Ave. N.E., Puyallup"
  },
  {
    "id": 869,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Sierra Sun Phase I",
    "latitude": 47.099318,
    "longitude": -122.26291,
    "original_address": "12415 172nd Street East",
    "building_number": 12415,
    "street": "172nd St E",
    "city": "Puyallup",
    "zip": 98374,
    "concatenated_address": "12415 172nd St E, Puyallup",
    "address": "12415 172nd St. E., Puyallup"
  },
  {
    "id": 870,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Argus Manor",
    "latitude": 47.184247,
    "longitude": -122.29214,
    "original_address": "204 9th Avenue Se",
    "building_number": 204,
    "street": "9th Ave SE",
    "city": "Puyallup",
    "zip": 98372,
    "concatenated_address": "204 9th Ave SE, Puyallup",
    "address": "204 9th Ave. S.E., Puyallup"
  },
  {
    "id": 871,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "One Canyon Place",
    "latitude": 47.150001,
    "longitude": -122.3566,
    "original_address": "11619 Canyon Road East",
    "building_number": 11619,
    "street": "Canyon Rd E",
    "city": "Puyallup",
    "zip": 98373,
    "concatenated_address": "11619 Canyon Rd E, Puyallup",
    "address": "11619 Canyon Road E., Puyallup"
  },
  {
    "id": 872,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Keystone Ridge Apartments",
    "latitude": 47.126732,
    "longitude": -122.28919,
    "original_address": "14209 103rd Avenue Court E",
    "building_number": 14209,
    "street": "103rd Ave Ct E",
    "city": "Puyallup",
    "zip": 98374,
    "concatenated_address": "14209 103rd Ave Ct E, Puyallup",
    "address": "14209 103rd Ave. Ct E., Puyallup"
  },
  {
    "id": 873,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Life Care Center Of Puyallup",
    "latitude": 47.183501,
    "longitude": -122.28745,
    "original_address": "511 10th Avenue Se",
    "building_number": 511,
    "street": "10th Ave SE",
    "city": "Puyallup",
    "zip": 98372,
    "concatenated_address": "511 10th Ave SE, Puyallup",
    "address": "511 10th Ave. S.E., Puyallup"
  },
  {
    "id": 874,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Silver Creek Retirement & Assisted Living",
    "latitude": 47.09624,
    "longitude": -122.30823,
    "original_address": "17607 91st. Avenue E",
    "building_number": 17607,
    "street": "91st Ave E",
    "city": "Puyallup",
    "zip": 98375,
    "concatenated_address": "17607 91st Ave E, Puyallup",
    "address": "17607 91st Ave. E., Puyallup"
  },
  {
    "id": 875,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Life Care Center Of South Hill",
    "latitude": 47.168232,
    "longitude": -122.2867,
    "original_address": "2508 7th Street Southeast",
    "building_number": 2508,
    "street": "7th St SE",
    "city": "Puyallup",
    "zip": 98374,
    "concatenated_address": "2508 7th St SE, Puyallup",
    "address": "2508 7th St. S.E., Puyallup"
  },
  {
    "id": 876,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Affinity At Puyallup",
    "latitude": 47.152279,
    "longitude": -122.28821,
    "original_address": "3909 5th Street Se",
    "building_number": 3909,
    "street": "5th St SE",
    "city": "Puyallup",
    "zip": 98374,
    "concatenated_address": "3909 5th St SE, Puyallup",
    "address": "3909 5th St. S.E., Puyallup"
  },
  {
    "id": 877,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "The Cambridge",
    "latitude": 47.232268,
    "longitude": -119.86,
    "original_address": "301 H Street Sw",
    "building_number": 301,
    "street": "H St SW",
    "city": "Quincy",
    "zip": 98848,
    "concatenated_address": "301 H St SW, Quincy",
    "address": "301 H St. S.W., Quincy"
  },
  {
    "id": 878,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Raymond Manor Apartments",
    "latitude": 46.687416,
    "longitude": -123.72994,
    "original_address": "434 6th Street",
    "building_number": 434,
    "street": "6th St",
    "city": "Raymond",
    "zip": 98577,
    "concatenated_address": "434 6th St, Raymond",
    "address": "434 6th St., Raymond"
  },
  {
    "id": 879,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Willapa Harbor Health & Rehabilitation",
    "latitude": 46.675326,
    "longitude": -123.74717,
    "original_address": "1100 Jackson Street",
    "building_number": 1100,
    "street": "Jackson Ave",
    "city": "Raymond",
    "zip": 98577,
    "concatenated_address": "1100 Jackson Ave, Raymond",
    "address": "1100 Jackson Ave., Raymond"
  },
  {
    "id": 880,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "9200 Redmond Place Apartments",
    "latitude": 47.683572,
    "longitude": -122.12284,
    "original_address": "9200 Redmond-Woodinville Road Ne",
    "building_number": 9200,
    "street": "Redmond Woodinville Rd NE",
    "city": "Redmond",
    "zip": 98052,
    "concatenated_address": "9200 Redmond Woodinville Rd NE, Redmond",
    "address": "9200 Redmond Woodinville Road N.E., Redmond"
  },
  {
    "id": 881,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Chelsea Square Apartments",
    "latitude": 47.677377,
    "longitude": -122.12211,
    "original_address": "16340 Ne 83rd Street",
    "building_number": 16340,
    "street": "NE 83rd St",
    "city": "Redmond",
    "zip": 98052,
    "concatenated_address": "16340 NE 83rd St, Redmond",
    "address": "16340 N.E. 83rd St., Redmond"
  },
  {
    "id": 882,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Lionsgate North",
    "latitude": 47.676836,
    "longitude": -122.12884,
    "original_address": "15900 Ne 83rd Street",
    "building_number": 15900,
    "street": "NE 83rd St",
    "city": "Redmond",
    "zip": 98052,
    "concatenated_address": "15900 NE 83rd St, Redmond",
    "address": "15900 N.E. 83rd St., Redmond"
  },
  {
    "id": 883,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Olde Redmond Place",
    "latitude": 47.668888,
    "longitude": -122.13406,
    "original_address": "7001 Ne Old Redmond Road",
    "building_number": 7001,
    "street": "Old Redmond Rd",
    "city": "Redmond",
    "zip": 98052,
    "concatenated_address": "7001 Old Redmond Rd, Redmond",
    "address": "7001 Old Redmond Road, Redmond"
  },
  {
    "id": 884,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "The Gates Of Redmond Apartments",
    "latitude": 47.673245,
    "longitude": -122.13532,
    "original_address": "15325 Ne Redmond Way",
    "building_number": 15325,
    "street": "Redmond Way",
    "city": "Redmond",
    "zip": 98052,
    "concatenated_address": "15325 Redmond Way, Redmond",
    "address": "15325 Redmond Way, Redmond"
  },
  {
    "id": 885,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Heritage Woods",
    "latitude": 47.683294,
    "longitude": -122.11939,
    "original_address": "16518 Ne 91st Street",
    "building_number": 16518,
    "street": "NE 91st St",
    "city": "Redmond",
    "zip": 98052,
    "concatenated_address": "16518 NE 91st St, Redmond",
    "address": "16518 N.E. 91st St., Redmond"
  },
  {
    "id": 886,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Elan At Redmond",
    "latitude": 47.672927,
    "longitude": -122.12209,
    "original_address": "16325 Cleveland Street",
    "building_number": 16325,
    "street": "Cleveland St",
    "city": "Redmond",
    "zip": 98052,
    "concatenated_address": "16325 Cleveland St, Redmond",
    "address": "16325 Cleveland St., Redmond"
  },
  {
    "id": 887,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Reflections By Windsor",
    "latitude": 47.663043,
    "longitude": -122.09788,
    "original_address": "6332 East Lake Sammamish Parkway Ne",
    "building_number": 6332,
    "street": "E Lake Sammamish Pkwy NE",
    "city": "Redmond",
    "zip": 98052,
    "concatenated_address": "6332 E Lake Sammamish Pkwy NE, Redmond",
    "address": "6332 E. Lake Sammamish Pkwy N.E., Redmond"
  },
  {
    "id": 888,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "The Summit Apartment Homes",
    "latitude": 47.676281,
    "longitude": -122.14216,
    "original_address": "14820 Redmond Way",
    "building_number": 14820,
    "street": "Redmond Way",
    "city": "Redmond",
    "zip": 98052,
    "concatenated_address": "14820 Redmond Way, Redmond",
    "address": "14820 Redmond Way, Redmond"
  },
  {
    "id": 889,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Reunion At Redmond Ridge Apartments",
    "latitude": 47.698688,
    "longitude": -122.02356,
    "original_address": "11315 Trilogy Parkway Ne",
    "building_number": 11315,
    "street": "Trilogy Pkwy NE",
    "city": "Redmond",
    "zip": 98053,
    "concatenated_address": "11315 Trilogy Pkwy NE, Redmond",
    "address": "11315 Trilogy Pkwy N.E., Redmond"
  },
  {
    "id": 890,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "162Ten",
    "latitude": 47.675152,
    "longitude": -122.12385,
    "original_address": "16210 Ne 80th Street",
    "building_number": 16210,
    "street": "NE 80th St",
    "city": "Redmond",
    "zip": 98052,
    "concatenated_address": "16210 NE 80th St, Redmond",
    "address": "16210 N.E. 80th St., Redmond"
  },
  {
    "id": 891,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "The Lodge At Redmond Ridge",
    "latitude": 47.693142,
    "longitude": -122.04136,
    "original_address": "22433 Ne Marketplace Drive",
    "building_number": 22433,
    "street": "NE Marketplace Dr",
    "city": "Redmond",
    "zip": 98053,
    "concatenated_address": "22433 NE Marketplace Dr, Redmond",
    "address": "22433 N.E. Marketplace Drive, Redmond"
  },
  {
    "id": 892,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Colony At Bear Creek II",
    "latitude": 47.687474,
    "longitude": -122.09943,
    "original_address": "18100 Ne 95th Street",
    "building_number": 18100,
    "street": "NE 95th St",
    "city": "Redmond",
    "zip": 98052,
    "concatenated_address": "18100 NE 95th St, Redmond",
    "address": "18100 N.E. 95th St., Redmond"
  },
  {
    "id": 893,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Bell Marymoor Park",
    "latitude": 47.662243,
    "longitude": -122.09933,
    "original_address": "6335 180th Place Ne",
    "building_number": 6335,
    "street": "180th Pl NE",
    "city": "Redmond",
    "zip": 98052,
    "concatenated_address": "6335 180th Pl NE, Redmond",
    "address": "6335 180th Pl N.E., Redmond"
  },
  {
    "id": 894,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Tudor Manor",
    "latitude": 47.677975,
    "longitude": -122.1197,
    "original_address": "16552 Northeast 84th Court",
    "building_number": 16552,
    "street": "NE 84th Ct",
    "city": "Redmond",
    "zip": 98052,
    "concatenated_address": "16552 NE 84th Ct, Redmond",
    "address": "16552 N.E. 84th Ct, Redmond"
  },
  {
    "id": 895,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "The Onyx Apartments",
    "latitude": 47.65085,
    "longitude": -122.13073,
    "original_address": "4850 156th Avenue Northeast",
    "building_number": 4850,
    "street": "156th Ave NE",
    "city": "Redmond",
    "zip": 98052,
    "concatenated_address": "4850 156th Ave NE, Redmond",
    "address": "4850 156th Ave. N.E., Redmond"
  },
  {
    "id": 896,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Vesta Apartments Fka Redmond Hill Apartments",
    "latitude": 47.659179,
    "longitude": -122.09068,
    "original_address": "18666 Redmond Way",
    "building_number": 18666,
    "street": "Redmond Way",
    "city": "Redmond",
    "zip": 98052,
    "concatenated_address": "18666 Redmond Way, Redmond",
    "address": "18666 Redmond Way, Redmond"
  },
  {
    "id": 897,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Redmond Hill",
    "latitude": 47.66115,
    "longitude": -122.09137,
    "original_address": "6110 186th Pl Ne",
    "building_number": 6110,
    "street": "186th Pl NE",
    "city": "Redmond",
    "zip": 98052,
    "concatenated_address": "6110 186th Pl NE, Redmond",
    "address": "6110 186th Pl N.E., Redmond"
  },
  {
    "id": 898,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Vision 5",
    "latitude": 47.678873,
    "longitude": -122.12312,
    "original_address": "8525 163rd Court Northeast",
    "building_number": 8525,
    "street": "163rd Ct NE",
    "city": "Redmond",
    "zip": 98052,
    "concatenated_address": "8525 163rd Ct NE, Redmond",
    "address": "8525 163rd Ct N.E., Redmond"
  },
  {
    "id": 899,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Colony At Bear Creek Phase I",
    "latitude": 47.685086,
    "longitude": -122.09775,
    "original_address": "9301 Avondale Road Northeast",
    "building_number": 9301,
    "street": "Avondale Rd NE",
    "city": "Redmond",
    "zip": 98052,
    "concatenated_address": "9301 Avondale Rd NE, Redmond",
    "address": "9301 Avondale Road N.E., Redmond"
  },
  {
    "id": 900,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "16990 Northeast 80th Street",
    "latitude": 47.675183,
    "longitude": -122.11405,
    "original_address": "16990 Northeast 80th Street",
    "building_number": 16990,
    "street": "NE 80th St",
    "city": "Redmond",
    "zip": 98052,
    "concatenated_address": "16990 NE 80th St, Redmond",
    "address": "16990 N.E. 80th St., Redmond"
  },
  {
    "id": 901,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Aegis Living At Marymoor",
    "latitude": 47.650021,
    "longitude": -122.11568,
    "original_address": "4585 West Lake Sammamish Parkway Northeast",
    "building_number": 4585,
    "street": "W Lake Sammamish Pkwy NE",
    "city": "Redmond",
    "zip": 98052,
    "concatenated_address": "4585 W Lake Sammamish Pkwy NE, Redmond",
    "address": "4585 W. Lake Sammamish Pkwy N.E., Redmond"
  },
  {
    "id": 902,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "The Anna Apartments",
    "latitude": 47.685373,
    "longitude": -122.11923,
    "original_address": "9447 166th Avenue Northeast",
    "building_number": 9447,
    "street": "166th Ave NE",
    "city": "Redmond",
    "zip": 98052,
    "concatenated_address": "9447 166th Ave NE, Redmond",
    "address": "9447 166th Ave. N.E., Redmond"
  },
  {
    "id": 903,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Townside Flats",
    "latitude": 47.673908,
    "longitude": -122.11258,
    "original_address": "7910 170th Place Ne",
    "building_number": 7910,
    "street": "170th Pl NE",
    "city": "Redmond",
    "zip": 98052,
    "concatenated_address": "7910 170th Pl NE, Redmond",
    "address": "7910 170th Pl N.E., Redmond"
  },
  {
    "id": 904,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Redmond Hill Apartments North And East",
    "latitude": 47.659179,
    "longitude": -122.09068,
    "original_address": "18666 Redmond Way",
    "building_number": 18666,
    "street": "Redmond Way",
    "city": "Redmond",
    "zip": 98052,
    "concatenated_address": "18666 Redmond Way, Redmond",
    "address": "18666 Redmond Way, Redmond"
  },
  {
    "id": 905,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Redmond Hill Apartments Central And West",
    "latitude": 47.66115,
    "longitude": -122.09137,
    "original_address": "6110 186th Place Ne",
    "building_number": 6110,
    "street": "186th Pl NE",
    "city": "Redmond",
    "zip": 98052,
    "concatenated_address": "6110 186th Pl NE, Redmond",
    "address": "6110 186th Pl N.E., Redmond"
  },
  {
    "id": 906,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Peters Creek Retirement & Assisted Living",
    "latitude": 47.674344,
    "longitude": -122.14635,
    "original_address": "14431 Redmond Way",
    "building_number": 14431,
    "street": "Redmond Way",
    "city": "Redmond",
    "zip": 98052,
    "concatenated_address": "14431 Redmond Way, Redmond",
    "address": "14431 Redmond Way, Redmond"
  },
  {
    "id": 907,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Summerwood Housing",
    "latitude": 47.688131,
    "longitude": -122.09478,
    "original_address": "9805 Avondale Road Ne",
    "building_number": 9805,
    "street": "Avondale Rd NE",
    "city": "Redmond",
    "zip": 98052,
    "concatenated_address": "9805 Avondale Rd NE, Redmond",
    "address": "9805 Avondale Road N.E., Redmond"
  },
  {
    "id": 908,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Highlands Apartments",
    "latitude": 47.502452,
    "longitude": -122.17305,
    "original_address": "1151 Olympia Avenue Ne",
    "building_number": 1151,
    "street": "Olympia Ave NE",
    "city": "Renton",
    "zip": 98056,
    "concatenated_address": "1151 Olympia Ave NE, Renton",
    "address": "1151 Olympia Ave. N.E., Renton"
  },
  {
    "id": 909,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Cedar Village Apartments",
    "latitude": 47.50324,
    "longitude": -122.16006,
    "original_address": "1201 Anacortes Avenue Ne",
    "building_number": 1201,
    "street": "Anacortes Ave NE",
    "city": "Renton",
    "zip": 98059,
    "concatenated_address": "1201 Anacortes Ave NE, Renton",
    "address": "1201 Anacortes Ave. N.E., Renton"
  },
  {
    "id": 910,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Williams Court Apartments",
    "latitude": 47.474771,
    "longitude": -122.20742,
    "original_address": "607 Williams Avenue South",
    "building_number": 607,
    "street": "Williams Ave S",
    "city": "Renton",
    "zip": 98057,
    "concatenated_address": "607 Williams Ave S, Renton",
    "address": "607 Williams Ave. S., Renton"
  },
  {
    "id": 911,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Harrington Square",
    "latitude": 47.497906,
    "longitude": -122.18108,
    "original_address": "950 Harrington Avenue Ne",
    "building_number": 950,
    "street": "Harrington Ave NE",
    "city": "Renton",
    "zip": 98056,
    "concatenated_address": "950 Harrington Ave NE, Renton",
    "address": "950 Harrington Ave. N.E., Renton"
  },
  {
    "id": 912,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Bella Vista",
    "latitude": 47.512503,
    "longitude": -122.20264,
    "original_address": "2100 Lake Washington Blvd",
    "building_number": 2100,
    "street": "Lake Washington Blvd N",
    "city": "Renton",
    "zip": 98056,
    "concatenated_address": "2100 Lake Washington Blvd N, Renton",
    "address": "2100 Lake Washington Blvd N., Renton"
  },
  {
    "id": 913,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Woodcliffe Apartments",
    "latitude": 47.469408,
    "longitude": -122.20011,
    "original_address": "1205 Grant Avenue South",
    "building_number": 1205,
    "street": "Grant Ave S",
    "city": "Renton",
    "zip": 98055,
    "concatenated_address": "1205 Grant Ave S, Renton",
    "address": "1205 Grant Ave. S., Renton"
  },
  {
    "id": 914,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Solstice Senior Living At Renton",
    "latitude": 47.505385,
    "longitude": -122.17292,
    "original_address": "1414 Monroe Ave Ne",
    "building_number": 1414,
    "street": "Monroe Ave NE",
    "city": "Renton",
    "zip": 98056,
    "concatenated_address": "1414 Monroe Ave NE, Renton",
    "address": "1414 Monroe Ave. N.E., Renton"
  },
  {
    "id": 915,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Heritage Grove",
    "latitude": 47.500705,
    "longitude": -122.1887,
    "original_address": "1100 Sunset Boulevard Ne",
    "building_number": 1100,
    "street": "Sunset Blvd NE",
    "city": "Renton",
    "zip": 98056,
    "concatenated_address": "1100 Sunset Blvd NE, Renton",
    "address": "1100 Sunset Blvd N.E., Renton"
  },
  {
    "id": 916,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Pebble Cove Apartments",
    "latitude": 47.445494,
    "longitude": -122.16093,
    "original_address": "17600 134th Avenue Se",
    "building_number": 17600,
    "street": "134th Ave SE",
    "city": "Renton",
    "zip": 98058,
    "concatenated_address": "17600 134th Ave SE, Renton",
    "address": "17600 134th Ave. S.E., Renton"
  },
  {
    "id": 917,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Springfield Apartments",
    "latitude": 47.437226,
    "longitude": -122.19599,
    "original_address": "10815 Se 184th Lane",
    "building_number": 10815,
    "street": "SE 184th Ln",
    "city": "Renton",
    "zip": 98055,
    "concatenated_address": "10815 SE 184th Ln, Renton",
    "address": "10815 S.E. 184th Lane, Renton"
  },
  {
    "id": 918,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Heritage Hill Apartment Homes",
    "latitude": 47.462485,
    "longitude": -122.20177,
    "original_address": "1300 South Puget Drive",
    "building_number": 1300,
    "street": "S Puget Dr",
    "city": "Renton",
    "zip": 98055,
    "concatenated_address": "1300 S Puget Dr, Renton",
    "address": "1300 S. Puget Drive, Renton"
  },
  {
    "id": 919,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Avaya Trails Apartments",
    "latitude": 47.449202,
    "longitude": -122.19455,
    "original_address": "10930 Se 172Th Street",
    "building_number": 10930,
    "street": "SE 172nd St",
    "city": "Renton",
    "zip": 98055,
    "concatenated_address": "10930 SE 172nd St, Renton",
    "address": "10930 S.E. 172nd St., Renton"
  },
  {
    "id": 920,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "The Carriages At Fairwood Downs Apartment Homes",
    "latitude": 47.442968,
    "longitude": -122.13984,
    "original_address": "15030 Se 179th Street",
    "building_number": 15030,
    "street": "SE 179th St",
    "city": "Renton",
    "zip": 98058,
    "concatenated_address": "15030 SE 179th St, Renton",
    "address": "15030 S.E. 179th St., Renton"
  },
  {
    "id": 921,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Lexington Heights",
    "latitude": 47.486347,
    "longitude": -122.18883,
    "original_address": "300 Vuemont Place Ne",
    "building_number": 300,
    "street": "Vuemont Pl NE",
    "city": "Renton",
    "zip": 98056,
    "concatenated_address": "300 Vuemont Pl NE, Renton",
    "address": "300 Vuemont Pl N.E., Renton"
  },
  {
    "id": 922,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Regency Woods Apartment Homes",
    "latitude": 47.465653,
    "longitude": -122.20343,
    "original_address": "1650 Eagle Ridge Drive South",
    "building_number": 1650,
    "street": "Eagle Ridge Dr S",
    "city": "Renton",
    "zip": 98055,
    "concatenated_address": "1650 Eagle Ridge Dr S, Renton",
    "address": "1650 Eagle Ridge Dr S., Renton"
  },
  {
    "id": 923,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Altitude Apartments",
    "latitude": 47.466672,
    "longitude": -122.20535,
    "original_address": "1620 Benson Road South",
    "building_number": 1620,
    "street": "Benson Rd S",
    "city": "Renton",
    "zip": 98055,
    "concatenated_address": "1620 Benson Rd S, Renton",
    "address": "1620 Benson Road S., Renton"
  },
  {
    "id": 924,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Benson Downs",
    "latitude": 47.446244,
    "longitude": -122.19051,
    "original_address": "11100 Se Petrovitsky Road",
    "building_number": 11100,
    "street": "SE Petrovitsky Rd",
    "city": "Renton",
    "zip": 98055,
    "concatenated_address": "11100 SE Petrovitsky Rd, Renton",
    "address": "11100 S.E. Petrovitsky Road, Renton"
  },
  {
    "id": 925,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Heritage Grove",
    "latitude": 47.500705,
    "longitude": -122.1887,
    "original_address": "1100 Sunset Bouleveard Ne",
    "building_number": 1100,
    "street": "Sunset Blvd NE",
    "city": "Renton",
    "zip": 98056,
    "concatenated_address": "1100 Sunset Blvd NE, Renton",
    "address": "1100 Sunset Blvd N.E., Renton"
  },
  {
    "id": 926,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Sunset View Apartments",
    "latitude": 47.480705,
    "longitude": -122.24286,
    "original_address": "2101 Sw Sunset Boulevard",
    "building_number": 2101,
    "street": "SW Sunset Blvd",
    "city": "Renton",
    "zip": 98057,
    "concatenated_address": "2101 SW Sunset Blvd, Renton",
    "address": "2101 S.W. Sunset Blvd., Renton"
  },
  {
    "id": 927,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "The Berkshire",
    "latitude": 47.470036,
    "longitude": -122.2034,
    "original_address": "1300 Eagle Ridge Drive South",
    "building_number": 1300,
    "street": "Eagle Ridge Dr S",
    "city": "Renton",
    "zip": 98055,
    "concatenated_address": "1300 Eagle Ridge Dr S, Renton",
    "address": "1300 Eagle Ridge Dr S., Renton"
  },
  {
    "id": 928,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "The Reserve Apartments",
    "latitude": 47.499412,
    "longitude": -122.20178,
    "original_address": "1202 North 10th Place",
    "building_number": 1202,
    "street": "N 10th Pl",
    "city": "Renton",
    "zip": 98057,
    "concatenated_address": "1202 N 10th Pl, Renton",
    "address": "1202 N. 10th Place, Renton"
  },
  {
    "id": 929,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Sanctuary Apartments",
    "latitude": 47.498798,
    "longitude": -122.20055,
    "original_address": "1205 North 10th Place",
    "building_number": 1205,
    "street": "N 10th Pl",
    "city": "Renton",
    "zip": 98057,
    "concatenated_address": "1205 N 10th Pl, Renton",
    "address": "1205 N. 10th Place, Renton"
  },
  {
    "id": 930,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Fairwood Landing Apartments",
    "latitude": 47.443604,
    "longitude": -122.15175,
    "original_address": "14121 Se 177th Street",
    "building_number": 14121,
    "street": "SE 177th St",
    "city": "Renton",
    "zip": 98058,
    "concatenated_address": "14121 SE 177th St, Renton",
    "address": "14121 S.E. 177th St., Renton"
  },
  {
    "id": 931,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Aviator Apartments",
    "latitude": 47.447136,
    "longitude": -122.20129,
    "original_address": "10406 Se 174th Street",
    "building_number": 10406,
    "street": "SE 174th St",
    "city": "Renton",
    "zip": 98055,
    "concatenated_address": "10406 SE 174th St, Renton",
    "address": "10406 S.E. 174th St., Renton"
  },
  {
    "id": 932,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "95 Burnett",
    "latitude": 47.482938,
    "longitude": -122.2081,
    "original_address": "95 Burnett Avenue South",
    "building_number": 95,
    "street": "Burnett Ave S",
    "city": "Renton",
    "zip": 98055,
    "concatenated_address": "95 Burnett Ave S, Renton",
    "address": "95 Burnett Ave. S., Renton"
  },
  {
    "id": 933,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Grammercy Apartment Homes",
    "latitude": 47.446567,
    "longitude": -122.18185,
    "original_address": "17425 120th Lane Southeast",
    "building_number": 17425,
    "street": "120th Ln SE",
    "city": "Renton",
    "zip": 98058,
    "concatenated_address": "17425 120th Ln SE, Renton",
    "address": "17425 120th Lane S.E., Renton"
  },
  {
    "id": 934,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Gateway Pointe",
    "latitude": 47.459529,
    "longitude": -122.19281,
    "original_address": "1455 South Puget Drive",
    "building_number": 1455,
    "street": "S Puget Dr",
    "city": "Renton",
    "zip": 98055,
    "concatenated_address": "1455 S Puget Dr, Renton",
    "address": "1455 S. Puget Drive, Renton"
  },
  {
    "id": 935,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Maplewood Park Apartments",
    "latitude": 47.486299,
    "longitude": -122.16775,
    "original_address": "3815 Northeast 4th Street",
    "building_number": 3815,
    "street": "NE 4th St",
    "city": "Renton",
    "zip": 98056,
    "concatenated_address": "3815 NE 4th St, Renton",
    "address": "3815 N.E. 4th St., Renton"
  },
  {
    "id": 936,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Borgata Apartments And Townhomes",
    "latitude": 47.435094,
    "longitude": -122.21257,
    "original_address": "400 South 50th Street",
    "building_number": 400,
    "street": "S 50th St",
    "city": "Renton",
    "zip": 98055,
    "concatenated_address": "400 S 50th St, Renton",
    "address": "400 S. 50th St., Renton"
  },
  {
    "id": 937,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Chateau De Ville",
    "latitude": 47.482412,
    "longitude": -122.20626,
    "original_address": "110 Williams Avenue South",
    "building_number": 110,
    "street": "Williams Ave S",
    "city": "Renton",
    "zip": 98057,
    "concatenated_address": "110 Williams Ave S, Renton",
    "address": "110 Williams Ave. S., Renton"
  },
  {
    "id": 938,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Constellation Apartment Homes",
    "latitude": 47.459529,
    "longitude": -122.19281,
    "original_address": "1455 South Puget Drive",
    "building_number": 1455,
    "street": "S Puget Dr",
    "city": "Renton",
    "zip": 98055,
    "concatenated_address": "1455 S Puget Dr, Renton",
    "address": "1455 S. Puget Drive, Renton"
  },
  {
    "id": 939,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "390 and 400 Taylor Avenue Northwest",
    "latitude": 47.47202,
    "longitude": -122.2219,
    "original_address": "390 And 400 Taylor Avenue Northwest",
    "building_number": "",
    "street": "",
    "city": "Renton",
    "zip": 98057,
    "concatenated_address": "390 And 400 Taylor Avenue Northwest, Renton",
    "address": "390 And 400 Taylor Avenue Northwest, Renton"
  },
  {
    "id": 940,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Maplewood Park Apartments",
    "latitude": 47.486299,
    "longitude": -122.16775,
    "original_address": "3815 Ne 4th Street",
    "building_number": 3815,
    "street": "NE 4th St",
    "city": "Renton",
    "zip": 98056,
    "concatenated_address": "3815 NE 4th St, Renton",
    "address": "3815 N.E. 4th St., Renton"
  },
  {
    "id": 941,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Montclair Heights",
    "latitude": 47.459951,
    "longitude": -122.20281,
    "original_address": "2223 Benson Road South",
    "building_number": 2223,
    "street": "Benson Rd S",
    "city": "Renton",
    "zip": 98055,
    "concatenated_address": "2223 Benson Rd S, Renton",
    "address": "2223 Benson Road S., Renton"
  },
  {
    "id": 942,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "The Becket Apartments",
    "latitude": 47.447052,
    "longitude": -122.18065,
    "original_address": "17333 121st Lane Southeast",
    "building_number": 17333,
    "street": "121st Ln SE",
    "city": "Renton",
    "zip": 98058,
    "concatenated_address": "17333 121st Ln SE, Renton",
    "address": "17333 121st Lane S.E., Renton"
  },
  {
    "id": 943,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Alaire Apartment Homes",
    "latitude": 47.475565,
    "longitude": -122.2229,
    "original_address": "510 Stevens Avenue Southwest",
    "building_number": 510,
    "street": "Stevens Ave SW",
    "city": "Renton",
    "zip": 98057,
    "concatenated_address": "510 Stevens Ave SW, Renton",
    "address": "510 Stevens Ave. S.W., Renton"
  },
  {
    "id": 944,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Windsor Apartments",
    "latitude": 47.489891,
    "longitude": -122.15944,
    "original_address": "4415 Northeast 5th Street",
    "building_number": 4415,
    "street": "NE 5th St",
    "city": "Renton",
    "zip": 98059,
    "concatenated_address": "4415 NE 5th St, Renton",
    "address": "4415 N.E. 5th St., Renton"
  },
  {
    "id": 945,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Honey Creek",
    "latitude": 47.503518,
    "longitude": -122.15628,
    "original_address": "1332 Duvall Avenue Northeast",
    "building_number": 1332,
    "street": "Duvall Ave NE",
    "city": "Renton",
    "zip": 98059,
    "concatenated_address": "1332 Duvall Ave NE, Renton",
    "address": "1332 Duvall Ave. N.E., Renton"
  },
  {
    "id": 946,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Dimension Townhomes",
    "latitude": 47.430376,
    "longitude": -122.19642,
    "original_address": "10830 Se 192nd St",
    "building_number": 10830,
    "street": "SE 192nd St",
    "city": "Renton",
    "zip": 98055,
    "concatenated_address": "10830 SE 192nd St, Renton",
    "address": "10830 S.E. 192nd St., Renton"
  },
  {
    "id": 947,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Taylor West Apartments",
    "latitude": 47.489036,
    "longitude": -122.22018,
    "original_address": "401 Taylor Pl Nw",
    "building_number": 401,
    "street": "Taylor Pl NW",
    "city": "Renton",
    "zip": 98057,
    "concatenated_address": "401 Taylor Pl NW, Renton",
    "address": "401 Taylor Pl N.W., Renton"
  },
  {
    "id": 948,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Summerhill Apartments",
    "latitude": 47.445845,
    "longitude": -122.20074,
    "original_address": "-10415 Southeast 174th Street",
    "building_number": 10415,
    "street": "SE 174th St",
    "city": "Renton",
    "zip": 98055,
    "concatenated_address": "10415 SE 174th St, Renton",
    "address": "10415 S.E. 174th St., Renton"
  },
  {
    "id": 949,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Stonebrook Apartments",
    "latitude": 47.445787,
    "longitude": -122.17789,
    "original_address": "12210 Southeast Petrovitsky Rd",
    "building_number": 12210,
    "street": "SE Petrovitsky Rd",
    "city": "Renton",
    "zip": 98058,
    "concatenated_address": "12210 SE Petrovitsky Rd, Renton",
    "address": "12210 S.E. Petrovitsky Road, Renton"
  },
  {
    "id": 950,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Chateau Valley Center",
    "latitude": 47.439383,
    "longitude": -122.21486,
    "original_address": "4450 Davis Ave South",
    "building_number": 4450,
    "street": "Davis Ave S",
    "city": "Renton",
    "zip": 98055,
    "concatenated_address": "4450 Davis Ave S, Renton",
    "address": "4450 Davis Ave. S., Renton"
  },
  {
    "id": 951,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Royal Hills Apartments",
    "latitude": 47.468763,
    "longitude": -122.17657,
    "original_address": "3000 Se Royal Hills Drive",
    "building_number": 3000,
    "street": "SE Royal Hills Dr",
    "city": "Renton",
    "zip": 98058,
    "concatenated_address": "3000 SE Royal Hills Dr, Renton",
    "address": "3000 S.E. Royal Hills Drive, Renton"
  },
  {
    "id": 952,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "La Verde Apartments",
    "latitude": 46.305149,
    "longitude": -119.28852,
    "original_address": "1201A Del Mar Court",
    "building_number": 1201,
    "street": "Del Mar Ct",
    "city": "Richland",
    "zip": 99354,
    "concatenated_address": "1201 Del Mar Ct, Richland",
    "address": "1201 Del Mar Ct, Richland"
  },
  {
    "id": 953,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Northpoint Apartments",
    "latitude": 46.302931,
    "longitude": -119.28383,
    "original_address": "2000 Stevens Dr.",
    "building_number": 2000,
    "street": "Stevens Dr",
    "city": "Richland",
    "zip": 99354,
    "concatenated_address": "2000 Stevens Dr, Richland",
    "address": "2000 Stevens Drive, Richland"
  },
  {
    "id": 954,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Bella Vista Apartments",
    "latitude": 46.225008,
    "longitude": -119.24958,
    "original_address": "2100 Bellerive Drive",
    "building_number": 2100,
    "street": "Bellerive Dr",
    "city": "Richland",
    "zip": 99352,
    "concatenated_address": "2100 Bellerive Dr, Richland",
    "address": "2100 Bellerive Drive, Richland"
  },
  {
    "id": 955,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Brookdale Meadow Springs",
    "latitude": 46.2276,
    "longitude": -119.27008,
    "original_address": "770 Gage Blvd",
    "building_number": 770,
    "street": "Gage Blvd",
    "city": "Richland",
    "zip": 99352,
    "concatenated_address": "770 Gage Blvd, Richland",
    "address": "770 Gage Blvd., Richland"
  },
  {
    "id": 956,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Badger Mountain Ranch",
    "latitude": 46.235212,
    "longitude": -119.28731,
    "original_address": "451 Westcliffe Blvd",
    "building_number": 451,
    "street": "Westcliffe Blvd",
    "city": "Richland",
    "zip": 99352,
    "concatenated_address": "451 Westcliffe Blvd, Richland",
    "address": "451 Westcliffe Blvd., Richland"
  },
  {
    "id": 957,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Arborpointe Apartments",
    "latitude": 46.261559,
    "longitude": -119.27104,
    "original_address": "301 Greentree Ct",
    "building_number": 301,
    "street": "Greentree Ct",
    "city": "Richland",
    "zip": 99352,
    "concatenated_address": "301 Greentree Ct, Richland",
    "address": "301 Greentree Ct, Richland"
  },
  {
    "id": 958,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Maple Ridge Apartments",
    "latitude": 46.260863,
    "longitude": -119.27217,
    "original_address": "50 Jadwin Ave",
    "building_number": 50,
    "street": "Jadwin Ave",
    "city": "Richland",
    "zip": 99352,
    "concatenated_address": "50 Jadwin Ave, Richland",
    "address": "50 Jadwin Ave., Richland"
  },
  {
    "id": 959,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Illahee Apartments",
    "latitude": 46.322567,
    "longitude": -119.27213,
    "original_address": "2500 George Washington Way",
    "building_number": 2500,
    "street": "George Washington Way",
    "city": "Richland",
    "zip": 99354,
    "concatenated_address": "2500 George Washington Way, Richland",
    "address": "2500 George Washington Way, Richland"
  },
  {
    "id": 960,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Cedar North Apartments",
    "latitude": 46.295745,
    "longitude": -119.27535,
    "original_address": "1621 George Washington Way",
    "building_number": 1621,
    "street": "George Washington Way",
    "city": "Richland",
    "zip": 99354,
    "concatenated_address": "1621 George Washington Way, Richland",
    "address": "1621 George Washington Way, Richland"
  },
  {
    "id": 961,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "North Trace Village Apartments",
    "latitude": 46.296796,
    "longitude": -119.27822,
    "original_address": "200 Waldron Street",
    "building_number": 200,
    "street": "Waldron St",
    "city": "Richland",
    "zip": 99354,
    "concatenated_address": "200 Waldron St, Richland",
    "address": "200 Waldron St., Richland"
  },
  {
    "id": 962,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Washington Square II Apartments",
    "latitude": 46.319173,
    "longitude": -119.27424,
    "original_address": "2433 George Washington Way",
    "building_number": 2433,
    "street": "George Washington Way",
    "city": "Richland",
    "zip": 99354,
    "concatenated_address": "2433 George Washington Way, Richland",
    "address": "2433 George Washington Way, Richland"
  },
  {
    "id": 963,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "575 Columbia",
    "latitude": 46.262344,
    "longitude": -119.25163,
    "original_address": "575 Columbia Point Drive",
    "building_number": 575,
    "street": "Columbia Point Dr",
    "city": "Richland",
    "zip": 99352,
    "concatenated_address": "575 Columbia Point Dr, Richland",
    "address": "575 Columbia Point Drive, Richland"
  },
  {
    "id": 964,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Island View Apartments",
    "latitude": 46.23664,
    "longitude": -119.22822,
    "original_address": "1529 Columbia Park Trail",
    "building_number": 1529,
    "street": "Columbia Park Trl",
    "city": "Richland",
    "zip": 99352,
    "concatenated_address": "1529 Columbia Park Trl, Richland",
    "address": "1529 Columbia Park Trl, Richland"
  },
  {
    "id": 965,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "The Lofts At Innovation Center",
    "latitude": 46.33512,
    "longitude": -119.27613,
    "original_address": "2895 Pauling Avenue",
    "building_number": 2895,
    "street": "Pauling Ave",
    "city": "Richland",
    "zip": 99354,
    "concatenated_address": "2895 Pauling Ave, Richland",
    "address": "2895 Pauling Ave., Richland"
  },
  {
    "id": 966,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Tapteal Apartments",
    "latitude": 46.237113,
    "longitude": -119.22027,
    "original_address": "1775 Columbia Park Trail",
    "building_number": 1775,
    "street": "Columbia Park Trl",
    "city": "Richland",
    "zip": 99352,
    "concatenated_address": "1775 Columbia Park Trl, Richland",
    "address": "1775 Columbia Park Trl, Richland"
  },
  {
    "id": 967,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Orchard Hills Apartments",
    "latitude": 46.226057,
    "longitude": -119.26536,
    "original_address": "1845 Leslie Road",
    "building_number": 1845,
    "street": "Leslie Rd",
    "city": "Richland",
    "zip": 99352,
    "concatenated_address": "1845 Leslie Rd, Richland",
    "address": "1845 Leslie Road, Richland"
  },
  {
    "id": 968,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Villas At Meadow Springs Apartments",
    "latitude": 46.227501,
    "longitude": -119.25796,
    "original_address": "250 Gage Boulevard",
    "building_number": 250,
    "street": "Gage Blvd",
    "city": "Richland",
    "zip": 99352,
    "concatenated_address": "250 Gage Blvd, Richland",
    "address": "250 Gage Blvd., Richland"
  },
  {
    "id": 969,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "The Commons At Innovation Center",
    "latitude": 46.335728,
    "longitude": -119.27807,
    "original_address": "2894 Salk Avenue",
    "building_number": 2894,
    "street": "Salk Ave",
    "city": "Richland",
    "zip": 99354,
    "concatenated_address": "2894 Salk Ave, Richland",
    "address": "2894 Salk Ave., Richland"
  },
  {
    "id": 970,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Regency Park Apartments At Queensgate",
    "latitude": 46.258605,
    "longitude": -119.31568,
    "original_address": "3003 Queensgate Drive",
    "building_number": 3003,
    "street": "Queensgate Dr",
    "city": "Richland",
    "zip": 99352,
    "concatenated_address": "3003 Queensgate Dr, Richland",
    "address": "3003 Queensgate Drive, Richland"
  },
  {
    "id": 971,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Villas At Meadow Springs",
    "latitude": 46.227501,
    "longitude": -119.25796,
    "original_address": "250 Gage Blvd",
    "building_number": 250,
    "street": "Gage Blvd",
    "city": "Richland",
    "zip": 99352,
    "concatenated_address": "250 Gage Blvd, Richland",
    "address": "250 Gage Blvd., Richland"
  },
  {
    "id": 972,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Riverpointe Apartments",
    "latitude": 46.267341,
    "longitude": -119.30397,
    "original_address": "2550 Duportail Street",
    "building_number": 2550,
    "street": "Duportail St",
    "city": "Richland",
    "zip": 99352,
    "concatenated_address": "2550 Duportail St, Richland",
    "address": "2550 Duportail St., Richland"
  },
  {
    "id": 973,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Washington Square One",
    "latitude": 46.320212,
    "longitude": -119.27525,
    "original_address": "2455 George Washington Way",
    "building_number": 2455,
    "street": "George Washington Way",
    "city": "Richland",
    "zip": 99352,
    "concatenated_address": "2455 George Washington Way, Richland",
    "address": "2455 George Washington Way, Richland"
  },
  {
    "id": 974,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Jadwin Stevens Apartments",
    "latitude": 46.299336,
    "longitude": -119.28273,
    "original_address": "1851 Jadwin Avenue",
    "building_number": 1851,
    "street": "Jadwin Ave",
    "city": "Richland",
    "zip": 99352,
    "concatenated_address": "1851 Jadwin Ave, Richland",
    "address": "1851 Jadwin Ave., Richland"
  },
  {
    "id": 975,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Riverton Assisted Living",
    "latitude": 46.228405,
    "longitude": -119.24945,
    "original_address": "1800 Bellerive Dr. Way",
    "building_number": 1800,
    "street": "Bellerive Dr",
    "city": "Richland",
    "zip": 99352,
    "concatenated_address": "1800 Bellerive Dr, Richland",
    "address": "1800 Bellerive Drive, Richland"
  },
  {
    "id": 976,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Guardian Angel Homes Richland",
    "latitude": 46.293718,
    "longitude": -119.27777,
    "original_address": "245 Van Giesen Street",
    "building_number": 245,
    "street": "Van Giesen St",
    "city": "Richland",
    "zip": 99352,
    "concatenated_address": "245 Van Giesen St, Richland",
    "address": "245 Van Giesen St., Richland"
  },
  {
    "id": 977,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "River Trails Apartments",
    "latitude": 46.269888,
    "longitude": -119.30006,
    "original_address": "Duportail Road",
    "building_number": "",
    "street": "Duportail St",
    "city": "Richland",
    "zip": 99352,
    "concatenated_address": "Duportail Road, Richland",
    "address": "Duportail Road, Richland"
  },
  {
    "id": 978,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Park Place Apartments",
    "latitude": 46.273723,
    "longitude": -119.27293,
    "original_address": "650 George Washington Way",
    "building_number": 650,
    "street": "George Washington Way",
    "city": "Richland",
    "zip": 99352,
    "concatenated_address": "650 George Washington Way, Richland",
    "address": "650 George Washington Way, Richland"
  },
  {
    "id": 979,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Columbia Park",
    "latitude": 46.296469,
    "longitude": -119.28043,
    "original_address": "1682 Jadwin Avenue",
    "building_number": 1682,
    "street": "Jadwin Ave",
    "city": "Richland",
    "zip": 99354,
    "concatenated_address": "1682 Jadwin Ave, Richland",
    "address": "1682 Jadwin Ave., Richland"
  },
  {
    "id": 980,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Luther Senior Center",
    "latitude": 46.302912,
    "longitude": -119.28102,
    "original_address": "625 Berkshire Place",
    "building_number": 625,
    "street": "Berkshire Pl",
    "city": "Richland",
    "zip": 99354,
    "concatenated_address": "625 Berkshire Pl, Richland",
    "address": "625 Berkshire Place, Richland"
  },
  {
    "id": 981,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Pioneer Vista",
    "latitude": 45.740573,
    "longitude": -122.6565,
    "original_address": "16501 Ne 15th Avenue",
    "building_number": 16501,
    "street": "NE 15th Ave",
    "city": "Ridgefield",
    "zip": 98642,
    "concatenated_address": "16501 NE 15th Ave, Ridgefield",
    "address": "16501 N.E. 15th Ave., Ridgefield"
  },
  {
    "id": 982,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Whipple Creek",
    "latitude": 45.749781,
    "longitude": -122.6493,
    "original_address": "2019 Northeast 179th Street",
    "building_number": 2019,
    "street": "NE 179th St",
    "city": "Ridgefield",
    "zip": 98642,
    "concatenated_address": "2019 NE 179th St, Ridgefield",
    "address": "2019 N.E. 179th St., Ridgefield"
  },
  {
    "id": 983,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Rose Garden Estates Assisted Living",
    "latitude": 47.12792,
    "longitude": -118.37065,
    "original_address": "406 South Cascade",
    "building_number": 406,
    "street": "S Cascade St",
    "city": "Ritzville",
    "zip": 99169,
    "concatenated_address": "406 S Cascade St, Ritzville",
    "address": "406 S. Cascade St., Ritzville"
  },
  {
    "id": 984,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Tanglewood MHC",
    "latitude": 46.819503,
    "longitude": -123.10476,
    "original_address": "10239 185th Avenue Southwest",
    "building_number": 10239,
    "street": "185th Ave SW",
    "city": "Rochester",
    "zip": 98579,
    "concatenated_address": "10239 185th Ave SW, Rochester",
    "address": "10239 185th Ave. S.W., Rochester"
  },
  {
    "id": 985,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Knolls At Inglewood Hill",
    "latitude": 47.617615,
    "longitude": -122.0383,
    "original_address": "22626 Ne Inglewood Hill Road",
    "building_number": 22626,
    "street": "NE Inglewood Hill Rd",
    "city": "Sammamish",
    "zip": 98074,
    "concatenated_address": "22626 NE Inglewood Hill Rd, Sammamish",
    "address": "22626 N.E. Inglewood Hill Road, Sammamish"
  },
  {
    "id": 986,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Four Seasons Apartments",
    "latitude": 47.44454,
    "longitude": -122.28934,
    "original_address": "3251 South 176th Street",
    "building_number": 3251,
    "street": "S 176th St",
    "city": "Seattle",
    "zip": 98188,
    "concatenated_address": "3251 S 176th St, Seattle",
    "address": "3251 S. 176th St., Seattle"
  },
  {
    "id": 987,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Brookstone Apartments",
    "latitude": 47.41888,
    "longitude": -122.29095,
    "original_address": "3231 South 204th Street",
    "building_number": 3231,
    "street": "S 204th St",
    "city": "Seattle",
    "zip": 98198,
    "concatenated_address": "3231 S 204th St, Seattle",
    "address": "3231 S. 204th St., Seattle"
  },
  {
    "id": 988,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Bow Lake",
    "latitude": 47.440848,
    "longitude": -122.29146,
    "original_address": "18050 32nd Ave S",
    "building_number": 18050,
    "street": "32nd Ave S",
    "city": "Seattle",
    "zip": 98188,
    "concatenated_address": "18050 32nd Ave S, Seattle",
    "address": "18050 32nd Ave. S., Seattle"
  },
  {
    "id": 989,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "The Hanover Apartment Homes",
    "latitude": 47.430566,
    "longitude": -122.29332,
    "original_address": "3117 South 192nd Street",
    "building_number": 3117,
    "street": "S 192nd St",
    "city": "Seattle",
    "zip": 98188,
    "concatenated_address": "3117 S 192nd St, Seattle",
    "address": "3117 S. 192nd St., Seattle"
  },
  {
    "id": 990,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Belvedere Apartment Homes",
    "latitude": 47.415948,
    "longitude": -122.28572,
    "original_address": "20998 37th Place South",
    "building_number": 20998,
    "street": "37th Pl S",
    "city": "Seattle",
    "zip": 98198,
    "concatenated_address": "20998 37th Pl S, Seattle",
    "address": "20998 37th Pl S., Seattle"
  },
  {
    "id": 991,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Emerald Place By The Lake",
    "latitude": 47.430566,
    "longitude": -122.29332,
    "original_address": "3117 South 192nd Street",
    "building_number": 3117,
    "street": "S 192nd St",
    "city": "Seattle",
    "zip": 98188,
    "concatenated_address": "3117 S 192nd St, Seattle",
    "address": "3117 S. 192nd St., Seattle"
  },
  {
    "id": 992,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Avion Apartments",
    "latitude": 47.445991,
    "longitude": -122.29005,
    "original_address": "3351 South 175th Street",
    "building_number": 3351,
    "street": "S 175th St",
    "city": "Seattle",
    "zip": 98188,
    "concatenated_address": "3351 S 175th St, Seattle",
    "address": "3351 S. 175th St., Seattle"
  },
  {
    "id": 993,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Landing At Angle Lake",
    "latitude": 47.424995,
    "longitude": -122.29635,
    "original_address": "19800 Pacific Highway South",
    "building_number": 19800,
    "street": "Pacific Hwy S",
    "city": "Seattle",
    "zip": 98188,
    "concatenated_address": "19800 Pacific Hwy S, Seattle",
    "address": "19800 Pacific Highway S., Seattle"
  },
  {
    "id": 994,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Sandpiper Apartments",
    "latitude": 47.41622,
    "longitude": -122.29268,
    "original_address": "3100 S 208th Street",
    "building_number": 3100,
    "street": "S 208th St",
    "city": "Seattle",
    "zip": 98198,
    "concatenated_address": "3100 S 208th St, Seattle",
    "address": "3100 S. 208th St., Seattle"
  },
  {
    "id": 995,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Des Moines Vista",
    "latitude": 47.391324,
    "longitude": -122.31498,
    "original_address": "21202 Jpacific Hwy South",
    "building_number": "",
    "street": "",
    "city": "Seattle",
    "zip": 98198,
    "concatenated_address": "21202 Jpacific Hwy South, Seattle",
    "address": "21202 Jpacific Highway S., Seattle"
  },
  {
    "id": 996,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "2718 and 2720 14th Ave South",
    "latitude": 47.578993,
    "longitude": -122.31427,
    "original_address": "2718 -20 14th Ave S",
    "building_number": 2718,
    "street": "14th Ave S",
    "city": "Seattle",
    "zip": 98144,
    "concatenated_address": "2718 14th Ave S, Seattle",
    "address": "2718 14th Ave. S., Seattle"
  },
  {
    "id": 997,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "6619 Roosevelt Way Northeast",
    "latitude": 47.6771,
    "longitude": -122.31765,
    "original_address": "6619 Roosevelt Way Ne",
    "building_number": 6619,
    "street": "Roosevelt Way NE",
    "city": "Seattle",
    "zip": 98115,
    "concatenated_address": "6619 Roosevelt Way NE, Seattle",
    "address": "6619 Roosevelt Way N.E., Seattle"
  },
  {
    "id": 998,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "931 Holden Street Southwest",
    "latitude": 47.533845,
    "longitude": -122.34899,
    "original_address": "931 Holden Street Sw",
    "building_number": 931,
    "street": "SW Holden St",
    "city": "Seattle",
    "zip": 98106,
    "concatenated_address": "931 SW Holden St, Seattle",
    "address": "931 S.W. Holden St., Seattle"
  },
  {
    "id": 999,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "1405 East John Street",
    "latitude": 47.619797,
    "longitude": -122.31413,
    "original_address": "1405 East John St.",
    "building_number": 1405,
    "street": "E John St",
    "city": "Seattle",
    "zip": 98112,
    "concatenated_address": "1405 E John St, Seattle",
    "address": "1405 E. John St., Seattle"
  },
  {
    "id": 1000,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "2440 54th Place Southwest",
    "latitude": 47.581841,
    "longitude": -122.40131,
    "original_address": "2440 54th Pl. Sw",
    "building_number": 2440,
    "street": "54th Pl SW",
    "city": "Seattle",
    "zip": 98116,
    "concatenated_address": "2440 54th Pl SW, Seattle",
    "address": "2440 54th Pl S.W., Seattle"
  },
  {
    "id": 1001,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "1205 Spring Street",
    "latitude": 47.610485,
    "longitude": -122.32419,
    "original_address": "1205 Spring St.",
    "building_number": 1205,
    "street": "Spring St",
    "city": "Seattle",
    "zip": 98104,
    "concatenated_address": "1205 Spring St, Seattle",
    "address": "1205 Spring St., Seattle"
  },
  {
    "id": 1002,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "9711 Greenwood Avenue North",
    "latitude": 47.700023,
    "longitude": -122.35569,
    "original_address": "9711 Greenwood Avenue N.",
    "building_number": 9711,
    "street": "Greenwood Ave N",
    "city": "Seattle",
    "zip": 98103,
    "concatenated_address": "9711 Greenwood Ave N, Seattle",
    "address": "9711 Greenwood Ave. N., Seattle"
  },
  {
    "id": 1003,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "2203 California Ave Southwest",
    "latitude": 47.583832,
    "longitude": -122.38681,
    "original_address": "2203 California Ave Sw",
    "building_number": 2203,
    "street": "California Ave SW",
    "city": "Seattle",
    "zip": 98116,
    "concatenated_address": "2203 California Ave SW, Seattle",
    "address": "2203 California Ave. S.W., Seattle"
  },
  {
    "id": 1004,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "409 West Mercer Street",
    "latitude": 47.624454,
    "longitude": -122.36228,
    "original_address": "409 W Mercer St",
    "building_number": 409,
    "street": "W Mercer St",
    "city": "Seattle",
    "zip": 98119,
    "concatenated_address": "409 W Mercer St, Seattle",
    "address": "409 W. Mercer St., Seattle"
  },
  {
    "id": 1005,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "5201 42nd Street South",
    "latitude": 47.658565,
    "longitude": -122.27191,
    "original_address": "5201 42nd Street S",
    "building_number": 5201,
    "street": "NE 42nd St",
    "city": "Seattle",
    "zip": 98105,
    "concatenated_address": "5201 NE 42nd St, Seattle",
    "address": "5201 N.E. 42nd St., Seattle"
  },
  {
    "id": 1006,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "320 West Republican Street",
    "latitude": 47.623451,
    "longitude": -122.36161,
    "original_address": "320 W Republican St.",
    "building_number": 320,
    "street": "W Republican St",
    "city": "Seattle",
    "zip": 98119,
    "concatenated_address": "320 W Republican St, Seattle",
    "address": "320 W. Republican St., Seattle"
  },
  {
    "id": 1007,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "323 West Republican Street",
    "latitude": 47.623067,
    "longitude": -122.36173,
    "original_address": "323 W Republican St.",
    "building_number": 323,
    "street": "W Republican St",
    "city": "Seattle",
    "zip": 98119,
    "concatenated_address": "323 W Republican St, Seattle",
    "address": "323 W. Republican St., Seattle"
  },
  {
    "id": 1008,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "12520 Greenwood Avenue North",
    "latitude": 47.720178,
    "longitude": -122.35509,
    "original_address": "12520 Greenwood Avenue N.",
    "building_number": 12520,
    "street": "Greenwood Ave N",
    "city": "Seattle",
    "zip": 98133,
    "concatenated_address": "12520 Greenwood Ave N, Seattle",
    "address": "12520 Greenwood Ave. N., Seattle"
  },
  {
    "id": 1009,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Crown Vista Apartments",
    "latitude": 47.699078,
    "longitude": -122.36834,
    "original_address": "9542 9th Av Nw",
    "building_number": 9542,
    "street": "9th Ave NW",
    "city": "Seattle",
    "zip": 98117,
    "concatenated_address": "9542 9th Ave NW, Seattle",
    "address": "9542 9th Ave. N.W., Seattle"
  },
  {
    "id": 1010,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Ripple Rock Apartments",
    "latitude": 47.579102,
    "longitude": -122.41004,
    "original_address": "2710 28 61st Av Sw",
    "building_number": 2710,
    "street": "61st Ave SW",
    "city": "Seattle",
    "zip": 98116,
    "concatenated_address": "2710 61st Ave SW, Seattle",
    "address": "2710 61st Ave. S.W., Seattle"
  },
  {
    "id": 1011,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "301 26th Avenue South",
    "latitude": 47.600196,
    "longitude": -122.29891,
    "original_address": "301 26th Avenue S",
    "building_number": 301,
    "street": "26th Ave S",
    "city": "Seattle",
    "zip": 98144,
    "concatenated_address": "301 26th Ave S, Seattle",
    "address": "301 26th Ave. S., Seattle"
  },
  {
    "id": 1012,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "526 & 532 14th Avenue East",
    "latitude": 47.611046,
    "longitude": -122.29321,
    "original_address": "526 & 532 14th Avenue E.",
    "building_number": "",
    "street": "",
    "city": "Seattle",
    "zip": 98122,
    "concatenated_address": "526 & 532 14th Avenue E., Seattle",
    "address": "526 & 532 14th Avenue E., Seattle"
  },
  {
    "id": 1013,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "1052 East Thomas Street",
    "latitude": 47.621246,
    "longitude": -122.31862,
    "original_address": "1052 East Thomas St",
    "building_number": 1052,
    "street": "E Thomas St",
    "city": "Seattle",
    "zip": 98102,
    "concatenated_address": "1052 E Thomas St, Seattle",
    "address": "1052 E. Thomas St., Seattle"
  },
  {
    "id": 1014,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "600 9th Avenue",
    "latitude": 47.605828,
    "longitude": -122.32469,
    "original_address": "600 9th Avenue",
    "building_number": 600,
    "street": "9th Ave",
    "city": "Seattle",
    "zip": 98104,
    "concatenated_address": "600 9th Ave, Seattle",
    "address": "600 9th Ave., Seattle"
  },
  {
    "id": 1015,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "8724 Mary Avenue Northwest",
    "latitude": 47.69323,
    "longitude": -122.37505,
    "original_address": "8724 Mary Av Nw",
    "building_number": 8724,
    "street": "Mary Ave NW",
    "city": "Seattle",
    "zip": 98117,
    "concatenated_address": "8724 Mary Ave NW, Seattle",
    "address": "8724 Mary Ave. N.W., Seattle"
  },
  {
    "id": 1016,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Baldwin Apartments",
    "latitude": 47.671876,
    "longitude": -122.3888,
    "original_address": "2424 Nw 59th St",
    "building_number": 2424,
    "street": "NW 59th St",
    "city": "Seattle",
    "zip": 98107,
    "concatenated_address": "2424 NW 59th St, Seattle",
    "address": "2424 N.W. 59th St., Seattle"
  },
  {
    "id": 1017,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Cornerstone Apartments",
    "latitude": 47.695109,
    "longitude": -122.34216,
    "original_address": "1158N 91st St",
    "building_number": 1158,
    "street": "N 91st St",
    "city": "Seattle",
    "zip": 98103,
    "concatenated_address": "1158 N 91st St, Seattle",
    "address": "1158 N. 91st St., Seattle"
  },
  {
    "id": 1018,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "4225 11th Avenue Northeast",
    "latitude": 47.659047,
    "longitude": -122.31697,
    "original_address": "4225 11th Avenue Northeast",
    "building_number": 4225,
    "street": "11th Ave NE",
    "city": "Seattle",
    "zip": 98105,
    "concatenated_address": "4225 11th Ave NE, Seattle",
    "address": "4225 11th Ave. N.E., Seattle"
  },
  {
    "id": 1019,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Fairway Apartments",
    "latitude": 47.562842,
    "longitude": -122.37635,
    "original_address": "4503 35th Avenue Sw",
    "building_number": 4503,
    "street": "35th Ave SW",
    "city": "Seattle",
    "zip": 98126,
    "concatenated_address": "4503 35th Ave SW, Seattle",
    "address": "4503 35th Ave. S.W., Seattle"
  },
  {
    "id": 1020,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Graham Terry Apartments",
    "latitude": 47.617747,
    "longitude": -122.33551,
    "original_address": "2020 Terry Avenue",
    "building_number": 2020,
    "street": "Terry Ave",
    "city": "Seattle",
    "zip": 98121,
    "concatenated_address": "2020 Terry Ave, Seattle",
    "address": "2020 Terry Ave., Seattle"
  },
  {
    "id": 1021,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Vine Court Apartments",
    "latitude": 47.615138,
    "longitude": -122.34917,
    "original_address": "2512 1st Avenue",
    "building_number": 2512,
    "street": "1st Ave",
    "city": "Seattle",
    "zip": 98121,
    "concatenated_address": "2512 1st Ave, Seattle",
    "address": "2512 1st Ave., Seattle"
  },
  {
    "id": 1022,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Seacliff Manor Apartments",
    "latitude": 47.580269,
    "longitude": -122.40714,
    "original_address": "2600 Alki Avenue Sw",
    "building_number": 2600,
    "street": "Alki Ave SW",
    "city": "Seattle",
    "zip": 98116,
    "concatenated_address": "2600 Alki Ave SW, Seattle",
    "address": "2600 Alki Ave. S.W., Seattle"
  },
  {
    "id": 1023,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Quintessa Apartments",
    "latitude": 47.601605,
    "longitude": -122.33134,
    "original_address": "201 Yesler Way",
    "building_number": 201,
    "street": "Yesler Way",
    "city": "Seattle",
    "zip": 98104,
    "concatenated_address": "201 Yesler Way, Seattle",
    "address": "201 Yesler Way, Seattle"
  },
  {
    "id": 1024,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Stanford Apartments",
    "latitude": 47.658518,
    "longitude": -122.31401,
    "original_address": "1304 Ne 42nd Street",
    "building_number": 1304,
    "street": "NE 42nd St",
    "city": "Seattle",
    "zip": 98105,
    "concatenated_address": "1304 NE 42nd St, Seattle",
    "address": "1304 N.E. 42nd St., Seattle"
  },
  {
    "id": 1025,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "The View 222 Apartments",
    "latitude": 47.620441,
    "longitude": -122.3565,
    "original_address": "222 Queen Anne Avenue North",
    "building_number": 222,
    "street": "Queen Anne Ave N",
    "city": "Seattle",
    "zip": 98109,
    "concatenated_address": "222 Queen Anne Ave N, Seattle",
    "address": "222 Queen Anne Ave. N., Seattle"
  },
  {
    "id": 1026,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Hunt Club Apartments",
    "latitude": 47.441882,
    "longitude": -122.28618,
    "original_address": "3726 S. 180th Street",
    "building_number": 3726,
    "street": "S 180th St",
    "city": "Seattle",
    "zip": 98188,
    "concatenated_address": "3726 S 180th St, Seattle",
    "address": "3726 S. 180th St., Seattle"
  },
  {
    "id": 1027,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Greenlake Pointe Apartments",
    "latitude": 47.687037,
    "longitude": -122.34006,
    "original_address": "1400 North 80th Street",
    "building_number": 1400,
    "street": "N 80th St",
    "city": "Seattle",
    "zip": 98103,
    "concatenated_address": "1400 N 80th St, Seattle",
    "address": "1400 N. 80th St., Seattle"
  },
  {
    "id": 1028,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Kam Lo Apartments",
    "latitude": 47.620287,
    "longitude": -122.32582,
    "original_address": "221 Summit Avenue East",
    "building_number": 221,
    "street": "Summit Ave E",
    "city": "Seattle",
    "zip": 98102,
    "concatenated_address": "221 Summit Ave E, Seattle",
    "address": "221 Summit Ave. E., Seattle"
  },
  {
    "id": 1029,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Park Hill Apartments",
    "latitude": 47.489754,
    "longitude": -122.24835,
    "original_address": "12511 69th Avenue South",
    "building_number": 12511,
    "street": "69th Ave S",
    "city": "Seattle",
    "zip": 98178,
    "concatenated_address": "12511 69th Ave S, Seattle",
    "address": "12511 69th Ave. S., Seattle"
  },
  {
    "id": 1030,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Chancery Place Apartments",
    "latitude": 47.608033,
    "longitude": -122.32638,
    "original_address": "910 Marion Street",
    "building_number": 910,
    "street": "Marion St",
    "city": "Seattle",
    "zip": 98104,
    "concatenated_address": "910 Marion St, Seattle",
    "address": "910 Marion St., Seattle"
  },
  {
    "id": 1031,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Versailles Apartments",
    "latitude": 47.617927,
    "longitude": -122.35484,
    "original_address": "3023 1st Avenue",
    "building_number": 3023,
    "street": "1st Ave",
    "city": "Seattle",
    "zip": 98121,
    "concatenated_address": "3023 1st Ave, Seattle",
    "address": "3023 1st Ave., Seattle"
  },
  {
    "id": 1032,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Corona Lofts",
    "latitude": 47.602733,
    "longitude": -122.33243,
    "original_address": "606 2nd Ave.",
    "building_number": 606,
    "street": "2nd Ave",
    "city": "Seattle",
    "zip": 98104,
    "concatenated_address": "606 2nd Ave, Seattle",
    "address": "606 2nd Ave., Seattle"
  },
  {
    "id": 1033,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Northbrook Place",
    "latitude": 47.702592,
    "longitude": -122.30222,
    "original_address": "10215 Lake City Way Ne",
    "building_number": 10215,
    "street": "Lake City Way NE",
    "city": "Seattle",
    "zip": 98125,
    "concatenated_address": "10215 Lake City Way NE, Seattle",
    "address": "10215 Lake City Way N.E., Seattle"
  },
  {
    "id": 1034,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "The Shelby Apartments",
    "latitude": 47.614608,
    "longitude": -122.34325,
    "original_address": "2201 4th Avenue",
    "building_number": 2201,
    "street": "4th Ave",
    "city": "Seattle",
    "zip": 98121,
    "concatenated_address": "2201 4th Ave, Seattle",
    "address": "2201 4th Ave., Seattle"
  },
  {
    "id": 1035,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Tower 801 Apartments",
    "latitude": 47.612974,
    "longitude": -122.33263,
    "original_address": "801 Pine Street",
    "building_number": 801,
    "street": "Pine St",
    "city": "Seattle",
    "zip": 98101,
    "concatenated_address": "801 Pine St, Seattle",
    "address": "801 Pine St., Seattle"
  },
  {
    "id": 1036,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Sandridge Apartments",
    "latitude": 47.673834,
    "longitude": -122.26513,
    "original_address": "6200 Sand Point Way Ne",
    "building_number": 6200,
    "street": "Sand Point Way NE",
    "city": "Seattle",
    "zip": 98115,
    "concatenated_address": "6200 Sand Point Way NE, Seattle",
    "address": "6200 Sand Point Way N.E., Seattle"
  },
  {
    "id": 1037,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Cortina Apartments",
    "latitude": 47.63711,
    "longitude": -122.32627,
    "original_address": "2001-2007 Eastlake Ave E",
    "building_number": 2007,
    "street": "Eastlake Ave E",
    "city": "Seattle",
    "zip": 98102,
    "concatenated_address": "2007 Eastlake Ave E, Seattle",
    "address": "2007 Eastlake Ave. E., Seattle"
  },
  {
    "id": 1038,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "NWloft Apartments",
    "latitude": 47.600383,
    "longitude": -122.33196,
    "original_address": "215 2nd Avenue South217 2nd Avenue South",
    "building_number": 215,
    "street": "2nd Ave S",
    "city": "Seattle",
    "zip": 98104,
    "concatenated_address": "215 2nd Ave S, Seattle",
    "address": "215 2nd Ave. S., Seattle"
  },
  {
    "id": 1039,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Bon Evan Apartments",
    "latitude": 47.709047,
    "longitude": -122.35589,
    "original_address": "11011 Greenwood Avenue North",
    "building_number": 11011,
    "street": "Greenwood Ave N",
    "city": "Seattle",
    "zip": 98133,
    "concatenated_address": "11011 Greenwood Ave N, Seattle",
    "address": "11011 Greenwood Ave. N., Seattle"
  },
  {
    "id": 1040,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "West Coast Arms",
    "latitude": 47.638679,
    "longitude": -122.37095,
    "original_address": "712 And 716 3rd Avenue West",
    "building_number": "",
    "street": "",
    "city": "Seattle",
    "zip": 98119,
    "concatenated_address": "712 And 716 3rd Avenue West, Seattle",
    "address": "712 And 716 3rd Avenue West, Seattle"
  },
  {
    "id": 1041,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Catalina Apartments",
    "latitude": 47.623475,
    "longitude": -122.32701,
    "original_address": "509 Bellevue Avenue East",
    "building_number": 509,
    "street": "Bellevue Ave E",
    "city": "Seattle",
    "zip": 98102,
    "concatenated_address": "509 Bellevue Ave E, Seattle",
    "address": "509 Bellevue Ave. E., Seattle"
  },
  {
    "id": 1042,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Fairhome Apartments",
    "latitude": 47.624712,
    "longitude": -122.31495,
    "original_address": "615 14th Avenue E",
    "building_number": 615,
    "street": "14th Ave E",
    "city": "Seattle",
    "zip": 98112,
    "concatenated_address": "615 14th Ave E, Seattle",
    "address": "615 14th Ave. E., Seattle"
  },
  {
    "id": 1043,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "6201 24th Avenue Northwest Apartments",
    "latitude": 47.674061,
    "longitude": -122.38799,
    "original_address": "6201 24th Avenue Northwest",
    "building_number": 6201,
    "street": "24th Ave NW",
    "city": "Seattle",
    "zip": 98107,
    "concatenated_address": "6201 24th Ave NW, Seattle",
    "address": "6201 24th Ave. N.W., Seattle"
  },
  {
    "id": 1044,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Bay Vista Apartments",
    "latitude": 47.669679,
    "longitude": -122.39093,
    "original_address": "2616 Nw 56th Street2620 Nw 56th Street",
    "building_number": 2616,
    "street": "NW 56th St",
    "city": "Seattle",
    "zip": 98107,
    "concatenated_address": "2616 NW 56th St, Seattle",
    "address": "2616 N.W. 56th St., Seattle"
  },
  {
    "id": 1045,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Melrose Terrace Inc.",
    "latitude": 47.62332,
    "longitude": -122.32753,
    "original_address": "308 East Republican Street",
    "building_number": 308,
    "street": "E Republican St",
    "city": "Seattle",
    "zip": 98102,
    "concatenated_address": "308 E Republican St, Seattle",
    "address": "308 E. Republican St., Seattle"
  },
  {
    "id": 1046,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Regis Apartments",
    "latitude": 47.623387,
    "longitude": -122.30774,
    "original_address": "1812 East Republican Street",
    "building_number": 1812,
    "street": "E Republican St",
    "city": "Seattle",
    "zip": 98112,
    "concatenated_address": "1812 E Republican St, Seattle",
    "address": "1812 E. Republican St., Seattle"
  },
  {
    "id": 1047,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Sedges At Piper Village",
    "latitude": 47.691636,
    "longitude": -122.35687,
    "original_address": "8623 Palatine Avenue North",
    "building_number": 8623,
    "street": "Palatine Ave N",
    "city": "Seattle",
    "zip": 98103,
    "concatenated_address": "8623 Palatine Ave N, Seattle",
    "address": "8623 Palatine Ave. N., Seattle"
  },
  {
    "id": 1048,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Crosby Queen Anne Apartments",
    "latitude": 47.631194,
    "longitude": -122.34728,
    "original_address": "1250 5th Avenue North",
    "building_number": 1250,
    "street": "5th Ave N",
    "city": "Seattle",
    "zip": 98109,
    "concatenated_address": "1250 5th Ave N, Seattle",
    "address": "1250 5th Ave. N., Seattle"
  },
  {
    "id": 1049,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Velo Apartments",
    "latitude": 47.62487,
    "longitude": -122.32768,
    "original_address": "301 East Roy Street",
    "building_number": 301,
    "street": "E Roy St",
    "city": "Seattle",
    "zip": 98102,
    "concatenated_address": "301 E Roy St, Seattle",
    "address": "301 E. Roy St., Seattle"
  },
  {
    "id": 1050,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "City View Apartments",
    "latitude": 47.514674,
    "longitude": -122.31865,
    "original_address": "9929 14th Avenue South",
    "building_number": 9929,
    "street": "14th Ave S",
    "city": "Seattle",
    "zip": 98108,
    "concatenated_address": "9929 14th Ave S, Seattle",
    "address": "9929 14th Ave. S., Seattle"
  },
  {
    "id": 1051,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Brubaker Apartments",
    "latitude": 47.687761,
    "longitude": -122.38487,
    "original_address": "7335 And 7345 15th Avenue Nw",
    "building_number": "",
    "street": "",
    "city": "Seattle",
    "zip": 98117,
    "concatenated_address": "7335 And 7345 15th Avenue Nw, Seattle",
    "address": "7335 And 7345 15th Avenue N.W., Seattle"
  },
  {
    "id": 1052,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Collage Apartments",
    "latitude": 47.650894,
    "longitude": -122.34362,
    "original_address": "3606 Woodland Park Avenue North",
    "building_number": 3606,
    "street": "Woodland Park Ave N",
    "city": "Seattle",
    "zip": 98103,
    "concatenated_address": "3606 Woodland Park Ave N, Seattle",
    "address": "3606 Woodland Park Ave. N., Seattle"
  },
  {
    "id": 1053,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "1311 2nd Avenue Apartments",
    "latitude": 47.630894,
    "longitude": -122.35953,
    "original_address": "1311 2nd Avenue West",
    "building_number": 1311,
    "street": "2nd Ave W",
    "city": "Seattle",
    "zip": 98119,
    "concatenated_address": "1311 2nd Ave W, Seattle",
    "address": "1311 2nd Ave. W., Seattle"
  },
  {
    "id": 1054,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Masa Terrace Apartments",
    "latitude": 47.622816,
    "longitude": -122.31432,
    "original_address": "426 14th Avenue E",
    "building_number": 426,
    "street": "14th Ave E",
    "city": "Seattle",
    "zip": 98112,
    "concatenated_address": "426 14th Ave E, Seattle",
    "address": "426 14th Ave. E., Seattle"
  },
  {
    "id": 1055,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Margola Apartments",
    "latitude": 47.61187,
    "longitude": -122.31058,
    "original_address": "1109 17th Avenue",
    "building_number": 1109,
    "street": "17th Ave",
    "city": "Seattle",
    "zip": 98122,
    "concatenated_address": "1109 17th Ave, Seattle",
    "address": "1109 17th Ave., Seattle"
  },
  {
    "id": 1056,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Element 42",
    "latitude": 47.579845,
    "longitude": -122.38547,
    "original_address": "2641 42nd Avenue Sw",
    "building_number": 2641,
    "street": "42nd Ave SW",
    "city": "Seattle",
    "zip": 98116,
    "concatenated_address": "2641 42nd Ave SW, Seattle",
    "address": "2641 42nd Ave. S.W., Seattle"
  },
  {
    "id": 1057,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "John Henry Apartments",
    "latitude": 47.664685,
    "longitude": -122.28441,
    "original_address": "4001 Ne 50th Street",
    "building_number": 4001,
    "street": "NE 50th St",
    "city": "Seattle",
    "zip": 98105,
    "concatenated_address": "4001 NE 50th St, Seattle",
    "address": "4001 N.E. 50th St., Seattle"
  },
  {
    "id": 1058,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "9242 Ashworth Avenue",
    "latitude": 47.697166,
    "longitude": -122.33945,
    "original_address": "9242 Ashworth Avenue North",
    "building_number": 9242,
    "street": "Ashworth Ave N",
    "city": "Seattle",
    "zip": 98103,
    "concatenated_address": "9242 Ashworth Ave N, Seattle",
    "address": "9242 Ashworth Ave. N., Seattle"
  },
  {
    "id": 1059,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Lawrence Lofts",
    "latitude": 47.616874,
    "longitude": -122.30784,
    "original_address": "1818 East Madison Street",
    "building_number": 1818,
    "street": "E Madison St",
    "city": "Seattle",
    "zip": 98122,
    "concatenated_address": "1818 E Madison St, Seattle",
    "address": "1818 E. Madison St., Seattle"
  },
  {
    "id": 1060,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "First And Republican Apartments",
    "latitude": 47.622864,
    "longitude": -122.35771,
    "original_address": "422 First Avenue West",
    "building_number": 422,
    "street": "1st Ave W",
    "city": "Seattle",
    "zip": 98119,
    "concatenated_address": "422 1st Ave W, Seattle",
    "address": "422 1st Ave. W., Seattle"
  },
  {
    "id": 1061,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Eagle Ridge Plaza",
    "latitude": 47.554007,
    "longitude": -122.31379,
    "original_address": "5333 15th Avenue South",
    "building_number": 5333,
    "street": "15th Ave S",
    "city": "Seattle",
    "zip": 98108,
    "concatenated_address": "5333 15th Ave S, Seattle",
    "address": "5333 15th Ave. S., Seattle"
  },
  {
    "id": 1062,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Rekhi Building",
    "latitude": 47.719845,
    "longitude": -122.29457,
    "original_address": "12500 - 12520 Lake City Way Ne &3104 - 3106 Ne 125th Street",
    "building_number": 12520,
    "street": "Lake City Way NE",
    "city": "Seattle",
    "zip": 98125,
    "concatenated_address": "12520 Lake City Way NE, Seattle",
    "address": "12520 Lake City Way N.E., Seattle"
  },
  {
    "id": 1063,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "The Cedars Apartments And Bayview Apartments",
    "latitude": 47.615451,
    "longitude": -122.35039,
    "original_address": "2615 1st Avenue & 2624 Western Avenue",
    "building_number": 2615,
    "street": "1st Ave",
    "city": "Seattle",
    "zip": 98121,
    "concatenated_address": "2615 1st Ave, Seattle",
    "address": "2615 1st Ave., Seattle"
  },
  {
    "id": 1064,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Array Apartments",
    "latitude": 47.731277,
    "longitude": -122.29305,
    "original_address": "14027 Lake City Way Ne",
    "building_number": 14027,
    "street": "Lake City Way NE",
    "city": "Seattle",
    "zip": 98125,
    "concatenated_address": "14027 Lake City Way NE, Seattle",
    "address": "14027 Lake City Way N.E., Seattle"
  },
  {
    "id": 1065,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Park 3025",
    "latitude": 47.72743,
    "longitude": -122.29536,
    "original_address": "3025 Ne 137th Street",
    "building_number": 3025,
    "street": "NE 137th St",
    "city": "Seattle",
    "zip": 98125,
    "concatenated_address": "3025 NE 137th St, Seattle",
    "address": "3025 N.E. 137th St., Seattle"
  },
  {
    "id": 1066,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Uptown Queen Anne Apartments",
    "latitude": 47.621312,
    "longitude": -122.35826,
    "original_address": "315 1st Ave West",
    "building_number": 315,
    "street": "1st Ave W",
    "city": "Seattle",
    "zip": 98119,
    "concatenated_address": "315 1st Ave W, Seattle",
    "address": "315 1st Ave. W., Seattle"
  },
  {
    "id": 1067,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Northbrook Place Apartments",
    "latitude": 47.702592,
    "longitude": -122.30222,
    "original_address": "10215 Lake City Way Ne",
    "building_number": 10215,
    "street": "Lake City Way NE",
    "city": "Seattle",
    "zip": 98125,
    "concatenated_address": "10215 Lake City Way NE, Seattle",
    "address": "10215 Lake City Way N.E., Seattle"
  },
  {
    "id": 1068,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Post Alley Court",
    "latitude": 47.607803,
    "longitude": -122.34013,
    "original_address": "1408 Western Avenue",
    "building_number": 1408,
    "street": "Western Ave",
    "city": "Seattle",
    "zip": 98101,
    "concatenated_address": "1408 Western Ave, Seattle",
    "address": "1408 Western Ave., Seattle"
  },
  {
    "id": 1069,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Benton Court Apartments",
    "latitude": 47.666964,
    "longitude": -122.30319,
    "original_address": "2251 Ne 53rd Street",
    "building_number": 2251,
    "street": "NE 53rd St",
    "city": "Seattle",
    "zip": 98105,
    "concatenated_address": "2251 NE 53rd St, Seattle",
    "address": "2251 N.E. 53rd St., Seattle"
  },
  {
    "id": 1070,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Flats At Interbay Apartments",
    "latitude": 47.647674,
    "longitude": -122.37731,
    "original_address": "3036 16th Avenue West",
    "building_number": 3036,
    "street": "16th Ave W",
    "city": "Seattle",
    "zip": 98119,
    "concatenated_address": "3036 16th Ave W, Seattle",
    "address": "3036 16th Ave. W., Seattle"
  },
  {
    "id": 1071,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Monticello Apartments",
    "latitude": 47.605304,
    "longitude": -122.32185,
    "original_address": "415 Boren Avenue",
    "building_number": 415,
    "street": "Boren Ave",
    "city": "Seattle",
    "zip": 98104,
    "concatenated_address": "415 Boren Ave, Seattle",
    "address": "415 Boren Ave., Seattle"
  },
  {
    "id": 1072,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Station At Othello Park",
    "latitude": 47.536901,
    "longitude": -122.27997,
    "original_address": "4219 South Othello Street",
    "building_number": 4219,
    "street": "S Othello St",
    "city": "Seattle",
    "zip": 98118,
    "concatenated_address": "4219 S Othello St, Seattle",
    "address": "4219 S. Othello St., Seattle"
  },
  {
    "id": 1073,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Guinevere Apartments",
    "latitude": 47.691065,
    "longitude": -122.35186,
    "original_address": "522 North 85th Street",
    "building_number": 522,
    "street": "N 85th St",
    "city": "Seattle",
    "zip": 98103,
    "concatenated_address": "522 N 85th St, Seattle",
    "address": "522 N. 85th St., Seattle"
  },
  {
    "id": 1074,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Handel + Pladhus Apartments",
    "latitude": 47.685746,
    "longitude": -122.28159,
    "original_address": "838 And 844 Ne 69th Street",
    "building_number": "",
    "street": "",
    "city": "Seattle",
    "zip": 98115,
    "concatenated_address": "838 And 844 Ne 69th Street, Seattle",
    "address": "838 And 844 Ne 69th St., Seattle"
  },
  {
    "id": 1075,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Ballard Apartments",
    "latitude": 47.667527,
    "longitude": -122.37755,
    "original_address": "1530 & 1540 Nw 52nd Street",
    "building_number": "",
    "street": "",
    "city": "Seattle",
    "zip": 98107,
    "concatenated_address": "1530 & 1540 Nw 52nd Street, Seattle",
    "address": "1530 & 1540 N.W. 52nd St., Seattle"
  },
  {
    "id": 1076,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "47+7 Apartments",
    "latitude": 47.663017,
    "longitude": -122.32038,
    "original_address": "4558 7th Ave Ne",
    "building_number": 4558,
    "street": "7th Ave NE",
    "city": "Seattle",
    "zip": 98105,
    "concatenated_address": "4558 7th Ave NE, Seattle",
    "address": "4558 7th Ave. N.E., Seattle"
  },
  {
    "id": 1077,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Boxcar Apartments",
    "latitude": 47.619516,
    "longitude": -122.33754,
    "original_address": "975 John Street",
    "building_number": 975,
    "street": "John St",
    "city": "Seattle",
    "zip": 98109,
    "concatenated_address": "975 John St, Seattle",
    "address": "975 John St., Seattle"
  },
  {
    "id": 1078,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Aya Terrace Apartments",
    "latitude": 47.623321,
    "longitude": -122.32284,
    "original_address": "500 Boylston Avenue East",
    "building_number": 500,
    "street": "Boylston Ave E",
    "city": "Seattle",
    "zip": 98102,
    "concatenated_address": "500 Boylston Ave E, Seattle",
    "address": "500 Boylston Ave. E., Seattle"
  },
  {
    "id": 1079,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Morningside Heights Apartments",
    "latitude": 47.697148,
    "longitude": -122.29099,
    "original_address": "9425 35th Avenue Ne",
    "building_number": 9425,
    "street": "35th Ave NE",
    "city": "Seattle",
    "zip": 98115,
    "concatenated_address": "9425 35th Ave NE, Seattle",
    "address": "9425 35th Ave. N.E., Seattle"
  },
  {
    "id": 1080,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Leilani And 107 On Greenwood",
    "latitude": 47.740475,
    "longitude": -122.34287,
    "original_address": "10215 And 10570 Greenwood Avenue North",
    "building_number": "",
    "street": "",
    "city": "Seattle",
    "zip": 98133,
    "concatenated_address": "10215 And 10570 Greenwood Avenue North, Seattle",
    "address": "10215 And 10570 Greenwood Avenue North, Seattle"
  },
  {
    "id": 1081,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Foster Commons Apartments",
    "latitude": 47.489185,
    "longitude": -122.26179,
    "original_address": "5700 South 129th Street",
    "building_number": 5700,
    "street": "S 129th St",
    "city": "Seattle",
    "zip": 98178,
    "concatenated_address": "5700 S 129th St, Seattle",
    "address": "5700 S. 129th St., Seattle"
  },
  {
    "id": 1082,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "The Overlook At Magnolia Apartments",
    "latitude": 47.652954,
    "longitude": -122.39078,
    "original_address": "3520 27th Place West",
    "building_number": 3520,
    "street": "27th Pl W",
    "city": "Seattle",
    "zip": 98199,
    "concatenated_address": "3520 27th Pl W, Seattle",
    "address": "3520 27th Pl W., Seattle"
  },
  {
    "id": 1083,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Latitude Queen Anne",
    "latitude": 47.623657,
    "longitude": -122.36028,
    "original_address": "500 3rd Avenue West",
    "building_number": 500,
    "street": "3rd Ave W",
    "city": "Seattle",
    "zip": 98119,
    "concatenated_address": "500 3rd Ave W, Seattle",
    "address": "500 3rd Ave. W., Seattle"
  },
  {
    "id": 1084,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Liv At East John Apartments",
    "latitude": 47.619739,
    "longitude": -122.3175,
    "original_address": "1113 East John Street",
    "building_number": 1113,
    "street": "E John St",
    "city": "Seattle",
    "zip": 98102,
    "concatenated_address": "1113 E John St, Seattle",
    "address": "1113 E. John St., Seattle"
  },
  {
    "id": 1085,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Northbridge Apartments",
    "latitude": 47.653064,
    "longitude": -122.3469,
    "original_address": "3800 Aurora Avenue N",
    "building_number": 3800,
    "street": "Aurora Ave N",
    "city": "Seattle",
    "zip": 98103,
    "concatenated_address": "3800 Aurora Ave N, Seattle",
    "address": "3800 Aurora Ave. N., Seattle"
  },
  {
    "id": 1086,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "4210 Brooklyn Avenue Northeast",
    "latitude": 47.658738,
    "longitude": -122.314,
    "original_address": "4210 Brooklyn Avenue Ne",
    "building_number": 4210,
    "street": "Brooklyn Ave NE",
    "city": "Seattle",
    "zip": 98105,
    "concatenated_address": "4210 Brooklyn Ave NE, Seattle",
    "address": "4210 Brooklyn Ave. N.E., Seattle"
  },
  {
    "id": 1087,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Marq 211",
    "latitude": 47.612593,
    "longitude": -122.34268,
    "original_address": "211 Lenora Street",
    "building_number": 211,
    "street": "Lenora St",
    "city": "Seattle",
    "zip": 98121,
    "concatenated_address": "211 Lenora St, Seattle",
    "address": "211 Lenora St., Seattle"
  },
  {
    "id": 1088,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Alcove Apartments",
    "latitude": 47.489569,
    "longitude": -122.29996,
    "original_address": "12033 And 12037 1st Avenue South",
    "building_number": "",
    "street": "",
    "city": "Seattle",
    "zip": 98168,
    "concatenated_address": "12033 And 12037 1st Avenue South, Seattle",
    "address": "12033 And 12037 1st Avenue S., Seattle"
  },
  {
    "id": 1089,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Graham Place Apartments",
    "latitude": 47.545898,
    "longitude": -122.27507,
    "original_address": "4601 S. Graham Street",
    "building_number": 4601,
    "street": "S Graham St",
    "city": "Seattle",
    "zip": 98118,
    "concatenated_address": "4601 S Graham St, Seattle",
    "address": "4601 S. Graham St., Seattle"
  },
  {
    "id": 1090,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "The Central",
    "latitude": 47.612728,
    "longitude": -122.30318,
    "original_address": "2203 East Union Street",
    "building_number": 2203,
    "street": "E Union St",
    "city": "Seattle",
    "zip": 98122,
    "concatenated_address": "2203 E Union St, Seattle",
    "address": "2203 E. Union St., Seattle"
  },
  {
    "id": 1091,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "East John Apartments",
    "latitude": 47.620067,
    "longitude": -122.30185,
    "original_address": "2311 East John Street",
    "building_number": 2311,
    "street": "E John St",
    "city": "Seattle",
    "zip": 98112,
    "concatenated_address": "2311 E John St, Seattle",
    "address": "2311 E. John St., Seattle"
  },
  {
    "id": 1092,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Lexicon Apartments",
    "latitude": 47.619362,
    "longitude": -122.32184,
    "original_address": "120 Harvard Avenue E",
    "building_number": 120,
    "street": "Harvard Ave E",
    "city": "Seattle",
    "zip": 98102,
    "concatenated_address": "120 Harvard Ave E, Seattle",
    "address": "120 Harvard Ave. E., Seattle"
  },
  {
    "id": 1093,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Nora",
    "latitude": 47.657107,
    "longitude": -122.31522,
    "original_address": "4106 12th Avenue Ne And 1210 41st Street And4123 12th Avenue Ne",
    "building_number": 4106,
    "street": "12th Ave NE",
    "city": "Seattle",
    "zip": 98105,
    "concatenated_address": "4106 12th Ave NE, Seattle",
    "address": "4106 12th Ave. N.E., Seattle"
  },
  {
    "id": 1094,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "City North",
    "latitude": 47.719845,
    "longitude": -122.29457,
    "original_address": "12500-12520 Lake City Way Ne &3104-3106 Ne 125th Street",
    "building_number": 12520,
    "street": "Lake City Way NE",
    "city": "Seattle",
    "zip": 98125,
    "concatenated_address": "12520 Lake City Way NE, Seattle",
    "address": "12520 Lake City Way N.E., Seattle"
  },
  {
    "id": 1095,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Julie Anne Apartments",
    "latitude": 47.664375,
    "longitude": -122.28386,
    "original_address": "4747 Sand Point Way Ne",
    "building_number": 4747,
    "street": "Sand Point Way NE",
    "city": "Seattle",
    "zip": 98105,
    "concatenated_address": "4747 Sand Point Way NE, Seattle",
    "address": "4747 Sand Point Way N.E., Seattle"
  },
  {
    "id": 1096,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Denning Apartments",
    "latitude": 47.578808,
    "longitude": -122.31099,
    "original_address": "1636 S Mcclellan St.",
    "building_number": 1636,
    "street": "S McClellan St",
    "city": "Seattle",
    "zip": 98144,
    "concatenated_address": "1636 S McClellan St, Seattle",
    "address": "1636 S. McClellan St., Seattle"
  },
  {
    "id": 1097,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Westview On Beacon Hill",
    "latitude": 47.580245,
    "longitude": -122.31513,
    "original_address": "2525 14th Avenue South",
    "building_number": 2525,
    "street": "14th Ave S",
    "city": "Seattle",
    "zip": 98144,
    "concatenated_address": "2525 14th Ave S, Seattle",
    "address": "2525 14th Ave. S., Seattle"
  },
  {
    "id": 1098,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Spruce Apartments",
    "latitude": 47.561552,
    "longitude": -122.38176,
    "original_address": "4555 39th Avenue Sw And 3900 & 3922 Sw Alaska Street",
    "building_number": 4555,
    "street": "39th Ave SW",
    "city": "Seattle",
    "zip": 98116,
    "concatenated_address": "4555 39th Ave SW, Seattle",
    "address": "4555 39th Ave. S.W., Seattle"
  },
  {
    "id": 1099,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Atrium Apartments",
    "latitude": 47.590455,
    "longitude": -122.29207,
    "original_address": "3104 S. Day Street",
    "building_number": 3104,
    "street": "S Day St",
    "city": "Seattle",
    "zip": 98144,
    "concatenated_address": "3104 S Day St, Seattle",
    "address": "3104 S. Day St., Seattle"
  },
  {
    "id": 1100,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Elan 41",
    "latitude": 47.559614,
    "longitude": -122.38526,
    "original_address": "4100 South West Edmonds Street",
    "building_number": 4100,
    "street": "SW Edmunds St",
    "city": "Seattle",
    "zip": 98116,
    "concatenated_address": "4100 SW Edmunds St, Seattle",
    "address": "4100 S.W. Edmunds St., Seattle"
  },
  {
    "id": 1101,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Greenfielding Building 47",
    "latitude": 47.690388,
    "longitude": -122.37765,
    "original_address": "8356 16th Avenue Nw",
    "building_number": 8356,
    "street": "16th Ave NW",
    "city": "Seattle",
    "zip": 98117,
    "concatenated_address": "8356 16th Ave NW, Seattle",
    "address": "8356 16th Ave. N.W., Seattle"
  },
  {
    "id": 1102,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Ruth Court Apartments",
    "latitude": 47.619394,
    "longitude": -122.30903,
    "original_address": "123 18th Avenue E",
    "building_number": 123,
    "street": "18th Ave E",
    "city": "Seattle",
    "zip": 98112,
    "concatenated_address": "123 18th Ave E, Seattle",
    "address": "123 18th Ave. E., Seattle"
  },
  {
    "id": 1103,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Liv Wallingford Apartments",
    "latitude": 47.661622,
    "longitude": -122.3431,
    "original_address": "1240 N Midvale Place",
    "building_number": 1240,
    "street": "N Midvale Pl",
    "city": "Seattle",
    "zip": 98103,
    "concatenated_address": "1240 N Midvale Pl, Seattle",
    "address": "1240 N. Midvale Place, Seattle"
  },
  {
    "id": 1104,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Oneone6 Apartments",
    "latitude": 47.619298,
    "longitude": -122.31528,
    "original_address": "116 13Th Avenue E",
    "building_number": 116,
    "street": "13th Ave E",
    "city": "Seattle",
    "zip": 98102,
    "concatenated_address": "116 13th Ave E, Seattle",
    "address": "116 13th Ave. E., Seattle"
  },
  {
    "id": 1105,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Violett Apartments On Melrose",
    "latitude": 47.615987,
    "longitude": -122.32758,
    "original_address": "1616-1620 Melrose Avenue",
    "building_number": 1620,
    "street": "Melrose Ave",
    "city": "Seattle",
    "zip": 98122,
    "concatenated_address": "1620 Melrose Ave, Seattle",
    "address": "1620 Melrose Ave., Seattle"
  },
  {
    "id": 1106,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Greentree Condominium Apartments",
    "latitude": 47.680443,
    "longitude": -122.35507,
    "original_address": "7100 Greenwood Avenue N.",
    "building_number": 7100,
    "street": "Greenwood Ave N",
    "city": "Seattle",
    "zip": 98103,
    "concatenated_address": "7100 Greenwood Ave N, Seattle",
    "address": "7100 Greenwood Ave. N., Seattle"
  },
  {
    "id": 1107,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Greenfielding Building 65",
    "latitude": 47.675052,
    "longitude": -122.37531,
    "original_address": "1433 Nw 64th Street",
    "building_number": 1433,
    "street": "NW 64th St",
    "city": "Seattle",
    "zip": 98107,
    "concatenated_address": "1433 NW 64th St, Seattle",
    "address": "1433 N.W. 64th St., Seattle"
  },
  {
    "id": 1108,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Fountain Apartments",
    "latitude": 47.697584,
    "longitude": -122.3493,
    "original_address": "715 N 95th Street",
    "building_number": 715,
    "street": "N 95th St",
    "city": "Seattle",
    "zip": 98103,
    "concatenated_address": "715 N 95th St, Seattle",
    "address": "715 N. 95th St., Seattle"
  },
  {
    "id": 1109,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Dunn Motors Apartments",
    "latitude": 47.613935,
    "longitude": -122.32517,
    "original_address": "501 East Pike St.",
    "building_number": 501,
    "street": "E Pike St",
    "city": "Seattle",
    "zip": 98122,
    "concatenated_address": "501 E Pike St, Seattle",
    "address": "501 E. Pike St., Seattle"
  },
  {
    "id": 1110,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Greenfielding Building 20",
    "latitude": 47.675507,
    "longitude": -122.3751,
    "original_address": "1430 Nw 64th Street",
    "building_number": 1430,
    "street": "NW 64th St",
    "city": "Seattle",
    "zip": 98107,
    "concatenated_address": "1430 NW 64th St, Seattle",
    "address": "1430 N.W. 64th St., Seattle"
  },
  {
    "id": 1111,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Stencil Apartments",
    "latitude": 47.612737,
    "longitude": -122.30101,
    "original_address": "2407 East Union Street",
    "building_number": 2407,
    "street": "E Union St",
    "city": "Seattle",
    "zip": 98122,
    "concatenated_address": "2407 E Union St, Seattle",
    "address": "2407 E. Union St., Seattle"
  },
  {
    "id": 1112,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Eastlake Flats",
    "latitude": 47.63714,
    "longitude": -122.32189,
    "original_address": "2820 & 2822 Eastlake Avenue East",
    "building_number": "",
    "street": "",
    "city": "Seattle",
    "zip": 98102,
    "concatenated_address": "2820 & 2822 Eastlake Avenue East, Seattle",
    "address": "2820 & 2822 Eastlake Avenue East, Seattle"
  },
  {
    "id": 1113,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Century House Apartments",
    "latitude": 47.587854,
    "longitude": -122.30309,
    "original_address": "1711 23rd Avenue South",
    "building_number": 1711,
    "street": "23rd Ave S",
    "city": "Seattle",
    "zip": 98144,
    "concatenated_address": "1711 23rd Ave S, Seattle",
    "address": "1711 23rd Ave. S., Seattle"
  },
  {
    "id": 1114,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Icon Apartments",
    "latitude": 47.599481,
    "longitude": -122.3285,
    "original_address": "400 South Jackson Street",
    "building_number": 400,
    "street": "S Jackson St",
    "city": "Seattle",
    "zip": 98104,
    "concatenated_address": "400 S Jackson St, Seattle",
    "address": "400 S. Jackson St., Seattle"
  },
  {
    "id": 1115,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Edwards On Fifth Apartments",
    "latitude": 47.618075,
    "longitude": -122.347,
    "original_address": "2619 5th Avenue",
    "building_number": 2619,
    "street": "5th Ave",
    "city": "Seattle",
    "zip": 98121,
    "concatenated_address": "2619 5th Ave, Seattle",
    "address": "2619 5th Ave., Seattle"
  },
  {
    "id": 1116,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "A. W. Larson Building",
    "latitude": 47.650266,
    "longitude": -122.32187,
    "original_address": "3206 Harvard Avenue E.",
    "building_number": 3206,
    "street": "Harvard Ave E",
    "city": "Seattle",
    "zip": 98102,
    "concatenated_address": "3206 Harvard Ave E, Seattle",
    "address": "3206 Harvard Ave. E., Seattle"
  },
  {
    "id": 1117,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Clocktower Apartment Homes",
    "latitude": 47.728977,
    "longitude": -122.29496,
    "original_address": "13725 32nd Ave.Ne",
    "building_number": 13725,
    "street": "32nd Ave NE",
    "city": "Seattle",
    "zip": 98125,
    "concatenated_address": "13725 32nd Ave NE, Seattle",
    "address": "13725 32nd Ave. N.E., Seattle"
  },
  {
    "id": 1118,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Minnie Flats",
    "latitude": 47.618447,
    "longitude": -122.35475,
    "original_address": "101 Denny Way",
    "building_number": 101,
    "street": "Denny Way",
    "city": "Seattle",
    "zip": 98109,
    "concatenated_address": "101 Denny Way, Seattle",
    "address": "101 Denny Way, Seattle"
  },
  {
    "id": 1119,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "St. James Tower",
    "latitude": 47.649307,
    "longitude": -122.34616,
    "original_address": "920 North 34th Street",
    "building_number": 920,
    "street": "N 34th St",
    "city": "Seattle",
    "zip": 98103,
    "concatenated_address": "920 N 34th St, Seattle",
    "address": "920 N. 34th St., Seattle"
  },
  {
    "id": 1120,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Park South Apartments",
    "latitude": 47.512962,
    "longitude": -122.32401,
    "original_address": "10101 8th Avenue South 10102 8th Avenue South",
    "building_number": 10101,
    "street": "8th Ave S",
    "city": "Seattle",
    "zip": 98168,
    "concatenated_address": "10101 8th Ave S, Seattle",
    "address": "10101 8th Ave. S., Seattle"
  },
  {
    "id": 1121,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "4517 Glenn Way Southwest",
    "latitude": 47.561945,
    "longitude": -122.38919,
    "original_address": "4517 Glenn Way Sw",
    "building_number": 4517,
    "street": "Glenn Way SW",
    "city": "Seattle",
    "zip": 98116,
    "concatenated_address": "4517 Glenn Way SW, Seattle",
    "address": "4517 Glenn Way S.W., Seattle"
  },
  {
    "id": 1122,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Shelton Eastlake Apartments",
    "latitude": 47.64144,
    "longitude": -122.32494,
    "original_address": "2359 Franklin Avenue E",
    "building_number": 2359,
    "street": "Franklin Ave E",
    "city": "Seattle",
    "zip": 98102,
    "concatenated_address": "2359 Franklin Ave E, Seattle",
    "address": "2359 Franklin Ave. E., Seattle"
  },
  {
    "id": 1123,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Tower 12 Apartments",
    "latitude": 47.611856,
    "longitude": -122.34254,
    "original_address": "2015 2nd Avenue",
    "building_number": 2015,
    "street": "2nd Ave",
    "city": "Seattle",
    "zip": 98121,
    "concatenated_address": "2015 2nd Ave, Seattle",
    "address": "2015 2nd Ave., Seattle"
  },
  {
    "id": 1124,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Corner House Apartments",
    "latitude": 47.712562,
    "longitude": -122.35595,
    "original_address": "11501 Greenwood Avenue N",
    "building_number": 11501,
    "street": "Greenwood Ave N",
    "city": "Seattle",
    "zip": 98133,
    "concatenated_address": "11501 Greenwood Ave N, Seattle",
    "address": "11501 Greenwood Ave. N., Seattle"
  },
  {
    "id": 1125,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Marq West Seattle",
    "latitude": 47.563828,
    "longitude": -122.37423,
    "original_address": "3261 Sw Avalon Way",
    "building_number": 3261,
    "street": "SW Avalon Way",
    "city": "Seattle",
    "zip": 98126,
    "concatenated_address": "3261 SW Avalon Way, Seattle",
    "address": "3261 S.W. Avalon Way, Seattle"
  },
  {
    "id": 1126,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Summit At Lake Union Apartments",
    "latitude": 47.634911,
    "longitude": -122.34266,
    "original_address": "1735 Dexter Ave N",
    "building_number": 1735,
    "street": "Dexter Ave N",
    "city": "Seattle",
    "zip": 98109,
    "concatenated_address": "1735 Dexter Ave N, Seattle",
    "address": "1735 Dexter Ave. N., Seattle"
  },
  {
    "id": 1127,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Alaska House",
    "latitude": 47.561462,
    "longitude": -122.38578,
    "original_address": "4545 42nd Ave Sw",
    "building_number": 4545,
    "street": "42nd Ave SW",
    "city": "Seattle",
    "zip": 98116,
    "concatenated_address": "4545 42nd Ave SW, Seattle",
    "address": "4545 42nd Ave. S.W., Seattle"
  },
  {
    "id": 1128,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Eversen Apartments",
    "latitude": 47.622648,
    "longitude": -122.3237,
    "original_address": "420 Belmont Avenue E",
    "building_number": 420,
    "street": "Belmont Ave E",
    "city": "Seattle",
    "zip": 98102,
    "concatenated_address": "420 Belmont Ave E, Seattle",
    "address": "420 Belmont Ave. E., Seattle"
  },
  {
    "id": 1129,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Parla Apartments",
    "latitude": 47.695737,
    "longitude": -122.37338,
    "original_address": "9176 Holman Road Nw",
    "building_number": 9176,
    "street": "Holman Rd NW",
    "city": "Seattle",
    "zip": 98117,
    "concatenated_address": "9176 Holman Rd NW, Seattle",
    "address": "9176 Holman Road N.W., Seattle"
  },
  {
    "id": 1130,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Aegis Of Queen Anne On Galer",
    "latitude": 47.632125,
    "longitude": -122.3601,
    "original_address": "223 W. Galer St.",
    "building_number": 223,
    "street": "W Galer St",
    "city": "Seattle",
    "zip": 98119,
    "concatenated_address": "223 W Galer St, Seattle",
    "address": "223 W. Galer St., Seattle"
  },
  {
    "id": 1131,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Cosmopolitan Apartments",
    "latitude": 47.661821,
    "longitude": -122.3237,
    "original_address": "400 Ne 45th Street",
    "building_number": 400,
    "street": "NE 45th St",
    "city": "Seattle",
    "zip": 98105,
    "concatenated_address": "400 NE 45th St, Seattle",
    "address": "400 N.E. 45th St., Seattle"
  },
  {
    "id": 1132,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Belmont Court Apartments",
    "latitude": 47.622904,
    "longitude": -122.32372,
    "original_address": "424 Belmont Avenue East",
    "building_number": 424,
    "street": "Belmont Ave E",
    "city": "Seattle",
    "zip": 98102,
    "concatenated_address": "424 Belmont Ave E, Seattle",
    "address": "424 Belmont Ave. E., Seattle"
  },
  {
    "id": 1133,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Lighthouse",
    "latitude": 47.544034,
    "longitude": -122.34987,
    "original_address": "7701 And 7901 Delridge Way Sw",
    "building_number": "",
    "street": "",
    "city": "Seattle",
    "zip": 98106,
    "concatenated_address": "7701 And 7901 Delridge Way Sw, Seattle",
    "address": "7701 And 7901 Delridge Way S.W., Seattle"
  },
  {
    "id": 1134,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Lock Vista Apartments",
    "latitude": 47.668299,
    "longitude": -122.39692,
    "original_address": "3025 Nw Market Street",
    "building_number": 3025,
    "street": "NW Market St",
    "city": "Seattle",
    "zip": 98107,
    "concatenated_address": "3025 NW Market St, Seattle",
    "address": "3025 N.W. Market St., Seattle"
  },
  {
    "id": 1135,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "The Iliad Apartments",
    "latitude": 47.619023,
    "longitude": -122.32639,
    "original_address": "112 Bellevue Avenue East",
    "building_number": 112,
    "street": "Bellevue Ave E",
    "city": "Seattle",
    "zip": 98102,
    "concatenated_address": "112 Bellevue Ave E, Seattle",
    "address": "112 Bellevue Ave. E., Seattle"
  },
  {
    "id": 1136,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Liv Roosevelt Apartments",
    "latitude": 47.675191,
    "longitude": -122.31831,
    "original_address": "6404 9th Avenue Ne",
    "building_number": 6404,
    "street": "9th Ave NE",
    "city": "Seattle",
    "zip": 98115,
    "concatenated_address": "6404 9th Ave NE, Seattle",
    "address": "6404 9th Ave. N.E., Seattle"
  },
  {
    "id": 1137,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "1404 Boylston Apartments",
    "latitude": 47.613346,
    "longitude": -122.32311,
    "original_address": "1404 Boylston Avenue",
    "building_number": 1404,
    "street": "Boylston Ave",
    "city": "Seattle",
    "zip": 98122,
    "concatenated_address": "1404 Boylston Ave, Seattle",
    "address": "1404 Boylston Ave., Seattle"
  },
  {
    "id": 1138,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Roy Vue Apartments",
    "latitude": 47.624784,
    "longitude": -122.32684,
    "original_address": "615 Bellevue Avenue East",
    "building_number": 615,
    "street": "Bellevue Ave E",
    "city": "Seattle",
    "zip": 98102,
    "concatenated_address": "615 Bellevue Ave E, Seattle",
    "address": "615 Bellevue Ave. E., Seattle"
  },
  {
    "id": 1139,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Metropolitan Park Apartments",
    "latitude": 47.600715,
    "longitude": -122.3257,
    "original_address": "601 South Washington Street",
    "building_number": 601,
    "street": "S Washington St",
    "city": "Seattle",
    "zip": 98104,
    "concatenated_address": "601 S Washington St, Seattle",
    "address": "601 S. Washington St., Seattle"
  },
  {
    "id": 1140,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Anthem On 12th",
    "latitude": 47.602054,
    "longitude": -122.31711,
    "original_address": "103 12th Ave.",
    "building_number": 103,
    "street": "12th Ave",
    "city": "Seattle",
    "zip": 98122,
    "concatenated_address": "103 12th Ave, Seattle",
    "address": "103 12th Ave., Seattle"
  },
  {
    "id": 1141,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Woodpark Apartments",
    "latitude": 47.678255,
    "longitude": -122.33815,
    "original_address": "4300 And 4312 Woodland Park Avenue North",
    "building_number": "",
    "street": "",
    "city": "Seattle",
    "zip": 98103,
    "concatenated_address": "4300 And 4312 Woodland Park Avenue North, Seattle",
    "address": "4300 And 4312 Woodland Park Avenue North, Seattle"
  },
  {
    "id": 1142,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Madison View (formerly known as Gramercy Flats)",
    "latitude": 47.619492,
    "longitude": -122.30101,
    "original_address": "114 24th Ave E",
    "building_number": 114,
    "street": "24th Ave E",
    "city": "Seattle",
    "zip": 98112,
    "concatenated_address": "114 24th Ave E, Seattle",
    "address": "114 24th Ave. E., Seattle"
  },
  {
    "id": 1143,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "View Crest Cooperative Association",
    "latitude": 47.626551,
    "longitude": -122.36404,
    "original_address": "515 West Olympic Place",
    "building_number": 515,
    "street": "W Olympic Pl",
    "city": "Seattle",
    "zip": 98119,
    "concatenated_address": "515 W Olympic Pl, Seattle",
    "address": "515 W. Olympic Place, Seattle"
  },
  {
    "id": 1144,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Heights On Capitol Hill Apartments",
    "latitude": 47.619728,
    "longitude": -122.32184,
    "original_address": "130 Harvard Ave E",
    "building_number": 130,
    "street": "Harvard Ave E",
    "city": "Seattle",
    "zip": 98102,
    "concatenated_address": "130 Harvard Ave E, Seattle",
    "address": "130 Harvard Ave. E., Seattle"
  },
  {
    "id": 1145,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Metro On First Apartments",
    "latitude": 47.62013,
    "longitude": -122.35843,
    "original_address": "215 1st Ave W",
    "building_number": 215,
    "street": "1st Ave W",
    "city": "Seattle",
    "zip": 98119,
    "concatenated_address": "215 1st Ave W, Seattle",
    "address": "215 1st Ave. W., Seattle"
  },
  {
    "id": 1146,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Modera South Lake Union",
    "latitude": 47.622921,
    "longitude": -122.34291,
    "original_address": "435 Dexter Ave N",
    "building_number": 435,
    "street": "Dexter Ave N",
    "city": "Seattle",
    "zip": 98109,
    "concatenated_address": "435 Dexter Ave N, Seattle",
    "address": "435 Dexter Ave. N., Seattle"
  },
  {
    "id": 1147,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Ellis Court",
    "latitude": 47.614475,
    "longitude": -122.3498,
    "original_address": "2510 Western Avenue",
    "building_number": 2510,
    "street": "Western Ave",
    "city": "Seattle",
    "zip": 98121,
    "concatenated_address": "2510 Western Ave, Seattle",
    "address": "2510 Western Ave., Seattle"
  },
  {
    "id": 1148,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Sherman Apartments",
    "latitude": 47.635828,
    "longitude": -122.35749,
    "original_address": "1835 Queen Anne Ave N",
    "building_number": 1835,
    "street": "Queen Anne Ave N",
    "city": "Seattle",
    "zip": 98109,
    "concatenated_address": "1835 Queen Anne Ave N, Seattle",
    "address": "1835 Queen Anne Ave. N., Seattle"
  },
  {
    "id": 1149,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "The Roost",
    "latitude": 47.594227,
    "longitude": -122.30934,
    "original_address": "901 Hiawatha Place South",
    "building_number": 901,
    "street": "Hiawatha Pl S",
    "city": "Seattle",
    "zip": 98144,
    "concatenated_address": "901 Hiawatha Pl S, Seattle",
    "address": "901 Hiawatha Pl S., Seattle"
  },
  {
    "id": 1150,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Tod Apartments",
    "latitude": 47.619462,
    "longitude": -122.3191,
    "original_address": "120 10th Avenue E",
    "building_number": 120,
    "street": "10th Ave E",
    "city": "Seattle",
    "zip": 98102,
    "concatenated_address": "120 10th Ave E, Seattle",
    "address": "120 10th Ave. E., Seattle"
  },
  {
    "id": 1151,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Rev Fremont",
    "latitude": 47.656774,
    "longitude": -122.36175,
    "original_address": "317 Nw 41st Street",
    "building_number": 317,
    "street": "NW 41st St",
    "city": "Seattle",
    "zip": 98107,
    "concatenated_address": "317 NW 41st St, Seattle",
    "address": "317 N.W. 41st St., Seattle"
  },
  {
    "id": 1152,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Elara At The Market",
    "latitude": 47.611919,
    "longitude": -122.34543,
    "original_address": "2134 Western Avenue",
    "building_number": 2134,
    "street": "Western Ave",
    "city": "Seattle",
    "zip": 98121,
    "concatenated_address": "2134 Western Ave, Seattle",
    "address": "2134 Western Ave., Seattle"
  },
  {
    "id": 1153,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "The Broadway Building",
    "latitude": 47.615923,
    "longitude": -122.32041,
    "original_address": "1620 Broadway",
    "building_number": 1620,
    "street": "Broadway",
    "city": "Seattle",
    "zip": 98122,
    "concatenated_address": "1620 Broadway, Seattle",
    "address": "1620 Broadway, Seattle"
  },
  {
    "id": 1154,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "The Nelson",
    "latitude": 47.732538,
    "longitude": -122.35506,
    "original_address": "14300 Greenwood Avenue North",
    "building_number": 14300,
    "street": "Greenwood Ave N",
    "city": "Seattle",
    "zip": 98133,
    "concatenated_address": "14300 Greenwood Ave N, Seattle",
    "address": "14300 Greenwood Ave. N., Seattle"
  },
  {
    "id": 1155,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Elliott Bayview",
    "latitude": 47.619585,
    "longitude": -122.35377,
    "original_address": "151 John Street",
    "building_number": 151,
    "street": "John St",
    "city": "Seattle",
    "zip": 98109,
    "concatenated_address": "151 John St, Seattle",
    "address": "151 John St., Seattle"
  },
  {
    "id": 1156,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Hana",
    "latitude": 47.601383,
    "longitude": -122.32654,
    "original_address": "101 6th Avenue South",
    "building_number": 101,
    "street": "6th Ave S",
    "city": "Seattle",
    "zip": 98104,
    "concatenated_address": "101 6th Ave S, Seattle",
    "address": "101 6th Ave. S., Seattle"
  },
  {
    "id": 1157,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Webster Apartments",
    "latitude": 47.555839,
    "longitude": -122.38647,
    "original_address": "4228 Sw Dawson Street",
    "building_number": 4228,
    "street": "SW Dawson St",
    "city": "Seattle",
    "zip": 98136,
    "concatenated_address": "4228 SW Dawson St, Seattle",
    "address": "4228 S.W. Dawson St., Seattle"
  },
  {
    "id": 1158,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Crystal Court Apartments",
    "latitude": 47.689784,
    "longitude": -122.32337,
    "original_address": "8401 5th Avenue Ne",
    "building_number": 8401,
    "street": "5th Ave NE",
    "city": "Seattle",
    "zip": 98115,
    "concatenated_address": "8401 5th Ave NE, Seattle",
    "address": "8401 5th Ave. N.E., Seattle"
  },
  {
    "id": 1159,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Riverview West Apartments",
    "latitude": 47.511296,
    "longitude": -122.30642,
    "original_address": "10300 Des Moines Memorial Drive South",
    "building_number": 10300,
    "street": "Des Moines Memorial Dr S",
    "city": "Seattle",
    "zip": 98168,
    "concatenated_address": "10300 Des Moines Memorial Dr S, Seattle",
    "address": "10300 Des Moines Memorial Dr S., Seattle"
  },
  {
    "id": 1160,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Bogtown Flats",
    "latitude": 47.695401,
    "longitude": -122.35563,
    "original_address": "9039 Greenwood Avenue N.",
    "building_number": 9039,
    "street": "Greenwood Ave N",
    "city": "Seattle",
    "zip": 98103,
    "concatenated_address": "9039 Greenwood Ave N, Seattle",
    "address": "9039 Greenwood Ave. N., Seattle"
  },
  {
    "id": 1161,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Atria Villa",
    "latitude": 47.630995,
    "longitude": -122.34658,
    "original_address": "1251 Taylor Avenue North",
    "building_number": 1251,
    "street": "Taylor Ave N",
    "city": "Seattle",
    "zip": 98109,
    "concatenated_address": "1251 Taylor Ave N, Seattle",
    "address": "1251 Taylor Ave. N., Seattle"
  },
  {
    "id": 1162,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Velo And Ray Apartments",
    "latitude": 47.651846,
    "longitude": -122.34438,
    "original_address": "3635 Woodland Park Avenue North",
    "building_number": 3635,
    "street": "Woodland Park Ave N",
    "city": "Seattle",
    "zip": 98103,
    "concatenated_address": "3635 Woodland Park Ave N, Seattle",
    "address": "3635 Woodland Park Ave. N., Seattle"
  },
  {
    "id": 1163,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "The Mill At First Hill",
    "latitude": 47.608355,
    "longitude": -122.3285,
    "original_address": "1000 8th Avenue",
    "building_number": 1000,
    "street": "8th Ave",
    "city": "Seattle",
    "zip": 98104,
    "concatenated_address": "1000 8th Ave, Seattle",
    "address": "1000 8th Ave., Seattle"
  },
  {
    "id": 1164,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Leeward Apartments",
    "latitude": 47.630792,
    "longitude": -122.34245,
    "original_address": "1309 Dexter Avenue North",
    "building_number": 1309,
    "street": "Dexter Ave N",
    "city": "Seattle",
    "zip": 98109,
    "concatenated_address": "1309 Dexter Ave N, Seattle",
    "address": "1309 Dexter Ave. N., Seattle"
  },
  {
    "id": 1165,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Terrazza",
    "latitude": 47.605685,
    "longitude": -122.31847,
    "original_address": "413 11th Avenue",
    "building_number": 413,
    "street": "11th Ave",
    "city": "Seattle",
    "zip": 98122,
    "concatenated_address": "413 11th Ave, Seattle",
    "address": "413 11th Ave., Seattle"
  },
  {
    "id": 1166,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Solana",
    "latitude": 47.599759,
    "longitude": -122.31003,
    "original_address": "310 17th Avenue South",
    "building_number": 310,
    "street": "17th Ave S",
    "city": "Seattle",
    "zip": 98144,
    "concatenated_address": "310 17th Ave S, Seattle",
    "address": "310 17th Ave. S., Seattle"
  },
  {
    "id": 1167,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Angeline Apartments",
    "latitude": 47.559275,
    "longitude": -122.28675,
    "original_address": "4801 Rainier Ave S",
    "building_number": 4801,
    "street": "Rainier Ave S",
    "city": "Seattle",
    "zip": 98118,
    "concatenated_address": "4801 Rainier Ave S, Seattle",
    "address": "4801 Rainier Ave. S., Seattle"
  },
  {
    "id": 1168,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Youngstown Flats",
    "latitude": 47.567083,
    "longitude": -122.36495,
    "original_address": "4040 26th Avenue Southwest",
    "building_number": 4040,
    "street": "26th Ave SW",
    "city": "Seattle",
    "zip": 98106,
    "concatenated_address": "4040 26th Ave SW, Seattle",
    "address": "4040 26th Ave. S.W., Seattle"
  },
  {
    "id": 1169,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Rollin Street Flats",
    "latitude": 47.61921,
    "longitude": -122.33807,
    "original_address": "120 Westlake Avenue North",
    "building_number": 120,
    "street": "Westlake Ave N",
    "city": "Seattle",
    "zip": 98109,
    "concatenated_address": "120 Westlake Ave N, Seattle",
    "address": "120 Westlake Ave. N., Seattle"
  },
  {
    "id": 1170,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Zephyr Apartments",
    "latitude": 47.619956,
    "longitude": -122.32381,
    "original_address": "200 Belmont Avenue East",
    "building_number": 200,
    "street": "Belmont Ave E",
    "city": "Seattle",
    "zip": 98102,
    "concatenated_address": "200 Belmont Ave E, Seattle",
    "address": "200 Belmont Ave. E., Seattle"
  },
  {
    "id": 1171,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "The Blake Apartments",
    "latitude": 47.556671,
    "longitude": -122.38648,
    "original_address": "5020 California Avenue Sw",
    "building_number": 5020,
    "street": "California Ave SW",
    "city": "Seattle",
    "zip": 98136,
    "concatenated_address": "5020 California Ave SW, Seattle",
    "address": "5020 California Ave. S.W., Seattle"
  },
  {
    "id": 1172,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "The Madison",
    "latitude": 47.608222,
    "longitude": -122.32747,
    "original_address": "823 Madison Street",
    "building_number": 823,
    "street": "Madison St",
    "city": "Seattle",
    "zip": 98104,
    "concatenated_address": "823 Madison St, Seattle",
    "address": "823 Madison St., Seattle"
  },
  {
    "id": 1173,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "The Overlook At Westridge",
    "latitude": 47.532126,
    "longitude": -122.34509,
    "original_address": "600 Southwest Kenyon Street",
    "building_number": 600,
    "street": "SW Kenyon St",
    "city": "Seattle",
    "zip": 98106,
    "concatenated_address": "600 SW Kenyon St, Seattle",
    "address": "600 S.W. Kenyon St., Seattle"
  },
  {
    "id": 1174,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Footprint 1806",
    "latitude": 47.617956,
    "longitude": -122.3022,
    "original_address": "1806 23rd Avenue",
    "building_number": 1806,
    "street": "23rd Ave",
    "city": "Seattle",
    "zip": 98122,
    "concatenated_address": "1806 23rd Ave, Seattle",
    "address": "1806 23rd Ave., Seattle"
  },
  {
    "id": 1175,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Muriels Landing",
    "latitude": 47.667836,
    "longitude": -122.31283,
    "original_address": "5240 University Way Ne",
    "building_number": 5240,
    "street": "University Way NE",
    "city": "Seattle",
    "zip": 98105,
    "concatenated_address": "5240 University Way NE, Seattle",
    "address": "5240 University Way N.E., Seattle"
  },
  {
    "id": 1176,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Verse Seattle",
    "latitude": 47.598957,
    "longitude": -122.30301,
    "original_address": "402 22nd Avenue South",
    "building_number": 402,
    "street": "22nd Ave S",
    "city": "Seattle",
    "zip": 98144,
    "concatenated_address": "402 22nd Ave S, Seattle",
    "address": "402 22nd Ave. S., Seattle"
  },
  {
    "id": 1177,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Dexter Hayes Apartments",
    "latitude": 47.634003,
    "longitude": -122.34266,
    "original_address": "1701 Dexter Avenue North",
    "building_number": 1701,
    "street": "Dexter Ave N",
    "city": "Seattle",
    "zip": 98109,
    "concatenated_address": "1701 Dexter Ave N, Seattle",
    "address": "1701 Dexter Ave. N., Seattle"
  },
  {
    "id": 1178,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Sunset Park Apartments",
    "latitude": 47.502258,
    "longitude": -122.33706,
    "original_address": "11202 2nd Lane Sw",
    "building_number": 11202,
    "street": "2nd Ln SW",
    "city": "Seattle",
    "zip": 98146,
    "concatenated_address": "11202 2nd Ln SW, Seattle",
    "address": "11202 2nd Lane S.W., Seattle"
  },
  {
    "id": 1179,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "The Beacon Apartments",
    "latitude": 47.572316,
    "longitude": -122.31435,
    "original_address": "1410 South Columbian Way",
    "building_number": 1410,
    "street": "S Columbian Way",
    "city": "Seattle",
    "zip": 98144,
    "concatenated_address": "1410 S Columbian Way, Seattle",
    "address": "1410 S. Columbian Way, Seattle"
  },
  {
    "id": 1180,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Hollywood Lofts",
    "latitude": 47.619587,
    "longitude": -122.32128,
    "original_address": "127 Broadway East",
    "building_number": 127,
    "street": "Broadway E",
    "city": "Seattle",
    "zip": 98102,
    "concatenated_address": "127 Broadway E, Seattle",
    "address": "127 Broadway E., Seattle"
  },
  {
    "id": 1181,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Starlight Apartments",
    "latitude": 47.606354,
    "longitude": -122.32461,
    "original_address": "915 Cherry Street",
    "building_number": 915,
    "street": "Cherry St",
    "city": "Seattle",
    "zip": 98104,
    "concatenated_address": "915 Cherry St, Seattle",
    "address": "915 Cherry St., Seattle"
  },
  {
    "id": 1182,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Bridge Park",
    "latitude": 47.545,
    "longitude": -122.37362,
    "original_address": "3204 Sw Morgan Street",
    "building_number": 3204,
    "street": "SW Morgan St",
    "city": "Seattle",
    "zip": 98126,
    "concatenated_address": "3204 SW Morgan St, Seattle",
    "address": "3204 S.W. Morgan St., Seattle"
  },
  {
    "id": 1183,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Westhaven Apartments",
    "latitude": 47.532074,
    "longitude": -122.36288,
    "original_address": "2201 Southwest Holden Street",
    "building_number": 2201,
    "street": "SW Holden St",
    "city": "Seattle",
    "zip": 98106,
    "concatenated_address": "2201 SW Holden St, Seattle",
    "address": "2201 S.W. Holden St., Seattle"
  },
  {
    "id": 1184,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Queen City Apartments",
    "latitude": 47.661181,
    "longitude": -122.3369,
    "original_address": "1707 N. 45th Street",
    "building_number": 1707,
    "street": "N 45th St",
    "city": "Seattle",
    "zip": 98103,
    "concatenated_address": "1707 N 45th St, Seattle",
    "address": "1707 N. 45th St., Seattle"
  },
  {
    "id": 1185,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "The Luxe At Meridian",
    "latitude": 47.703463,
    "longitude": -122.33315,
    "original_address": "10306 Meridian Avenue North",
    "building_number": 10306,
    "street": "Meridian Ave N",
    "city": "Seattle",
    "zip": 98133,
    "concatenated_address": "10306 Meridian Ave N, Seattle",
    "address": "10306 Meridian Ave. N., Seattle"
  },
  {
    "id": 1186,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Mirrorwood Apartments",
    "latitude": 47.733514,
    "longitude": -122.29682,
    "original_address": "14371 30th Avenue Northeast",
    "building_number": 14371,
    "street": "30th Ave NE",
    "city": "Seattle",
    "zip": 98125,
    "concatenated_address": "14371 30th Ave NE, Seattle",
    "address": "14371 30th Ave. N.E., Seattle"
  },
  {
    "id": 1187,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Minadoka Apartments",
    "latitude": 47.704104,
    "longitude": -122.35035,
    "original_address": "10311 Fremont Avenue North",
    "building_number": 10311,
    "street": "Fremont Ave N",
    "city": "Seattle",
    "zip": 98133,
    "concatenated_address": "10311 Fremont Ave N, Seattle",
    "address": "10311 Fremont Ave. N., Seattle"
  },
  {
    "id": 1188,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Fremont Apartments",
    "latitude": 47.660157,
    "longitude": -122.34959,
    "original_address": "4400 Fremont Avenue North",
    "building_number": 4400,
    "street": "Fremont Ave N",
    "city": "Seattle",
    "zip": 98103,
    "concatenated_address": "4400 Fremont Ave N, Seattle",
    "address": "4400 Fremont Ave. N., Seattle"
  },
  {
    "id": 1189,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Plymouth Apartments",
    "latitude": 47.636041,
    "longitude": -122.38837,
    "original_address": "2357 West Plymouth Street",
    "building_number": 2357,
    "street": "W Plymouth St",
    "city": "Seattle",
    "zip": 98199,
    "concatenated_address": "2357 W Plymouth St, Seattle",
    "address": "2357 W. Plymouth St., Seattle"
  },
  {
    "id": 1190,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Dravus Apartments",
    "latitude": 47.648177,
    "longitude": -122.38767,
    "original_address": "3047 24th Avenue West",
    "building_number": 3047,
    "street": "24th Ave W",
    "city": "Seattle",
    "zip": 98199,
    "concatenated_address": "3047 24th Ave W, Seattle",
    "address": "3047 24th Ave. W., Seattle"
  },
  {
    "id": 1191,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Boston Crest Apartments",
    "latitude": 47.638102,
    "longitude": -122.35222,
    "original_address": "215-219 Boston Street",
    "building_number": 219,
    "street": "Boston St",
    "city": "Seattle",
    "zip": 98109,
    "concatenated_address": "219 Boston St, Seattle",
    "address": "219 Boston St., Seattle"
  },
  {
    "id": 1192,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Mona Lisa Apartments",
    "latitude": 47.675769,
    "longitude": -122.38252,
    "original_address": "2001 Nw 65th Street",
    "building_number": 2001,
    "street": "NW 65th St",
    "city": "Seattle",
    "zip": 98117,
    "concatenated_address": "2001 NW 65th St, Seattle",
    "address": "2001 N.W. 65th St., Seattle"
  },
  {
    "id": 1193,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Glover Townhomes",
    "latitude": 47.69447,
    "longitude": -122.34208,
    "original_address": "9001-9007 Stone Avenue N And 1142-1156 N",
    "building_number": 9007,
    "street": "Stone Ave N",
    "city": "Seattle",
    "zip": 98103,
    "concatenated_address": "9007 Stone Ave N, Seattle",
    "address": "9007 Stone Ave. N., Seattle"
  },
  {
    "id": 1194,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Roosevelt Apartments",
    "latitude": 47.717447,
    "longitude": -122.31771,
    "original_address": "12054 Roosevelt Way Se",
    "building_number": 12054,
    "street": "Roosevelt Way NE",
    "city": "Seattle",
    "zip": 98125,
    "concatenated_address": "12054 Roosevelt Way NE, Seattle",
    "address": "12054 Roosevelt Way N.E., Seattle"
  },
  {
    "id": 1195,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Charlemagne Apartments",
    "latitude": 47.591344,
    "longitude": -122.31447,
    "original_address": "1300 14th Avenue South",
    "building_number": 1300,
    "street": "14th Ave S",
    "city": "Seattle",
    "zip": 98144,
    "concatenated_address": "1300 14th Ave S, Seattle",
    "address": "1300 14th Ave. S., Seattle"
  },
  {
    "id": 1196,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Lake Union Apartments",
    "latitude": 47.644663,
    "longitude": -122.32728,
    "original_address": "100 East Edgar St",
    "building_number": 100,
    "street": "E Edgar St",
    "city": "Seattle",
    "zip": 98102,
    "concatenated_address": "100 E Edgar St, Seattle",
    "address": "100 E. Edgar St., Seattle"
  },
  {
    "id": 1197,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Tempo Apartments",
    "latitude": 47.648227,
    "longitude": -122.38276,
    "original_address": "2015 W Dravus Street",
    "building_number": 2015,
    "street": "W Dravus St",
    "city": "Seattle",
    "zip": 98199,
    "concatenated_address": "2015 W Dravus St, Seattle",
    "address": "2015 W. Dravus St., Seattle"
  },
  {
    "id": 1198,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Whitely Manor Apartments",
    "latitude": 47.623992,
    "longitude": -122.3631,
    "original_address": "542 5th Avenue West",
    "building_number": 542,
    "street": "5th Ave W",
    "city": "Seattle",
    "zip": 98119,
    "concatenated_address": "542 5th Ave W, Seattle",
    "address": "542 5th Ave. W., Seattle"
  },
  {
    "id": 1199,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "8th And Republican",
    "latitude": 47.622725,
    "longitude": -122.34067,
    "original_address": "430 8th Avenue North",
    "building_number": 430,
    "street": "8th Ave N",
    "city": "Seattle",
    "zip": 98109,
    "concatenated_address": "430 8th Ave N, Seattle",
    "address": "430 8th Ave. N., Seattle"
  },
  {
    "id": 1200,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Westhaven Apartments",
    "latitude": 47.532074,
    "longitude": -122.36288,
    "original_address": "2201 Sw Holden St.",
    "building_number": 2201,
    "street": "SW Holden St",
    "city": "Seattle",
    "zip": 98106,
    "concatenated_address": "2201 SW Holden St, Seattle",
    "address": "2201 S.W. Holden St., Seattle"
  },
  {
    "id": 1201,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Galleria Apartments",
    "latitude": 47.705721,
    "longitude": -122.33367,
    "original_address": "10500 Meridian Avenue North",
    "building_number": 10500,
    "street": "Meridian Ave N",
    "city": "Seattle",
    "zip": 98133,
    "concatenated_address": "10500 Meridian Ave N, Seattle",
    "address": "10500 Meridian Ave. N., Seattle"
  },
  {
    "id": 1202,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Terry Denny Building",
    "latitude": 47.601248,
    "longitude": -122.33456,
    "original_address": "111 First Avenue South",
    "building_number": 111,
    "street": "1st Ave S",
    "city": "Seattle",
    "zip": 98104,
    "concatenated_address": "111 1st Ave S, Seattle",
    "address": "111 1st Ave. S., Seattle"
  },
  {
    "id": 1203,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Courtland Place At Rainier Court",
    "latitude": 47.571109,
    "longitude": -122.29126,
    "original_address": "3621 33rd Avenue South",
    "building_number": 3621,
    "street": "33rd Ave S",
    "city": "Seattle",
    "zip": 98144,
    "concatenated_address": "3621 33rd Ave S, Seattle",
    "address": "3621 33rd Ave. S., Seattle"
  },
  {
    "id": 1204,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Juxt",
    "latitude": 47.626637,
    "longitude": -122.34185,
    "original_address": "810 Dexter Avenue North",
    "building_number": 810,
    "street": "Dexter Ave N",
    "city": "Seattle",
    "zip": 98109,
    "concatenated_address": "810 Dexter Ave N, Seattle",
    "address": "810 Dexter Ave. N., Seattle"
  },
  {
    "id": 1205,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Solara Apartments",
    "latitude": 47.722282,
    "longitude": -122.29318,
    "original_address": "12736 Lake City Way Northeast",
    "building_number": 12736,
    "street": "Lake City Way NE",
    "city": "Seattle",
    "zip": 98125,
    "concatenated_address": "12736 Lake City Way NE, Seattle",
    "address": "12736 Lake City Way N.E., Seattle"
  },
  {
    "id": 1206,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Oxford Crest Apartments",
    "latitude": 47.612847,
    "longitude": -122.32776,
    "original_address": "1400 Boren Avenue",
    "building_number": 1400,
    "street": "Boren Ave",
    "city": "Seattle",
    "zip": 98101,
    "concatenated_address": "1400 Boren Ave, Seattle",
    "address": "1400 Boren Ave., Seattle"
  },
  {
    "id": 1207,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Vesper Apartments",
    "latitude": 47.612019,
    "longitude": -122.32565,
    "original_address": "Minor Ave",
    "building_number": "",
    "street": "Minor Ave",
    "city": "Seattle",
    "zip": 98101,
    "concatenated_address": "Minor Ave, Seattle",
    "address": "Minor Ave., Seattle"
  },
  {
    "id": 1208,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Sunset Park Apartments",
    "latitude": 47.502258,
    "longitude": -122.33706,
    "original_address": "11202 2nd Lane Southwest",
    "building_number": 11202,
    "street": "2nd Ln SW",
    "city": "Seattle",
    "zip": 98146,
    "concatenated_address": "11202 2nd Ln SW, Seattle",
    "address": "11202 2nd Lane S.W., Seattle"
  },
  {
    "id": 1209,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Woodland Pointe Apartments",
    "latitude": 47.733731,
    "longitude": -122.34837,
    "original_address": "14359 Linden Avenue North",
    "building_number": 14359,
    "street": "Linden Ave N",
    "city": "Seattle",
    "zip": 98133,
    "concatenated_address": "14359 Linden Ave N, Seattle",
    "address": "14359 Linden Ave. N., Seattle"
  },
  {
    "id": 1210,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "West 206",
    "latitude": 47.582844,
    "longitude": -122.38648,
    "original_address": "2301 California Avenue Southwest",
    "building_number": 2301,
    "street": "California Ave SW",
    "city": "Seattle",
    "zip": 98116,
    "concatenated_address": "2301 California Ave SW, Seattle",
    "address": "2301 California Ave. S.W., Seattle"
  },
  {
    "id": 1211,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Skye At Belltown",
    "latitude": 47.617844,
    "longitude": -122.34512,
    "original_address": "500 Wall Street",
    "building_number": 500,
    "street": "Wall St",
    "city": "Seattle",
    "zip": 98121,
    "concatenated_address": "500 Wall St, Seattle",
    "address": "500 Wall St., Seattle"
  },
  {
    "id": 1212,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Avanti Apartments",
    "latitude": 47.612584,
    "longitude": -122.32846,
    "original_address": "1401 Boren Avenue",
    "building_number": 1401,
    "street": "Boren Ave",
    "city": "Seattle",
    "zip": 98101,
    "concatenated_address": "1401 Boren Ave, Seattle",
    "address": "1401 Boren Ave., Seattle"
  },
  {
    "id": 1213,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Centro",
    "latitude": 47.620132,
    "longitude": -122.31523,
    "original_address": "1304 East John Street",
    "building_number": 1304,
    "street": "E John St",
    "city": "Seattle",
    "zip": 98102,
    "concatenated_address": "1304 E John St, Seattle",
    "address": "1304 E. John St., Seattle"
  },
  {
    "id": 1214,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Alturra",
    "latitude": 47.621089,
    "longitude": -122.32504,
    "original_address": "306 Summit Avenue East",
    "building_number": 306,
    "street": "Summit Ave E",
    "city": "Seattle",
    "zip": 98102,
    "concatenated_address": "306 Summit Ave E, Seattle",
    "address": "306 Summit Ave. E., Seattle"
  },
  {
    "id": 1215,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Oregon 42 Apartments",
    "latitude": 47.562647,
    "longitude": -122.38508,
    "original_address": "4502 42nd Avenue Southwest",
    "building_number": 4502,
    "street": "42nd Ave SW",
    "city": "Seattle",
    "zip": 98116,
    "concatenated_address": "4502 42nd Ave SW, Seattle",
    "address": "4502 42nd Ave. S.W., Seattle"
  },
  {
    "id": 1216,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Squire Park Apartments",
    "latitude": 47.599539,
    "longitude": -122.30976,
    "original_address": "1710 South Jackson Street",
    "building_number": 1710,
    "street": "S Jackson St",
    "city": "Seattle",
    "zip": 98144,
    "concatenated_address": "1710 S Jackson St, Seattle",
    "address": "1710 S. Jackson St., Seattle"
  },
  {
    "id": 1217,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Cadence Apartments",
    "latitude": 47.668843,
    "longitude": -122.39762,
    "original_address": "3040 Northwest Market Street",
    "building_number": 3040,
    "street": "NW Market St",
    "city": "Seattle",
    "zip": 98107,
    "concatenated_address": "3040 NW Market St, Seattle",
    "address": "3040 N.W. Market St., Seattle"
  },
  {
    "id": 1218,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Mad Flats",
    "latitude": 47.614765,
    "longitude": -122.31171,
    "original_address": "1523 East Madison Street",
    "building_number": 1523,
    "street": "E Madison St",
    "city": "Seattle",
    "zip": 98122,
    "concatenated_address": "1523 E Madison St, Seattle",
    "address": "1523 E. Madison St., Seattle"
  },
  {
    "id": 1219,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Avanti Apartments",
    "latitude": 47.612584,
    "longitude": -122.32846,
    "original_address": "1401 Boren Ave",
    "building_number": 1401,
    "street": "Boren Ave",
    "city": "Seattle",
    "zip": 98101,
    "concatenated_address": "1401 Boren Ave, Seattle",
    "address": "1401 Boren Ave., Seattle"
  },
  {
    "id": 1220,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "621 12th Avenue East",
    "latitude": 47.624907,
    "longitude": -122.31702,
    "original_address": "621 12th Avenue East",
    "building_number": 621,
    "street": "12th Ave E",
    "city": "Seattle",
    "zip": 98102,
    "concatenated_address": "621 12th Ave E, Seattle",
    "address": "621 12th Ave. E., Seattle"
  },
  {
    "id": 1221,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "918 North 103rd Street",
    "latitude": 47.703824,
    "longitude": -122.34647,
    "original_address": "918 North 103rd Street",
    "building_number": 918,
    "street": "N 103rd St",
    "city": "Seattle",
    "zip": 98133,
    "concatenated_address": "918 N 103rd St, Seattle",
    "address": "918 N. 103rd St., Seattle"
  },
  {
    "id": 1222,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "7429 Rainier Avenue South",
    "latitude": 47.534948,
    "longitude": -122.27032,
    "original_address": "7429 Rainier Avenue South",
    "building_number": 7429,
    "street": "Rainier Ave S",
    "city": "Seattle",
    "zip": 98118,
    "concatenated_address": "7429 Rainier Ave S, Seattle",
    "address": "7429 Rainier Ave. S., Seattle"
  },
  {
    "id": 1223,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "4710 11th Avenue Northeast",
    "latitude": 47.663544,
    "longitude": -122.31607,
    "original_address": "4710 11th Avenue Northeast",
    "building_number": 4710,
    "street": "11th Ave NE",
    "city": "Seattle",
    "zip": 98105,
    "concatenated_address": "4710 11th Ave NE, Seattle",
    "address": "4710 11th Ave. N.E., Seattle"
  },
  {
    "id": 1224,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "1800 Eastlake Avenue East",
    "latitude": 47.635314,
    "longitude": -122.32501,
    "original_address": "1800 Eastlake Avenue East",
    "building_number": 1800,
    "street": "Eastlake Ave E",
    "city": "Seattle",
    "zip": 98102,
    "concatenated_address": "1800 Eastlake Ave E, Seattle",
    "address": "1800 Eastlake Ave. E., Seattle"
  },
  {
    "id": 1225,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "704 East Thomas Street",
    "latitude": 47.621195,
    "longitude": -122.32271,
    "original_address": "704 East Thomas Street",
    "building_number": 704,
    "street": "E Thomas St",
    "city": "Seattle",
    "zip": 98102,
    "concatenated_address": "704 E Thomas St, Seattle",
    "address": "704 E. Thomas St., Seattle"
  },
  {
    "id": 1226,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "1630 Boylston Avenue",
    "latitude": 47.616192,
    "longitude": -122.32309,
    "original_address": "1630 Boylston Avenue",
    "building_number": 1630,
    "street": "Boylston Ave",
    "city": "Seattle",
    "zip": 98122,
    "concatenated_address": "1630 Boylston Ave, Seattle",
    "address": "1630 Boylston Ave., Seattle"
  },
  {
    "id": 1227,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "235 Bellevue Avenue East",
    "latitude": 47.62037,
    "longitude": -122.32704,
    "original_address": "235 Bellevue Avenue East",
    "building_number": 235,
    "street": "Bellevue Ave E",
    "city": "Seattle",
    "zip": 98102,
    "concatenated_address": "235 Bellevue Ave E, Seattle",
    "address": "235 Bellevue Ave. E., Seattle"
  },
  {
    "id": 1228,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "203 Belmont Avenue East",
    "latitude": 47.619832,
    "longitude": -122.32434,
    "original_address": "203 Belmont Avenue East",
    "building_number": 203,
    "street": "Belmont Ave E",
    "city": "Seattle",
    "zip": 98102,
    "concatenated_address": "203 Belmont Ave E, Seattle",
    "address": "203 Belmont Ave. E., Seattle"
  },
  {
    "id": 1229,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "614 South Jackson Street",
    "latitude": 47.599346,
    "longitude": -122.32561,
    "original_address": "614 South Jackson Street",
    "building_number": 614,
    "street": "S Jackson St",
    "city": "Seattle",
    "zip": 98104,
    "concatenated_address": "614 S Jackson St, Seattle",
    "address": "614 S. Jackson St., Seattle"
  },
  {
    "id": 1230,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "1629 Summit Avenue",
    "latitude": 47.616097,
    "longitude": -122.32591,
    "original_address": "1629 Summit Avenue",
    "building_number": 1629,
    "street": "Summit Ave",
    "city": "Seattle",
    "zip": 98122,
    "concatenated_address": "1629 Summit Ave, Seattle",
    "address": "1629 Summit Ave., Seattle"
  },
  {
    "id": 1231,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "6023 Southwest Stevens Street",
    "latitude": 47.577536,
    "longitude": -122.4103,
    "original_address": "6023 Southwest Stevens Street",
    "building_number": 6023,
    "street": "SW Stevens St",
    "city": "Seattle",
    "zip": 98116,
    "concatenated_address": "6023 SW Stevens St, Seattle",
    "address": "6023 S.W. Stevens St., Seattle"
  },
  {
    "id": 1232,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "623 Federal Avenue East",
    "latitude": 47.624991,
    "longitude": -122.31902,
    "original_address": "623 Federal Avenue East",
    "building_number": 623,
    "street": "Federal Ave E",
    "city": "Seattle",
    "zip": 98102,
    "concatenated_address": "623 Federal Ave E, Seattle",
    "address": "623 Federal Ave. E., Seattle"
  },
  {
    "id": 1233,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "5408 Meridian Avenue North",
    "latitude": 47.668218,
    "longitude": -122.33335,
    "original_address": "5408 Meridian Avenue North",
    "building_number": 5408,
    "street": "Meridian Ave N",
    "city": "Seattle",
    "zip": 98103,
    "concatenated_address": "5408 Meridian Ave N, Seattle",
    "address": "5408 Meridian Ave. N., Seattle"
  },
  {
    "id": 1234,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "7000 Roosevelt Way Northeast",
    "latitude": 47.679689,
    "longitude": -122.31713,
    "original_address": "7000 Roosevelt Way Northeast",
    "building_number": 7000,
    "street": "Roosevelt Way NE",
    "city": "Seattle",
    "zip": 98115,
    "concatenated_address": "7000 Roosevelt Way NE, Seattle",
    "address": "7000 Roosevelt Way N.E., Seattle"
  },
  {
    "id": 1235,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "1305 Queen Anne Avenue North",
    "latitude": 47.630566,
    "longitude": -122.35701,
    "original_address": "1305 Queen Anne Avenue North",
    "building_number": 1305,
    "street": "Queen Anne Ave N",
    "city": "Seattle",
    "zip": 98109,
    "concatenated_address": "1305 Queen Anne Ave N, Seattle",
    "address": "1305 Queen Anne Ave. N., Seattle"
  },
  {
    "id": 1236,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "744 Belmont Place East",
    "latitude": 47.626772,
    "longitude": -122.32406,
    "original_address": "744 Belmont Place East",
    "building_number": 744,
    "street": "Belmont Pl E",
    "city": "Seattle",
    "zip": 98102,
    "concatenated_address": "744 Belmont Pl E, Seattle",
    "address": "744 Belmont Pl E., Seattle"
  },
  {
    "id": 1237,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "2518, 2520 And 2522 32nd Avenue West",
    "latitude": 47.651371,
    "longitude": -122.40735,
    "original_address": "2518, 2520 And 2522 32nd Avenue West",
    "building_number": "",
    "street": "",
    "city": "Seattle",
    "zip": 98199,
    "concatenated_address": "2518, 2520 And 2522 32nd Avenue West, Seattle",
    "address": "2518, 2520 And 2522 32nd Avenue West, Seattle"
  },
  {
    "id": 1238,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "1717 Bellevue Avenue",
    "latitude": 47.617695,
    "longitude": -122.32701,
    "original_address": "1717 Bellevue Avenue",
    "building_number": 1717,
    "street": "Bellevue Ave",
    "city": "Seattle",
    "zip": 98122,
    "concatenated_address": "1717 Bellevue Ave, Seattle",
    "address": "1717 Bellevue Ave., Seattle"
  },
  {
    "id": 1239,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "1121 17th Avenue",
    "latitude": 47.612202,
    "longitude": -122.31051,
    "original_address": "1121 17th Avenue",
    "building_number": 1121,
    "street": "17th Ave",
    "city": "Seattle",
    "zip": 98122,
    "concatenated_address": "1121 17th Ave, Seattle",
    "address": "1121 17th Ave., Seattle"
  },
  {
    "id": 1240,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "400 12th Avenue East",
    "latitude": 47.622136,
    "longitude": -122.31643,
    "original_address": "400 12th Avenue East",
    "building_number": 400,
    "street": "12th Ave E",
    "city": "Seattle",
    "zip": 98102,
    "concatenated_address": "400 12th Ave E, Seattle",
    "address": "400 12th Ave. E., Seattle"
  },
  {
    "id": 1241,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "7201 6th Avenue Northeast",
    "latitude": 47.681122,
    "longitude": -122.32202,
    "original_address": "7201 6th Avenue Northeast",
    "building_number": 7201,
    "street": "6th Ave NE",
    "city": "Seattle",
    "zip": 98115,
    "concatenated_address": "7201 6th Ave NE, Seattle",
    "address": "7201 6th Ave. N.E., Seattle"
  },
  {
    "id": 1242,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "404 Terry Avenue",
    "latitude": 47.60501,
    "longitude": -122.32211,
    "original_address": "404 Terry Avenue",
    "building_number": 404,
    "street": "Terry Ave",
    "city": "Seattle",
    "zip": 98104,
    "concatenated_address": "404 Terry Ave, Seattle",
    "address": "404 Terry Ave., Seattle"
  },
  {
    "id": 1243,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "1000 1st Avenue West",
    "latitude": 47.627997,
    "longitude": -122.35769,
    "original_address": "1000 1st Avenue West",
    "building_number": 1000,
    "street": "1st Ave W",
    "city": "Seattle",
    "zip": 98119,
    "concatenated_address": "1000 1st Ave W, Seattle",
    "address": "1000 1st Ave. W., Seattle"
  },
  {
    "id": 1244,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "1733 Boylston Avenue",
    "latitude": 47.617349,
    "longitude": -122.32379,
    "original_address": "1733 Boylston Avenue",
    "building_number": 1733,
    "street": "Boylston Ave",
    "city": "Seattle",
    "zip": 98122,
    "concatenated_address": "1733 Boylston Ave, Seattle",
    "address": "1733 Boylston Ave., Seattle"
  },
  {
    "id": 1245,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "12003 15th Avenue Northeast",
    "latitude": 47.715959,
    "longitude": -122.31296,
    "original_address": "12003 15th Avenue Northeast",
    "building_number": 12003,
    "street": "15th Ave NE",
    "city": "Seattle",
    "zip": 98125,
    "concatenated_address": "12003 15th Ave NE, Seattle",
    "address": "12003 15th Ave. N.E., Seattle"
  },
  {
    "id": 1246,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "4116 12th Avenue Northeast",
    "latitude": 47.657491,
    "longitude": -122.31521,
    "original_address": "4116 12th Avenue Northeast",
    "building_number": 4116,
    "street": "12th Ave NE",
    "city": "Seattle",
    "zip": 98105,
    "concatenated_address": "4116 12th Ave NE, Seattle",
    "address": "4116 12th Ave. N.E., Seattle"
  },
  {
    "id": 1247,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "372 Aloha Street",
    "latitude": 47.62737,
    "longitude": -122.34906,
    "original_address": "372 Aloha Street",
    "building_number": 372,
    "street": "Aloha St",
    "city": "Seattle",
    "zip": 98109,
    "concatenated_address": "372 Aloha St, Seattle",
    "address": "372 Aloha St., Seattle"
  },
  {
    "id": 1248,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "3237 14th Avenue West",
    "latitude": 47.649717,
    "longitude": -122.3753,
    "original_address": "3237 14th Avenue West",
    "building_number": 3237,
    "street": "14th Ave W",
    "city": "Seattle",
    "zip": 98119,
    "concatenated_address": "3237 14th Ave W, Seattle",
    "address": "3237 14th Ave. W., Seattle"
  },
  {
    "id": 1249,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "510 East Thomas Street",
    "latitude": 47.620957,
    "longitude": -122.32499,
    "original_address": "510 East Thomas Street",
    "building_number": 510,
    "street": "E Thomas St",
    "city": "Seattle",
    "zip": 98102,
    "concatenated_address": "510 E Thomas St, Seattle",
    "address": "510 E. Thomas St., Seattle"
  },
  {
    "id": 1250,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "205 Summit Avenue East",
    "latitude": 47.619826,
    "longitude": -122.32551,
    "original_address": "205 Summit Avenue East",
    "building_number": 205,
    "street": "Summit Ave E",
    "city": "Seattle",
    "zip": 98102,
    "concatenated_address": "205 Summit Ave E, Seattle",
    "address": "205 Summit Ave. E., Seattle"
  },
  {
    "id": 1251,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "2350 Beacon Avenue South",
    "latitude": 47.582152,
    "longitude": -122.31555,
    "original_address": "2350 Beacon Avenue South",
    "building_number": 2350,
    "street": "Beacon Ave S",
    "city": "Seattle",
    "zip": 98144,
    "concatenated_address": "2350 Beacon Ave S, Seattle",
    "address": "2350 Beacon Ave. S., Seattle"
  },
  {
    "id": 1252,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "1 West Highland Drive",
    "latitude": 47.629327,
    "longitude": -122.35702,
    "original_address": "1 West Highland Drive",
    "building_number": 1,
    "street": "W Highland Dr",
    "city": "Seattle",
    "zip": 98119,
    "concatenated_address": "1 W Highland Dr, Seattle",
    "address": "1 W. Highland Drive, Seattle"
  },
  {
    "id": 1253,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "1320 Boren Avenue",
    "latitude": 47.612165,
    "longitude": -122.32736,
    "original_address": "1320 Boren Avenue",
    "building_number": 1320,
    "street": "Boren Ave",
    "city": "Seattle",
    "zip": 98101,
    "concatenated_address": "1320 Boren Ave, Seattle",
    "address": "1320 Boren Ave., Seattle"
  },
  {
    "id": 1254,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "163 Etruria Street",
    "latitude": 47.647562,
    "longitude": -122.35391,
    "original_address": "163 Etruria Street",
    "building_number": 163,
    "street": "Etruria St",
    "city": "Seattle",
    "zip": 98109,
    "concatenated_address": "163 Etruria St, Seattle",
    "address": "163 Etruria St., Seattle"
  },
  {
    "id": 1255,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "711 2nd Avenue North",
    "latitude": 47.625775,
    "longitude": -122.35306,
    "original_address": "711 2nd Avenue North",
    "building_number": 711,
    "street": "2nd Ave N",
    "city": "Seattle",
    "zip": 98109,
    "concatenated_address": "711 2nd Ave N, Seattle",
    "address": "711 2nd Ave. N., Seattle"
  },
  {
    "id": 1256,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "1408 Northwest 63rd Street",
    "latitude": 47.674775,
    "longitude": -122.37413,
    "original_address": "1408 Northwest 63rd Street",
    "building_number": 1408,
    "street": "NW 63rd St",
    "city": "Seattle",
    "zip": 98107,
    "concatenated_address": "1408 NW 63rd St, Seattle",
    "address": "1408 N.W. 63rd St., Seattle"
  },
  {
    "id": 1257,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "1021 North 50th Street",
    "latitude": 47.664856,
    "longitude": -122.34494,
    "original_address": "1021 North 50th Street",
    "building_number": 1021,
    "street": "N 50th St",
    "city": "Seattle",
    "zip": 98103,
    "concatenated_address": "1021 N 50th St, Seattle",
    "address": "1021 N. 50th St., Seattle"
  },
  {
    "id": 1258,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "410 Northwest 58th Street",
    "latitude": 47.670987,
    "longitude": -122.36247,
    "original_address": "410 Northwest 58th Street",
    "building_number": 410,
    "street": "NW 58th St",
    "city": "Seattle",
    "zip": 98107,
    "concatenated_address": "410 NW 58th St, Seattle",
    "address": "410 N.W. 58th St., Seattle"
  },
  {
    "id": 1259,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "1006 15th Avenue East",
    "latitude": 47.627863,
    "longitude": -122.31226,
    "original_address": "1006 15th Avenue East",
    "building_number": 1006,
    "street": "15th Ave E",
    "city": "Seattle",
    "zip": 98112,
    "concatenated_address": "1006 15th Ave E, Seattle",
    "address": "1006 15th Ave. E., Seattle"
  },
  {
    "id": 1260,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "4312 Francis Avenue North",
    "latitude": 47.659384,
    "longitude": -122.35292,
    "original_address": "4312 Francis Avenue North",
    "building_number": 4312,
    "street": "Francis Ave N",
    "city": "Seattle",
    "zip": 98103,
    "concatenated_address": "4312 Francis Ave N, Seattle",
    "address": "4312 Francis Ave. N., Seattle"
  },
  {
    "id": 1261,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "1519 Northwest 65th Street",
    "latitude": 47.675783,
    "longitude": -122.37701,
    "original_address": "1519 Northwest 65th Street",
    "building_number": 1519,
    "street": "NW 65th St",
    "city": "Seattle",
    "zip": 98117,
    "concatenated_address": "1519 NW 65th St, Seattle",
    "address": "1519 N.W. 65th St., Seattle"
  },
  {
    "id": 1262,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "1531 Northwest 53rd Street",
    "latitude": 47.666939,
    "longitude": -122.37764,
    "original_address": "1531 Northwest 53rd Street",
    "building_number": 1531,
    "street": "NW 53rd St",
    "city": "Seattle",
    "zip": 98107,
    "concatenated_address": "1531 NW 53rd St, Seattle",
    "address": "1531 N.W. 53rd St., Seattle"
  },
  {
    "id": 1263,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Brookdale Admiral Heights",
    "latitude": 47.582121,
    "longitude": -122.38611,
    "original_address": "2326 California Avenue Southwest",
    "building_number": 2326,
    "street": "California Ave SW",
    "city": "Seattle",
    "zip": 98116,
    "concatenated_address": "2326 California Ave SW, Seattle",
    "address": "2326 California Ave. S.W., Seattle"
  },
  {
    "id": 1264,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Brookdale West Seattle",
    "latitude": 47.561785,
    "longitude": -122.37651,
    "original_address": "4611 35th Avenue Southwest",
    "building_number": 4611,
    "street": "35th Ave SW",
    "city": "Seattle",
    "zip": 98126,
    "concatenated_address": "4611 35th Ave SW, Seattle",
    "address": "4611 35th Ave. S.W., Seattle"
  },
  {
    "id": 1265,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Creston Point Apartments",
    "latitude": 47.48156,
    "longitude": -122.24646,
    "original_address": "13445 Martin Luther King Jr. Way South",
    "building_number": 13445,
    "street": "Martin Luther King Jr Way S",
    "city": "Seattle",
    "zip": 98178,
    "concatenated_address": "13445 Martin Luther King Jr Way S, Seattle",
    "address": "13445 Martin Luther King Jr Way S., Seattle"
  },
  {
    "id": 1266,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Westlake Steps",
    "latitude": 47.630065,
    "longitude": -122.3413,
    "original_address": "1207 Westlake Avenue North",
    "building_number": 1207,
    "street": "Westlake Ave N",
    "city": "Seattle",
    "zip": 98109,
    "concatenated_address": "1207 Westlake Ave N, Seattle",
    "address": "1207 Westlake Ave. N., Seattle"
  },
  {
    "id": 1267,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "One Lakefront",
    "latitude": 47.631978,
    "longitude": -122.34134,
    "original_address": "1287 Westlake Avenue North",
    "building_number": 1287,
    "street": "Westlake Ave N",
    "city": "Seattle",
    "zip": 98109,
    "concatenated_address": "1287 Westlake Ave N, Seattle",
    "address": "1287 Westlake Ave. N., Seattle"
  },
  {
    "id": 1268,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "The Overlook At Westridge",
    "latitude": 47.532126,
    "longitude": -122.34509,
    "original_address": "600 Sw Kenyon Street",
    "building_number": 600,
    "street": "SW Kenyon St",
    "city": "Seattle",
    "zip": 98106,
    "concatenated_address": "600 SW Kenyon St, Seattle",
    "address": "600 S.W. Kenyon St., Seattle"
  },
  {
    "id": 1269,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Anew Terry Apartments",
    "latitude": 47.605035,
    "longitude": -122.32318,
    "original_address": "423 Terry Avenue",
    "building_number": 423,
    "street": "Terry Ave",
    "city": "Seattle",
    "zip": 98104,
    "concatenated_address": "423 Terry Ave, Seattle",
    "address": "423 Terry Ave., Seattle"
  },
  {
    "id": 1270,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Pike Flats",
    "latitude": 47.614218,
    "longitude": -122.32239,
    "original_address": "722 East Pike Street",
    "building_number": 722,
    "street": "E Pike St",
    "city": "Seattle",
    "zip": 98122,
    "concatenated_address": "722 E Pike St, Seattle",
    "address": "722 E. Pike St., Seattle"
  },
  {
    "id": 1271,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "The Bluestone Apartments",
    "latitude": 47.521363,
    "longitude": -122.35946,
    "original_address": "9051 20th Avenue Southwest",
    "building_number": 9051,
    "street": "20th Ave SW",
    "city": "Seattle",
    "zip": 98106,
    "concatenated_address": "9051 20th Ave SW, Seattle",
    "address": "9051 20th Ave. S.W., Seattle"
  },
  {
    "id": 1272,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Maude Urban Living",
    "latitude": 47.677519,
    "longitude": -122.31844,
    "original_address": "836 Northeast 67th Street",
    "building_number": 836,
    "street": "NE 67th St",
    "city": "Seattle",
    "zip": 98115,
    "concatenated_address": "836 NE 67th St, Seattle",
    "address": "836 N.E. 67th St., Seattle"
  },
  {
    "id": 1273,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Etta Ballard Apartments",
    "latitude": 47.670405,
    "longitude": -122.37983,
    "original_address": "1710 Northwest 57th Street",
    "building_number": 1710,
    "street": "NW 57th St",
    "city": "Seattle",
    "zip": 98107,
    "concatenated_address": "1710 NW 57th St, Seattle",
    "address": "1710 N.W. 57th St., Seattle"
  },
  {
    "id": 1274,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Minor Tower Apartments",
    "latitude": 47.642723,
    "longitude": -122.32866,
    "original_address": "2525 Minor Avenue E.",
    "building_number": 2525,
    "street": "Minor Ave E",
    "city": "Seattle",
    "zip": 98102,
    "concatenated_address": "2525 Minor Ave E, Seattle",
    "address": "2525 Minor Ave. E., Seattle"
  },
  {
    "id": 1275,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "1415 1st Avenue North",
    "latitude": 47.631875,
    "longitude": -122.35582,
    "original_address": "1415 1st Avenue N",
    "building_number": 1415,
    "street": "1st Ave N",
    "city": "Seattle",
    "zip": 98109,
    "concatenated_address": "1415 1st Ave N, Seattle",
    "address": "1415 1st Ave. N., Seattle"
  },
  {
    "id": 1276,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "The Agena Apartments",
    "latitude": 47.711645,
    "longitude": -122.29894,
    "original_address": "2711 Ne 115th Street",
    "building_number": 2711,
    "street": "NE 115th St",
    "city": "Seattle",
    "zip": 98125,
    "concatenated_address": "2711 NE 115th St, Seattle",
    "address": "2711 N.E. 115th St., Seattle"
  },
  {
    "id": 1277,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Hawthorne Place",
    "latitude": 47.667665,
    "longitude": -122.28507,
    "original_address": "5231 40th Avenue Ne",
    "building_number": 5231,
    "street": "40th Ave NE",
    "city": "Seattle",
    "zip": 98105,
    "concatenated_address": "5231 40th Ave NE, Seattle",
    "address": "5231 40th Ave. N.E., Seattle"
  },
  {
    "id": 1278,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Ponderay Apartments",
    "latitude": 47.670242,
    "longitude": -122.31222,
    "original_address": "5625 15th Ave Ne",
    "building_number": 5625,
    "street": "15th Ave NE",
    "city": "Seattle",
    "zip": 98105,
    "concatenated_address": "5625 15th Ave NE, Seattle",
    "address": "5625 15th Ave. N.E., Seattle"
  },
  {
    "id": 1279,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Roosevelt Park Apartments",
    "latitude": 47.720311,
    "longitude": -122.31864,
    "original_address": "12520 Roosevelt Way Ne",
    "building_number": 12520,
    "street": "Roosevelt Way NE",
    "city": "Seattle",
    "zip": 98125,
    "concatenated_address": "12520 Roosevelt Way NE, Seattle",
    "address": "12520 Roosevelt Way N.E., Seattle"
  },
  {
    "id": 1280,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Hilltop Flats",
    "latitude": 47.632459,
    "longitude": -122.35722,
    "original_address": "1501 Queen Anne Avenue North",
    "building_number": 1501,
    "street": "Queen Anne Ave N",
    "city": "Seattle",
    "zip": 98109,
    "concatenated_address": "1501 Queen Anne Ave N, Seattle",
    "address": "1501 Queen Anne Ave. N., Seattle"
  },
  {
    "id": 1281,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Ballard Heights Apartments",
    "latitude": 47.67621,
    "longitude": -122.38717,
    "original_address": "6500 24th Avenue Nw",
    "building_number": 6500,
    "street": "24th Ave NW",
    "city": "Seattle",
    "zip": 98117,
    "concatenated_address": "6500 24th Ave NW, Seattle",
    "address": "6500 24th Ave. N.W., Seattle"
  },
  {
    "id": 1282,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "The Edge Apartments",
    "latitude": 47.628213,
    "longitude": -122.34408,
    "original_address": "620 Ward Street",
    "building_number": 620,
    "street": "Ward St",
    "city": "Seattle",
    "zip": 98109,
    "concatenated_address": "620 Ward St, Seattle",
    "address": "620 Ward St., Seattle"
  },
  {
    "id": 1283,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Columbia Green",
    "latitude": 47.560537,
    "longitude": -122.2885,
    "original_address": "4700 35th Avenue South",
    "building_number": 4700,
    "street": "35th Ave S",
    "city": "Seattle",
    "zip": 98118,
    "concatenated_address": "4700 35th Ave S, Seattle",
    "address": "4700 35th Ave. S., Seattle"
  },
  {
    "id": 1284,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Capitol Hill 6 Plex",
    "latitude": 47.626557,
    "longitude": -122.31292,
    "original_address": "815 15th Avenue East",
    "building_number": 815,
    "street": "15th Ave E",
    "city": "Seattle",
    "zip": 98112,
    "concatenated_address": "815 15th Ave E, Seattle",
    "address": "815 15th Ave. E., Seattle"
  },
  {
    "id": 1285,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Cali Apartments",
    "latitude": 47.547316,
    "longitude": -122.38676,
    "original_address": "6040 California Avenue Sw",
    "building_number": 6040,
    "street": "California Ave SW",
    "city": "Seattle",
    "zip": 98136,
    "concatenated_address": "6040 California Ave SW, Seattle",
    "address": "6040 California Ave. S.W., Seattle"
  },
  {
    "id": 1286,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "California Court Apartments",
    "latitude": 47.542228,
    "longitude": -122.38695,
    "original_address": "6900 California Avenue",
    "building_number": 6900,
    "street": "California Ave SW",
    "city": "Seattle",
    "zip": 98136,
    "concatenated_address": "6900 California Ave SW, Seattle",
    "address": "6900 California Ave. S.W., Seattle"
  },
  {
    "id": 1287,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Beryllium Apartments",
    "latitude": 47.63998,
    "longitude": -122.38728,
    "original_address": "2401 Thorndyke Pl W",
    "building_number": 2401,
    "street": "Thorndyke Pl W",
    "city": "Seattle",
    "zip": 98199,
    "concatenated_address": "2401 Thorndyke Pl W, Seattle",
    "address": "2401 Thorndyke Place W., Seattle"
  },
  {
    "id": 1288,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Alki Apartments",
    "latitude": 47.573934,
    "longitude": -122.40018,
    "original_address": "3036 & 3040 60th Avenue Southwest",
    "building_number": "",
    "street": "",
    "city": "Seattle",
    "zip": 98116,
    "concatenated_address": "3036 & 3040 60th Avenue Southwest, Seattle",
    "address": "3036 & 3040 60th Avenue S.W., Seattle"
  },
  {
    "id": 1289,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "4431 Evanston",
    "latitude": 47.661158,
    "longitude": -122.35133,
    "original_address": "4431 Evanston Avenue North",
    "building_number": 4431,
    "street": "Evanston Ave N",
    "city": "Seattle",
    "zip": 98103,
    "concatenated_address": "4431 Evanston Ave N, Seattle",
    "address": "4431 Evanston Ave. N., Seattle"
  },
  {
    "id": 1290,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Duo Apartments",
    "latitude": 47.687761,
    "longitude": -122.38487,
    "original_address": "Duo Apartments",
    "building_number": "",
    "street": "",
    "city": "Seattle",
    "zip": 98117,
    "concatenated_address": "Duo Apartments, Seattle",
    "address": "Duo Apartments, Seattle"
  },
  {
    "id": 1291,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Thorndyke Apartments",
    "latitude": 47.641586,
    "longitude": -122.38596,
    "original_address": "2501 Thorndyke Avenue W",
    "building_number": 2501,
    "street": "Thorndyke Ave W",
    "city": "Seattle",
    "zip": 98199,
    "concatenated_address": "2501 Thorndyke Ave W, Seattle",
    "address": "2501 Thorndyke Ave. W., Seattle"
  },
  {
    "id": 1292,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Yardhouse Apartments",
    "latitude": 47.623324,
    "longitude": -122.31433,
    "original_address": "1406 East Republican Street",
    "building_number": 1406,
    "street": "E Republican St",
    "city": "Seattle",
    "zip": 98112,
    "concatenated_address": "1406 E Republican St, Seattle",
    "address": "1406 E. Republican St., Seattle"
  },
  {
    "id": 1293,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "3-Eighteen Apartments",
    "latitude": 47.631669,
    "longitude": -122.36135,
    "original_address": "318 West Lee Street",
    "building_number": 318,
    "street": "W Lee St",
    "city": "Seattle",
    "zip": 98119,
    "concatenated_address": "318 W Lee St, Seattle",
    "address": "318 W. Lee St., Seattle"
  },
  {
    "id": 1294,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "4059 8th Avenue Northeast",
    "latitude": 47.657369,
    "longitude": -122.32012,
    "original_address": "4059 8th Avenue Ne",
    "building_number": 4059,
    "street": "8th Ave NE",
    "city": "Seattle",
    "zip": 98105,
    "concatenated_address": "4059 8th Ave NE, Seattle",
    "address": "4059 8th Ave. N.E., Seattle"
  },
  {
    "id": 1295,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Fresco Apartments",
    "latitude": 47.567885,
    "longitude": -122.31377,
    "original_address": "3939 15th Avenue South",
    "building_number": 3939,
    "street": "15th Ave S",
    "city": "Seattle",
    "zip": 98108,
    "concatenated_address": "3939 15th Ave S, Seattle",
    "address": "3939 15th Ave. S., Seattle"
  },
  {
    "id": 1296,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Winslow Apartments",
    "latitude": 47.660006,
    "longitude": -122.34636,
    "original_address": "4314 Winslow Place North",
    "building_number": 4314,
    "street": "Winslow Pl N",
    "city": "Seattle",
    "zip": 98103,
    "concatenated_address": "4314 Winslow Pl N, Seattle",
    "address": "4314 Winslow Pl N., Seattle"
  },
  {
    "id": 1297,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Golden Leaf Apartments",
    "latitude": 47.589594,
    "longitude": -122.31713,
    "original_address": "1550 12th Avenue South",
    "building_number": 1550,
    "street": "12th Ave S",
    "city": "Seattle",
    "zip": 98144,
    "concatenated_address": "1550 12th Ave S, Seattle",
    "address": "1550 12th Ave. S., Seattle"
  },
  {
    "id": 1298,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Pinnacle Apartments",
    "latitude": 47.58941,
    "longitude": -122.31695,
    "original_address": "1516 12th Avenue South",
    "building_number": 1516,
    "street": "12th Ave S",
    "city": "Seattle",
    "zip": 98144,
    "concatenated_address": "1516 12th Ave S, Seattle",
    "address": "1516 12th Ave. S., Seattle"
  },
  {
    "id": 1299,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Pali Apartments",
    "latitude": 47.591418,
    "longitude": -122.31515,
    "original_address": "1313-1315 South Judkins Street",
    "building_number": 1315,
    "street": "S Judkins St",
    "city": "Seattle",
    "zip": 98144,
    "concatenated_address": "1315 S Judkins St, Seattle",
    "address": "1315 S. Judkins St., Seattle"
  },
  {
    "id": 1300,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Westminster Apartments",
    "latitude": 47.607714,
    "longitude": -122.32717,
    "original_address": "903 9th Avenue",
    "building_number": 903,
    "street": "9th Ave",
    "city": "Seattle",
    "zip": 98104,
    "concatenated_address": "903 9th Ave, Seattle",
    "address": "903 9th Ave., Seattle"
  },
  {
    "id": 1301,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "San Juan Apartments",
    "latitude": 47.558015,
    "longitude": -122.38651,
    "original_address": "4840 California Avenue Sw",
    "building_number": 4840,
    "street": "California Ave SW",
    "city": "Seattle",
    "zip": 98116,
    "concatenated_address": "4840 California Ave SW, Seattle",
    "address": "4840 California Ave. S.W., Seattle"
  },
  {
    "id": 1302,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Malden Apartments",
    "latitude": 47.622174,
    "longitude": -122.31347,
    "original_address": "1454 East Harrison Street",
    "building_number": 1454,
    "street": "E Harrison St",
    "city": "Seattle",
    "zip": 98112,
    "concatenated_address": "1454 E Harrison St, Seattle",
    "address": "1454 E. Harrison St., Seattle"
  },
  {
    "id": 1303,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Cinebar Apartments",
    "latitude": 47.638679,
    "longitude": -122.37095,
    "original_address": "3240 And 3250 15th Avenue West",
    "building_number": "",
    "street": "",
    "city": "Seattle",
    "zip": 98119,
    "concatenated_address": "3240 And 3250 15th Avenue West, Seattle",
    "address": "3240 and 3250 15th Ave. W., Seattle"
  },
  {
    "id": 1304,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "220 16th Apartments",
    "latitude": 47.620327,
    "longitude": -122.31121,
    "original_address": "220 16th Avenue East",
    "building_number": 220,
    "street": "16th Ave E",
    "city": "Seattle",
    "zip": 98112,
    "concatenated_address": "220 16th Ave E, Seattle",
    "address": "220 16th Ave. E., Seattle"
  },
  {
    "id": 1305,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "5949 California Apartments",
    "latitude": 47.548941,
    "longitude": -122.3875,
    "original_address": "5949 California Avenue Southwest",
    "building_number": 5949,
    "street": "California Ave SW",
    "city": "Seattle",
    "zip": 98136,
    "concatenated_address": "5949 California Ave SW, Seattle",
    "address": "5949 California Ave. S.W., Seattle"
  },
  {
    "id": 1306,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Corner Stone Apartments",
    "latitude": 47.695109,
    "longitude": -122.34216,
    "original_address": "1158 North 91st Street",
    "building_number": 1158,
    "street": "N 91st St",
    "city": "Seattle",
    "zip": 98103,
    "concatenated_address": "1158 N 91st St, Seattle",
    "address": "1158 N. 91st St., Seattle"
  },
  {
    "id": 1307,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Wallingford Terrace Apartments",
    "latitude": 47.663366,
    "longitude": -122.34695,
    "original_address": "4710 Aurora Avenue North",
    "building_number": 4710,
    "street": "Aurora Ave N",
    "city": "Seattle",
    "zip": 98103,
    "concatenated_address": "4710 Aurora Ave N, Seattle",
    "address": "4710 Aurora Ave. N., Seattle"
  },
  {
    "id": 1308,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "The Four Two Four Summit",
    "latitude": 47.622815,
    "longitude": -122.32492,
    "original_address": "424 Summit Avenue East",
    "building_number": 424,
    "street": "Summit Ave E",
    "city": "Seattle",
    "zip": 98102,
    "concatenated_address": "424 Summit Ave E, Seattle",
    "address": "424 Summit Ave. E., Seattle"
  },
  {
    "id": 1309,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Boston West Apartments",
    "latitude": 47.638196,
    "longitude": -122.38699,
    "original_address": "2315 West Boston Street",
    "building_number": 2315,
    "street": "W Boston St",
    "city": "Seattle",
    "zip": 98199,
    "concatenated_address": "2315 W Boston St, Seattle",
    "address": "2315 W. Boston St., Seattle"
  },
  {
    "id": 1310,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "1114 East Olive Street",
    "latitude": 47.616556,
    "longitude": -122.31724,
    "original_address": "1114 East Olive Street",
    "building_number": 1114,
    "street": "E Olive St",
    "city": "Seattle",
    "zip": 98122,
    "concatenated_address": "1114 E Olive St, Seattle",
    "address": "1114 E. Olive St., Seattle"
  },
  {
    "id": 1311,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Alta Casa Apartments",
    "latitude": 47.634379,
    "longitude": -122.32034,
    "original_address": "1645 10th Avenue East",
    "building_number": 1645,
    "street": "10th Ave E",
    "city": "Seattle",
    "zip": 98102,
    "concatenated_address": "1645 10th Ave E, Seattle",
    "address": "1645 10th Ave. E., Seattle"
  },
  {
    "id": 1312,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Castlereach Apartments",
    "latitude": 47.661615,
    "longitude": -122.33818,
    "original_address": "1618 North 45th Street",
    "building_number": 1618,
    "street": "N 45th St",
    "city": "Seattle",
    "zip": 98103,
    "concatenated_address": "1618 N 45th St, Seattle",
    "address": "1618 N. 45th St., Seattle"
  },
  {
    "id": 1313,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Travis Apartments",
    "latitude": 47.63281,
    "longitude": -122.28851,
    "original_address": "Travis Apartments",
    "building_number": "",
    "street": "",
    "city": "Seattle",
    "zip": 98112,
    "concatenated_address": "Travis Apartments, Seattle",
    "address": "Travis Apartments, Seattle"
  },
  {
    "id": 1314,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Villa Maria Apartments",
    "latitude": 47.695111,
    "longitude": -122.34249,
    "original_address": "1146 N 91st Street",
    "building_number": 1146,
    "street": "N 91st St",
    "city": "Seattle",
    "zip": 98103,
    "concatenated_address": "1146 N 91st St, Seattle",
    "address": "1146 N. 91st St., Seattle"
  },
  {
    "id": 1315,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "2635 Prosch Avenue West",
    "latitude": 47.644068,
    "longitude": -122.37442,
    "original_address": "2635 Prosch Avenue West",
    "building_number": 2635,
    "street": "Prosch Ave W",
    "city": "Seattle",
    "zip": 98119,
    "concatenated_address": "2635 Prosch Ave W, Seattle",
    "address": "2635 Prosch Ave. W., Seattle"
  },
  {
    "id": 1316,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "2114 7th Avenue West",
    "latitude": 47.638265,
    "longitude": -122.36595,
    "original_address": "2114 7th Avenue West",
    "building_number": 2114,
    "street": "7th Ave W",
    "city": "Seattle",
    "zip": 98119,
    "concatenated_address": "2114 7th Ave W, Seattle",
    "address": "2114 7th Ave. W., Seattle"
  },
  {
    "id": 1317,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Broadmoor Manor Apartments",
    "latitude": 47.627984,
    "longitude": -122.28987,
    "original_address": "3232 East Madison Street",
    "building_number": 3232,
    "street": "E Madison St",
    "city": "Seattle",
    "zip": 98112,
    "concatenated_address": "3232 E Madison St, Seattle",
    "address": "3232 E. Madison St., Seattle"
  },
  {
    "id": 1318,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "NW 61st Street 1417",
    "latitude": 47.672862,
    "longitude": -122.37449,
    "original_address": "1417 Nw 61st Street",
    "building_number": 1417,
    "street": "NW 61st St",
    "city": "Seattle",
    "zip": 98107,
    "concatenated_address": "1417 NW 61st St, Seattle",
    "address": "1417 N.W. 61st St., Seattle"
  },
  {
    "id": 1319,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Capitol Core",
    "latitude": 47.620373,
    "longitude": -122.32334,
    "original_address": "215 Boylston Avenue East",
    "building_number": 215,
    "street": "Boylston Ave E",
    "city": "Seattle",
    "zip": 98102,
    "concatenated_address": "215 Boylston Ave E, Seattle",
    "address": "215 Boylston Ave. E., Seattle"
  },
  {
    "id": 1320,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Hill Vista Apartments Fka Stella Apartments",
    "latitude": 47.603219,
    "longitude": -122.31046,
    "original_address": "165 17th Avenue",
    "building_number": 165,
    "street": "17th Ave",
    "city": "Seattle",
    "zip": 98122,
    "concatenated_address": "165 17th Ave, Seattle",
    "address": "165 17th Ave., Seattle"
  },
  {
    "id": 1321,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Seattle View Apartments",
    "latitude": 47.589224,
    "longitude": -122.31761,
    "original_address": "1527 12th Avenue South",
    "building_number": 1527,
    "street": "12th Ave S",
    "city": "Seattle",
    "zip": 98144,
    "concatenated_address": "1527 12th Ave S, Seattle",
    "address": "1527 12th Ave. S., Seattle"
  },
  {
    "id": 1322,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Arbol Lofts",
    "latitude": 47.617569,
    "longitude": -122.32391,
    "original_address": "611 East Howell Street",
    "building_number": 611,
    "street": "E Howell St",
    "city": "Seattle",
    "zip": 98122,
    "concatenated_address": "611 E Howell St, Seattle",
    "address": "611 E. Howell St., Seattle"
  },
  {
    "id": 1323,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Jupiter Apartments",
    "latitude": 47.602967,
    "longitude": -122.31047,
    "original_address": "155 17th Avenue",
    "building_number": 155,
    "street": "17th Ave",
    "city": "Seattle",
    "zip": 98122,
    "concatenated_address": "155 17th Ave, Seattle",
    "address": "155 17th Ave., Seattle"
  },
  {
    "id": 1324,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Cubix 95",
    "latitude": 47.698091,
    "longitude": -122.34925,
    "original_address": "714 North 95th Street",
    "building_number": 714,
    "street": "N 95th St",
    "city": "Seattle",
    "zip": 98103,
    "concatenated_address": "714 N 95th St, Seattle",
    "address": "714 N. 95th St., Seattle"
  },
  {
    "id": 1325,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Vitality Apartments",
    "latitude": 47.674047,
    "longitude": -122.37531,
    "original_address": "1436 Nw 62nd Street",
    "building_number": 1436,
    "street": "NW 62nd St",
    "city": "Seattle",
    "zip": 98107,
    "concatenated_address": "1436 NW 62nd St, Seattle",
    "address": "1436 N.W. 62nd St., Seattle"
  },
  {
    "id": 1326,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Capitol Core II",
    "latitude": 47.614288,
    "longitude": -122.31123,
    "original_address": "1500 16th Avenue",
    "building_number": 1500,
    "street": "16th Ave",
    "city": "Seattle",
    "zip": 98122,
    "concatenated_address": "1500 16th Ave, Seattle",
    "address": "1500 16th Ave., Seattle"
  },
  {
    "id": 1327,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Quarter Deck Apartments",
    "latitude": 47.499899,
    "longitude": -122.22121,
    "original_address": "11441 Rainier Avenue S",
    "building_number": 11441,
    "street": "Rainier Ave S",
    "city": "Seattle",
    "zip": 98178,
    "concatenated_address": "11441 Rainier Ave S, Seattle",
    "address": "11441 Rainier Ave. S., Seattle"
  },
  {
    "id": 1328,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Corona Apartments",
    "latitude": 47.625956,
    "longitude": -122.35306,
    "original_address": "715 2nd Avenue North",
    "building_number": 715,
    "street": "2nd Ave N",
    "city": "Seattle",
    "zip": 98109,
    "concatenated_address": "715 2nd Ave N, Seattle",
    "address": "715 2nd Ave. N., Seattle"
  },
  {
    "id": 1329,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Belfiore Apartments",
    "latitude": 47.617412,
    "longitude": -122.32714,
    "original_address": "1707 Bellevue Avenue",
    "building_number": 1707,
    "street": "Bellevue Ave",
    "city": "Seattle",
    "zip": 98122,
    "concatenated_address": "1707 Bellevue Ave, Seattle",
    "address": "1707 Bellevue Ave., Seattle"
  },
  {
    "id": 1330,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Joey Ray Apartments",
    "latitude": 47.621816,
    "longitude": -122.32701,
    "original_address": "331 Bellevue Avenue East",
    "building_number": 331,
    "street": "Bellevue Ave E",
    "city": "Seattle",
    "zip": 98102,
    "concatenated_address": "331 Bellevue Ave E, Seattle",
    "address": "331 Bellevue Ave. E., Seattle"
  },
  {
    "id": 1331,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Lynnyale Apartments",
    "latitude": 47.639582,
    "longitude": -122.32731,
    "original_address": "2245 Yale Avenue East",
    "building_number": 2245,
    "street": "Yale Ave E",
    "city": "Seattle",
    "zip": 98102,
    "concatenated_address": "2245 Yale Ave E, Seattle",
    "address": "2245 Yale Ave. E., Seattle"
  },
  {
    "id": 1332,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Stephensberg Apartments",
    "latitude": 47.616192,
    "longitude": -122.32658,
    "original_address": "405 East Olive Street",
    "building_number": 405,
    "street": "E Olive St",
    "city": "Seattle",
    "zip": 98122,
    "concatenated_address": "405 E Olive St, Seattle",
    "address": "405 E. Olive St., Seattle"
  },
  {
    "id": 1333,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "La Villa Apartments",
    "latitude": 47.615954,
    "longitude": -122.31516,
    "original_address": "1620 13Th Avenue",
    "building_number": 1620,
    "street": "13th Ave",
    "city": "Seattle",
    "zip": 98122,
    "concatenated_address": "1620 13th Ave, Seattle",
    "address": "1620 13th Ave., Seattle"
  },
  {
    "id": 1334,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Halmar Apartments",
    "latitude": 47.618946,
    "longitude": -122.3162,
    "original_address": "103 13Th Ave East",
    "building_number": 103,
    "street": "13th Ave E",
    "city": "Seattle",
    "zip": 98102,
    "concatenated_address": "103 13th Ave E, Seattle",
    "address": "103 13th Ave. E., Seattle"
  },
  {
    "id": 1335,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Towne Apartments",
    "latitude": 47.617024,
    "longitude": -122.31729,
    "original_address": "1717 12th Avenue",
    "building_number": 1717,
    "street": "12th Ave",
    "city": "Seattle",
    "zip": 98122,
    "concatenated_address": "1717 12th Ave, Seattle",
    "address": "1717 12th Ave., Seattle"
  },
  {
    "id": 1336,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Starbird Apartments",
    "latitude": 47.614454,
    "longitude": -122.32323,
    "original_address": "1512 Boylston Avenue",
    "building_number": 1512,
    "street": "Boylston Ave",
    "city": "Seattle",
    "zip": 98122,
    "concatenated_address": "1512 Boylston Ave, Seattle",
    "address": "1512 Boylston Ave., Seattle"
  },
  {
    "id": 1337,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Beacon Crest Apartments",
    "latitude": 47.579856,
    "longitude": -122.31445,
    "original_address": "2530 14th Avenue South",
    "building_number": 2530,
    "street": "14th Ave S",
    "city": "Seattle",
    "zip": 98144,
    "concatenated_address": "2530 14th Ave S, Seattle",
    "address": "2530 14th Ave. S., Seattle"
  },
  {
    "id": 1338,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Sou'Wester Apartments",
    "latitude": 47.500058,
    "longitude": -122.35785,
    "original_address": "11054 And 11060 4th Avenue Southwest",
    "building_number": "",
    "street": "",
    "city": "Seattle",
    "zip": 98146,
    "concatenated_address": "11054 And 11060 4th Avenue Southwest, Seattle",
    "address": "11054 And 11060 4th Avenue Southwest, Seattle"
  },
  {
    "id": 1339,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Ballard 57",
    "latitude": 47.669951,
    "longitude": -122.38034,
    "original_address": "1731 Nw 57th Street",
    "building_number": 1731,
    "street": "NW 57th St",
    "city": "Seattle",
    "zip": 98107,
    "concatenated_address": "1731 NW 57th St, Seattle",
    "address": "1731 N.W. 57th St., Seattle"
  },
  {
    "id": 1340,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Holgate 12 Phase II",
    "latitude": 47.586696,
    "longitude": -122.31691,
    "original_address": "1808 12th Avenue South",
    "building_number": 1808,
    "street": "12th Ave S",
    "city": "Seattle",
    "zip": 98144,
    "concatenated_address": "1808 12th Ave S, Seattle",
    "address": "1808 12th Ave. S., Seattle"
  },
  {
    "id": 1341,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Lofts At The Junction",
    "latitude": 47.561837,
    "longitude": -122.38835,
    "original_address": "4535 44th Avenue Sw",
    "building_number": 4535,
    "street": "44th Ave SW",
    "city": "Seattle",
    "zip": 98116,
    "concatenated_address": "4535 44th Ave SW, Seattle",
    "address": "4535 44th Ave. S.W., Seattle"
  },
  {
    "id": 1342,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Century Villa Apartments",
    "latitude": 47.631907,
    "longitude": -122.35955,
    "original_address": "1417 2nd Avenue W",
    "building_number": 1417,
    "street": "2nd Ave W",
    "city": "Seattle",
    "zip": 98119,
    "concatenated_address": "1417 2nd Ave W, Seattle",
    "address": "1417 2nd Ave. W., Seattle"
  },
  {
    "id": 1343,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Windemere Estates",
    "latitude": 47.505943,
    "longitude": -122.35417,
    "original_address": "10746 16th Avenue Sw",
    "building_number": 10746,
    "street": "16th Ave SW",
    "city": "Seattle",
    "zip": 98146,
    "concatenated_address": "10746 16th Ave SW, Seattle",
    "address": "10746 16th Ave. S.W., Seattle"
  },
  {
    "id": 1344,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Barton Court Apartments",
    "latitude": 47.522251,
    "longitude": -122.37718,
    "original_address": "9021 35th Avenue Sw",
    "building_number": 9021,
    "street": "35th Ave SW",
    "city": "Seattle",
    "zip": 98126,
    "concatenated_address": "9021 35th Ave SW, Seattle",
    "address": "9021 35th Ave. S.W., Seattle"
  },
  {
    "id": 1345,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Roxbury 12",
    "latitude": 47.51658,
    "longitude": -122.35804,
    "original_address": "1802 Sw 96th Lane",
    "building_number": 1802,
    "street": "SW 96th Ln",
    "city": "Seattle",
    "zip": 98106,
    "concatenated_address": "1802 SW 96th Ln, Seattle",
    "address": "1802 S.W. 96th Lane, Seattle"
  },
  {
    "id": 1346,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Maxmillian Apartments",
    "latitude": 47.612667,
    "longitude": -122.3226,
    "original_address": "1414 Seneca St",
    "building_number": 1414,
    "street": "Seneca St",
    "city": "Seattle",
    "zip": 98101,
    "concatenated_address": "1414 Seneca St, Seattle",
    "address": "1414 Seneca St., Seattle"
  },
  {
    "id": 1347,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Broadway Fortune Apartments",
    "latitude": 47.606801,
    "longitude": -122.32111,
    "original_address": "1203 James Street",
    "building_number": 1203,
    "street": "James St",
    "city": "Seattle",
    "zip": 98104,
    "concatenated_address": "1203 James St, Seattle",
    "address": "1203 James St., Seattle"
  },
  {
    "id": 1348,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Greenlake North Apartments",
    "latitude": 47.697516,
    "longitude": -122.3482,
    "original_address": "739 North 95th St",
    "building_number": 739,
    "street": "N 95th St",
    "city": "Seattle",
    "zip": 98103,
    "concatenated_address": "739 N 95th St, Seattle",
    "address": "739 N. 95th St., Seattle"
  },
  {
    "id": 1349,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "The Bostonian Apartments",
    "latitude": 47.638572,
    "longitude": -122.31982,
    "original_address": "1000 East Boston St",
    "building_number": 1000,
    "street": "E Boston St",
    "city": "Seattle",
    "zip": 98102,
    "concatenated_address": "1000 E Boston St, Seattle",
    "address": "1000 E. Boston St., Seattle"
  },
  {
    "id": 1350,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "La Mirada Apartments",
    "latitude": 47.660021,
    "longitude": -122.31581,
    "original_address": "1120 Ne 43rd Street",
    "building_number": 1120,
    "street": "NE 43rd St",
    "city": "Seattle",
    "zip": 98105,
    "concatenated_address": "1120 NE 43rd St, Seattle",
    "address": "1120 N.E. 43rd St., Seattle"
  },
  {
    "id": 1351,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Lois Lane Apartments",
    "latitude": 47.596882,
    "longitude": -122.29827,
    "original_address": "2608 South Lane Street",
    "building_number": 2608,
    "street": "S Lane St",
    "city": "Seattle",
    "zip": 98144,
    "concatenated_address": "2608 S Lane St, Seattle",
    "address": "2608 S. Lane St., Seattle"
  },
  {
    "id": 1352,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Belmont Apartments",
    "latitude": 47.614928,
    "longitude": -122.32479,
    "original_address": "1527 Belmont Ave",
    "building_number": 1527,
    "street": "Belmont Ave",
    "city": "Seattle",
    "zip": 98122,
    "concatenated_address": "1527 Belmont Ave, Seattle",
    "address": "1527 Belmont Ave., Seattle"
  },
  {
    "id": 1353,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Parkway Apartments",
    "latitude": 47.535581,
    "longitude": -122.2706,
    "original_address": "7401 Rainier Avenue South",
    "building_number": 7401,
    "street": "Rainier Ave S",
    "city": "Seattle",
    "zip": 98118,
    "concatenated_address": "7401 Rainier Ave S, Seattle",
    "address": "7401 Rainier Ave. S., Seattle"
  },
  {
    "id": 1354,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Fontanelle Apartments",
    "latitude": 47.536278,
    "longitude": -122.27074,
    "original_address": "7325 Rainier Avenue South",
    "building_number": 7325,
    "street": "Rainier Ave S",
    "city": "Seattle",
    "zip": 98118,
    "concatenated_address": "7325 Rainier Ave S, Seattle",
    "address": "7325 Rainier Ave. S., Seattle"
  },
  {
    "id": 1355,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Myrtle Street Apartments",
    "latitude": 47.539278,
    "longitude": -122.27045,
    "original_address": "7020 Rainier Avenue South",
    "building_number": 7020,
    "street": "Rainier Ave S",
    "city": "Seattle",
    "zip": 98118,
    "concatenated_address": "7020 Rainier Ave S, Seattle",
    "address": "7020 Rainier Ave. S., Seattle"
  },
  {
    "id": 1356,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "California Dreaming",
    "latitude": 47.569257,
    "longitude": -122.38714,
    "original_address": "3829 California Ave Sw",
    "building_number": 3829,
    "street": "California Ave SW",
    "city": "Seattle",
    "zip": 98116,
    "concatenated_address": "3829 California Ave SW, Seattle",
    "address": "3829 California Ave. S.W., Seattle"
  },
  {
    "id": 1357,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "900 Southwest Holden Street",
    "latitude": 47.534452,
    "longitude": -122.34774,
    "original_address": "900 Sw Holden Street",
    "building_number": 900,
    "street": "SW Holden St",
    "city": "Seattle",
    "zip": 98106,
    "concatenated_address": "900 SW Holden St, Seattle",
    "address": "900 S.W. Holden St., Seattle"
  },
  {
    "id": 1358,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Sundowner Apartments",
    "latitude": 47.662118,
    "longitude": -122.35748,
    "original_address": "101 North 46th Street",
    "building_number": 101,
    "street": "N 46th St",
    "city": "Seattle",
    "zip": 98103,
    "concatenated_address": "101 N 46th St, Seattle",
    "address": "101 N. 46th St., Seattle"
  },
  {
    "id": 1359,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Phinney Apartments",
    "latitude": 47.675668,
    "longitude": -122.354,
    "original_address": "6408 Phinney Avenue North",
    "building_number": 6408,
    "street": "Phinney Ave N",
    "city": "Seattle",
    "zip": 98103,
    "concatenated_address": "6408 Phinney Ave N, Seattle",
    "address": "6408 Phinney Ave. N., Seattle"
  },
  {
    "id": 1360,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Wally",
    "latitude": 47.657002,
    "longitude": -122.34276,
    "original_address": "4111 Stone Way North",
    "building_number": 4111,
    "street": "Stone Way N",
    "city": "Seattle",
    "zip": 98103,
    "concatenated_address": "4111 Stone Way N, Seattle",
    "address": "4111 Stone Way N., Seattle"
  },
  {
    "id": 1361,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Sovereign Apartments",
    "latitude": 47.611873,
    "longitude": -122.3278,
    "original_address": "1317 Boren Ave",
    "building_number": 1317,
    "street": "Boren Ave",
    "city": "Seattle",
    "zip": 98101,
    "concatenated_address": "1317 Boren Ave, Seattle",
    "address": "1317 Boren Ave., Seattle"
  },
  {
    "id": 1362,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Mckay Apartments",
    "latitude": 47.557601,
    "longitude": -122.38183,
    "original_address": "4857 Fauntleroy Way Sw",
    "building_number": 4857,
    "street": "Fauntleroy Way SW",
    "city": "Seattle",
    "zip": 98116,
    "concatenated_address": "4857 Fauntleroy Way SW, Seattle",
    "address": "4857 Fauntleroy Way S.W., Seattle"
  },
  {
    "id": 1363,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Columbia Gardens At Rainier Court",
    "latitude": 47.585621,
    "longitude": -122.29249,
    "original_address": "3600,3610 33rd Ave S And3311S Spokane St",
    "building_number": "",
    "street": "",
    "city": "Seattle",
    "zip": 98144,
    "concatenated_address": "3600,3610 33rd Ave S And3311S Spokane St, Seattle",
    "address": "3600,3610 33rd Ave. S. And3311S Spokane St., Seattle"
  },
  {
    "id": 1364,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Rivet Apartments",
    "latitude": 47.624049,
    "longitude": -122.33269,
    "original_address": "1201 Mercer Street",
    "building_number": 1201,
    "street": "Mercer St",
    "city": "Seattle",
    "zip": 98109,
    "concatenated_address": "1201 Mercer St, Seattle",
    "address": "1201 Mercer St., Seattle"
  },
  {
    "id": 1365,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Westwood Court Apartments",
    "latitude": 47.525174,
    "longitude": -122.36488,
    "original_address": "2500 Southwest Trenton Street",
    "building_number": 2500,
    "street": "SW Trenton St",
    "city": "Seattle",
    "zip": 98106,
    "concatenated_address": "2500 SW Trenton St, Seattle",
    "address": "2500 S.W. Trenton St., Seattle"
  },
  {
    "id": 1366,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "The Court At Northgate Apartments",
    "latitude": 47.710865,
    "longitude": -122.32481,
    "original_address": "11300 3rd Avenue Northeast",
    "building_number": 11300,
    "street": "3rd Ave NE",
    "city": "Seattle",
    "zip": 98125,
    "concatenated_address": "11300 3rd Ave NE, Seattle",
    "address": "11300 3rd Ave. N.E., Seattle"
  },
  {
    "id": 1367,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Minor Tower Apartments",
    "latitude": 47.642723,
    "longitude": -122.32866,
    "original_address": "2525 Minor Avenue East",
    "building_number": 2525,
    "street": "Minor Ave E",
    "city": "Seattle",
    "zip": 98102,
    "concatenated_address": "2525 Minor Ave E, Seattle",
    "address": "2525 Minor Ave. E., Seattle"
  },
  {
    "id": 1368,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Alcyone Apartments",
    "latitude": 47.620943,
    "longitude": -122.33328,
    "original_address": "301 Minor Avenue North",
    "building_number": 301,
    "street": "Minor Ave N",
    "city": "Seattle",
    "zip": 98109,
    "concatenated_address": "301 Minor Ave N, Seattle",
    "address": "301 Minor Ave. N., Seattle"
  },
  {
    "id": 1369,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Queen Anne Manor",
    "latitude": 47.637787,
    "longitude": -122.3548,
    "original_address": "100 Crockett Street",
    "building_number": 100,
    "street": "Crockett St",
    "city": "Seattle",
    "zip": 98109,
    "concatenated_address": "100 Crockett St, Seattle",
    "address": "100 Crockett St., Seattle"
  },
  {
    "id": 1370,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Zindorf Apartments",
    "latitude": 47.605918,
    "longitude": -122.32768,
    "original_address": "714 7th Avenue",
    "building_number": 714,
    "street": "7th Ave",
    "city": "Seattle",
    "zip": 98104,
    "concatenated_address": "714 7th Ave, Seattle",
    "address": "714 7th Ave., Seattle"
  },
  {
    "id": 1371,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Florentia",
    "latitude": 47.647096,
    "longitude": -122.35743,
    "original_address": "4 Florentia Street",
    "building_number": 4,
    "street": "Florentia St",
    "city": "Seattle",
    "zip": 98109,
    "concatenated_address": "4 Florentia St, Seattle",
    "address": "4 Florentia St., Seattle"
  },
  {
    "id": 1372,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Footprint Phinney",
    "latitude": 47.678255,
    "longitude": -122.33815,
    "original_address": "8727 & 8731 Phinney Ave N",
    "building_number": "",
    "street": "",
    "city": "Seattle",
    "zip": 98103,
    "concatenated_address": "8727 & 8731 Phinney Ave N, Seattle",
    "address": "8727 & 8731 Phinney Ave. N., Seattle"
  },
  {
    "id": 1373,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Footprint Greenwood",
    "latitude": 47.690413,
    "longitude": -122.3598,
    "original_address": "143 Nw 85th St",
    "building_number": 143,
    "street": "NW 85th St",
    "city": "Seattle",
    "zip": 98117,
    "concatenated_address": "143 NW 85th St, Seattle",
    "address": "143 N.W. 85th St., Seattle"
  },
  {
    "id": 1374,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Brighton Place Apts",
    "latitude": 47.541661,
    "longitude": -122.27345,
    "original_address": "6727 Ranier Avenue Apts",
    "building_number": 6727,
    "street": "Rainier Ave S",
    "city": "Seattle",
    "zip": 98118,
    "concatenated_address": "6727 Rainier Ave S, Seattle",
    "address": "6727 Rainier Ave. S., Seattle"
  },
  {
    "id": 1375,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Elizabeth James House",
    "latitude": 47.602023,
    "longitude": -122.3027,
    "original_address": "109 23rd Avenue",
    "building_number": 109,
    "street": "23rd Ave",
    "city": "Seattle",
    "zip": 98112,
    "concatenated_address": "109 23rd Ave, Seattle",
    "address": "109 23rd Ave., Seattle"
  },
  {
    "id": 1376,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Penn Hall Aptsreet",
    "latitude": 47.63281,
    "longitude": -122.28851,
    "original_address": "1907 East Hohn Street",
    "building_number": "",
    "street": "",
    "city": "Seattle",
    "zip": 98112,
    "concatenated_address": "1907 East Hohn Street, Seattle",
    "address": "1907 East Hohn St., Seattle"
  },
  {
    "id": 1377,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "McGuire Court Apts",
    "latitude": 47.707902,
    "longitude": -122.31984,
    "original_address": "10740 8th Ave Ne",
    "building_number": 10740,
    "street": "8th Ave NE",
    "city": "Seattle",
    "zip": 98125,
    "concatenated_address": "10740 8th Ave NE, Seattle",
    "address": "10740 8th Ave. N.E., Seattle"
  },
  {
    "id": 1378,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Northaven Apartments",
    "latitude": 47.709783,
    "longitude": -122.32156,
    "original_address": "11045 8th Avenue Ne",
    "building_number": 11045,
    "street": "8th Ave NE",
    "city": "Seattle",
    "zip": 98125,
    "concatenated_address": "11045 8th Ave NE, Seattle",
    "address": "11045 8th Ave. N.E., Seattle"
  },
  {
    "id": 1379,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Hill Crest Apartments",
    "latitude": 47.534565,
    "longitude": -122.37613,
    "original_address": "7524 35th Ave Sw",
    "building_number": 7524,
    "street": "35th Ave SW",
    "city": "Seattle",
    "zip": 98126,
    "concatenated_address": "7524 35th Ave SW, Seattle",
    "address": "7524 35th Ave. S.W., Seattle"
  },
  {
    "id": 1380,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Willows Court Apartments",
    "latitude": 47.718336,
    "longitude": -122.29749,
    "original_address": "12316 28th Avenue Ne",
    "building_number": 12316,
    "street": "28th Ave NE",
    "city": "Seattle",
    "zip": 98125,
    "concatenated_address": "12316 28th Ave NE, Seattle",
    "address": "12316 28th Ave. N.E., Seattle"
  },
  {
    "id": 1381,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Ventana Apartments",
    "latitude": 47.611308,
    "longitude": -122.34478,
    "original_address": "2100 Western Avenue",
    "building_number": 2100,
    "street": "Western Ave",
    "city": "Seattle",
    "zip": 98121,
    "concatenated_address": "2100 Western Ave, Seattle",
    "address": "2100 Western Ave., Seattle"
  },
  {
    "id": 1382,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Burke Gilman Trail Apartments",
    "latitude": 47.666024,
    "longitude": -122.28423,
    "original_address": "5100 40th Avenue Ne",
    "building_number": 5100,
    "street": "40th Ave NE",
    "city": "Seattle",
    "zip": 98105,
    "concatenated_address": "5100 40th Ave NE, Seattle",
    "address": "5100 40th Ave. N.E., Seattle"
  },
  {
    "id": 1383,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Kawabe Memorial House",
    "latitude": 47.60042,
    "longitude": -122.30947,
    "original_address": "221 18th Ave South",
    "building_number": 221,
    "street": "18th Ave S",
    "city": "Seattle",
    "zip": 98144,
    "concatenated_address": "221 18th Ave S, Seattle",
    "address": "221 18th Ave. S., Seattle"
  },
  {
    "id": 1384,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Seed Scaterred Site Portfolio",
    "latitude": 47.569976,
    "longitude": -122.28874,
    "original_address": "3656 35th Avenue S",
    "building_number": 3656,
    "street": "35th Ave S",
    "city": "Seattle",
    "zip": 98144,
    "concatenated_address": "3656 35th Ave S, Seattle",
    "address": "3656 35th Ave. S., Seattle"
  },
  {
    "id": 1385,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Roosevelt Ridge",
    "latitude": 47.716236,
    "longitude": -122.31767,
    "original_address": "12002 Roosevelt Way Ne",
    "building_number": 12002,
    "street": "Roosevelt Way NE",
    "city": "Seattle",
    "zip": 98125,
    "concatenated_address": "12002 Roosevelt Way NE, Seattle",
    "address": "12002 Roosevelt Way N.E., Seattle"
  },
  {
    "id": 1386,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Ilumina Apartments",
    "latitude": 47.633718,
    "longitude": -122.32486,
    "original_address": "219 East Garfield Street",
    "building_number": 219,
    "street": "E Garfield St",
    "city": "Seattle",
    "zip": 98102,
    "concatenated_address": "219 E Garfield St, Seattle",
    "address": "219 E. Garfield St., Seattle"
  },
  {
    "id": 1387,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Saxe Apartments",
    "latitude": 47.676038,
    "longitude": -122.30134,
    "original_address": "2402 Ne 65th Street",
    "building_number": 2402,
    "street": "NE 65th St",
    "city": "Seattle",
    "zip": 98115,
    "concatenated_address": "2402 NE 65th St, Seattle",
    "address": "2402 N.E. 65th St., Seattle"
  },
  {
    "id": 1388,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "International House",
    "latitude": 47.597343,
    "longitude": -122.32527,
    "original_address": "607 Maynard Avenue South",
    "building_number": 607,
    "street": "Maynard Ave S",
    "city": "Seattle",
    "zip": 98104,
    "concatenated_address": "607 Maynard Ave S, Seattle",
    "address": "607 Maynard Ave. S., Seattle"
  },
  {
    "id": 1389,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Loyal Heights Manor",
    "latitude": 47.684517,
    "longitude": -122.38792,
    "original_address": "7547 24th Avenue Nw",
    "building_number": 7547,
    "street": "24th Ave NW",
    "city": "Seattle",
    "zip": 98117,
    "concatenated_address": "7547 24th Ave NW, Seattle",
    "address": "7547 24th Ave. N.W., Seattle"
  },
  {
    "id": 1390,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Sanford Hildebrandt Tower",
    "latitude": 47.726455,
    "longitude": -122.34916,
    "original_address": "747 N. 135th Street",
    "building_number": 747,
    "street": "N 135th St",
    "city": "Seattle",
    "zip": 98133,
    "concatenated_address": "747 N 135th St, Seattle",
    "address": "747 N. 135th St., Seattle"
  },
  {
    "id": 1391,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Park Place Assisted Living",
    "latitude": 47.538913,
    "longitude": -122.28607,
    "original_address": "37th Ave S & S Myrtle St",
    "building_number": "",
    "street": "37th Ave S",
    "city": "Seattle",
    "zip": 98118,
    "concatenated_address": "37th Ave S & S Myrtle St, Seattle",
    "address": "37th Ave. S. & S. Myrtle St., Seattle"
  },
  {
    "id": 1392,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "St. Anne Nursing & Rehab",
    "latitude": 47.651678,
    "longitude": -122.37139,
    "original_address": "3540 Ne 11Oth Street",
    "building_number": 3540,
    "street": "NE 11th St",
    "city": "Seattle",
    "zip": 98125,
    "concatenated_address": "3540 NE 11th St, Seattle",
    "address": "3540 N.E. 11th St., Seattle"
  },
  {
    "id": 1393,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Hilltop Manor",
    "latitude": 47.617431,
    "longitude": -122.31112,
    "original_address": "1732 16th Avenue",
    "building_number": 1732,
    "street": "16th Ave",
    "city": "Seattle",
    "zip": 98122,
    "concatenated_address": "1732 16th Ave, Seattle",
    "address": "1732 16th Ave., Seattle"
  },
  {
    "id": 1394,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Community House-Spring Manor",
    "latitude": 47.611794,
    "longitude": -122.31185,
    "original_address": "1103 16th Ave.",
    "building_number": 1103,
    "street": "16th Ave",
    "city": "Seattle",
    "zip": 98122,
    "concatenated_address": "1103 16th Ave, Seattle",
    "address": "1103 16th Ave., Seattle"
  },
  {
    "id": 1395,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Tashiro Kaplan",
    "latitude": 47.601108,
    "longitude": -122.32995,
    "original_address": "300 S Washington Street",
    "building_number": 300,
    "street": "S Washington St",
    "city": "Seattle",
    "zip": 98104,
    "concatenated_address": "300 S Washington St, Seattle",
    "address": "300 S. Washington St., Seattle"
  },
  {
    "id": 1396,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Zella Apts",
    "latitude": 47.622773,
    "longitude": -122.35956,
    "original_address": "425 2nd Avenue.",
    "building_number": 425,
    "street": "2nd Ave W",
    "city": "Seattle",
    "zip": 98119,
    "concatenated_address": "425 2nd Ave W, Seattle",
    "address": "425 2nd Ave. W., Seattle"
  },
  {
    "id": 1397,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Jackson Apartments",
    "latitude": 47.599372,
    "longitude": -122.3241,
    "original_address": "670 S Jackson Street",
    "building_number": 670,
    "street": "S Jackson St",
    "city": "Seattle",
    "zip": 98104,
    "concatenated_address": "670 S Jackson St, Seattle",
    "address": "670 S. Jackson St., Seattle"
  },
  {
    "id": 1398,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "H20 Apartments",
    "latitude": 47.62197,
    "longitude": -122.35972,
    "original_address": "201 West Harrison Street",
    "building_number": 201,
    "street": "W Harrison St",
    "city": "Seattle",
    "zip": 98119,
    "concatenated_address": "201 W Harrison St, Seattle",
    "address": "201 W. Harrison St., Seattle"
  },
  {
    "id": 1399,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Mount Zion Heights",
    "latitude": 47.617269,
    "longitude": -122.30682,
    "original_address": "1916 East Madison",
    "building_number": 1916,
    "street": "E Madison St",
    "city": "Seattle",
    "zip": 98122,
    "concatenated_address": "1916 E Madison St, Seattle",
    "address": "1916 E. Madison St., Seattle"
  },
  {
    "id": 1400,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Esperanza Apts",
    "latitude": 47.539154,
    "longitude": -122.28479,
    "original_address": "3728 S Myrtle Street",
    "building_number": 3728,
    "street": "S Myrtle St",
    "city": "Seattle",
    "zip": 98118,
    "concatenated_address": "3728 S Myrtle St, Seattle",
    "address": "3728 S. Myrtle St., Seattle"
  },
  {
    "id": 1401,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Anthem On 12th",
    "latitude": 47.602054,
    "longitude": -122.31711,
    "original_address": "103 12th Avenue",
    "building_number": 103,
    "street": "12th Ave",
    "city": "Seattle",
    "zip": 98112,
    "concatenated_address": "103 12th Ave, Seattle",
    "address": "103 12th Ave., Seattle"
  },
  {
    "id": 1402,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Publix Hotel",
    "latitude": 47.598192,
    "longitude": -122.32746,
    "original_address": "504 5th Avenue South",
    "building_number": 504,
    "street": "5th Ave S",
    "city": "Seattle",
    "zip": 98108,
    "concatenated_address": "504 5th Ave S, Seattle",
    "address": "504 5th Ave. S., Seattle"
  },
  {
    "id": 1403,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Junction Flats Apartments",
    "latitude": 47.563598,
    "longitude": -122.38579,
    "original_address": "4433 42nd Avenue Sw",
    "building_number": 4433,
    "street": "42nd Ave SW",
    "city": "Seattle",
    "zip": 98116,
    "concatenated_address": "4433 42nd Ave SW, Seattle",
    "address": "4433 42nd Ave. S.W., Seattle"
  },
  {
    "id": 1404,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Decibel Apartments",
    "latitude": 47.604509,
    "longitude": -122.31711,
    "original_address": "301 12th Ave.",
    "building_number": 301,
    "street": "12th Ave",
    "city": "Seattle",
    "zip": 98122,
    "concatenated_address": "301 12th Ave, Seattle",
    "address": "301 12th Ave., Seattle"
  },
  {
    "id": 1405,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Hilltop House",
    "latitude": 47.604458,
    "longitude": -122.3217,
    "original_address": "1005 Terrace St.",
    "building_number": 1005,
    "street": "Terrace St",
    "city": "Seattle",
    "zip": 98104,
    "concatenated_address": "1005 Terrace St, Seattle",
    "address": "1005 Terrace St., Seattle"
  },
  {
    "id": 1406,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Reverb",
    "latitude": 47.604215,
    "longitude": -122.31842,
    "original_address": "1023 East Alder Street",
    "building_number": 1023,
    "street": "E Alder St",
    "city": "Seattle",
    "zip": 98122,
    "concatenated_address": "1023 E Alder St, Seattle",
    "address": "1023 E. Alder St., Seattle"
  },
  {
    "id": 1407,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Sonata East Apartments",
    "latitude": 47.560962,
    "longitude": -122.29337,
    "original_address": "3004 S Alaska St",
    "building_number": 3004,
    "street": "S Alaska St",
    "city": "Seattle",
    "zip": 98118,
    "concatenated_address": "3004 S Alaska St, Seattle",
    "address": "3004 S. Alaska St., Seattle"
  },
  {
    "id": 1408,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Mount Baker Station-North Building",
    "latitude": 47.579422,
    "longitude": -122.30078,
    "original_address": "2615 25th Avenue South",
    "building_number": 2615,
    "street": "25th Ave S",
    "city": "Seattle",
    "zip": 98114,
    "concatenated_address": "2615 25th Ave S, Seattle",
    "address": "2615 25th Ave. S., Seattle"
  },
  {
    "id": 1409,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Mount Baker Station-South Building",
    "latitude": 47.579422,
    "longitude": -122.30078,
    "original_address": "2615 25th Avenue South",
    "building_number": 2615,
    "street": "25th Ave S",
    "city": "Seattle",
    "zip": 98114,
    "concatenated_address": "2615 25th Ave S, Seattle",
    "address": "2615 25th Ave. S., Seattle"
  },
  {
    "id": 1410,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Lilac Lodge Apartments",
    "latitude": 47.556088,
    "longitude": -122.28651,
    "original_address": "5033 37th Avenue South",
    "building_number": 5033,
    "street": "37th Ave S",
    "city": "Seattle",
    "zip": 98118,
    "concatenated_address": "5033 37th Ave S, Seattle",
    "address": "5033 37th Ave. S., Seattle"
  },
  {
    "id": 1411,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Junction Landing Apartments",
    "latitude": 47.564141,
    "longitude": -122.38579,
    "original_address": "4417 42nd Avenue Sw",
    "building_number": 4417,
    "street": "42nd Ave SW",
    "city": "Seattle",
    "zip": 98116,
    "concatenated_address": "4417 42nd Ave SW, Seattle",
    "address": "4417 42nd Ave. S.W., Seattle"
  },
  {
    "id": 1412,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Othello Square",
    "latitude": 47.536894,
    "longitude": -122.28312,
    "original_address": "3939 South Othello Street",
    "building_number": 3939,
    "street": "S Othello St",
    "city": "Seattle",
    "zip": 98118,
    "concatenated_address": "3939 S Othello St, Seattle",
    "address": "3939 S. Othello St., Seattle"
  },
  {
    "id": 1413,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Lake City Senior Apartments",
    "latitude": 47.729437,
    "longitude": -122.29188,
    "original_address": "13730 Lake City Way Ne",
    "building_number": 13730,
    "street": "Lake City Way NE",
    "city": "Seattle",
    "zip": 98125,
    "concatenated_address": "13730 Lake City Way NE, Seattle",
    "address": "13730 Lake City Way N.E., Seattle"
  },
  {
    "id": 1414,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Skagit Valley Convalescent Center",
    "latitude": 48.501193,
    "longitude": -122.25777,
    "original_address": "2019 Highway 20",
    "building_number": 2019,
    "street": "State Rte 20",
    "city": "Sedro-Woolley",
    "zip": 98284,
    "concatenated_address": "2019 State Rte 20, Sedro-Woolley",
    "address": "2019 State Rte 20, Sedro-Woolley"
  },
  {
    "id": 1415,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Village Concepts Of Sedro-Woolley-Country Meadow V",
    "latitude": 48.496116,
    "longitude": -122.27912,
    "original_address": "1501 Collins Road",
    "building_number": 1501,
    "street": "Collins Rd",
    "city": "Sedro-Woolley",
    "zip": 98284,
    "concatenated_address": "1501 Collins Rd, Sedro-Woolley",
    "address": "1501 Collins Road, Sedro-Woolley"
  },
  {
    "id": 1416,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Valley View MHC",
    "latitude": 48.518138,
    "longitude": -122.23521,
    "original_address": "700 N. Reed Street",
    "building_number": 700,
    "street": "N Reed St",
    "city": "Sedro-Woolley",
    "zip": 98284,
    "concatenated_address": "700 N Reed St, Sedro-Woolley",
    "address": "700 N. Reed St., Sedro-Woolley"
  },
  {
    "id": 1417,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "High Valley MHC",
    "latitude": 46.667525,
    "longitude": -120.52169,
    "original_address": "1060 N Wenas Road",
    "building_number": 1060,
    "street": "N Wenas Rd",
    "city": "Selah",
    "zip": 98942,
    "concatenated_address": "1060 N Wenas Rd, Selah",
    "address": "1060 N. Wenas Road, Selah"
  },
  {
    "id": 1418,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Riverview Manor",
    "latitude": 46.665684,
    "longitude": -120.51931,
    "original_address": "555 East Goodlander Road",
    "building_number": 555,
    "street": "E Goodlander Rd",
    "city": "Selah",
    "zip": 98942,
    "concatenated_address": "555 E Goodlander Rd, Selah",
    "address": "555 E. Goodlander Road, Selah"
  },
  {
    "id": 1419,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Dungeness Courte Alzheimers Community",
    "latitude": 48.086316,
    "longitude": -123.11475,
    "original_address": "651 Garry Oak Drive",
    "building_number": 651,
    "street": "Garry Oak Dr",
    "city": "Sequim",
    "zip": 98382,
    "concatenated_address": "651 Garry Oak Dr, Sequim",
    "address": "651 Garry Oak Drive, Sequim"
  },
  {
    "id": 1420,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Pebble Bay Apartments",
    "latitude": 48.077377,
    "longitude": -123.09946,
    "original_address": "300 S Sunnyside Ave.",
    "building_number": 300,
    "street": "S Sunnyside Ave",
    "city": "Sequim",
    "zip": 98382,
    "concatenated_address": "300 S Sunnyside Ave, Sequim",
    "address": "300 S. Sunnyside Ave., Sequim"
  },
  {
    "id": 1421,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Parkwood MHC",
    "latitude": 48.076849,
    "longitude": -123.16536,
    "original_address": "261520 Highway 101",
    "building_number": 261520,
    "street": "Hwy 101",
    "city": "Sequim",
    "zip": 98382,
    "concatenated_address": "261520 Hwy 101, Sequim",
    "address": "261520 Highway 101, Sequim"
  },
  {
    "id": 1422,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Hendrickson Mobile Home Park",
    "latitude": 48.08499,
    "longitude": -123.11845,
    "original_address": "535 N. Seventh Avenue",
    "building_number": 535,
    "street": "N 7th Ave",
    "city": "Sequim",
    "zip": 98382,
    "concatenated_address": "535 N 7th Ave, Sequim",
    "address": "535 N. 7th Ave., Sequim"
  },
  {
    "id": 1423,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Alpine Way",
    "latitude": 47.230706,
    "longitude": -123.10914,
    "original_address": "900 Alpine Way",
    "building_number": 900,
    "street": "Alpine Way",
    "city": "Shelton",
    "zip": 98584,
    "concatenated_address": "900 Alpine Way, Shelton",
    "address": "900 Alpine Way, Shelton"
  },
  {
    "id": 1424,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Maple Glen Assisted Living",
    "latitude": 47.225656,
    "longitude": -123.11096,
    "original_address": "1700 N 13Th Loop Road",
    "building_number": 1700,
    "street": "N 13th Loop Rd",
    "city": "Shelton",
    "zip": 98584,
    "concatenated_address": "1700 N 13th Loop Rd, Shelton",
    "address": "1700 N. 13th Loop Road, Shelton"
  },
  {
    "id": 1425,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Pine Garden Apartments",
    "latitude": 47.234524,
    "longitude": -123.10746,
    "original_address": "3000 Johns Prairie Road",
    "building_number": 3000,
    "street": "Johns Prairie Rd",
    "city": "Shelton",
    "zip": 98584,
    "concatenated_address": "3000 Johns Prairie Rd, Shelton",
    "address": "3000 Johns Prairie Road, Shelton"
  },
  {
    "id": 1426,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Extendicare21-Fir Lane Health",
    "latitude": 47.230718,
    "longitude": -123.11076,
    "original_address": "2430 North 13Th Street",
    "building_number": 2430,
    "street": "N 13th St",
    "city": "Shelton",
    "zip": 98584,
    "concatenated_address": "2430 N 13th St, Shelton",
    "address": "2430 N. 13th St., Shelton"
  },
  {
    "id": 1427,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Goldsborough Creek",
    "latitude": 47.211511,
    "longitude": -123.10885,
    "original_address": "303 South 7th St",
    "building_number": 303,
    "street": "S 7th St",
    "city": "Shelton",
    "zip": 98584,
    "concatenated_address": "303 S 7th St, Shelton",
    "address": "303 S. 7th St., Shelton"
  },
  {
    "id": 1428,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Ballinger Place",
    "latitude": 47.775848,
    "longitude": -122.31347,
    "original_address": "20060 15th Ave Ne",
    "building_number": 20060,
    "street": "15th Ave NE",
    "city": "Seattle",
    "zip": 98155,
    "concatenated_address": "20060 15th Ave NE, Seattle",
    "address": "20060 15th Ave. N.E., Seattle"
  },
  {
    "id": 1429,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Shorewood Court Apartments",
    "latitude": 47.759766,
    "longitude": -122.34427,
    "original_address": "1122 N. 180th Street",
    "building_number": 1122,
    "street": "N 180th St",
    "city": "Seattle",
    "zip": 98133,
    "concatenated_address": "1122 N 180th St, Seattle",
    "address": "1122 N. 180th St., Seattle"
  },
  {
    "id": 1430,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "The Artiste Apartment Homes",
    "latitude": 47.776442,
    "longitude": -122.34662,
    "original_address": "20221 Aurora Avenue North",
    "building_number": 20221,
    "street": "Aurora Ave N",
    "city": "Seattle",
    "zip": 98133,
    "concatenated_address": "20221 Aurora Ave N, Seattle",
    "address": "20221 Aurora Ave. N., Seattle"
  },
  {
    "id": 1431,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Linden Highlands",
    "latitude": 47.756686,
    "longitude": -122.34783,
    "original_address": "17520 Linden Avenue N",
    "building_number": 17520,
    "street": "Linden Ave N",
    "city": "Seattle",
    "zip": 98133,
    "concatenated_address": "17520 Linden Ave N, Seattle",
    "address": "17520 Linden Ave. N., Seattle"
  },
  {
    "id": 1432,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Sunrise 11 Apartments",
    "latitude": 47.773933,
    "longitude": -122.31051,
    "original_address": "20015 Ballinger Way Ne",
    "building_number": 20015,
    "street": "Ballinger Way NE",
    "city": "Seattle",
    "zip": 98155,
    "concatenated_address": "20015 Ballinger Way NE, Seattle",
    "address": "20015 Ballinger Way N.E., Seattle"
  },
  {
    "id": 1433,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "205 Apartments",
    "latitude": 47.777278,
    "longitude": -122.31008,
    "original_address": "1795 Northeast 205th Street",
    "building_number": 1795,
    "street": "NE 205th St",
    "city": "Seattle",
    "zip": 98155,
    "concatenated_address": "1795 NE 205th St, Seattle",
    "address": "1795 N.E. 205th St., Seattle"
  },
  {
    "id": 1434,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Paceline Apartments",
    "latitude": 47.75387,
    "longitude": -122.34471,
    "original_address": "17202 Aurora Avenue North",
    "building_number": 17202,
    "street": "Aurora Ave N",
    "city": "Seattle",
    "zip": 98133,
    "concatenated_address": "17202 Aurora Ave N, Seattle",
    "address": "17202 Aurora Ave. N., Seattle"
  },
  {
    "id": 1435,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Forest Hills Estates",
    "latitude": 47.755134,
    "longitude": -122.34241,
    "original_address": "1301 North 175th Street",
    "building_number": 1301,
    "street": "N 175th St",
    "city": "Seattle",
    "zip": 98133,
    "concatenated_address": "1301 N 175th St, Seattle",
    "address": "1301 N. 175th St., Seattle"
  },
  {
    "id": 1436,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "17210-17422 12th Avenue Northeast",
    "latitude": 47.755269,
    "longitude": -122.31582,
    "original_address": "17210-17422 12th Avenue Northeast",
    "building_number": 17422,
    "street": "12th Ave NE",
    "city": "Seattle",
    "zip": 98155,
    "concatenated_address": "17422 12th Ave NE, Seattle",
    "address": "17422 12th Ave. N.E., Seattle"
  },
  {
    "id": 1437,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Highlander Apartments",
    "latitude": 47.760962,
    "longitude": -122.34464,
    "original_address": "1115 N 183rd Street",
    "building_number": 1115,
    "street": "N 183rd St",
    "city": "Seattle",
    "zip": 98133,
    "concatenated_address": "1115 N 183rd St, Seattle",
    "address": "1115 N. 183rd St., Seattle"
  },
  {
    "id": 1438,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Ararbella Apartment Homes",
    "latitude": 47.759255,
    "longitude": -122.3141,
    "original_address": "17763 15th Avenue Ne",
    "building_number": 17763,
    "street": "15th Ave NE",
    "city": "Seattle",
    "zip": 98115,
    "concatenated_address": "17763 15th Ave NE, Seattle",
    "address": "17763 15th Ave. N.E., Seattle"
  },
  {
    "id": 1439,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Anderson Plaza",
    "latitude": 47.754327,
    "longitude": -122.31475,
    "original_address": "17201 15th Avenue",
    "building_number": 17201,
    "street": "15th Ave NE",
    "city": "Seattle",
    "zip": 98155,
    "concatenated_address": "17201 15th Ave NE, Seattle",
    "address": "17201 15th Ave. N.E., Seattle"
  },
  {
    "id": 1440,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Trillium Heights Apartments",
    "latitude": 47.672941,
    "longitude": -122.66972,
    "original_address": "12240 Daphne Lane Nw",
    "building_number": 12240,
    "street": "Daphne Ln NW",
    "city": "Silverdale",
    "zip": 98383,
    "concatenated_address": "12240 Daphne Ln NW, Silverdale",
    "address": "12240 Daphne Lane N.W., Silverdale"
  },
  {
    "id": 1441,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Crosspointe Apartments",
    "latitude": 47.652519,
    "longitude": -122.67855,
    "original_address": "9902 Cranberry Lane Nw",
    "building_number": 9902,
    "street": "Cranberry Ln NW",
    "city": "Silverdale",
    "zip": 98383,
    "concatenated_address": "9902 Cranberry Ln NW, Silverdale",
    "address": "9902 Cranberry Lane N.W., Silverdale"
  },
  {
    "id": 1442,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Crestwood Apartments",
    "latitude": 47.672498,
    "longitude": -122.70798,
    "original_address": "9866 9876 9879 9886 9887 9896 9897Enterprise Ln Nw",
    "building_number": "",
    "street": "",
    "city": "Silverdale",
    "zip": 98383,
    "concatenated_address": "9866 9876 9879 9886 9887 9896 9897Enterprise Ln Nw, Silverdale",
    "address": "9866, 9876, 9879, 9886, 9887, 9896, 9897 Enterprise Lane N.W., Silverdale"
  },
  {
    "id": 1443,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Reserve At Bucklin Hill",
    "latitude": 47.652968,
    "longitude": -122.66885,
    "original_address": "1255 Nw Mirage Ln",
    "building_number": 1255,
    "street": "NW Mirage Ln",
    "city": "Silverdale",
    "zip": 98383,
    "concatenated_address": "1255 NW Mirage Ln, Silverdale",
    "address": "1255 N.W. Mirage Lane, Silverdale"
  },
  {
    "id": 1444,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Ridgetop Apartment Homes",
    "latitude": 47.662485,
    "longitude": -122.66938,
    "original_address": "11153 Shipside Lane Nw",
    "building_number": 11153,
    "street": "Shipside Ln NW",
    "city": "Silverdale",
    "zip": 98383,
    "concatenated_address": "11153 Shipside Ln NW, Silverdale",
    "address": "11153 Shipside Lane N.W., Silverdale"
  },
  {
    "id": 1445,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Silverdale Ridge",
    "latitude": 47.667869,
    "longitude": -122.67098,
    "original_address": "1501 Nw Ambercrest Way",
    "building_number": 1501,
    "street": "NW Ambercrest Way",
    "city": "Silverdale",
    "zip": 98383,
    "concatenated_address": "1501 NW Ambercrest Way, Silverdale",
    "address": "1501 N.W. Ambercrest Way, Silverdale"
  },
  {
    "id": 1446,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Treetops Apartments",
    "latitude": 47.671363,
    "longitude": -122.66649,
    "original_address": "1206 Nw Tahoe Lane",
    "building_number": 1206,
    "street": "NW Tahoe Ln",
    "city": "Silverdale",
    "zip": 98383,
    "concatenated_address": "1206 NW Tahoe Ln, Silverdale",
    "address": "1206 N.W. Tahoe Lane, Silverdale"
  },
  {
    "id": 1447,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Madison At The Wellington",
    "latitude": 47.654795,
    "longitude": -122.69627,
    "original_address": "3414 Northwest Kensington Lane",
    "building_number": 3414,
    "street": "NW Kensington Ln",
    "city": "Silverdale",
    "zip": 98383,
    "concatenated_address": "3414 NW Kensington Ln, Silverdale",
    "address": "3414 N.W. Kensington Lane, Silverdale"
  },
  {
    "id": 1448,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Santa Fe Ridge Apartments",
    "latitude": 47.665202,
    "longitude": -122.6689,
    "original_address": "1415 Northwest Santa Fe Lane",
    "building_number": 1415,
    "street": "NW Santa Fe Ln",
    "city": "Silverdale",
    "zip": 98383,
    "concatenated_address": "1415 NW Santa Fe Ln, Silverdale",
    "address": "1415 N.W. Santa Fe Lane, Silverdale"
  },
  {
    "id": 1449,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "The Diplomat Apartment Homes",
    "latitude": 47.672293,
    "longitude": -122.67153,
    "original_address": "12188 Cloudy Peak Lane Northwest",
    "building_number": 12188,
    "street": "Cloudy Peak Ln NW",
    "city": "Silverdale",
    "zip": 98383,
    "concatenated_address": "12188 Cloudy Peak Ln NW, Silverdale",
    "address": "12188 Cloudy Peak Lane N.W., Silverdale"
  },
  {
    "id": 1450,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "The Woodlands Apartments",
    "latitude": 47.524152,
    "longitude": -121.8777,
    "original_address": "34626 Se Swenson Drive",
    "building_number": 34626,
    "street": "SE Swenson Dr",
    "city": "Snoqualmie",
    "zip": 98065,
    "concatenated_address": "34626 SE Swenson Dr, Snoqualmie",
    "address": "34626 S.E. Swenson Drive, Snoqualmie"
  },
  {
    "id": 1451,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Culmstock Arms Apartments",
    "latitude": 47.648529,
    "longitude": -117.41761,
    "original_address": "328 W. 8th Avenue",
    "building_number": 328,
    "street": "W 8th Ave",
    "city": "Spokane",
    "zip": 99204,
    "concatenated_address": "328 W 8th Ave, Spokane",
    "address": "328 W. 8th Ave., Spokane"
  },
  {
    "id": 1452,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Brookstone Apartments",
    "latitude": 47.661529,
    "longitude": -117.22825,
    "original_address": "13129 East Valleyway Ave.",
    "building_number": 13129,
    "street": "E Valleyway Ave",
    "city": "Spokane",
    "zip": 99216,
    "concatenated_address": "13129 E Valleyway Ave, Spokane",
    "address": "13129 E. Valleyway Ave., Spokane"
  },
  {
    "id": 1453,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Brookside Apartments",
    "latitude": 47.679598,
    "longitude": -117.37412,
    "original_address": "2405 East Upriver Drive",
    "building_number": 2405,
    "street": "E Upriver Dr",
    "city": "Spokane",
    "zip": 99207,
    "concatenated_address": "2405 E Upriver Dr, Spokane",
    "address": "2405 E. Upriver Drive, Spokane"
  },
  {
    "id": 1454,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Indian Canyon Apartments",
    "latitude": 47.64325,
    "longitude": -117.47312,
    "original_address": "1302 South Westcliff Place",
    "building_number": 1302,
    "street": "S Westcliff Pl",
    "city": "Spokane",
    "zip": 99224,
    "concatenated_address": "1302 S Westcliff Pl, Spokane",
    "address": "1302 S. Westcliff Place, Spokane"
  },
  {
    "id": 1455,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Adirondack Lodge",
    "latitude": 47.614464,
    "longitude": -117.37021,
    "original_address": "2711 East Adirondack Lane",
    "building_number": 2711,
    "street": "E Adirondack Ln",
    "city": "Spokane",
    "zip": 99223,
    "concatenated_address": "2711 E Adirondack Ln, Spokane",
    "address": "2711 E. Adirondack Lane, Spokane"
  },
  {
    "id": 1456,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Deer Creek Apartments",
    "latitude": 47.639726,
    "longitude": -117.55219,
    "original_address": "1610 South Deer Heights Road",
    "building_number": 1610,
    "street": "S Deer Heights Rd",
    "city": "Spokane",
    "zip": 99224,
    "concatenated_address": "1610 S Deer Heights Rd, Spokane",
    "address": "1610 S. Deer Heights Road, Spokane"
  },
  {
    "id": 1457,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Serrano Apartments",
    "latitude": 47.720422,
    "longitude": -117.40585,
    "original_address": "221 East Wedgewood Ave.",
    "building_number": 221,
    "street": "E Wedgewood Ave",
    "city": "Spokane",
    "zip": 99208,
    "concatenated_address": "221 E Wedgewood Ave, Spokane",
    "address": "221 E. Wedgewood Ave., Spokane"
  },
  {
    "id": 1458,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Northcliff Terrace Apartments",
    "latitude": 47.689235,
    "longitude": -117.42449,
    "original_address": "840 West Cora Avenue",
    "building_number": 840,
    "street": "W Cora Ave",
    "city": "Spokane",
    "zip": 99205,
    "concatenated_address": "840 W Cora Ave, Spokane",
    "address": "840 W. Cora Ave., Spokane"
  },
  {
    "id": 1459,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Hart Terrace Apartments",
    "latitude": 47.645495,
    "longitude": -117.36127,
    "original_address": "3308 East 11th Avenue",
    "building_number": 3308,
    "street": "E 11th Ave",
    "city": "Spokane",
    "zip": 99202,
    "concatenated_address": "3308 E 11th Ave, Spokane",
    "address": "3308 E. 11th Ave., Spokane"
  },
  {
    "id": 1460,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Highline At Kendall Yards",
    "latitude": 47.662493,
    "longitude": -117.43402,
    "original_address": "1512 W. Highline Ln",
    "building_number": 1512,
    "street": "W Highline Ln",
    "city": "Spokane",
    "zip": 99201,
    "concatenated_address": "1512 W Highline Ln, Spokane",
    "address": "1512 W. Highline Lane, Spokane"
  },
  {
    "id": 1461,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Rosewood Club Apartments",
    "latitude": 47.736819,
    "longitude": -117.40449,
    "original_address": "401 East Magnesium Road",
    "building_number": 401,
    "street": "E Magnesium Rd",
    "city": "Spokane",
    "zip": 99208,
    "concatenated_address": "401 E Magnesium Rd, Spokane",
    "address": "401 E. Magnesium Road, Spokane"
  },
  {
    "id": 1462,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Indian Canyon Apartments",
    "latitude": 47.643746,
    "longitude": -117.47248,
    "original_address": "1314 S. Westcliff Place",
    "building_number": 1314,
    "street": "S Westcliff Pl",
    "city": "Spokane",
    "zip": 99224,
    "concatenated_address": "1314 S Westcliff Pl, Spokane",
    "address": "1314 S. Westcliff Place, Spokane"
  },
  {
    "id": 1463,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Residence At River Run",
    "latitude": 47.671969,
    "longitude": -117.47259,
    "original_address": "1605 N River Ridge Blvd",
    "building_number": 1605,
    "street": "N River Ridge Blvd",
    "city": "Spokane",
    "zip": 99224,
    "concatenated_address": "1605 N River Ridge Blvd, Spokane",
    "address": "1605 N. River Ridge Blvd., Spokane"
  },
  {
    "id": 1464,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Pheasant Ridge",
    "latitude": 47.651544,
    "longitude": -117.27176,
    "original_address": "601 S. Woodruff",
    "building_number": 601,
    "street": "S Woodruff Rd",
    "city": "Spokane",
    "zip": 99206,
    "concatenated_address": "601 S Woodruff Rd, Spokane",
    "address": "601 S. Woodruff Road, Spokane"
  },
  {
    "id": 1465,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Beau Rivage",
    "latitude": 47.680791,
    "longitude": -117.33935,
    "original_address": "4707 East Upriver Drive",
    "building_number": 4707,
    "street": "E Upriver Dr",
    "city": "Spokane",
    "zip": 99217,
    "concatenated_address": "4707 E Upriver Dr, Spokane",
    "address": "4707 E. Upriver Drive, Spokane"
  },
  {
    "id": 1466,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Randolph Arms Apartments",
    "latitude": 47.628858,
    "longitude": -117.55129,
    "original_address": "3911 And 3915 W. Randolph Rd.",
    "building_number": "",
    "street": "",
    "city": "Spokane",
    "zip": 99224,
    "concatenated_address": "3911 And 3915 W. Randolph Rd., Spokane",
    "address": "3911 And 3915 W. Randolph Road., Spokane"
  },
  {
    "id": 1467,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Stonecrest Apartments",
    "latitude": 47.648843,
    "longitude": -117.4079,
    "original_address": "803 S. Cowley St.",
    "building_number": 803,
    "street": "S Cowley St",
    "city": "Spokane",
    "zip": 99202,
    "concatenated_address": "803 S Cowley St, Spokane",
    "address": "803 S. Cowley St., Spokane"
  },
  {
    "id": 1468,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "The Courts At Indian Canyon",
    "latitude": 47.644401,
    "longitude": -117.47509,
    "original_address": "4320 W Deska Dr",
    "building_number": 4320,
    "street": "W Deska Dr",
    "city": "Spokane",
    "zip": 99224,
    "concatenated_address": "4320 W Deska Dr, Spokane",
    "address": "4320 W. Deska Drive, Spokane"
  },
  {
    "id": 1469,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Adams Place Apartments",
    "latitude": 47.650511,
    "longitude": -117.43169,
    "original_address": "1310 W. 6th Ave.",
    "building_number": 1310,
    "street": "W 6th Ave",
    "city": "Spokane",
    "zip": 99204,
    "concatenated_address": "1310 W 6th Ave, Spokane",
    "address": "1310 W. 6th Ave., Spokane"
  },
  {
    "id": 1470,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Bentley Apartments",
    "latitude": 47.638748,
    "longitude": -117.56008,
    "original_address": "1715 South Hayford Road",
    "building_number": 1715,
    "street": "S Hayford Rd",
    "city": "Spokane",
    "zip": 99224,
    "concatenated_address": "1715 S Hayford Rd, Spokane",
    "address": "1715 S. Hayford Road, Spokane"
  },
  {
    "id": 1471,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "All Seasons Courtyard Apartments",
    "latitude": 47.6232,
    "longitude": -117.36909,
    "original_address": "3414 S. Regal Street",
    "building_number": 3414,
    "street": "S Regal St",
    "city": "Spokane",
    "zip": 99223,
    "concatenated_address": "3414 S Regal St, Spokane",
    "address": "3414 S. Regal St., Spokane"
  },
  {
    "id": 1472,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Northwood Ridge Apartments",
    "latitude": 47.707359,
    "longitude": -117.28201,
    "original_address": "9118 East Columbia Drive",
    "building_number": 9118,
    "street": "E Columbia Dr",
    "city": "Spokane",
    "zip": 99212,
    "concatenated_address": "9118 E Columbia Dr, Spokane",
    "address": "9118 E. Columbia Drive, Spokane"
  },
  {
    "id": 1473,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Chateaux Apartments",
    "latitude": 47.666509,
    "longitude": -117.41706,
    "original_address": "930 North Washington Street",
    "building_number": 930,
    "street": "N Washington St",
    "city": "Spokane",
    "zip": 99201,
    "concatenated_address": "930 N Washington St, Spokane",
    "address": "930 N. Washington St., Spokane"
  },
  {
    "id": 1474,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Cedar Hollow And Cedar Willow Apartments",
    "latitude": 47.605868,
    "longitude": -117.36836,
    "original_address": "5808 S. Regal Street. And 2820 East 53rd Avenue",
    "building_number": "",
    "street": "E 53rd Ave",
    "city": "Spokane",
    "zip": 99223,
    "concatenated_address": "5808 S. Regal Street. And 2820 East 53rd Avenue, Spokane",
    "address": "5808 S. Regal St.. And 2820 East 53rd Avenue, Spokane"
  },
  {
    "id": 1475,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Highline West Apartments",
    "latitude": 47.662295,
    "longitude": -117.43706,
    "original_address": "1701 W. Bridge Avenue",
    "building_number": 1701,
    "street": "W Bridge Ave",
    "city": "Spokane",
    "zip": 99201,
    "concatenated_address": "1701 W Bridge Ave, Spokane",
    "address": "1701 W. Bridge Ave., Spokane"
  },
  {
    "id": 1476,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Selkirk Lodge",
    "latitude": 47.742332,
    "longitude": -117.4879,
    "original_address": "9295 N Coursier Lane",
    "building_number": 9295,
    "street": "N Coursier Ln",
    "city": "Spokane",
    "zip": 99208,
    "concatenated_address": "9295 N Coursier Ln, Spokane",
    "address": "9295 N. Coursier Lane, Spokane"
  },
  {
    "id": 1477,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Blue Point Apartments",
    "latitude": 47.795123,
    "longitude": -117.40629,
    "original_address": "15001 N. Wandermere Road",
    "building_number": 15001,
    "street": "N Wandermere Rd",
    "city": "Spokane",
    "zip": 99208,
    "concatenated_address": "15001 N Wandermere Rd, Spokane",
    "address": "15001 N. Wandermere Road, Spokane"
  },
  {
    "id": 1478,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "317 CDA Apartments",
    "latitude": 47.653193,
    "longitude": -117.44767,
    "original_address": "317 S. Coeur D'Alene St.",
    "building_number": 317,
    "street": "S Coeur D Alene St",
    "city": "Spokane",
    "zip": 99201,
    "concatenated_address": "317 S Coeur D Alene St, Spokane",
    "address": "317 S. Coeur D Alene St., Spokane"
  },
  {
    "id": 1479,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Windriver Place",
    "latitude": 47.725328,
    "longitude": -117.49562,
    "original_address": "7310 N. Pine Rock Street",
    "building_number": 7310,
    "street": "N Pine Rock St",
    "city": "Spokane",
    "zip": 99208,
    "concatenated_address": "7310 N Pine Rock St, Spokane",
    "address": "7310 N. Pine Rock St., Spokane"
  },
  {
    "id": 1480,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Jake At Indian Trail Apartments",
    "latitude": 47.738767,
    "longitude": -117.48385,
    "original_address": "8808 N. Indian Trail Road",
    "building_number": 8808,
    "street": "N Indian Trail Rd",
    "city": "Spokane",
    "zip": 99208,
    "concatenated_address": "8808 N Indian Trail Rd, Spokane",
    "address": "8808 N. Indian Trail Road, Spokane"
  },
  {
    "id": 1481,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "New Madison Apartments",
    "latitude": 47.656413,
    "longitude": -117.42786,
    "original_address": "1021 - 1033 W 1st Avenue111 S Madison Street",
    "building_number": 1033,
    "street": "W 1st Ave",
    "city": "Spokane",
    "zip": 99201,
    "concatenated_address": "1033 W 1st Ave, Spokane",
    "address": "1033 W. 1st Ave., Spokane"
  },
  {
    "id": 1482,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Brentwood Garden Apartments",
    "latitude": 47.75754,
    "longitude": -117.40755,
    "original_address": "110 120 And 128 East Hawthorne Rd.",
    "building_number": "",
    "street": "",
    "city": "Spokane",
    "zip": 99218,
    "concatenated_address": "110 120 And 128 East Hawthorne Rd., Spokane",
    "address": "110 120 And 128 East Hawthorne Road, Spokane"
  },
  {
    "id": 1483,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Alpine Square Apartments",
    "latitude": 47.67869,
    "longitude": -117.36745,
    "original_address": "2918 East South Riverton Avenue",
    "building_number": 2918,
    "street": "E South Riverton Ave",
    "city": "Spokane",
    "zip": 99207,
    "concatenated_address": "2918 E South Riverton Ave, Spokane",
    "address": "2918 E. South Riverton Ave., Spokane"
  },
  {
    "id": 1484,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Arthur Court Apartments",
    "latitude": 47.648888,
    "longitude": -117.39547,
    "original_address": "716 South Arthur Street",
    "building_number": 716,
    "street": "S Arthur St",
    "city": "Spokane",
    "zip": 99202,
    "concatenated_address": "716 S Arthur St, Spokane",
    "address": "716 S. Arthur St., Spokane"
  },
  {
    "id": 1485,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Elm Lofts",
    "latitude": 47.661527,
    "longitude": -117.44084,
    "original_address": "1907 West Summit Parkway",
    "building_number": 1907,
    "street": "W Summit Pkwy",
    "city": "Spokane",
    "zip": 99201,
    "concatenated_address": "1907 W Summit Pkwy, Spokane",
    "address": "1907 W. Summit Pkwy, Spokane"
  },
  {
    "id": 1486,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Highline East Apartments",
    "latitude": 47.663028,
    "longitude": -117.43237,
    "original_address": "656 North Cedar Street",
    "building_number": 656,
    "street": "N Cedar St",
    "city": "Spokane",
    "zip": 99201,
    "concatenated_address": "656 N Cedar St, Spokane",
    "address": "656 N. Cedar St., Spokane"
  },
  {
    "id": 1487,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Cedar Estates",
    "latitude": 47.605868,
    "longitude": -117.36836,
    "original_address": "5808 S. Regal Street And 2820 East 53rd Avenue",
    "building_number": "",
    "street": "E 53rd Ave",
    "city": "Spokane",
    "zip": 99223,
    "concatenated_address": "5808 S. Regal Street And 2820 East 53rd Avenue, Spokane",
    "address": "5808 S. Regal St. And 2820 East 53rd Avenue, Spokane"
  },
  {
    "id": 1488,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Ashton Apartments",
    "latitude": 47.606329,
    "longitude": -117.35547,
    "original_address": "3630 East 51st Avenue",
    "building_number": 3630,
    "street": "E 51st Ave",
    "city": "Spokane",
    "zip": 99223,
    "concatenated_address": "3630 E 51st Ave, Spokane",
    "address": "3630 E. 51st Ave., Spokane"
  },
  {
    "id": 1489,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Pine Valley Ranch",
    "latitude": 47.624138,
    "longitude": -117.22235,
    "original_address": "3711 South Highway 27",
    "building_number": 3711,
    "street": "S Sr 27 Hwy",
    "city": "Spokane",
    "zip": 99206,
    "concatenated_address": "3711 S Sr 27 Hwy, Spokane",
    "address": "3711 S. Sr 27 Highway, Spokane"
  },
  {
    "id": 1490,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Beaumont-Biltmore Apartments",
    "latitude": 47.592452,
    "longitude": -117.34212,
    "original_address": "2525 & 2727 East 53rd Avenue",
    "building_number": "",
    "street": "",
    "city": "Spokane",
    "zip": 99223,
    "concatenated_address": "2525 & 2727 East 53rd Avenue, Spokane",
    "address": "2525 & 2727 East 53rd Avenue, Spokane"
  },
  {
    "id": 1491,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Blue Point Apartments Phase II",
    "latitude": 47.795123,
    "longitude": -117.40629,
    "original_address": "15001 N. Wandermere Road",
    "building_number": 15001,
    "street": "N Wandermere Rd",
    "city": "Spokane",
    "zip": 99208,
    "concatenated_address": "15001 N Wandermere Rd, Spokane",
    "address": "15001 N. Wandermere Road, Spokane"
  },
  {
    "id": 1492,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Riverview Lofts",
    "latitude": 47.672974,
    "longitude": -117.38547,
    "original_address": "1608 East South Riverton Avenue",
    "building_number": 1608,
    "street": "E Riverton Ave",
    "city": "Spokane",
    "zip": 99207,
    "concatenated_address": "1608 E Riverton Ave, Spokane",
    "address": "1608 E. Riverton Ave., Spokane"
  },
  {
    "id": 1493,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Hideaway MHC",
    "latitude": 47.614977,
    "longitude": -117.50753,
    "original_address": "4315 South Cheatham Road",
    "building_number": 4315,
    "street": "S Cheatham Rd",
    "city": "Spokane",
    "zip": 99224,
    "concatenated_address": "4315 S Cheatham Rd, Spokane",
    "address": "4315 S. Cheatham Road, Spokane"
  },
  {
    "id": 1494,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Bentley Apartments",
    "latitude": 47.628858,
    "longitude": -117.55129,
    "original_address": "1705 And 1715 S Hayford Road",
    "building_number": "",
    "street": "",
    "city": "Spokane",
    "zip": 99224,
    "concatenated_address": "1705 And 1715 S Hayford Road, Spokane",
    "address": "1705 And 1715 S. Hayford Road, Spokane"
  },
  {
    "id": 1495,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Canyon Greens Apartments",
    "latitude": 47.645728,
    "longitude": -117.47138,
    "original_address": "1001 South Westcliff Place",
    "building_number": 1001,
    "street": "S Westcliff Pl",
    "city": "Spokane",
    "zip": 99224,
    "concatenated_address": "1001 S Westcliff Pl, Spokane",
    "address": "1001 S. Westcliff Place, Spokane"
  },
  {
    "id": 1496,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "North Star Lodge",
    "latitude": 47.717734,
    "longitude": -117.4322,
    "original_address": "6614 North Cedar Road",
    "building_number": 6614,
    "street": "N Cedar Rd",
    "city": "Spokane",
    "zip": 99208,
    "concatenated_address": "6614 N Cedar Rd, Spokane",
    "address": "6614 N. Cedar Road, Spokane"
  },
  {
    "id": 1497,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "South Hill Heights",
    "latitude": 47.647745,
    "longitude": -117.42432,
    "original_address": "815 S. Lincoln Street",
    "building_number": 815,
    "street": "S Lincoln St",
    "city": "Spokane",
    "zip": 99204,
    "concatenated_address": "815 S Lincoln St, Spokane",
    "address": "815 S. Lincoln St., Spokane"
  },
  {
    "id": 1498,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Cascade MHC",
    "latitude": 47.640864,
    "longitude": -117.44752,
    "original_address": "2311 West 16th Avenue",
    "building_number": 2311,
    "street": "W 16th Ave",
    "city": "Spokane",
    "zip": 99224,
    "concatenated_address": "2311 W 16th Ave, Spokane",
    "address": "2311 W. 16th Ave., Spokane"
  },
  {
    "id": 1499,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Brookdale Nine Mile",
    "latitude": 47.721726,
    "longitude": -117.48859,
    "original_address": "5329 West Rifle Club Court",
    "building_number": 5329,
    "street": "W Rifle Club Ct",
    "city": "Spokane",
    "zip": 99208,
    "concatenated_address": "5329 W Rifle Club Ct, Spokane",
    "address": "5329 W. Rifle Club Ct, Spokane"
  },
  {
    "id": 1500,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Harvard Park",
    "latitude": 47.626719,
    "longitude": -117.38662,
    "original_address": "1616 East 30th Avenue",
    "building_number": 1616,
    "street": "E 30th Ave",
    "city": "Spokane",
    "zip": 99203,
    "concatenated_address": "1616 E 30th Ave, Spokane",
    "address": "1616 E. 30th Ave., Spokane"
  },
  {
    "id": 1501,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Windsor Crossing",
    "latitude": 47.59338,
    "longitude": -117.48917,
    "original_address": "5321 West John Gay Drive",
    "building_number": 5321,
    "street": "W John Gay Dr",
    "city": "Spokane",
    "zip": 99224,
    "concatenated_address": "5321 W John Gay Dr, Spokane",
    "address": "5321 W. John Gay Drive, Spokane"
  },
  {
    "id": 1502,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Hill 'N Dale Apartments",
    "latitude": 47.737339,
    "longitude": -117.40652,
    "original_address": "8719 North Hill N Dale Street",
    "building_number": 8719,
    "street": "N Hill N Dale St",
    "city": "Spokane",
    "zip": 99218,
    "concatenated_address": "8719 N Hill N Dale St, Spokane",
    "address": "8719 N. Hill N. Dale St., Spokane"
  },
  {
    "id": 1503,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Affinity At Mill Road",
    "latitude": 47.77265,
    "longitude": -117.41784,
    "original_address": "12710 North Mill Road",
    "building_number": 12710,
    "street": "N Mill Rd",
    "city": "Spokane",
    "zip": 99208,
    "concatenated_address": "12710 N Mill Rd, Spokane",
    "address": "12710 N. Mill Road, Spokane"
  },
  {
    "id": 1504,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Touchmark On South Hill",
    "latitude": 47.627106,
    "longitude": -117.38277,
    "original_address": "2929 South Waterford Drive",
    "building_number": 2929,
    "street": "S Waterford Dr",
    "city": "Spokane",
    "zip": 99203,
    "concatenated_address": "2929 S Waterford Dr, Spokane",
    "address": "2929 S. Waterford Drive, Spokane"
  },
  {
    "id": 1505,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Deer Run At Northpointe",
    "latitude": 47.74585,
    "longitude": -117.39114,
    "original_address": "1225 East Westview Court",
    "building_number": 1225,
    "street": "E Westview Ct",
    "city": "Spokane",
    "zip": 99218,
    "concatenated_address": "1225 E Westview Ct, Spokane",
    "address": "1225 E. Westview Ct, Spokane"
  },
  {
    "id": 1506,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Whispering Pines",
    "latitude": 47.626868,
    "longitude": -117.36726,
    "original_address": "3002 East 30th Avenue",
    "building_number": 3002,
    "street": "E 30th Ave",
    "city": "Spokane",
    "zip": 99223,
    "concatenated_address": "3002 E 30th Ave, Spokane",
    "address": "3002 E. 30th Ave., Spokane"
  },
  {
    "id": 1507,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Timber Court",
    "latitude": 47.621071,
    "longitude": -117.37067,
    "original_address": "2707 East 37th Avenue",
    "building_number": 2707,
    "street": "E 37th Ave",
    "city": "Spokane",
    "zip": 99223,
    "concatenated_address": "2707 E 37th Ave, Spokane",
    "address": "2707 E. 37th Ave., Spokane"
  },
  {
    "id": 1508,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Manito Gardens",
    "latitude": 47.628286,
    "longitude": -117.39977,
    "original_address": "East 500 29th Avenue",
    "building_number": "",
    "street": "E 29th Ave",
    "city": "Spokane",
    "zip": 99203,
    "concatenated_address": "East 500 29th Avenue, Spokane",
    "address": "East 500 29th Avenue, Spokane"
  },
  {
    "id": 1509,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Opportunity Manor",
    "latitude": 47.659802,
    "longitude": -117.23773,
    "original_address": "12325 East Main Avenue",
    "building_number": 12325,
    "street": "E Main Ave",
    "city": "Spokane",
    "zip": 99216,
    "concatenated_address": "12325 E Main Ave, Spokane",
    "address": "12325 E. Main Ave., Spokane"
  },
  {
    "id": 1510,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Winchester Court I II",
    "latitude": 47.695491,
    "longitude": -117.37398,
    "original_address": "4101 North Cook Street",
    "building_number": 4101,
    "street": "N Cook St",
    "city": "Spokane",
    "zip": 98207,
    "concatenated_address": "4101 N Cook St, Spokane",
    "address": "4101 N. Cook St., Spokane"
  },
  {
    "id": 1511,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "The Timbers At Wandermere",
    "latitude": 47.770344,
    "longitude": -117.39577,
    "original_address": "824 East Hastings Road",
    "building_number": 824,
    "street": "E Hastings Rd",
    "city": "Spokane",
    "zip": 99218,
    "concatenated_address": "824 E Hastings Rd, Spokane",
    "address": "824 E. Hastings Road, Spokane"
  },
  {
    "id": 1512,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Ponderosa",
    "latitude": 47.677523,
    "longitude": -117.27894,
    "original_address": "9314 East Montgomery Ave",
    "building_number": 9314,
    "street": "E Montgomery Ave",
    "city": "Spokane",
    "zip": 99206,
    "concatenated_address": "9314 E Montgomery Ave, Spokane",
    "address": "9314 E. Montgomery Ave., Spokane"
  },
  {
    "id": 1513,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Park Tower Apartments",
    "latitude": 47.659848,
    "longitude": -117.41423,
    "original_address": "217 W. Spokane Falls Boulevard",
    "building_number": 217,
    "street": "W Spokane Falls Blvd",
    "city": "Spokane",
    "zip": 99201,
    "concatenated_address": "217 W Spokane Falls Blvd, Spokane",
    "address": "217 W. Spokane Falls Blvd., Spokane"
  },
  {
    "id": 1514,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Copper Hill Apartments",
    "latitude": 47.613374,
    "longitude": -117.36239,
    "original_address": "3210 East 44th Avenue",
    "building_number": 3210,
    "street": "E 44th Ave",
    "city": "Spokane",
    "zip": 99223,
    "concatenated_address": "3210 E 44th Ave, Spokane",
    "address": "3210 E. 44th Ave., Spokane"
  },
  {
    "id": 1515,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Hillyard Plaza Apartments",
    "latitude": 47.706504,
    "longitude": -117.3691,
    "original_address": "2808 East Sanson Avenue",
    "building_number": 2808,
    "street": "E Sanson Ave",
    "city": "Spokane",
    "zip": 99217,
    "concatenated_address": "2808 E Sanson Ave, Spokane",
    "address": "2808 E. Sanson Ave., Spokane"
  },
  {
    "id": 1516,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Canterbury Court Apartments",
    "latitude": 47.645072,
    "longitude": -117.40738,
    "original_address": "1010 S Rockwood Boulevard",
    "building_number": 1010,
    "street": "S Rockwood Blvd",
    "city": "Spokane",
    "zip": 99203,
    "concatenated_address": "1010 S Rockwood Blvd, Spokane",
    "address": "1010 S. Rockwood Blvd., Spokane"
  },
  {
    "id": 1517,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "The O'Malley",
    "latitude": 47.67211,
    "longitude": -117.39875,
    "original_address": "707 East Mission",
    "building_number": 707,
    "street": "E Mission Ave",
    "city": "Spokane",
    "zip": 99202,
    "concatenated_address": "707 E Mission Ave, Spokane",
    "address": "707 E. Mission Ave., Spokane"
  },
  {
    "id": 1518,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Cathedral Plaza",
    "latitude": 47.657472,
    "longitude": -117.42903,
    "original_address": "1120 Sprague Ave.",
    "building_number": 1120,
    "street": "W Sprague Ave",
    "city": "Spokane",
    "zip": 99201,
    "concatenated_address": "1120 W Sprague Ave, Spokane",
    "address": "1120 W. Sprague Ave., Spokane"
  },
  {
    "id": 1519,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Liberty Park Apartments",
    "latitude": 47.650123,
    "longitude": -117.38846,
    "original_address": "1411 East Hartson Avenue",
    "building_number": 1411,
    "street": "E Hartson Ave",
    "city": "Spokane",
    "zip": 99202,
    "concatenated_address": "1411 E Hartson Ave, Spokane",
    "address": "1411 E. Hartson Ave., Spokane"
  },
  {
    "id": 1520,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Prestige Care-Sullivan Park Assisted Living",
    "latitude": 47.652101,
    "longitude": -117.20639,
    "original_address": "421 South Adams Road",
    "building_number": 421,
    "street": "S Adams Rd",
    "city": "Spokane",
    "zip": 99216,
    "concatenated_address": "421 S Adams Rd, Spokane",
    "address": "421 S. Adams Road, Spokane"
  },
  {
    "id": 1521,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Alderwood Manor",
    "latitude": 47.649821,
    "longitude": -117.35687,
    "original_address": "3600 East Hartson Ave",
    "building_number": 3600,
    "street": "E Hartson Ave",
    "city": "Spokane",
    "zip": 99202,
    "concatenated_address": "3600 E Hartson Ave, Spokane",
    "address": "3600 E. Hartson Ave., Spokane"
  },
  {
    "id": 1522,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "The Gardens on University Skilled Nursing Care",
    "latitude": 47.652654,
    "longitude": -117.26205,
    "original_address": "414 South University Road",
    "building_number": 414,
    "street": "S University Rd",
    "city": "Spokane",
    "zip": 99206,
    "concatenated_address": "414 S University Rd, Spokane",
    "address": "414 S. University Road, Spokane"
  },
  {
    "id": 1523,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Franklin Hills Health & Rehab",
    "latitude": 47.71279,
    "longitude": -117.40647,
    "original_address": "6021 North Lidgerwood",
    "building_number": 6021,
    "street": "N Lidgerwood St",
    "city": "Spokane",
    "zip": 99207,
    "concatenated_address": "6021 N Lidgerwood St, Spokane",
    "address": "6021 N. Lidgerwood St., Spokane"
  },
  {
    "id": 1524,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Avalon Care Center At Northpointe",
    "latitude": 47.746444,
    "longitude": -117.39853,
    "original_address": "9827 North Nevada Road",
    "building_number": 9827,
    "street": "N Nevada St",
    "city": "Spokane",
    "zip": 99218,
    "concatenated_address": "9827 N Nevada St, Spokane",
    "address": "9827 N. Nevada St., Spokane"
  },
  {
    "id": 1525,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Regency At Northpointe",
    "latitude": 47.75754,
    "longitude": -117.40755,
    "original_address": "St Westview Court",
    "building_number": "",
    "street": "",
    "city": "Spokane",
    "zip": 99218,
    "concatenated_address": "St Westview Court, Spokane",
    "address": "St Westview Court, Spokane"
  },
  {
    "id": 1526,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Canyon Bluff Apartments",
    "latitude": 47.632594,
    "longitude": -117.45192,
    "original_address": "2611 West Westwood Lane",
    "building_number": 2611,
    "street": "W Westwood Ln",
    "city": "Spokane",
    "zip": 99224,
    "concatenated_address": "2611 W Westwood Ln, Spokane",
    "address": "2611 W. Westwood Lane, Spokane"
  },
  {
    "id": 1527,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Canyon Bluffs Apartments",
    "latitude": 47.628858,
    "longitude": -117.55129,
    "original_address": "2110 And 2111 S. Canyon Woods",
    "building_number": "",
    "street": "",
    "city": "Spokane",
    "zip": 99224,
    "concatenated_address": "2110 And 2111 S. Canyon Woods, Spokane",
    "address": "2110 & 2111 S. Canyon Woods, Spokane"
  },
  {
    "id": 1528,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "The Ridge At Midway",
    "latitude": 47.805493,
    "longitude": -117.40105,
    "original_address": "16320 N Hatch Road",
    "building_number": 16320,
    "street": "N Hatch Rd",
    "city": "Colbert",
    "zip": 99208,
    "concatenated_address": "16320 N Hatch Rd, Colbert",
    "address": "16320 N. Hatch Road, Colbert"
  },
  {
    "id": 1529,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Spokane Portfolio",
    "latitude": 47.655805,
    "longitude": -117.43619,
    "original_address": "1600 W. Pacific Ave.",
    "building_number": 1600,
    "street": "W Pacific Ave",
    "city": "Spokane",
    "zip": 99201,
    "concatenated_address": "1600 W Pacific Ave, Spokane",
    "address": "1600 W. Pacific Ave., Spokane"
  },
  {
    "id": 1530,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "North Central Care Center",
    "latitude": 47.674364,
    "longitude": -117.42166,
    "original_address": "1812 North Wall Street",
    "building_number": 1812,
    "street": "N Wall St",
    "city": "Spokane",
    "zip": 99205,
    "concatenated_address": "1812 N Wall St, Spokane",
    "address": "1812 N. Wall St., Spokane"
  },
  {
    "id": 1531,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Eagle Rock Apartments",
    "latitude": 47.67777,
    "longitude": -117.23729,
    "original_address": "12423 East Mansfield Avenue",
    "building_number": 12423,
    "street": "E Mansfield Ave",
    "city": "Spokane",
    "zip": 99216,
    "concatenated_address": "12423 E Mansfield Ave, Spokane",
    "address": "12423 E. Mansfield Ave., Spokane"
  },
  {
    "id": 1532,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Sunrise Village Apartments",
    "latitude": 47.654088,
    "longitude": -117.19453,
    "original_address": "15615 East 4th Avenue",
    "building_number": 15615,
    "street": "E 4th Ave",
    "city": "Veradale",
    "zip": 99037,
    "concatenated_address": "15615 E 4th Ave, Veradale",
    "address": "15615 E. 4th Ave., Veradale"
  },
  {
    "id": 1533,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Clocktower Place Apartments",
    "latitude": 47.654347,
    "longitude": -117.19326,
    "original_address": "15719 East 4th Avenue",
    "building_number": 15719,
    "street": "E 4th Ave",
    "city": "Veradale",
    "zip": 99037,
    "concatenated_address": "15719 E 4th Ave, Veradale",
    "address": "15719 E. 4th Ave., Veradale"
  },
  {
    "id": 1534,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Homestead Apartments",
    "latitude": 47.651685,
    "longitude": -117.19355,
    "original_address": "15720 East 4th Ave",
    "building_number": 15720,
    "street": "E 4th Ave",
    "city": "Veradale",
    "zip": 99037,
    "concatenated_address": "15720 E 4th Ave, Veradale",
    "address": "15720 E. 4th Ave., Veradale"
  },
  {
    "id": 1535,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Sunshine Village Apartments",
    "latitude": 47.654577,
    "longitude": -117.19598,
    "original_address": "217 S. Sullivan Rd",
    "building_number": 217,
    "street": "S Sullivan Rd",
    "city": "Veradale",
    "zip": 99037,
    "concatenated_address": "217 S Sullivan Rd, Veradale",
    "address": "217 S. Sullivan Road, Veradale"
  },
  {
    "id": 1536,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Fox Court Apartments",
    "latitude": 47.654255,
    "longitude": -117.24727,
    "original_address": "11715 East 4th Ave.",
    "building_number": 11715,
    "street": "E 4th Ave",
    "city": "Spokane",
    "zip": 99206,
    "concatenated_address": "11715 E 4th Ave, Spokane",
    "address": "11715 E. 4th Ave., Spokane"
  },
  {
    "id": 1537,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Park Place Apartments",
    "latitude": 47.665571,
    "longitude": -117.29788,
    "original_address": "916 North Ella Road",
    "building_number": 916,
    "street": "N Ella Rd",
    "city": "Spokane",
    "zip": 99212,
    "concatenated_address": "916 N Ella Rd, Spokane",
    "address": "916 N. Ella Road, Spokane"
  },
  {
    "id": 1538,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Mirabolante Apartments",
    "latitude": 47.663367,
    "longitude": -117.18831,
    "original_address": "16102 East Broadway Ave",
    "building_number": 16102,
    "street": "E Broadway Ave",
    "city": "Veradale",
    "zip": 99037,
    "concatenated_address": "16102 E Broadway Ave, Veradale",
    "address": "16102 E. Broadway Ave., Veradale"
  },
  {
    "id": 1539,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Marietta Villas Apartments",
    "latitude": 47.681114,
    "longitude": -117.24206,
    "original_address": "12010-12040 East Marietta Avenue",
    "building_number": 12040,
    "street": "E Marietta Ave",
    "city": "Spokane",
    "zip": 99206,
    "concatenated_address": "12040 E Marietta Ave, Spokane",
    "address": "12040 E. Marietta Ave., Spokane"
  },
  {
    "id": 1540,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Whimsical Pig",
    "latitude": 47.671971,
    "longitude": -117.22611,
    "original_address": "13303 East Mission Avenue",
    "building_number": 13303,
    "street": "E Mission Ave",
    "city": "Spokane",
    "zip": 99216,
    "concatenated_address": "13303 E Mission Ave, Spokane",
    "address": "13303 E. Mission Ave., Spokane"
  },
  {
    "id": 1541,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Brianwood Apartments",
    "latitude": 47.672417,
    "longitude": -117.27848,
    "original_address": "9407 East Mission Avenue",
    "building_number": 9407,
    "street": "E Mission Ave",
    "city": "Spokane",
    "zip": 99206,
    "concatenated_address": "9407 E Mission Ave, Spokane",
    "address": "9407 E. Mission Ave., Spokane"
  },
  {
    "id": 1542,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Bella Tess Apartments",
    "latitude": 47.670684,
    "longitude": -117.17628,
    "original_address": "17016 East Indiana Parkway",
    "building_number": 17016,
    "street": "E Indiana Pkwy",
    "city": "Greenacres",
    "zip": 99016,
    "concatenated_address": "17016 E Indiana Pkwy, Greenacres",
    "address": "17016 E. Indiana Pkwy, Greenacres"
  },
  {
    "id": 1543,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Whispering Pines",
    "latitude": 47.655606,
    "longitude": -117.14766,
    "original_address": "19106 East Sprague Ave",
    "building_number": 19106,
    "street": "E Sprague Ave",
    "city": "Greenacres",
    "zip": 99016,
    "concatenated_address": "19106 E Sprague Ave, Greenacres",
    "address": "19106 E. Sprague Ave., Greenacres"
  },
  {
    "id": 1544,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Cherry Bluff Apartments Andcherry Ridge Apartments",
    "latitude": 47.671164,
    "longitude": -117.19926,
    "original_address": "2405 And 2415 N. Cherry Street",
    "building_number": "",
    "street": "",
    "city": "Spokane",
    "zip": 99216,
    "concatenated_address": "2405 And 2415 N. Cherry Street, Spokane",
    "address": "2405 And 2415 N. Cherry St., Spokane"
  },
  {
    "id": 1545,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Arbor Grove Mobile Home Park",
    "latitude": 47.670876,
    "longitude": -117.14741,
    "original_address": "19029 East Boone Avenue",
    "building_number": 19029,
    "street": "E Boone Ave",
    "city": "Greenacres",
    "zip": 99016,
    "concatenated_address": "19029 E Boone Ave, Greenacres",
    "address": "19029 E. Boone Ave., Greenacres"
  },
  {
    "id": 1546,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Mirabolante Apartments",
    "latitude": 47.663367,
    "longitude": -117.18831,
    "original_address": "16102 East Broadway Avenue",
    "building_number": 16102,
    "street": "E Broadway Ave",
    "city": "Veradale",
    "zip": 99037,
    "concatenated_address": "16102 E Broadway Ave, Veradale",
    "address": "16102 E. Broadway Ave., Veradale"
  },
  {
    "id": 1547,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Clocktower Place Apartments",
    "latitude": 47.654347,
    "longitude": -117.19326,
    "original_address": "15719 East 4th Ave",
    "building_number": 15719,
    "street": "E 4th Ave",
    "city": "Veradale",
    "zip": 99037,
    "concatenated_address": "15719 E 4th Ave, Veradale",
    "address": "15719 E. 4th Ave., Veradale"
  },
  {
    "id": 1548,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Sunrise Village Apartments",
    "latitude": 47.654088,
    "longitude": -117.19453,
    "original_address": "15615 East 4th Ave",
    "building_number": 15615,
    "street": "E 4th Ave",
    "city": "Veradale",
    "zip": 99037,
    "concatenated_address": "15615 E 4th Ave, Veradale",
    "address": "15615 E. 4th Ave., Veradale"
  },
  {
    "id": 1549,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Sunshine Village Apartments",
    "latitude": 47.654577,
    "longitude": -117.19598,
    "original_address": "217 S Sullivan Rd",
    "building_number": 217,
    "street": "S Sullivan Rd",
    "city": "Veradale",
    "zip": 99037,
    "concatenated_address": "217 S Sullivan Rd, Veradale",
    "address": "217 S. Sullivan Road, Veradale"
  },
  {
    "id": 1550,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Broadway Villas II",
    "latitude": 47.664047,
    "longitude": -117.22379,
    "original_address": "13420 East Broadway Avenue",
    "building_number": 13420,
    "street": "E Broadway Ave",
    "city": "Spokane",
    "zip": 99216,
    "concatenated_address": "13420 E Broadway Ave, Spokane",
    "address": "13420 E. Broadway Ave., Spokane"
  },
  {
    "id": 1551,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "The Blake",
    "latitude": 47.653957,
    "longitude": -117.22516,
    "original_address": "13313 East 4th Avenue",
    "building_number": 13313,
    "street": "E 4th Ave",
    "city": "Spokane",
    "zip": 99216,
    "concatenated_address": "13313 E 4th Ave, Spokane",
    "address": "13313 E. 4th Ave., Spokane"
  },
  {
    "id": 1552,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Eastgate Apartments",
    "latitude": 47.653567,
    "longitude": -117.18902,
    "original_address": "15913 East 4th Ave",
    "building_number": 15913,
    "street": "E 4th Ave",
    "city": "Veradale",
    "zip": 99037,
    "concatenated_address": "15913 E 4th Ave, Veradale",
    "address": "15913 E. 4th Ave., Veradale"
  },
  {
    "id": 1553,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Village On Broadway",
    "latitude": 47.665551,
    "longitude": -117.23546,
    "original_address": "12623 East Broadway Avenue",
    "building_number": 12623,
    "street": "E Broadway Ave",
    "city": "Spokane",
    "zip": 99216,
    "concatenated_address": "12623 E Broadway Ave, Spokane",
    "address": "12623 E. Broadway Ave., Spokane"
  },
  {
    "id": 1554,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "River House At The Trailhead",
    "latitude": 47.670591,
    "longitude": -117.18184,
    "original_address": "16621 East Indiana Avenue",
    "building_number": 16621,
    "street": "E Indiana Ave",
    "city": "Greenacres",
    "zip": 99216,
    "concatenated_address": "16621 E Indiana Ave, Greenacres",
    "address": "16621 E. Indiana Ave., Greenacres"
  },
  {
    "id": 1555,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "South Eastern Apartments",
    "latitude": 47.65256,
    "longitude": -117.32002,
    "original_address": "403 S Eastern Road",
    "building_number": 403,
    "street": "S Eastern Rd",
    "city": "Spokane",
    "zip": 99212,
    "concatenated_address": "403 S Eastern Rd, Spokane",
    "address": "403 S. Eastern Road, Spokane"
  },
  {
    "id": 1556,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Montgomery Court Apartments",
    "latitude": 47.678605,
    "longitude": -117.2486,
    "original_address": "2301 North Wilbur Road",
    "building_number": 2301,
    "street": "N Wilbur Rd",
    "city": "Spokane",
    "zip": 99206,
    "concatenated_address": "2301 N Wilbur Rd, Spokane",
    "address": "2301 N. Wilbur Road, Spokane"
  },
  {
    "id": 1557,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Bella Tess Phase II",
    "latitude": 47.670684,
    "longitude": -117.17628,
    "original_address": "17016 East Indiana Parkway",
    "building_number": 17016,
    "street": "E Indiana Pkwy",
    "city": "Greenacres",
    "zip": 99016,
    "concatenated_address": "17016 E Indiana Pkwy, Greenacres",
    "address": "17016 E. Indiana Pkwy, Greenacres"
  },
  {
    "id": 1558,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Willowbrook Apartment Homes",
    "latitude": 47.670272,
    "longitude": -117.24105,
    "original_address": "12202 East Maxwell Avenue",
    "building_number": 12202,
    "street": "E Maxwell Ave",
    "city": "Spokane",
    "zip": 99206,
    "concatenated_address": "12202 E Maxwell Ave, Spokane",
    "address": "12202 E. Maxwell Ave., Spokane"
  },
  {
    "id": 1559,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Pine Ridge Alzheimer's Special Care Center",
    "latitude": 47.672054,
    "longitude": -117.24247,
    "original_address": "12009 East Mission Avenue",
    "building_number": 12009,
    "street": "E Mission Ave",
    "city": "Spokane",
    "zip": 99206,
    "concatenated_address": "12009 E Mission Ave, Spokane",
    "address": "12009 E. Mission Ave., Spokane"
  },
  {
    "id": 1560,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Eagle Pointe",
    "latitude": 47.681692,
    "longitude": -117.24938,
    "original_address": "2718 North Bowdish Road",
    "building_number": 2718,
    "street": "N Bowdish Rd",
    "city": "Spokane",
    "zip": 99206,
    "concatenated_address": "2718 N Bowdish Rd, Spokane",
    "address": "2718 N. Bowdish Road, Spokane"
  },
  {
    "id": 1561,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Aspen Village",
    "latitude": 47.65404,
    "longitude": -117.19159,
    "original_address": "15821 East 4th Avenue",
    "building_number": 15821,
    "street": "E 4th Ave",
    "city": "Veradale",
    "zip": 99037,
    "concatenated_address": "15821 E 4th Ave, Veradale",
    "address": "15821 E. 4th Ave., Veradale"
  },
  {
    "id": 1562,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Ridgestone Apartments",
    "latitude": 47.67304,
    "longitude": -117.24624,
    "original_address": "1723 North Union Road",
    "building_number": 1723,
    "street": "N Union Rd",
    "city": "Spokane",
    "zip": 99206,
    "concatenated_address": "1723 N Union Rd, Spokane",
    "address": "1723 N. Union Road, Spokane"
  },
  {
    "id": 1563,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Somerset Meadows Apartments",
    "latitude": 47.694568,
    "longitude": -117.22804,
    "original_address": "4216 North Mcdonald Road",
    "building_number": 4216,
    "street": "N McDonald Rd",
    "city": "Spokane",
    "zip": 99216,
    "concatenated_address": "4216 N McDonald Rd, Spokane",
    "address": "4216 N. McDonald Road, Spokane"
  },
  {
    "id": 1564,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Farr Court Apartments",
    "latitude": 47.654638,
    "longitude": -117.27688,
    "original_address": "210 South Farr Road",
    "building_number": 210,
    "street": "S Farr Rd",
    "city": "Spokane",
    "zip": 99206,
    "concatenated_address": "210 S Farr Rd, Spokane",
    "address": "210 S. Farr Road, Spokane"
  },
  {
    "id": 1565,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Oakwood Club",
    "latitude": 47.663432,
    "longitude": -117.22787,
    "original_address": "726 North Mcdonald Road",
    "building_number": 726,
    "street": "N McDonald Rd",
    "city": "Spokane",
    "zip": 99216,
    "concatenated_address": "726 N McDonald Rd, Spokane",
    "address": "726 N. McDonald Road, Spokane"
  },
  {
    "id": 1566,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Bavarian Villas",
    "latitude": 47.658015,
    "longitude": -117.23202,
    "original_address": "12903 East Sprague Avenue",
    "building_number": 12903,
    "street": "E Sprague Ave",
    "city": "Spokane",
    "zip": 99216,
    "concatenated_address": "12903 E Sprague Ave, Spokane",
    "address": "12903 E. Sprague Ave., Spokane"
  },
  {
    "id": 1567,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Beringer Place Apartments",
    "latitude": 47.658465,
    "longitude": -117.27797,
    "original_address": "111 North Locust Road",
    "building_number": 111,
    "street": "N Locust Rd",
    "city": "Spokane",
    "zip": 99206,
    "concatenated_address": "111 N Locust Rd, Spokane",
    "address": "111 N. Locust Road, Spokane"
  },
  {
    "id": 1568,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Evergreen Fountains Phase II",
    "latitude": 47.667545,
    "longitude": -117.22027,
    "original_address": "1112 N. Mamer Road",
    "building_number": 1112,
    "street": "N Mamer Rd",
    "city": "Spokane",
    "zip": 99216,
    "concatenated_address": "1112 N Mamer Rd, Spokane",
    "address": "1112 N. Mamer Road, Spokane"
  },
  {
    "id": 1569,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Holman Gardens",
    "latitude": 47.645745,
    "longitude": -117.23081,
    "original_address": "12912 East 12th Avenue",
    "building_number": 12912,
    "street": "E 12th Ave",
    "city": "Spokane",
    "zip": 99216,
    "concatenated_address": "12912 E 12th Ave, Spokane",
    "address": "12912 E. 12th Ave., Spokane"
  },
  {
    "id": 1570,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Pines Senior Apartments",
    "latitude": 47.629296,
    "longitude": -117.25466,
    "original_address": "512 North Lines Road",
    "building_number": "",
    "street": "",
    "city": "Spokane Valley",
    "zip": 99206,
    "concatenated_address": "512 North Lines Road, Spokane Valley",
    "address": "512 North Lines Road, Spokane Valley"
  },
  {
    "id": 1571,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Evergreen Fountains",
    "latitude": 47.66822,
    "longitude": -117.21996,
    "original_address": "1201 North Evergreen Road",
    "building_number": 1201,
    "street": "N Evergreen Rd",
    "city": "Spokane",
    "zip": 99216,
    "concatenated_address": "1201 N Evergreen Rd, Spokane",
    "address": "1201 N. Evergreen Road, Spokane"
  },
  {
    "id": 1572,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Creekside Apartment Homes",
    "latitude": 48.233143,
    "longitude": -122.3294,
    "original_address": "26031 72nd Avenue Nw",
    "building_number": 26031,
    "street": "72nd Ave NW",
    "city": "Stanwood",
    "zip": 98292,
    "concatenated_address": "26031 72nd Ave NW, Stanwood",
    "address": "26031 72nd Ave. N.W., Stanwood"
  },
  {
    "id": 1573,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Maple Court Apartments",
    "latitude": 48.233143,
    "longitude": -122.3294,
    "original_address": "26031 72nd Avenue Nw",
    "building_number": 26031,
    "street": "72nd Ave NW",
    "city": "Stanwood",
    "zip": 98292,
    "concatenated_address": "26031 72nd Ave NW, Stanwood",
    "address": "26031 72nd Ave. N.W., Stanwood"
  },
  {
    "id": 1574,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Brookdale Stanwood",
    "latitude": 48.236493,
    "longitude": -122.33217,
    "original_address": "7212 265th Street Northeast",
    "building_number": 7212,
    "street": "265th St",
    "city": "Stanwood",
    "zip": 98292,
    "concatenated_address": "7212 265th St, Stanwood",
    "address": "7212 265th St., Stanwood"
  },
  {
    "id": 1575,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Harbor Oaks",
    "latitude": 47.177429,
    "longitude": -122.57779,
    "original_address": "97 Byrd Drive",
    "building_number": 97,
    "street": "Byrd Dr",
    "city": "Steilacoom",
    "zip": 98388,
    "concatenated_address": "97 Byrd Dr, Steilacoom",
    "address": "97 Byrd Drive, Steilacoom"
  },
  {
    "id": 1576,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "3000-3012 Steilacoom Boulevard",
    "latitude": 47.176551,
    "longitude": -122.57667,
    "original_address": "3000-3012 Steilacoom Boulevard",
    "building_number": 3012,
    "street": "Steilacoom Blvd",
    "city": "Steilacoom",
    "zip": 98388,
    "concatenated_address": "3012 Steilacoom Blvd, Steilacoom",
    "address": "3012 Steilacoom Blvd., Steilacoom"
  },
  {
    "id": 1577,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Sumner Square Apartments",
    "latitude": 47.210277,
    "longitude": -122.2276,
    "original_address": "15106 Elm Street East",
    "building_number": 15106,
    "street": "Elm St E",
    "city": "Sumner",
    "zip": 98390,
    "concatenated_address": "15106 Elm St E, Sumner",
    "address": "15106 Elm St. E., Sumner"
  },
  {
    "id": 1578,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Walnut Grove Townhomes",
    "latitude": 47.209445,
    "longitude": -122.22732,
    "original_address": "15209 And 15213 Elm Street E.",
    "building_number": "",
    "street": "",
    "city": "Sumner",
    "zip": 98390,
    "concatenated_address": "15209 And 15213 Elm Street E., Sumner",
    "address": "15209 And 15213 Elm St. E., Sumner"
  },
  {
    "id": 1579,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Washington Court",
    "latitude": 47.205199,
    "longitude": -122.22462,
    "original_address": "15318 Washington Street East",
    "building_number": 15318,
    "street": "Washington St",
    "city": "Sumner",
    "zip": 98390,
    "concatenated_address": "15318 Washington St, Sumner",
    "address": "15318 Washington St., Sumner"
  },
  {
    "id": 1580,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Franklin Place",
    "latitude": 47.204611,
    "longitude": -122.22073,
    "original_address": "5713 Parker Road",
    "building_number": 5713,
    "street": "Parker Rd E",
    "city": "Sumner",
    "zip": 98390,
    "concatenated_address": "5713 Parker Rd E, Sumner",
    "address": "5713 Parker Road E., Sumner"
  },
  {
    "id": 1581,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "The Retreat Apartments",
    "latitude": 47.189954,
    "longitude": -122.2385,
    "original_address": "7413 142nd Avenue E",
    "building_number": 7413,
    "street": "142nd Ave E",
    "city": "Sumner",
    "zip": 98390,
    "concatenated_address": "7413 142nd Ave E, Sumner",
    "address": "7413 142nd Ave. E., Sumner"
  },
  {
    "id": 1582,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Aster Townhomes",
    "latitude": 47.198484,
    "longitude": -122.21365,
    "original_address": "16120 64th Street East",
    "building_number": 16120,
    "street": "64th St E",
    "city": "Sumner",
    "zip": 98390,
    "concatenated_address": "16120 64th St E, Sumner",
    "address": "16120 64th St. E., Sumner"
  },
  {
    "id": 1583,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Washington Court Flats",
    "latitude": 47.209445,
    "longitude": -122.22732,
    "original_address": "5816 To 5822 Graham Avenue East",
    "building_number": "",
    "street": "",
    "city": "Sumner",
    "zip": 98390,
    "concatenated_address": "5816 To 5822 Graham Avenue East, Sumner",
    "address": "5816 To 5822 Graham Avenue East, Sumner"
  },
  {
    "id": 1584,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Cavalla Apartment Homes",
    "latitude": 47.197727,
    "longitude": -122.21601,
    "original_address": "16026 65th Street Court E",
    "building_number": 16026,
    "street": "65th Street Ct E",
    "city": "Sumner",
    "zip": 98390,
    "concatenated_address": "16026 65th Street Ct E, Sumner",
    "address": "16026 65th St. Ct E., Sumner"
  },
  {
    "id": 1585,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "The Alexander",
    "latitude": 47.199227,
    "longitude": -122.24037,
    "original_address": "1103 Thompson Street",
    "building_number": 1103,
    "street": "Thompson St",
    "city": "Sumner",
    "zip": 98390,
    "concatenated_address": "1103 Thompson St, Sumner",
    "address": "1103 Thompson St., Sumner"
  },
  {
    "id": 1586,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Aria Apartments",
    "latitude": 47.199517,
    "longitude": -122.21791,
    "original_address": "15817 64th Street East",
    "building_number": 15817,
    "street": "64th St E",
    "city": "Sumner",
    "zip": 98390,
    "concatenated_address": "15817 64th St E, Sumner",
    "address": "15817 64th St. E., Sumner"
  },
  {
    "id": 1587,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Stafford Suites At Sumner",
    "latitude": 47.201239,
    "longitude": -122.22259,
    "original_address": "15519 62nd Street Court E",
    "building_number": 15519,
    "street": "62nd St Ct E",
    "city": "Sumner",
    "zip": 98390,
    "concatenated_address": "15519 62nd St Ct E, Sumner",
    "address": "15519 62nd St. Ct E., Sumner"
  },
  {
    "id": 1588,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Memory Haven Sumner",
    "latitude": 47.209892,
    "longitude": -122.22115,
    "original_address": "5107 Parker Road East",
    "building_number": 5107,
    "street": "Parker Rd E",
    "city": "Sumner",
    "zip": 98390,
    "concatenated_address": "5107 Parker Rd E, Sumner",
    "address": "5107 Parker Road E., Sumner"
  },
  {
    "id": 1589,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Parkhurst Apartments",
    "latitude": 47.249397,
    "longitude": -122.50596,
    "original_address": "5202 South 12th Street",
    "building_number": 5202,
    "street": "S 12th St",
    "city": "Tacoma",
    "zip": 98465,
    "concatenated_address": "5202 S 12th St, Tacoma",
    "address": "5202 S. 12th St., Tacoma"
  },
  {
    "id": 1590,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Lakeshore Apartments",
    "latitude": 47.169976,
    "longitude": -122.45917,
    "original_address": "9615 18th Avenue South",
    "building_number": 9615,
    "street": "18th Ave S",
    "city": "Tacoma",
    "zip": 98444,
    "concatenated_address": "9615 18th Ave S, Tacoma",
    "address": "9615 18th Ave. S., Tacoma"
  },
  {
    "id": 1591,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Narrows Pointe Apartments",
    "latitude": 47.271663,
    "longitude": -122.52487,
    "original_address": "2545 N. Narrows Drive",
    "building_number": 2545,
    "street": "N Narrows Dr",
    "city": "Tacoma",
    "zip": 98406,
    "concatenated_address": "2545 N Narrows Dr, Tacoma",
    "address": "2545 N. Narrows Drive, Tacoma"
  },
  {
    "id": 1592,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Westmall Terrace",
    "latitude": 47.214275,
    "longitude": -122.47476,
    "original_address": "4720 S. Pine Street 3030 S. 47th St.3102-3110 S. 47th Street 4710-4722 S. Cedar St.",
    "building_number": 4720,
    "street": "S Pine St",
    "city": "Tacoma",
    "zip": 98409,
    "concatenated_address": "4720 S Pine St, Tacoma",
    "address": "4720 S. Pine St., Tacoma"
  },
  {
    "id": 1593,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Olympic View Apartments",
    "latitude": 47.277687,
    "longitude": -122.51446,
    "original_address": "5716 North 33rd Street",
    "building_number": 5716,
    "street": "N 33rd St",
    "city": "Tacoma",
    "zip": 98407,
    "concatenated_address": "5716 N 33rd St, Tacoma",
    "address": "5716 N. 33rd St., Tacoma"
  },
  {
    "id": 1594,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "408 And 420 North M Street Apartments",
    "latitude": 47.265371,
    "longitude": -122.45709,
    "original_address": "408 And 420 North M Street",
    "building_number": "",
    "street": "",
    "city": "Tacoma",
    "zip": 98403,
    "concatenated_address": "408 And 420 North M Street, Tacoma",
    "address": "408 And 420 North M St., Tacoma"
  },
  {
    "id": 1595,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Westview Terrace Apartments",
    "latitude": 47.190591,
    "longitude": -122.46601,
    "original_address": "2201 South 74th Street",
    "building_number": 2201,
    "street": "S 74th St",
    "city": "Tacoma",
    "zip": 98409,
    "concatenated_address": "2201 S 74th St, Tacoma",
    "address": "2201 S. 74th St., Tacoma"
  },
  {
    "id": 1596,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Fairmont Park Apartments",
    "latitude": 47.190385,
    "longitude": -122.41254,
    "original_address": "1204 73rd Street East",
    "building_number": 1204,
    "street": "73rd St E",
    "city": "Tacoma",
    "zip": 98404,
    "concatenated_address": "1204 73rd St E, Tacoma",
    "address": "1204 73rd St. E., Tacoma"
  },
  {
    "id": 1597,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Lanes Landing Apartments",
    "latitude": 47.27817,
    "longitude": -122.51538,
    "original_address": "5821 N. 33rd Street",
    "building_number": 5821,
    "street": "N 33rd St",
    "city": "Tacoma",
    "zip": 98407,
    "concatenated_address": "5821 N 33rd St, Tacoma",
    "address": "5821 N. 33rd St., Tacoma"
  },
  {
    "id": 1598,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "1013 South Pearl Street Apartments",
    "latitude": 47.251133,
    "longitude": -122.51541,
    "original_address": "1013-1016 South Pearl Street",
    "building_number": 1013,
    "street": "S Pearl St",
    "city": "Tacoma",
    "zip": 98465,
    "concatenated_address": "1013 S Pearl St, Tacoma",
    "address": "1013 S. Pearl St., Tacoma"
  },
  {
    "id": 1599,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "417 North L Street",
    "latitude": 47.260995,
    "longitude": -122.45723,
    "original_address": "417 N. L Street",
    "building_number": 417,
    "street": "N L St",
    "city": "Tacoma",
    "zip": 98403,
    "concatenated_address": "417 N L St, Tacoma",
    "address": "417 N. L St., Tacoma"
  },
  {
    "id": 1600,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Market Street Apartments",
    "latitude": 47.250479,
    "longitude": -122.44129,
    "original_address": "1314 Market Street",
    "building_number": 1314,
    "street": "Market St",
    "city": "Tacoma",
    "zip": 98402,
    "concatenated_address": "1314 Market St, Tacoma",
    "address": "1314 Market St., Tacoma"
  },
  {
    "id": 1601,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Apex Apartments",
    "latitude": 47.210957,
    "longitude": -122.48158,
    "original_address": "2424-B And 2424-A South 41st Street",
    "building_number": "",
    "street": "",
    "city": "Tacoma",
    "zip": 98409,
    "concatenated_address": "2424-B And 2424-A South 41st Street, Tacoma",
    "address": "2424-B And 2424-A South 41st St., Tacoma"
  },
  {
    "id": 1602,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Bella Vista Apartments",
    "latitude": 47.227937,
    "longitude": -122.4956,
    "original_address": "3502 South Mason Avenue",
    "building_number": 3502,
    "street": "S Mason Ave",
    "city": "Tacoma",
    "zip": 98409,
    "concatenated_address": "3502 S Mason Ave, Tacoma",
    "address": "3502 S. Mason Ave., Tacoma"
  },
  {
    "id": 1603,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Solstice Senior Living At Tacoma",
    "latitude": 47.2993,
    "longitude": -122.52365,
    "original_address": "6414 N. Park Way",
    "building_number": 6414,
    "street": "N Park Way",
    "city": "Tacoma",
    "zip": 98407,
    "concatenated_address": "6414 N Park Way, Tacoma",
    "address": "6414 N. Park Way, Tacoma"
  },
  {
    "id": 1604,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Cherry Creek",
    "latitude": 47.170767,
    "longitude": -122.4665,
    "original_address": "2325 South 96th Street",
    "building_number": 2325,
    "street": "S 96th St",
    "city": "Tacoma",
    "zip": 98444,
    "concatenated_address": "2325 S 96th St, Tacoma",
    "address": "2325 S. 96th St., Tacoma"
  },
  {
    "id": 1605,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Gibson Gardens Apartments",
    "latitude": 47.211583,
    "longitude": -122.43318,
    "original_address": "5001 Pacific Avenue",
    "building_number": 5001,
    "street": "Pacific Ave",
    "city": "Tacoma",
    "zip": 98408,
    "concatenated_address": "5001 Pacific Ave, Tacoma",
    "address": "5001 Pacific Ave., Tacoma"
  },
  {
    "id": 1606,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Notch8 Apartments",
    "latitude": 47.173059,
    "longitude": -122.46357,
    "original_address": "9210 South Hosmer Street",
    "building_number": 9210,
    "street": "S Hosmer St",
    "city": "Tacoma",
    "zip": 98444,
    "concatenated_address": "9210 S Hosmer St, Tacoma",
    "address": "9210 S. Hosmer St., Tacoma"
  },
  {
    "id": 1607,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Demark Apartments",
    "latitude": 47.18953,
    "longitude": -122.40626,
    "original_address": "1707 74th Street Court East",
    "building_number": 1707,
    "street": "74th St Ct E",
    "city": "Tacoma",
    "zip": 98404,
    "concatenated_address": "1707 74th St Ct E, Tacoma",
    "address": "1707 74th St. Ct E., Tacoma"
  },
  {
    "id": 1608,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Sienna Apartments",
    "latitude": 47.161114,
    "longitude": -122.45562,
    "original_address": "10614 Ainsworth Avenue S.",
    "building_number": 10614,
    "street": "Ainsworth Ave S",
    "city": "Tacoma",
    "zip": 98444,
    "concatenated_address": "10614 Ainsworth Ave S, Tacoma",
    "address": "10614 Ainsworth Ave. S., Tacoma"
  },
  {
    "id": 1609,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Aravia Apartments",
    "latitude": 47.129451,
    "longitude": -122.39855,
    "original_address": "2300 Brookdale Road East",
    "building_number": 2300,
    "street": "Brookdale Rd E",
    "city": "Tacoma",
    "zip": 98445,
    "concatenated_address": "2300 Brookdale Rd E, Tacoma",
    "address": "2300 Brookdale Road E., Tacoma"
  },
  {
    "id": 1610,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "The Meadows",
    "latitude": 47.156692,
    "longitude": -122.40248,
    "original_address": "11012 Portland Avenue E",
    "building_number": 11012,
    "street": "Portland Ave E",
    "city": "Tacoma",
    "zip": 98445,
    "concatenated_address": "11012 Portland Ave E, Tacoma",
    "address": "11012 Portland Ave. E., Tacoma"
  },
  {
    "id": 1611,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Century Apartments",
    "latitude": 47.287606,
    "longitude": -122.50049,
    "original_address": "5105 And 5115 Grand Loop",
    "building_number": "",
    "street": "",
    "city": "Tacoma",
    "zip": 98407,
    "concatenated_address": "5105 And 5115 Grand Loop, Tacoma",
    "address": "5105 And 5115 Grand Loop, Tacoma"
  },
  {
    "id": 1612,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Aero Apartments",
    "latitude": 47.172119,
    "longitude": -122.46218,
    "original_address": "9314 South Ash Street",
    "building_number": 9314,
    "street": "S Ash St",
    "city": "Tacoma",
    "zip": 98444,
    "concatenated_address": "9314 S Ash St, Tacoma",
    "address": "9314 S. Ash St., Tacoma"
  },
  {
    "id": 1613,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Forest Hill Village Apartments",
    "latitude": 47.219714,
    "longitude": -122.49644,
    "original_address": "4332 South 41st Street",
    "building_number": 4332,
    "street": "S 41st St",
    "city": "Tacoma",
    "zip": 98409,
    "concatenated_address": "4332 S 41st St, Tacoma",
    "address": "4332 S. 41st St., Tacoma"
  },
  {
    "id": 1614,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Proctor Station Apartments",
    "latitude": 47.272846,
    "longitude": -122.48939,
    "original_address": "3910 N 28th Street",
    "building_number": 3910,
    "street": "N 28th St",
    "city": "Tacoma",
    "zip": 98407,
    "concatenated_address": "3910 N 28th St, Tacoma",
    "address": "3910 N. 28th St., Tacoma"
  },
  {
    "id": 1615,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Altitude 104 Apartments",
    "latitude": 47.163335,
    "longitude": -122.46642,
    "original_address": "2201 104th Street South",
    "building_number": 2201,
    "street": "104th St S",
    "city": "Tacoma",
    "zip": 98444,
    "concatenated_address": "2201 104th St S, Tacoma",
    "address": "2201 104th St. S., Tacoma"
  },
  {
    "id": 1616,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Copperline Apartments",
    "latitude": 47.29712,
    "longitude": -122.50389,
    "original_address": "5005 North Ruston Way",
    "building_number": 5005,
    "street": "Ruston Way",
    "city": "Tacoma",
    "zip": 98407,
    "concatenated_address": "5005 Ruston Way, Tacoma",
    "address": "5005 Ruston Way, Tacoma"
  },
  {
    "id": 1617,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Miramar Apartments",
    "latitude": 47.2551,
    "longitude": -122.53527,
    "original_address": "7320 6th Avenue",
    "building_number": 7320,
    "street": "6th Ave",
    "city": "Tacoma",
    "zip": 98406,
    "concatenated_address": "7320 6th Ave, Tacoma",
    "address": "7320 6th Ave., Tacoma"
  },
  {
    "id": 1618,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Bryn Mawr Village",
    "latitude": 47.206871,
    "longitude": -122.44853,
    "original_address": "1711-1729 & 1801-1823 South 82nd Street",
    "building_number": "",
    "street": "",
    "city": "Tacoma",
    "zip": 98408,
    "concatenated_address": "1711-1729 & 1801-1823 South 82nd Street, Tacoma",
    "address": "1711-1729 & 1801-1823 South 82nd St., Tacoma"
  },
  {
    "id": 1619,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "The Miller Apartments",
    "latitude": 47.26153,
    "longitude": -122.44673,
    "original_address": "202-212 Tacoma Avenue South",
    "building_number": 212,
    "street": "Tacoma Ave S",
    "city": "Tacoma",
    "zip": 98402,
    "concatenated_address": "212 Tacoma Ave S, Tacoma",
    "address": "212 Tacoma Ave. S., Tacoma"
  },
  {
    "id": 1620,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "The Henry",
    "latitude": 47.244092,
    "longitude": -122.43371,
    "original_address": "1933 Dock Street",
    "building_number": 1933,
    "street": "Dock St",
    "city": "Tacoma",
    "zip": 98402,
    "concatenated_address": "1933 Dock St, Tacoma",
    "address": "1933 Dock St., Tacoma"
  },
  {
    "id": 1621,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Northpoint Apartments",
    "latitude": 47.28206,
    "longitude": -122.5131,
    "original_address": "5601 N 37th Street And 3815 N Pearl Street",
    "building_number": 5601,
    "street": "N 37th St",
    "city": "Tacoma",
    "zip": 98407,
    "concatenated_address": "5601 N 37th St, Tacoma",
    "address": "5601 N. 37th St., Tacoma"
  },
  {
    "id": 1622,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "The Grand On Broadway",
    "latitude": 47.26096,
    "longitude": -122.44364,
    "original_address": "252 Broadway",
    "building_number": 252,
    "street": "Broadway",
    "city": "Tacoma",
    "zip": 98402,
    "concatenated_address": "252 Broadway, Tacoma",
    "address": "252 Broadway, Tacoma"
  },
  {
    "id": 1623,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Brookdale Greens MHC",
    "latitude": 47.132049,
    "longitude": -122.40272,
    "original_address": "13702 20th Ave E",
    "building_number": 13702,
    "street": "20th Ave E",
    "city": "Tacoma",
    "zip": 98445,
    "concatenated_address": "13702 20th Ave E, Tacoma",
    "address": "13702 20th Ave. E., Tacoma"
  },
  {
    "id": 1624,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Norpoint Village",
    "latitude": 47.302722,
    "longitude": -122.40718,
    "original_address": "4301 Norpoint Way Ne",
    "building_number": 4301,
    "street": "Norpoint Way NE",
    "city": "Tacoma",
    "zip": 98422,
    "concatenated_address": "4301 Norpoint Way NE, Tacoma",
    "address": "4301 Norpoint Way N.E., Tacoma"
  },
  {
    "id": 1625,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Terra Heights Apartments (formerly known as Cherry Creek)",
    "latitude": 47.170767,
    "longitude": -122.4665,
    "original_address": "2325 South 96th Street",
    "building_number": 2325,
    "street": "S 96th St",
    "city": "Tacoma",
    "zip": 98444,
    "concatenated_address": "2325 S 96th St, Tacoma",
    "address": "2325 S. 96th St., Tacoma"
  },
  {
    "id": 1626,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "iStudios Apartments",
    "latitude": 47.221342,
    "longitude": -122.47466,
    "original_address": "3825 South Junett Street",
    "building_number": 3825,
    "street": "S Junett St",
    "city": "Tacoma",
    "zip": 98409,
    "concatenated_address": "3825 S Junett St, Tacoma",
    "address": "3825 S. Junett St., Tacoma"
  },
  {
    "id": 1627,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Heatherstone Apartments",
    "latitude": 47.161791,
    "longitude": -122.46138,
    "original_address": "1809 105th Street Court South",
    "building_number": 1809,
    "street": "105th St Ct S",
    "city": "Tacoma",
    "zip": 98444,
    "concatenated_address": "1809 105th St Ct S, Tacoma",
    "address": "1809 105th St. Ct S., Tacoma"
  },
  {
    "id": 1628,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Monterra Apartments",
    "latitude": 47.155634,
    "longitude": -122.42577,
    "original_address": "416 111th Street Court East",
    "building_number": 416,
    "street": "111th St Ct E",
    "city": "Tacoma",
    "zip": 98445,
    "concatenated_address": "416 111th St Ct E, Tacoma",
    "address": "416 111th St. Ct E., Tacoma"
  },
  {
    "id": 1629,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "The Lodge At Miramonte Apartments",
    "latitude": 47.154788,
    "longitude": -122.4612,
    "original_address": "11216 18th Avenue South",
    "building_number": 11216,
    "street": "18th Ave S",
    "city": "Tacoma",
    "zip": 98444,
    "concatenated_address": "11216 18th Ave S, Tacoma",
    "address": "11216 18th Ave. S., Tacoma"
  },
  {
    "id": 1630,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Sunrise Ridge Apartments",
    "latitude": 47.233353,
    "longitude": -122.48762,
    "original_address": "3852 South 29th Street",
    "building_number": 3852,
    "street": "S 29th St",
    "city": "Tacoma",
    "zip": 98409,
    "concatenated_address": "3852 S 29th St, Tacoma",
    "address": "3852 S. 29th St., Tacoma"
  },
  {
    "id": 1631,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "The Lodge At Madrona Apartment Homes",
    "latitude": 47.22936,
    "longitude": -122.49533,
    "original_address": "3202 South Mason Avenue",
    "building_number": 3202,
    "street": "S Mason Ave",
    "city": "Tacoma",
    "zip": 98409,
    "concatenated_address": "3202 S Mason Ave, Tacoma",
    "address": "3202 S. Mason Ave., Tacoma"
  },
  {
    "id": 1632,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Verandas Apartments",
    "latitude": 47.226661,
    "longitude": -122.50462,
    "original_address": "3509 South Orchard Street",
    "building_number": 3509,
    "street": "S Orchard St",
    "city": "Tacoma",
    "zip": 98466,
    "concatenated_address": "3509 S Orchard St, Tacoma",
    "address": "3509 S. Orchard St., Tacoma"
  },
  {
    "id": 1633,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Sienna Park Apartments",
    "latitude": 47.159847,
    "longitude": -122.45829,
    "original_address": "10710 17th Avenue South",
    "building_number": 10710,
    "street": "17th Ave S",
    "city": "Tacoma",
    "zip": 98444,
    "concatenated_address": "10710 17th Ave S, Tacoma",
    "address": "10710 17th Ave. S., Tacoma"
  },
  {
    "id": 1634,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Mark Twain Apartments",
    "latitude": 47.25445,
    "longitude": -122.51793,
    "original_address": "5930 6th Avenue",
    "building_number": 5930,
    "street": "6th Ave",
    "city": "Tacoma",
    "zip": 98406,
    "concatenated_address": "5930 6th Ave, Tacoma",
    "address": "5930 6th Ave., Tacoma"
  },
  {
    "id": 1635,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Christine Apartments",
    "latitude": 47.237233,
    "longitude": -122.44498,
    "original_address": "2503 South I Street",
    "building_number": 2503,
    "street": "S I St",
    "city": "Tacoma",
    "zip": 98405,
    "concatenated_address": "2503 S I St, Tacoma",
    "address": "2503 S. I St., Tacoma"
  },
  {
    "id": 1636,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Coventry Court IV Apartments",
    "latitude": 47.1874,
    "longitude": -122.41828,
    "original_address": "908 76th Street East",
    "building_number": 908,
    "street": "76th St E",
    "city": "Tacoma",
    "zip": 98404,
    "concatenated_address": "908 76th St E, Tacoma",
    "address": "908 76th St. E., Tacoma"
  },
  {
    "id": 1637,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Coventry Court IV Annex",
    "latitude": 47.209131,
    "longitude": -122.39793,
    "original_address": "7412 & 7416 Golden Given Road E",
    "building_number": "",
    "street": "",
    "city": "Tacoma",
    "zip": 98404,
    "concatenated_address": "7412 & 7416 Golden Given Road E, Tacoma",
    "address": "7412 & 7416 Golden Given Road E., Tacoma"
  },
  {
    "id": 1638,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Orchard Terrace Apartments",
    "latitude": 47.224595,
    "longitude": -122.50462,
    "original_address": "3701 South Orchard St",
    "building_number": 3701,
    "street": "S Orchard St",
    "city": "Tacoma",
    "zip": 98466,
    "concatenated_address": "3701 S Orchard St, Tacoma",
    "address": "3701 S. Orchard St., Tacoma"
  },
  {
    "id": 1639,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Madison25",
    "latitude": 47.270404,
    "longitude": -122.48961,
    "original_address": "3911 N. 25th Street",
    "building_number": 3911,
    "street": "N 25th St",
    "city": "Tacoma",
    "zip": 98406,
    "concatenated_address": "3911 N 25th St, Tacoma",
    "address": "3911 N. 25th St., Tacoma"
  },
  {
    "id": 1640,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Orion",
    "latitude": 47.263361,
    "longitude": -122.44628,
    "original_address": "29 Street Helens Avenue",
    "building_number": 29,
    "street": "St Helens Ave",
    "city": "Tacoma",
    "zip": 98402,
    "concatenated_address": "29 St Helens Ave, Tacoma",
    "address": "29 St. Helens Ave., Tacoma"
  },
  {
    "id": 1641,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Stratford Heights Apartments",
    "latitude": 47.236768,
    "longitude": -122.53326,
    "original_address": "2602-2618 Cascade Pl W",
    "building_number": 2602,
    "street": "Cascade Pl W",
    "city": "Tacoma",
    "zip": 98466,
    "concatenated_address": "2602 Cascade Pl W, Tacoma",
    "address": "2602 Cascade Pl W., Tacoma"
  },
  {
    "id": 1642,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Sawyer Trail Apartments Phase II",
    "latitude": 47.098573,
    "longitude": -122.37456,
    "original_address": "17404 44th Avenue East",
    "building_number": 17404,
    "street": "44th Ave E",
    "city": "Tacoma",
    "zip": 98446,
    "concatenated_address": "17404 44th Ave E, Tacoma",
    "address": "17404 44th Ave. E., Tacoma"
  },
  {
    "id": 1643,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Fairlane Terrace Mobile Home Park",
    "latitude": 47.161179,
    "longitude": -122.46135,
    "original_address": "10606 18th Ave S",
    "building_number": 10606,
    "street": "18th Ave S",
    "city": "Tacoma",
    "zip": 98444,
    "concatenated_address": "10606 18th Ave S, Tacoma",
    "address": "10606 18th Ave. S., Tacoma"
  },
  {
    "id": 1644,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Alta Apartments",
    "latitude": 47.168585,
    "longitude": -122.46661,
    "original_address": "2220 97th Street South",
    "building_number": 2220,
    "street": "97th St S",
    "city": "Tacoma",
    "zip": 98444,
    "concatenated_address": "2220 97th St S, Tacoma",
    "address": "2220 97th St. S., Tacoma"
  },
  {
    "id": 1645,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "The Metropolitan",
    "latitude": 47.260645,
    "longitude": -122.44444,
    "original_address": "245 Street Helens Avenue",
    "building_number": 245,
    "street": "St Helens Ave",
    "city": "Tacoma",
    "zip": 98402,
    "concatenated_address": "245 St Helens Ave, Tacoma",
    "address": "245 St. Helens Ave., Tacoma"
  },
  {
    "id": 1646,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Woodmark Apartments",
    "latitude": 47.171357,
    "longitude": -122.46886,
    "original_address": "2425 96th Street S.",
    "building_number": 2425,
    "street": "96th St S",
    "city": "Tacoma",
    "zip": 98444,
    "concatenated_address": "2425 96th St S, Tacoma",
    "address": "2425 96th St. S., Tacoma"
  },
  {
    "id": 1647,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "The Summit",
    "latitude": 47.156167,
    "longitude": -122.38923,
    "original_address": "11016 Waller Road East",
    "building_number": 11016,
    "street": "Waller Rd E",
    "city": "Tacoma",
    "zip": 98446,
    "concatenated_address": "11016 Waller Rd E, Tacoma",
    "address": "11016 Waller Road E., Tacoma"
  },
  {
    "id": 1648,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Westminster Towers Apartments",
    "latitude": 47.15755,
    "longitude": -122.43826,
    "original_address": "10925 Park Avenue South",
    "building_number": 10925,
    "street": "Park Ave S",
    "city": "Tacoma",
    "zip": 98444,
    "concatenated_address": "10925 Park Ave S, Tacoma",
    "address": "10925 Park Ave. S., Tacoma"
  },
  {
    "id": 1649,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Avery On Pearl",
    "latitude": 47.261408,
    "longitude": -122.51747,
    "original_address": "1202 North Pearl Street",
    "building_number": 1202,
    "street": "N Pearl St",
    "city": "Tacoma",
    "zip": 98406,
    "concatenated_address": "1202 N Pearl St, Tacoma",
    "address": "1202 N. Pearl St., Tacoma"
  },
  {
    "id": 1650,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Tacoma Apartments",
    "latitude": 47.161737,
    "longitude": -122.46485,
    "original_address": "2017 106th Street South",
    "building_number": 2017,
    "street": "106th St S",
    "city": "Tacoma",
    "zip": 98444,
    "concatenated_address": "2017 106th St S, Tacoma",
    "address": "2017 106th St. S., Tacoma"
  },
  {
    "id": 1651,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Pearl Plaza Apartments",
    "latitude": 47.263825,
    "longitude": -122.51538,
    "original_address": "1425 N Pearl Street",
    "building_number": 1425,
    "street": "N Pearl St",
    "city": "Tacoma",
    "zip": 98406,
    "concatenated_address": "1425 N Pearl St, Tacoma",
    "address": "1425 N. Pearl St., Tacoma"
  },
  {
    "id": 1652,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Norpoint Ridge Apartments",
    "latitude": 47.28152,
    "longitude": -122.36763,
    "original_address": "168 Norpoint Way Ne",
    "building_number": 168,
    "street": "Norpoint Way NE",
    "city": "Tacoma",
    "zip": 98422,
    "concatenated_address": "168 Norpoint Way NE, Tacoma",
    "address": "168 Norpoint Way N.E., Tacoma"
  },
  {
    "id": 1653,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "The Westridges Apartments",
    "latitude": 47.236904,
    "longitude": -122.5561,
    "original_address": "2602 Westridge Avenue West",
    "building_number": 2602,
    "street": "Westridge Ave W",
    "city": "Tacoma",
    "zip": 98466,
    "concatenated_address": "2602 Westridge Ave W, Tacoma",
    "address": "2602 Westridge Ave. W., Tacoma"
  },
  {
    "id": 1654,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Weatherly Inn",
    "latitude": 47.259216,
    "longitude": -122.50924,
    "original_address": "Weatherly Inn",
    "building_number": "",
    "street": "",
    "city": "Tacoma",
    "zip": 98406,
    "concatenated_address": "Weatherly Inn, Tacoma",
    "address": "Weatherly Inn, Tacoma"
  },
  {
    "id": 1655,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Vue 25",
    "latitude": 47.239898,
    "longitude": -122.44475,
    "original_address": "2368 South Yakima Avenue",
    "building_number": 2368,
    "street": "S Yakima Ave",
    "city": "Tacoma",
    "zip": 98405,
    "concatenated_address": "2368 S Yakima Ave, Tacoma",
    "address": "2368 S. Yakima Ave., Tacoma"
  },
  {
    "id": 1656,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Boulders At Puget Sound",
    "latitude": 47.236904,
    "longitude": -122.5561,
    "original_address": "2602 Westridge Avenue West",
    "building_number": 2602,
    "street": "Westridge Ave W",
    "city": "Tacoma",
    "zip": 98466,
    "concatenated_address": "2602 Westridge Ave W, Tacoma",
    "address": "2602 Westridge Ave. W., Tacoma"
  },
  {
    "id": 1657,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Boulders At Puget Sound (Third Lien)",
    "latitude": 47.236904,
    "longitude": -122.5561,
    "original_address": "2602 Westridge Avenue West",
    "building_number": 2602,
    "street": "Westridge Ave W",
    "city": "Tacoma",
    "zip": 98466,
    "concatenated_address": "2602 Westridge Ave W, Tacoma",
    "address": "2602 Westridge Ave. W., Tacoma"
  },
  {
    "id": 1658,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Lakeside Landing",
    "latitude": 47.248689,
    "longitude": -122.52693,
    "original_address": "1414 South Mildred Street",
    "building_number": 1414,
    "street": "S Mildred St",
    "city": "Tacoma",
    "zip": 98465,
    "concatenated_address": "1414 S Mildred St, Tacoma",
    "address": "1414 S. Mildred St., Tacoma"
  },
  {
    "id": 1659,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Green Leaf Pacifica",
    "latitude": 47.217768,
    "longitude": -122.47275,
    "original_address": "4275 South Pine Street",
    "building_number": 4275,
    "street": "S Pine St",
    "city": "Tacoma",
    "zip": 98409,
    "concatenated_address": "4275 S Pine St, Tacoma",
    "address": "4275 S. Pine St., Tacoma"
  },
  {
    "id": 1660,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Boulders At Puget Sound (Fourth Lien)",
    "latitude": 47.236904,
    "longitude": -122.5561,
    "original_address": "2602 Westridge Avenue West",
    "building_number": 2602,
    "street": "Westridge Ave W",
    "city": "Tacoma",
    "zip": 98466,
    "concatenated_address": "2602 Westridge Ave W, Tacoma",
    "address": "2602 Westridge Ave. W., Tacoma"
  },
  {
    "id": 1661,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "The Stadium Apartments",
    "latitude": 47.263615,
    "longitude": -122.44983,
    "original_address": "102 North G Street",
    "building_number": 102,
    "street": "N G St",
    "city": "Tacoma",
    "zip": 98403,
    "concatenated_address": "102 N G St, Tacoma",
    "address": "102 N. G St., Tacoma"
  },
  {
    "id": 1662,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Park Tower Apartments",
    "latitude": 47.261182,
    "longitude": -122.44676,
    "original_address": "220 Tacoma Avenue South",
    "building_number": 220,
    "street": "Tacoma Ave S",
    "city": "Tacoma",
    "zip": 98402,
    "concatenated_address": "220 Tacoma Ave S, Tacoma",
    "address": "220 Tacoma Ave. S., Tacoma"
  },
  {
    "id": 1663,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Valley Vista Apartments",
    "latitude": 47.195215,
    "longitude": -122.46533,
    "original_address": "6830 Tacoma Mall Boulevard",
    "building_number": 6830,
    "street": "Tacoma Mall Blvd",
    "city": "Tacoma",
    "zip": 98409,
    "concatenated_address": "6830 Tacoma Mall Blvd, Tacoma",
    "address": "6830 Tacoma Mall Blvd., Tacoma"
  },
  {
    "id": 1664,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Lakeside Landing Apartments",
    "latitude": 47.248689,
    "longitude": -122.52693,
    "original_address": "1414 South Mildred St",
    "building_number": 1414,
    "street": "S Mildred St",
    "city": "Tacoma",
    "zip": 98465,
    "concatenated_address": "1414 S Mildred St, Tacoma",
    "address": "1414 S. Mildred St., Tacoma"
  },
  {
    "id": 1665,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Vue 25",
    "latitude": 47.238234,
    "longitude": -122.4444,
    "original_address": "2368 Yakima Avenue",
    "building_number": 2368,
    "street": "Yakima Ave",
    "city": "Tacoma",
    "zip": 98405,
    "concatenated_address": "2368 Yakima Ave, Tacoma",
    "address": "2368 Yakima Ave., Tacoma"
  },
  {
    "id": 1666,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Pacific Sunset",
    "latitude": 47.183771,
    "longitude": -122.43348,
    "original_address": "8015-8019 Pacific Avenue",
    "building_number": 8019,
    "street": "Pacific Ave",
    "city": "Tacoma",
    "zip": 98408,
    "concatenated_address": "8019 Pacific Ave, Tacoma",
    "address": "8019 Pacific Ave., Tacoma"
  },
  {
    "id": 1667,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Terrace Apartments",
    "latitude": 47.264162,
    "longitude": -122.52274,
    "original_address": "1321 North Highlands Parkway",
    "building_number": 1321,
    "street": "N Highlands Pkwy",
    "city": "Tacoma",
    "zip": 98406,
    "concatenated_address": "1321 N Highlands Pkwy, Tacoma",
    "address": "1321 N. Highlands Pkwy, Tacoma"
  },
  {
    "id": 1668,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Midtown 15",
    "latitude": 47.246974,
    "longitude": -122.46128,
    "original_address": "1801 South 15th Street",
    "building_number": 1801,
    "street": "S 15th St",
    "city": "Tacoma",
    "zip": 98405,
    "concatenated_address": "1801 S 15th St, Tacoma",
    "address": "1801 S. 15th St., Tacoma"
  },
  {
    "id": 1669,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Kingston Manor",
    "latitude": 47.264837,
    "longitude": -122.45368,
    "original_address": "402 North G Street",
    "building_number": 402,
    "street": "N G St",
    "city": "Tacoma",
    "zip": 98403,
    "concatenated_address": "402 N G St, Tacoma",
    "address": "402 N. G St., Tacoma"
  },
  {
    "id": 1670,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Harbor Place Townhomes",
    "latitude": 47.275487,
    "longitude": -122.46915,
    "original_address": "2406 North 31st Street",
    "building_number": 2406,
    "street": "N 31st St",
    "city": "Tacoma",
    "zip": 98401,
    "concatenated_address": "2406 N 31st St, Tacoma",
    "address": "2406 N. 31st St., Tacoma"
  },
  {
    "id": 1671,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "The Oliver Apartments",
    "latitude": 47.146711,
    "longitude": -122.43726,
    "original_address": "420 Wheeler Street South",
    "building_number": 420,
    "street": "Wheeler St S",
    "city": "Tacoma",
    "zip": 98444,
    "concatenated_address": "420 Wheeler St S, Tacoma",
    "address": "420 Wheeler St. S., Tacoma"
  },
  {
    "id": 1672,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "14515 A Street Apartments",
    "latitude": 47.124668,
    "longitude": -122.43175,
    "original_address": "14515 A Street Apartments",
    "building_number": 14515,
    "street": "A St S",
    "city": "Tacoma",
    "zip": 98444,
    "concatenated_address": "14515 A St S, Tacoma",
    "address": "14515 A St. S., Tacoma"
  },
  {
    "id": 1673,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "One Saint Helens Apartments",
    "latitude": 47.264152,
    "longitude": -122.44654,
    "original_address": "1 Saint Helens Avenue",
    "building_number": 1,
    "street": "St Helens Ave",
    "city": "Tacoma",
    "zip": 98402,
    "concatenated_address": "1 St Helens Ave, Tacoma",
    "address": "1 St. Helens Ave., Tacoma"
  },
  {
    "id": 1674,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Sheffield Apartments",
    "latitude": 47.266307,
    "longitude": -122.47176,
    "original_address": "1922 North Oakes Street",
    "building_number": 1922,
    "street": "N Oakes St",
    "city": "Tacoma",
    "zip": 98406,
    "concatenated_address": "1922 N Oakes St, Tacoma",
    "address": "1922 N. Oakes St., Tacoma"
  },
  {
    "id": 1675,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Junett Townhomes",
    "latitude": 47.210957,
    "longitude": -122.48158,
    "original_address": "3002 And 3008 South 45th Street",
    "building_number": "",
    "street": "",
    "city": "Tacoma",
    "zip": 98409,
    "concatenated_address": "3002 And 3008 South 45th Street, Tacoma",
    "address": "3002 And 3008 South 45th St., Tacoma"
  },
  {
    "id": 1676,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Webster Apartments",
    "latitude": 47.257717,
    "longitude": -122.44245,
    "original_address": "629 Street Helens Avenue",
    "building_number": 629,
    "street": "St Helens Ave",
    "city": "Tacoma",
    "zip": 98402,
    "concatenated_address": "629 St Helens Ave, Tacoma",
    "address": "629 St. Helens Ave., Tacoma"
  },
  {
    "id": 1677,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Pine Street Townhomes",
    "latitude": 47.217067,
    "longitude": -122.47423,
    "original_address": "2911 South 45th Street",
    "building_number": 2911,
    "street": "S 45th St",
    "city": "Tacoma",
    "zip": 98409,
    "concatenated_address": "2911 S 45th St, Tacoma",
    "address": "2911 S. 45th St., Tacoma"
  },
  {
    "id": 1678,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Heather Court Apartments",
    "latitude": 47.141595,
    "longitude": -122.43746,
    "original_address": "12720 C Street South",
    "building_number": 12720,
    "street": "C St S",
    "city": "Tacoma",
    "zip": 98444,
    "concatenated_address": "12720 C St S, Tacoma",
    "address": "12720 C St. S., Tacoma"
  },
  {
    "id": 1679,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "McIlvaine Apartments",
    "latitude": 47.254114,
    "longitude": -122.45041,
    "original_address": "920 South 9th Street",
    "building_number": 920,
    "street": "S 9th St",
    "city": "Tacoma",
    "zip": 98405,
    "concatenated_address": "920 S 9th St, Tacoma",
    "address": "920 S. 9th St., Tacoma"
  },
  {
    "id": 1680,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Pacific 5000",
    "latitude": 47.179904,
    "longitude": -122.43311,
    "original_address": "8425 Pacific Avenue",
    "building_number": 8425,
    "street": "Pacific Ave",
    "city": "Tacoma",
    "zip": 98444,
    "concatenated_address": "8425 Pacific Ave, Tacoma",
    "address": "8425 Pacific Ave., Tacoma"
  },
  {
    "id": 1681,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Colonial Village Apartments",
    "latitude": 47.174861,
    "longitude": -122.43423,
    "original_address": "9220 Pacific Avenue South",
    "building_number": 9220,
    "street": "Pacific Ave S",
    "city": "Tacoma",
    "zip": 98444,
    "concatenated_address": "9220 Pacific Ave S, Tacoma",
    "address": "9220 Pacific Ave. S., Tacoma"
  },
  {
    "id": 1682,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Westwood Square Apartments",
    "latitude": 47.176385,
    "longitude": -122.43439,
    "original_address": "8820 Pacific Avenue",
    "building_number": 8820,
    "street": "Pacific Ave",
    "city": "Tacoma",
    "zip": 98444,
    "concatenated_address": "8820 Pacific Ave, Tacoma",
    "address": "8820 Pacific Ave., Tacoma"
  },
  {
    "id": 1683,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Pearl Manor",
    "latitude": 47.263593,
    "longitude": -122.51534,
    "original_address": "1401-1409 North Pearl Street",
    "building_number": 1409,
    "street": "N Pearl St",
    "city": "Tacoma",
    "zip": 98406,
    "concatenated_address": "1409 N Pearl St, Tacoma",
    "address": "1409 N. Pearl St., Tacoma"
  },
  {
    "id": 1684,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Broadmoor Apartments",
    "latitude": 47.260331,
    "longitude": -122.4424,
    "original_address": "431 Broadway",
    "building_number": 431,
    "street": "Broadway",
    "city": "Tacoma",
    "zip": 98402,
    "concatenated_address": "431 Broadway, Tacoma",
    "address": "431 Broadway, Tacoma"
  },
  {
    "id": 1685,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Camden Terrace Apartments",
    "latitude": 47.287606,
    "longitude": -122.50049,
    "original_address": "6208 And 6212 North 26th Street",
    "building_number": "",
    "street": "",
    "city": "Tacoma",
    "zip": 98407,
    "concatenated_address": "6208 And 6212 North 26th Street, Tacoma",
    "address": "6208 And 6212 North 26th St., Tacoma"
  },
  {
    "id": 1686,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Tacoma Country Estates MHC",
    "latitude": 47.229171,
    "longitude": -122.38059,
    "original_address": "3116 36th Avenue East",
    "building_number": 3116,
    "street": "36th Ave E",
    "city": "Tacoma",
    "zip": 98443,
    "concatenated_address": "3116 36th Ave E, Tacoma",
    "address": "3116 36th Ave. E., Tacoma"
  },
  {
    "id": 1687,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Golden Hemlock",
    "latitude": 47.271918,
    "longitude": -122.51748,
    "original_address": "5939 North 26th Street",
    "building_number": 5939,
    "street": "N 26th St",
    "city": "Tacoma",
    "zip": 98407,
    "concatenated_address": "5939 N 26th St, Tacoma",
    "address": "5939 N. 26th St., Tacoma"
  },
  {
    "id": 1688,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Tahoma Terrace",
    "latitude": 47.236509,
    "longitude": -122.48267,
    "original_address": "2602 South Union Ave",
    "building_number": 2602,
    "street": "S Union Ave",
    "city": "Tacoma",
    "zip": 98405,
    "concatenated_address": "2602 S Union Ave, Tacoma",
    "address": "2602 S. Union Ave., Tacoma"
  },
  {
    "id": 1689,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "True Vine Senior Citizens Center",
    "latitude": 47.243205,
    "longitude": -122.49352,
    "original_address": "1819 South Mason Ave",
    "building_number": 1819,
    "street": "S Mason Ave",
    "city": "Tacoma",
    "zip": 98405,
    "concatenated_address": "1819 S Mason Ave, Tacoma",
    "address": "1819 S. Mason Ave., Tacoma"
  },
  {
    "id": 1690,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Thea's Landing Apts",
    "latitude": 47.247411,
    "longitude": -122.43462,
    "original_address": "1705 Dock St.",
    "building_number": 1705,
    "street": "Dock St",
    "city": "Tacoma",
    "zip": 98402,
    "concatenated_address": "1705 Dock St, Tacoma",
    "address": "1705 Dock St., Tacoma"
  },
  {
    "id": 1691,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Heartwood Extended Health Care",
    "latitude": 47.193192,
    "longitude": -122.40576,
    "original_address": "1649 East 72nd Street",
    "building_number": 1649,
    "street": "E 72nd St",
    "city": "Tacoma",
    "zip": 98104,
    "concatenated_address": "1649 E 72nd St, Tacoma",
    "address": "1649 E. 72nd St., Tacoma"
  },
  {
    "id": 1692,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Cascade Park Vista",
    "latitude": 47.260544,
    "longitude": -122.44517,
    "original_address": "242 Saint Helens Avenue",
    "building_number": 242,
    "street": "St Helens Ave",
    "city": "Tacoma",
    "zip": 98402,
    "concatenated_address": "242 St Helens Ave, Tacoma",
    "address": "242 St. Helens Ave., Tacoma"
  },
  {
    "id": 1693,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Cascade Park Gardens",
    "latitude": 47.216939,
    "longitude": -122.48303,
    "original_address": "4347 South Union Avenue",
    "building_number": 4347,
    "street": "S Union Ave",
    "city": "Tacoma",
    "zip": 98409,
    "concatenated_address": "4347 S Union Ave, Tacoma",
    "address": "4347 S. Union Ave., Tacoma"
  },
  {
    "id": 1694,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Spring Ridge Assisted Living",
    "latitude": 47.194161,
    "longitude": -122.40839,
    "original_address": "6856 East Portland Avenue",
    "building_number": 6856,
    "street": "E Portland Ave",
    "city": "Tacoma",
    "zip": 98404,
    "concatenated_address": "6856 E Portland Ave, Tacoma",
    "address": "6856 E. Portland Ave., Tacoma"
  },
  {
    "id": 1695,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Conifer South Apartments",
    "latitude": 47.208599,
    "longitude": -122.48095,
    "original_address": "5234 5235 S Warner Street",
    "building_number": 5235,
    "street": "S Warner St",
    "city": "Tacoma",
    "zip": 98409,
    "concatenated_address": "5235 S Warner St, Tacoma",
    "address": "5235 S. Warner St., Tacoma"
  },
  {
    "id": 1696,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Redwood Park And Juniper Gard",
    "latitude": 47.276109,
    "longitude": -122.51471,
    "original_address": "3015 N. Pearl Street",
    "building_number": 3015,
    "street": "N Pearl St",
    "city": "Tacoma",
    "zip": 98407,
    "concatenated_address": "3015 N Pearl St, Tacoma",
    "address": "3015 N. Pearl St., Tacoma"
  },
  {
    "id": 1697,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Pine Tree Harbor",
    "latitude": 47.238,
    "longitude": -122.44232,
    "original_address": "2501 South G Street",
    "building_number": 2501,
    "street": "S G St",
    "city": "Tacoma",
    "zip": 98405,
    "concatenated_address": "2501 S G St, Tacoma",
    "address": "2501 S. G St., Tacoma"
  },
  {
    "id": 1698,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Tahoma Vista Village",
    "latitude": 47.24576,
    "longitude": -122.53024,
    "original_address": "1512 South Mildred St.",
    "building_number": 1512,
    "street": "S Mildred St",
    "city": "Tacoma",
    "zip": 98465,
    "concatenated_address": "1512 S Mildred St, Tacoma",
    "address": "1512 S. Mildred St., Tacoma"
  },
  {
    "id": 1699,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Peoples Retirement Community",
    "latitude": 47.19592,
    "longitude": -122.40476,
    "original_address": "1800 East 67th Street",
    "building_number": 1800,
    "street": "E 67th St",
    "city": "Tacoma",
    "zip": 98404,
    "concatenated_address": "1800 E 67th St, Tacoma",
    "address": "1800 E. 67th St., Tacoma"
  },
  {
    "id": 1700,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Vintage At Tacoma",
    "latitude": 47.219657,
    "longitude": -122.47868,
    "original_address": "4023 South Lawrence Street",
    "building_number": 4023,
    "street": "S Lawrence St",
    "city": "Tacoma",
    "zip": 98409,
    "concatenated_address": "4023 S Lawrence St, Tacoma",
    "address": "4023 S. Lawrence St., Tacoma"
  },
  {
    "id": 1701,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Wheatland Apts",
    "latitude": 47.227679,
    "longitude": -117.0698,
    "original_address": "320 East Alder Street",
    "building_number": 320,
    "street": "Alder St",
    "city": "Tekoa",
    "zip": 99033,
    "concatenated_address": "320 Alder St, Tekoa",
    "address": "320 Alder St., Tekoa"
  },
  {
    "id": 1702,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Toppenish Nursing & Rehab Care",
    "latitude": 46.373388,
    "longitude": -120.32293,
    "original_address": "802 West 3rd Avenue",
    "building_number": 802,
    "street": "W 3rd Ave",
    "city": "Toppenish",
    "zip": 98948,
    "concatenated_address": "802 W 3rd Ave, Toppenish",
    "address": "802 W. 3rd Ave., Toppenish"
  },
  {
    "id": 1703,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Pyramid Pointe Apartments",
    "latitude": 47.447335,
    "longitude": -122.27309,
    "original_address": "5709 5711 5717 5811 & 5821 South 152nd Place",
    "building_number": "",
    "street": "",
    "city": "Seattle",
    "zip": 98188,
    "concatenated_address": "5709 5711 5717 5811 & 5821 South 152nd Place, Seattle",
    "address": "5709 5711 5717 5811 & 5821 South 152nd Place, Seattle"
  },
  {
    "id": 1704,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Colonial Garden Apartments",
    "latitude": 47.473773,
    "longitude": -122.28686,
    "original_address": "3465 S. 144th Street",
    "building_number": 3465,
    "street": "S 144th St",
    "city": "Seattle",
    "zip": 98168,
    "concatenated_address": "3465 S 144th St, Seattle",
    "address": "3465 S. 144th St., Seattle"
  },
  {
    "id": 1705,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Villa Nelle Apartments",
    "latitude": 47.472923,
    "longitude": -122.28711,
    "original_address": "3516 South 146th Street",
    "building_number": 3516,
    "street": "S 146th St",
    "city": "Seattle",
    "zip": 98168,
    "concatenated_address": "3516 S 146th St, Seattle",
    "address": "3516 S. 146th St., Seattle"
  },
  {
    "id": 1706,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Rochelle Apartments",
    "latitude": 47.473919,
    "longitude": -122.28787,
    "original_address": "3445 S 144th Street",
    "building_number": 3445,
    "street": "S 144th St",
    "city": "Seattle",
    "zip": 98168,
    "concatenated_address": "3445 S 144th St, Seattle",
    "address": "3445 S. 144th St., Seattle"
  },
  {
    "id": 1707,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Parkview Apartments",
    "latitude": 47.467074,
    "longitude": -122.25289,
    "original_address": "15130 65th Avenue South",
    "building_number": 15130,
    "street": "65th Ave S",
    "city": "Seattle",
    "zip": 98188,
    "concatenated_address": "15130 65th Ave S, Seattle",
    "address": "15130 65th Ave. S., Seattle"
  },
  {
    "id": 1708,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Hampton Heights",
    "latitude": 47.447335,
    "longitude": -122.27309,
    "original_address": "5710 And 5711 South 152nd Street",
    "building_number": "",
    "street": "",
    "city": "Seattle",
    "zip": 98188,
    "concatenated_address": "5710 And 5711 South 152nd Street, Seattle",
    "address": "5710 And 5711 South 152nd St., Seattle"
  },
  {
    "id": 1709,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Boulevard At South Station",
    "latitude": 47.466114,
    "longitude": -122.27478,
    "original_address": "4708 Southcenter Bouelvard",
    "building_number": 4708,
    "street": "Southcenter Blvd",
    "city": "Seattle",
    "zip": 98188,
    "concatenated_address": "4708 Southcenter Blvd, Seattle",
    "address": "4708 Southcenter Blvd., Seattle"
  },
  {
    "id": 1710,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Foster Creek Apartments",
    "latitude": 47.46742,
    "longitude": -122.26571,
    "original_address": "15110 Macadam Road South",
    "building_number": 15110,
    "street": "Macadam Rd S",
    "city": "Seattle",
    "zip": 98188,
    "concatenated_address": "15110 Macadam Rd S, Seattle",
    "address": "15110 Macadam Road S., Seattle"
  },
  {
    "id": 1711,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Courtyard At South Station",
    "latitude": 47.465685,
    "longitude": -122.28443,
    "original_address": "3900 Southcenter Boulevard",
    "building_number": 3900,
    "street": "Southcenter Blvd",
    "city": "Seattle",
    "zip": 98188,
    "concatenated_address": "3900 Southcenter Blvd, Seattle",
    "address": "3900 Southcenter Blvd., Seattle"
  },
  {
    "id": 1712,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Birch Crest Apartments",
    "latitude": 47.478254,
    "longitude": -122.28244,
    "original_address": "4030 S 140th St",
    "building_number": 4030,
    "street": "S 140th St",
    "city": "Seattle",
    "zip": 98168,
    "concatenated_address": "4030 S 140th St, Seattle",
    "address": "4030 S. 140th St., Seattle"
  },
  {
    "id": 1713,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Cottage Woods Apartments",
    "latitude": 47.447335,
    "longitude": -122.27309,
    "original_address": "4025 And 4217 Southcenter Blvd",
    "building_number": "",
    "street": "",
    "city": "Seattle",
    "zip": 98188,
    "concatenated_address": "4025 And 4217 Southcenter Blvd, Seattle",
    "address": "4025 And 4217 Southcenter Blvd., Seattle"
  },
  {
    "id": 1714,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Cielo Apartments",
    "latitude": 47.46064,
    "longitude": -122.28425,
    "original_address": "15830 39th Pl S",
    "building_number": 15830,
    "street": "39th Pl S",
    "city": "Seattle",
    "zip": 98188,
    "concatenated_address": "15830 39th Pl S, Seattle",
    "address": "15830 39th Pl S., Seattle"
  },
  {
    "id": 1715,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Ladera Healtherwood Apartments",
    "latitude": 47.466709,
    "longitude": -122.26,
    "original_address": "5821-5881 South 152nd Street",
    "building_number": 5881,
    "street": "S 152nd St",
    "city": "Seattle",
    "zip": 98188,
    "concatenated_address": "5881 S 152nd St, Seattle",
    "address": "5881 S. 152nd St., Seattle"
  },
  {
    "id": 1716,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "The Hampton Alzheimers Special Care Center",
    "latitude": 47.000127,
    "longitude": -122.92149,
    "original_address": "1400 Trosper Road Sw",
    "building_number": 1400,
    "street": "Trosper Rd SW",
    "city": "Olympia",
    "zip": 98512,
    "concatenated_address": "1400 Trosper Rd SW, Olympia",
    "address": "1400 Trosper Road S.W., Olympia"
  },
  {
    "id": 1717,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Breckenridge Apartments",
    "latitude": 47.020485,
    "longitude": -122.92454,
    "original_address": "2820 Tuscany Lane",
    "building_number": 2820,
    "street": "Tuscany Ln SW",
    "city": "Olympia",
    "zip": 98512,
    "concatenated_address": "2820 Tuscany Ln SW, Olympia",
    "address": "2820 Tuscany Lane S.W., Olympia"
  },
  {
    "id": 1718,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Breckenridge Heights Apartments",
    "latitude": 47.021065,
    "longitude": -122.92169,
    "original_address": "1923 Brittany Lane Sw",
    "building_number": 1923,
    "street": "Brittany Ln SW",
    "city": "Olympia",
    "zip": 98512,
    "concatenated_address": "1923 Brittany Ln SW, Olympia",
    "address": "1923 Brittany Lane S.W., Olympia"
  },
  {
    "id": 1719,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Alpine Village Apartments",
    "latitude": 46.996205,
    "longitude": -122.91011,
    "original_address": "301 T Street Sw",
    "building_number": 301,
    "street": "T St SW",
    "city": "Olympia",
    "zip": 98501,
    "concatenated_address": "301 T St SW, Olympia",
    "address": "301 T St. S.W., Olympia"
  },
  {
    "id": 1720,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Villas At Kennedy Creek",
    "latitude": 46.99984,
    "longitude": -122.92578,
    "original_address": "1978 Trosper Road Sw",
    "building_number": 1978,
    "street": "Trosper Rd SW",
    "city": "Olympia",
    "zip": 98512,
    "concatenated_address": "1978 Trosper Rd SW, Olympia",
    "address": "1978 Trosper Road S.W., Olympia"
  },
  {
    "id": 1721,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Montair At Somerset Hill",
    "latitude": 47.017015,
    "longitude": -122.91754,
    "original_address": "1704 Barnes Boulevard Southwest",
    "building_number": 1704,
    "street": "Barnes Blvd SW",
    "city": "Olympia",
    "zip": 98512,
    "concatenated_address": "1704 Barnes Blvd SW, Olympia",
    "address": "1704 Barnes Blvd S.W., Olympia"
  },
  {
    "id": 1722,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Hearthstone Apartments",
    "latitude": 46.995661,
    "longitude": -122.90614,
    "original_address": "215 Pinehurst Drive Sw",
    "building_number": 215,
    "street": "Pinehurst Dr SE",
    "city": "Olympia",
    "zip": 98501,
    "concatenated_address": "215 Pinehurst Dr SE, Olympia",
    "address": "215 Pinehurst Dr S.E., Olympia"
  },
  {
    "id": 1723,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Sunset View Apartments",
    "latitude": 47.218047,
    "longitude": -122.54041,
    "original_address": "7713 44th Street",
    "building_number": 7713,
    "street": "44th St W",
    "city": "Tacoma",
    "zip": 98466,
    "concatenated_address": "7713 44th St W, Tacoma",
    "address": "7713 44th St. W., Tacoma"
  },
  {
    "id": 1724,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Olympic Terrace Apartments",
    "latitude": 47.224946,
    "longitude": -122.53763,
    "original_address": "3656 Bridgeport Way W.",
    "building_number": 3656,
    "street": "Bridgeport Way W",
    "city": "Tacoma",
    "zip": 98466,
    "concatenated_address": "3656 Bridgeport Way W, Tacoma",
    "address": "3656 Bridgeport Way W., Tacoma"
  },
  {
    "id": 1725,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Crystal Grove Apartments",
    "latitude": 47.236882,
    "longitude": -122.54819,
    "original_address": "2508 Crystal Springs Road West",
    "building_number": 2508,
    "street": "Crystal Springs Rd W",
    "city": "Tacoma",
    "zip": 98466,
    "concatenated_address": "2508 Crystal Springs Rd W, Tacoma",
    "address": "2508 Crystal Springs Road W., Tacoma"
  },
  {
    "id": 1726,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "University Commons Apartments",
    "latitude": 47.214849,
    "longitude": -122.5384,
    "original_address": "7602 46th Street W",
    "building_number": 7602,
    "street": "46th St W",
    "city": "Tacoma",
    "zip": 98466,
    "concatenated_address": "7602 46th St W, Tacoma",
    "address": "7602 46th St. W., Tacoma"
  },
  {
    "id": 1727,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Latitude 47",
    "latitude": 47.225451,
    "longitude": -122.53612,
    "original_address": "3633 Market Place West",
    "building_number": 3633,
    "street": "Market Pl W",
    "city": "Tacoma",
    "zip": 98466,
    "concatenated_address": "3633 Market Pl W, Tacoma",
    "address": "3633 Market Pl W., Tacoma"
  },
  {
    "id": 1728,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Chambers Creek Estates",
    "latitude": 47.201154,
    "longitude": -122.53329,
    "original_address": "6124 70th Avenue Court W",
    "building_number": 6124,
    "street": "70th Ave Ct W",
    "city": "University Place",
    "zip": 98467,
    "concatenated_address": "6124 70th Ave Ct W, University Place",
    "address": "6124 70th Ave. Ct W., University Place"
  },
  {
    "id": 1729,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Narrows Ridge Apartments",
    "latitude": 47.238266,
    "longitude": -122.5313,
    "original_address": "2302-2330 70th Avenue W.",
    "building_number": 2330,
    "street": "70th Ave W",
    "city": "Tacoma",
    "zip": 98466,
    "concatenated_address": "2330 70th Ave W, Tacoma",
    "address": "2330 70th Ave. W., Tacoma"
  },
  {
    "id": 1730,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Stonepointe",
    "latitude": 47.222771,
    "longitude": -122.54179,
    "original_address": "3806 78th Avenue Court West",
    "building_number": 3806,
    "street": "78th Ave Ct W",
    "city": "Tacoma",
    "zip": 98466,
    "concatenated_address": "3806 78th Ave Ct W, Tacoma",
    "address": "3806 78th Ave. Ct W., Tacoma"
  },
  {
    "id": 1731,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Devonshire Townhomes",
    "latitude": 47.22605,
    "longitude": -122.53944,
    "original_address": "2707 And 2711 Mountain View Avenue W",
    "building_number": "",
    "street": "",
    "city": "Tacoma",
    "zip": 98466,
    "concatenated_address": "2707 And 2711 Mountain View Avenue W, Tacoma",
    "address": "2707 And 2711 Mountain View Avenue W., Tacoma"
  },
  {
    "id": 1732,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "3109 Bridgeport Way West",
    "latitude": 47.231484,
    "longitude": -122.53674,
    "original_address": "3109 Bridgeport Way West",
    "building_number": 3109,
    "street": "Bridgeport Way W",
    "city": "Tacoma",
    "zip": 98466,
    "concatenated_address": "3109 Bridgeport Way W, Tacoma",
    "address": "3109 Bridgeport Way W., Tacoma"
  },
  {
    "id": 1733,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Madison Ave Retirement Center",
    "latitude": 47.623224,
    "longitude": -122.52083,
    "original_address": "285 Madison Ave South",
    "building_number": 285,
    "street": "Madison Ave S",
    "city": "Bainbridge Island",
    "zip": 98110,
    "concatenated_address": "285 Madison Ave S, Bainbridge Island",
    "address": "285 Madison Ave. S., Bainbridge Island"
  },
  {
    "id": 1734,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "The Mountains Apartments",
    "latitude": 45.646381,
    "longitude": -122.60552,
    "original_address": "3400 Ne 66th Avenue",
    "building_number": 3400,
    "street": "NE 66th Ave",
    "city": "Vancouver",
    "zip": 98661,
    "concatenated_address": "3400 NE 66th Ave, Vancouver",
    "address": "3400 N.E. 66th Ave., Vancouver"
  },
  {
    "id": 1735,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Van Plaza Apartments",
    "latitude": 45.647107,
    "longitude": -122.58993,
    "original_address": "8011 Ne Fourth Plain Boulevard",
    "building_number": 8011,
    "street": "NE 4th Plain Blvd",
    "city": "Vancouver",
    "zip": 98662,
    "concatenated_address": "8011 NE 4th Plain Blvd, Vancouver",
    "address": "8011 N.E. 4th Plain Blvd., Vancouver"
  },
  {
    "id": 1736,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Pacific Crest Apartments",
    "latitude": 45.637743,
    "longitude": -122.63176,
    "original_address": "3700 East Fourth Plain Blvd.",
    "building_number": 3700,
    "street": "E 4th Plain Blvd",
    "city": "Vancouver",
    "zip": 98661,
    "concatenated_address": "3700 E 4th Plain Blvd, Vancouver",
    "address": "3700 E. 4th Plain Blvd., Vancouver"
  },
  {
    "id": 1737,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Willow Brook Apartments",
    "latitude": 45.658917,
    "longitude": -122.63393,
    "original_address": "3512 Ne 51st",
    "building_number": 3512,
    "street": "NE 51st St",
    "city": "Vancouver",
    "zip": 98661,
    "concatenated_address": "3512 NE 51st St, Vancouver",
    "address": "3512 N.E. 51st St., Vancouver"
  },
  {
    "id": 1738,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Timberknoll Apartments",
    "latitude": 45.702526,
    "longitude": -122.65056,
    "original_address": "11201 Ne Hwy 99",
    "building_number": 11201,
    "street": "NE Highway 99",
    "city": "Vancouver",
    "zip": 98686,
    "concatenated_address": "11201 NE Highway 99, Vancouver",
    "address": "11201 N.E. Highway 99, Vancouver"
  },
  {
    "id": 1739,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "North Glen Villas",
    "latitude": 45.699347,
    "longitude": -122.60037,
    "original_address": "7101 Ne 109th Street",
    "building_number": 7101,
    "street": "NE 109th St",
    "city": "Vancouver",
    "zip": 98686,
    "concatenated_address": "7101 NE 109th St, Vancouver",
    "address": "7101 N.E. 109th St., Vancouver"
  },
  {
    "id": 1740,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Gardenview Estates Apartments",
    "latitude": 45.644863,
    "longitude": -122.61488,
    "original_address": "3114 Ne 57th Ave",
    "building_number": 3114,
    "street": "NE 57th Ave",
    "city": "Vancouver",
    "zip": 98661,
    "concatenated_address": "3114 NE 57th Ave, Vancouver",
    "address": "3114 N.E. 57th Ave., Vancouver"
  },
  {
    "id": 1741,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "First Street Station Apartments",
    "latitude": 45.62087,
    "longitude": -122.50751,
    "original_address": "16119 Se 1st St",
    "building_number": 16119,
    "street": "SE 1st St",
    "city": "Vancouver",
    "zip": 98684,
    "concatenated_address": "16119 SE 1st St, Vancouver",
    "address": "16119 S.E. 1st St., Vancouver"
  },
  {
    "id": 1742,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Highgate Senior Living - Vancouver",
    "latitude": 45.692451,
    "longitude": -122.66838,
    "original_address": "9803 Northeast Hazel Dell Avenue",
    "building_number": 9803,
    "street": "NE Hazel Dell Ave",
    "city": "Vancouver",
    "zip": 98665,
    "concatenated_address": "9803 NE Hazel Dell Ave, Vancouver",
    "address": "9803 N.E. Hazel Dell Ave., Vancouver"
  },
  {
    "id": 1743,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Wyeast Pointe",
    "latitude": 45.6148,
    "longitude": -122.53468,
    "original_address": "812 Se 136th Avenue",
    "building_number": 812,
    "street": "SE 136th Ave",
    "city": "Vancouver",
    "zip": 98683,
    "concatenated_address": "812 SE 136th Ave, Vancouver",
    "address": "812 S.E. 136th Ave., Vancouver"
  },
  {
    "id": 1744,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Fontana Court Apartments",
    "latitude": 45.630036,
    "longitude": -122.66976,
    "original_address": "215 East 12th Street",
    "building_number": 215,
    "street": "E 12th St",
    "city": "Vancouver",
    "zip": 98660,
    "concatenated_address": "215 E 12th St, Vancouver",
    "address": "215 E. 12th St., Vancouver"
  },
  {
    "id": 1745,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Cedar Ridge Apartments",
    "latitude": 45.635325,
    "longitude": -122.62493,
    "original_address": "4200 East 18th Street",
    "building_number": 4200,
    "street": "E 18th St",
    "city": "Vancouver",
    "zip": 98661,
    "concatenated_address": "4200 E 18th St, Vancouver",
    "address": "4200 E. 18th St., Vancouver"
  },
  {
    "id": 1746,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Allwood Apartments",
    "latitude": 45.627257,
    "longitude": -122.63991,
    "original_address": "3011 East 9th Street",
    "building_number": 3011,
    "street": "E 9th St",
    "city": "Vancouver",
    "zip": 98661,
    "concatenated_address": "3011 E 9th St, Vancouver",
    "address": "3011 E. 9th St., Vancouver"
  },
  {
    "id": 1747,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "North Glen Villas II",
    "latitude": 45.69995,
    "longitude": -122.64891,
    "original_address": "6807 Ne 109th Street And 6909 Ne 109th Street",
    "building_number": "",
    "street": "NE 109th Cir",
    "city": "Vancouver",
    "zip": 98686,
    "concatenated_address": "6807 Ne 109th Street And 6909 Ne 109th Street, Vancouver",
    "address": "6807 N.E. 109th St. And 6909 N.E. 109th St., Vancouver"
  },
  {
    "id": 1748,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Autumn Chase Apartments",
    "latitude": 45.624896,
    "longitude": -122.55506,
    "original_address": "11301 - 11307 Ne 7th Street",
    "building_number": 11307,
    "street": "NE 7th St",
    "city": "Vancouver",
    "zip": 98684,
    "concatenated_address": "11307 NE 7th St, Vancouver",
    "address": "11307 N.E. 7th St., Vancouver"
  },
  {
    "id": 1749,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Millbrook Townhomes",
    "latitude": 45.647185,
    "longitude": -122.62138,
    "original_address": "3500 Ne 50th Court",
    "building_number": 3500,
    "street": "NE 50th Ct",
    "city": "Vancouver",
    "zip": 98661,
    "concatenated_address": "3500 NE 50th Ct, Vancouver",
    "address": "3500 N.E. 50th Ct, Vancouver"
  },
  {
    "id": 1750,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Overlook Park",
    "latitude": 45.637954,
    "longitude": -122.55662,
    "original_address": "2201 Ne 112th Avenue",
    "building_number": 2201,
    "street": "NE 112th Ave",
    "city": "Vancouver",
    "zip": 98684,
    "concatenated_address": "2201 NE 112th Ave, Vancouver",
    "address": "2201 N.E. 112th Ave., Vancouver"
  },
  {
    "id": 1751,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Willow Pointe Townhomes",
    "latitude": 45.721125,
    "longitude": -122.66975,
    "original_address": "13717 Nw 2nd Avenue",
    "building_number": 13717,
    "street": "NW 2nd Ave",
    "city": "Vancouver",
    "zip": 98685,
    "concatenated_address": "13717 NW 2nd Ave, Vancouver",
    "address": "13717 N.W. 2nd Ave., Vancouver"
  },
  {
    "id": 1752,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Summerfield Rental Homes",
    "latitude": 45.622045,
    "longitude": -122.51363,
    "original_address": "15501 Ne 2nd Street",
    "building_number": 15501,
    "street": "NE 2nd St",
    "city": "Vancouver",
    "zip": 98684,
    "concatenated_address": "15501 NE 2nd St, Vancouver",
    "address": "15501 N.E. 2nd St., Vancouver"
  },
  {
    "id": 1753,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Covington Estates Apartments",
    "latitude": 45.673607,
    "longitude": -122.57001,
    "original_address": "7020 Northeast 100th Court",
    "building_number": 7020,
    "street": "NE 100th Ct",
    "city": "Vancouver",
    "zip": 98662,
    "concatenated_address": "7020 NE 100th Ct, Vancouver",
    "address": "7020 N.E. 100th Ct, Vancouver"
  },
  {
    "id": 1754,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Cascade Inn",
    "latitude": 45.615533,
    "longitude": -122.55287,
    "original_address": "11613 Southeast 7th Street",
    "building_number": 11613,
    "street": "SE 7th St",
    "city": "Vancouver",
    "zip": 98683,
    "concatenated_address": "11613 SE 7th St, Vancouver",
    "address": "11613 S.E. 7th St., Vancouver"
  },
  {
    "id": 1755,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Meadows At Cascade Park Apartments",
    "latitude": 45.608499,
    "longitude": -122.53397,
    "original_address": "13314 Se 19th Street",
    "building_number": 13314,
    "street": "SE 19th St",
    "city": "Vancouver",
    "zip": 98683,
    "concatenated_address": "13314 SE 19th St, Vancouver",
    "address": "13314 S.E. 19th St., Vancouver"
  },
  {
    "id": 1756,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Somerset Terrace Apartments",
    "latitude": 45.607519,
    "longitude": -122.53287,
    "original_address": "13607 Se 19th Street",
    "building_number": 13607,
    "street": "SE 19th St",
    "city": "Vancouver",
    "zip": 98683,
    "concatenated_address": "13607 SE 19th St, Vancouver",
    "address": "13607 S.E. 19th St., Vancouver"
  },
  {
    "id": 1757,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Steeple Chase Apartments",
    "latitude": 45.640067,
    "longitude": -122.62502,
    "original_address": "4617 Ne Street Johns Road",
    "building_number": "",
    "street": "",
    "city": "Vancouver",
    "zip": 98661,
    "concatenated_address": "4617 Ne Street Johns Road, Vancouver",
    "address": "4617 N.E. St. Johns Road, Vancouver"
  },
  {
    "id": 1758,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Evergreen Pointe Apartments",
    "latitude": 45.619539,
    "longitude": -122.62259,
    "original_address": "4503 East 5th Street",
    "building_number": 4503,
    "street": "E 5th St",
    "city": "Vancouver",
    "zip": 98661,
    "concatenated_address": "4503 E 5th St, Vancouver",
    "address": "4503 E. 5th St., Vancouver"
  },
  {
    "id": 1759,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Prestige Plaza",
    "latitude": 45.631426,
    "longitude": -122.66884,
    "original_address": "305 East Mill Plain Boulevard",
    "building_number": 305,
    "street": "E Mill Plain Blvd",
    "city": "Vancouver",
    "zip": 98660,
    "concatenated_address": "305 E Mill Plain Blvd, Vancouver",
    "address": "305 E. Mill Plain Blvd., Vancouver"
  },
  {
    "id": 1760,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Cascade Park Estates",
    "latitude": 45.625473,
    "longitude": -122.50257,
    "original_address": "16500 Se 1st Street",
    "building_number": 16500,
    "street": "SE 1st St",
    "city": "Vancouver",
    "zip": 98684,
    "concatenated_address": "16500 SE 1st St, Vancouver",
    "address": "16500 S.E. 1st St., Vancouver"
  },
  {
    "id": 1761,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Willow Pointe Apartments",
    "latitude": 45.721125,
    "longitude": -122.66975,
    "original_address": "13717 Nw 2nd Avenue",
    "building_number": 13717,
    "street": "NW 2nd Ave",
    "city": "Vancouver",
    "zip": 98685,
    "concatenated_address": "13717 NW 2nd Ave, Vancouver",
    "address": "13717 N.W. 2nd Ave., Vancouver"
  },
  {
    "id": 1762,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "The Park At Fox Pointe",
    "latitude": 45.642024,
    "longitude": -122.61348,
    "original_address": "3009 Ne 57th Avenue",
    "building_number": 3009,
    "street": "NE 57th Ave",
    "city": "Vancouver",
    "zip": 98661,
    "concatenated_address": "3009 NE 57th Ave, Vancouver",
    "address": "3009 N.E. 57th Ave., Vancouver"
  },
  {
    "id": 1763,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Park Crest Commons Apartments",
    "latitude": 45.61603,
    "longitude": -122.51729,
    "original_address": "14913 Se Mill Plain Boulevard",
    "building_number": 14913,
    "street": "SE Mill Plain Blvd",
    "city": "Vancouver",
    "zip": 98684,
    "concatenated_address": "14913 SE Mill Plain Blvd, Vancouver",
    "address": "14913 S.E. Mill Plain Blvd., Vancouver"
  },
  {
    "id": 1764,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Madison Park",
    "latitude": 45.641261,
    "longitude": -122.54092,
    "original_address": "12901 Ne 28th Street",
    "building_number": 12901,
    "street": "NE 28th St",
    "city": "Vancouver",
    "zip": 98682,
    "concatenated_address": "12901 NE 28th St, Vancouver",
    "address": "12901 N.E. 28th St., Vancouver"
  },
  {
    "id": 1765,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Autumn Chase Apartments",
    "latitude": 45.624896,
    "longitude": -122.55506,
    "original_address": "11301 - 11307 Ne 7th St.",
    "building_number": 11307,
    "street": "NE 7th St",
    "city": "Vancouver",
    "zip": 98684,
    "concatenated_address": "11307 NE 7th St, Vancouver",
    "address": "11307 N.E. 7th St., Vancouver"
  },
  {
    "id": 1766,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Eagle Pointe Apartments",
    "latitude": 45.636397,
    "longitude": -122.63137,
    "original_address": "2003 Todd Road",
    "building_number": 2003,
    "street": "Todd Rd",
    "city": "Vancouver",
    "zip": 98661,
    "concatenated_address": "2003 Todd Rd, Vancouver",
    "address": "2003 Todd Road, Vancouver"
  },
  {
    "id": 1767,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Union Park",
    "latitude": 45.707107,
    "longitude": -122.54628,
    "original_address": "11803 Ne 124th Avenue",
    "building_number": 11800,
    "street": "NE 124th Ave",
    "city": "Vancouver",
    "zip": 98682,
    "concatenated_address": "11800 NE 124th Ave, Vancouver",
    "address": "11800 N.E. 124th Ave., Vancouver"
  },
  {
    "id": 1768,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Slate Ridge At Fishers Landing",
    "latitude": 45.598581,
    "longitude": -122.50169,
    "original_address": "3100 Southeast 168th Avenue",
    "building_number": 3100,
    "street": "SE 168th Ave",
    "city": "Vancouver",
    "zip": 98683,
    "concatenated_address": "3100 SE 168th Ave, Vancouver",
    "address": "3100 S.E. 168th Ave., Vancouver"
  },
  {
    "id": 1769,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Highland Crossing Apartments",
    "latitude": 45.678782,
    "longitude": -122.47885,
    "original_address": "11806 Ne 122nd Avenue",
    "building_number": "",
    "street": "",
    "city": "Vancouver",
    "zip": 98682,
    "concatenated_address": "11806 Ne 122nd Avenue, Vancouver",
    "address": "11806 N.E. 122nd Avenue, Vancouver"
  },
  {
    "id": 1770,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Oakbrook Apartments",
    "latitude": 45.642438,
    "longitude": -122.56579,
    "original_address": "10415 North East Oakbrook Circle",
    "building_number": 10415,
    "street": "NE Oakbrook Cir",
    "city": "Vancouver",
    "zip": 98662,
    "concatenated_address": "10415 NE Oakbrook Cir, Vancouver",
    "address": "10415 N.E. Oakbrook Cir, Vancouver"
  },
  {
    "id": 1771,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Cascade Park Apartments",
    "latitude": 45.599261,
    "longitude": -122.52807,
    "original_address": "14000 Se Cascade Park Drive",
    "building_number": 14000,
    "street": "SE Cascade Park Dr",
    "city": "Vancouver",
    "zip": 98683,
    "concatenated_address": "14000 SE Cascade Park Dr, Vancouver",
    "address": "14000 S.E. Cascade Park Drive, Vancouver"
  },
  {
    "id": 1772,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Cascade View",
    "latitude": 45.620052,
    "longitude": -122.49946,
    "original_address": "16801 Se 1st Street",
    "building_number": 16801,
    "street": "SE 1st St",
    "city": "Vancouver",
    "zip": 98684,
    "concatenated_address": "16801 SE 1st St, Vancouver",
    "address": "16801 S.E. 1st St., Vancouver"
  },
  {
    "id": 1773,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Avalon Park",
    "latitude": 45.613592,
    "longitude": -122.5605,
    "original_address": "10883 Se 10th Street",
    "building_number": 10883,
    "street": "SE 10th St",
    "city": "Vancouver",
    "zip": 98664,
    "concatenated_address": "10883 SE 10th St, Vancouver",
    "address": "10883 S.E. 10th St., Vancouver"
  },
  {
    "id": 1774,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Villas At Bridge Creek",
    "latitude": 45.636483,
    "longitude": -122.63007,
    "original_address": "2011 Brandt Road",
    "building_number": 2011,
    "street": "Brandt Rd",
    "city": "Vancouver",
    "zip": 98661,
    "concatenated_address": "2011 Brandt Rd, Vancouver",
    "address": "2011 Brandt Road, Vancouver"
  },
  {
    "id": 1775,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Creekside Village",
    "latitude": 45.643505,
    "longitude": -122.63112,
    "original_address": "3100 Falk Road",
    "building_number": 3100,
    "street": "Falk Rd",
    "city": "Vancouver",
    "zip": 98661,
    "concatenated_address": "3100 Falk Rd, Vancouver",
    "address": "3100 Falk Road, Vancouver"
  },
  {
    "id": 1776,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Alder Creek Apartments",
    "latitude": 45.658375,
    "longitude": -122.552,
    "original_address": "11716 Ne 49th Street",
    "building_number": 11716,
    "street": "NE 49th St",
    "city": "Vancouver",
    "zip": 98682,
    "concatenated_address": "11716 NE 49th St, Vancouver",
    "address": "11716 N.E. 49th St., Vancouver"
  },
  {
    "id": 1777,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Broadway Apartments",
    "latitude": 45.635854,
    "longitude": -122.67009,
    "original_address": "1901 Broadway Street",
    "building_number": 1901,
    "street": "Broadway St",
    "city": "Vancouver",
    "zip": 98663,
    "concatenated_address": "1901 Broadway St, Vancouver",
    "address": "1901 Broadway St., Vancouver"
  },
  {
    "id": 1778,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Marketplace Apartments",
    "latitude": 45.64163,
    "longitude": -122.62252,
    "original_address": "2900 General Anderson Avenue",
    "building_number": 2900,
    "street": "General Anderson Ave",
    "city": "Vancouver",
    "zip": 98661,
    "concatenated_address": "2900 General Anderson Ave, Vancouver",
    "address": "2900 General Anderson Ave., Vancouver"
  },
  {
    "id": 1779,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Clark Apartments",
    "latitude": 45.634534,
    "longitude": -122.66455,
    "original_address": "701 East Mcloughlin Boulevard",
    "building_number": 701,
    "street": "E McLoughlin Blvd",
    "city": "Vancouver",
    "zip": 98663,
    "concatenated_address": "701 E McLoughlin Blvd, Vancouver",
    "address": "701 E. McLoughlin Blvd., Vancouver"
  },
  {
    "id": 1780,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Sterling Heights",
    "latitude": 45.61374,
    "longitude": -122.5589,
    "original_address": "1221 Southeast Ellsworth Road",
    "building_number": 1221,
    "street": "SE Ellsworth Rd",
    "city": "Vancouver",
    "zip": 98664,
    "concatenated_address": "1221 SE Ellsworth Rd, Vancouver",
    "address": "1221 S.E. Ellsworth Road, Vancouver"
  },
  {
    "id": 1781,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Nomad Country Club MHC",
    "latitude": 45.697513,
    "longitude": -122.61638,
    "original_address": "10505 Ne 53rd Avenue",
    "building_number": 10505,
    "street": "NE 53rd Ave",
    "city": "Vancouver",
    "zip": 98686,
    "concatenated_address": "10505 NE 53rd Ave, Vancouver",
    "address": "10505 N.E. 53rd Ave., Vancouver"
  },
  {
    "id": 1782,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Hamilton And Eliza Apartments",
    "latitude": 45.63692,
    "longitude": -122.67069,
    "original_address": "2000 Broadway Street",
    "building_number": 2000,
    "street": "Broadway St",
    "city": "Vancouver",
    "zip": 98663,
    "concatenated_address": "2000 Broadway St, Vancouver",
    "address": "2000 Broadway St., Vancouver"
  },
  {
    "id": 1783,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Springfield Meadows Apartments",
    "latitude": 45.653826,
    "longitude": -122.6033,
    "original_address": "4317 Northeast 66th Avenue",
    "building_number": 4317,
    "street": "NE 66th Ave",
    "city": "Vancouver",
    "zip": 98661,
    "concatenated_address": "4317 NE 66th Ave, Vancouver",
    "address": "4317 N.E. 66th Ave., Vancouver"
  },
  {
    "id": 1784,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Greenway Terrace MHC",
    "latitude": 45.673968,
    "longitude": -122.5577,
    "original_address": "11515 Northeast 71st Street",
    "building_number": 11515,
    "street": "NE 71st St",
    "city": "Vancouver",
    "zip": 98662,
    "concatenated_address": "11515 NE 71st St, Vancouver",
    "address": "11515 N.E. 71st St., Vancouver"
  },
  {
    "id": 1785,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Brookside 112",
    "latitude": 45.656163,
    "longitude": -122.55593,
    "original_address": "4619 Northeast 112th Avenue",
    "building_number": 4619,
    "street": "NE 112th Ave",
    "city": "Vancouver",
    "zip": 98682,
    "concatenated_address": "4619 NE 112th Ave, Vancouver",
    "address": "4619 N.E. 112th Ave., Vancouver"
  },
  {
    "id": 1786,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Arnada Pointe Apartment Homes",
    "latitude": 45.656887,
    "longitude": -122.66705,
    "original_address": "4820 Northeast Hazel Dell Aven",
    "building_number": 4820,
    "street": "NE Hazel Dell Ave",
    "city": "Vancouver",
    "zip": 98663,
    "concatenated_address": "4820 NE Hazel Dell Ave, Vancouver",
    "address": "4820 N.E. Hazel Dell Ave., Vancouver"
  },
  {
    "id": 1787,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Maple Ridge Apartments",
    "latitude": 45.622952,
    "longitude": -122.56692,
    "original_address": "306 North East 104th Avenue",
    "building_number": 306,
    "street": "NE 104th Ave",
    "city": "Vancouver",
    "zip": 98664,
    "concatenated_address": "306 NE 104th Ave, Vancouver",
    "address": "306 N.E. 104th Ave., Vancouver"
  },
  {
    "id": 1788,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Golfside Village Apartments",
    "latitude": 45.678018,
    "longitude": -122.60101,
    "original_address": "7700 Northeast 72nd Avenue",
    "building_number": 7700,
    "street": "NE 72nd Ave",
    "city": "Vancouver",
    "zip": 98661,
    "concatenated_address": "7700 NE 72nd Ave, Vancouver",
    "address": "7700 N.E. 72nd Ave., Vancouver"
  },
  {
    "id": 1789,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Renaissance At 29th",
    "latitude": 45.601101,
    "longitude": -122.50143,
    "original_address": "16506 Southeast 29th Street",
    "building_number": 16506,
    "street": "SE 29th St",
    "city": "Vancouver",
    "zip": 98683,
    "concatenated_address": "16506 SE 29th St, Vancouver",
    "address": "16506 S.E. 29th St., Vancouver"
  },
  {
    "id": 1790,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Cascade Woods Apartments",
    "latitude": 45.641076,
    "longitude": -122.5314,
    "original_address": "2508 Northeast 138th Avenue",
    "building_number": 2508,
    "street": "NE 138th Ave",
    "city": "Vancouver",
    "zip": 98684,
    "concatenated_address": "2508 NE 138th Ave, Vancouver",
    "address": "2508 N.E. 138th Ave., Vancouver"
  },
  {
    "id": 1791,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Touchmark At Fairway Village",
    "latitude": 45.601329,
    "longitude": -122.50732,
    "original_address": "2911 Se Village Loop",
    "building_number": 2911,
    "street": "SE Village Loop",
    "city": "Vancouver",
    "zip": 98683,
    "concatenated_address": "2911 SE Village Loop, Vancouver",
    "address": "2911 S.E. Village Loop, Vancouver"
  },
  {
    "id": 1792,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Silver Oak Apartment Homes",
    "latitude": 45.660995,
    "longitude": -122.58295,
    "original_address": "8701 Northeast 54th Street",
    "building_number": 8701,
    "street": "NE 54th St",
    "city": "Vancouver",
    "zip": 98662,
    "concatenated_address": "8701 NE 54th St, Vancouver",
    "address": "8701 N.E. 54th St., Vancouver"
  },
  {
    "id": 1793,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Sedona At Bridgecreek",
    "latitude": 45.637444,
    "longitude": -122.58894,
    "original_address": "2220 Northeast Bridgecreek Avenue",
    "building_number": 2220,
    "street": "NE Bridgecreek Ave",
    "city": "Vancouver",
    "zip": 98664,
    "concatenated_address": "2220 NE Bridgecreek Ave, Vancouver",
    "address": "2220 N.E. Bridgecreek Ave., Vancouver"
  },
  {
    "id": 1794,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Larkspur Place",
    "latitude": 45.655627,
    "longitude": -122.5954,
    "original_address": "7609 Northeast Vancouver Mall Drive",
    "building_number": 7609,
    "street": "NE Vancouver Mall Dr",
    "city": "Vancouver",
    "zip": 98662,
    "concatenated_address": "7609 NE Vancouver Mall Dr, Vancouver",
    "address": "7609 N.E. Vancouver Mall Drive, Vancouver"
  },
  {
    "id": 1795,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Columbia View",
    "latitude": 45.619564,
    "longitude": -122.619,
    "original_address": "4801 East 5th Street",
    "building_number": 4801,
    "street": "E 5th St",
    "city": "Vancouver",
    "zip": 98661,
    "concatenated_address": "4801 E 5th St, Vancouver",
    "address": "4801 E. 5th St., Vancouver"
  },
  {
    "id": 1796,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "The Park At Mill Plain",
    "latitude": 45.622748,
    "longitude": -122.54217,
    "original_address": "206 Northeast 126th Avenue",
    "building_number": 206,
    "street": "NE 126th Ave",
    "city": "Vancouver",
    "zip": 98684,
    "concatenated_address": "206 NE 126th Ave, Vancouver",
    "address": "206 N.E. 126th Ave., Vancouver"
  },
  {
    "id": 1797,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Walnut Grove Landing Apartments",
    "latitude": 45.655753,
    "longitude": -122.59766,
    "original_address": "4701 Northeast 72nd Avenue",
    "building_number": 4701,
    "street": "NE 72nd Ave",
    "city": "Vancouver",
    "zip": 98661,
    "concatenated_address": "4701 NE 72nd Ave, Vancouver",
    "address": "4701 N.E. 72nd Ave., Vancouver"
  },
  {
    "id": 1798,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Lewis Ridge Apartments",
    "latitude": 45.639359,
    "longitude": -122.59138,
    "original_address": "7915 Northeast Burton Road",
    "building_number": 7915,
    "street": "NE Burton Rd",
    "city": "Vancouver",
    "zip": 98662,
    "concatenated_address": "7915 NE Burton Rd, Vancouver",
    "address": "7915 N.E. Burton Road, Vancouver"
  },
  {
    "id": 1799,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Van Mall Retirement Center",
    "latitude": 45.659757,
    "longitude": -122.59187,
    "original_address": "7808 Northeast 51st Street",
    "building_number": 7808,
    "street": "NE 51st St",
    "city": "Vancouver",
    "zip": 98662,
    "concatenated_address": "7808 NE 51st St, Vancouver",
    "address": "7808 N.E. 51st St., Vancouver"
  },
  {
    "id": 1800,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Hampton At Salmon Creek",
    "latitude": 45.714044,
    "longitude": -122.64771,
    "original_address": "2305 Ne 129th Street",
    "building_number": 2305,
    "street": "NE 129th St",
    "city": "Vancouver",
    "zip": 98686,
    "concatenated_address": "2305 NE 129th St, Vancouver",
    "address": "2305 N.E. 129th St., Vancouver"
  },
  {
    "id": 1801,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "The Addison Apartments",
    "latitude": 45.638851,
    "longitude": -122.5951,
    "original_address": "7531 Northeast 18th Street",
    "building_number": 7531,
    "street": "NE 18th St",
    "city": "Vancouver",
    "zip": 98661,
    "concatenated_address": "7531 NE 18th St, Vancouver",
    "address": "7531 N.E. 18th St., Vancouver"
  },
  {
    "id": 1802,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Fairview Court",
    "latitude": 45.650279,
    "longitude": -122.56203,
    "original_address": "4000 Northeast 109th Avenue",
    "building_number": 4000,
    "street": "NE 109th Ave",
    "city": "Vancouver",
    "zip": 98682,
    "concatenated_address": "4000 NE 109th Ave, Vancouver",
    "address": "4000 N.E. 109th Ave., Vancouver"
  },
  {
    "id": 1803,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Rock Creek Commons",
    "latitude": 45.707107,
    "longitude": -122.54628,
    "original_address": "11800 Northeast 124th Avenue",
    "building_number": 11800,
    "street": "NE 124th Ave",
    "city": "Vancouver",
    "zip": 98682,
    "concatenated_address": "11800 NE 124th Ave, Vancouver",
    "address": "11800 N.E. 124th Ave., Vancouver"
  },
  {
    "id": 1804,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Parkview Apartments",
    "latitude": 45.630411,
    "longitude": -122.59049,
    "original_address": "7806 Northeast 12th Street",
    "building_number": 7806,
    "street": "NE 12th St",
    "city": "Vancouver",
    "zip": 98664,
    "concatenated_address": "7806 NE 12th St, Vancouver",
    "address": "7806 N.E. 12th St., Vancouver"
  },
  {
    "id": 1805,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Royal Crest Townhomes",
    "latitude": 45.642834,
    "longitude": -122.58552,
    "original_address": "2810 Northeast 86th Avenue",
    "building_number": 2810,
    "street": "NE 86th Ave",
    "city": "Vancouver",
    "zip": 98662,
    "concatenated_address": "2810 NE 86th Ave, Vancouver",
    "address": "2810 N.E. 86th Ave., Vancouver"
  },
  {
    "id": 1806,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Green Leaf Cascade Park",
    "latitude": 45.617149,
    "longitude": -122.54964,
    "original_address": "604 Southeast 121st Avenue",
    "building_number": 604,
    "street": "SE 121st Ave",
    "city": "Vancouver",
    "zip": 98683,
    "concatenated_address": "604 SE 121st Ave, Vancouver",
    "address": "604 S.E. 121st Ave., Vancouver"
  },
  {
    "id": 1807,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Carriage House Apartments",
    "latitude": 45.656758,
    "longitude": -122.60069,
    "original_address": "4714 Northeast 72nd Avenue",
    "building_number": 4714,
    "street": "NE 72nd Ave",
    "city": "Vancouver",
    "zip": 98661,
    "concatenated_address": "4714 NE 72nd Ave, Vancouver",
    "address": "4714 N.E. 72nd Ave., Vancouver"
  },
  {
    "id": 1808,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Carriage Park Apartments",
    "latitude": 45.658537,
    "longitude": -122.60065,
    "original_address": "5000 Northeast 72nd Avenue",
    "building_number": 5000,
    "street": "NE 72nd Ave",
    "city": "Vancouver",
    "zip": 98661,
    "concatenated_address": "5000 NE 72nd Ave, Vancouver",
    "address": "5000 N.E. 72nd Ave., Vancouver"
  },
  {
    "id": 1809,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Village On Seventh Apartment Homes",
    "latitude": 45.616863,
    "longitude": -122.5416,
    "original_address": "12800 Southeast 7th Street",
    "building_number": 12800,
    "street": "SE 7th St",
    "city": "Vancouver",
    "zip": 98683,
    "concatenated_address": "12800 SE 7th St, Vancouver",
    "address": "12800 S.E. 7th St., Vancouver"
  },
  {
    "id": 1810,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Teal Pointe Apartments",
    "latitude": 45.696018,
    "longitude": -122.66233,
    "original_address": "10405 Northeast 9th Avenue",
    "building_number": 10405,
    "street": "NE 9th Ave",
    "city": "Vancouver",
    "zip": 98685,
    "concatenated_address": "10405 NE 9th Ave, Vancouver",
    "address": "10405 N.E. 9th Ave., Vancouver"
  },
  {
    "id": 1811,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Stonebridge Crossing Apartments",
    "latitude": 45.63853,
    "longitude": -122.5907,
    "original_address": "2301 Northeast 81st Street",
    "building_number": 2209,
    "street": "NE 81st Ave",
    "city": "Vancouver",
    "zip": 98665,
    "concatenated_address": "2209 NE 81st Ave, Vancouver",
    "address": "2209 N.E. 81st Ave., Vancouver"
  },
  {
    "id": 1812,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "6th Street Townhomes",
    "latitude": 46.148461,
    "longitude": -122.90578,
    "original_address": "8215 Ne 6th St And 8212 Ne 5th St",
    "building_number": "",
    "street": "6th Ave N",
    "city": "Kelso",
    "zip": 98664,
    "concatenated_address": "8215 Ne 6th St And 8212 Ne 5th St, Kelso",
    "address": "8215 N.E. 6th St. And 8212 N.E. 5th St., Kelso"
  },
  {
    "id": 1813,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Bryant Court Apartments",
    "latitude": 45.633243,
    "longitude": -122.62751,
    "original_address": "1604 Bryant St",
    "building_number": 1604,
    "street": "Bryant St",
    "city": "Vancouver",
    "zip": 98661,
    "concatenated_address": "1604 Bryant St, Vancouver",
    "address": "1604 Bryant St., Vancouver"
  },
  {
    "id": 1814,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Avenue 66 Apartments",
    "latitude": 45.656835,
    "longitude": -122.60415,
    "original_address": "4721 Ne 66th Avenue",
    "building_number": 4721,
    "street": "NE 66th Ave",
    "city": "Vancouver",
    "zip": 98661,
    "concatenated_address": "4721 NE 66th Ave, Vancouver",
    "address": "4721 N.E. 66th Ave., Vancouver"
  },
  {
    "id": 1815,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Ash Street Apartments",
    "latitude": 45.633146,
    "longitude": -122.6363,
    "original_address": "1601-1625 Ash Street",
    "building_number": 1601,
    "street": "Ash St",
    "city": "Vancouver",
    "zip": 98661,
    "concatenated_address": "1601 Ash St, Vancouver",
    "address": "1601 Ash St., Vancouver"
  },
  {
    "id": 1816,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "King James And Kings Gate Apartments",
    "latitude": 45.640067,
    "longitude": -122.62502,
    "original_address": "3707 And 3804 East 18th Street",
    "building_number": "",
    "street": "",
    "city": "Vancouver",
    "zip": 98661,
    "concatenated_address": "3707 And 3804 East 18th Street, Vancouver",
    "address": "3707 And 3804 East 18th St., Vancouver"
  },
  {
    "id": 1817,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Wellington Court Townhomes",
    "latitude": 45.66051,
    "longitude": -122.63549,
    "original_address": "3415 Northeast 53rd Street",
    "building_number": 3415,
    "street": "NE 53rd St",
    "city": "Vancouver",
    "zip": 98661,
    "concatenated_address": "3415 NE 53rd St, Vancouver",
    "address": "3415 N.E. 53rd St., Vancouver"
  },
  {
    "id": 1818,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Cedar Lane Apartments",
    "latitude": 45.643987,
    "longitude": -122.63556,
    "original_address": "3201 East 33rd Street",
    "building_number": 3201,
    "street": "E 33rd St",
    "city": "Vancouver",
    "zip": 98661,
    "concatenated_address": "3201 E 33rd St, Vancouver",
    "address": "3201 E. 33rd St., Vancouver"
  },
  {
    "id": 1819,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Greystone Park Apartments",
    "latitude": 45.64717,
    "longitude": -122.61434,
    "original_address": "5500 Northeast 34th Street",
    "building_number": 5500,
    "street": "NE 34th St",
    "city": "Vancouver",
    "zip": 98661,
    "concatenated_address": "5500 NE 34th St, Vancouver",
    "address": "5500 N.E. 34th St., Vancouver"
  },
  {
    "id": 1820,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Timbers Apartments",
    "latitude": 45.689187,
    "longitude": -122.66161,
    "original_address": "602, 608 & 614 Ne 86th St.",
    "building_number": "",
    "street": "",
    "city": "Vancouver",
    "zip": 98665,
    "concatenated_address": "602, 608 & 614 Ne 86th St., Vancouver",
    "address": "602, 608 & 614 N.E. 86th St., Vancouver"
  },
  {
    "id": 1821,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "White Peaks Townhomes",
    "latitude": 45.615856,
    "longitude": -122.51658,
    "original_address": "907 Se Park Crest Avenue",
    "building_number": 907,
    "street": "SE Park Crest Ave",
    "city": "Vancouver",
    "zip": 98683,
    "concatenated_address": "907 SE Park Crest Ave, Vancouver",
    "address": "907 S.E. Park Crest Ave., Vancouver"
  },
  {
    "id": 1822,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "34th Street Apartments",
    "latitude": 45.646877,
    "longitude": -122.61289,
    "original_address": "5750 Ne 34th Street",
    "building_number": 5750,
    "street": "NE 34th St",
    "city": "Vancouver",
    "zip": 98661,
    "concatenated_address": "5750 NE 34th St, Vancouver",
    "address": "5750 N.E. 34th St., Vancouver"
  },
  {
    "id": 1823,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Sydney Court Apartments",
    "latitude": 45.684907,
    "longitude": -122.66187,
    "original_address": "1016 Ne 86th St",
    "building_number": 1016,
    "street": "NE 86th St",
    "city": "Vancouver",
    "zip": 98665,
    "concatenated_address": "1016 NE 86th St, Vancouver",
    "address": "1016 N.E. 86th St., Vancouver"
  },
  {
    "id": 1824,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Wingate Square Apartments",
    "latitude": 45.678371,
    "longitude": -122.57333,
    "original_address": "9700 Ne 76th St",
    "building_number": 9700,
    "street": "NE 76th St",
    "city": "Vancouver",
    "zip": 98662,
    "concatenated_address": "9700 NE 76th St, Vancouver",
    "address": "9700 N.E. 76th St., Vancouver"
  },
  {
    "id": 1825,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "T Street Apartments",
    "latitude": 45.638951,
    "longitude": -122.6493,
    "original_address": "2008 East Fourth Plain Blvd",
    "building_number": 2008,
    "street": "E 4th Plain Blvd",
    "city": "Vancouver",
    "zip": 98661,
    "concatenated_address": "2008 E 4th Plain Blvd, Vancouver",
    "address": "2008 E. 4th Plain Blvd., Vancouver"
  },
  {
    "id": 1826,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Garden View Apartments",
    "latitude": 45.621902,
    "longitude": -122.56755,
    "original_address": "117 Northeast 102nd Avenue",
    "building_number": 117,
    "street": "NE 102nd Ave",
    "city": "Vancouver",
    "zip": 98664,
    "concatenated_address": "117 NE 102nd Ave, Vancouver",
    "address": "117 N.E. 102nd Ave., Vancouver"
  },
  {
    "id": 1827,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Vancouver Pointe Senior Village",
    "latitude": 45.655524,
    "longitude": -122.6038,
    "original_address": "4555 Ne 66th Avenue",
    "building_number": 4555,
    "street": "NE 66th Ave",
    "city": "Vancouver",
    "zip": 98661,
    "concatenated_address": "4555 NE 66th Ave, Vancouver",
    "address": "4555 N.E. 66th Ave., Vancouver"
  },
  {
    "id": 1828,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Evergreen Non Profit Housing",
    "latitude": 45.639775,
    "longitude": -122.67309,
    "original_address": "2509 Columbia Street",
    "building_number": 2509,
    "street": "Columbia St",
    "city": "Vancouver",
    "zip": 98660,
    "concatenated_address": "2509 Columbia St, Vancouver",
    "address": "2509 Columbia St., Vancouver"
  },
  {
    "id": 1829,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Evergreen Village Apartments",
    "latitude": 45.641106,
    "longitude": -122.52993,
    "original_address": "2501 Northeast 138th Avenue",
    "building_number": 2501,
    "street": "NE 138th Ave",
    "city": "Vancouver",
    "zip": 98684,
    "concatenated_address": "2501 NE 138th Ave, Vancouver",
    "address": "2501 N.E. 138th Ave., Vancouver"
  },
  {
    "id": 1830,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Prairie View Apartments",
    "latitude": 45.692465,
    "longitude": -122.54191,
    "original_address": "12611 Northeast 99th Street",
    "building_number": 12611,
    "street": "NE 99th St",
    "city": "Vancouver",
    "zip": 98682,
    "concatenated_address": "12611 NE 99th St, Vancouver",
    "address": "12611 N.E. 99th St., Vancouver"
  },
  {
    "id": 1831,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Covington Townhomes",
    "latitude": 45.675614,
    "longitude": -122.5748,
    "original_address": "9402 Ne 73rd Circle",
    "building_number": 9402,
    "street": "NE 73rd Cir",
    "city": "Vancouver",
    "zip": 98662,
    "concatenated_address": "9402 NE 73rd Cir, Vancouver",
    "address": "9402 N.E. 73rd Cir, Vancouver"
  },
  {
    "id": 1832,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Nobl Park",
    "latitude": 45.665917,
    "longitude": -122.56723,
    "original_address": "6001 Ne 102nd Avenue",
    "building_number": 6001,
    "street": "NE 102nd Ave",
    "city": "Vancouver",
    "zip": 98662,
    "concatenated_address": "6001 NE 102nd Ave, Vancouver",
    "address": "6001 N.E. 102nd Ave., Vancouver"
  },
  {
    "id": 1833,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Crown Plaza Apartments",
    "latitude": 45.694548,
    "longitude": -122.66236,
    "original_address": "10117 Ne 9th Avenue",
    "building_number": 10117,
    "street": "NE 9th Ave",
    "city": "Vancouver",
    "zip": 98685,
    "concatenated_address": "10117 NE 9th Ave, Vancouver",
    "address": "10117 N.E. 9th Ave., Vancouver"
  },
  {
    "id": 1834,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Parc Central",
    "latitude": 45.639794,
    "longitude": -122.65087,
    "original_address": "2600 T Street",
    "building_number": 2600,
    "street": "T St",
    "city": "Vancouver",
    "zip": 98661,
    "concatenated_address": "2600 T St, Vancouver",
    "address": "2600 T St., Vancouver"
  },
  {
    "id": 1835,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Rolling Creek Apartments",
    "latitude": 45.675006,
    "longitude": -122.65873,
    "original_address": "7301 Ne 13Th Avenue",
    "building_number": 7301,
    "street": "NE 13th Ave",
    "city": "Vancouver",
    "zip": 98665,
    "concatenated_address": "7301 NE 13th Ave, Vancouver",
    "address": "7301 N.E. 13th Ave., Vancouver"
  },
  {
    "id": 1836,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Block 88 Townhomes",
    "latitude": 45.686493,
    "longitude": -122.65844,
    "original_address": "1304 Ne 88th Street",
    "building_number": 1304,
    "street": "NE 88th St",
    "city": "Vancouver",
    "zip": 98665,
    "concatenated_address": "1304 NE 88th St, Vancouver",
    "address": "1304 N.E. 88th St., Vancouver"
  },
  {
    "id": 1837,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Arbor Ridge Assited Living",
    "latitude": 45.690377,
    "longitude": -122.66745,
    "original_address": "9501 Hazel Dell Avenue",
    "building_number": 9501,
    "street": "NE Hazel Dell Ave",
    "city": "Vancouver",
    "zip": 98665,
    "concatenated_address": "9501 NE Hazel Dell Ave, Vancouver",
    "address": "9501 N.E. Hazel Dell Ave., Vancouver"
  },
  {
    "id": 1838,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Prestige Discovery Nursing & Rehab",
    "latitude": 45.65999,
    "longitude": -122.66889,
    "original_address": "5220 Ne Hazel Dell Avenue",
    "building_number": 5220,
    "street": "NE Hazel Dell Ave",
    "city": "Vancouver",
    "zip": 98663,
    "concatenated_address": "5220 NE Hazel Dell Ave, Vancouver",
    "address": "5220 N.E. Hazel Dell Ave., Vancouver"
  },
  {
    "id": 1839,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Atherton Woods Apartments",
    "latitude": 45.65715,
    "longitude": -122.59774,
    "original_address": "4719 Ne 72nd Avenue",
    "building_number": 4719,
    "street": "NE 72nd Ave",
    "city": "Vancouver",
    "zip": 98661,
    "concatenated_address": "4719 NE 72nd Ave, Vancouver",
    "address": "4719 N.E. 72nd Ave., Vancouver"
  },
  {
    "id": 1840,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Knights Of Pythias Care Center",
    "latitude": 45.646517,
    "longitude": -122.66755,
    "original_address": "3409 Main Street",
    "building_number": 3409,
    "street": "Main St",
    "city": "Vancouver",
    "zip": 98663,
    "concatenated_address": "3409 Main St, Vancouver",
    "address": "3409 Main St., Vancouver"
  },
  {
    "id": 1841,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Vashon Community Care Center",
    "latitude": 47.467308,
    "longitude": -122.46138,
    "original_address": "15333 Vashon Hwy Sw",
    "building_number": 15333,
    "street": "Vashon Hwy SW",
    "city": "Vashon",
    "zip": 98070,
    "concatenated_address": "15333 Vashon Hwy SW, Vashon",
    "address": "15333 Vashon Highway S.W., Vashon"
  },
  {
    "id": 1842,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Affinity At Vancouver",
    "latitude": 45.658995,
    "longitude": -122.55798,
    "original_address": "Ne 112th Avenue And Ne 51st Ci",
    "building_number": "",
    "street": "NE 112th Ave",
    "city": "Vancouver",
    "zip": 98682,
    "concatenated_address": "Ne 112th Avenue And Ne 51st Ci, Vancouver",
    "address": "N.E. 112th Avenue And N.E. 51st Ci, Vancouver"
  },
  {
    "id": 1843,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Wheatland Village",
    "latitude": 46.054254,
    "longitude": -118.32685,
    "original_address": "1500 Catherine Street",
    "building_number": 1500,
    "street": "Catherine St",
    "city": "Walla Walla",
    "zip": 99362,
    "concatenated_address": "1500 Catherine St, Walla Walla",
    "address": "1500 Catherine St., Walla Walla"
  },
  {
    "id": 1844,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Cottages At Sunset Lodge",
    "latitude": 46.047604,
    "longitude": -118.33759,
    "original_address": "202 Chinook Loopmultiple Addresses",
    "building_number": 202,
    "street": "Chinook Loop",
    "city": "Walla Walla",
    "zip": 99362,
    "concatenated_address": "202 Chinook Loop, Walla Walla",
    "address": "202 Chinook Loop, Walla Walla"
  },
  {
    "id": 1845,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Brookhaven Apartments",
    "latitude": 46.056593,
    "longitude": -118.33055,
    "original_address": "130 Bryant Avenue",
    "building_number": 130,
    "street": "Bryant Ave",
    "city": "Walla Walla",
    "zip": 99362,
    "concatenated_address": "130 Bryant Ave, Walla Walla",
    "address": "130 Bryant Ave., Walla Walla"
  },
  {
    "id": 1846,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Park Plaza",
    "latitude": 46.046505,
    "longitude": -118.35773,
    "original_address": "1400 Dalles Military Road",
    "building_number": 1400,
    "street": "Dalles Military Rd",
    "city": "Walla Walla",
    "zip": 99362,
    "concatenated_address": "1400 Dalles Military Rd, Walla Walla",
    "address": "1400 Dalles Military Road, Walla Walla"
  },
  {
    "id": 1847,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Affinity At Walla Walla",
    "latitude": 46.04806,
    "longitude": -118.34937,
    "original_address": "1706 Fairway Drive",
    "building_number": 1706,
    "street": "Fairway Dr",
    "city": "Walla Walla",
    "zip": 99362,
    "concatenated_address": "1706 Fairway Dr, Walla Walla",
    "address": "1706 Fairway Drive, Walla Walla"
  },
  {
    "id": 1848,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Brookdale Walla Walla",
    "latitude": 46.047074,
    "longitude": -118.35643,
    "original_address": "1460 Dalles Military Road",
    "building_number": 1460,
    "street": "Dalles Military Rd",
    "city": "Walla Walla",
    "zip": 99362,
    "concatenated_address": "1460 Dalles Military Rd, Walla Walla",
    "address": "1460 Dalles Military Road, Walla Walla"
  },
  {
    "id": 1849,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Stonecreek Apartments",
    "latitude": 46.045296,
    "longitude": -118.34576,
    "original_address": "1821 Plaza Way",
    "building_number": 1821,
    "street": "Plaza Way",
    "city": "Walla Walla",
    "zip": 99362,
    "concatenated_address": "1821 Plaza Way, Walla Walla",
    "address": "1821 Plaza Way, Walla Walla"
  },
  {
    "id": 1850,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Emerald Care",
    "latitude": 46.449253,
    "longitude": -120.42673,
    "original_address": "209 Ahtanum Ave.",
    "building_number": 209,
    "street": "N Ahtanum Ave",
    "city": "Wapato",
    "zip": 98951,
    "concatenated_address": "209 N Ahtanum Ave, Wapato",
    "address": "209 N. Ahtanum Ave., Wapato"
  },
  {
    "id": 1851,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Lookout Ridge",
    "latitude": 45.592996,
    "longitude": -122.37504,
    "original_address": "232 West Lookout Ridge Drive",
    "building_number": 232,
    "street": "W Lookout Ridge Dr",
    "city": "Washougal",
    "zip": 98671,
    "concatenated_address": "232 W Lookout Ridge Dr, Washougal",
    "address": "232 W. Lookout Ridge Drive, Washougal"
  },
  {
    "id": 1852,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Lookout Ridge Townhomes",
    "latitude": 45.593538,
    "longitude": -122.37464,
    "original_address": "147-643 West Lookout Ridge Dri",
    "building_number": 147,
    "street": "W Lookout Ridge Dr",
    "city": "Washougal",
    "zip": 98671,
    "concatenated_address": "147 W Lookout Ridge Dr, Washougal",
    "address": "147 W. Lookout Ridge Drive, Washougal"
  },
  {
    "id": 1853,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Columbia Ridge Assisted Living",
    "latitude": 45.579202,
    "longitude": -122.35179,
    "original_address": "2300 W. 19th Street",
    "building_number": "",
    "street": "19th St",
    "city": "Washougal",
    "zip": 98671,
    "concatenated_address": "2300 W. 19th Street, Washougal",
    "address": "2300 W. 19th St., Washougal"
  },
  {
    "id": 1854,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Highgate Senior Living - Wenatchee",
    "latitude": 47.405189,
    "longitude": -120.32508,
    "original_address": "1320 South Miller Street",
    "building_number": 1320,
    "street": "S Miller St",
    "city": "Wenatchee",
    "zip": 98801,
    "concatenated_address": "1320 S Miller St, Wenatchee",
    "address": "1320 S. Miller St., Wenatchee"
  },
  {
    "id": 1855,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Riverside 9 Apartment Homes",
    "latitude": 47.436938,
    "longitude": -120.31479,
    "original_address": "895 Riverside Drive",
    "building_number": 895,
    "street": "Riverside Dr",
    "city": "Wenatchee",
    "zip": 98801,
    "concatenated_address": "895 Riverside Dr, Wenatchee",
    "address": "895 Riverside Drive, Wenatchee"
  },
  {
    "id": 1856,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Avamere At Wenatchee",
    "latitude": 47.416789,
    "longitude": -120.34058,
    "original_address": "1550 Cherry Street",
    "building_number": 1550,
    "street": "Cherry St",
    "city": "Wenatchee",
    "zip": 98801,
    "concatenated_address": "1550 Cherry St, Wenatchee",
    "address": "1550 Cherry St., Wenatchee"
  },
  {
    "id": 1857,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Park View Apartments",
    "latitude": 47.439899,
    "longitude": -120.33073,
    "original_address": "1250 Central Avenue",
    "building_number": 1250,
    "street": "Central Ave",
    "city": "Wenatchee",
    "zip": 98801,
    "concatenated_address": "1250 Central Ave, Wenatchee",
    "address": "1250 Central Ave., Wenatchee"
  },
  {
    "id": 1858,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Cedarwood Apartments",
    "latitude": 47.439578,
    "longitude": -120.33687,
    "original_address": "1400 Central Ave",
    "building_number": 1400,
    "street": "Central Ave",
    "city": "Wenatchee",
    "zip": 98801,
    "concatenated_address": "1400 Central Ave, Wenatchee",
    "address": "1400 Central Ave., Wenatchee"
  },
  {
    "id": 1859,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Blossom Valley",
    "latitude": 47.425561,
    "longitude": -120.34468,
    "original_address": "1701 Orchard Avenue",
    "building_number": 1701,
    "street": "Orchard Ave",
    "city": "Wenatchee",
    "zip": 98801,
    "concatenated_address": "1701 Orchard Ave, Wenatchee",
    "address": "1701 Orchard Ave., Wenatchee"
  },
  {
    "id": 1860,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Blossom Creek",
    "latitude": 47.425067,
    "longitude": -120.34512,
    "original_address": "1740 Madison Street",
    "building_number": 1740,
    "street": "Madison St",
    "city": "Wenatchee",
    "zip": 98801,
    "concatenated_address": "1740 Madison St, Wenatchee",
    "address": "1740 Madison St., Wenatchee"
  },
  {
    "id": 1861,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Willow Tree Apartments",
    "latitude": 47.419771,
    "longitude": -120.32026,
    "original_address": "801 Idaho Street",
    "building_number": 801,
    "street": "Idaho St",
    "city": "Wenatchee",
    "zip": 98801,
    "concatenated_address": "801 Idaho St, Wenatchee",
    "address": "801 Idaho St., Wenatchee"
  },
  {
    "id": 1862,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Garden Terrace/Garden Terrace",
    "latitude": 47.430111,
    "longitude": -120.32215,
    "original_address": "500 N Emerson Avenue",
    "building_number": 500,
    "street": "N Emerson Ave",
    "city": "Wenatchee",
    "zip": 96801,
    "concatenated_address": "500 N Emerson Ave, Wenatchee",
    "address": "500 N. Emerson Ave., Wenatchee"
  },
  {
    "id": 1863,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Quail Springs",
    "latitude": 46.25802,
    "longitude": -119.34328,
    "original_address": "4711 Dallas Road",
    "building_number": 4711,
    "street": "Dallas Rd",
    "city": "West Richland",
    "zip": 99353,
    "concatenated_address": "4711 Dallas Rd, West Richland",
    "address": "4711 Dallas Road, West Richland"
  },
  {
    "id": 1864,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Beaumont Apartments",
    "latitude": 47.740741,
    "longitude": -122.09087,
    "original_address": "14001 14120 & 14170 Northeast 183rd Street18245 142nd Ave Ne",
    "building_number": "",
    "street": "",
    "city": "Woodinville",
    "zip": 98072,
    "concatenated_address": "14001 14120 & 14170 Northeast 183rd Street18245 142nd Ave Ne, Woodinville",
    "address": "14001, 14120 & 14170 N.E. 183rd St., 18245 142nd Ave. N.E., Woodinville"
  },
  {
    "id": 1865,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Campbell Run",
    "latitude": 47.748788,
    "longitude": -122.16163,
    "original_address": "13305 Ne 171st Street",
    "building_number": 13305,
    "street": "NE 171st St",
    "city": "Woodinville",
    "zip": 98072,
    "concatenated_address": "13305 NE 171st St, Woodinville",
    "address": "13305 N.E. 171st St., Woodinville"
  },
  {
    "id": 1866,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Beaumont Apartments",
    "latitude": 47.740741,
    "longitude": -122.09087,
    "original_address": "14001 14120 & 14170 Northeast 183rd Street 18245 142nd Avenue Ne",
    "building_number": "",
    "street": "",
    "city": "Woodinville",
    "zip": 98072,
    "concatenated_address": "14001 14120 & 14170 Northeast 183rd Street 18245 142nd Avenue Ne, Woodinville",
    "address": "14001 14120 & 14170 Northeast 183rd St. 18245 142nd Avenue Ne, Woodinville"
  },
  {
    "id": 1867,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Chateau Woods Apartments",
    "latitude": 47.760409,
    "longitude": -122.14855,
    "original_address": "18250 142nd Avenue Ne",
    "building_number": 18250,
    "street": "142nd Ave NE",
    "city": "Woodinville",
    "zip": 98072,
    "concatenated_address": "18250 142nd Ave NE, Woodinville",
    "address": "18250 142nd Ave. N.E., Woodinville"
  },
  {
    "id": 1868,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Woodin Creek Village",
    "latitude": 47.752652,
    "longitude": -122.15909,
    "original_address": "17300 135th Avenue Ne",
    "building_number": 17300,
    "street": "135th Ave NE",
    "city": "Woodinville",
    "zip": 98072,
    "concatenated_address": "17300 135th Ave NE, Woodinville",
    "address": "17300 135th Ave. N.E., Woodinville"
  },
  {
    "id": 1869,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "14110 Northeast 179th Street",
    "latitude": 47.757762,
    "longitude": -122.15015,
    "original_address": "14110 Northeast 179th Street",
    "building_number": 14110,
    "street": "NE 179th St",
    "city": "Woodinville",
    "zip": 98072,
    "concatenated_address": "14110 NE 179th St, Woodinville",
    "address": "14110 N.E. 179th St., Woodinville"
  },
  {
    "id": 1870,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Jefferson Place Apartments",
    "latitude": 45.912067,
    "longitude": -122.74234,
    "original_address": "1473 N. Goerig Street",
    "building_number": 1473,
    "street": "N Goerig St",
    "city": "Woodland",
    "zip": 98674,
    "concatenated_address": "1473 N Goerig St, Woodland",
    "address": "1473 N. Goerig St., Woodland"
  },
  {
    "id": 1871,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Woodland East Community",
    "latitude": 45.926421,
    "longitude": -122.7313,
    "original_address": "369 Gun Club Road",
    "building_number": 369,
    "street": "Gun Club Rd",
    "city": "Woodland",
    "zip": 98674,
    "concatenated_address": "369 Gun Club Rd, Woodland",
    "address": "369 Gun Club Road, Woodland"
  },
  {
    "id": 1872,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Englewood Garden Apartments",
    "latitude": 46.609989,
    "longitude": -120.55646,
    "original_address": "3601 Fairbanks Avenue",
    "building_number": 3601,
    "street": "Fairbanks Ave",
    "city": "Yakima",
    "zip": 98902,
    "concatenated_address": "3601 Fairbanks Ave, Yakima",
    "address": "3601 Fairbanks Ave., Yakima"
  },
  {
    "id": 1873,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Highgate Senior Living - Yakima",
    "latitude": 46.596806,
    "longitude": -120.584,
    "original_address": "5605 West Chestnut Avenue",
    "building_number": 5605,
    "street": "W Chestnut Ave",
    "city": "Yakima",
    "zip": 98908,
    "concatenated_address": "5605 W Chestnut Ave, Yakima",
    "address": "5605 W. Chestnut Ave., Yakima"
  },
  {
    "id": 1874,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "El Rey Apartments",
    "latitude": 46.586378,
    "longitude": -120.54577,
    "original_address": "2705 West Nob Hill Boulevard",
    "building_number": 2705,
    "street": "W Nob Hill Blvd",
    "city": "Yakima",
    "zip": 98902,
    "concatenated_address": "2705 W Nob Hill Blvd, Yakima",
    "address": "2705 W. Nob Hill Blvd., Yakima"
  },
  {
    "id": 1875,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Skyline MHC",
    "latitude": 46.618326,
    "longitude": -120.47093,
    "original_address": "2205 Butterfield Road",
    "building_number": 2205,
    "street": "Butterfield Rd",
    "city": "Yakima",
    "zip": 98901,
    "concatenated_address": "2205 Butterfield Rd, Yakima",
    "address": "2205 Butterfield Road, Yakima"
  },
  {
    "id": 1876,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Whispering Pines MHC",
    "latitude": 46.615294,
    "longitude": -120.55284,
    "original_address": "1011 N 34th Ave",
    "building_number": 1011,
    "street": "N 34th Ave",
    "city": "Yakima",
    "zip": 98902,
    "concatenated_address": "1011 N 34th Ave, Yakima",
    "address": "1011 N. 34th Ave., Yakima"
  },
  {
    "id": 1877,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Blossom Place",
    "latitude": 46.584773,
    "longitude": -120.57551,
    "original_address": "5100 W. Nob Hill Blvd.",
    "building_number": 5100,
    "street": "W Nob Hill Blvd",
    "city": "Yakima",
    "zip": 98908,
    "concatenated_address": "5100 W Nob Hill Blvd, Yakima",
    "address": "5100 W. Nob Hill Blvd., Yakima"
  },
  {
    "id": 1878,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Broadmoor Mobile Home Park",
    "latitude": 46.572524,
    "longitude": -120.50367,
    "original_address": "55 West Washington Avenue",
    "building_number": 55,
    "street": "W Washington Ave",
    "city": "Yakima",
    "zip": 98903,
    "concatenated_address": "55 W Washington Ave, Yakima",
    "address": "55 W. Washington Ave., Yakima"
  },
  {
    "id": 1879,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Castle Creek Apartments",
    "latitude": 46.58384,
    "longitude": -120.57649,
    "original_address": "5200 West Nob Hill Boulevard",
    "building_number": 5200,
    "street": "W Nob Hill Blvd",
    "city": "Yakima",
    "zip": 98908,
    "concatenated_address": "5200 W Nob Hill Blvd, Yakima",
    "address": "5200 W. Nob Hill Blvd., Yakima"
  },
  {
    "id": 1880,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Sun Meadows Estates MHC",
    "latitude": 46.571852,
    "longitude": -120.52718,
    "original_address": "1201 West Washington Avenue",
    "building_number": 1201,
    "street": "W Washington Ave",
    "city": "Yakima",
    "zip": 98903,
    "concatenated_address": "1201 W Washington Ave, Yakima",
    "address": "1201 W. Washington Ave., Yakima"
  },
  {
    "id": 1881,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Elmcroft Of Chesterley",
    "latitude": 46.6162,
    "longitude": -120.55628,
    "original_address": "1100 North 35th Avenue",
    "building_number": 1100,
    "street": "N 35th Ave",
    "city": "Yakima",
    "zip": 98902,
    "concatenated_address": "1100 N 35th Ave, Yakima",
    "address": "1100 N. 35th Ave., Yakima"
  },
  {
    "id": 1882,
    "financing": "Financed with a Freddie Mac-guaranteed loan",
    "building_name": "Meadowbrook MHC",
    "latitude": 46.583929,
    "longitude": -120.61339,
    "original_address": "7610 West Nob Hill Boulevard",
    "building_number": 7610,
    "street": "W Nob Hill Blvd",
    "city": "Yakima",
    "zip": 98908,
    "concatenated_address": "7610 W Nob Hill Blvd, Yakima",
    "address": "7610 W. Nob Hill Blvd., Yakima"
  },
  {
    "id": 1883,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Mabel Swan Manor",
    "latitude": 46.598617,
    "longitude": -120.52031,
    "original_address": "10 South 8 Ave",
    "building_number": 10,
    "street": "S 8th Ave",
    "city": "Yakima",
    "zip": 98902,
    "concatenated_address": "10 S 8th Ave, Yakima",
    "address": "10 S. 8th Ave., Yakima"
  },
  {
    "id": 1884,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Providence House Yakima",
    "latitude": 46.607975,
    "longitude": -120.50431,
    "original_address": "312 N Fourth Street",
    "building_number": 312,
    "street": "N 4th St",
    "city": "Yakima",
    "zip": 98901,
    "concatenated_address": "312 N 4th St, Yakima",
    "address": "312 N. 4th St., Yakima"
  },
  {
    "id": 1885,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Cornerstone Apartments",
    "latitude": 46.582984,
    "longitude": -120.60574,
    "original_address": "1210 South 72nd Avenue",
    "building_number": 1210,
    "street": "S 72nd Ave",
    "city": "Yakima",
    "zip": 98908,
    "concatenated_address": "1210 S 72nd Ave, Yakima",
    "address": "1210 S. 72nd Ave., Yakima"
  },
  {
    "id": 1886,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Chandler House",
    "latitude": 46.609157,
    "longitude": -120.55967,
    "original_address": "701 N. 39th Street",
    "building_number": 701,
    "street": "N 39th Ave",
    "city": "Yakima",
    "zip": 98902,
    "concatenated_address": "701 N 39th Ave, Yakima",
    "address": "701 N. 39th Ave., Yakima"
  },
  {
    "id": 1887,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Good Samaritan Health Care Cen",
    "latitude": 46.609376,
    "longitude": -120.53147,
    "original_address": "702 N 16th Avenue",
    "building_number": 702,
    "street": "N 16th Ave",
    "city": "Yakima",
    "zip": 98902,
    "concatenated_address": "702 N 16th Ave, Yakima",
    "address": "702 N. 16th Ave., Yakima"
  },
  {
    "id": 1888,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Crescent Convalescent Center",
    "latitude": 46.605662,
    "longitude": -120.56037,
    "original_address": "505 North 40th Avenue",
    "building_number": 505,
    "street": "N 40th Ave",
    "city": "Yakima",
    "zip": 98908,
    "concatenated_address": "505 N 40th Ave, Yakima",
    "address": "505 N. 40th Ave., Yakima"
  },
  {
    "id": 1889,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Parkside Care Center",
    "latitude": 46.552466,
    "longitude": -120.47987,
    "original_address": "308 West Emma Street",
    "building_number": 308,
    "street": "W Emma St",
    "city": "Yakima",
    "zip": 98903,
    "concatenated_address": "308 W Emma St, Yakima",
    "address": "308 W. Emma St., Yakima"
  },
  {
    "id": 1890,
    "financing": "Financed with an FHA-insured loan",
    "building_name": "Landmark Care Center",
    "latitude": 46.609675,
    "longitude": -120.56101,
    "original_address": "710 North 39th Street",
    "building_number": 710,
    "street": "N 39th Ave",
    "city": "Yakima",
    "zip": 98908,
    "concatenated_address": "710 N 39th Ave, Yakima",
    "address": "710 N. 39th Ave., Yakima"
  },
  {
    "id": 1891,
    "financing": "Financed with a Fannie Mae-guaranteed loan",
    "building_name": "Tustin Apartment Homes",
    "latitude": 46.935008,
    "longitude": -122.58778,
    "original_address": "10520 Creek Street Se",
    "building_number": 10520,
    "street": "Creek St SE",
    "city": "Yelm",
    "zip": 98597,
    "concatenated_address": "10520 Creek St SE, Yelm",
    "address": "10520 Creek St. S.E., Yelm"
  },
  {
    "id": 1892,
    "financing": "Federally subsidized",
    "building_name": "1 South Madelia",
    "latitude": 47.656898,
    "longitude": -117.38545,
    "original_address": "1 South Madelia",
    "building_number": 1,
    "street": "S Madelia St",
    "city": "Spokane",
    "zip": 99202,
    "concatenated_address": "1 S Madelia St, Spokane",
    "address": "1 S. Madelia St., Spokane"
  },
  {
    "id": 1893,
    "financing": "Federally subsidized",
    "building_name": "103 Pennsylvania Avenue",
    "latitude": 47.223408,
    "longitude": -120.99279,
    "original_address": "103 E Pennsylvania Ave",
    "building_number": 103,
    "street": "E Pennsylvania Ave",
    "city": "Roslyn",
    "zip": 98941,
    "concatenated_address": "103 E Pennsylvania Ave, Roslyn",
    "address": "103 E. Pennsylvania Ave., Roslyn"
  },
  {
    "id": 1894,
    "financing": "Federally subsidized",
    "building_name": "118 McArthur Street",
    "latitude": 46.856895,
    "longitude": -122.85701,
    "original_address": "118 Mcarthur Street N",
    "building_number": 118,
    "street": "McArthur St N",
    "city": "Tenino",
    "zip": 98589,
    "concatenated_address": "118 McArthur St N, Tenino",
    "address": "118 McArthur St. N., Tenino"
  },
  {
    "id": 1895,
    "financing": "Federally subsidized",
    "building_name": "12th Avenue Arts",
    "latitude": 47.616028,
    "longitude": -122.31653,
    "original_address": "1660 - 12th Avenue",
    "building_number": 1660,
    "street": "12th Ave",
    "city": "Seattle",
    "zip": 98122,
    "concatenated_address": "1660 12th Ave, Seattle",
    "address": "1660 12th Ave., Seattle"
  },
  {
    "id": 1896,
    "financing": "Federally subsidized",
    "building_name": "13 West Apartments",
    "latitude": 45.631663,
    "longitude": -122.67415,
    "original_address": "1300 W. Columbia Street",
    "building_number": 1300,
    "street": "Columbia St",
    "city": "Vancouver",
    "zip": 98660,
    "concatenated_address": "1300 Columbia St, Vancouver",
    "address": "1300 Columbia St., Vancouver"
  },
  {
    "id": 1897,
    "financing": "Federally subsidized",
    "building_name": "13405 97th Avenue Northwest",
    "latitude": 47.379719,
    "longitude": -122.66897,
    "original_address": "13405 97th Avenue Nw",
    "building_number": 13405,
    "street": "97th Ave NW",
    "city": "Gig Harbor",
    "zip": 98329,
    "concatenated_address": "13405 97th Ave NW, Gig Harbor",
    "address": "13405 97th Ave. N.W., Gig Harbor"
  },
  {
    "id": 1898,
    "financing": "Federally subsidized",
    "building_name": "1400 Market Street",
    "latitude": 47.249949,
    "longitude": -122.44105,
    "original_address": "1400 Market St",
    "building_number": 1400,
    "street": "Market St",
    "city": "Tacoma",
    "zip": 98402,
    "concatenated_address": "1400 Market St, Tacoma",
    "address": "1400 Market St., Tacoma"
  },
  {
    "id": 1899,
    "financing": "Federally subsidized",
    "building_name": "14002 Linden Avenue North",
    "latitude": 47.730736,
    "longitude": -122.34723,
    "original_address": "14002 Linden Avenue N",
    "building_number": 14002,
    "street": "Linden Ave N",
    "city": "Seattle",
    "zip": 98133,
    "concatenated_address": "14002 Linden Ave N, Seattle",
    "address": "14002 Linden Ave. N., Seattle"
  },
  {
    "id": 1900,
    "financing": "Federally subsidized",
    "building_name": "1443 East Craig Street",
    "latitude": 47.17789,
    "longitude": -119.32723,
    "original_address": "1443 E Craig St",
    "building_number": 1443,
    "street": "E Craig St",
    "city": "Moses Lake",
    "zip": 98837,
    "concatenated_address": "1443 E Craig St, Moses Lake",
    "address": "1443 E. Craig St., Moses Lake"
  },
  {
    "id": 1901,
    "financing": "Federally subsidized",
    "building_name": "15 West Apartments",
    "latitude": 45.632182,
    "longitude": -122.66777,
    "original_address": "400 W. Mill Plain Blvd.",
    "building_number": 400,
    "street": "E Mill Plain Blvd",
    "city": "Vancouver",
    "zip": 98660,
    "concatenated_address": "400 E Mill Plain Blvd, Vancouver",
    "address": "400 E. Mill Plain Blvd., Vancouver"
  },
  {
    "id": 1902,
    "financing": "Federally subsidized",
    "building_name": "1615 20th Avenue",
    "latitude": 46.142686,
    "longitude": -122.94287,
    "original_address": "1615 20th Ave",
    "building_number": 1615,
    "street": "20th Ave",
    "city": "Longview",
    "zip": 98632,
    "concatenated_address": "1615 20th Ave, Longview",
    "address": "1615 20th Ave., Longview"
  },
  {
    "id": 1903,
    "financing": "Federally subsidized",
    "building_name": "1710 Texas Street Project",
    "latitude": 48.761466,
    "longitude": -122.45165,
    "original_address": "1710 Texas St",
    "building_number": 1710,
    "street": "Texas St",
    "city": "Bellingham",
    "zip": 98229,
    "concatenated_address": "1710 Texas St, Bellingham",
    "address": "1710 Texas St., Bellingham"
  },
  {
    "id": 1904,
    "financing": "Federally subsidized",
    "building_name": "1720 Texas Street Project",
    "latitude": 48.761083,
    "longitude": -122.45159,
    "original_address": "1720 Texas St",
    "building_number": 1720,
    "street": "Texas St",
    "city": "Bellingham",
    "zip": 98229,
    "concatenated_address": "1720 Texas St, Bellingham",
    "address": "1720 Texas St., Bellingham"
  },
  {
    "id": 1905,
    "financing": "Federally subsidized",
    "building_name": "1730 Texas Street Project",
    "latitude": 48.761067,
    "longitude": -122.4512,
    "original_address": "1730 Texas St",
    "building_number": 1730,
    "street": "Texas St",
    "city": "Bellingham",
    "zip": 98229,
    "concatenated_address": "1730 Texas St, Bellingham",
    "address": "1730 Texas St., Bellingham"
  },
  {
    "id": 1906,
    "financing": "Federally subsidized",
    "building_name": "1740 Texas Street Project",
    "latitude": 48.761431,
    "longitude": -122.45111,
    "original_address": "1740 Texas St",
    "building_number": 1740,
    "street": "Texas St",
    "city": "Bellingham",
    "zip": 98229,
    "concatenated_address": "1740 Texas St, Bellingham",
    "address": "1740 Texas St., Bellingham"
  },
  {
    "id": 1907,
    "financing": "Federally subsidized",
    "building_name": "1811 Eastlake Supportive Housing",
    "latitude": 47.61824,
    "longitude": -122.32949,
    "original_address": "1811 Eastlake Ave",
    "building_number": 1811,
    "street": "Eastlake Ave",
    "city": "Seattle",
    "zip": 98101,
    "concatenated_address": "1811 Eastlake Ave, Seattle",
    "address": "1811 Eastlake Ave., Seattle"
  },
  {
    "id": 1908,
    "financing": "Federally subsidized",
    "building_name": "1835 8th Avenue",
    "latitude": 47.614585,
    "longitude": -122.33527,
    "original_address": "1835 Eighth Ave",
    "building_number": 1835,
    "street": "8th Ave",
    "city": "Seattle",
    "zip": 98101,
    "concatenated_address": "1835 8th Ave, Seattle",
    "address": "1835 8th Ave., Seattle"
  },
  {
    "id": 1909,
    "financing": "Federally subsidized",
    "building_name": "2130 Texas Street",
    "latitude": 48.761542,
    "longitude": -122.44588,
    "original_address": "2130 Texas St",
    "building_number": 2130,
    "street": "Texas St",
    "city": "Bellingham",
    "zip": 98229,
    "concatenated_address": "2130 Texas St, Bellingham",
    "address": "2130 Texas St., Bellingham"
  },
  {
    "id": 1910,
    "financing": "Federally subsidized",
    "building_name": "2150 Texas Street",
    "latitude": 48.761435,
    "longitude": -122.44561,
    "original_address": "2150 Texas St",
    "building_number": 2150,
    "street": "Texas St",
    "city": "Bellingham",
    "zip": 98229,
    "concatenated_address": "2150 Texas St, Bellingham",
    "address": "2150 Texas St., Bellingham"
  },
  {
    "id": 1911,
    "financing": "Federally subsidized",
    "building_name": "2301 Second Avenue",
    "latitude": 47.613961,
    "longitude": -122.34609,
    "original_address": "2301 Second Ave",
    "building_number": 2301,
    "street": "2nd Ave",
    "city": "Seattle",
    "zip": 98121,
    "concatenated_address": "2301 2nd Ave, Seattle",
    "address": "2301 2nd Ave., Seattle"
  },
  {
    "id": 1912,
    "financing": "Federally subsidized",
    "building_name": "2316 Valencia Street Apartments",
    "latitude": 48.760943,
    "longitude": -122.44632,
    "original_address": "2316 Valencia St",
    "building_number": 2316,
    "street": "Valencia St",
    "city": "Bellingham",
    "zip": 98229,
    "concatenated_address": "2316 Valencia St, Bellingham",
    "address": "2316 Valencia St., Bellingham"
  },
  {
    "id": 1913,
    "financing": "Federally subsidized",
    "building_name": "2320 Valencia Street Apartments",
    "latitude": 48.761131,
    "longitude": -122.44632,
    "original_address": "2320 Valencia St",
    "building_number": 2320,
    "street": "Valencia St",
    "city": "Bellingham",
    "zip": 98229,
    "concatenated_address": "2320 Valencia St, Bellingham",
    "address": "2320 Valencia St., Bellingham"
  },
  {
    "id": 1914,
    "financing": "Federally subsidized",
    "building_name": "2324 Valencia Street Apartments",
    "latitude": 48.761316,
    "longitude": -122.44632,
    "original_address": "2324 Valencia St",
    "building_number": 2324,
    "street": "Valencia St",
    "city": "Bellingham",
    "zip": 98229,
    "concatenated_address": "2324 Valencia St, Bellingham",
    "address": "2324 Valencia St., Bellingham"
  },
  {
    "id": 1915,
    "financing": "Federally subsidized",
    "building_name": "2328 Valencia Street Apartments",
    "latitude": 48.761504,
    "longitude": -122.44632,
    "original_address": "2328 Valencia St",
    "building_number": 2328,
    "street": "Valencia St",
    "city": "Bellingham",
    "zip": 98229,
    "concatenated_address": "2328 Valencia St, Bellingham",
    "address": "2328 Valencia St., Bellingham"
  },
  {
    "id": 1916,
    "financing": "Federally subsidized",
    "building_name": "2606 168th Place Northeast",
    "latitude": 48.148661,
    "longitude": -122.19435,
    "original_address": "2606 168th Pl Ne",
    "building_number": 2606,
    "street": "168th Pl NE",
    "city": "Marysville",
    "zip": 98271,
    "concatenated_address": "2606 168th Pl NE, Marysville",
    "address": "2606 168th Pl N.E., Marysville"
  },
  {
    "id": 1917,
    "financing": "Federally subsidized",
    "building_name": "2800 Alder Street",
    "latitude": 47.257636,
    "longitude": -122.29652,
    "original_address": "2800 Alder St",
    "building_number": 2800,
    "street": "Alder St",
    "city": "Milton",
    "zip": 98354,
    "concatenated_address": "2800 Alder St, Milton",
    "address": "2800 Alder St., Milton"
  },
  {
    "id": 1918,
    "financing": "Federally subsidized",
    "building_name": "298 Ritter Street South",
    "latitude": 46.85557,
    "longitude": -122.85386,
    "original_address": "298 Ritter Street S",
    "building_number": 298,
    "street": "Ritter St S",
    "city": "Tenino",
    "zip": 98589,
    "concatenated_address": "298 Ritter St S, Tenino",
    "address": "298 Ritter St. S., Tenino"
  },
  {
    "id": 1919,
    "financing": "Federally subsidized",
    "building_name": "301 26th Avenue South",
    "latitude": 47.600196,
    "longitude": -122.29891,
    "original_address": "301 26th Avenue S",
    "building_number": 301,
    "street": "26th Ave S",
    "city": "Seattle",
    "zip": 98144,
    "concatenated_address": "301 26th Ave S, Seattle",
    "address": "301 26th Ave. S., Seattle"
  },
  {
    "id": 1920,
    "financing": "Federally subsidized",
    "building_name": "301 Apartments",
    "latitude": 47.604499,
    "longitude": -122.30418,
    "original_address": "301 22nd Ave",
    "building_number": 301,
    "street": "22nd Ave",
    "city": "Seattle",
    "zip": 98122,
    "concatenated_address": "301 22nd Ave, Seattle",
    "address": "301 22nd Ave., Seattle"
  },
  {
    "id": 1921,
    "financing": "Federally subsidized",
    "building_name": "3017 Lombard",
    "latitude": 47.977755,
    "longitude": -122.20283,
    "original_address": "3017 Lombard Ave",
    "building_number": 3017,
    "street": "Lombard Ave",
    "city": "Everett",
    "zip": 98201,
    "concatenated_address": "3017 Lombard Ave, Everett",
    "address": "3017 Lombard Ave., Everett"
  },
  {
    "id": 1922,
    "financing": "Federally subsidized",
    "building_name": "3322 Oakes Project",
    "latitude": 47.973012,
    "longitude": -122.20455,
    "original_address": "3322 Oakes Ave",
    "building_number": 3322,
    "street": "Oakes Ave",
    "city": "Everett",
    "zip": 98201,
    "concatenated_address": "3322 Oakes Ave, Everett",
    "address": "3322 Oakes Ave., Everett"
  },
  {
    "id": 1923,
    "financing": "Federally subsidized",
    "building_name": "3327 Rucker Avenue",
    "latitude": 47.972772,
    "longitude": -122.21076,
    "original_address": "3327 Rucker Ave",
    "building_number": 3327,
    "street": "Rucker Ave",
    "city": "Everett",
    "zip": 98201,
    "concatenated_address": "3327 Rucker Ave, Everett",
    "address": "3327 Rucker Ave., Everett"
  },
  {
    "id": 1924,
    "financing": "Federally subsidized",
    "building_name": "39th Avenue Flats Apartments",
    "latitude": 47.554951,
    "longitude": -122.28414,
    "original_address": "5231 39th Avenue South",
    "building_number": 5231,
    "street": "39th Ave S",
    "city": "Seattle",
    "zip": 98118,
    "concatenated_address": "5231 39th Ave S, Seattle",
    "address": "5231 39th Ave. S., Seattle"
  },
  {
    "id": 1925,
    "financing": "Federally subsidized",
    "building_name": "410 Apartments",
    "latitude": 47.622328,
    "longitude": -122.31759,
    "original_address": "410 11th Avenue E.",
    "building_number": 410,
    "street": "11th Ave E",
    "city": "Seattle",
    "zip": 98102,
    "concatenated_address": "410 11th Ave E, Seattle",
    "address": "410 11th Ave. E., Seattle"
  },
  {
    "id": 1926,
    "financing": "Federally subsidized",
    "building_name": "412 Apartments",
    "latitude": 47.5988,
    "longitude": -122.29954,
    "original_address": "412 25th Avenue S.",
    "building_number": 412,
    "street": "25th Ave S",
    "city": "Seattle",
    "zip": 98144,
    "concatenated_address": "412 25th Ave S, Seattle",
    "address": "412 25th Ave. S., Seattle"
  },
  {
    "id": 1927,
    "financing": "Federally subsidized",
    "building_name": "450 Norris Place",
    "latitude": 48.47566,
    "longitude": -122.32544,
    "original_address": "450 Norris Pl",
    "building_number": "",
    "street": "",
    "city": "Burlington",
    "zip": "",
    "concatenated_address": "450 Norris Pl, Burlington",
    "address": "450 Norris Place, Burlington"
  },
  {
    "id": 1928,
    "financing": "Federally subsidized",
    "building_name": "458 Norris Place",
    "latitude": 48.47566,
    "longitude": -122.32544,
    "original_address": "458 Norris Pl",
    "building_number": "",
    "street": "",
    "city": "Burlington",
    "zip": "",
    "concatenated_address": "458 Norris Pl, Burlington",
    "address": "458 Norris Place, Burlington"
  },
  {
    "id": 1929,
    "financing": "Federally subsidized",
    "building_name": "466 Norris Place",
    "latitude": 48.47566,
    "longitude": -122.32544,
    "original_address": "466 Norris Pl",
    "building_number": "",
    "street": "",
    "city": "Burlington",
    "zip": "",
    "concatenated_address": "466 Norris Pl, Burlington",
    "address": "466 Norris Place, Burlington"
  },
  {
    "id": 1930,
    "financing": "Federally subsidized",
    "building_name": "474 Norris Place",
    "latitude": 48.47566,
    "longitude": -122.32544,
    "original_address": "474 Norris Pl",
    "building_number": "",
    "street": "",
    "city": "Burlington",
    "zip": "",
    "concatenated_address": "474 Norris Pl, Burlington",
    "address": "474 Norris Place, Burlington"
  },
  {
    "id": 1931,
    "financing": "Federally subsidized",
    "building_name": "482 Norris Place",
    "latitude": 48.47566,
    "longitude": -122.32544,
    "original_address": "482 Norris Pl",
    "building_number": "",
    "street": "",
    "city": "Burlington",
    "zip": "",
    "concatenated_address": "482 Norris Pl, Burlington",
    "address": "482 Norris Place, Burlington"
  },
  {
    "id": 1932,
    "financing": "Federally subsidized",
    "building_name": "490 Norris Place",
    "latitude": 48.47566,
    "longitude": -122.32544,
    "original_address": "490 Norris Pl",
    "building_number": "",
    "street": "",
    "city": "Burlington",
    "zip": "",
    "concatenated_address": "490 Norris Pl, Burlington",
    "address": "490 Norris Place, Burlington"
  },
  {
    "id": 1933,
    "financing": "Federally subsidized",
    "building_name": "498 Norris Place",
    "latitude": 48.47566,
    "longitude": -122.32544,
    "original_address": "498 Norris Pl",
    "building_number": "",
    "street": "",
    "city": "Burlington",
    "zip": "",
    "concatenated_address": "498 Norris Pl, Burlington",
    "address": "498 Norris Place, Burlington"
  },
  {
    "id": 1934,
    "financing": "Federally subsidized",
    "building_name": "525 C Street",
    "latitude": 45.581148,
    "longitude": -122.37115,
    "original_address": "525 C St",
    "building_number": 525,
    "street": "C St",
    "city": "Washougal",
    "zip": 98671,
    "concatenated_address": "525 C St, Washougal",
    "address": "525 C St., Washougal"
  },
  {
    "id": 1935,
    "financing": "Federally subsidized",
    "building_name": "550 Madison Apartments",
    "latitude": 47.62886,
    "longitude": -122.52086,
    "original_address": "550 Madison Avenue North",
    "building_number": 550,
    "street": "Madison Ave N",
    "city": "Bainbridge Island",
    "zip": 98110,
    "concatenated_address": "550 Madison Ave N, Bainbridge Island",
    "address": "550 Madison Ave. N., Bainbridge Island"
  },
  {
    "id": 1936,
    "financing": "Federally subsidized",
    "building_name": "55th Avenue Apartments",
    "latitude": 47.604143,
    "longitude": -117.36458,
    "original_address": "3223 East 55th Ave",
    "building_number": 3223,
    "street": "E 55th Ave",
    "city": "Spokane",
    "zip": 99223,
    "concatenated_address": "3223 E 55th Ave, Spokane",
    "address": "3223 E. 55th Ave., Spokane"
  },
  {
    "id": 1937,
    "financing": "Federally subsidized",
    "building_name": "6401 Sherwood Addition Road",
    "latitude": 47.865868,
    "longitude": -117.91708,
    "original_address": "6401 Sherwood Addition Rd",
    "building_number": 6401,
    "street": "Sherwood Rd",
    "city": "Wellpinit",
    "zip": "",
    "concatenated_address": "6401 Sherwood Rd, Wellpinit",
    "address": "6401 Sherwood Road, Wellpinit"
  },
  {
    "id": 1938,
    "financing": "Federally subsidized",
    "building_name": "6950 Sand Point Way Northeast",
    "latitude": 47.679083,
    "longitude": -122.26345,
    "original_address": "6950 Sand Point Way Ne",
    "building_number": 6950,
    "street": "Sand Point Way NE",
    "city": "Seattle",
    "zip": "",
    "concatenated_address": "6950 Sand Point Way NE, Seattle",
    "address": "6950 Sand Point Way N.E., Seattle"
  },
  {
    "id": 1939,
    "financing": "Federally subsidized",
    "building_name": "700 North Cle Elum",
    "latitude": 46.999034,
    "longitude": -120.55401,
    "original_address": "700 N Cle Elum",
    "building_number": 700,
    "street": "N Cle Elum St",
    "city": "Ellensburg",
    "zip": 98926,
    "concatenated_address": "700 N Cle Elum St, Ellensburg",
    "address": "700 N. Cle Elum St., Ellensburg"
  },
  {
    "id": 1940,
    "financing": "Federally subsidized",
    "building_name": "708 Washington Street Buidling E",
    "latitude": 46.213934,
    "longitude": -119.99154,
    "original_address": "708 Washington St",
    "building_number": 708,
    "street": "Washington St",
    "city": "Mabton",
    "zip": 98935,
    "concatenated_address": "708 Washington St, Mabton",
    "address": "708 Washington St., Mabton"
  },
  {
    "id": 1941,
    "financing": "Federally subsidized",
    "building_name": "708 Washington Street Building A",
    "latitude": 46.213934,
    "longitude": -119.99154,
    "original_address": "708 Washington St",
    "building_number": 708,
    "street": "Washington St",
    "city": "Mabton",
    "zip": 98935,
    "concatenated_address": "708 Washington St, Mabton",
    "address": "708 Washington St., Mabton"
  },
  {
    "id": 1942,
    "financing": "Federally subsidized",
    "building_name": "708 Washington Street Building B",
    "latitude": 46.213934,
    "longitude": -119.99154,
    "original_address": "708 Washington St",
    "building_number": 708,
    "street": "Washington St",
    "city": "Mabton",
    "zip": 98935,
    "concatenated_address": "708 Washington St, Mabton",
    "address": "708 Washington St., Mabton"
  },
  {
    "id": 1943,
    "financing": "Federally subsidized",
    "building_name": "708 Washington Street Building C",
    "latitude": 46.213934,
    "longitude": -119.99154,
    "original_address": "708 Washington St",
    "building_number": 708,
    "street": "Washington St",
    "city": "Mabton",
    "zip": 98935,
    "concatenated_address": "708 Washington St, Mabton",
    "address": "708 Washington St., Mabton"
  },
  {
    "id": 1944,
    "financing": "Federally subsidized",
    "building_name": "708 Washington Street Building D",
    "latitude": 46.213934,
    "longitude": -119.99154,
    "original_address": "708 Washington St",
    "building_number": 708,
    "street": "Washington St",
    "city": "Mabton",
    "zip": 98935,
    "concatenated_address": "708 Washington St, Mabton",
    "address": "708 Washington St., Mabton"
  },
  {
    "id": 1945,
    "financing": "Federally subsidized",
    "building_name": "708 Washington Street Building F",
    "latitude": 46.213934,
    "longitude": -119.99154,
    "original_address": "708 Washington St",
    "building_number": 708,
    "street": "Washington St",
    "city": "Mabton",
    "zip": 98935,
    "concatenated_address": "708 Washington St, Mabton",
    "address": "708 Washington St., Mabton"
  },
  {
    "id": 1946,
    "financing": "Federally subsidized",
    "building_name": "708 Washington Street Building G",
    "latitude": 46.213934,
    "longitude": -119.99154,
    "original_address": "708 Washington St",
    "building_number": 708,
    "street": "Washington St",
    "city": "Mabton",
    "zip": 98935,
    "concatenated_address": "708 Washington St, Mabton",
    "address": "708 Washington St., Mabton"
  },
  {
    "id": 1947,
    "financing": "Federally subsidized",
    "building_name": "708 Washington Street Building H",
    "latitude": 46.213934,
    "longitude": -119.99154,
    "original_address": "708 Washington St",
    "building_number": 708,
    "street": "Washington St",
    "city": "Mabton",
    "zip": 98935,
    "concatenated_address": "708 Washington St, Mabton",
    "address": "708 Washington St., Mabton"
  },
  {
    "id": 1948,
    "financing": "Federally subsidized",
    "building_name": "708 Washington Street Building J",
    "latitude": 46.213934,
    "longitude": -119.99154,
    "original_address": "708 Washington St",
    "building_number": 708,
    "street": "Washington St",
    "city": "Mabton",
    "zip": 98935,
    "concatenated_address": "708 Washington St, Mabton",
    "address": "708 Washington St., Mabton"
  },
  {
    "id": 1949,
    "financing": "Federally subsidized",
    "building_name": "708 Washington Street Building K",
    "latitude": 46.213934,
    "longitude": -119.99154,
    "original_address": "708 Washington St",
    "building_number": 708,
    "street": "Washington St",
    "city": "Mabton",
    "zip": 98935,
    "concatenated_address": "708 Washington St, Mabton",
    "address": "708 Washington St., Mabton"
  },
  {
    "id": 1950,
    "financing": "Federally subsidized",
    "building_name": "708 Washington Street Building L",
    "latitude": 46.213934,
    "longitude": -119.99154,
    "original_address": "708 Washington St",
    "building_number": 708,
    "street": "Washington St",
    "city": "Mabton",
    "zip": 98935,
    "concatenated_address": "708 Washington St, Mabton",
    "address": "708 Washington St., Mabton"
  },
  {
    "id": 1951,
    "financing": "Federally subsidized",
    "building_name": "708 Washington Street Building M",
    "latitude": 46.213934,
    "longitude": -119.99154,
    "original_address": "708 Washington St",
    "building_number": 708,
    "street": "Washington St",
    "city": "Mabton",
    "zip": 98935,
    "concatenated_address": "708 Washington St, Mabton",
    "address": "708 Washington St., Mabton"
  },
  {
    "id": 1952,
    "financing": "Federally subsidized",
    "building_name": "708 Washington Street Building N",
    "latitude": 46.213934,
    "longitude": -119.99154,
    "original_address": "708 Washington St",
    "building_number": 708,
    "street": "Washington St",
    "city": "Mabton",
    "zip": 98935,
    "concatenated_address": "708 Washington St, Mabton",
    "address": "708 Washington St., Mabton"
  },
  {
    "id": 1953,
    "financing": "Federally subsidized",
    "building_name": "7135 Holly Park Drive South",
    "latitude": 47.5383,
    "longitude": -122.28743,
    "original_address": "7135 Holly Park Dr S",
    "building_number": 7135,
    "street": "Holly Park Dr S",
    "city": "Seattle",
    "zip": 98118,
    "concatenated_address": "7135 Holly Park Dr S, Seattle",
    "address": "7135 Holly Park Dr S., Seattle"
  },
  {
    "id": 1954,
    "financing": "Federally subsidized",
    "building_name": "80128th Street",
    "latitude": 48.499495,
    "longitude": -122.61278,
    "original_address": "801 28th St",
    "building_number": 801,
    "street": "28th St",
    "city": "Anacortes",
    "zip": 98221,
    "concatenated_address": "801 28th St, Anacortes",
    "address": "801 28th St., Anacortes"
  },
  {
    "id": 1955,
    "financing": "Federally subsidized",
    "building_name": "802 30th Street",
    "latitude": 48.498598,
    "longitude": -122.6104,
    "original_address": "802 30th St",
    "building_number": 802,
    "street": "30th St",
    "city": "Anacortes",
    "zip": 98221,
    "concatenated_address": "802 30th St, Anacortes",
    "address": "802 30th St., Anacortes"
  },
  {
    "id": 1956,
    "financing": "Federally subsidized",
    "building_name": "80328th Street",
    "latitude": 48.499495,
    "longitude": -122.61277,
    "original_address": "803 28th St",
    "building_number": 803,
    "street": "28th St",
    "city": "Anacortes",
    "zip": 98221,
    "concatenated_address": "803 28th St, Anacortes",
    "address": "803 28th St., Anacortes"
  },
  {
    "id": 1957,
    "financing": "Federally subsidized",
    "building_name": "804 30th Street",
    "latitude": 48.498138,
    "longitude": -122.60964,
    "original_address": "804 30th St",
    "building_number": 804,
    "street": "30th St",
    "city": "Anacortes",
    "zip": 98221,
    "concatenated_address": "804 30th St, Anacortes",
    "address": "804 30th St., Anacortes"
  },
  {
    "id": 1958,
    "financing": "Federally subsidized",
    "building_name": "806 29th Street",
    "latitude": 48.498964,
    "longitude": -122.61118,
    "original_address": "806 29th St",
    "building_number": 806,
    "street": "29th St",
    "city": "Anacortes",
    "zip": 98221,
    "concatenated_address": "806 29th St, Anacortes",
    "address": "806 29th St., Anacortes"
  },
  {
    "id": 1959,
    "financing": "Federally subsidized",
    "building_name": "807 28th Street",
    "latitude": 48.499495,
    "longitude": -122.61275,
    "original_address": "807 28th St",
    "building_number": 807,
    "street": "28th St",
    "city": "Anacortes",
    "zip": 98221,
    "concatenated_address": "807 28th St, Anacortes",
    "address": "807 28th St., Anacortes"
  },
  {
    "id": 1960,
    "financing": "Federally subsidized",
    "building_name": "808 29th Street",
    "latitude": 48.498964,
    "longitude": -122.61118,
    "original_address": "808 29th St",
    "building_number": 808,
    "street": "29th St",
    "city": "Anacortes",
    "zip": 98221,
    "concatenated_address": "808 29th St, Anacortes",
    "address": "808 29th St., Anacortes"
  },
  {
    "id": 1961,
    "financing": "Federally subsidized",
    "building_name": "809 28th Street",
    "latitude": 48.499495,
    "longitude": -122.61274,
    "original_address": "809 28th St",
    "building_number": 809,
    "street": "28th St",
    "city": "Anacortes",
    "zip": 98221,
    "concatenated_address": "809 28th St, Anacortes",
    "address": "809 28th St., Anacortes"
  },
  {
    "id": 1962,
    "financing": "Federally subsidized",
    "building_name": "A Place Of Our Own",
    "latitude": 47.691939,
    "longitude": -122.31794,
    "original_address": "8623 Roosevelt Way Ne",
    "building_number": 8623,
    "street": "Roosevelt Way NE",
    "city": "Seattle",
    "zip": 98115,
    "concatenated_address": "8623 Roosevelt Way NE, Seattle",
    "address": "8623 Roosevelt Way N.E., Seattle"
  },
  {
    "id": 1963,
    "financing": "Federally subsidized",
    "building_name": "Abbey Lincoln Court",
    "latitude": 47.599449,
    "longitude": -122.30495,
    "original_address": "2020 S Jackson Street",
    "building_number": 2020,
    "street": "S Jackson St",
    "city": "Seattle",
    "zip": 98144,
    "concatenated_address": "2020 S Jackson St, Seattle",
    "address": "2020 S. Jackson St., Seattle"
  },
  {
    "id": 1964,
    "financing": "Federally subsidized",
    "building_name": "Adams House Apartments",
    "latitude": 47.125229,
    "longitude": -118.38397,
    "original_address": "401 West Broadway",
    "building_number": 401,
    "street": "W Broadway Ave",
    "city": "Ritzville",
    "zip": 99169,
    "concatenated_address": "401 W Broadway Ave, Ritzville",
    "address": "401 W. Broadway Ave., Ritzville"
  },
  {
    "id": 1965,
    "financing": "Federally subsidized",
    "building_name": "Adams View",
    "latitude": 46.522398,
    "longitude": -120.50844,
    "original_address": "330 Nukshay",
    "building_number": "",
    "street": "",
    "city": "Wapato",
    "zip": 98951,
    "concatenated_address": "330 Nukshay, Wapato",
    "address": "330 Nukshay, Wapato"
  },
  {
    "id": 1966,
    "financing": "Federally subsidized",
    "building_name": "Adams View",
    "latitude": 46.522398,
    "longitude": -120.50844,
    "original_address": "330 Nukshay Dr",
    "building_number": "",
    "street": "",
    "city": "Wapato",
    "zip": 98951,
    "concatenated_address": "330 Nukshay Dr, Wapato",
    "address": "330 Nukshay Drive, Wapato"
  },
  {
    "id": 1967,
    "financing": "Federally subsidized",
    "building_name": "Addison On Fourth",
    "latitude": 47.599866,
    "longitude": -122.32875,
    "original_address": "308 4th Avenue South",
    "building_number": 308,
    "street": "4th Ave S",
    "city": "Seattle",
    "zip": 98104,
    "concatenated_address": "308 4th Ave S, Seattle",
    "address": "308 4th Ave. S., Seattle"
  },
  {
    "id": 1968,
    "financing": "Federally subsidized",
    "building_name": "Addison On Fourth",
    "latitude": 47.599866,
    "longitude": -122.32875,
    "original_address": "308 Fourth Avenue South",
    "building_number": 308,
    "street": "4th Ave S",
    "city": "Seattle",
    "zip": 98104,
    "concatenated_address": "308 4th Ave S, Seattle",
    "address": "308 4th Ave. S., Seattle"
  },
  {
    "id": 1969,
    "financing": "Federally subsidized",
    "building_name": "Adriana Senior Apartments",
    "latitude": 47.399325,
    "longitude": -122.32603,
    "original_address": "22525 7th Avenue South",
    "building_number": 22525,
    "street": "7th Ave S",
    "city": "Seattle",
    "zip": 98198,
    "concatenated_address": "22525 7th Ave S, Seattle",
    "address": "22525 7th Ave. S., Seattle"
  },
  {
    "id": 1970,
    "financing": "Federally subsidized",
    "building_name": "Agnes Kehoe Place",
    "latitude": 47.706267,
    "longitude": -117.36847,
    "original_address": "5313 North Regal St",
    "building_number": 5313,
    "street": "N Regal St",
    "city": "Spokane",
    "zip": 99217,
    "concatenated_address": "5313 N Regal St, Spokane",
    "address": "5313 N. Regal St., Spokane"
  },
  {
    "id": 1971,
    "financing": "Federally subsidized",
    "building_name": "Airway Pointe",
    "latitude": 47.643803,
    "longitude": -117.59205,
    "original_address": "13513 West Sixth Avenue",
    "building_number": "",
    "street": "",
    "city": "Airway Heights",
    "zip": 99001,
    "concatenated_address": "13513 West Sixth Avenue, Airway Heights",
    "address": "13513 West Sixth Avenue, Airway Heights"
  },
  {
    "id": 1972,
    "financing": "Federally subsidized",
    "building_name": "Airway Pointe Seniors",
    "latitude": 47.650091,
    "longitude": -117.59597,
    "original_address": "13520 6th Ave",
    "building_number": 13520,
    "street": "6th Ave",
    "city": "Airway Heights",
    "zip": 99001,
    "concatenated_address": "13520 6th Ave, Airway Heights",
    "address": "13520 6th Ave., Airway Heights"
  },
  {
    "id": 1973,
    "financing": "Federally subsidized",
    "building_name": "Aki Kurose II",
    "latitude": 47.713423,
    "longitude": -122.34173,
    "original_address": "11540 Stone Avenue N",
    "building_number": 11540,
    "street": "Stone Ave N",
    "city": "Seattle",
    "zip": "98133-8365",
    "concatenated_address": "11540 Stone Ave N, Seattle",
    "address": "11540 Stone Ave. N., Seattle"
  },
  {
    "id": 1974,
    "financing": "Federally subsidized",
    "building_name": "Aki Kurose Village (Stone View)",
    "latitude": 47.71248,
    "longitude": -122.34181,
    "original_address": "11500 Stone Avenue N",
    "building_number": 11500,
    "street": "Stone Ave N",
    "city": "Seattle",
    "zip": 98133,
    "concatenated_address": "11500 Stone Ave N, Seattle",
    "address": "11500 Stone Ave. N., Seattle"
  },
  {
    "id": 1975,
    "financing": "Federally subsidized",
    "building_name": "Aki Kurose Village (Stone View)",
    "latitude": 47.03823,
    "longitude": -122.94803,
    "original_address": "3600 Forestbrooke Way Sw",
    "building_number": 3600,
    "street": "Forestbrooke Way SW",
    "city": "Olympia",
    "zip": 98502,
    "concatenated_address": "3600 Forestbrooke Way SW, Olympia",
    "address": "3600 Forestbrooke Way S.W., Olympia"
  },
  {
    "id": 1976,
    "financing": "Federally subsidized",
    "building_name": "Alaska House",
    "latitude": 47.561462,
    "longitude": -122.38578,
    "original_address": "4545 - 42nd Avenue Sw",
    "building_number": 4545,
    "street": "42nd Ave SW",
    "city": "Seattle",
    "zip": "98116-4237",
    "concatenated_address": "4545 42nd Ave SW, Seattle",
    "address": "4545 42nd Ave. S.W., Seattle"
  },
  {
    "id": 1977,
    "financing": "Federally subsidized",
    "building_name": "Alberta J. Canada Apartments",
    "latitude": 47.251637,
    "longitude": -122.45187,
    "original_address": "1114 11th Street",
    "building_number": 1114,
    "street": "S 11th St",
    "city": "Tacoma",
    "zip": 98405,
    "concatenated_address": "1114 S 11th St, Tacoma",
    "address": "1114 S. 11th St., Tacoma"
  },
  {
    "id": 1978,
    "financing": "Federally subsidized",
    "building_name": "Alder Commons",
    "latitude": 48.064477,
    "longitude": -122.17233,
    "original_address": "4308 76th Street Ne",
    "building_number": 4308,
    "street": "76th St NE",
    "city": "Marysville",
    "zip": 98270,
    "concatenated_address": "4308 76th St NE, Marysville",
    "address": "4308 76th St. N.E., Marysville"
  },
  {
    "id": 1979,
    "financing": "Federally subsidized",
    "building_name": "Alder Crest Apartments",
    "latitude": 47.543863,
    "longitude": -122.37603,
    "original_address": "6520 35th Avenue Sw",
    "building_number": 6520,
    "street": "35th Ave SW",
    "city": "Seattle",
    "zip": 98126,
    "concatenated_address": "6520 35th Ave SW, Seattle",
    "address": "6520 35th Ave. S.W., Seattle"
  },
  {
    "id": 1980,
    "financing": "Federally subsidized",
    "building_name": "Alder House",
    "latitude": 47.604147,
    "longitude": -122.3199,
    "original_address": "925 East Alder Street",
    "building_number": 925,
    "street": "E Alder St",
    "city": "Seattle",
    "zip": 98122,
    "concatenated_address": "925 E Alder St, Seattle",
    "address": "925 E. Alder St., Seattle"
  },
  {
    "id": 1981,
    "financing": "Federally subsidized",
    "building_name": "Alder Ridge Senior Apartments",
    "latitude": 47.257636,
    "longitude": -122.29652,
    "original_address": "2800 Alder St.",
    "building_number": 2800,
    "street": "Alder St",
    "city": "Milton",
    "zip": 98354,
    "concatenated_address": "2800 Alder St, Milton",
    "address": "2800 Alder St., Milton"
  },
  {
    "id": 1982,
    "financing": "Federally subsidized",
    "building_name": "Alder Ridge Senior Apartments",
    "latitude": 47.258761,
    "longitude": -122.29786,
    "original_address": "38338 28th Avenue South",
    "building_number": 38338,
    "street": "28th Ave S",
    "city": "Milton",
    "zip": 98354,
    "concatenated_address": "38338 28th Ave S, Milton",
    "address": "38338 28th Ave. S., Milton"
  },
  {
    "id": 1983,
    "financing": "Federally subsidized",
    "building_name": "Alderbrook Apartments",
    "latitude": 47.393563,
    "longitude": -122.23024,
    "original_address": "412 E. Novak Lane",
    "building_number": 412,
    "street": "E Novak Ln",
    "city": "Kent",
    "zip": "98032-2017",
    "concatenated_address": "412 E Novak Ln, Kent",
    "address": "412 E. Novak Lane, Kent"
  },
  {
    "id": 1984,
    "financing": "Federally subsidized",
    "building_name": "Alderwood Court Apartments",
    "latitude": 47.831431,
    "longitude": -122.28237,
    "original_address": "18420 - 36th Avenue West",
    "building_number": 18420,
    "street": "36th Ave W",
    "city": "Lynnwood",
    "zip": "98037-7638",
    "concatenated_address": "18420 36th Ave W, Lynnwood",
    "address": "18420 36th Ave. W., Lynnwood"
  },
  {
    "id": 1985,
    "financing": "Federally subsidized",
    "building_name": "Ale Housing",
    "latitude": 48.95703,
    "longitude": -122.45205,
    "original_address": "18611 Depot Road",
    "building_number": "",
    "street": "Depot Rd",
    "city": "Lynden",
    "zip": 98264,
    "concatenated_address": "18611 Depot Road, Lynden",
    "address": "18611 Depot Road, Lynden"
  },
  {
    "id": 1986,
    "financing": "Federally subsidized",
    "building_name": "Alex Jackson House",
    "latitude": 47.609472,
    "longitude": -122.34286,
    "original_address": "1901 Western Ave",
    "building_number": 1901,
    "street": "Western Ave",
    "city": "Seattle",
    "zip": 98101,
    "concatenated_address": "1901 Western Ave, Seattle",
    "address": "1901 Western Ave., Seattle"
  },
  {
    "id": 1987,
    "financing": "Federally subsidized",
    "building_name": "Allegre Villa & Sandstone Apartments",
    "latitude": 46.49083,
    "longitude": -122.93597,
    "original_address": "207 E Walnut St",
    "building_number": 207,
    "street": "E Walnut St",
    "city": "Winlock",
    "zip": 98596,
    "concatenated_address": "207 E Walnut St, Winlock",
    "address": "207 E. Walnut St., Winlock"
  },
  {
    "id": 1988,
    "financing": "Federally subsidized",
    "building_name": "Alma Gamble",
    "latitude": 47.597316,
    "longitude": -122.30031,
    "original_address": "525 25th Avenue South",
    "building_number": 525,
    "street": "25th Ave S",
    "city": "Seattle",
    "zip": 98144,
    "concatenated_address": "525 25th Ave S, Seattle",
    "address": "525 25th Ave. S., Seattle"
  },
  {
    "id": 1989,
    "financing": "Federally subsidized",
    "building_name": "Alpine Ridge",
    "latitude": 48.424201,
    "longitude": -122.32123,
    "original_address": "401 North 17th Street",
    "building_number": 401,
    "street": "N 17th St",
    "city": "Mount Vernon",
    "zip": "98273-3474",
    "concatenated_address": "401 N 17th St, Mount Vernon",
    "address": "401 N. 17th St., Mount Vernon"
  },
  {
    "id": 1990,
    "financing": "Federally subsidized",
    "building_name": "Alpine Ridge",
    "latitude": 47.349258,
    "longitude": -122.31031,
    "original_address": "1802 S 281st Pl",
    "building_number": 1802,
    "street": "S 281st Pl",
    "city": "Federal Way",
    "zip": 98003,
    "concatenated_address": "1802 S 281st Pl, Federal Way",
    "address": "1802 S. 281st Place, Federal Way"
  },
  {
    "id": 1991,
    "financing": "Federally subsidized",
    "building_name": "Alpine Ridge Apartments",
    "latitude": 47.732641,
    "longitude": -122.21561,
    "original_address": "14461 Simonds Road Ne, Building A",
    "building_number": 14461,
    "street": "Simonds Rd NE",
    "city": "Kirkland",
    "zip": "98011-5184",
    "concatenated_address": "14461 Simonds Rd NE, Kirkland",
    "address": "14461 Simonds Road N.E., Kirkland"
  },
  {
    "id": 1992,
    "financing": "Federally subsidized",
    "building_name": "American Legion Housing",
    "latitude": 48.935268,
    "longitude": -119.42986,
    "original_address": "1105 Appleway Street",
    "building_number": "",
    "street": "Appleway St",
    "city": "Oroville",
    "zip": 98844,
    "concatenated_address": "1105 Appleway Street, Oroville",
    "address": "1105 Appleway St., Oroville"
  },
  {
    "id": 1993,
    "financing": "Federally subsidized",
    "building_name": "Anacortes Manor Apartments",
    "latitude": 48.503661,
    "longitude": -122.61565,
    "original_address": "1110 24th Street",
    "building_number": 1110,
    "street": "24th St",
    "city": "Anacortes",
    "zip": 98221,
    "concatenated_address": "1110 24th St, Anacortes",
    "address": "1110 24th St., Anacortes"
  },
  {
    "id": 1994,
    "financing": "Federally subsidized",
    "building_name": "Andrew's Arms",
    "latitude": 47.52113,
    "longitude": -122.03218,
    "original_address": "820 Front Street S",
    "building_number": 820,
    "street": "Front St S",
    "city": "Issaquah",
    "zip": 98027,
    "concatenated_address": "820 Front St S, Issaquah",
    "address": "820 Front St. S., Issaquah"
  },
  {
    "id": 1995,
    "financing": "Federally subsidized",
    "building_name": "Andrew's Glen",
    "latitude": 47.569713,
    "longitude": -122.16839,
    "original_address": "4220 Factoria Blvd Se",
    "building_number": 4220,
    "street": "Factoria Blvd SE",
    "city": "Bellevue",
    "zip": 98006,
    "concatenated_address": "4220 Factoria Blvd SE, Bellevue",
    "address": "4220 Factoria Blvd S.E., Bellevue"
  },
  {
    "id": 1996,
    "financing": "Federally subsidized",
    "building_name": "Andrew's Heights",
    "latitude": 47.572857,
    "longitude": -122.1664,
    "original_address": "4087 129th Place Se",
    "building_number": 4087,
    "street": "129th Pl SE",
    "city": "Bellevue",
    "zip": 98006,
    "concatenated_address": "4087 129th Pl SE, Bellevue",
    "address": "4087 129th Pl S.E., Bellevue"
  },
  {
    "id": 1997,
    "financing": "Federally subsidized",
    "building_name": "Angle Lake Court",
    "latitude": 47.434852,
    "longitude": -122.28373,
    "original_address": "4010 South 188th Street",
    "building_number": 4010,
    "street": "S 188th St",
    "city": "Seattle",
    "zip": 98188,
    "concatenated_address": "4010 S 188th St, Seattle",
    "address": "4010 S. 188th St., Seattle"
  },
  {
    "id": 1998,
    "financing": "Federally subsidized",
    "building_name": "Annapolis",
    "latitude": 47.615063,
    "longitude": -122.32484,
    "original_address": "1531 Belmont Ave",
    "building_number": 1531,
    "street": "Belmont Ave",
    "city": "Seattle",
    "zip": 98122,
    "concatenated_address": "1531 Belmont Ave, Seattle",
    "address": "1531 Belmont Ave., Seattle"
  },
  {
    "id": 1999,
    "financing": "Federally subsidized",
    "building_name": "Anthem Park At Uptown Village",
    "latitude": 45.63918,
    "longitude": -122.67265,
    "original_address": "127 Nw 25th Street",
    "building_number": 127,
    "street": "W 25th St",
    "city": "Vancouver",
    "zip": 98660,
    "concatenated_address": "127 W 25th St, Vancouver",
    "address": "127 W. 25th St., Vancouver"
  },
  {
    "id": 2000,
    "financing": "Federally subsidized",
    "building_name": "Apartment",
    "latitude": 47.561579,
    "longitude": -122.29339,
    "original_address": "4626 Mlk Jr Way S",
    "building_number": 4626,
    "street": "Martin Luther King Jr Way S",
    "city": "Seattle",
    "zip": 98108,
    "concatenated_address": "4626 Martin Luther King Jr Way S, Seattle",
    "address": "4626 Martin Luther King Jr Way S., Seattle"
  },
  {
    "id": 2001,
    "financing": "Federally subsidized",
    "building_name": "Appian Way Apartments",
    "latitude": 47.369084,
    "longitude": -122.2978,
    "original_address": "25815 - 27th Place South",
    "building_number": 25815,
    "street": "27th Pl S",
    "city": "Kent",
    "zip": 98032,
    "concatenated_address": "25815 27th Pl S, Kent",
    "address": "25815 27th Pl S., Kent"
  },
  {
    "id": 2002,
    "financing": "Federally subsidized",
    "building_name": "Apple Valley Apartments",
    "latitude": 48.954015,
    "longitude": -122.4528,
    "original_address": "8611 Depot Road",
    "building_number": 8611,
    "street": "Depot Rd",
    "city": "Lynden",
    "zip": 98264,
    "concatenated_address": "8611 Depot Rd, Lynden",
    "address": "8611 Depot Road, Lynden"
  },
  {
    "id": 2003,
    "financing": "Federally subsidized",
    "building_name": "Appleway Court II",
    "latitude": 47.654623,
    "longitude": -117.27494,
    "original_address": "225 S. Farr Rd",
    "building_number": 225,
    "street": "S Farr Rd",
    "city": "Spokane",
    "zip": 99206,
    "concatenated_address": "225 S Farr Rd, Spokane",
    "address": "225 S. Farr Road, Spokane"
  },
  {
    "id": 2004,
    "financing": "Federally subsidized",
    "building_name": "Aptsnt",
    "latitude": 47.547334,
    "longitude": -122.3738,
    "original_address": "6025 Lanham Pl Sw",
    "building_number": 6025,
    "street": "Lanham Pl SW",
    "city": "Seattle",
    "zip": 98126,
    "concatenated_address": "6025 Lanham Pl SW, Seattle",
    "address": "6025 Lanham Pl S.W., Seattle"
  },
  {
    "id": 2005,
    "financing": "Federally subsidized",
    "building_name": "Arbor Heights",
    "latitude": 47.499352,
    "longitude": -122.33414,
    "original_address": "11603 1st Avenue South",
    "building_number": 11603,
    "street": "1st Ave S",
    "city": "Seattle",
    "zip": "98168-2071",
    "concatenated_address": "11603 1st Ave S, Seattle",
    "address": "11603 1st Ave. S., Seattle"
  },
  {
    "id": 2006,
    "financing": "Federally subsidized",
    "building_name": "Arbor Park Apartment Homes",
    "latitude": 48.419152,
    "longitude": -122.31308,
    "original_address": "200 S Laventure Road",
    "building_number": 200,
    "street": "S Laventure Rd",
    "city": "Mount Vernon",
    "zip": "98274-4795",
    "concatenated_address": "200 S Laventure Rd, Mount Vernon",
    "address": "200 S. Laventure Road, Mount Vernon"
  },
  {
    "id": 2007,
    "financing": "Federally subsidized",
    "building_name": "Arbor Ridge Assisted Living Project",
    "latitude": 45.690377,
    "longitude": -122.66745,
    "original_address": "9501 Ne Hazel Dell Avenue",
    "building_number": 9501,
    "street": "NE Hazel Dell Ave",
    "city": "Vancouver",
    "zip": 98665,
    "concatenated_address": "9501 NE Hazel Dell Ave, Vancouver",
    "address": "9501 N.E. Hazel Dell Ave., Vancouver"
  },
  {
    "id": 2008,
    "financing": "Federally subsidized",
    "building_name": "Arbor Woods",
    "latitude": 47.488082,
    "longitude": -122.25622,
    "original_address": "6230 South 129th Street",
    "building_number": 6230,
    "street": "S 129th St",
    "city": "Seattle",
    "zip": 98178,
    "concatenated_address": "6230 S 129th St, Seattle",
    "address": "6230 S. 129th St., Seattle"
  },
  {
    "id": 2009,
    "financing": "Federally subsidized",
    "building_name": "Argus Manor",
    "latitude": 47.184247,
    "longitude": -122.29214,
    "original_address": "204 9th Avenue Se",
    "building_number": 204,
    "street": "9th Ave SE",
    "city": "Puyallup",
    "zip": 98372,
    "concatenated_address": "204 9th Ave SE, Puyallup",
    "address": "204 9th Ave. S.E., Puyallup"
  },
  {
    "id": 2010,
    "financing": "Federally subsidized",
    "building_name": "Arrowhead Gardens",
    "latitude": 47.521158,
    "longitude": -122.33575,
    "original_address": "9200 2nd Avenue Sw",
    "building_number": 9200,
    "street": "2nd Ave SW",
    "city": "Seattle",
    "zip": 98106,
    "concatenated_address": "9200 2nd Ave SW, Seattle",
    "address": "9200 2nd Ave. S.W., Seattle"
  },
  {
    "id": 2011,
    "financing": "Federally subsidized",
    "building_name": "Arrowhead Park Apartments",
    "latitude": 47.157924,
    "longitude": -122.58007,
    "original_address": "10724 109th Street Sw",
    "building_number": 10724,
    "street": "109th St SW",
    "city": "Lakewood",
    "zip": "98498-1512",
    "concatenated_address": "10724 109th St SW, Lakewood",
    "address": "10724 109th St. S.W., Lakewood"
  },
  {
    "id": 2012,
    "financing": "Federally subsidized",
    "building_name": "Arrowleaf Village",
    "latitude": 47.650091,
    "longitude": -117.596,
    "original_address": "13526 West 6th Ave",
    "building_number": 13526,
    "street": "W 6th Ave",
    "city": "Airway Heights",
    "zip": 99001,
    "concatenated_address": "13526 W 6th Ave, Airway Heights",
    "address": "13526 W. 6th Ave., Airway Heights"
  },
  {
    "id": 2013,
    "financing": "Federally subsidized",
    "building_name": "Artspace Everett Lofts",
    "latitude": 47.97906,
    "longitude": -122.20989,
    "original_address": "2917 Hoyt Avenue",
    "building_number": 2917,
    "street": "Hoyt Ave",
    "city": "Everett",
    "zip": 98201,
    "concatenated_address": "2917 Hoyt Ave, Everett",
    "address": "2917 Hoyt Ave., Everett"
  },
  {
    "id": 2014,
    "financing": "Federally subsidized",
    "building_name": "Artspace Everett Lofts",
    "latitude": 47.97906,
    "longitude": -122.20989,
    "original_address": "2917 Hoyt Ave",
    "building_number": 2917,
    "street": "Hoyt Ave",
    "city": "Everett",
    "zip": "98201-4002",
    "concatenated_address": "2917 Hoyt Ave, Everett",
    "address": "2917 Hoyt Ave., Everett"
  },
  {
    "id": 2015,
    "financing": "Federally subsidized",
    "building_name": "Artspace Mt. Baker Lofts",
    "latitude": 47.577242,
    "longitude": -122.29778,
    "original_address": "2915 Rainier Avenue South",
    "building_number": 2915,
    "street": "Rainier Ave S",
    "city": "Seattle",
    "zip": 98144,
    "concatenated_address": "2915 Rainier Ave S, Seattle",
    "address": "2915 Rainier Ave. S., Seattle"
  },
  {
    "id": 2016,
    "financing": "Federally subsidized",
    "building_name": "Artspace Mt. Baker Station Lofts",
    "latitude": 47.577242,
    "longitude": -122.29778,
    "original_address": "2915 Rainier Ave. S",
    "building_number": 2915,
    "street": "Rainier Ave S",
    "city": "Seattle",
    "zip": 98144,
    "concatenated_address": "2915 Rainier Ave S, Seattle",
    "address": "2915 Rainier Ave. S., Seattle"
  },
  {
    "id": 2017,
    "financing": "Federally subsidized",
    "building_name": "Ascona",
    "latitude": 47.600717,
    "longitude": -122.32738,
    "original_address": "200 Fifth Avenue S",
    "building_number": 200,
    "street": "5th Ave S",
    "city": "Seattle",
    "zip": 98104,
    "concatenated_address": "200 5th Ave S, Seattle",
    "address": "200 5th Ave. S., Seattle"
  },
  {
    "id": 2018,
    "financing": "Federally subsidized",
    "building_name": "Ashford House I Apartments",
    "latitude": 47.45335,
    "longitude": -122.82002,
    "original_address": "24170 Ne Highway 3",
    "building_number": 24170,
    "street": "NE State Route 3",
    "city": "Belfair",
    "zip": 98528,
    "concatenated_address": "24170 NE State Route 3, Belfair",
    "address": "24170 N.E. State Route 3, Belfair"
  },
  {
    "id": 2019,
    "financing": "Federally subsidized",
    "building_name": "Ashford House II Apartments",
    "latitude": 47.453301,
    "longitude": -122.82595,
    "original_address": "170 State Route 300",
    "building_number": 170,
    "street": "NE State Route 300",
    "city": "Belfair",
    "zip": 98528,
    "concatenated_address": "170 NE State Route 300, Belfair",
    "address": "170 N.E. State Route 300, Belfair"
  },
  {
    "id": 2020,
    "financing": "Federally subsidized",
    "building_name": "Ashwood Court",
    "latitude": 47.620364,
    "longitude": -122.19277,
    "original_address": "11018 Ne 11th St",
    "building_number": 11018,
    "street": "NE 11th St",
    "city": "Bellevue",
    "zip": 98004,
    "concatenated_address": "11018 NE 11th St, Bellevue",
    "address": "11018 N.E. 11th St., Bellevue"
  },
  {
    "id": 2021,
    "financing": "Federally subsidized",
    "building_name": "Ashwood Downs",
    "latitude": 47.031342,
    "longitude": -122.84882,
    "original_address": "1900 Ashwood Downs Lane Se",
    "building_number": 1900,
    "street": "Ashwood Downs Ln SE",
    "city": "Olympia",
    "zip": 98501,
    "concatenated_address": "1900 Ashwood Downs Ln SE, Olympia",
    "address": "1900 Ashwood Downs Lane S.E., Olympia"
  },
  {
    "id": 2022,
    "financing": "Federally subsidized",
    "building_name": "Athene",
    "latitude": 47.709515,
    "longitude": -122.17278,
    "original_address": "12531 Ne 124th St.",
    "building_number": 12531,
    "street": "NE 124th St",
    "city": "Kirkland",
    "zip": 98034,
    "concatenated_address": "12531 NE 124th St, Kirkland",
    "address": "12531 N.E. 124th St., Kirkland"
  },
  {
    "id": 2023,
    "financing": "Federally subsidized",
    "building_name": "Atherton Woods",
    "latitude": 45.65715,
    "longitude": -122.59774,
    "original_address": "4719 Ne 72nd Avenue",
    "building_number": 4719,
    "street": "NE 72nd Ave",
    "city": "Vancouver",
    "zip": 98661,
    "concatenated_address": "4719 NE 72nd Ave, Vancouver",
    "address": "4719 N.E. 72nd Ave., Vancouver"
  },
  {
    "id": 2024,
    "financing": "Federally subsidized",
    "building_name": "Auburn Court Apartments",
    "latitude": 47.31614,
    "longitude": -122.2289,
    "original_address": "102 - 10th Street Ne",
    "building_number": 102,
    "street": "10th St NE",
    "city": "Auburn",
    "zip": 98002,
    "concatenated_address": "102 10th St NE, Auburn",
    "address": "102 10th St. N.E., Auburn"
  },
  {
    "id": 2025,
    "financing": "Federally subsidized",
    "building_name": "Auburn Manor Apartments",
    "latitude": 47.319581,
    "longitude": -122.21732,
    "original_address": "950 14th Street Northeast",
    "building_number": 950,
    "street": "14th St NE",
    "city": "Auburn",
    "zip": 98002,
    "concatenated_address": "950 14th St NE, Auburn",
    "address": "950 14th St. N.E., Auburn"
  },
  {
    "id": 2026,
    "financing": "Federally subsidized",
    "building_name": "Auburn Square",
    "latitude": 47.34131,
    "longitude": -122.21973,
    "original_address": "3740 H Street Ne",
    "building_number": 3740,
    "street": "H St NE",
    "city": "Auburn",
    "zip": 98002,
    "concatenated_address": "3740 H St NE, Auburn",
    "address": "3740 H St. N.E., Auburn"
  },
  {
    "id": 2027,
    "financing": "Federally subsidized",
    "building_name": "August Wilson Place",
    "latitude": 47.612197,
    "longitude": -122.19199,
    "original_address": "204 111th Avenue Ne",
    "building_number": 204,
    "street": "111th Ave NE",
    "city": "Bellevue",
    "zip": "98004-5819",
    "concatenated_address": "204 111th Ave NE, Bellevue",
    "address": "204 111th Ave. N.E., Bellevue"
  },
  {
    "id": 2028,
    "financing": "Federally subsidized",
    "building_name": "Aurora Place Apartments",
    "latitude": 45.64693,
    "longitude": -122.58854,
    "original_address": "8105 Ne Fourth Plain Blvd",
    "building_number": 8105,
    "street": "NE 4th Plain Blvd",
    "city": "Vancouver",
    "zip": 98662,
    "concatenated_address": "8105 NE 4th Plain Blvd, Vancouver",
    "address": "8105 N.E. 4th Plain Blvd., Vancouver"
  },
  {
    "id": 2029,
    "financing": "Federally subsidized",
    "building_name": "Aurora Supportive Housing",
    "latitude": 47.705476,
    "longitude": -122.34504,
    "original_address": "10507 Aurora Avenue N.",
    "building_number": 10507,
    "street": "Aurora Ave N",
    "city": "Seattle",
    "zip": 98133,
    "concatenated_address": "10507 Aurora Ave N, Seattle",
    "address": "10507 Aurora Ave. N., Seattle"
  },
  {
    "id": 2030,
    "financing": "Federally subsidized",
    "building_name": "Austen Manor Apartments",
    "latitude": 46.411019,
    "longitude": -117.05437,
    "original_address": "1222 Chestnut Street",
    "building_number": 1222,
    "street": "Chestnut St",
    "city": "Clarkston",
    "zip": 99403,
    "concatenated_address": "1222 Chestnut St, Clarkston",
    "address": "1222 Chestnut St., Clarkston"
  },
  {
    "id": 2031,
    "financing": "Federally subsidized",
    "building_name": "Autumn Ridge",
    "latitude": 46.443657,
    "longitude": -120.42608,
    "original_address": "509 S Tieton Ave",
    "building_number": 509,
    "street": "S Tieton Ave",
    "city": "Wapato",
    "zip": 98951,
    "concatenated_address": "509 S Tieton Ave, Wapato",
    "address": "509 S. Tieton Ave., Wapato"
  },
  {
    "id": 2032,
    "financing": "Federally subsidized",
    "building_name": "Autumn Ridge II",
    "latitude": 46.443811,
    "longitude": -120.42408,
    "original_address": "402 West 6th Street",
    "building_number": 402,
    "street": "W 6th St",
    "city": "Wapato",
    "zip": 98951,
    "concatenated_address": "402 W 6th St, Wapato",
    "address": "402 W. 6th St., Wapato"
  },
  {
    "id": 2033,
    "financing": "Federally subsidized",
    "building_name": "Avaire Apartments",
    "latitude": 47.91999,
    "longitude": -122.24552,
    "original_address": "824 West Casino Road",
    "building_number": 824,
    "street": "W Casino Rd",
    "city": "Everett",
    "zip": 98204,
    "concatenated_address": "824 W Casino Rd, Everett",
    "address": "824 W. Casino Road, Everett"
  },
  {
    "id": 2034,
    "financing": "Federally subsidized",
    "building_name": "Avondale Park",
    "latitude": 47.686554,
    "longitude": -122.09515,
    "original_address": "18435 Ne 98th Way",
    "building_number": 18435,
    "street": "NE 98th Way",
    "city": "Redmond",
    "zip": 98052,
    "concatenated_address": "18435 NE 98th Way, Redmond",
    "address": "18435 N.E. 98th Way, Redmond"
  },
  {
    "id": 2035,
    "financing": "Federally subsidized",
    "building_name": "Avondale Village",
    "latitude": 47.883229,
    "longitude": -122.25953,
    "original_address": "12709 Avondale Way",
    "building_number": 12709,
    "street": "Avondale Way",
    "city": "Everett",
    "zip": "98204-5570",
    "concatenated_address": "12709 Avondale Way, Everett",
    "address": "12709 Avondale Way, Everett"
  },
  {
    "id": 2036,
    "financing": "Federally subsidized",
    "building_name": "Axis Apartments",
    "latitude": 47.888244,
    "longitude": -122.25955,
    "original_address": "12118 Highway 99",
    "building_number": 12118,
    "street": "Pacific Hwy",
    "city": "Everett",
    "zip": 98204,
    "concatenated_address": "12118 Pacific Hwy, Everett",
    "address": "12118 Pacific Highway, Everett"
  },
  {
    "id": 2037,
    "financing": "Federally subsidized",
    "building_name": "Baird Springs Apartments",
    "latitude": 47.324691,
    "longitude": -119.53544,
    "original_address": "1120 3rd Avenue Ne",
    "building_number": 1120,
    "street": "3rd Ave NE",
    "city": "Ephrata",
    "zip": 98823,
    "concatenated_address": "1120 3rd Ave NE, Ephrata",
    "address": "1120 3rd Ave. N.E., Ephrata"
  },
  {
    "id": 2038,
    "financing": "Federally subsidized",
    "building_name": "Bakerview Grandview Affordable Housing Lllp",
    "latitude": 47.998121,
    "longitude": -122.19454,
    "original_address": "2605 15th Street",
    "building_number": 2605,
    "street": "15th St",
    "city": "Everett",
    "zip": 98201,
    "concatenated_address": "2605 15th St, Everett",
    "address": "2605 15th St., Everett"
  },
  {
    "id": 2039,
    "financing": "Federally subsidized",
    "building_name": "Bakhita Gardens-Rose Of Lima",
    "latitude": 47.613862,
    "longitude": -122.34611,
    "original_address": "118 Bell St.",
    "building_number": 118,
    "street": "Bell St",
    "city": "Seattle",
    "zip": 98101,
    "concatenated_address": "118 Bell St, Seattle",
    "address": "118 Bell St., Seattle"
  },
  {
    "id": 2040,
    "financing": "Federally subsidized",
    "building_name": "Balfour Place",
    "latitude": 47.617723,
    "longitude": -122.33138,
    "original_address": "1820 Minor Avenue",
    "building_number": 1820,
    "street": "Minor Ave",
    "city": "Seattle",
    "zip": 98101,
    "concatenated_address": "1820 Minor Ave, Seattle",
    "address": "1820 Minor Ave., Seattle"
  },
  {
    "id": 2041,
    "financing": "Federally subsidized",
    "building_name": "Ballinger Court Apartments",
    "latitude": 47.793108,
    "longitude": -122.3348,
    "original_address": "22707 - 76th Avenue W",
    "building_number": 22707,
    "street": "76th Ave W",
    "city": "Edmonds",
    "zip": "98026-8490",
    "concatenated_address": "22707 76th Ave W, Edmonds",
    "address": "22707 76th Ave. W., Edmonds"
  },
  {
    "id": 2042,
    "financing": "Federally subsidized",
    "building_name": "Ballou Apartments",
    "latitude": 47.628858,
    "longitude": -117.55129,
    "original_address": "4150 W Ft George Wright Dr",
    "building_number": "",
    "street": "",
    "city": "Spokane",
    "zip": 99224,
    "concatenated_address": "4150 W Ft George Wright Dr, Spokane",
    "address": "4150 W. Ft George Wright Drive, Spokane"
  },
  {
    "id": 2043,
    "financing": "Federally subsidized",
    "building_name": "Barkley Ridge Apartments",
    "latitude": 47.351507,
    "longitude": -122.30978,
    "original_address": "27830 Pacific Hwy South",
    "building_number": 27830,
    "street": "Pacific Hwy S",
    "city": "Federal Way",
    "zip": "98003-3401",
    "concatenated_address": "27830 Pacific Hwy S, Federal Way",
    "address": "27830 Pacific Highway S., Federal Way"
  },
  {
    "id": 2044,
    "financing": "Federally subsidized",
    "building_name": "Bart Harvey",
    "latitude": 47.622924,
    "longitude": -122.33265,
    "original_address": "430 Minor Avenue N",
    "building_number": 430,
    "street": "Minor Ave N",
    "city": "Seattle",
    "zip": 98109,
    "concatenated_address": "430 Minor Ave N, Seattle",
    "address": "430 Minor Ave. N., Seattle"
  },
  {
    "id": 2045,
    "financing": "Federally subsidized",
    "building_name": "Battle Ground Place Apartments",
    "latitude": 45.779752,
    "longitude": -122.54117,
    "original_address": "112 Sw 3rd Ave",
    "building_number": 112,
    "street": "SW 3rd Ave",
    "city": "Battle Ground",
    "zip": 98604,
    "concatenated_address": "112 SW 3rd Ave, Battle Ground",
    "address": "112 S.W. 3rd Ave., Battle Ground"
  },
  {
    "id": 2046,
    "financing": "Federally subsidized",
    "building_name": "Bavarian Village",
    "latitude": 47.593756,
    "longitude": -120.67515,
    "original_address": "330 Prospect St",
    "building_number": 330,
    "street": "Prospect St",
    "city": "Leavenworth",
    "zip": 98826,
    "concatenated_address": "330 Prospect St, Leavenworth",
    "address": "330 Prospect St., Leavenworth"
  },
  {
    "id": 2047,
    "financing": "Federally subsidized",
    "building_name": "Bay Terrace",
    "latitude": 47.238051,
    "longitude": -122.44263,
    "original_address": "2500 S G St",
    "building_number": 2500,
    "street": "S G St",
    "city": "Tacoma",
    "zip": 98405,
    "concatenated_address": "2500 S G St, Tacoma",
    "address": "2500 S. G St., Tacoma"
  },
  {
    "id": 2048,
    "financing": "Federally subsidized",
    "building_name": "Bay Terrace Phase II",
    "latitude": 47.238027,
    "longitude": -122.44395,
    "original_address": "2505 S Yakima Ave",
    "building_number": 2505,
    "street": "S Yakima Ave",
    "city": "Tacoma",
    "zip": 98405,
    "concatenated_address": "2505 S Yakima Ave, Tacoma",
    "address": "2505 S. Yakima Ave., Tacoma"
  },
  {
    "id": 2049,
    "financing": "Federally subsidized",
    "building_name": "Bay Vista South",
    "latitude": 47.561971,
    "longitude": -122.67377,
    "original_address": "4417 Conch St",
    "building_number": 4417,
    "street": "Conch St",
    "city": "Bremerton",
    "zip": 98312,
    "concatenated_address": "4417 Conch St, Bremerton",
    "address": "4417 Conch St., Bremerton"
  },
  {
    "id": 2050,
    "financing": "Federally subsidized",
    "building_name": "Bay Vista West",
    "latitude": 47.575851,
    "longitude": -122.68884,
    "original_address": "5670 Kitsap Way",
    "building_number": 5670,
    "street": "Kitsap Way",
    "city": "Bremerton",
    "zip": 98312,
    "concatenated_address": "5670 Kitsap Way, Bremerton",
    "address": "5670 Kitsap Way, Bremerton"
  },
  {
    "id": 2051,
    "financing": "Federally subsidized",
    "building_name": "Bays Water",
    "latitude": 47.235923,
    "longitude": -122.53344,
    "original_address": "2632 Cascade Pl W",
    "building_number": 2632,
    "street": "Cascade Pl W",
    "city": "Tacoma",
    "zip": "98466-5332",
    "concatenated_address": "2632 Cascade Pl W, Tacoma",
    "address": "2632 Cascade Pl W., Tacoma"
  },
  {
    "id": 2052,
    "financing": "Federally subsidized",
    "building_name": "Bayshore Court",
    "latitude": 47.844273,
    "longitude": -120.01978,
    "original_address": "510 Cedar Street",
    "building_number": 510,
    "street": "N Cedar St",
    "city": "Chelan",
    "zip": 98816,
    "concatenated_address": "510 N Cedar St, Chelan",
    "address": "510 N. Cedar St., Chelan"
  },
  {
    "id": 2053,
    "financing": "Federally subsidized",
    "building_name": "Bayside",
    "latitude": 48.503327,
    "longitude": -122.61498,
    "original_address": "1106 24th St",
    "building_number": 1106,
    "street": "24th St",
    "city": "Anacortes",
    "zip": 98221,
    "concatenated_address": "1106 24th St, Anacortes",
    "address": "1106 24th St., Anacortes"
  },
  {
    "id": 2054,
    "financing": "Federally subsidized",
    "building_name": "Bayview Apartments",
    "latitude": 48.498665,
    "longitude": -122.61121,
    "original_address": "801 29th St",
    "building_number": 801,
    "street": "29th St",
    "city": "Anacortes",
    "zip": 98221,
    "concatenated_address": "801 29th St, Anacortes",
    "address": "801 29th St., Anacortes"
  },
  {
    "id": 2055,
    "financing": "Federally subsidized",
    "building_name": "Bayview Apartments",
    "latitude": 47.615451,
    "longitude": -122.35039,
    "original_address": "2615 First Ave",
    "building_number": 2615,
    "street": "1st Ave",
    "city": "Seattle",
    "zip": 98121,
    "concatenated_address": "2615 1st Ave, Seattle",
    "address": "2615 1st Ave., Seattle"
  },
  {
    "id": 2056,
    "financing": "Federally subsidized",
    "building_name": "Bayview Gardens",
    "latitude": 48.242755,
    "longitude": -122.33954,
    "original_address": "7822 272nd. N.W.",
    "building_number": 7822,
    "street": "272nd St",
    "city": "Stanwood",
    "zip": 98292,
    "concatenated_address": "7822 272nd St, Stanwood",
    "address": "7822 272nd St., Stanwood"
  },
  {
    "id": 2057,
    "financing": "Federally subsidized",
    "building_name": "Beach Court Apartments",
    "latitude": 47.525382,
    "longitude": -122.26959,
    "original_address": "8630 Rainier Avenue South",
    "building_number": 8630,
    "street": "Rainier Ave S",
    "city": "Seattle",
    "zip": 98118,
    "concatenated_address": "8630 Rainier Ave S, Seattle",
    "address": "8630 Rainier Ave. S., Seattle"
  },
  {
    "id": 2058,
    "financing": "Federally subsidized",
    "building_name": "Beachwood",
    "latitude": 48.058196,
    "longitude": -122.18285,
    "original_address": "1027 Beach Avenue",
    "building_number": 1027,
    "street": "Beach Ave",
    "city": "Marysville",
    "zip": "98270-4224",
    "concatenated_address": "1027 Beach Ave, Marysville",
    "address": "1027 Beach Ave., Marysville"
  },
  {
    "id": 2059,
    "financing": "Federally subsidized",
    "building_name": "Beacon Manor Apartments",
    "latitude": 48.846334,
    "longitude": -122.60775,
    "original_address": "2308 Douglas Road",
    "building_number": 2308,
    "street": "Douglas Rd",
    "city": "Ferndale",
    "zip": 98248,
    "concatenated_address": "2308 Douglas Rd, Ferndale",
    "address": "2308 Douglas Road, Ferndale"
  },
  {
    "id": 2060,
    "financing": "Federally subsidized",
    "building_name": "Beasley Hills Apartments",
    "latitude": 47.323572,
    "longitude": -119.53454,
    "original_address": "1211 2nd Avenue Ne",
    "building_number": 1223,
    "street": "2nd Ave NE",
    "city": "Ephrata",
    "zip": 98823,
    "concatenated_address": "1223 2nd Ave NE, Ephrata",
    "address": "1223 2nd Ave. N.E., Ephrata"
  },
  {
    "id": 2061,
    "financing": "Federally subsidized",
    "building_name": "Beaver Cove Apartment Homes",
    "latitude": 47.81867,
    "longitude": -122.30064,
    "original_address": "19800 50th Avenue West",
    "building_number": 19800,
    "street": "50th Ave W",
    "city": "Lynnwood",
    "zip": 98036,
    "concatenated_address": "19800 50th Ave W, Lynnwood",
    "address": "19800 50th Ave. W., Lynnwood"
  },
  {
    "id": 2062,
    "financing": "Federally subsidized",
    "building_name": "Beaver Creek Apartment Homes",
    "latitude": 47.817924,
    "longitude": -122.29914,
    "original_address": "4807 200th St. Sw",
    "building_number": 4807,
    "street": "200th St SW",
    "city": "Lynnwood",
    "zip": 98036,
    "concatenated_address": "4807 200th St SW, Lynnwood",
    "address": "4807 200th St. S.W., Lynnwood"
  },
  {
    "id": 2063,
    "financing": "Federally subsidized",
    "building_name": "Beech Street Apartments",
    "latitude": 46.597511,
    "longitude": -120.48373,
    "original_address": "1402 E Beech Street 105",
    "building_number": 1402,
    "street": "E Beech St",
    "city": "Yakima",
    "zip": 98901,
    "concatenated_address": "1402 E Beech St, Yakima",
    "address": "1402 E. Beech St., Yakima"
  },
  {
    "id": 2064,
    "financing": "Federally subsidized",
    "building_name": "Bel Franklin Apartments",
    "latitude": 47.659891,
    "longitude": -117.4114,
    "original_address": "225 N Division St",
    "building_number": 225,
    "street": "N Division St",
    "city": "Spokane",
    "zip": 99201,
    "concatenated_address": "225 N Division St, Spokane",
    "address": "225 N. Division St., Spokane"
  },
  {
    "id": 2065,
    "financing": "Federally subsidized",
    "building_name": "Bell Hotel",
    "latitude": 47.320551,
    "longitude": -119.55181,
    "original_address": "210 W Division St",
    "building_number": 210,
    "street": "W Division Ave",
    "city": "Ephrata",
    "zip": 98823,
    "concatenated_address": "210 W Division Ave, Ephrata",
    "address": "210 W. Division Ave., Ephrata"
  },
  {
    "id": 2066,
    "financing": "Federally subsidized",
    "building_name": "Bellevue/Olive Apartments",
    "latitude": 47.61666,
    "longitude": -122.32707,
    "original_address": "1641 Bellevue Ave",
    "building_number": 1641,
    "street": "Bellevue Ave",
    "city": "Seattle",
    "zip": 98122,
    "concatenated_address": "1641 Bellevue Ave, Seattle",
    "address": "1641 Bellevue Ave., Seattle"
  },
  {
    "id": 2067,
    "financing": "Federally subsidized",
    "building_name": "Bello Rio",
    "latitude": 47.437693,
    "longitude": -120.30193,
    "original_address": "2017 Nw Cascade Ave",
    "building_number": 2017,
    "street": "NW Cascade Ave",
    "city": "East Wenatchee",
    "zip": 98802,
    "concatenated_address": "2017 NW Cascade Ave, East Wenatchee",
    "address": "2017 N.W. Cascade Ave., East Wenatchee"
  },
  {
    "id": 2068,
    "financing": "Federally subsidized",
    "building_name": "Belltown Senior Apartments",
    "latitude": 47.613626,
    "longitude": -122.3446,
    "original_address": "2208 Second Avenue",
    "building_number": 2208,
    "street": "2nd Ave",
    "city": "Seattle",
    "zip": 98121,
    "concatenated_address": "2208 2nd Ave, Seattle",
    "address": "2208 2nd Ave., Seattle"
  },
  {
    "id": 2069,
    "financing": "Federally subsidized",
    "building_name": "Belmont/Boylston",
    "latitude": 47.613405,
    "longitude": -122.32365,
    "original_address": "1411 Boylston Ave",
    "building_number": 1411,
    "street": "Boylston Ave",
    "city": "Seattle",
    "zip": 98122,
    "concatenated_address": "1411 Boylston Ave, Seattle",
    "address": "1411 Boylston Ave., Seattle"
  },
  {
    "id": 2070,
    "financing": "Federally subsidized",
    "building_name": "Benson East Duplexes",
    "latitude": 47.402125,
    "longitude": -122.19435,
    "original_address": "10945 Se 223rd St",
    "building_number": 10945,
    "street": "SE 223rd St",
    "city": "Kent",
    "zip": 98031,
    "concatenated_address": "10945 SE 223rd St, Kent",
    "address": "10945 S.E. 223rd St., Kent"
  },
  {
    "id": 2071,
    "financing": "Federally subsidized",
    "building_name": "Berg Rose",
    "latitude": 47.593356,
    "longitude": -120.67546,
    "original_address": "263 Mine St.",
    "building_number": 263,
    "street": "Mine St",
    "city": "Leavenworth",
    "zip": 98826,
    "concatenated_address": "263 Mine St, Leavenworth",
    "address": "263 Mine St., Leavenworth"
  },
  {
    "id": 2072,
    "financing": "Federally subsidized",
    "building_name": "Bergan Place Apartments",
    "latitude": 47.70414,
    "longitude": -122.35791,
    "original_address": "101 North 104th St.",
    "building_number": 101,
    "street": "N 104th St",
    "city": "Seattle",
    "zip": 98133,
    "concatenated_address": "101 N 104th St, Seattle",
    "address": "101 N. 104th St., Seattle"
  },
  {
    "id": 2073,
    "financing": "Federally subsidized",
    "building_name": "Bernadette Place",
    "latitude": 47.665837,
    "longitude": -117.45406,
    "original_address": "925 N. A St.",
    "building_number": 925,
    "street": "N A St",
    "city": "Spokane",
    "zip": 99201,
    "concatenated_address": "925 N A St, Spokane",
    "address": "925 N. A St., Spokane"
  },
  {
    "id": 2074,
    "financing": "Federally subsidized",
    "building_name": "Berneva Apartments",
    "latitude": 47.624285,
    "longitude": -122.31038,
    "original_address": "535 17th Avenue E",
    "building_number": 535,
    "street": "17th Ave E",
    "city": "Seattle",
    "zip": 98112,
    "concatenated_address": "535 17th Ave E, Seattle",
    "address": "535 17th Ave. E., Seattle"
  },
  {
    "id": 2075,
    "financing": "Federally subsidized",
    "building_name": "Bethany House",
    "latitude": 47.600439,
    "longitude": -122.29227,
    "original_address": "212 31st Avenue S",
    "building_number": 212,
    "street": "31st Ave S",
    "city": "Seattle",
    "zip": 98144,
    "concatenated_address": "212 31st Ave S, Seattle",
    "address": "212 31st Ave. S., Seattle"
  },
  {
    "id": 2076,
    "financing": "Federally subsidized",
    "building_name": "Beverly Lane",
    "latitude": 47.234216,
    "longitude": -119.85832,
    "original_address": "301 3rd Ave. S.W.",
    "building_number": 301,
    "street": "3rd Ave SW",
    "city": "Quincy",
    "zip": 98848,
    "concatenated_address": "301 3rd Ave SW, Quincy",
    "address": "301 3rd Ave. S.W., Quincy"
  },
  {
    "id": 2077,
    "financing": "Federally subsidized",
    "building_name": "Beverly Park Group Home",
    "latitude": 47.501576,
    "longitude": -122.33562,
    "original_address": "150 Sw 114th Street",
    "building_number": 150,
    "street": "SW 114th St",
    "city": "Seattle",
    "zip": 98146,
    "concatenated_address": "150 SW 114th St, Seattle",
    "address": "150 S.W. 114th St., Seattle"
  },
  {
    "id": 2078,
    "financing": "Federally subsidized",
    "building_name": "Billy Frank Jr. Place",
    "latitude": 47.04627,
    "longitude": -122.89849,
    "original_address": "318 State Avenue",
    "building_number": 318,
    "street": "State Ave NE",
    "city": "Olympia",
    "zip": 98501,
    "concatenated_address": "318 State Ave NE, Olympia",
    "address": "318 State Ave. N.E., Olympia"
  },
  {
    "id": 2079,
    "financing": "Federally subsidized",
    "building_name": "Birch Creek Apartments",
    "latitude": 47.355839,
    "longitude": -122.16879,
    "original_address": "27360 - 129th Place Se",
    "building_number": 27360,
    "street": "129th Pl SE",
    "city": "Kent",
    "zip": "98030-8922",
    "concatenated_address": "27360 129th Pl SE, Kent",
    "address": "27360 129th Pl S.E., Kent"
  },
  {
    "id": 2080,
    "financing": "Federally subsidized",
    "building_name": "Birch Street Apartments",
    "latitude": 47.229533,
    "longitude": -119.87187,
    "original_address": "1010 Birch Street",
    "building_number": 1010,
    "street": "Birch St SW",
    "city": "Quincy",
    "zip": 98848,
    "concatenated_address": "1010 Birch St SW, Quincy",
    "address": "1010 Birch St. S.W., Quincy"
  },
  {
    "id": 2081,
    "financing": "Federally subsidized",
    "building_name": "Bishop Park",
    "latitude": 48.105787,
    "longitude": -122.79469,
    "original_address": "819 Hancock St.",
    "building_number": 819,
    "street": "Hancock St",
    "city": "Port Townsend",
    "zip": 98368,
    "concatenated_address": "819 Hancock St, Port Townsend",
    "address": "819 Hancock St., Port Townsend"
  },
  {
    "id": 2082,
    "financing": "Federally subsidized",
    "building_name": "Bishop Topel Haven",
    "latitude": 46.241414,
    "longitude": -119.0768,
    "original_address": "1534 East Spokane Street",
    "building_number": 1534,
    "street": "E Spokane St",
    "city": "Pasco",
    "zip": 99301,
    "concatenated_address": "1534 E Spokane St, Pasco",
    "address": "1534 E. Spokane St., Pasco"
  },
  {
    "id": 2083,
    "financing": "Federally subsidized",
    "building_name": "Blair Gardens",
    "latitude": 48.919013,
    "longitude": -122.3373,
    "original_address": "103 Blair Dr",
    "building_number": 103,
    "street": "Blair Dr",
    "city": "Everson",
    "zip": 98247,
    "concatenated_address": "103 Blair Dr, Everson",
    "address": "103 Blair Drive, Everson"
  },
  {
    "id": 2084,
    "financing": "Federally subsidized",
    "building_name": "Blakely At Echo Lake",
    "latitude": 47.768647,
    "longitude": -122.34474,
    "original_address": "1140 N 192nd St",
    "building_number": 1140,
    "street": "N 192nd St",
    "city": "Seattle",
    "zip": "98133-3931",
    "concatenated_address": "1140 N 192nd St, Seattle",
    "address": "1140 N. 192nd St., Seattle"
  },
  {
    "id": 2085,
    "financing": "Federally subsidized",
    "building_name": "Blessed Kateri Village",
    "latitude": 46.437878,
    "longitude": -120.41201,
    "original_address": "1000 Kateri Ln",
    "building_number": 1000,
    "street": "Kateri Ln",
    "city": "Wapato",
    "zip": 98951,
    "concatenated_address": "1000 Kateri Ln, Wapato",
    "address": "1000 Kateri Lane, Wapato"
  },
  {
    "id": 2086,
    "financing": "Federally subsidized",
    "building_name": "Blue Mountain Senior College Place",
    "latitude": 46.053847,
    "longitude": -118.37556,
    "original_address": "342 Della Street",
    "building_number": 342,
    "street": "NE Della Ave",
    "city": "College Place",
    "zip": 99324,
    "concatenated_address": "342 NE Della Ave, College Place",
    "address": "342 N.E. Della Ave., College Place"
  },
  {
    "id": 2087,
    "financing": "Federally subsidized",
    "building_name": "Blue Mountain Senior Walla Walla",
    "latitude": 46.056487,
    "longitude": -118.34353,
    "original_address": "504 Malcolm Street",
    "building_number": 504,
    "street": "Malcolm St",
    "city": "Walla Walla",
    "zip": 99362,
    "concatenated_address": "504 Malcolm St, Walla Walla",
    "address": "504 Malcolm St., Walla Walla"
  },
  {
    "id": 2088,
    "financing": "Federally subsidized",
    "building_name": "Blue Street",
    "latitude": 46.075625,
    "longitude": -118.31455,
    "original_address": "315 Blue Street",
    "building_number": 315,
    "street": "N Blue St",
    "city": "Walla Walla",
    "zip": 99362,
    "concatenated_address": "315 N Blue St, Walla Walla",
    "address": "315 N. Blue St., Walla Walla"
  },
  {
    "id": 2089,
    "financing": "Federally subsidized",
    "building_name": "Bluffs At Evergreen",
    "latitude": 47.919945,
    "longitude": -122.23367,
    "original_address": "2 West Casino Road",
    "building_number": 2,
    "street": "W Casino Rd",
    "city": "Everett",
    "zip": 98204,
    "concatenated_address": "2 W Casino Rd, Everett",
    "address": "2 W. Casino Road, Everett"
  },
  {
    "id": 2090,
    "financing": "Federally subsidized",
    "building_name": "Boardwalk Apartments",
    "latitude": 47.047936,
    "longitude": -122.90148,
    "original_address": "410 Capitol Way North",
    "building_number": 410,
    "street": "Capitol Way N",
    "city": "Olympia",
    "zip": "98501-8220",
    "concatenated_address": "410 Capitol Way N, Olympia",
    "address": "410 Capitol Way N., Olympia"
  },
  {
    "id": 2091,
    "financing": "Federally subsidized",
    "building_name": "Boh Preservation Portfolio",
    "latitude": 47.492627,
    "longitude": -122.29592,
    "original_address": "12400 28th Ave. S.",
    "building_number": 12400,
    "street": "28th Ave S",
    "city": "Seattle",
    "zip": 98168,
    "concatenated_address": "12400 28th Ave S, Seattle",
    "address": "12400 28th Ave. S., Seattle"
  },
  {
    "id": 2092,
    "financing": "Federally subsidized",
    "building_name": "Bonair",
    "latitude": 47.614435,
    "longitude": -122.33421,
    "original_address": "1806 Eighth Ave",
    "building_number": 1806,
    "street": "8th Ave",
    "city": "Seattle",
    "zip": 98101,
    "concatenated_address": "1806 8th Ave, Seattle",
    "address": "1806 8th Ave., Seattle"
  },
  {
    "id": 2093,
    "financing": "Federally subsidized",
    "building_name": "Boulevard Place",
    "latitude": 47.760475,
    "longitude": -122.20764,
    "original_address": "18221 Bothell Way",
    "building_number": 18221,
    "street": "Bothell Way NE",
    "city": "Bothell",
    "zip": 98011,
    "concatenated_address": "18221 Bothell Way NE, Bothell",
    "address": "18221 Bothell Way N.E., Bothell"
  },
  {
    "id": 2094,
    "financing": "Federally subsidized",
    "building_name": "Boundary Village",
    "latitude": 49.001618,
    "longitude": -122.74157,
    "original_address": "730 A Street",
    "building_number": 730,
    "street": "A St",
    "city": "Blaine",
    "zip": 98230,
    "concatenated_address": "730 A St, Blaine",
    "address": "730 A St., Blaine"
  },
  {
    "id": 2095,
    "financing": "Federally subsidized",
    "building_name": "Boylston Howell Apartments",
    "latitude": 47.617348,
    "longitude": -122.3231,
    "original_address": "1726 Boylston Avenue",
    "building_number": 1726,
    "street": "Boylston Ave",
    "city": "Seattle",
    "zip": 98122,
    "concatenated_address": "1726 Boylston Ave, Seattle",
    "address": "1726 Boylston Ave., Seattle"
  },
  {
    "id": 2096,
    "financing": "Federally subsidized",
    "building_name": "Brandenwood Apartments",
    "latitude": 47.646627,
    "longitude": -122.14606,
    "original_address": "14520 Ne 40th St.",
    "building_number": 14520,
    "street": "NE 40th St",
    "city": "Bellevue",
    "zip": 98007,
    "concatenated_address": "14520 NE 40th St, Bellevue",
    "address": "14520 N.E. 40th St., Bellevue"
  },
  {
    "id": 2097,
    "financing": "Federally subsidized",
    "building_name": "Brandenwood Senior Apartments",
    "latitude": 47.646627,
    "longitude": -122.14606,
    "original_address": "14520 Ne 40th Street",
    "building_number": 14520,
    "street": "NE 40th St",
    "city": "Bellevue",
    "zip": 98007,
    "concatenated_address": "14520 NE 40th St, Bellevue",
    "address": "14520 N.E. 40th St., Bellevue"
  },
  {
    "id": 2098,
    "financing": "Federally subsidized",
    "building_name": "Brant Apartments",
    "latitude": 47.260401,
    "longitude": -122.44582,
    "original_address": "247 Tacoma Avenue S",
    "building_number": 247,
    "street": "Tacoma Ave S",
    "city": "Tacoma",
    "zip": 98402,
    "concatenated_address": "247 Tacoma Ave S, Tacoma",
    "address": "247 Tacoma Ave. S., Tacoma"
  },
  {
    "id": 2099,
    "financing": "Federally subsidized",
    "building_name": "Bremer Apartments",
    "latitude": 47.616785,
    "longitude": -122.35316,
    "original_address": "2905 First Avenue",
    "building_number": 2905,
    "street": "1st Ave",
    "city": "Seattle",
    "zip": 98121,
    "concatenated_address": "2905 1st Ave, Seattle",
    "address": "2905 1st Ave., Seattle"
  },
  {
    "id": 2100,
    "financing": "Federally subsidized",
    "building_name": "Brentwood Apartments",
    "latitude": 46.206163,
    "longitude": -119.16532,
    "original_address": "3204 West 4th",
    "building_number": 3204,
    "street": "W 4th Ave",
    "city": "Kennewick",
    "zip": 99336,
    "concatenated_address": "3204 W 4th Ave, Kennewick",
    "address": "3204 W. 4th Ave., Kennewick"
  },
  {
    "id": 2101,
    "financing": "Federally subsidized",
    "building_name": "Brettler Family Housing",
    "latitude": 47.678053,
    "longitude": -122.2617,
    "original_address": "6800 62nd Avenue Ne",
    "building_number": 6800,
    "street": "62nd Ave NE",
    "city": "Seattle",
    "zip": 98115,
    "concatenated_address": "6800 62nd Ave NE, Seattle",
    "address": "6800 62nd Ave. N.E., Seattle"
  },
  {
    "id": 2102,
    "financing": "Federally subsidized",
    "building_name": "Brewster",
    "latitude": 47.619511,
    "longitude": -122.3326,
    "original_address": "133 Pontius Avenue N.",
    "building_number": 133,
    "street": "Pontius Ave N",
    "city": "Seattle",
    "zip": 98109,
    "concatenated_address": "133 Pontius Ave N, Seattle",
    "address": "133 Pontius Ave. N., Seattle"
  },
  {
    "id": 2103,
    "financing": "Federally subsidized",
    "building_name": "Briarwood Commons",
    "latitude": 46.983201,
    "longitude": -120.53777,
    "original_address": "1001 S Chestnut St.",
    "building_number": 1001,
    "street": "S Chestnut St",
    "city": "Ellensburg",
    "zip": 98926,
    "concatenated_address": "1001 S Chestnut St, Ellensburg",
    "address": "1001 S. Chestnut St., Ellensburg"
  },
  {
    "id": 2104,
    "financing": "Federally subsidized",
    "building_name": "Bridge Creek II Apartments",
    "latitude": 48.79057,
    "longitude": -122.48097,
    "original_address": "272 E Bakerview Rd",
    "building_number": 272,
    "street": "E Bakerview Rd",
    "city": "Bellingham",
    "zip": 98226,
    "concatenated_address": "272 E Bakerview Rd, Bellingham",
    "address": "272 E. Bakerview Road, Bellingham"
  },
  {
    "id": 2105,
    "financing": "Federally subsidized",
    "building_name": "Brindlewood Apartments",
    "latitude": 46.732274,
    "longitude": -122.98288,
    "original_address": "1401 Johnson Road",
    "building_number": 1401,
    "street": "Johnson Rd",
    "city": "Centralia",
    "zip": 98531,
    "concatenated_address": "1401 Johnson Rd, Centralia",
    "address": "1401 Johnson Road, Centralia"
  },
  {
    "id": 2106,
    "financing": "Federally subsidized",
    "building_name": "Bristol Square II",
    "latitude": 47.856285,
    "longitude": -122.2943,
    "original_address": "15700 - 44th Avenue W",
    "building_number": 15700,
    "street": "44th Ave W",
    "city": "Lynnwood",
    "zip": 98087,
    "concatenated_address": "15700 44th Ave W, Lynnwood",
    "address": "15700 44th Ave. W., Lynnwood"
  },
  {
    "id": 2107,
    "financing": "Federally subsidized",
    "building_name": "Broadway Apartments",
    "latitude": 47.627258,
    "longitude": -122.32115,
    "original_address": "946 Broadway Avenue E",
    "building_number": 946,
    "street": "Broadway Ave E",
    "city": "Seattle",
    "zip": 98112,
    "concatenated_address": "946 Broadway Ave E, Seattle",
    "address": "946 Broadway Ave. E., Seattle"
  },
  {
    "id": 2108,
    "financing": "Federally subsidized",
    "building_name": "Broadway Crossing",
    "latitude": 47.615105,
    "longitude": -122.32132,
    "original_address": "815 E. Pine Street",
    "building_number": 815,
    "street": "E Pine St",
    "city": "Seattle",
    "zip": 98122,
    "concatenated_address": "815 E Pine St, Seattle",
    "address": "815 E. Pine St., Seattle"
  },
  {
    "id": 2109,
    "financing": "Federally subsidized",
    "building_name": "Broadway Plaza",
    "latitude": 47.977548,
    "longitude": -122.20195,
    "original_address": "3020 Broadway",
    "building_number": 3020,
    "street": "Broadway Ave",
    "city": "Everett",
    "zip": 98201,
    "concatenated_address": "3020 Broadway Ave, Everett",
    "address": "3020 Broadway Ave., Everett"
  },
  {
    "id": 2110,
    "financing": "Federally subsidized",
    "building_name": "Broadwing Apartments",
    "latitude": 47.685054,
    "longitude": -117.06891,
    "original_address": "25000 Hawkstone Loop",
    "building_number": 25000,
    "street": "E Hawkstone Loop",
    "city": "Liberty Lake",
    "zip": 99019,
    "concatenated_address": "25000 E Hawkstone Loop, Liberty Lake",
    "address": "25000 E. Hawkstone Loop, Liberty Lake"
  },
  {
    "id": 2111,
    "financing": "Federally subsidized",
    "building_name": "Brookside Apartments",
    "latitude": 47.679598,
    "longitude": -117.37412,
    "original_address": "2405 East Up River Dr.",
    "building_number": 2405,
    "street": "E Upriver Dr",
    "city": "Spokane",
    "zip": 99207,
    "concatenated_address": "2405 E Upriver Dr, Spokane",
    "address": "2405 E. Upriver Drive, Spokane"
  },
  {
    "id": 2112,
    "financing": "Federally subsidized",
    "building_name": "Brookstone Apartments",
    "latitude": 47.671164,
    "longitude": -117.19926,
    "original_address": "13129 East Valley Way",
    "building_number": "",
    "street": "",
    "city": "Spokane",
    "zip": 99216,
    "concatenated_address": "13129 East Valley Way, Spokane",
    "address": "13129 East Valley Way, Spokane"
  },
  {
    "id": 2113,
    "financing": "Federally subsidized",
    "building_name": "Brookstone/Brookside",
    "latitude": 47.662339,
    "longitude": -117.22824,
    "original_address": "504 N Mcdonald",
    "building_number": 504,
    "street": "N McDonald Rd",
    "city": "Spokane",
    "zip": "99216-0980",
    "concatenated_address": "504 N McDonald Rd, Spokane",
    "address": "504 N. McDonald Road, Spokane"
  },
  {
    "id": 2114,
    "financing": "Federally subsidized",
    "building_name": "Brookwood Apartments",
    "latitude": 46.988085,
    "longitude": -120.53954,
    "original_address": "606 E. Manitoba Avenue",
    "building_number": 606,
    "street": "E Manitoba Ave",
    "city": "Ellensburg",
    "zip": 98926,
    "concatenated_address": "606 E Manitoba Ave, Ellensburg",
    "address": "606 E. Manitoba Ave., Ellensburg"
  },
  {
    "id": 2115,
    "financing": "Federally subsidized",
    "building_name": "Bryant Manor",
    "latitude": 47.601515,
    "longitude": -122.30846,
    "original_address": "1801 East Yesler Way",
    "building_number": 1801,
    "street": "E Yesler Way",
    "city": "Seattle",
    "zip": 98122,
    "concatenated_address": "1801 E Yesler Way, Seattle",
    "address": "1801 E. Yesler Way, Seattle"
  },
  {
    "id": 2116,
    "financing": "Federally subsidized",
    "building_name": "Buder Haven",
    "latitude": 47.654688,
    "longitude": -117.41494,
    "original_address": "201-213 2nd Avenue",
    "building_number": 201,
    "street": "W 2nd Ave",
    "city": "Spokane",
    "zip": 99201,
    "concatenated_address": "201 W 2nd Ave, Spokane",
    "address": "201 W. 2nd Ave., Spokane"
  },
  {
    "id": 2117,
    "financing": "Federally subsidized",
    "building_name": "Buena Nueva Agricultural Worker Housing",
    "latitude": 46.430816,
    "longitude": -120.31341,
    "original_address": "66 Highland Drive",
    "building_number": 66,
    "street": "Highland Dr",
    "city": "Buena",
    "zip": 98921,
    "concatenated_address": "66 Highland Dr, Buena",
    "address": "66 Highland Drive, Buena"
  },
  {
    "id": 2118,
    "financing": "Federally subsidized",
    "building_name": "Buena Nueva Agricultural Worker Housing",
    "latitude": 46.42874,
    "longitude": -120.31339,
    "original_address": "50 Highland Drive",
    "building_number": "",
    "street": "",
    "city": "Buena",
    "zip": 98921,
    "concatenated_address": "50 Highland Drive, Buena",
    "address": "50 Highland Drive, Buena"
  },
  {
    "id": 2119,
    "financing": "Federally subsidized",
    "building_name": "Buena Vista Apartments",
    "latitude": 47.30882,
    "longitude": -122.23135,
    "original_address": "125 A Street Nw",
    "building_number": 125,
    "street": "A St NW",
    "city": "Auburn",
    "zip": 98001,
    "concatenated_address": "125 A St NW, Auburn",
    "address": "125 A St. N.W., Auburn"
  },
  {
    "id": 2120,
    "financing": "Federally subsidized",
    "building_name": "Burke Gilman Gardens",
    "latitude": 47.667819,
    "longitude": -122.28042,
    "original_address": "5251 Sand Point Way Ne",
    "building_number": 5251,
    "street": "Sand Point Way NE",
    "city": "Seattle",
    "zip": 98105,
    "concatenated_address": "5251 Sand Point Way NE, Seattle",
    "address": "5251 Sand Point Way N.E., Seattle"
  },
  {
    "id": 2121,
    "financing": "Federally subsidized",
    "building_name": "Burke Gilman Place Apartments",
    "latitude": 47.666024,
    "longitude": -122.28423,
    "original_address": "5100 40th Avenue Ne",
    "building_number": 5100,
    "street": "40th Ave NE",
    "city": "Seattle",
    "zip": "98105-3058",
    "concatenated_address": "5100 40th Ave NE, Seattle",
    "address": "5100 40th Ave. N.E., Seattle"
  },
  {
    "id": 2122,
    "financing": "Federally subsidized",
    "building_name": "Bush Hotel",
    "latitude": 47.598956,
    "longitude": -122.32549,
    "original_address": "621 S Jackson Street",
    "building_number": 621,
    "street": "S Jackson St",
    "city": "Seattle",
    "zip": 98104,
    "concatenated_address": "621 S Jackson St, Seattle",
    "address": "621 S. Jackson St., Seattle"
  },
  {
    "id": 2123,
    "financing": "Federally subsidized",
    "building_name": "Byron/Wetmore",
    "latitude": 47.574142,
    "longitude": -122.29319,
    "original_address": "3300-3308 Wetmore Avenue S.",
    "building_number": 3308,
    "street": "Wetmore Ave S",
    "city": "Seattle",
    "zip": 98144,
    "concatenated_address": "3308 Wetmore Ave S, Seattle",
    "address": "3308 Wetmore Ave. S., Seattle"
  },
  {
    "id": 2124,
    "financing": "Federally subsidized",
    "building_name": "Cabrini Senior Housing",
    "latitude": 47.609093,
    "longitude": -122.32514,
    "original_address": "909 Boren Ave",
    "building_number": 909,
    "street": "Boren Ave",
    "city": "Seattle",
    "zip": 98104,
    "concatenated_address": "909 Boren Ave, Seattle",
    "address": "909 Boren Ave., Seattle"
  },
  {
    "id": 2125,
    "financing": "Federally subsidized",
    "building_name": "Cabrini Senior Housing",
    "latitude": 47.609093,
    "longitude": -122.32514,
    "original_address": "909 Boren",
    "building_number": 909,
    "street": "Boren Ave",
    "city": "Seattle",
    "zip": 98104,
    "concatenated_address": "909 Boren Ave, Seattle",
    "address": "909 Boren Ave., Seattle"
  },
  {
    "id": 2126,
    "financing": "Federally subsidized",
    "building_name": "Cac 515 Preservation Portfolio",
    "latitude": 46.950424,
    "longitude": -122.61798,
    "original_address": "405 Killion Court Nw",
    "building_number": 405,
    "street": "Killion Ct NW",
    "city": "Yelm",
    "zip": 98597,
    "concatenated_address": "405 Killion Ct NW, Yelm",
    "address": "405 Killion Ct N.W., Yelm"
  },
  {
    "id": 2127,
    "financing": "Federally subsidized",
    "building_name": "Camas Court Senior Apartments",
    "latitude": 47.386874,
    "longitude": -119.49117,
    "original_address": "23 2nd Avenue Sw",
    "building_number": 23,
    "street": "2nd Ave SW",
    "city": "Soap Lake",
    "zip": 98851,
    "concatenated_address": "23 2nd Ave SW, Soap Lake",
    "address": "23 2nd Ave. S.W., Soap Lake"
  },
  {
    "id": 2128,
    "financing": "Federally subsidized",
    "building_name": "Cambridge Apartments",
    "latitude": 46.733014,
    "longitude": -122.98311,
    "original_address": "1429 Johnson Rd",
    "building_number": 1429,
    "street": "Johnson Rd",
    "city": "Centralia",
    "zip": 98531,
    "concatenated_address": "1429 Johnson Rd, Centralia",
    "address": "1429 Johnson Road, Centralia"
  },
  {
    "id": 2129,
    "financing": "Federally subsidized",
    "building_name": "Cambridge Apartments",
    "latitude": 47.724394,
    "longitude": -122.34728,
    "original_address": "13030 Linden Avenue N",
    "building_number": 13030,
    "street": "Linden Ave N",
    "city": "Seattle",
    "zip": 98133,
    "concatenated_address": "13030 Linden Ave N, Seattle",
    "address": "13030 Linden Ave. N., Seattle"
  },
  {
    "id": 2130,
    "financing": "Federally subsidized",
    "building_name": "Cambridge Apartments",
    "latitude": 47.611503,
    "longitude": -122.32984,
    "original_address": "903 Union St.",
    "building_number": 903,
    "street": "Union St",
    "city": "Seattle",
    "zip": 98101,
    "concatenated_address": "903 Union St, Seattle",
    "address": "903 Union St., Seattle"
  },
  {
    "id": 2131,
    "financing": "Federally subsidized",
    "building_name": "Cambridge Cove",
    "latitude": 48.295268,
    "longitude": -122.65291,
    "original_address": "470 Se 4th Avenue",
    "building_number": 470,
    "street": "SE 4th Ave",
    "city": "Oak Harbor",
    "zip": "98277-5217",
    "concatenated_address": "470 SE 4th Ave, Oak Harbor",
    "address": "470 S.E. 4th Ave., Oak Harbor"
  },
  {
    "id": 2132,
    "financing": "Federally subsidized",
    "building_name": "Campbell Gardens",
    "latitude": 47.487285,
    "longitude": -122.2551,
    "original_address": "6241 S 129th St",
    "building_number": 6241,
    "street": "S 129th St",
    "city": "Seattle",
    "zip": 98178,
    "concatenated_address": "6241 S 129th St, Seattle",
    "address": "6241 S. 129th St., Seattle"
  },
  {
    "id": 2133,
    "financing": "Federally subsidized",
    "building_name": "Canaday House",
    "latitude": 47.622769,
    "longitude": -122.33277,
    "original_address": "424 Minor Ave",
    "building_number": 424,
    "street": "Minor Ave N",
    "city": "Seattle",
    "zip": 98109,
    "concatenated_address": "424 Minor Ave N, Seattle",
    "address": "424 Minor Ave. N., Seattle"
  },
  {
    "id": 2134,
    "financing": "Federally subsidized",
    "building_name": "Candlewood Apartments",
    "latitude": 46.731688,
    "longitude": -122.9852,
    "original_address": "1322 Harrison Avenue",
    "building_number": 1322,
    "street": "Harrison Ave",
    "city": "Centralia",
    "zip": 98531,
    "concatenated_address": "1322 Harrison Ave, Centralia",
    "address": "1322 Harrison Ave., Centralia"
  },
  {
    "id": 2135,
    "financing": "Federally subsidized",
    "building_name": "Capehart Wherry Apartments",
    "latitude": 47.175578,
    "longitude": -119.32434,
    "original_address": "1239 Moses Street",
    "building_number": 1239,
    "street": "Moses St",
    "city": "Moses Lake",
    "zip": 98837,
    "concatenated_address": "1239 Moses St, Moses Lake",
    "address": "1239 Moses St., Moses Lake"
  },
  {
    "id": 2136,
    "financing": "Federally subsidized",
    "building_name": "Capitol House",
    "latitude": 47.043808,
    "longitude": -122.91411,
    "original_address": "420 Sherman Street Sw",
    "building_number": 420,
    "street": "Sherman St SW",
    "city": "Olympia",
    "zip": 98502,
    "concatenated_address": "420 Sherman St SW, Olympia",
    "address": "420 Sherman St. S.W., Olympia"
  },
  {
    "id": 2137,
    "financing": "Federally subsidized",
    "building_name": "Caroline W. Apartments",
    "latitude": 47.622971,
    "longitude": -122.32331,
    "original_address": "431 Boylston Avenue E.",
    "building_number": 431,
    "street": "Boylston Ave E",
    "city": "Seattle",
    "zip": 98102,
    "concatenated_address": "431 Boylston Ave E, Seattle",
    "address": "431 Boylston Ave. E., Seattle"
  },
  {
    "id": 2138,
    "financing": "Federally subsidized",
    "building_name": "Casa Del Sol",
    "latitude": 46.314623,
    "longitude": -120.00138,
    "original_address": "1410 Ida Belle Lane",
    "building_number": 1410,
    "street": "Ida Bell Ln",
    "city": "Sunnyside",
    "zip": 98944,
    "concatenated_address": "1410 Ida Bell Ln, Sunnyside",
    "address": "1410 Ida Bell Lane, Sunnyside"
  },
  {
    "id": 2139,
    "financing": "Federally subsidized",
    "building_name": "Casa Guadalupe Apartments",
    "latitude": 47.830579,
    "longitude": -120.01266,
    "original_address": "1105 S Bradley St",
    "building_number": 1105,
    "street": "S Bradley St",
    "city": "Chelan",
    "zip": 98816,
    "concatenated_address": "1105 S Bradley St, Chelan",
    "address": "1105 S. Bradley St., Chelan"
  },
  {
    "id": 2140,
    "financing": "Federally subsidized",
    "building_name": "Casa Kino",
    "latitude": 47.243053,
    "longitude": -119.85355,
    "original_address": "705 Central Avenue North",
    "building_number": 705,
    "street": "Central Ave N",
    "city": "Quincy",
    "zip": 98848,
    "concatenated_address": "705 Central Ave N, Quincy",
    "address": "705 Central Ave. N., Quincy"
  },
  {
    "id": 2141,
    "financing": "Federally subsidized",
    "building_name": "Casa Pacifica",
    "latitude": 47.622891,
    "longitude": -122.33349,
    "original_address": "1167 Republican St",
    "building_number": 1167,
    "street": "Republican St",
    "city": "Seattle",
    "zip": 98109,
    "concatenated_address": "1167 Republican St, Seattle",
    "address": "1167 Republican St., Seattle"
  },
  {
    "id": 2142,
    "financing": "Federally subsidized",
    "building_name": "Casas Salvadas",
    "latitude": 47.649908,
    "longitude": -117.4034,
    "original_address": "704 S Sherman",
    "building_number": 704,
    "street": "S Sherman Rd",
    "city": "Spokane",
    "zip": 99202,
    "concatenated_address": "704 S Sherman Rd, Spokane",
    "address": "704 S. Sherman Road, Spokane"
  },
  {
    "id": 2143,
    "financing": "Federally subsidized",
    "building_name": "Cascade Apartments",
    "latitude": 48.078517,
    "longitude": -121.97012,
    "original_address": "106 West Wallace",
    "building_number": 106,
    "street": "W Wallace St",
    "city": "Granite Falls",
    "zip": 98252,
    "concatenated_address": "106 W Wallace St, Granite Falls",
    "address": "106 W. Wallace St., Granite Falls"
  },
  {
    "id": 2144,
    "financing": "Federally subsidized",
    "building_name": "Cascade Court",
    "latitude": 47.611869,
    "longitude": -122.32477,
    "original_address": "1201 Summit Ave.",
    "building_number": 1201,
    "street": "Summit Ave",
    "city": "Seattle",
    "zip": 98101,
    "concatenated_address": "1201 Summit Ave, Seattle",
    "address": "1201 Summit Ave., Seattle"
  },
  {
    "id": 2145,
    "financing": "Federally subsidized",
    "building_name": "Cascade Court Apartments",
    "latitude": 46.734761,
    "longitude": -122.98221,
    "original_address": "1605 Johnson Road",
    "building_number": 1605,
    "street": "Johnson Rd",
    "city": "Centralia",
    "zip": 98531,
    "concatenated_address": "1605 Johnson Rd, Centralia",
    "address": "1605 Johnson Road, Centralia"
  },
  {
    "id": 2146,
    "financing": "Federally subsidized",
    "building_name": "Cascade Court/Sterling Court",
    "latitude": 47.611046,
    "longitude": -122.29321,
    "original_address": "1722 Belmont",
    "building_number": "",
    "street": "",
    "city": "Seattle",
    "zip": 98122,
    "concatenated_address": "1722 Belmont, Seattle",
    "address": "1722 Belmont, Seattle"
  },
  {
    "id": 2147,
    "financing": "Federally subsidized",
    "building_name": "Cascade Manor Apartments",
    "latitude": 46.992027,
    "longitude": -120.54734,
    "original_address": "101 S. Pearl St.",
    "building_number": 101,
    "street": "S Pearl St",
    "city": "Ellensburg",
    "zip": 98926,
    "concatenated_address": "101 S Pearl St, Ellensburg",
    "address": "101 S. Pearl St., Ellensburg"
  },
  {
    "id": 2148,
    "financing": "Federally subsidized",
    "building_name": "Cascade Meadows",
    "latitude": 48.792476,
    "longitude": -122.49456,
    "original_address": "455 Westerly Road",
    "building_number": 455,
    "street": "Westerly Rd",
    "city": "Bellingham",
    "zip": 98226,
    "concatenated_address": "455 Westerly Rd, Bellingham",
    "address": "455 Westerly Road, Bellingham"
  },
  {
    "id": 2149,
    "financing": "Federally subsidized",
    "building_name": "Cascade Park Apartments",
    "latitude": 47.491305,
    "longitude": -121.78753,
    "original_address": "440 Main Avenue S",
    "building_number": 440,
    "street": "Main Ave S",
    "city": "North Bend",
    "zip": 98045,
    "concatenated_address": "440 Main Ave S, North Bend",
    "address": "440 Main Ave. S., North Bend"
  },
  {
    "id": 2150,
    "financing": "Federally subsidized",
    "building_name": "Cascade Village Apartments",
    "latitude": 45.696201,
    "longitude": -121.89011,
    "original_address": "530 Nw Viewpoint Dr",
    "building_number": 530,
    "street": "NW Viewpoint Dr",
    "city": "Stevenson",
    "zip": 98648,
    "concatenated_address": "530 NW Viewpoint Dr, Stevenson",
    "address": "530 N.W. Viewpoint Drive, Stevenson"
  },
  {
    "id": 2151,
    "financing": "Federally subsidized",
    "building_name": "Cascade Woods - Phase I",
    "latitude": 45.641076,
    "longitude": -122.5314,
    "original_address": "2508 Ne 138th Ave",
    "building_number": 2508,
    "street": "NE 138th Ave",
    "city": "Vancouver",
    "zip": 98684,
    "concatenated_address": "2508 NE 138th Ave, Vancouver",
    "address": "2508 N.E. 138th Ave., Vancouver"
  },
  {
    "id": 2152,
    "financing": "Federally subsidized",
    "building_name": "Cascade Woods - Phase II",
    "latitude": 45.639859,
    "longitude": -122.5314,
    "original_address": "2412 Ne 138th Ave",
    "building_number": 2412,
    "street": "NE 138th Ave",
    "city": "Vancouver",
    "zip": 98684,
    "concatenated_address": "2412 NE 138th Ave, Vancouver",
    "address": "2412 N.E. 138th Ave., Vancouver"
  },
  {
    "id": 2153,
    "financing": "Federally subsidized",
    "building_name": "Cascadia Village Apartments",
    "latitude": 45.674881,
    "longitude": -122.57458,
    "original_address": "9600 Ne 73rd Street",
    "building_number": 9600,
    "street": "NE 73rd St",
    "city": "Vancouver",
    "zip": 98662,
    "concatenated_address": "9600 NE 73rd St, Vancouver",
    "address": "9600 N.E. 73rd St., Vancouver"
  },
  {
    "id": 2154,
    "financing": "Federally subsidized",
    "building_name": "Cascadian Apartments",
    "latitude": 47.620372,
    "longitude": -122.13292,
    "original_address": "15517 Ne 12th St",
    "building_number": 15517,
    "street": "NE 12th St",
    "city": "Bellevue",
    "zip": 98008,
    "concatenated_address": "15517 NE 12th St, Bellevue",
    "address": "15517 N.E. 12th St., Bellevue"
  },
  {
    "id": 2155,
    "financing": "Federally subsidized",
    "building_name": "Cashmere Manor Apartments",
    "latitude": 47.524302,
    "longitude": -120.46867,
    "original_address": "100 North Street",
    "building_number": 100,
    "street": "North St",
    "city": "Cashmere",
    "zip": 98815,
    "concatenated_address": "100 North St, Cashmere",
    "address": "100 North St., Cashmere"
  },
  {
    "id": 2156,
    "financing": "Federally subsidized",
    "building_name": "Cashmere Park",
    "latitude": 47.516435,
    "longitude": -120.48566,
    "original_address": "302 Fisher Street",
    "building_number": 302,
    "street": "Fisher St",
    "city": "Cashmere",
    "zip": 98815,
    "concatenated_address": "302 Fisher St, Cashmere",
    "address": "302 Fisher St., Cashmere"
  },
  {
    "id": 2157,
    "financing": "Federally subsidized",
    "building_name": "Catalina Apartments",
    "latitude": 47.247871,
    "longitude": -122.47279,
    "original_address": "1616 + 1717 South Yakima St",
    "building_number": "",
    "street": "",
    "city": "Tacoma",
    "zip": 98405,
    "concatenated_address": "1616 + 1717 South Yakima St, Tacoma",
    "address": "1616 + 1717 South Yakima St., Tacoma"
  },
  {
    "id": 2158,
    "financing": "Federally subsidized",
    "building_name": "Cate Apartments",
    "latitude": 47.690853,
    "longitude": -122.36127,
    "original_address": "312 Nw 85th Street",
    "building_number": 312,
    "street": "NW 85th St",
    "city": "Seattle",
    "zip": 98117,
    "concatenated_address": "312 NW 85th St, Seattle",
    "address": "312 N.W. 85th St., Seattle"
  },
  {
    "id": 2159,
    "financing": "Federally subsidized",
    "building_name": "Cathedral Plaza Apartments",
    "latitude": 47.657472,
    "longitude": -117.42903,
    "original_address": "1120 W Sprague Avenue",
    "building_number": 1120,
    "street": "W Sprague Ave",
    "city": "Spokane",
    "zip": 99201,
    "concatenated_address": "1120 W Sprague Ave, Spokane",
    "address": "1120 W. Sprague Ave., Spokane"
  },
  {
    "id": 2160,
    "financing": "Federally subsidized",
    "building_name": "Catherine Johnson Court",
    "latitude": 47.653734,
    "longitude": -117.31849,
    "original_address": "6321 E. 4th Avenue",
    "building_number": 6321,
    "street": "E 4th Ave",
    "city": "Spokane",
    "zip": "99212-4508",
    "concatenated_address": "6321 E 4th Ave, Spokane",
    "address": "6321 E. 4th Ave., Spokane"
  },
  {
    "id": 2161,
    "financing": "Federally subsidized",
    "building_name": "Catherine Of Siena Village",
    "latitude": 47.95036,
    "longitude": -124.38549,
    "original_address": "351 Founders Way",
    "building_number": "",
    "street": "",
    "city": "Forks",
    "zip": 98331,
    "concatenated_address": "351 Founders Way, Forks",
    "address": "351 Founders Way, Forks"
  },
  {
    "id": 2162,
    "financing": "Federally subsidized",
    "building_name": "Cedar Center",
    "latitude": 48.27286,
    "longitude": -117.71166,
    "original_address": "402 S. 5th Street East",
    "building_number": 402,
    "street": "E 5th St S",
    "city": "Chewelah",
    "zip": 99109,
    "concatenated_address": "402 E 5th St S, Chewelah",
    "address": "402 E. 5th St. S., Chewelah"
  },
  {
    "id": 2163,
    "financing": "Federally subsidized",
    "building_name": "Cedar Heights Apartments",
    "latitude": 47.518975,
    "longitude": -122.65457,
    "original_address": "333 Lippert Drive West",
    "building_number": 333,
    "street": "Lippert Dr",
    "city": "Port Orchard",
    "zip": 98366,
    "concatenated_address": "333 Lippert Dr, Port Orchard",
    "address": "333 Lippert Drive, Port Orchard"
  },
  {
    "id": 2164,
    "financing": "Federally subsidized",
    "building_name": "Cedar Park Apartments",
    "latitude": 47.722303,
    "longitude": -122.296,
    "original_address": "12740 - 30th Avenue Ne",
    "building_number": 12740,
    "street": "30th Ave NE",
    "city": "Seattle",
    "zip": "98125-4487",
    "concatenated_address": "12740 30th Ave NE, Seattle",
    "address": "12740 30th Ave. N.E., Seattle"
  },
  {
    "id": 2165,
    "financing": "Federally subsidized",
    "building_name": "Cedar Park Apartments Renton",
    "latitude": 47.488812,
    "longitude": -122.17408,
    "original_address": "408 Monroe Avenue Ne",
    "building_number": 408,
    "street": "Monroe Ave NE",
    "city": "Renton",
    "zip": 98056,
    "concatenated_address": "408 Monroe Ave NE, Renton",
    "address": "408 Monroe Ave. N.E., Renton"
  },
  {
    "id": 2166,
    "financing": "Federally subsidized",
    "building_name": "Cedar Pointe",
    "latitude": 47.282224,
    "longitude": -122.21301,
    "original_address": "2922 M Street Se",
    "building_number": 2922,
    "street": "M St SE",
    "city": "Auburn",
    "zip": 98002,
    "concatenated_address": "2922 M St SE, Auburn",
    "address": "2922 M St. S.E., Auburn"
  },
  {
    "id": 2167,
    "financing": "Federally subsidized",
    "building_name": "Cedar Ridge Apartments",
    "latitude": 47.326045,
    "longitude": -122.17948,
    "original_address": "30819 124th Avenue Se, #118",
    "building_number": 30819,
    "street": "124th Ave SE",
    "city": "Auburn",
    "zip": "98092-3127",
    "concatenated_address": "30819 124th Ave SE, Auburn",
    "address": "30819 124th Ave. S.E., Auburn"
  },
  {
    "id": 2168,
    "financing": "Federally subsidized",
    "building_name": "Cedar River Court Apartments",
    "latitude": 47.482115,
    "longitude": -122.20344,
    "original_address": "130 Main Avenue S",
    "building_number": 130,
    "street": "Main Ave S",
    "city": "Renton",
    "zip": 98057,
    "concatenated_address": "130 Main Ave S, Renton",
    "address": "130 Main Ave. S., Renton"
  },
  {
    "id": 2169,
    "financing": "Federally subsidized",
    "building_name": "Cedar West Apartments",
    "latitude": 47.708605,
    "longitude": -117.47027,
    "original_address": "4018 W Rowan Ave",
    "building_number": 4018,
    "street": "W Rowan Ave",
    "city": "Spokane",
    "zip": 99205,
    "concatenated_address": "4018 W Rowan Ave, Spokane",
    "address": "4018 W. Rowan Ave., Spokane"
  },
  {
    "id": 2170,
    "financing": "Federally subsidized",
    "building_name": "Cedars On 67th",
    "latitude": 48.073088,
    "longitude": -122.14101,
    "original_address": "8700 67th Avenue Ne",
    "building_number": 8700,
    "street": "67th Ave NE",
    "city": "Marysville",
    "zip": "98270-8886",
    "concatenated_address": "8700 67th Ave NE, Marysville",
    "address": "8700 67th Ave. N.E., Marysville"
  },
  {
    "id": 2171,
    "financing": "Federally subsidized",
    "building_name": "Cedarwood",
    "latitude": 48.471575,
    "longitude": -120.18191,
    "original_address": "220 White Ave",
    "building_number": "",
    "street": "White Ave",
    "city": "Winthrop",
    "zip": 98862,
    "concatenated_address": "220 White Ave, Winthrop",
    "address": "220 White Ave., Winthrop"
  },
  {
    "id": 2172,
    "financing": "Federally subsidized",
    "building_name": "Cedarwood Apartments",
    "latitude": 48.471575,
    "longitude": -120.18191,
    "original_address": "220 White Ave",
    "building_number": "",
    "street": "White Ave",
    "city": "Winthrop",
    "zip": 98862,
    "concatenated_address": "220 White Ave, Winthrop",
    "address": "220 White Ave., Winthrop"
  },
  {
    "id": 2173,
    "financing": "Federally subsidized",
    "building_name": "Cedarwood I Apartments",
    "latitude": 47.991028,
    "longitude": -122.09629,
    "original_address": "10018 5th Pl Se",
    "building_number": 10018,
    "street": "5th Pl SE",
    "city": "Lake Stevens",
    "zip": 98258,
    "concatenated_address": "10018 5th Pl SE, Lake Stevens",
    "address": "10018 5th Pl S.E., Lake Stevens"
  },
  {
    "id": 2174,
    "financing": "Federally subsidized",
    "building_name": "Cedarwood II",
    "latitude": 47.99195,
    "longitude": -122.09555,
    "original_address": "420 101st Avenue Southeast",
    "building_number": 420,
    "street": "101st Ave SE",
    "city": "Lake Stevens",
    "zip": 98258,
    "concatenated_address": "420 101st Ave SE, Lake Stevens",
    "address": "420 101st Ave. S.E., Lake Stevens"
  },
  {
    "id": 2175,
    "financing": "Federally subsidized",
    "building_name": "Cedarwood IV Apartments",
    "latitude": 47.991649,
    "longitude": -122.09331,
    "original_address": "521 102nd Dr. Se",
    "building_number": 521,
    "street": "102nd Dr SE",
    "city": "Lake Stevens",
    "zip": 98258,
    "concatenated_address": "521 102nd Dr SE, Lake Stevens",
    "address": "521 102nd Dr S.E., Lake Stevens"
  },
  {
    "id": 2176,
    "financing": "Federally subsidized",
    "building_name": "Celebration Senior Living East",
    "latitude": 47.30833,
    "longitude": -122.31427,
    "original_address": "1524 South 328th Street",
    "building_number": 1524,
    "street": "S 328th St",
    "city": "Federal Way",
    "zip": 98003,
    "concatenated_address": "1524 S 328th St, Federal Way",
    "address": "1524 S. 328th St., Federal Way"
  },
  {
    "id": 2177,
    "financing": "Federally subsidized",
    "building_name": "Celebration Senior Living West",
    "latitude": 47.308322,
    "longitude": -122.31554,
    "original_address": "1316 South 328th Street",
    "building_number": 1316,
    "street": "S 328th St",
    "city": "Federal Way",
    "zip": 98003,
    "concatenated_address": "1316 S 328th St, Federal Way",
    "address": "1316 S. 328th St., Federal Way"
  },
  {
    "id": 2178,
    "financing": "Federally subsidized",
    "building_name": "Centennial Apartments",
    "latitude": 47.616592,
    "longitude": -122.32419,
    "original_address": "600 East Olive Street",
    "building_number": 600,
    "street": "E Olive St",
    "city": "Seattle",
    "zip": 98122,
    "concatenated_address": "600 E Olive St, Seattle",
    "address": "600 E. Olive St., Seattle"
  },
  {
    "id": 2179,
    "financing": "Federally subsidized",
    "building_name": "Centerwood Apartments",
    "latitude": 47.52749,
    "longitude": -122.36094,
    "original_address": "8427 Delridge Way Sw",
    "building_number": 8427,
    "street": "Delridge Way SW",
    "city": "Seattle",
    "zip": 98106,
    "concatenated_address": "8427 Delridge Way SW, Seattle",
    "address": "8427 Delridge Way S.W., Seattle"
  },
  {
    "id": 2180,
    "financing": "Federally subsidized",
    "building_name": "Central Colville Apartments",
    "latitude": 48.538463,
    "longitude": -117.90277,
    "original_address": "630 South Elm",
    "building_number": 630,
    "street": "S Elm St",
    "city": "Colville",
    "zip": "99114-2644",
    "concatenated_address": "630 S Elm St, Colville",
    "address": "630 S. Elm St., Colville"
  },
  {
    "id": 2181,
    "financing": "Federally subsidized",
    "building_name": "Central Park Place",
    "latitude": 45.629137,
    "longitude": -122.66074,
    "original_address": "1900 Fort Vancouver Way",
    "building_number": 1900,
    "street": "Fort Vancouver Way",
    "city": "Vancouver",
    "zip": "98663-3500",
    "concatenated_address": "1900 Fort Vancouver Way, Vancouver",
    "address": "1900 Fort Vancouver Way, Vancouver"
  },
  {
    "id": 2182,
    "financing": "Federally subsidized",
    "building_name": "Central Park Place",
    "latitude": 46.606881,
    "longitude": -120.49545,
    "original_address": "110 N Ninth St",
    "building_number": 110,
    "street": "N 9th St",
    "city": "Yakima",
    "zip": 98901,
    "concatenated_address": "110 N 9th St, Yakima",
    "address": "110 N. 9th St., Yakima"
  },
  {
    "id": 2183,
    "financing": "Federally subsidized",
    "building_name": "Central Villa Apartments",
    "latitude": 46.587,
    "longitude": -120.50961,
    "original_address": "1004 South 3rd Ave",
    "building_number": 1004,
    "street": "S 3rd Ave",
    "city": "Yakima",
    "zip": 98902,
    "concatenated_address": "1004 S 3rd Ave, Yakima",
    "address": "1004 S. 3rd Ave., Yakima"
  },
  {
    "id": 2184,
    "financing": "Federally subsidized",
    "building_name": "Centralia Manor Apartments",
    "latitude": 46.718036,
    "longitude": -122.9567,
    "original_address": "303 West Pine Street",
    "building_number": 303,
    "street": "W Pine St",
    "city": "Centralia",
    "zip": 98531,
    "concatenated_address": "303 W Pine St, Centralia",
    "address": "303 W. Pine St., Centralia"
  },
  {
    "id": 2185,
    "financing": "Federally subsidized",
    "building_name": "Century House",
    "latitude": 47.587854,
    "longitude": -122.30309,
    "original_address": "1711 23rd Avenue South",
    "building_number": 1711,
    "street": "23rd Ave S",
    "city": "Seattle",
    "zip": 98144,
    "concatenated_address": "1711 23rd Ave S, Seattle",
    "address": "1711 23rd Ave. S., Seattle"
  },
  {
    "id": 2186,
    "financing": "Federally subsidized",
    "building_name": "Cesar Chavez Village",
    "latitude": 47.523203,
    "longitude": -122.3203,
    "original_address": "1000 South Henderson St",
    "building_number": 1000,
    "street": "S Henderson St",
    "city": "Seattle",
    "zip": 98108,
    "concatenated_address": "1000 S Henderson St, Seattle",
    "address": "1000 S. Henderson St., Seattle"
  },
  {
    "id": 2187,
    "financing": "Federally subsidized",
    "building_name": "Chalet Apartments",
    "latitude": 47.586855,
    "longitude": -122.1432,
    "original_address": "2627 148th Avenue Se",
    "building_number": 2627,
    "street": "148th Ave SE",
    "city": "Bellevue",
    "zip": 98007,
    "concatenated_address": "2627 148th Ave SE, Bellevue",
    "address": "2627 148th Ave. S.E., Bellevue"
  },
  {
    "id": 2188,
    "financing": "Federally subsidized",
    "building_name": "Chancery Place Apartments",
    "latitude": 47.608033,
    "longitude": -122.32638,
    "original_address": "910 Marion Street",
    "building_number": 910,
    "street": "Marion St",
    "city": "Seattle",
    "zip": 98104,
    "concatenated_address": "910 Marion St, Seattle",
    "address": "910 Marion St., Seattle"
  },
  {
    "id": 2189,
    "financing": "Federally subsidized",
    "building_name": "Chaparral Apartments",
    "latitude": 47.178705,
    "longitude": -119.32744,
    "original_address": "1432 East Craig Boulevard",
    "building_number": 1432,
    "street": "E Craig St",
    "city": "Moses Lake",
    "zip": 98837,
    "concatenated_address": "1432 E Craig St, Moses Lake",
    "address": "1432 E. Craig St., Moses Lake"
  },
  {
    "id": 2190,
    "financing": "Federally subsidized",
    "building_name": "Charlesbee",
    "latitude": 47.255587,
    "longitude": -122.44637,
    "original_address": "801 S G St",
    "building_number": 801,
    "street": "S G St",
    "city": "Tacoma",
    "zip": 98405,
    "concatenated_address": "801 S G St, Tacoma",
    "address": "801 S. G St., Tacoma"
  },
  {
    "id": 2191,
    "financing": "Federally subsidized",
    "building_name": "Chateau Apartments",
    "latitude": 47.602513,
    "longitude": -122.30805,
    "original_address": "119 19th Avenue",
    "building_number": 119,
    "street": "19th Ave",
    "city": "Seattle",
    "zip": 98122,
    "concatenated_address": "119 19th Ave, Seattle",
    "address": "119 19th Ave., Seattle"
  },
  {
    "id": 2192,
    "financing": "Federally subsidized",
    "building_name": "Chehalis Avenue Apartments",
    "latitude": 46.656938,
    "longitude": -122.96752,
    "original_address": "366 Sw 3rd Street",
    "building_number": 366,
    "street": "SW 3rd St",
    "city": "Chehalis",
    "zip": 98532,
    "concatenated_address": "366 SW 3rd St, Chehalis",
    "address": "366 S.W. 3rd St., Chehalis"
  },
  {
    "id": 2193,
    "financing": "Federally subsidized",
    "building_name": "Chehalis Manor",
    "latitude": 46.659736,
    "longitude": -122.96084,
    "original_address": "300 S Market Blvd",
    "building_number": 300,
    "street": "S Market Blvd",
    "city": "Chehalis",
    "zip": 98532,
    "concatenated_address": "300 S Market Blvd, Chehalis",
    "address": "300 S. Market Blvd., Chehalis"
  },
  {
    "id": 2194,
    "financing": "Federally subsidized",
    "building_name": "Chehalis Valley",
    "latitude": 46.64246,
    "longitude": -122.94172,
    "original_address": "1025 Sw 20th St.",
    "building_number": 1025,
    "street": "SW 20th St",
    "city": "Chehalis",
    "zip": 98532,
    "concatenated_address": "1025 SW 20th St, Chehalis",
    "address": "1025 S.W. 20th St., Chehalis"
  },
  {
    "id": 2195,
    "financing": "Federally subsidized",
    "building_name": "Chehalis Valley Apartments",
    "latitude": 46.64246,
    "longitude": -122.94172,
    "original_address": "1025 Sw 20th Street",
    "building_number": 1025,
    "street": "SW 20th St",
    "city": "Chehalis",
    "zip": "98532-4229",
    "concatenated_address": "1025 SW 20th St, Chehalis",
    "address": "1025 S.W. 20th St., Chehalis"
  },
  {
    "id": 2196,
    "financing": "Federally subsidized",
    "building_name": "Chelsea Apartments",
    "latitude": 48.299705,
    "longitude": -122.64665,
    "original_address": "180 Ne Izett Street",
    "building_number": 180,
    "street": "NE Izett St",
    "city": "Oak Harbor",
    "zip": 98277,
    "concatenated_address": "180 NE Izett St, Oak Harbor",
    "address": "180 N.E. Izett St., Oak Harbor"
  },
  {
    "id": 2197,
    "financing": "Federally subsidized",
    "building_name": "Cheney Gardens",
    "latitude": 47.501848,
    "longitude": -117.56705,
    "original_address": "2336 University Lane",
    "building_number": 2336,
    "street": "University Ln",
    "city": "Cheney",
    "zip": 99004,
    "concatenated_address": "2336 University Ln, Cheney",
    "address": "2336 University Lane, Cheney"
  },
  {
    "id": 2198,
    "financing": "Federally subsidized",
    "building_name": "Cherrybrook Apartments",
    "latitude": 45.77912,
    "longitude": -122.53155,
    "original_address": "511 Se 2nd Street",
    "building_number": 511,
    "street": "SE 2nd St",
    "city": "Battle Ground",
    "zip": 98604,
    "concatenated_address": "511 SE 2nd St, Battle Ground",
    "address": "511 S.E. 2nd St., Battle Ground"
  },
  {
    "id": 2199,
    "financing": "Federally subsidized",
    "building_name": "Cheryl Chow Court",
    "latitude": 47.670404,
    "longitude": -122.38278,
    "original_address": "2014 Nw 57th Street",
    "building_number": 2014,
    "street": "NW 57th St",
    "city": "Seattle",
    "zip": 98107,
    "concatenated_address": "2014 NW 57th St, Seattle",
    "address": "2014 N.W. 57th St., Seattle"
  },
  {
    "id": 2200,
    "financing": "Federally subsidized",
    "building_name": "Chestnut Court",
    "latitude": 46.602273,
    "longitude": -120.488,
    "original_address": "209 S. Fair Ave",
    "building_number": 209,
    "street": "S Fair Ave",
    "city": "Yakima",
    "zip": 98901,
    "concatenated_address": "209 S Fair Ave, Yakima",
    "address": "209 S. Fair Ave., Yakima"
  },
  {
    "id": 2201,
    "financing": "Federally subsidized",
    "building_name": "Chestnut Grove Apartments",
    "latitude": 47.128869,
    "longitude": -119.27157,
    "original_address": "610 Chestnut Street",
    "building_number": 610,
    "street": "S Chestnut St",
    "city": "Moses Lake",
    "zip": 98837,
    "concatenated_address": "610 S Chestnut St, Moses Lake",
    "address": "610 S. Chestnut St., Moses Lake"
  },
  {
    "id": 2202,
    "financing": "Federally subsidized",
    "building_name": "Chewelah Meadows",
    "latitude": 48.272702,
    "longitude": -117.71166,
    "original_address": "420 S. 5th Street East",
    "building_number": 420,
    "street": "E 5th St S",
    "city": "Chewelah",
    "zip": 99109,
    "concatenated_address": "420 E 5th St S, Chewelah",
    "address": "420 E. 5th St. S., Chewelah"
  },
  {
    "id": 2203,
    "financing": "Federally subsidized",
    "building_name": "Citi-Mini / Virginia Court Apartments",
    "latitude": 47.617413,
    "longitude": -122.33491,
    "original_address": "1000 Virginia St",
    "building_number": 1000,
    "street": "Virginia St",
    "city": "Seattle",
    "zip": 98101,
    "concatenated_address": "1000 Virginia St, Seattle",
    "address": "1000 Virginia St., Seattle"
  },
  {
    "id": 2204,
    "financing": "Federally subsidized",
    "building_name": "Citycenter Apartments",
    "latitude": 47.820782,
    "longitude": -122.28324,
    "original_address": "3720 196th Street Southwest",
    "building_number": 3720,
    "street": "196th St SW",
    "city": "Lynnwood",
    "zip": 98036,
    "concatenated_address": "3720 196th St SW, Lynnwood",
    "address": "3720 196th St. S.W., Lynnwood"
  },
  {
    "id": 2205,
    "financing": "Federally subsidized",
    "building_name": "Clallam Bay",
    "latitude": 48.248905,
    "longitude": -124.25723,
    "original_address": "140 Weel Road",
    "building_number": 140,
    "street": "Weel Rd",
    "city": "Clallam Bay",
    "zip": 98326,
    "concatenated_address": "140 Weel Rd, Clallam Bay",
    "address": "140 Weel Road, Clallam Bay"
  },
  {
    "id": 2206,
    "financing": "Federally subsidized",
    "building_name": "Clare House Independent Apartments",
    "latitude": 47.61015,
    "longitude": -117.36049,
    "original_address": "4827 S Palouse Hwy",
    "building_number": 4827,
    "street": "S Palouse Hwy",
    "city": "Spokane",
    "zip": 99223,
    "concatenated_address": "4827 S Palouse Hwy, Spokane",
    "address": "4827 S. Palouse Highway, Spokane"
  },
  {
    "id": 2207,
    "financing": "Federally subsidized",
    "building_name": "Clare View Seniors Apartments",
    "latitude": 47.613453,
    "longitude": -117.36354,
    "original_address": "3202 East 44th Ave",
    "building_number": 3202,
    "street": "E 44th Ave",
    "city": "Spokane",
    "zip": 99223,
    "concatenated_address": "3202 E 44th Ave, Spokane",
    "address": "3202 E. 44th Ave., Spokane"
  },
  {
    "id": 2208,
    "financing": "Federally subsidized",
    "building_name": "Claridge Court Apartments",
    "latitude": 48.109161,
    "longitude": -122.78275,
    "original_address": "1235 Landes St",
    "building_number": 1235,
    "street": "Landes St",
    "city": "Port Townsend",
    "zip": "98368-8331",
    "concatenated_address": "1235 Landes St, Port Townsend",
    "address": "1235 Landes St., Port Townsend"
  },
  {
    "id": 2209,
    "financing": "Federally subsidized",
    "building_name": "Clark Village Apartments",
    "latitude": 45.578996,
    "longitude": -122.36478,
    "original_address": "211 8th Street",
    "building_number": 211,
    "street": "8th St",
    "city": "Washougal",
    "zip": 98671,
    "concatenated_address": "211 8th St, Washougal",
    "address": "211 8th St., Washougal"
  },
  {
    "id": 2210,
    "financing": "Federally subsidized",
    "building_name": "Clarke Court",
    "latitude": 46.968006,
    "longitude": -123.79849,
    "original_address": "620 W Cushing St",
    "building_number": 620,
    "street": "W Cushing St",
    "city": "Aberdeen",
    "zip": 98520,
    "concatenated_address": "620 W Cushing St, Aberdeen",
    "address": "620 W. Cushing St., Aberdeen"
  },
  {
    "id": 2211,
    "financing": "Federally subsidized",
    "building_name": "Clarkston Gardens",
    "latitude": 46.407169,
    "longitude": -117.05879,
    "original_address": "1210 13Th St",
    "building_number": 1210,
    "street": "13th St",
    "city": "Clarkston",
    "zip": 99403,
    "concatenated_address": "1210 13th St, Clarkston",
    "address": "1210 13th St., Clarkston"
  },
  {
    "id": 2212,
    "financing": "Federally subsidized",
    "building_name": "Clarkston Manor",
    "latitude": 46.421577,
    "longitude": -117.06427,
    "original_address": "1411 Fair Street",
    "building_number": 1411,
    "street": "Fair St",
    "city": "Clarkston",
    "zip": 99403,
    "concatenated_address": "1411 Fair St, Clarkston",
    "address": "1411 Fair St., Clarkston"
  },
  {
    "id": 2213,
    "financing": "Federally subsidized",
    "building_name": "Cle Elem Manor",
    "latitude": 47.1941,
    "longitude": -120.93846,
    "original_address": "100 N Pennsylvania Ave",
    "building_number": 100,
    "street": "N Pennsylvania Ave",
    "city": "Cle Elum",
    "zip": 98922,
    "concatenated_address": "100 N Pennsylvania Ave, Cle Elum",
    "address": "100 N. Pennsylvania Ave., Cle Elum"
  },
  {
    "id": 2214,
    "financing": "Federally subsidized",
    "building_name": "Colby Crest Apartments",
    "latitude": 47.984019,
    "longitude": -122.20806,
    "original_address": "2515 Colby Ave",
    "building_number": 2515,
    "street": "Colby Ave",
    "city": "Everett",
    "zip": 98201,
    "concatenated_address": "2515 Colby Ave, Everett",
    "address": "2515 Colby Ave., Everett"
  },
  {
    "id": 2215,
    "financing": "Federally subsidized",
    "building_name": "College Glen",
    "latitude": 46.999277,
    "longitude": -122.8216,
    "original_address": "4870 55th Lane Se",
    "building_number": 4870,
    "street": "55th Ln SE",
    "city": "Lacey",
    "zip": 98503,
    "concatenated_address": "4870 55th Ln SE, Lacey",
    "address": "4870 55th Lane S.E., Lacey"
  },
  {
    "id": 2216,
    "financing": "Federally subsidized",
    "building_name": "Colonial Gardens",
    "latitude": 47.737602,
    "longitude": -122.31402,
    "original_address": "15001 15th Avenue Ne",
    "building_number": 15001,
    "street": "15th Ave NE",
    "city": "Seattle",
    "zip": "98155-7161",
    "concatenated_address": "15001 15th Ave NE, Seattle",
    "address": "15001 15th Ave. N.E., Seattle"
  },
  {
    "id": 2217,
    "financing": "Federally subsidized",
    "building_name": "Colonial Square Apartments",
    "latitude": 47.257048,
    "longitude": -122.44,
    "original_address": "701 Commerce Street",
    "building_number": 701,
    "street": "Commerce St",
    "city": "Tacoma",
    "zip": 98402,
    "concatenated_address": "701 Commerce St, Tacoma",
    "address": "701 Commerce St., Tacoma"
  },
  {
    "id": 2218,
    "financing": "Federally subsidized",
    "building_name": "Colonial Village",
    "latitude": 47.325733,
    "longitude": -122.21887,
    "original_address": "2022 I Street Ne",
    "building_number": 2022,
    "street": "I St NE",
    "city": "Auburn",
    "zip": 98002,
    "concatenated_address": "2022 I St NE, Auburn",
    "address": "2022 I St. N.E., Auburn"
  },
  {
    "id": 2219,
    "financing": "Federally subsidized",
    "building_name": "Colorado Apartments",
    "latitude": 47.411944,
    "longitude": -120.28686,
    "original_address": "245 5th Street Ne",
    "building_number": 245,
    "street": "5th St NE",
    "city": "East Wenatchee",
    "zip": 98802,
    "concatenated_address": "245 5th St NE, East Wenatchee",
    "address": "245 5th St. N.E., East Wenatchee"
  },
  {
    "id": 2220,
    "financing": "Federally subsidized",
    "building_name": "Columbia City Station Apartments",
    "latitude": 47.563372,
    "longitude": -122.29448,
    "original_address": "4484 Martin Luther King Jr. Way S.",
    "building_number": 4484,
    "street": "Martin Luther King Jr Way S",
    "city": "Seattle",
    "zip": 98108,
    "concatenated_address": "4484 Martin Luther King Jr Way S, Seattle",
    "address": "4484 Martin Luther King Jr Way S., Seattle"
  },
  {
    "id": 2221,
    "financing": "Federally subsidized",
    "building_name": "Columbia Gardens At Rainier Court",
    "latitude": 47.571162,
    "longitude": -122.29049,
    "original_address": "3610 33rd Avenue South",
    "building_number": 3610,
    "street": "33rd Ave S",
    "city": "Seattle",
    "zip": 98144,
    "concatenated_address": "3610 33rd Ave S, Seattle",
    "address": "3610 33rd Ave. S., Seattle"
  },
  {
    "id": 2222,
    "financing": "Federally subsidized",
    "building_name": "Columbia Park",
    "latitude": 46.296469,
    "longitude": -119.28043,
    "original_address": "1682 Jadwin Ave",
    "building_number": 1682,
    "street": "Jadwin Ave",
    "city": "Richland",
    "zip": 99354,
    "concatenated_address": "1682 Jadwin Ave, Richland",
    "address": "1682 Jadwin Ave., Richland"
  },
  {
    "id": 2223,
    "financing": "Federally subsidized",
    "building_name": "Colville Homes I",
    "latitude": 48.430699,
    "longitude": -120.24354,
    "original_address": "701 Bitterroot Lane",
    "building_number": "",
    "street": "Bitterroot Ln",
    "city": "Winthrop",
    "zip": 99155,
    "concatenated_address": "701 Bitterroot Lane, Winthrop",
    "address": "701 Bitterroot Lane, Winthrop"
  },
  {
    "id": 2224,
    "financing": "Federally subsidized",
    "building_name": "Colville Homes II",
    "latitude": 48.268566,
    "longitude": -118.30546,
    "original_address": "6 Sugar Bowl Cul-De-Sac",
    "building_number": "",
    "street": "",
    "city": "Inchelium",
    "zip": 99138,
    "concatenated_address": "6 Sugar Bowl Cul-De-Sac, Inchelium",
    "address": "6 Sugar Bowl Cul-De-Sac, Inchelium"
  },
  {
    "id": 2225,
    "financing": "Federally subsidized",
    "building_name": "Colville Park Apartments",
    "latitude": 48.533931,
    "longitude": -117.90249,
    "original_address": "1170 South Elm Street",
    "building_number": 1170,
    "street": "S Elm St",
    "city": "Colville",
    "zip": 99114,
    "concatenated_address": "1170 S Elm St, Colville",
    "address": "1170 S. Elm St., Colville"
  },
  {
    "id": 2226,
    "financing": "Federally subsidized",
    "building_name": "Colvos Terrace Apartments",
    "latitude": 47.309203,
    "longitude": -122.57431,
    "original_address": "2601 Hollycroft Street",
    "building_number": 2601,
    "street": "Hollycroft St",
    "city": "Gig Harbor",
    "zip": 98335,
    "concatenated_address": "2601 Hollycroft St, Gig Harbor",
    "address": "2601 Hollycroft St., Gig Harbor"
  },
  {
    "id": 2227,
    "financing": "Federally subsidized",
    "building_name": "Commerce Building",
    "latitude": 47.9794,
    "longitude": -122.20577,
    "original_address": "1803 Hewitt Ave",
    "building_number": 1803,
    "street": "Hewitt Ave",
    "city": "Everett",
    "zip": 98201,
    "concatenated_address": "1803 Hewitt Ave, Everett",
    "address": "1803 Hewitt Ave., Everett"
  },
  {
    "id": 2228,
    "financing": "Federally subsidized",
    "building_name": "Commonwealth Apartments",
    "latitude": 47.2484,
    "longitude": -122.45358,
    "original_address": "1401 South M Street",
    "building_number": 1401,
    "street": "S M St",
    "city": "Tacoma",
    "zip": 98405,
    "concatenated_address": "1401 S M St, Tacoma",
    "address": "1401 S. M St., Tacoma"
  },
  {
    "id": 2229,
    "financing": "Federally subsidized",
    "building_name": "Compass At Ronald Commons",
    "latitude": 47.758892,
    "longitude": -122.34688,
    "original_address": "17839 Aurora Avenue North",
    "building_number": 17839,
    "street": "Aurora Ave N",
    "city": "Seattle",
    "zip": 98133,
    "concatenated_address": "17839 Aurora Ave N, Seattle",
    "address": "17839 Aurora Ave. N., Seattle"
  },
  {
    "id": 2230,
    "financing": "Federally subsidized",
    "building_name": "Compass Broadview",
    "latitude": 47.724868,
    "longitude": -122.35667,
    "original_address": "147 N 132nd St",
    "building_number": 147,
    "street": "N 132nd St",
    "city": "Seattle",
    "zip": 98133,
    "concatenated_address": "147 N 132nd St, Seattle",
    "address": "147 N. 132nd St., Seattle"
  },
  {
    "id": 2231,
    "financing": "Federally subsidized",
    "building_name": "Compass Center Renton Lutheran Regional Veterans' Program",
    "latitude": 47.481011,
    "longitude": -122.21096,
    "original_address": "419 S Second St",
    "building_number": 419,
    "street": "S 2nd St",
    "city": "Renton",
    "zip": 98057,
    "concatenated_address": "419 S 2nd St, Renton",
    "address": "419 S. 2nd St., Renton"
  },
  {
    "id": 2232,
    "financing": "Federally subsidized",
    "building_name": "Compass Center Transitional Housing Program",
    "latitude": 47.620693,
    "longitude": -122.33272,
    "original_address": "1205 Thomas Street",
    "building_number": 1205,
    "street": "Thomas St",
    "city": "Seattle",
    "zip": "98109-5427",
    "concatenated_address": "1205 Thomas St, Seattle",
    "address": "1205 Thomas St., Seattle"
  },
  {
    "id": 2233,
    "financing": "Federally subsidized",
    "building_name": "Compass On Dexter",
    "latitude": 47.620012,
    "longitude": -122.34196,
    "original_address": "756 John Street",
    "building_number": 756,
    "street": "John St",
    "city": "Seattle",
    "zip": 98109,
    "concatenated_address": "756 John St, Seattle",
    "address": "756 John St., Seattle"
  },
  {
    "id": 2234,
    "financing": "Federally subsidized",
    "building_name": "Conbela Apartments",
    "latitude": 47.527454,
    "longitude": -122.36014,
    "original_address": "8424 Delridge Way Sw",
    "building_number": 8424,
    "street": "Delridge Way SW",
    "city": "Seattle",
    "zip": 98106,
    "concatenated_address": "8424 Delridge Way SW, Seattle",
    "address": "8424 Delridge Way S.W., Seattle"
  },
  {
    "id": 2235,
    "financing": "Federally subsidized",
    "building_name": "Conifer Ridge Senior Apartments",
    "latitude": 47.532587,
    "longitude": -122.59875,
    "original_address": "1721 Fircrest Dr. Se",
    "building_number": 1721,
    "street": "Fircrest Dr SE",
    "city": "Port Orchard",
    "zip": 98366,
    "concatenated_address": "1721 Fircrest Dr SE, Port Orchard",
    "address": "1721 Fircrest Dr S.E., Port Orchard"
  },
  {
    "id": 2236,
    "financing": "Federally subsidized",
    "building_name": "Conifer South Apartments",
    "latitude": 47.208599,
    "longitude": -122.48095,
    "original_address": "5235 South Warner",
    "building_number": 5235,
    "street": "S Warner St",
    "city": "Tacoma",
    "zip": 98409,
    "concatenated_address": "5235 S Warner St, Tacoma",
    "address": "5235 S. Warner St., Tacoma"
  },
  {
    "id": 2237,
    "financing": "Federally subsidized",
    "building_name": "Conifer South Apartments",
    "latitude": 47.208478,
    "longitude": -122.48159,
    "original_address": "5234 S Warner St",
    "building_number": 5234,
    "street": "S Warner St",
    "city": "Tacoma",
    "zip": 98409,
    "concatenated_address": "5234 S Warner St, Tacoma",
    "address": "5234 S. Warner St., Tacoma"
  },
  {
    "id": 2238,
    "financing": "Federally subsidized",
    "building_name": "Conifer Woods",
    "latitude": 47.52095,
    "longitude": -122.59299,
    "original_address": "4698 Se Conifer Park Dr",
    "building_number": 4698,
    "street": "SE Conifer Park Dr",
    "city": "Port Orchard",
    "zip": "98366-2132",
    "concatenated_address": "4698 SE Conifer Park Dr, Port Orchard",
    "address": "4698 S.E. Conifer Park Drive, Port Orchard"
  },
  {
    "id": 2239,
    "financing": "Federally subsidized",
    "building_name": "Conservatory Place Apartments I",
    "latitude": 47.261616,
    "longitude": -122.44747,
    "original_address": "203 S G St",
    "building_number": 203,
    "street": "S G St",
    "city": "Tacoma",
    "zip": 98405,
    "concatenated_address": "203 S G St, Tacoma",
    "address": "203 S. G St., Tacoma"
  },
  {
    "id": 2240,
    "financing": "Federally subsidized",
    "building_name": "Conservatory Place Apartments II",
    "latitude": 47.260039,
    "longitude": -122.44725,
    "original_address": "319 S G St",
    "building_number": 319,
    "street": "S G St",
    "city": "Tacoma",
    "zip": 98405,
    "concatenated_address": "319 S G St, Tacoma",
    "address": "319 S. G St., Tacoma"
  },
  {
    "id": 2241,
    "financing": "Federally subsidized",
    "building_name": "Cooper Artist Housing",
    "latitude": 47.563794,
    "longitude": -122.36301,
    "original_address": "4408 Delridge Way Sw",
    "building_number": 4408,
    "street": "Delridge Way SW",
    "city": "Seattle",
    "zip": 98106,
    "concatenated_address": "4408 Delridge Way SW, Seattle",
    "address": "4408 Delridge Way S.W., Seattle"
  },
  {
    "id": 2242,
    "financing": "Federally subsidized",
    "building_name": "Copper Hill",
    "latitude": 47.613374,
    "longitude": -117.36239,
    "original_address": "3210 E. 44th Ave",
    "building_number": 3210,
    "street": "E 44th Ave",
    "city": "Spokane",
    "zip": 99223,
    "concatenated_address": "3210 E 44th Ave, Spokane",
    "address": "3210 E. 44th Ave., Spokane"
  },
  {
    "id": 2243,
    "financing": "Federally subsidized",
    "building_name": "Copper Landing Apartments",
    "latitude": 47.65009,
    "longitude": -117.5956,
    "original_address": "10913 W. 6th Avenue",
    "building_number": 10913,
    "street": "W 6th Ave",
    "city": "Airway Heights",
    "zip": 99001,
    "concatenated_address": "10913 W 6th Ave, Airway Heights",
    "address": "10913 W. 6th Ave., Airway Heights"
  },
  {
    "id": 2244,
    "financing": "Federally subsidized",
    "building_name": "Copper Lane Apartments",
    "latitude": 45.639978,
    "longitude": -122.54979,
    "original_address": "2401 Ne Four Seasons Lane",
    "building_number": 2401,
    "street": "NE Four Seasons Ln",
    "city": "Vancouver",
    "zip": 98684,
    "concatenated_address": "2401 NE Four Seasons Ln, Vancouver",
    "address": "2401 N.E. Four Seasons Lane, Vancouver"
  },
  {
    "id": 2245,
    "financing": "Federally subsidized",
    "building_name": "Copper Lantern Apartments",
    "latitude": 47.75732,
    "longitude": -122.24401,
    "original_address": "18230 + 18240 70th Lane Ne",
    "building_number": "",
    "street": "",
    "city": "Kenmore",
    "zip": 98028,
    "concatenated_address": "18230 + 18240 70th Lane Ne, Kenmore",
    "address": "18230 + 18240 70th Lane Ne, Kenmore"
  },
  {
    "id": 2246,
    "financing": "Federally subsidized",
    "building_name": "Copper Ridge Apartments",
    "latitude": 46.177653,
    "longitude": -119.21183,
    "original_address": "5501 W Hildebrand Blvd.",
    "building_number": "",
    "street": "Hildebrand Rd",
    "city": "Kennewick",
    "zip": 99338,
    "concatenated_address": "5501 W Hildebrand Blvd., Kennewick",
    "address": "5501 W. Hildebrand Blvd., Kennewick"
  },
  {
    "id": 2247,
    "financing": "Federally subsidized",
    "building_name": "Copper River Apartments",
    "latitude": 47.676327,
    "longitude": -117.45365,
    "original_address": "2865 W. Elliott",
    "building_number": 2865,
    "street": "W Elliott Dr",
    "city": "Spokane",
    "zip": 99224,
    "concatenated_address": "2865 W Elliott Dr, Spokane",
    "address": "2865 W. Elliott Drive, Spokane"
  },
  {
    "id": 2248,
    "financing": "Federally subsidized",
    "building_name": "Copper Trail",
    "latitude": 47.104269,
    "longitude": -123.05515,
    "original_address": "3500 Block Of Capitol Mall Drive Sw",
    "building_number": "",
    "street": "",
    "city": "Olympia",
    "zip": 98502,
    "concatenated_address": "3500 Block Of Capitol Mall Drive Sw, Olympia",
    "address": "3500 Block Of Capitol Mall Drive S.W., Olympia"
  },
  {
    "id": 2249,
    "financing": "Federally subsidized",
    "building_name": "Copper Valley Apartments",
    "latitude": 47.146189,
    "longitude": -122.37515,
    "original_address": "12111 40th Ave. E.",
    "building_number": 12111,
    "street": "40th Ave E",
    "city": "Tacoma",
    "zip": 98374,
    "concatenated_address": "12111 40th Ave E, Tacoma",
    "address": "12111 40th Ave. E., Tacoma"
  },
  {
    "id": 2250,
    "financing": "Federally subsidized",
    "building_name": "Copper Wood Apartments",
    "latitude": 47.059544,
    "longitude": -122.74556,
    "original_address": "10244 E. Martin Way",
    "building_number": 10244,
    "street": "E Martin Way",
    "city": "Olympia",
    "zip": 98516,
    "concatenated_address": "10244 E Martin Way, Olympia",
    "address": "10244 E. Martin Way, Olympia"
  },
  {
    "id": 2251,
    "financing": "Federally subsidized",
    "building_name": "Corinthian Apartments",
    "latitude": 47.464781,
    "longitude": -122.29267,
    "original_address": "3039 S 154th St",
    "building_number": 3039,
    "street": "S 154th St",
    "city": "Seattle",
    "zip": 98188,
    "concatenated_address": "3039 S 154th St, Seattle",
    "address": "3039 S. 154th St., Seattle"
  },
  {
    "id": 2252,
    "financing": "Federally subsidized",
    "building_name": "Cornerstone Apartments",
    "latitude": 46.582984,
    "longitude": -120.60574,
    "original_address": "1210 S 72nd Ave.",
    "building_number": 1210,
    "street": "S 72nd Ave",
    "city": "Yakima",
    "zip": 98908,
    "concatenated_address": "1210 S 72nd Ave, Yakima",
    "address": "1210 S. 72nd Ave., Yakima"
  },
  {
    "id": 2253,
    "financing": "Federally subsidized",
    "building_name": "Cornerstone Courtyard",
    "latitude": 47.655308,
    "longitude": -117.43083,
    "original_address": "151 South Adams St",
    "building_number": 151,
    "street": "S Adams St",
    "city": "Spokane",
    "zip": 99201,
    "concatenated_address": "151 S Adams St, Spokane",
    "address": "151 S. Adams St., Spokane"
  },
  {
    "id": 2254,
    "financing": "Federally subsidized",
    "building_name": "Coronado Springs Apartments",
    "latitude": 47.508704,
    "longitude": -122.35122,
    "original_address": "1400 Sw 107th Street",
    "building_number": 1400,
    "street": "SW 107th St",
    "city": "Seattle",
    "zip": "98146-2144",
    "concatenated_address": "1400 SW 107th St, Seattle",
    "address": "1400 S.W. 107th St., Seattle"
  },
  {
    "id": 2255,
    "financing": "Federally subsidized",
    "building_name": "Corridor Apartments",
    "latitude": 46.731832,
    "longitude": -122.98981,
    "original_address": "2804 Russell Rd",
    "building_number": 2804,
    "street": "Russell Rd",
    "city": "Centralia",
    "zip": 98531,
    "concatenated_address": "2804 Russell Rd, Centralia",
    "address": "2804 Russell Road, Centralia"
  },
  {
    "id": 2256,
    "financing": "Federally subsidized",
    "building_name": "Cottage Bay Apartments",
    "latitude": 47.621489,
    "longitude": -122.61784,
    "original_address": "2500 Ne Mcwilliams Road",
    "building_number": 2500,
    "street": "NE Mcwilliams Rd",
    "city": "Bremerton",
    "zip": "98311-9503",
    "concatenated_address": "2500 NE Mcwilliams Rd, Bremerton",
    "address": "2500 N.E. Mcwilliams Road, Bremerton"
  },
  {
    "id": 2257,
    "financing": "Federally subsidized",
    "building_name": "Cottage Grove",
    "latitude": 47.55261,
    "longitude": -122.36256,
    "original_address": "5444 Delridge Way Sw",
    "building_number": 5444,
    "street": "Delridge Way SW",
    "city": "Seattle",
    "zip": 98106,
    "concatenated_address": "5444 Delridge Way SW, Seattle",
    "address": "5444 Delridge Way S.W., Seattle"
  },
  {
    "id": 2258,
    "financing": "Federally subsidized",
    "building_name": "Cottonwood Glen",
    "latitude": 46.421589,
    "longitude": -117.0599,
    "original_address": "1371 Fair Street",
    "building_number": 1371,
    "street": "Fair St",
    "city": "Clarkston",
    "zip": 99403,
    "concatenated_address": "1371 Fair St, Clarkston",
    "address": "1371 Fair St., Clarkston"
  },
  {
    "id": 2259,
    "financing": "Federally subsidized",
    "building_name": "Cottonwood Glen",
    "latitude": 46.421589,
    "longitude": -117.0599,
    "original_address": "1371 Fair Street",
    "building_number": 1371,
    "street": "Fair St",
    "city": "Clarkston",
    "zip": "99403-2376",
    "concatenated_address": "1371 Fair St, Clarkston",
    "address": "1371 Fair St., Clarkston"
  },
  {
    "id": 2260,
    "financing": "Federally subsidized",
    "building_name": "Cottonwood Springs I",
    "latitude": 47.656626,
    "longitude": -118.14865,
    "original_address": "516 Ross St",
    "building_number": 516,
    "street": "Ross St",
    "city": "Davenport",
    "zip": 99122,
    "concatenated_address": "516 Ross St, Davenport",
    "address": "516 Ross St., Davenport"
  },
  {
    "id": 2261,
    "financing": "Federally subsidized",
    "building_name": "Coulee City Gardens",
    "latitude": 47.609181,
    "longitude": -119.281,
    "original_address": "406 E Chelan",
    "building_number": 406,
    "street": "E Chelan St",
    "city": "Coulee City",
    "zip": 99115,
    "concatenated_address": "406 E Chelan St, Coulee City",
    "address": "406 E. Chelan St., Coulee City"
  },
  {
    "id": 2262,
    "financing": "Federally subsidized",
    "building_name": "Country Run Apartments",
    "latitude": 46.178676,
    "longitude": -122.9136,
    "original_address": "120 Solomon Rd",
    "building_number": 120,
    "street": "Solomon Rd",
    "city": "Kelso",
    "zip": 98626,
    "concatenated_address": "120 Solomon Rd, Kelso",
    "address": "120 Solomon Road, Kelso"
  },
  {
    "id": 2263,
    "financing": "Federally subsidized",
    "building_name": "Courtland Place At Rainier Court",
    "latitude": 47.571109,
    "longitude": -122.29126,
    "original_address": "3621 33rd Avenue South",
    "building_number": 3621,
    "street": "33rd Ave S",
    "city": "Seattle",
    "zip": 98144,
    "concatenated_address": "3621 33rd Ave S, Seattle",
    "address": "3621 33rd Ave. S., Seattle"
  },
  {
    "id": 2264,
    "financing": "Federally subsidized",
    "building_name": "Courtside Apartments",
    "latitude": 47.042397,
    "longitude": -122.94964,
    "original_address": "600 Sw Yauger Way",
    "building_number": 600,
    "street": "Yauger Way SW",
    "city": "Olympia",
    "zip": "98502-8774",
    "concatenated_address": "600 Yauger Way SW, Olympia",
    "address": "600 Yauger Way S.W., Olympia"
  },
  {
    "id": 2265,
    "financing": "Federally subsidized",
    "building_name": "Covington Commons Apartments",
    "latitude": 45.674353,
    "longitude": -122.57326,
    "original_address": "9703 Ne Covington Road",
    "building_number": 9703,
    "street": "NE Covington Rd",
    "city": "Vancouver",
    "zip": "98662-4099",
    "concatenated_address": "9703 NE Covington Rd, Vancouver",
    "address": "9703 N.E. Covington Road, Vancouver"
  },
  {
    "id": 2266,
    "financing": "Federally subsidized",
    "building_name": "Covington Place Senior Apartments",
    "latitude": 47.361201,
    "longitude": -122.11516,
    "original_address": "26902 169th Pl. Se.",
    "building_number": 26902,
    "street": "169th Pl SE",
    "city": "Kent",
    "zip": 98042,
    "concatenated_address": "26902 169th Pl SE, Kent",
    "address": "26902 169th Pl S.E., Kent"
  },
  {
    "id": 2267,
    "financing": "Federally subsidized",
    "building_name": "Cowlitz Terrace",
    "latitude": 46.138344,
    "longitude": -122.9069,
    "original_address": "812 S. 8th Ave.",
    "building_number": 812,
    "street": "S 8th Ave",
    "city": "Kelso",
    "zip": 98626,
    "concatenated_address": "812 S 8th Ave, Kelso",
    "address": "812 S. 8th Ave., Kelso"
  },
  {
    "id": 2268,
    "financing": "Federally subsidized",
    "building_name": "Creekside Apartments",
    "latitude": 47.210197,
    "longitude": -123.10508,
    "original_address": "468 Park St",
    "building_number": 468,
    "street": "Park St",
    "city": "Shelton",
    "zip": 98584,
    "concatenated_address": "468 Park St, Shelton",
    "address": "468 Park St., Shelton"
  },
  {
    "id": 2269,
    "financing": "Federally subsidized",
    "building_name": "Creekside Cottages",
    "latitude": 46.044807,
    "longitude": -118.36882,
    "original_address": "1297 Creekside",
    "building_number": 1297,
    "street": "SE Creekside Dr",
    "city": "College Place",
    "zip": 99324,
    "concatenated_address": "1297 SE Creekside Dr, College Place",
    "address": "1297 S.E. Creekside Drive, College Place"
  },
  {
    "id": 2270,
    "financing": "Federally subsidized",
    "building_name": "Creekside Meadows",
    "latitude": 48.992877,
    "longitude": -122.25969,
    "original_address": "1400 Boon St",
    "building_number": 1400,
    "street": "Boon St",
    "city": "Sumas",
    "zip": 98295,
    "concatenated_address": "1400 Boon St, Sumas",
    "address": "1400 Boon St., Sumas"
  },
  {
    "id": 2271,
    "financing": "Federally subsidized",
    "building_name": "Crestline Apartments",
    "latitude": 47.720034,
    "longitude": -122.15954,
    "original_address": "13248 135th Avenue Ne",
    "building_number": 13248,
    "street": "135th Ave NE",
    "city": "Kirkland",
    "zip": 98033,
    "concatenated_address": "13248 135th Ave NE, Kirkland",
    "address": "13248 135th Ave. N.E., Kirkland"
  },
  {
    "id": 2272,
    "financing": "Federally subsidized",
    "building_name": "Creston Point",
    "latitude": 47.48156,
    "longitude": -122.24646,
    "original_address": "13445 Martin Luther King Jr. Way S",
    "building_number": 13445,
    "street": "Martin Luther King Jr Way S",
    "city": "Seattle",
    "zip": "98178-5202",
    "concatenated_address": "13445 Martin Luther King Jr Way S, Seattle",
    "address": "13445 Martin Luther King Jr Way S., Seattle"
  },
  {
    "id": 2273,
    "financing": "Federally subsidized",
    "building_name": "Crestview Apartments",
    "latitude": 45.80586,
    "longitude": -120.82193,
    "original_address": "102 East 21st Street",
    "building_number": 102,
    "street": "E 21st St",
    "city": "Goldendale",
    "zip": 98620,
    "concatenated_address": "102 E 21st St, Goldendale",
    "address": "102 E. 21st St., Goldendale"
  },
  {
    "id": 2274,
    "financing": "Federally subsidized",
    "building_name": "Crestview Terrace Apartments",
    "latitude": 47.012999,
    "longitude": -120.53333,
    "original_address": "2101 N Alder Street",
    "building_number": 2101,
    "street": "N Alder St",
    "city": "Ellensburg",
    "zip": 98926,
    "concatenated_address": "2101 N Alder St, Ellensburg",
    "address": "2101 N. Alder St., Ellensburg"
  },
  {
    "id": 2275,
    "financing": "Federally subsidized",
    "building_name": "Crestview West Apartments",
    "latitude": 47.349859,
    "longitude": -122.31164,
    "original_address": "27912 Pacific Hwy S",
    "building_number": 27912,
    "street": "Pacific Hwy S",
    "city": "Federal Way",
    "zip": "98003-3293",
    "concatenated_address": "27912 Pacific Hwy S, Federal Way",
    "address": "27912 Pacific Highway S., Federal Way"
  },
  {
    "id": 2276,
    "financing": "Federally subsidized",
    "building_name": "Crestwood Place",
    "latitude": 47.506434,
    "longitude": -122.26986,
    "original_address": "10500 51st Avenue South",
    "building_number": 10500,
    "street": "51st Ave S",
    "city": "Seattle",
    "zip": 98178,
    "concatenated_address": "10500 51st Ave S, Seattle",
    "address": "10500 51st Ave. S., Seattle"
  },
  {
    "id": 2277,
    "financing": "Federally subsidized",
    "building_name": "Cristo Rey",
    "latitude": 46.329889,
    "longitude": -119.99775,
    "original_address": "330 N. 16th St",
    "building_number": 330,
    "street": "N 16th St",
    "city": "Sunnyside",
    "zip": 98944,
    "concatenated_address": "330 N 16th St, Sunnyside",
    "address": "330 N. 16th St., Sunnyside"
  },
  {
    "id": 2278,
    "financing": "Federally subsidized",
    "building_name": "Croft Place Townhomes",
    "latitude": 47.542524,
    "longitude": -122.36013,
    "original_address": "6701 21st Ave. Sw",
    "building_number": 6701,
    "street": "21st Ave SW",
    "city": "Seattle",
    "zip": 98106,
    "concatenated_address": "6701 21st Ave SW, Seattle",
    "address": "6701 21st Ave. S.W., Seattle"
  },
  {
    "id": 2279,
    "financing": "Federally subsidized",
    "building_name": "Crowne Pointe Apartments",
    "latitude": 47.048388,
    "longitude": -122.93416,
    "original_address": "2800 Limited Lane N.W.",
    "building_number": 2800,
    "street": "Limited Ln NW",
    "city": "Olympia",
    "zip": 98502,
    "concatenated_address": "2800 Limited Ln NW, Olympia",
    "address": "2800 Limited Lane N.W., Olympia"
  },
  {
    "id": 2280,
    "financing": "Federally subsidized",
    "building_name": "Dakota At Rainier Court",
    "latitude": 47.571547,
    "longitude": -122.29115,
    "original_address": "3605 - 33rd Avenue South",
    "building_number": 3605,
    "street": "33rd Ave S",
    "city": "Seattle",
    "zip": "98144-6929",
    "concatenated_address": "3605 33rd Ave S, Seattle",
    "address": "3605 33rd Ave. S., Seattle"
  },
  {
    "id": 2281,
    "financing": "Federally subsidized",
    "building_name": "Danwood Apartments",
    "latitude": 47.652016,
    "longitude": -122.69644,
    "original_address": "9711 Danwood Lane N. W.",
    "building_number": 9711,
    "street": "Danwood Ln",
    "city": "Silverdale",
    "zip": 98383,
    "concatenated_address": "9711 Danwood Ln, Silverdale",
    "address": "9711 Danwood Lane, Silverdale"
  },
  {
    "id": 2282,
    "financing": "Federally subsidized",
    "building_name": "David Colwell Building",
    "latitude": 47.619094,
    "longitude": -122.33079,
    "original_address": "111 Yale Avenue North",
    "building_number": 111,
    "street": "Yale Ave N",
    "city": "Seattle",
    "zip": 98109,
    "concatenated_address": "111 Yale Ave N, Seattle",
    "address": "111 Yale Ave. N., Seattle"
  },
  {
    "id": 2283,
    "financing": "Federally subsidized",
    "building_name": "Dawn Village",
    "latitude": 47.325625,
    "longitude": -119.5423,
    "original_address": "318 East Street Ne",
    "building_number": 318,
    "street": "E St NE",
    "city": "Ephrata",
    "zip": 98823,
    "concatenated_address": "318 E St NE, Ephrata",
    "address": "318 E. St. N.E., Ephrata"
  },
  {
    "id": 2284,
    "financing": "Federally subsidized",
    "building_name": "Deaconess Apartments",
    "latitude": 47.418191,
    "longitude": -120.31417,
    "original_address": "300 Okanogan Avenue",
    "building_number": 300,
    "street": "Okanogan Ave",
    "city": "Wenatchee",
    "zip": 98807,
    "concatenated_address": "300 Okanogan Ave, Wenatchee",
    "address": "300 Okanogan Ave., Wenatchee"
  },
  {
    "id": 2285,
    "financing": "Federally subsidized",
    "building_name": "Deer Creek",
    "latitude": 47.920225,
    "longitude": -122.25839,
    "original_address": "8605 18th Avenue W",
    "building_number": 8605,
    "street": "18th Ave W",
    "city": "Everett",
    "zip": 98204,
    "concatenated_address": "8605 18th Ave W, Everett",
    "address": "8605 18th Ave. W., Everett"
  },
  {
    "id": 2286,
    "financing": "Federally subsidized",
    "building_name": "Deer Park Meadows",
    "latitude": 47.954638,
    "longitude": -117.45413,
    "original_address": "15 North Weber Rd",
    "building_number": 15,
    "street": "N Weber Rd",
    "city": "Deer Park",
    "zip": 99006,
    "concatenated_address": "15 N Weber Rd, Deer Park",
    "address": "15 N. Weber Road, Deer Park"
  },
  {
    "id": 2287,
    "financing": "Federally subsidized",
    "building_name": "Deer Run At Northpointe",
    "latitude": 47.74585,
    "longitude": -117.39114,
    "original_address": "1225 East Westview Court",
    "building_number": 1225,
    "street": "E Westview Ct",
    "city": "Spokane",
    "zip": "99218-3819",
    "concatenated_address": "1225 E Westview Ct, Spokane",
    "address": "1225 E. Westview Ct, Spokane"
  },
  {
    "id": 2288,
    "financing": "Federally subsidized",
    "building_name": "Deer Run Terrace",
    "latitude": 48.774485,
    "longitude": -122.45675,
    "original_address": "3210 Orleans St.",
    "building_number": 3210,
    "street": "Orleans St",
    "city": "Bellingham",
    "zip": 98226,
    "concatenated_address": "3210 Orleans St, Bellingham",
    "address": "3210 Orleans St., Bellingham"
  },
  {
    "id": 2289,
    "financing": "Federally subsidized",
    "building_name": "Deer Run West",
    "latitude": 47.746378,
    "longitude": -117.39204,
    "original_address": "9728 N Morton Ct",
    "building_number": 9728,
    "street": "N Morton Ct",
    "city": "Spokane",
    "zip": "99218-3828",
    "concatenated_address": "9728 N Morton Ct, Spokane",
    "address": "9728 N. Morton Ct, Spokane"
  },
  {
    "id": 2290,
    "financing": "Federally subsidized",
    "building_name": "Dekko Place",
    "latitude": 47.615753,
    "longitude": -122.33381,
    "original_address": "919 Stewart Street",
    "building_number": 919,
    "street": "Stewart St",
    "city": "Seattle",
    "zip": 98101,
    "concatenated_address": "919 Stewart St, Seattle",
    "address": "919 Stewart St., Seattle"
  },
  {
    "id": 2291,
    "financing": "Federally subsidized",
    "building_name": "Delridge Heights Apartments",
    "latitude": 47.525504,
    "longitude": -122.36016,
    "original_address": "8630 Delridge Way Sw",
    "building_number": 8630,
    "street": "Delridge Way SW",
    "city": "Seattle",
    "zip": 98106,
    "concatenated_address": "8630 Delridge Way SW, Seattle",
    "address": "8630 Delridge Way S.W., Seattle"
  },
  {
    "id": 2292,
    "financing": "Federally subsidized",
    "building_name": "Denny Park Apartments",
    "latitude": 47.620677,
    "longitude": -122.34072,
    "original_address": "230 - 8th Avenue N",
    "building_number": 230,
    "street": "8th Ave N",
    "city": "Seattle",
    "zip": 98109,
    "concatenated_address": "230 8th Ave N, Seattle",
    "address": "230 8th Ave. N., Seattle"
  },
  {
    "id": 2293,
    "financing": "Federally subsidized",
    "building_name": "Des Moines Family Housing",
    "latitude": 47.384284,
    "longitude": -122.29821,
    "original_address": "2741 S. 242nd St",
    "building_number": 2741,
    "street": "S 242nd St",
    "city": "Seattle",
    "zip": 98198,
    "concatenated_address": "2741 S 242nd St, Seattle",
    "address": "2741 S. 242nd St., Seattle"
  },
  {
    "id": 2294,
    "financing": "Federally subsidized",
    "building_name": "Deschutes Cove",
    "latitude": 46.983084,
    "longitude": -122.88794,
    "original_address": "7201 Henderson Blvd Se",
    "building_number": 7201,
    "street": "Henderson Blvd SE",
    "city": "Olympia",
    "zip": 98501,
    "concatenated_address": "7201 Henderson Blvd SE, Olympia",
    "address": "7201 Henderson Blvd S.E., Olympia"
  },
  {
    "id": 2295,
    "financing": "Federally subsidized",
    "building_name": "Desert Haven",
    "latitude": 46.816117,
    "longitude": -119.16528,
    "original_address": "935 S 7th Ave",
    "building_number": 935,
    "street": "S 7th Ave",
    "city": "Othello",
    "zip": 99344,
    "concatenated_address": "935 S 7th Ave, Othello",
    "address": "935 S. 7th Ave., Othello"
  },
  {
    "id": 2296,
    "financing": "Federally subsidized",
    "building_name": "Desert Rose Terrace",
    "latitude": 46.262863,
    "longitude": -119.494,
    "original_address": "510 14th St",
    "building_number": 510,
    "street": "14th St",
    "city": "Benton City",
    "zip": 99320,
    "concatenated_address": "510 14th St, Benton City",
    "address": "510 14th St., Benton City"
  },
  {
    "id": 2297,
    "financing": "Federally subsidized",
    "building_name": "Desert Villa & Desert Villa East",
    "latitude": 46.202096,
    "longitude": -119.11833,
    "original_address": "635 S Auburn St",
    "building_number": 635,
    "street": "S Auburn St",
    "city": "Kennewick",
    "zip": 99336,
    "concatenated_address": "635 S Auburn St, Kennewick",
    "address": "635 S. Auburn St., Kennewick"
  },
  {
    "id": 2298,
    "financing": "Federally subsidized",
    "building_name": "Devonshire Apartments",
    "latitude": 47.617241,
    "longitude": -122.34594,
    "original_address": "420 Wall Street",
    "building_number": 420,
    "street": "Wall St",
    "city": "Seattle",
    "zip": 98121,
    "concatenated_address": "420 Wall St, Seattle",
    "address": "420 Wall St., Seattle"
  },
  {
    "id": 2299,
    "financing": "Federally subsidized",
    "building_name": "Discovery Heights",
    "latitude": 47.538438,
    "longitude": -122.01556,
    "original_address": "942 Discovery Circle Ne",
    "building_number": 942,
    "street": "Discovery Cir NE",
    "city": "Issaquah",
    "zip": 98029,
    "concatenated_address": "942 Discovery Cir NE, Issaquah",
    "address": "942 Discovery Cir N.E., Issaquah"
  },
  {
    "id": 2300,
    "financing": "Federally subsidized",
    "building_name": "Discovery View",
    "latitude": 48.107298,
    "longitude": -122.79486,
    "original_address": "1051 Hancock Street",
    "building_number": 1051,
    "street": "Hancock St",
    "city": "Port Townsend",
    "zip": 98368,
    "concatenated_address": "1051 Hancock St, Port Townsend",
    "address": "1051 Hancock St., Port Townsend"
  },
  {
    "id": 2301,
    "financing": "Federally subsidized",
    "building_name": "Doherty/Broadway",
    "latitude": 47.942844,
    "longitude": -122.19922,
    "original_address": "6003 Broadway",
    "building_number": 6003,
    "street": "Broadway",
    "city": "Everett",
    "zip": 98203,
    "concatenated_address": "6003 Broadway, Everett",
    "address": "6003 Broadway, Everett"
  },
  {
    "id": 2302,
    "financing": "Federally subsidized",
    "building_name": "Domingo Viernes Apartments",
    "latitude": 47.596211,
    "longitude": -122.32278,
    "original_address": "721 S Lane St",
    "building_number": 721,
    "street": "S Lane St",
    "city": "Seattle",
    "zip": 98104,
    "concatenated_address": "721 S Lane St, Seattle",
    "address": "721 S. Lane St., Seattle"
  },
  {
    "id": 2303,
    "financing": "Federally subsidized",
    "building_name": "Donna Hanson Haven",
    "latitude": 47.654687,
    "longitude": -117.41236,
    "original_address": "24 W. 2nd Avenue",
    "building_number": 24,
    "street": "W 2nd Ave",
    "city": "Spokane",
    "zip": 99201,
    "concatenated_address": "24 W 2nd Ave, Spokane",
    "address": "24 W. 2nd Ave., Spokane"
  },
  {
    "id": 2304,
    "financing": "Federally subsidized",
    "building_name": "Dororthy Street",
    "latitude": 46.145364,
    "longitude": -122.97074,
    "original_address": "1908 Dorothy St",
    "building_number": 1908,
    "street": "Dorothy St",
    "city": "Longview",
    "zip": 98632,
    "concatenated_address": "1908 Dorothy St, Longview",
    "address": "1908 Dorothy St., Longview"
  },
  {
    "id": 2305,
    "financing": "Federally subsidized",
    "building_name": "Dorothy Day Residence",
    "latitude": 47.613684,
    "longitude": -122.34641,
    "original_address": "106 Bell Street",
    "building_number": 106,
    "street": "Bell St",
    "city": "Seattle",
    "zip": "98121-1785",
    "concatenated_address": "106 Bell St, Seattle",
    "address": "106 Bell St., Seattle"
  },
  {
    "id": 2306,
    "financing": "Federally subsidized",
    "building_name": "Dorothy Day Residence",
    "latitude": 46.24438,
    "longitude": -119.09364,
    "original_address": "318 Pearl St",
    "building_number": 318,
    "street": "W Pearl St",
    "city": "Pasco",
    "zip": 99301,
    "concatenated_address": "318 W Pearl St, Pasco",
    "address": "318 W. Pearl St., Pasco"
  },
  {
    "id": 2307,
    "financing": "Federally subsidized",
    "building_name": "Drexel House",
    "latitude": 47.043892,
    "longitude": -122.86036,
    "original_address": "606 Devoe Street Se",
    "building_number": 606,
    "street": "Devoe St SE",
    "city": "Olympia",
    "zip": 98501,
    "concatenated_address": "606 Devoe St SE, Olympia",
    "address": "606 Devoe St. S.E., Olympia"
  },
  {
    "id": 2308,
    "financing": "Federally subsidized",
    "building_name": "Drexel House II",
    "latitude": 47.044613,
    "longitude": -122.85922,
    "original_address": "607 Pattison Street Se",
    "building_number": 607,
    "street": "Pattison St SE",
    "city": "Olympia",
    "zip": 98501,
    "concatenated_address": "607 Pattison St SE, Olympia",
    "address": "607 Pattison St. S.E., Olympia"
  },
  {
    "id": 2309,
    "financing": "Federally subsidized",
    "building_name": "Dune Grass",
    "latitude": 47.011442,
    "longitude": -124.16425,
    "original_address": "807 Anchor Avenue Nw",
    "building_number": 807,
    "street": "Anchor Ave NW",
    "city": "Ocean Shores",
    "zip": 98569,
    "concatenated_address": "807 Anchor Ave NW, Ocean Shores",
    "address": "807 Anchor Ave. N.W., Ocean Shores"
  },
  {
    "id": 2310,
    "financing": "Federally subsidized",
    "building_name": "Eagle Nest",
    "latitude": 48.42723,
    "longitude": -119.45871,
    "original_address": "324R Omak-Riverside Eastside Road",
    "building_number": 324,
    "street": "Omak-riverside Eastside Rd",
    "city": "Omak",
    "zip": 98841,
    "concatenated_address": "324 Omak-riverside Eastside Rd, Omak",
    "address": "324 Omak-riverside Eastside Road, Omak"
  },
  {
    "id": 2311,
    "financing": "Federally subsidized",
    "building_name": "Eagle's Landing Apartments",
    "latitude": 47.883783,
    "longitude": -122.24281,
    "original_address": "12601 Eighth Avenue W",
    "building_number": 12601,
    "street": "8th Ave W",
    "city": "Everett",
    "zip": 98204,
    "concatenated_address": "12601 8th Ave W, Everett",
    "address": "12601 8th Ave. W., Everett"
  },
  {
    "id": 2312,
    "financing": "Federally subsidized",
    "building_name": "Eaglepointe Apartments",
    "latitude": 47.681692,
    "longitude": -117.24938,
    "original_address": "2718 North Bowdish Rd",
    "building_number": 2718,
    "street": "N Bowdish Rd",
    "city": "Spokane",
    "zip": "99206-4799",
    "concatenated_address": "2718 N Bowdish Rd, Spokane",
    "address": "2718 N. Bowdish Road, Spokane"
  },
  {
    "id": 2313,
    "financing": "Federally subsidized",
    "building_name": "Eagles Apartments",
    "latitude": 47.610885,
    "longitude": -122.33225,
    "original_address": "706 Union St",
    "building_number": 706,
    "street": "Union St",
    "city": "Seattle",
    "zip": 98101,
    "concatenated_address": "706 Union St, Seattle",
    "address": "706 Union St., Seattle"
  },
  {
    "id": 2314,
    "financing": "Federally subsidized",
    "building_name": "East Ridge Apartments",
    "latitude": 46.610175,
    "longitude": -120.49652,
    "original_address": "821 East \"D\" Street",
    "building_number": 821,
    "street": "E D St",
    "city": "Yakima",
    "zip": 98901,
    "concatenated_address": "821 E D St, Yakima",
    "address": "821 E. D St., Yakima"
  },
  {
    "id": 2315,
    "financing": "Federally subsidized",
    "building_name": "East Valley Senior Housing",
    "latitude": 47.659187,
    "longitude": -117.18976,
    "original_address": "16010 East Valley Way",
    "building_number": 16010,
    "street": "E Valleyway Ave",
    "city": "Veradale",
    "zip": "99037-8937",
    "concatenated_address": "16010 E Valleyway Ave, Veradale",
    "address": "16010 E. Valleyway Ave., Veradale"
  },
  {
    "id": 2316,
    "financing": "Federally subsidized",
    "building_name": "East Village",
    "latitude": 48.426942,
    "longitude": -119.56067,
    "original_address": "902 Apple Lane",
    "building_number": "",
    "street": "",
    "city": "Omak",
    "zip": 98841,
    "concatenated_address": "902 Apple Lane, Omak",
    "address": "902 Apple Lane, Omak"
  },
  {
    "id": 2317,
    "financing": "Federally subsidized",
    "building_name": "Eastern Hotel",
    "latitude": 47.598053,
    "longitude": -122.32486,
    "original_address": "506 Maynard Avenue South",
    "building_number": 506,
    "street": "Maynard Ave S",
    "city": "Seattle",
    "zip": 98104,
    "concatenated_address": "506 Maynard Ave S, Seattle",
    "address": "506 Maynard Ave. S., Seattle"
  },
  {
    "id": 2318,
    "financing": "Federally subsidized",
    "building_name": "Easternwood Apartments",
    "latitude": 47.765868,
    "longitude": -122.20901,
    "original_address": "9814 Ne 190th Street",
    "building_number": 9814,
    "street": "NE 190th St",
    "city": "Bothell",
    "zip": 98011,
    "concatenated_address": "9814 NE 190th St, Bothell",
    "address": "9814 N.E. 190th St., Bothell"
  },
  {
    "id": 2319,
    "financing": "Federally subsidized",
    "building_name": "Eastridge",
    "latitude": 46.610299,
    "longitude": -120.49697,
    "original_address": "825 E D Street",
    "building_number": 825,
    "street": "E D St",
    "city": "Yakima",
    "zip": 98901,
    "concatenated_address": "825 E D St, Yakima",
    "address": "825 E. D St., Yakima"
  },
  {
    "id": 2320,
    "financing": "Federally subsidized",
    "building_name": "Eastwood Square",
    "latitude": 47.640997,
    "longitude": -122.1463,
    "original_address": "14531 Ne 35th Street",
    "building_number": 14531,
    "street": "NE 35th St",
    "city": "Bellevue",
    "zip": 98007,
    "concatenated_address": "14531 NE 35th St, Bellevue",
    "address": "14531 N.E. 35th St., Bellevue"
  },
  {
    "id": 2321,
    "financing": "Federally subsidized",
    "building_name": "Eastwood Square Apartments",
    "latitude": 47.641047,
    "longitude": -122.14678,
    "original_address": "14511 Ne 35th Street",
    "building_number": 14511,
    "street": "NE 35th St",
    "city": "Bellevue",
    "zip": 98007,
    "concatenated_address": "14511 NE 35th St, Bellevue",
    "address": "14511 N.E. 35th St., Bellevue"
  },
  {
    "id": 2322,
    "financing": "Federally subsidized",
    "building_name": "Edison Park",
    "latitude": 46.324211,
    "longitude": -119.98892,
    "original_address": "2400 East Edison Rd.",
    "building_number": 2400,
    "street": "E Edison Rd",
    "city": "Sunnyside",
    "zip": 98944,
    "concatenated_address": "2400 E Edison Rd, Sunnyside",
    "address": "2400 E. Edison Road, Sunnyside"
  },
  {
    "id": 2323,
    "financing": "Federally subsidized",
    "building_name": "Edison Park Apartments",
    "latitude": 46.324572,
    "longitude": -119.98886,
    "original_address": "2400 East Edison Ave",
    "building_number": 2400,
    "street": "E Edison Ave",
    "city": "Sunnyside",
    "zip": 98944,
    "concatenated_address": "2400 E Edison Ave, Sunnyside",
    "address": "2400 E. Edison Ave., Sunnyside"
  },
  {
    "id": 2324,
    "financing": "Federally subsidized",
    "building_name": "Eernisse Apartments",
    "latitude": 47.44493,
    "longitude": -122.45844,
    "original_address": "17905 97th Pl Sw",
    "building_number": 17905,
    "street": "97th Pl SW",
    "city": "Vashon",
    "zip": 98070,
    "concatenated_address": "17905 97th Pl SW, Vashon",
    "address": "17905 97th Pl S.W., Vashon"
  },
  {
    "id": 2325,
    "financing": "Federally subsidized",
    "building_name": "Eha Senior Housing Portfolio",
    "latitude": 48.002747,
    "longitude": -122.19787,
    "original_address": "1115 Rainier Avenue",
    "building_number": 1115,
    "street": "Rainier Ave",
    "city": "Everett",
    "zip": 98201,
    "concatenated_address": "1115 Rainier Ave, Everett",
    "address": "1115 Rainier Ave., Everett"
  },
  {
    "id": 2326,
    "financing": "Federally subsidized",
    "building_name": "Eighteenth Avenue Apartments",
    "latitude": 47.615068,
    "longitude": -122.30848,
    "original_address": "1532 18th Avenue",
    "building_number": 1532,
    "street": "18th Ave",
    "city": "Seattle",
    "zip": 98122,
    "concatenated_address": "1532 18th Ave, Seattle",
    "address": "1532 18th Ave., Seattle"
  },
  {
    "id": 2327,
    "financing": "Federally subsidized",
    "building_name": "El Estero Apartments",
    "latitude": 47.679096,
    "longitude": -117.37589,
    "original_address": "2303 E Upriver Drive",
    "building_number": 2303,
    "street": "E Upriver Dr",
    "city": "Spokane",
    "zip": 99202,
    "concatenated_address": "2303 E Upriver Dr, Spokane",
    "address": "2303 E. Upriver Drive, Spokane"
  },
  {
    "id": 2328,
    "financing": "Federally subsidized",
    "building_name": "El Nor Apartments",
    "latitude": 47.602283,
    "longitude": -122.30928,
    "original_address": "117 18th Avenue",
    "building_number": 117,
    "street": "18th Ave",
    "city": "Seattle",
    "zip": 98122,
    "concatenated_address": "117 18th Ave, Seattle",
    "address": "117 18th Ave., Seattle"
  },
  {
    "id": 2329,
    "financing": "Federally subsidized",
    "building_name": "El Patio",
    "latitude": 47.580209,
    "longitude": -122.31417,
    "original_address": "2522 14th Avenue S",
    "building_number": 2522,
    "street": "14th Ave S",
    "city": "Seattle",
    "zip": 98144,
    "concatenated_address": "2522 14th Ave S, Seattle",
    "address": "2522 14th Ave. S., Seattle"
  },
  {
    "id": 2330,
    "financing": "Federally subsidized",
    "building_name": "Eleanor Apartments",
    "latitude": 48.749882,
    "longitude": -122.47238,
    "original_address": "1510 N. Forest St",
    "building_number": 1510,
    "street": "N Forest St",
    "city": "Bellingham",
    "zip": 98225,
    "concatenated_address": "1510 N Forest St, Bellingham",
    "address": "1510 N. Forest St., Bellingham"
  },
  {
    "id": 2331,
    "financing": "Federally subsidized",
    "building_name": "Eliza Mccabe Townhomes",
    "latitude": 47.240814,
    "longitude": -122.44414,
    "original_address": "2315 Yakima Avenue South",
    "building_number": 2315,
    "street": "Yakima Ave",
    "city": "Tacoma",
    "zip": 98405,
    "concatenated_address": "2315 Yakima Ave, Tacoma",
    "address": "2315 Yakima Ave., Tacoma"
  },
  {
    "id": 2332,
    "financing": "Federally subsidized",
    "building_name": "Elizabeth James Senior Housing",
    "latitude": 47.619709,
    "longitude": -122.30287,
    "original_address": "109 23rd Ave. East",
    "building_number": 109,
    "street": "23rd Ave E",
    "city": "Seattle",
    "zip": 98112,
    "concatenated_address": "109 23rd Ave E, Seattle",
    "address": "109 23rd Ave. E., Seattle"
  },
  {
    "id": 2333,
    "financing": "Federally subsidized",
    "building_name": "Elk Creek Apartments",
    "latitude": 48.072747,
    "longitude": -123.08225,
    "original_address": "90 S Rhodefer Rd",
    "building_number": 90,
    "street": "S Rhodefer Rd",
    "city": "Sequim",
    "zip": "98382-3574",
    "concatenated_address": "90 S Rhodefer Rd, Sequim",
    "address": "90 S. Rhodefer Road, Sequim"
  },
  {
    "id": 2334,
    "financing": "Federally subsidized",
    "building_name": "Ellis Court",
    "latitude": 47.614475,
    "longitude": -122.3498,
    "original_address": "2510 Western Ave",
    "building_number": 2510,
    "street": "Western Ave",
    "city": "Seattle",
    "zip": 98121,
    "concatenated_address": "2510 Western Ave, Seattle",
    "address": "2510 Western Ave., Seattle"
  },
  {
    "id": 2335,
    "financing": "Federally subsidized",
    "building_name": "Ellsworth House",
    "latitude": 47.586126,
    "longitude": -122.23696,
    "original_address": "2720 76th Ave. Se",
    "building_number": 2720,
    "street": "76th Ave SE",
    "city": "Mercer Island",
    "zip": 98040,
    "concatenated_address": "2720 76th Ave SE, Mercer Island",
    "address": "2720 76th Ave. S.E., Mercer Island"
  },
  {
    "id": 2336,
    "financing": "Federally subsidized",
    "building_name": "Elma Gardens Apartments",
    "latitude": 47.007191,
    "longitude": -123.40039,
    "original_address": "309 E Martin Street",
    "building_number": 309,
    "street": "E Martin St",
    "city": "Elma",
    "zip": 98541,
    "concatenated_address": "309 E Martin St, Elma",
    "address": "309 E. Martin St., Elma"
  },
  {
    "id": 2337,
    "financing": "Federally subsidized",
    "building_name": "Elmwood",
    "latitude": 48.357479,
    "longitude": -119.59042,
    "original_address": "880 Second Avenue S",
    "building_number": 880,
    "street": "2nd Ave S",
    "city": "Okanogan",
    "zip": 98840,
    "concatenated_address": "880 2nd Ave S, Okanogan",
    "address": "880 2nd Ave. S., Okanogan"
  },
  {
    "id": 2338,
    "financing": "Federally subsidized",
    "building_name": "Emerald City Commons",
    "latitude": 47.533429,
    "longitude": -122.26934,
    "original_address": "7700 Rainier Avenue South",
    "building_number": 7700,
    "street": "Rainier Ave S",
    "city": "Seattle",
    "zip": 98118,
    "concatenated_address": "7700 Rainier Ave S, Seattle",
    "address": "7700 Rainier Ave. S., Seattle"
  },
  {
    "id": 2339,
    "financing": "Federally subsidized",
    "building_name": "Emerson Manor",
    "latitude": 46.977147,
    "longitude": -123.88384,
    "original_address": "703 Simpson Ave.",
    "building_number": 703,
    "street": "Simpson Ave",
    "city": "Hoquiam",
    "zip": 98550,
    "concatenated_address": "703 Simpson Ave, Hoquiam",
    "address": "703 Simpson Ave., Hoquiam"
  },
  {
    "id": 2340,
    "financing": "Federally subsidized",
    "building_name": "Emma Pardee Townhomes",
    "latitude": 47.6163,
    "longitude": -122.31397,
    "original_address": "1401 East Olive",
    "building_number": 1401,
    "street": "E Olive St",
    "city": "Seattle",
    "zip": 98122,
    "concatenated_address": "1401 E Olive St, Seattle",
    "address": "1401 E. Olive St., Seattle"
  },
  {
    "id": 2341,
    "financing": "Federally subsidized",
    "building_name": "Emmons Apartments",
    "latitude": 47.255077,
    "longitude": -122.45116,
    "original_address": "802 South J Street",
    "building_number": 802,
    "street": "S J St",
    "city": "Tacoma",
    "zip": "98405-4107",
    "concatenated_address": "802 S J St, Tacoma",
    "address": "802 S. J St., Tacoma"
  },
  {
    "id": 2342,
    "financing": "Federally subsidized",
    "building_name": "Englewood Gardens",
    "latitude": 46.609989,
    "longitude": -120.55646,
    "original_address": "3601 Fairbanks Ave",
    "building_number": 3601,
    "street": "Fairbanks Ave",
    "city": "Yakima",
    "zip": 98902,
    "concatenated_address": "3601 Fairbanks Ave, Yakima",
    "address": "3601 Fairbanks Ave., Yakima"
  },
  {
    "id": 2343,
    "financing": "Federally subsidized",
    "building_name": "Ephrata Manor Apartments",
    "latitude": 47.319205,
    "longitude": -119.54499,
    "original_address": "15 D Street Ne",
    "building_number": 15,
    "street": "D St NE",
    "city": "Ephrata",
    "zip": 98823,
    "concatenated_address": "15 D St NE, Ephrata",
    "address": "15 D St. N.E., Ephrata"
  },
  {
    "id": 2344,
    "financing": "Federally subsidized",
    "building_name": "Ernestine Anderson Place",
    "latitude": 47.599467,
    "longitude": -122.30555,
    "original_address": "2010 S. Jackson St",
    "building_number": 2010,
    "street": "S Jackson St",
    "city": "Seattle",
    "zip": 98144,
    "concatenated_address": "2010 S Jackson St, Seattle",
    "address": "2010 S. Jackson St., Seattle"
  },
  {
    "id": 2345,
    "financing": "Federally subsidized",
    "building_name": "Esperanza Apartments",
    "latitude": 47.539336,
    "longitude": -122.28559,
    "original_address": "6940 37th Avenue South",
    "building_number": 6940,
    "street": "37th Ave S",
    "city": "Seattle",
    "zip": 98118,
    "concatenated_address": "6940 37th Ave S, Seattle",
    "address": "6940 37th Ave. S., Seattle"
  },
  {
    "id": 2346,
    "financing": "Federally subsidized",
    "building_name": "Esther Short Commons",
    "latitude": 45.626829,
    "longitude": -122.67688,
    "original_address": "555 West 8th Street",
    "building_number": 555,
    "street": "W 8th St",
    "city": "Vancouver",
    "zip": 98660,
    "concatenated_address": "555 W 8th St, Vancouver",
    "address": "555 W. 8th St., Vancouver"
  },
  {
    "id": 2347,
    "financing": "Federally subsidized",
    "building_name": "Evans House",
    "latitude": 47.605799,
    "longitude": -122.31981,
    "original_address": "415 - 10th Ave",
    "building_number": 415,
    "street": "10th Ave",
    "city": "Seattle",
    "zip": 98122,
    "concatenated_address": "415 10th Ave, Seattle",
    "address": "415 10th Ave., Seattle"
  },
  {
    "id": 2348,
    "financing": "Federally subsidized",
    "building_name": "Everett Affordable Housing Portfolio Lllp",
    "latitude": 47.972772,
    "longitude": -122.21076,
    "original_address": "3327 Rucker Avenue",
    "building_number": 3327,
    "street": "Rucker Ave",
    "city": "Everett",
    "zip": 98201,
    "concatenated_address": "3327 Rucker Ave, Everett",
    "address": "3327 Rucker Ave., Everett"
  },
  {
    "id": 2349,
    "financing": "Federally subsidized",
    "building_name": "Evergreen Apartments",
    "latitude": 47.055445,
    "longitude": -123.27678,
    "original_address": "907 W. Simpson Ave",
    "building_number": 907,
    "street": "W Simpson Ave",
    "city": "McCleary",
    "zip": 98557,
    "concatenated_address": "907 W Simpson Ave, McCleary",
    "address": "907 W. Simpson Ave., McCleary"
  },
  {
    "id": 2350,
    "financing": "Federally subsidized",
    "building_name": "Evergreen Court",
    "latitude": 47.617622,
    "longitude": -122.17371,
    "original_address": "900 124th Avenue Ne",
    "building_number": 900,
    "street": "124th Ave NE",
    "city": "Bellevue",
    "zip": 98005,
    "concatenated_address": "900 124th Ave NE, Bellevue",
    "address": "900 124th Ave. N.E., Bellevue"
  },
  {
    "id": 2351,
    "financing": "Federally subsidized",
    "building_name": "Evergreen Court Apartments",
    "latitude": 48.125282,
    "longitude": -123.49314,
    "original_address": "2202 West 16th Street",
    "building_number": 2202,
    "street": "W 16th St",
    "city": "Port Angeles",
    "zip": "98363-5138",
    "concatenated_address": "2202 W 16th St, Port Angeles",
    "address": "2202 W. 16th St., Port Angeles"
  },
  {
    "id": 2352,
    "financing": "Federally subsidized",
    "building_name": "Evergreen Retirement",
    "latitude": 45.625154,
    "longitude": -122.67204,
    "original_address": "500 Main St",
    "building_number": 500,
    "street": "Main St",
    "city": "Vancouver",
    "zip": 98660,
    "concatenated_address": "500 Main St, Vancouver",
    "address": "500 Main St., Vancouver"
  },
  {
    "id": 2353,
    "financing": "Federally subsidized",
    "building_name": "Evergreen Ridge Apartments",
    "latitude": 48.775785,
    "longitude": -122.44583,
    "original_address": "3451 Woburn Street",
    "building_number": 3451,
    "street": "Woburn St",
    "city": "Bellingham",
    "zip": "98226-5674",
    "concatenated_address": "3451 Woburn St, Bellingham",
    "address": "3451 Woburn St., Bellingham"
  },
  {
    "id": 2354,
    "financing": "Federally subsidized",
    "building_name": "Evergreen Villages",
    "latitude": 47.051216,
    "longitude": -122.92847,
    "original_address": "505 Nw Division Street",
    "building_number": 505,
    "street": "Division St NW",
    "city": "Olympia",
    "zip": "98502-4767",
    "concatenated_address": "505 Division St NW, Olympia",
    "address": "505 Division St. N.W., Olympia"
  },
  {
    "id": 2355,
    "financing": "Federally subsidized",
    "building_name": "Evergreen Vista I",
    "latitude": 47.036583,
    "longitude": -122.93094,
    "original_address": "1209 Fern Street Sw",
    "building_number": 1209,
    "street": "Fern St SW",
    "city": "Olympia",
    "zip": 98502,
    "concatenated_address": "1209 Fern St SW, Olympia",
    "address": "1209 Fern St. S.W., Olympia"
  },
  {
    "id": 2356,
    "financing": "Federally subsidized",
    "building_name": "Evergreen Vista II",
    "latitude": 47.036453,
    "longitude": -122.92964,
    "original_address": "1225 Fern Street Sw",
    "building_number": 1225,
    "street": "Fern St SW",
    "city": "Olympia",
    "zip": 98502,
    "concatenated_address": "1225 Fern St SW, Olympia",
    "address": "1225 Fern St. S.W., Olympia"
  },
  {
    "id": 2357,
    "financing": "Federally subsidized",
    "building_name": "Fahy Garden Apartments",
    "latitude": 47.666002,
    "longitude": -117.43286,
    "original_address": "1403 W. Dean Ave",
    "building_number": 1403,
    "street": "W Dean Ave",
    "city": "Spokane",
    "zip": 99201,
    "concatenated_address": "1403 W Dean Ave, Spokane",
    "address": "1403 W. Dean Ave., Spokane"
  },
  {
    "id": 2358,
    "financing": "Federally subsidized",
    "building_name": "Fahy West Apartments",
    "latitude": 47.666091,
    "longitude": -117.43507,
    "original_address": "1523 W. Dean Ave",
    "building_number": 1523,
    "street": "W Dean Ave",
    "city": "Spokane",
    "zip": 99201,
    "concatenated_address": "1523 W Dean Ave, Spokane",
    "address": "1523 W. Dean Ave., Spokane"
  },
  {
    "id": 2359,
    "financing": "Federally subsidized",
    "building_name": "Fair Street",
    "latitude": 46.421577,
    "longitude": -117.06427,
    "original_address": "1411 Fair Street",
    "building_number": 1411,
    "street": "Fair St",
    "city": "Clarkston",
    "zip": 99403,
    "concatenated_address": "1411 Fair St, Clarkston",
    "address": "1411 Fair St., Clarkston"
  },
  {
    "id": 2360,
    "financing": "Federally subsidized",
    "building_name": "Fair Street Apartments",
    "latitude": 46.421577,
    "longitude": -117.06427,
    "original_address": "1411 Fair Street",
    "building_number": 1411,
    "street": "Fair St",
    "city": "Clarkston",
    "zip": 99403,
    "concatenated_address": "1411 Fair St, Clarkston",
    "address": "1411 Fair St., Clarkston"
  },
  {
    "id": 2361,
    "financing": "Federally subsidized",
    "building_name": "Fairchild Heights Apartments",
    "latitude": 48.122328,
    "longitude": -123.49051,
    "original_address": "2301 W 18th Street",
    "building_number": 2301,
    "street": "W 18th St",
    "city": "Port Angeles",
    "zip": 98363,
    "concatenated_address": "2301 W 18th St, Port Angeles",
    "address": "2301 W. 18th St., Port Angeles"
  },
  {
    "id": 2362,
    "financing": "Federally subsidized",
    "building_name": "Fairhaven Manor Apartments",
    "latitude": 48.475033,
    "longitude": -122.33798,
    "original_address": "115 Hulbush Ln",
    "building_number": 115,
    "street": "Hulbush Ln",
    "city": "Burlington",
    "zip": 98233,
    "concatenated_address": "115 Hulbush Ln, Burlington",
    "address": "115 Hulbush Lane, Burlington"
  },
  {
    "id": 2363,
    "financing": "Federally subsidized",
    "building_name": "Fairview Senior Housing",
    "latitude": 46.968654,
    "longitude": -119.0332,
    "original_address": "508 E. 2nd Street",
    "building_number": 508,
    "street": "E 2nd St",
    "city": "Warden",
    "zip": 98857,
    "concatenated_address": "508 E 2nd St, Warden",
    "address": "508 E. 2nd St., Warden"
  },
  {
    "id": 2364,
    "financing": "Federally subsidized",
    "building_name": "Fairwind Apartments",
    "latitude": 47.504697,
    "longitude": -122.33992,
    "original_address": "411 Sw 110th Lane",
    "building_number": 411,
    "street": "SW 110th Ln",
    "city": "Seattle",
    "zip": 98146,
    "concatenated_address": "411 SW 110th Ln, Seattle",
    "address": "411 S.W. 110th Lane, Seattle"
  },
  {
    "id": 2365,
    "financing": "Federally subsidized",
    "building_name": "Fairwood Apartments",
    "latitude": 47.446588,
    "longitude": -122.14957,
    "original_address": "14300 Se 171st Way",
    "building_number": 14300,
    "street": "SE 171st Way",
    "city": "Renton",
    "zip": 98058,
    "concatenated_address": "14300 SE 171st Way, Renton",
    "address": "14300 S.E. 171st Way, Renton"
  },
  {
    "id": 2366,
    "financing": "Federally subsidized",
    "building_name": "Family Tree And Lincoln Way",
    "latitude": 48.305992,
    "longitude": -122.65681,
    "original_address": "950 N Oak Harbor St",
    "building_number": 950,
    "street": "N Oak Harbor St",
    "city": "Oak Harbor",
    "zip": 98277,
    "concatenated_address": "950 N Oak Harbor St, Oak Harbor",
    "address": "950 N. Oak Harbor St., Oak Harbor"
  },
  {
    "id": 2367,
    "financing": "Federally subsidized",
    "building_name": "Family Tree Apartments",
    "latitude": 47.905931,
    "longitude": -122.20838,
    "original_address": "10110 19th Ave. Se",
    "building_number": 10110,
    "street": "19th Ave SE",
    "city": "Everett",
    "zip": 98208,
    "concatenated_address": "10110 19th Ave SE, Everett",
    "address": "10110 19th Ave. S.E., Everett"
  },
  {
    "id": 2368,
    "financing": "Federally subsidized",
    "building_name": "Father Bach Haven (formerly known as Valor Haven)",
    "latitude": 47.656209,
    "longitude": -117.41244,
    "original_address": "108 South State St",
    "building_number": 108,
    "street": "S State St",
    "city": "Spokane",
    "zip": 99201,
    "concatenated_address": "108 S State St, Spokane",
    "address": "108 S. State St., Spokane"
  },
  {
    "id": 2369,
    "financing": "Federally subsidized",
    "building_name": "Fawcett Street",
    "latitude": 47.259305,
    "longitude": -122.44477,
    "original_address": "435 Fawcett",
    "building_number": 435,
    "street": "Fawcett Ave",
    "city": "Tacoma",
    "zip": 98402,
    "concatenated_address": "435 Fawcett Ave, Tacoma",
    "address": "435 Fawcett Ave., Tacoma"
  },
  {
    "id": 2370,
    "financing": "Federally subsidized",
    "building_name": "Fern Hill Terrace",
    "latitude": 47.184111,
    "longitude": -122.43496,
    "original_address": "214 So. 80th St.",
    "building_number": 214,
    "street": "S 80th St",
    "city": "Tacoma",
    "zip": 98408,
    "concatenated_address": "214 S 80th St, Tacoma",
    "address": "214 S. 80th St., Tacoma"
  },
  {
    "id": 2371,
    "financing": "Federally subsidized",
    "building_name": "Fern Ridge I & II",
    "latitude": 47.035513,
    "longitude": -122.93125,
    "original_address": "1309 Fern Street Sw",
    "building_number": 1309,
    "street": "Fern St SW",
    "city": "Olympia",
    "zip": 98502,
    "concatenated_address": "1309 Fern St SW, Olympia",
    "address": "1309 Fern St. S.W., Olympia"
  },
  {
    "id": 2372,
    "financing": "Federally subsidized",
    "building_name": "Ferndale Square",
    "latitude": 48.849417,
    "longitude": -122.60467,
    "original_address": "2254 Main Street",
    "building_number": 2254,
    "street": "Main St",
    "city": "Ferndale",
    "zip": 98248,
    "concatenated_address": "2254 Main St, Ferndale",
    "address": "2254 Main St., Ferndale"
  },
  {
    "id": 2373,
    "financing": "Federally subsidized",
    "building_name": "Ferndale Villa",
    "latitude": 48.849205,
    "longitude": -122.60957,
    "original_address": "2348 Main Street",
    "building_number": 2348,
    "street": "Main St",
    "city": "Ferndale",
    "zip": 98248,
    "concatenated_address": "2348 Main St, Ferndale",
    "address": "2348 Main St., Ferndale"
  },
  {
    "id": 2374,
    "financing": "Federally subsidized",
    "building_name": "Fernview Apartments",
    "latitude": 48.850327,
    "longitude": -122.5993,
    "original_address": "2160 Washington St.",
    "building_number": 2160,
    "street": "Washington St",
    "city": "Ferndale",
    "zip": 98248,
    "concatenated_address": "2160 Washington St, Ferndale",
    "address": "2160 Washington St., Ferndale"
  },
  {
    "id": 2375,
    "financing": "Federally subsidized",
    "building_name": "Finch Place",
    "latitude": 47.624482,
    "longitude": -122.52231,
    "original_address": "215 Finch Place Sw",
    "building_number": 215,
    "street": "Finch Pl SW",
    "city": "Bainbridge Island",
    "zip": 98110,
    "concatenated_address": "215 Finch Pl SW, Bainbridge Island",
    "address": "215 Finch Pl S.W., Bainbridge Island"
  },
  {
    "id": 2376,
    "financing": "Federally subsidized",
    "building_name": "Fir Meadows",
    "latitude": 47.956776,
    "longitude": -117.48147,
    "original_address": "223 West 3rd Street",
    "building_number": 223,
    "street": "W 3rd St",
    "city": "Deer Park",
    "zip": 99006,
    "concatenated_address": "223 W 3rd St, Deer Park",
    "address": "223 W. 3rd St., Deer Park"
  },
  {
    "id": 2377,
    "financing": "Federally subsidized",
    "building_name": "Fir Tree Park",
    "latitude": 47.217516,
    "longitude": -123.10194,
    "original_address": "614 N 4th St",
    "building_number": 614,
    "street": "N 4th St",
    "city": "Shelton",
    "zip": 98584,
    "concatenated_address": "614 N 4th St, Shelton",
    "address": "614 N. 4th St., Shelton"
  },
  {
    "id": 2378,
    "financing": "Federally subsidized",
    "building_name": "Fir Village Apartments",
    "latitude": 48.3053,
    "longitude": -122.65703,
    "original_address": "869 N Oak Harbor St.",
    "building_number": 869,
    "street": "N Oak Harbor St",
    "city": "Oak Harbor",
    "zip": 98277,
    "concatenated_address": "869 N Oak Harbor St, Oak Harbor",
    "address": "869 N. Oak Harbor St., Oak Harbor"
  },
  {
    "id": 2379,
    "financing": "Federally subsidized",
    "building_name": "Fircrest Apartments",
    "latitude": 48.428929,
    "longitude": -122.31713,
    "original_address": "1826 East Bel Air Dr.",
    "building_number": 1826,
    "street": "E Belair Dr",
    "city": "Concrete",
    "zip": 98273,
    "concatenated_address": "1826 E Belair Dr, Concrete",
    "address": "1826 E. Belair Drive, Concrete"
  },
  {
    "id": 2380,
    "financing": "Federally subsidized",
    "building_name": "First & Vine Apartments",
    "latitude": 47.614904,
    "longitude": -122.34957,
    "original_address": "2519 First Ave",
    "building_number": 2519,
    "street": "1st Ave",
    "city": "Seattle",
    "zip": 98121,
    "concatenated_address": "2519 1st Ave, Seattle",
    "address": "2519 1st Ave., Seattle"
  },
  {
    "id": 2381,
    "financing": "Federally subsidized",
    "building_name": "First Liberty Apartments",
    "latitude": 47.685054,
    "longitude": -117.06891,
    "original_address": "25000 East Hawkstone Loop",
    "building_number": 25000,
    "street": "E Hawkstone Loop",
    "city": "Liberty Lake",
    "zip": "99019-5007",
    "concatenated_address": "25000 E Hawkstone Loop, Liberty Lake",
    "address": "25000 E. Hawkstone Loop, Liberty Lake"
  },
  {
    "id": 2382,
    "financing": "Federally subsidized",
    "building_name": "First Street Apartments",
    "latitude": 45.620004,
    "longitude": -122.50077,
    "original_address": "16703 Se First St",
    "building_number": 16703,
    "street": "SE 1st St",
    "city": "Vancouver",
    "zip": 98684,
    "concatenated_address": "16703 SE 1st St, Vancouver",
    "address": "16703 S.E. 1st St., Vancouver"
  },
  {
    "id": 2383,
    "financing": "Federally subsidized",
    "building_name": "Fjord Manor and Fjord Vista II",
    "latitude": 47.740733,
    "longitude": -122.64848,
    "original_address": "19581 1st Avenue Ne",
    "building_number": 19581,
    "street": "1st Ave NE",
    "city": "Poulsbo",
    "zip": 98370,
    "concatenated_address": "19581 1st Ave NE, Poulsbo",
    "address": "19581 1st Ave. N.E., Poulsbo"
  },
  {
    "id": 2384,
    "financing": "Federally subsidized",
    "building_name": "Fleetwood Apartments",
    "latitude": 47.042184,
    "longitude": -122.90038,
    "original_address": "119 7th Ave Se",
    "building_number": 119,
    "street": "7th Ave SE",
    "city": "Olympia",
    "zip": 98504,
    "concatenated_address": "119 7th Ave SE, Olympia",
    "address": "119 7th Ave. S.E., Olympia"
  },
  {
    "id": 2385,
    "financing": "Federally subsidized",
    "building_name": "Fleming Apartments",
    "latitude": 47.615581,
    "longitude": -122.34496,
    "original_address": "2321 4th Avenue",
    "building_number": 2321,
    "street": "4th Ave",
    "city": "Seattle",
    "zip": 98121,
    "concatenated_address": "2321 4th Ave, Seattle",
    "address": "2321 4th Ave., Seattle"
  },
  {
    "id": 2386,
    "financing": "Federally subsidized",
    "building_name": "Forest Creek Apartments",
    "latitude": 47.777086,
    "longitude": -117.40311,
    "original_address": "13110 N Addison St",
    "building_number": 13110,
    "street": "N Addison St",
    "city": "Spokane",
    "zip": 99208,
    "concatenated_address": "13110 N Addison St, Spokane",
    "address": "13110 N. Addison St., Spokane"
  },
  {
    "id": 2387,
    "financing": "Federally subsidized",
    "building_name": "Forest Grove Apartments",
    "latitude": 47.020332,
    "longitude": -122.80871,
    "original_address": "5701 30th Avenue Se",
    "building_number": 5701,
    "street": "30th Ave SE",
    "city": "Lacey",
    "zip": 98503,
    "concatenated_address": "5701 30th Ave SE, Lacey",
    "address": "5701 30th Ave. S.E., Lacey"
  },
  {
    "id": 2388,
    "financing": "Federally subsidized",
    "building_name": "Forest View",
    "latitude": 47.181984,
    "longitude": -122.19137,
    "original_address": "8313 Meyer Rd",
    "building_number": 8313,
    "street": "Myers Rd",
    "city": "Bonney Lake",
    "zip": 98391,
    "concatenated_address": "8313 Myers Rd, Bonney Lake",
    "address": "8313 Myers Road, Bonney Lake"
  },
  {
    "id": 2389,
    "financing": "Federally subsidized",
    "building_name": "Fort Vancouver Terrace",
    "latitude": 45.644448,
    "longitude": -122.62035,
    "original_address": "4710 Plomondon Street",
    "building_number": 4710,
    "street": "Plomondon St",
    "city": "Vancouver",
    "zip": 98661,
    "concatenated_address": "4710 Plomondon St, Vancouver",
    "address": "4710 Plomondon St., Vancouver"
  },
  {
    "id": 2390,
    "financing": "Federally subsidized",
    "building_name": "Francis Place",
    "latitude": 48.74931,
    "longitude": -122.4799,
    "original_address": "1100 Cornwall Avenue",
    "building_number": 1100,
    "street": "Cornwall Ave",
    "city": "Bellingham",
    "zip": 98225,
    "concatenated_address": "1100 Cornwall Ave, Bellingham",
    "address": "1100 Cornwall Ave., Bellingham"
  },
  {
    "id": 2391,
    "financing": "Federally subsidized",
    "building_name": "Francis Village",
    "latitude": 47.709751,
    "longitude": -122.17189,
    "original_address": "12601 Ne 124th Street",
    "building_number": 12601,
    "street": "NE 124th St",
    "city": "Kirkland",
    "zip": 98034,
    "concatenated_address": "12601 NE 124th St, Kirkland",
    "address": "12601 N.E. 124th St., Kirkland"
  },
  {
    "id": 2392,
    "financing": "Federally subsidized",
    "building_name": "Frank Chopp Place",
    "latitude": 47.568357,
    "longitude": -122.63525,
    "original_address": "704 Chester Avenue",
    "building_number": 704,
    "street": "Chester Ave",
    "city": "Bremerton",
    "zip": 98337,
    "concatenated_address": "704 Chester Ave, Bremerton",
    "address": "704 Chester Ave., Bremerton"
  },
  {
    "id": 2393,
    "financing": "Federally subsidized",
    "building_name": "Frederic Ozanam House",
    "latitude": 47.607073,
    "longitude": -122.3265,
    "original_address": "801 - 9th Ave",
    "building_number": 801,
    "street": "9th Ave",
    "city": "Seattle",
    "zip": 98104,
    "concatenated_address": "801 9th Ave, Seattle",
    "address": "801 9th Ave., Seattle"
  },
  {
    "id": 2394,
    "financing": "Federally subsidized",
    "building_name": "Fredonia Apartments",
    "latitude": 47.624157,
    "longitude": -122.31237,
    "original_address": "1509 E. Mercer Street",
    "building_number": 1509,
    "street": "E Mercer St",
    "city": "Seattle",
    "zip": 98112,
    "concatenated_address": "1509 E Mercer St, Seattle",
    "address": "1509 E. Mercer St., Seattle"
  },
  {
    "id": 2395,
    "financing": "Federally subsidized",
    "building_name": "Freedoms Path At Vancouver Wa",
    "latitude": 45.623704,
    "longitude": -122.65497,
    "original_address": "1601 E 4th Plain Blvd.",
    "building_number": 1601,
    "street": "E 4th St",
    "city": "Vancouver",
    "zip": 98661,
    "concatenated_address": "1601 E 4th St, Vancouver",
    "address": "1601 E. 4th St., Vancouver"
  },
  {
    "id": 2396,
    "financing": "Federally subsidized",
    "building_name": "Freeport Apartments",
    "latitude": 47.164768,
    "longitude": -122.49911,
    "original_address": "10211 47th Avenue Sw",
    "building_number": 10211,
    "street": "47th Ave SW",
    "city": "Lakewood",
    "zip": 98499,
    "concatenated_address": "10211 47th Ave SW, Lakewood",
    "address": "10211 47th Ave. S.W., Lakewood"
  },
  {
    "id": 2397,
    "financing": "Federally subsidized",
    "building_name": "Fremont Solstice",
    "latitude": 47.651283,
    "longitude": -122.34428,
    "original_address": "3623 Woodland Park Avenue No.",
    "building_number": 3623,
    "street": "Woodland Park Ave N",
    "city": "Seattle",
    "zip": 98103,
    "concatenated_address": "3623 Woodland Park Ave N, Seattle",
    "address": "3623 Woodland Park Ave. N., Seattle"
  },
  {
    "id": 2398,
    "financing": "Federally subsidized",
    "building_name": "Frenchman Hill Apartments",
    "latitude": 46.903264,
    "longitude": -119.62176,
    "original_address": "590 Beach Avenue Ne",
    "building_number": 590,
    "street": "Beech Ave NE",
    "city": "Royal City",
    "zip": 99357,
    "concatenated_address": "590 Beech Ave NE, Royal City",
    "address": "590 Beech Ave. N.E., Royal City"
  },
  {
    "id": 2399,
    "financing": "Federally subsidized",
    "building_name": "Friday Harbor Village",
    "latitude": 48.538766,
    "longitude": -123.02976,
    "original_address": "445 Carter Ave",
    "building_number": 445,
    "street": "Carter Ave Ofc",
    "city": "Friday Harbor",
    "zip": 98250,
    "concatenated_address": "445 Carter Ave Ofc, Friday Harbor",
    "address": "445 Carter Ave. Ofc, Friday Harbor"
  },
  {
    "id": 2400,
    "financing": "Federally subsidized",
    "building_name": "Friendship House I & II Apartments",
    "latitude": 47.857971,
    "longitude": -121.98079,
    "original_address": "701 West Elizabeth",
    "building_number": 701,
    "street": "W Elizabeth St",
    "city": "Monroe",
    "zip": 98272,
    "concatenated_address": "701 W Elizabeth St, Monroe",
    "address": "701 W. Elizabeth St., Monroe"
  },
  {
    "id": 2401,
    "financing": "Federally subsidized",
    "building_name": "Frontier Springs",
    "latitude": 48.653974,
    "longitude": -118.73138,
    "original_address": "11 North Star Lane",
    "building_number": 11,
    "street": "N Star Ln",
    "city": "Republic",
    "zip": 99166,
    "concatenated_address": "11 N Star Ln, Republic",
    "address": "11 N. Star Lane, Republic"
  },
  {
    "id": 2402,
    "financing": "Federally subsidized",
    "building_name": "Fruit Valley Court Apartments",
    "latitude": 45.64656,
    "longitude": -122.69061,
    "original_address": "1904 W 34th Street",
    "building_number": 1904,
    "street": "W 34th St",
    "city": "Vancouver",
    "zip": 98660,
    "concatenated_address": "1904 W 34th St, Vancouver",
    "address": "1904 W. 34th St., Vancouver"
  },
  {
    "id": 2403,
    "financing": "Federally subsidized",
    "building_name": "Frye Building",
    "latitude": 47.601598,
    "longitude": -122.33061,
    "original_address": "223 Yesler Way",
    "building_number": 223,
    "street": "Yesler Way",
    "city": "Seattle",
    "zip": "98104-2638",
    "concatenated_address": "223 Yesler Way, Seattle",
    "address": "223 Yesler Way, Seattle"
  },
  {
    "id": 2404,
    "financing": "Federally subsidized",
    "building_name": "Galbraith Gardens",
    "latitude": 46.064649,
    "longitude": -118.3323,
    "original_address": "343 Catherine St",
    "building_number": 343,
    "street": "Catherine St",
    "city": "Walla Walla",
    "zip": "99362-3042",
    "concatenated_address": "343 Catherine St, Walla Walla",
    "address": "343 Catherine St., Walla Walla"
  },
  {
    "id": 2405,
    "financing": "Federally subsidized",
    "building_name": "Galena Apartments",
    "latitude": 47.643803,
    "longitude": -117.59205,
    "original_address": "13500 Block W. 6th Avenue",
    "building_number": "",
    "street": "",
    "city": "Airway Heights",
    "zip": 99001,
    "concatenated_address": "13500 Block W. 6th Avenue, Airway Heights",
    "address": "13500 Block W. 6th Avenue, Airway Heights"
  },
  {
    "id": 2406,
    "financing": "Federally subsidized",
    "building_name": "Galway Bay Apartments",
    "latitude": 47.8665,
    "longitude": -121.81026,
    "original_address": "507 Eight Street",
    "building_number": 507,
    "street": "8th St",
    "city": "Sultan",
    "zip": 98294,
    "concatenated_address": "507 8th St, Sultan",
    "address": "507 8th St., Sultan"
  },
  {
    "id": 2407,
    "financing": "Federally subsidized",
    "building_name": "Garden Court Apartments",
    "latitude": 48.031078,
    "longitude": -122.76264,
    "original_address": "61 Garden Court Rd",
    "building_number": 61,
    "street": "Garden Ct",
    "city": "Port Hadlock",
    "zip": 98339,
    "concatenated_address": "61 Garden Ct, Port Hadlock",
    "address": "61 Garden Ct, Port Hadlock"
  },
  {
    "id": 2408,
    "financing": "Federally subsidized",
    "building_name": "Garden Grove & Wildwood Court",
    "latitude": 47.600492,
    "longitude": -122.15321,
    "original_address": "1027 140th Avenue Se",
    "building_number": 1027,
    "street": "140th Ave SE",
    "city": "Bellevue",
    "zip": 98005,
    "concatenated_address": "1027 140th Ave SE, Bellevue",
    "address": "1027 140th Ave. S.E., Bellevue"
  },
  {
    "id": 2409,
    "financing": "Federally subsidized",
    "building_name": "Garden Senior Village (formerly known as Lynnwood Rotary Center)",
    "latitude": 47.822207,
    "longitude": -122.32056,
    "original_address": "6425 196th Street Sw",
    "building_number": 6425,
    "street": "196th St SW",
    "city": "Lynnwood",
    "zip": 98036,
    "concatenated_address": "6425 196th St SW, Lynnwood",
    "address": "6425 196th St. S.W., Lynnwood"
  },
  {
    "id": 2410,
    "financing": "Federally subsidized",
    "building_name": "Gateway Apartments",
    "latitude": 47.879642,
    "longitude": -122.20334,
    "original_address": "13105 21st Dr. Se",
    "building_number": 13105,
    "street": "21st Dr SE",
    "city": "Everett",
    "zip": 98208,
    "concatenated_address": "13105 21st Dr SE, Everett",
    "address": "13105 21st Dr S.E., Everett"
  },
  {
    "id": 2411,
    "financing": "Federally subsidized",
    "building_name": "Genesee Housing",
    "latitude": 47.563431,
    "longitude": -122.29554,
    "original_address": "4425 Martin Luther King Jr Way S",
    "building_number": 4425,
    "street": "Martin Luther King Jr Way S",
    "city": "Seattle",
    "zip": 98108,
    "concatenated_address": "4425 Martin Luther King Jr Way S, Seattle",
    "address": "4425 Martin Luther King Jr Way S., Seattle"
  },
  {
    "id": 2412,
    "financing": "Federally subsidized",
    "building_name": "Gerard Park",
    "latitude": 48.531095,
    "longitude": -123.01295,
    "original_address": "595 Linder Street",
    "building_number": 595,
    "street": "Linder St",
    "city": "Friday Harbor",
    "zip": 98250,
    "concatenated_address": "595 Linder St, Friday Harbor",
    "address": "595 Linder St., Friday Harbor"
  },
  {
    "id": 2413,
    "financing": "Federally subsidized",
    "building_name": "Gilman Court Apartments",
    "latitude": 47.668117,
    "longitude": -122.37131,
    "original_address": "1116 Nw 54th Street",
    "building_number": 1116,
    "street": "NW 54th St",
    "city": "Seattle",
    "zip": 98107,
    "concatenated_address": "1116 NW 54th St, Seattle",
    "address": "1116 N.W. 54th St., Seattle"
  },
  {
    "id": 2414,
    "financing": "Federally subsidized",
    "building_name": "Gilmore Apartments",
    "latitude": 47.610644,
    "longitude": -122.338,
    "original_address": "1526 Third Ave",
    "building_number": 1526,
    "street": "3rd Ave",
    "city": "Seattle",
    "zip": 98101,
    "concatenated_address": "1526 3rd Ave, Seattle",
    "address": "1526 3rd Ave., Seattle"
  },
  {
    "id": 2415,
    "financing": "Federally subsidized",
    "building_name": "Glacier Village",
    "latitude": 46.867174,
    "longitude": -122.26427,
    "original_address": "212 Glacier Avenue North",
    "building_number": 212,
    "street": "Glacier Ave N",
    "city": "Eatonville",
    "zip": 98328,
    "concatenated_address": "212 Glacier Ave N, Eatonville",
    "address": "212 Glacier Ave. N., Eatonville"
  },
  {
    "id": 2416,
    "financing": "Federally subsidized",
    "building_name": "Glen Hotel",
    "latitude": 47.609069,
    "longitude": -122.33748,
    "original_address": "1413 Third Ave",
    "building_number": 1413,
    "street": "3rd Ave",
    "city": "Seattle",
    "zip": 98101,
    "concatenated_address": "1413 3rd Ave, Seattle",
    "address": "1413 3rd Ave., Seattle"
  },
  {
    "id": 2417,
    "financing": "Federally subsidized",
    "building_name": "Glenbrooke Apartments",
    "latitude": 47.152054,
    "longitude": -122.28477,
    "original_address": "701 43rd Avenue Se",
    "building_number": 701,
    "street": "43rd Ave SE",
    "city": "Puyallup",
    "zip": "98371-2198",
    "concatenated_address": "701 43rd Ave SE, Puyallup",
    "address": "701 43rd Ave. S.E., Puyallup"
  },
  {
    "id": 2418,
    "financing": "Federally subsidized",
    "building_name": "Glendale Apartments",
    "latitude": 47.618361,
    "longitude": -122.1728,
    "original_address": "12640 Ne 10th Place",
    "building_number": 12640,
    "street": "NE 10th Pl",
    "city": "Bellevue",
    "zip": 98005,
    "concatenated_address": "12640 NE 10th Pl, Bellevue",
    "address": "12640 N.E. 10th Place, Bellevue"
  },
  {
    "id": 2419,
    "financing": "Federally subsidized",
    "building_name": "Glenwood Apartments",
    "latitude": 47.998793,
    "longitude": -122.09932,
    "original_address": "9808 4th Street Ne",
    "building_number": 9808,
    "street": "4th St NE",
    "city": "Lake Stevens",
    "zip": 98258,
    "concatenated_address": "9808 4th St NE, Lake Stevens",
    "address": "9808 4th St. N.E., Lake Stevens"
  },
  {
    "id": 2420,
    "financing": "Federally subsidized",
    "building_name": "Golden Arms Apartments",
    "latitude": 45.822338,
    "longitude": -120.81563,
    "original_address": "509B East Main Street",
    "building_number": 509,
    "street": "E Main St",
    "city": "Goldendale",
    "zip": 98620,
    "concatenated_address": "509 E Main St, Goldendale",
    "address": "509 E. Main St., Goldendale"
  },
  {
    "id": 2421,
    "financing": "Federally subsidized",
    "building_name": "Golden Elm",
    "latitude": 47.208096,
    "longitude": -121.98703,
    "original_address": "1323 Battersby Ave",
    "building_number": 1323,
    "street": "Battersby Ave",
    "city": "Enumclaw",
    "zip": 98022,
    "concatenated_address": "1323 Battersby Ave, Enumclaw",
    "address": "1323 Battersby Ave., Enumclaw"
  },
  {
    "id": 2422,
    "financing": "Federally subsidized",
    "building_name": "Golden Hemlock",
    "latitude": 47.271918,
    "longitude": -122.51748,
    "original_address": "5939 N 26th",
    "building_number": 5939,
    "street": "N 26th St",
    "city": "Tacoma",
    "zip": 98407,
    "concatenated_address": "5939 N 26th St, Tacoma",
    "address": "5939 N. 26th St., Tacoma"
  },
  {
    "id": 2423,
    "financing": "Federally subsidized",
    "building_name": "Golden Sunset Apartments",
    "latitude": 47.668019,
    "longitude": -122.40072,
    "original_address": "3256 Nw 54th Street",
    "building_number": 3256,
    "street": "NW 54th St",
    "city": "Seattle",
    "zip": 98107,
    "concatenated_address": "3256 NW 54th St, Seattle",
    "address": "3256 N.W. 54th St., Seattle"
  },
  {
    "id": 2424,
    "financing": "Federally subsidized",
    "building_name": "Golden Tides II",
    "latitude": 47.647421,
    "longitude": -122.69403,
    "original_address": "9239 Bayshore Drive Nw",
    "building_number": 9239,
    "street": "Bayshore Dr NW",
    "city": "Silverdale",
    "zip": 98383,
    "concatenated_address": "9239 Bayshore Dr NW, Silverdale",
    "address": "9239 Bayshore Dr N.W., Silverdale"
  },
  {
    "id": 2425,
    "financing": "Federally subsidized",
    "building_name": "Golden Tides III",
    "latitude": 47.647304,
    "longitude": -122.69408,
    "original_address": "9225 Bayshore Drive Nw",
    "building_number": 9225,
    "street": "Bayshore Dr NW",
    "city": "Silverdale",
    "zip": 98383,
    "concatenated_address": "9225 Bayshore Dr NW, Silverdale",
    "address": "9225 Bayshore Dr N.W., Silverdale"
  },
  {
    "id": 2426,
    "financing": "Federally subsidized",
    "building_name": "Goldendale Village",
    "latitude": 45.817151,
    "longitude": -120.81738,
    "original_address": "801 S Schuster Street",
    "building_number": 801,
    "street": "S Schuster Ave",
    "city": "Goldendale",
    "zip": "98620-4126",
    "concatenated_address": "801 S Schuster Ave, Goldendale",
    "address": "801 S. Schuster Ave., Goldendale"
  },
  {
    "id": 2427,
    "financing": "Federally subsidized",
    "building_name": "Goldsborough Creek Apartments",
    "latitude": 47.211511,
    "longitude": -123.10885,
    "original_address": "303 South 7th Street",
    "building_number": 303,
    "street": "S 7th St",
    "city": "Shelton",
    "zip": 98584,
    "concatenated_address": "303 S 7th St, Shelton",
    "address": "303 S. 7th St., Shelton"
  },
  {
    "id": 2428,
    "financing": "Federally subsidized",
    "building_name": "Gossett Place",
    "latitude": 47.663716,
    "longitude": -122.31554,
    "original_address": "4719 12th Avenue Ne",
    "building_number": 4719,
    "street": "12th Ave NE",
    "city": "Seattle",
    "zip": 98105,
    "concatenated_address": "4719 12th Ave NE, Seattle",
    "address": "4719 12th Ave. N.E., Seattle"
  },
  {
    "id": 2429,
    "financing": "Federally subsidized",
    "building_name": "Gowe Court Apartments",
    "latitude": 47.38015,
    "longitude": -122.23993,
    "original_address": "627 W Titus St",
    "building_number": 627,
    "street": "W Titus St",
    "city": "Kent",
    "zip": 98032,
    "concatenated_address": "627 W Titus St, Kent",
    "address": "627 W. Titus St., Kent"
  },
  {
    "id": 2430,
    "financing": "Federally subsidized",
    "building_name": "Graham Terry Apartments",
    "latitude": 47.617747,
    "longitude": -122.33551,
    "original_address": "2020 Terry Avenue",
    "building_number": 2020,
    "street": "Terry Ave",
    "city": "Seattle",
    "zip": 98121,
    "concatenated_address": "2020 Terry Ave, Seattle",
    "address": "2020 Terry Ave., Seattle"
  },
  {
    "id": 2431,
    "financing": "Federally subsidized",
    "building_name": "Graham/Terry Apartments",
    "latitude": 47.617511,
    "longitude": -122.33529,
    "original_address": "2014 Terry",
    "building_number": 2014,
    "street": "Terry Ave",
    "city": "Seattle",
    "zip": 98121,
    "concatenated_address": "2014 Terry Ave, Seattle",
    "address": "2014 Terry Ave., Seattle"
  },
  {
    "id": 2432,
    "financing": "Federally subsidized",
    "building_name": "Grandview Apartments",
    "latitude": 47.395944,
    "longitude": -122.28273,
    "original_address": "3900 Veterans Drive",
    "building_number": 3900,
    "street": "Veterans Dr",
    "city": "Kent",
    "zip": 98032,
    "concatenated_address": "3900 Veterans Dr, Kent",
    "address": "3900 Veterans Drive, Kent"
  },
  {
    "id": 2433,
    "financing": "Federally subsidized",
    "building_name": "Grandview Estates",
    "latitude": 46.257385,
    "longitude": -119.89452,
    "original_address": "601 Washington St",
    "building_number": 601,
    "street": "Washington St",
    "city": "Grandview",
    "zip": 98930,
    "concatenated_address": "601 Washington St, Grandview",
    "address": "601 Washington St., Grandview"
  },
  {
    "id": 2434,
    "financing": "Federally subsidized",
    "building_name": "Grandview Family Housing Phase II",
    "latitude": 46.242259,
    "longitude": -119.91383,
    "original_address": "1200 Carriage Ct",
    "building_number": 1200,
    "street": "Carriage Ct",
    "city": "Grandview",
    "zip": 98930,
    "concatenated_address": "1200 Carriage Ct, Grandview",
    "address": "1200 Carriage Ct, Grandview"
  },
  {
    "id": 2435,
    "financing": "Federally subsidized",
    "building_name": "Grandview Square",
    "latitude": 46.257385,
    "longitude": -119.89452,
    "original_address": "601 Washington Street",
    "building_number": 601,
    "street": "Washington St",
    "city": "Grandview",
    "zip": 98930,
    "concatenated_address": "601 Washington St, Grandview",
    "address": "601 Washington St., Grandview"
  },
  {
    "id": 2436,
    "financing": "Federally subsidized",
    "building_name": "Grandy Lake Residences",
    "latitude": 48.442812,
    "longitude": -122.30255,
    "original_address": "30th And Martin Rd",
    "building_number": "",
    "street": "E Martin Rd",
    "city": "Mount Vernon",
    "zip": 98249,
    "concatenated_address": "30th And Martin Rd, Mount Vernon",
    "address": "30th And Martin Road, Mount Vernon"
  },
  {
    "id": 2437,
    "financing": "Federally subsidized",
    "building_name": "Green River Court Apartments",
    "latitude": 47.381813,
    "longitude": -122.25142,
    "original_address": "1401 W Meeker St",
    "building_number": 1401,
    "street": "W Meeker St",
    "city": "Kent",
    "zip": 98032,
    "concatenated_address": "1401 W Meeker St, Kent",
    "address": "1401 W. Meeker St., Kent"
  },
  {
    "id": 2438,
    "financing": "Federally subsidized",
    "building_name": "Green River Homes",
    "latitude": 47.300181,
    "longitude": -122.21375,
    "original_address": "1103 9th Street Se",
    "building_number": 1103,
    "street": "9th St SE",
    "city": "Auburn",
    "zip": "98002-6230",
    "concatenated_address": "1103 9th St SE, Auburn",
    "address": "1103 9th St. S.E., Auburn"
  },
  {
    "id": 2439,
    "financing": "Federally subsidized",
    "building_name": "Greenbridge Hope VI - Eastbridge Apartments",
    "latitude": 47.514668,
    "longitude": -122.33942,
    "original_address": "9963 3rd Lane Sw",
    "building_number": 9963,
    "street": "3rd Ln SW",
    "city": "Seattle",
    "zip": 98106,
    "concatenated_address": "9963 3rd Ln SW, Seattle",
    "address": "9963 3rd Lane S.W., Seattle"
  },
  {
    "id": 2440,
    "financing": "Federally subsidized",
    "building_name": "Greenbridge Hope VI - Nia, Salmon Creek and Seola Crossing Apartments",
    "latitude": 47.515343,
    "longitude": -122.34463,
    "original_address": "9800 - 8th Avenue Sw.",
    "building_number": 9800,
    "street": "8th Ave SW",
    "city": "Seattle",
    "zip": 98106,
    "concatenated_address": "9800 8th Ave SW, Seattle",
    "address": "9800 8th Ave. S.W., Seattle"
  },
  {
    "id": 2441,
    "financing": "Federally subsidized",
    "building_name": "Greenbrier Family Apartments",
    "latitude": 47.763523,
    "longitude": -122.14757,
    "original_address": "18746 144th Avenue Ne",
    "building_number": 18746,
    "street": "144th Ave NE",
    "city": "Woodinville",
    "zip": 98072,
    "concatenated_address": "18746 144th Ave NE, Woodinville",
    "address": "18746 144th Ave. N.E., Woodinville"
  },
  {
    "id": 2442,
    "financing": "Federally subsidized",
    "building_name": "Greenbrier Heights Senior",
    "latitude": 47.76476,
    "longitude": -122.14826,
    "original_address": "14390 Ne 189th Place",
    "building_number": 14390,
    "street": "NE 189th Pl",
    "city": "Woodinville",
    "zip": 98072,
    "concatenated_address": "14390 NE 189th Pl, Woodinville",
    "address": "14390 N.E. 189th Place, Woodinville"
  },
  {
    "id": 2443,
    "financing": "Federally subsidized",
    "building_name": "Greenbrier Heights Senior Apartments",
    "latitude": 47.76476,
    "longitude": -122.14826,
    "original_address": "14390 Ne 189th Place",
    "building_number": 14390,
    "street": "NE 189th Pl",
    "city": "Woodinville",
    "zip": 98072,
    "concatenated_address": "14390 NE 189th Pl, Woodinville",
    "address": "14390 N.E. 189th Place, Woodinville"
  },
  {
    "id": 2444,
    "financing": "Federally subsidized",
    "building_name": "Greens Of Merrill Creek",
    "latitude": 47.94508,
    "longitude": -122.2565,
    "original_address": "1707 Merrill Creek Parkway",
    "building_number": 1707,
    "street": "Merrill Creek Pkwy",
    "city": "Everett",
    "zip": "98203-7106",
    "concatenated_address": "1707 Merrill Creek Pkwy, Everett",
    "address": "1707 Merrill Creek Pkwy, Everett"
  },
  {
    "id": 2445,
    "financing": "Federally subsidized",
    "building_name": "Greentree Apartment Homes",
    "latitude": 47.490253,
    "longitude": -122.24707,
    "original_address": "6900 S 125th St",
    "building_number": 6900,
    "street": "S 125th St",
    "city": "Seattle",
    "zip": "98178-4330",
    "concatenated_address": "6900 S 125th St, Seattle",
    "address": "6900 S. 125th St., Seattle"
  },
  {
    "id": 2446,
    "financing": "Federally subsidized",
    "building_name": "Greenwood Apartments",
    "latitude": 48.186755,
    "longitude": -117.04495,
    "original_address": "427 West Willow",
    "building_number": 427,
    "street": "W Willow St",
    "city": "Newport",
    "zip": 99156,
    "concatenated_address": "427 W Willow St, Newport",
    "address": "427 W. Willow St., Newport"
  },
  {
    "id": 2447,
    "financing": "Federally subsidized",
    "building_name": "Griffin Glen",
    "latitude": 47.609861,
    "longitude": -122.63081,
    "original_address": "5163 Mariah Lane Ne",
    "building_number": 5163,
    "street": "Mariah Ln NE",
    "city": "Bremerton",
    "zip": 98311,
    "concatenated_address": "5163 Mariah Ln NE, Bremerton",
    "address": "5163 Mariah Lane N.E., Bremerton"
  },
  {
    "id": 2448,
    "financing": "Federally subsidized",
    "building_name": "Guadalupe Haven",
    "latitude": 46.852708,
    "longitude": -118.99318,
    "original_address": "705 E Gemstone",
    "building_number": "",
    "street": "",
    "city": "Othello",
    "zip": 99344,
    "concatenated_address": "705 E Gemstone, Othello",
    "address": "705 E. Gemstone, Othello"
  },
  {
    "id": 2449,
    "financing": "Federally subsidized",
    "building_name": "Guadalupe Vista",
    "latitude": 47.25032,
    "longitude": -122.44499,
    "original_address": "1305 South \"G\" St",
    "building_number": 1305,
    "street": "S G St",
    "city": "Tacoma",
    "zip": 98405,
    "concatenated_address": "1305 S G St, Tacoma",
    "address": "1305 S. G St., Tacoma"
  },
  {
    "id": 2450,
    "financing": "Federally subsidized",
    "building_name": "Guiry-Schillistad-Bond",
    "latitude": 47.611869,
    "longitude": -122.34429,
    "original_address": "2105 First Ave",
    "building_number": 2105,
    "street": "1st Ave",
    "city": "Seattle",
    "zip": 98121,
    "concatenated_address": "2105 1st Ave, Seattle",
    "address": "2105 1st Ave., Seattle"
  },
  {
    "id": 2451,
    "financing": "Federally subsidized",
    "building_name": "Haines Apartments",
    "latitude": 47.61624,
    "longitude": -122.3135,
    "original_address": "1415 East Olive Street",
    "building_number": 1415,
    "street": "E Olive St",
    "city": "Seattle",
    "zip": 98122,
    "concatenated_address": "1415 E Olive St, Seattle",
    "address": "1415 E. Olive St., Seattle"
  },
  {
    "id": 2452,
    "financing": "Federally subsidized",
    "building_name": "Haines Apartments",
    "latitude": 47.61624,
    "longitude": -122.3135,
    "original_address": "1415 E Olive St",
    "building_number": 1415,
    "street": "E Olive St",
    "city": "Seattle",
    "zip": 98122,
    "concatenated_address": "1415 E Olive St, Seattle",
    "address": "1415 E. Olive St., Seattle"
  },
  {
    "id": 2453,
    "financing": "Federally subsidized",
    "building_name": "Hamilton Park",
    "latitude": 45.635511,
    "longitude": -121.97975,
    "original_address": "30 Portage Dr",
    "building_number": 30,
    "street": "Portage Dr",
    "city": "North Bonneville",
    "zip": 98639,
    "concatenated_address": "30 Portage Dr, North Bonneville",
    "address": "30 Portage Drive, North Bonneville"
  },
  {
    "id": 2454,
    "financing": "Federally subsidized",
    "building_name": "Hampton Court Apartments",
    "latitude": 46.999034,
    "longitude": -120.55401,
    "original_address": "700 North Cle Elum Street",
    "building_number": 700,
    "street": "N Cle Elum St",
    "city": "Ellensburg",
    "zip": 98926,
    "concatenated_address": "700 N Cle Elum St, Ellensburg",
    "address": "700 N. Cle Elum St., Ellensburg"
  },
  {
    "id": 2455,
    "financing": "Federally subsidized",
    "building_name": "Hampton Heights Apartments",
    "latitude": 47.466513,
    "longitude": -122.26165,
    "original_address": "5711 S 152nd St",
    "building_number": 5711,
    "street": "S 152nd St",
    "city": "Seattle",
    "zip": "98188-5749",
    "concatenated_address": "5711 S 152nd St, Seattle",
    "address": "5711 S. 152nd St., Seattle"
  },
  {
    "id": 2456,
    "financing": "Federally subsidized",
    "building_name": "Hampton Heights Apartments",
    "latitude": 47.522423,
    "longitude": -122.267,
    "original_address": "9061 Seward Park Avenue South",
    "building_number": 9061,
    "street": "Seward Park Ave S",
    "city": "Seattle",
    "zip": 98118,
    "concatenated_address": "9061 Seward Park Ave S, Seattle",
    "address": "9061 Seward Park Ave. S., Seattle"
  },
  {
    "id": 2457,
    "financing": "Federally subsidized",
    "building_name": "Hana Apartments",
    "latitude": 47.601383,
    "longitude": -122.32654,
    "original_address": "101 6th Avenue South",
    "building_number": 101,
    "street": "6th Ave S",
    "city": "Seattle",
    "zip": 98104,
    "concatenated_address": "101 6th Ave S, Seattle",
    "address": "101 6th Ave. S., Seattle"
  },
  {
    "id": 2458,
    "financing": "Federally subsidized",
    "building_name": "Hancock Street",
    "latitude": 48.104464,
    "longitude": -122.79467,
    "original_address": "620 Hancock St.",
    "building_number": 620,
    "street": "Hancock St",
    "city": "Port Townsend",
    "zip": 98368,
    "concatenated_address": "620 Hancock St, Port Townsend",
    "address": "620 Hancock St., Port Townsend"
  },
  {
    "id": 2459,
    "financing": "Federally subsidized",
    "building_name": "Harbor Heights",
    "latitude": 48.307345,
    "longitude": -122.6577,
    "original_address": "31 Nw Crosby Ave",
    "building_number": 31,
    "street": "NW Crosby Ave",
    "city": "Oak Harbor",
    "zip": 98277,
    "concatenated_address": "31 NW Crosby Ave, Oak Harbor",
    "address": "31 N.W. Crosby Ave., Oak Harbor"
  },
  {
    "id": 2460,
    "financing": "Federally subsidized",
    "building_name": "Harbor Manor Apartments",
    "latitude": 46.974306,
    "longitude": -123.8835,
    "original_address": "411 10th Street",
    "building_number": 411,
    "street": "10th St",
    "city": "Hoquiam",
    "zip": 98550,
    "concatenated_address": "411 10th St, Hoquiam",
    "address": "411 10th St., Hoquiam"
  },
  {
    "id": 2461,
    "financing": "Federally subsidized",
    "building_name": "Harbor Ridge",
    "latitude": 48.305992,
    "longitude": -122.65681,
    "original_address": "950 N. Oak Harbor St.",
    "building_number": 950,
    "street": "N Oak Harbor St",
    "city": "Oak Harbor",
    "zip": 98277,
    "concatenated_address": "950 N Oak Harbor St, Oak Harbor",
    "address": "950 N. Oak Harbor St., Oak Harbor"
  },
  {
    "id": 2462,
    "financing": "Federally subsidized",
    "building_name": "Harbor View",
    "latitude": 48.540302,
    "longitude": -123.02292,
    "original_address": "500 Tucker Avenue",
    "building_number": 500,
    "street": "Tucker Ave",
    "city": "Friday Harbor",
    "zip": 98250,
    "concatenated_address": "500 Tucker Ave, Friday Harbor",
    "address": "500 Tucker Ave., Friday Harbor"
  },
  {
    "id": 2463,
    "financing": "Federally subsidized",
    "building_name": "Harbor View Manor",
    "latitude": 47.254812,
    "longitude": -122.44326,
    "original_address": "919 South Fawcett Ave",
    "building_number": 919,
    "street": "S Fawcett Ave",
    "city": "Tacoma",
    "zip": 98402,
    "concatenated_address": "919 S Fawcett Ave, Tacoma",
    "address": "919 S. Fawcett Ave., Tacoma"
  },
  {
    "id": 2464,
    "financing": "Federally subsidized",
    "building_name": "Harbor Villa",
    "latitude": 48.394089,
    "longitude": -122.49275,
    "original_address": "401 E State St",
    "building_number": 401,
    "street": "State St",
    "city": "La Conner",
    "zip": 98257,
    "concatenated_address": "401 State St, La Conner",
    "address": "401 State St., La Conner"
  },
  {
    "id": 2465,
    "financing": "Federally subsidized",
    "building_name": "Harbor Village",
    "latitude": 48.292355,
    "longitude": -122.65877,
    "original_address": "55 Sw 6th Ave",
    "building_number": 55,
    "street": "SW 6th Ave",
    "city": "Oak Harbor",
    "zip": 98277,
    "concatenated_address": "55 SW 6th Ave, Oak Harbor",
    "address": "55 S.W. 6th Ave., Oak Harbor"
  },
  {
    "id": 2466,
    "financing": "Federally subsidized",
    "building_name": "Harborview Apartments",
    "latitude": 48.757226,
    "longitude": -122.48678,
    "original_address": "1505 G Street",
    "building_number": 1505,
    "street": "G St",
    "city": "Bellingham",
    "zip": 98225,
    "concatenated_address": "1505 G St, Bellingham",
    "address": "1505 G St., Bellingham"
  },
  {
    "id": 2467,
    "financing": "Federally subsidized",
    "building_name": "Harborview Apartments",
    "latitude": 48.500133,
    "longitude": -122.61577,
    "original_address": "1110 27th Court",
    "building_number": 1110,
    "street": "27th Ct",
    "city": "Anacortes",
    "zip": 98221,
    "concatenated_address": "1110 27th Ct, Anacortes",
    "address": "1110 27th Ct, Anacortes"
  },
  {
    "id": 2468,
    "financing": "Federally subsidized",
    "building_name": "Harmony House Apartments",
    "latitude": 47.221157,
    "longitude": -123.11252,
    "original_address": "1100 North 13Th Street",
    "building_number": 1100,
    "street": "N 13th St",
    "city": "Shelton",
    "zip": 98584,
    "concatenated_address": "1100 N 13th St, Shelton",
    "address": "1100 N. 13th St., Shelton"
  },
  {
    "id": 2469,
    "financing": "Federally subsidized",
    "building_name": "Harmony Park",
    "latitude": 46.443657,
    "longitude": -120.42608,
    "original_address": "509 S Tieton Ave",
    "building_number": 509,
    "street": "S Tieton Ave",
    "city": "Wapato",
    "zip": 98951,
    "concatenated_address": "509 S Tieton Ave, Wapato",
    "address": "509 S. Tieton Ave., Wapato"
  },
  {
    "id": 2470,
    "financing": "Federally subsidized",
    "building_name": "Harrison At Fifteenth",
    "latitude": 47.621902,
    "longitude": -122.31218,
    "original_address": "1505 East Harrison",
    "building_number": 1505,
    "street": "E Harrison St",
    "city": "Seattle",
    "zip": 98112,
    "concatenated_address": "1505 E Harrison St, Seattle",
    "address": "1505 E. Harrison St., Seattle"
  },
  {
    "id": 2471,
    "financing": "Federally subsidized",
    "building_name": "Harrison House",
    "latitude": 47.621875,
    "longitude": -122.31254,
    "original_address": "346 15th Avenue E",
    "building_number": 346,
    "street": "15th Ave E",
    "city": "Seattle",
    "zip": 98112,
    "concatenated_address": "346 15th Ave E, Seattle",
    "address": "346 15th Ave. E., Seattle"
  },
  {
    "id": 2472,
    "financing": "Federally subsidized",
    "building_name": "Harrison House Apartments",
    "latitude": 47.382823,
    "longitude": -122.23924,
    "original_address": "615 West Harrison St",
    "building_number": 615,
    "street": "W Harrison St",
    "city": "Kent",
    "zip": 98032,
    "concatenated_address": "615 W Harrison St, Kent",
    "address": "615 W. Harrison St., Kent"
  },
  {
    "id": 2473,
    "financing": "Federally subsidized",
    "building_name": "Harrison Village",
    "latitude": 46.732134,
    "longitude": -122.98547,
    "original_address": "1402 Harrison Ave",
    "building_number": 1402,
    "street": "Harrison Ave",
    "city": "Centralia",
    "zip": 98531,
    "concatenated_address": "1402 Harrison Ave, Centralia",
    "address": "1402 Harrison Ave., Centralia"
  },
  {
    "id": 2474,
    "financing": "Federally subsidized",
    "building_name": "Hart Terrace",
    "latitude": 47.645495,
    "longitude": -117.36127,
    "original_address": "3308 E. 11th Ave",
    "building_number": 3308,
    "street": "E 11th Ave",
    "city": "Spokane",
    "zip": 99202,
    "concatenated_address": "3308 E 11th Ave, Spokane",
    "address": "3308 E. 11th Ave., Spokane"
  },
  {
    "id": 2475,
    "financing": "Federally subsidized",
    "building_name": "Harvest Manor Apartments",
    "latitude": 46.81575,
    "longitude": -119.16993,
    "original_address": "1045 Sylvan Drive",
    "building_number": 1045,
    "street": "Sylvan Dr",
    "city": "Othello",
    "zip": 99344,
    "concatenated_address": "1045 Sylvan Dr, Othello",
    "address": "1045 Sylvan Drive, Othello"
  },
  {
    "id": 2476,
    "financing": "Federally subsidized",
    "building_name": "Harvest Ridge",
    "latitude": 46.244481,
    "longitude": -119.90432,
    "original_address": "1181 Grandridge Road",
    "building_number": 1181,
    "street": "Grandridge Rd",
    "city": "Grandview",
    "zip": 98930,
    "concatenated_address": "1181 Grandridge Rd, Grandview",
    "address": "1181 Grandridge Road, Grandview"
  },
  {
    "id": 2477,
    "financing": "Federally subsidized",
    "building_name": "Harvest Ridge Apartments",
    "latitude": 46.244481,
    "longitude": -119.90432,
    "original_address": "1181 Grandridge Road",
    "building_number": 1181,
    "street": "Grandridge Rd",
    "city": "Grandview",
    "zip": 98930,
    "concatenated_address": "1181 Grandridge Rd, Grandview",
    "address": "1181 Grandridge Road, Grandview"
  },
  {
    "id": 2478,
    "financing": "Federally subsidized",
    "building_name": "Hawthorne Lane",
    "latitude": 47.07744,
    "longitude": -122.29236,
    "original_address": "10306 196th St. Ct. E.",
    "building_number": 10306,
    "street": "196th St Ct E",
    "city": "Graham",
    "zip": 98338,
    "concatenated_address": "10306 196th St Ct E, Graham",
    "address": "10306 196th St. Ct E., Graham"
  },
  {
    "id": 2479,
    "financing": "Federally subsidized",
    "building_name": "Hazel Plaza I Apartments",
    "latitude": 47.619948,
    "longitude": -122.30502,
    "original_address": "2021 East John",
    "building_number": 2021,
    "street": "E John St",
    "city": "Seattle",
    "zip": 98112,
    "concatenated_address": "2021 E John St, Seattle",
    "address": "2021 E. John St., Seattle"
  },
  {
    "id": 2480,
    "financing": "Federally subsidized",
    "building_name": "Hearthstone Apartments",
    "latitude": 47.569507,
    "longitude": -117.6696,
    "original_address": "1020 E. Campbell St",
    "building_number": 1020,
    "street": "E Campbell St",
    "city": "Medical Lake",
    "zip": 99022,
    "concatenated_address": "1020 E Campbell St, Medical Lake",
    "address": "1020 E. Campbell St., Medical Lake"
  },
  {
    "id": 2481,
    "financing": "Federally subsidized",
    "building_name": "Heather Commons",
    "latitude": 48.792749,
    "longitude": -122.47905,
    "original_address": "4169 Cory Street",
    "building_number": 4169,
    "street": "Cory St",
    "city": "Bellingham",
    "zip": "98226-6493",
    "concatenated_address": "4169 Cory St, Bellingham",
    "address": "4169 Cory St., Bellingham"
  },
  {
    "id": 2482,
    "financing": "Federally subsidized",
    "building_name": "Heather Commons I & II",
    "latitude": 48.792502,
    "longitude": -122.47966,
    "original_address": "4163 Deemer Rd",
    "building_number": 4163,
    "street": "Deemer Rd",
    "city": "Bellingham",
    "zip": 98226,
    "concatenated_address": "4163 Deemer Rd, Bellingham",
    "address": "4163 Deemer Road, Bellingham"
  },
  {
    "id": 2483,
    "financing": "Federally subsidized",
    "building_name": "Heatherstone",
    "latitude": 46.198665,
    "longitude": -119.13344,
    "original_address": "1114 W. 10th Ave.",
    "building_number": 1114,
    "street": "W 10th Ave",
    "city": "Kennewick",
    "zip": "99336-6084",
    "concatenated_address": "1114 W 10th Ave, Kennewick",
    "address": "1114 W. 10th Ave., Kennewick"
  },
  {
    "id": 2484,
    "financing": "Federally subsidized",
    "building_name": "Heatherwood",
    "latitude": 48.498997,
    "longitude": -122.61566,
    "original_address": "1110 29th St",
    "building_number": 1110,
    "street": "29th St",
    "city": "Anacortes",
    "zip": 98221,
    "concatenated_address": "1110 29th St, Anacortes",
    "address": "1110 29th St., Anacortes"
  },
  {
    "id": 2485,
    "financing": "Federally subsidized",
    "building_name": "Heatherwood Apartments",
    "latitude": 47.876256,
    "longitude": -122.22027,
    "original_address": "13510 North Creek Dr",
    "building_number": 13510,
    "street": "N Creek Dr",
    "city": "Bothell",
    "zip": "98012-2078",
    "concatenated_address": "13510 N Creek Dr, Bothell",
    "address": "13510 N. Creek Drive, Bothell"
  },
  {
    "id": 2486,
    "financing": "Federally subsidized",
    "building_name": "Heg House",
    "latitude": 47.612824,
    "longitude": -122.32278,
    "original_address": "711 East Union",
    "building_number": 711,
    "street": "E Union St",
    "city": "Seattle",
    "zip": 98122,
    "concatenated_address": "711 E Union St, Seattle",
    "address": "711 E. Union St., Seattle"
  },
  {
    "id": 2487,
    "financing": "Federally subsidized",
    "building_name": "Helen V Apartments",
    "latitude": 47.612396,
    "longitude": -122.31447,
    "original_address": "1319 E Union St",
    "building_number": 1319,
    "street": "E Union St",
    "city": "Seattle",
    "zip": 98122,
    "concatenated_address": "1319 E Union St, Seattle",
    "address": "1319 E. Union St., Seattle"
  },
  {
    "id": 2488,
    "financing": "Federally subsidized",
    "building_name": "Hemlock Court",
    "latitude": 46.136805,
    "longitude": -122.94055,
    "original_address": "1700 Hemlock St",
    "building_number": 1700,
    "street": "Hemlock St",
    "city": "Longview",
    "zip": 98632,
    "concatenated_address": "1700 Hemlock St, Longview",
    "address": "1700 Hemlock St., Longview"
  },
  {
    "id": 2489,
    "financing": "Federally subsidized",
    "building_name": "Henry House Apartments",
    "latitude": 47.764635,
    "longitude": -122.36334,
    "original_address": "351 Nw Richmond Beach Road",
    "building_number": 351,
    "street": "NW Richmond Beach Rd",
    "city": "Seattle",
    "zip": 98177,
    "concatenated_address": "351 NW Richmond Beach Rd, Seattle",
    "address": "351 N.W. Richmond Beach Road, Seattle"
  },
  {
    "id": 2490,
    "financing": "Federally subsidized",
    "building_name": "Heritage Apartments",
    "latitude": 47.518564,
    "longitude": -122.64884,
    "original_address": "145 Lippert Drive",
    "building_number": 145,
    "street": "Lippert Dr",
    "city": "Port Orchard",
    "zip": 98366,
    "concatenated_address": "145 Lippert Dr, Port Orchard",
    "address": "145 Lippert Drive, Port Orchard"
  },
  {
    "id": 2491,
    "financing": "Federally subsidized",
    "building_name": "Heritage Court",
    "latitude": 46.257532,
    "longitude": -119.89238,
    "original_address": "701 Washington Street",
    "building_number": 701,
    "street": "Washington St",
    "city": "Grandview",
    "zip": 98930,
    "concatenated_address": "701 Washington St, Grandview",
    "address": "701 Washington St., Grandview"
  },
  {
    "id": 2492,
    "financing": "Federally subsidized",
    "building_name": "Heritage Grove Apartments",
    "latitude": 47.500705,
    "longitude": -122.1887,
    "original_address": "1100 Sunset Blvd Ne",
    "building_number": 1100,
    "street": "Sunset Blvd NE",
    "city": "Renton",
    "zip": "98056-2971",
    "concatenated_address": "1100 Sunset Blvd NE, Renton",
    "address": "1100 Sunset Blvd N.E., Renton"
  },
  {
    "id": 2493,
    "financing": "Federally subsidized",
    "building_name": "Heritage Heights Apartments",
    "latitude": 47.692875,
    "longitude": -117.37252,
    "original_address": "3818 North Cook",
    "building_number": 3818,
    "street": "N Cook St",
    "city": "Spokane",
    "zip": 99207,
    "concatenated_address": "3818 N Cook St, Spokane",
    "address": "3818 N. Cook St., Spokane"
  },
  {
    "id": 2494,
    "financing": "Federally subsidized",
    "building_name": "Heritage Park",
    "latitude": 47.767607,
    "longitude": -122.20935,
    "original_address": "9838 Ne 190th Street",
    "building_number": 9838,
    "street": "NE 190th St",
    "city": "Bothell",
    "zip": "98011-6015",
    "concatenated_address": "9838 NE 190th St, Bothell",
    "address": "9838 N.E. 190th St., Bothell"
  },
  {
    "id": 2495,
    "financing": "Federally subsidized",
    "building_name": "Heritage Woods Apartments",
    "latitude": 47.683294,
    "longitude": -122.11939,
    "original_address": "16518 Ne 91st St",
    "building_number": 16518,
    "street": "NE 91st St",
    "city": "Redmond",
    "zip": "98052-3638",
    "concatenated_address": "16518 NE 91st St, Redmond",
    "address": "16518 N.E. 91st St., Redmond"
  },
  {
    "id": 2496,
    "financing": "Federally subsidized",
    "building_name": "Heron Creek Apartments",
    "latitude": 47.12415,
    "longitude": -119.272,
    "original_address": "222 East 9th Ave",
    "building_number": 222,
    "street": "E 9th Ave",
    "city": "Moses Lake",
    "zip": "98837-2190",
    "concatenated_address": "222 E 9th Ave, Moses Lake",
    "address": "222 E. 9th Ave., Moses Lake"
  },
  {
    "id": 2497,
    "financing": "Federally subsidized",
    "building_name": "Heron Landing",
    "latitude": 47.760223,
    "longitude": -122.24519,
    "original_address": "7025 Ne 182nd Street",
    "building_number": 7025,
    "street": "NE 182nd St",
    "city": "Kenmore",
    "zip": 98028,
    "concatenated_address": "7025 NE 182nd St, Kenmore",
    "address": "7025 N.E. 182nd St., Kenmore"
  },
  {
    "id": 2498,
    "financing": "Federally subsidized",
    "building_name": "Heron Run",
    "latitude": 47.760521,
    "longitude": -122.24664,
    "original_address": "7021 Ne 182nd Street",
    "building_number": 7021,
    "street": "NE 182nd St",
    "city": "Kenmore",
    "zip": 98028,
    "concatenated_address": "7021 NE 182nd St, Kenmore",
    "address": "7021 N.E. 182nd St., Kenmore"
  },
  {
    "id": 2499,
    "financing": "Federally subsidized",
    "building_name": "Hiawatha Artist Lofts",
    "latitude": 47.59519,
    "longitude": -122.30992,
    "original_address": "843 Hiawatha Place S.",
    "building_number": 843,
    "street": "Hiawatha Pl S",
    "city": "Seattle",
    "zip": 98144,
    "concatenated_address": "843 Hiawatha Pl S, Seattle",
    "address": "843 Hiawatha Pl S., Seattle"
  },
  {
    "id": 2500,
    "financing": "Federally subsidized",
    "building_name": "Hidden Creek Apartments",
    "latitude": 46.176416,
    "longitude": -123.01489,
    "original_address": "5607 Finch Dr",
    "building_number": 5607,
    "street": "Finch Dr",
    "city": "Longview",
    "zip": 98632,
    "concatenated_address": "5607 Finch Dr, Longview",
    "address": "5607 Finch Drive, Longview"
  },
  {
    "id": 2501,
    "financing": "Federally subsidized",
    "building_name": "Hidden Hills",
    "latitude": 47.23049,
    "longitude": -122.53373,
    "original_address": "3213 72nd Avenue Ct W",
    "building_number": 3213,
    "street": "72nd Avenue Ct W",
    "city": "Tacoma",
    "zip": 98466,
    "concatenated_address": "3213 72nd Avenue Ct W, Tacoma",
    "address": "3213 72nd Avenue Ct W., Tacoma"
  },
  {
    "id": 2502,
    "financing": "Federally subsidized",
    "building_name": "Hidden Hills",
    "latitude": 47.681089,
    "longitude": -117.33653,
    "original_address": "5008 E Buckeye Ave",
    "building_number": 5008,
    "street": "E Buckeye Ave",
    "city": "Spokane",
    "zip": 99217,
    "concatenated_address": "5008 E Buckeye Ave, Spokane",
    "address": "5008 E. Buckeye Ave., Spokane"
  },
  {
    "id": 2503,
    "financing": "Federally subsidized",
    "building_name": "Hidden Pines",
    "latitude": 47.65226,
    "longitude": -117.27237,
    "original_address": "9817 East 6th Avenue",
    "building_number": 9817,
    "street": "E 6th Ave",
    "city": "Spokane",
    "zip": "99206-3602",
    "concatenated_address": "9817 E 6th Ave, Spokane",
    "address": "9817 E. 6th Ave., Spokane"
  },
  {
    "id": 2504,
    "financing": "Federally subsidized",
    "building_name": "High Point Phase I",
    "latitude": 47.543805,
    "longitude": -122.37353,
    "original_address": "6550 32nd Avenue Sw",
    "building_number": 6550,
    "street": "32nd Ave SW",
    "city": "Seattle",
    "zip": 98126,
    "concatenated_address": "6550 32nd Ave SW, Seattle",
    "address": "6550 32nd Ave. S.W., Seattle"
  },
  {
    "id": 2505,
    "financing": "Federally subsidized",
    "building_name": "High Point Phase II",
    "latitude": 47.543028,
    "longitude": -122.37609,
    "original_address": "6558 35th Avenue Sw",
    "building_number": 6558,
    "street": "35th Ave SW",
    "city": "Seattle",
    "zip": "98116-3006",
    "concatenated_address": "6558 35th Ave SW, Seattle",
    "address": "6558 35th Ave. S.W., Seattle"
  },
  {
    "id": 2506,
    "financing": "Federally subsidized",
    "building_name": "Highland Commons I & II",
    "latitude": 48.099315,
    "longitude": -123.40627,
    "original_address": "1702 Melody Circle",
    "building_number": 1702,
    "street": "Melody Cir",
    "city": "Port Angeles",
    "zip": "98362-4974",
    "concatenated_address": "1702 Melody Cir, Port Angeles",
    "address": "1702 Melody Cir, Port Angeles"
  },
  {
    "id": 2507,
    "financing": "Federally subsidized",
    "building_name": "Highland Gardens",
    "latitude": 47.564499,
    "longitude": -122.00656,
    "original_address": "4575 Klahanie Drive Se",
    "building_number": 4575,
    "street": "Klahanie Dr SE",
    "city": "Issaquah",
    "zip": 98029,
    "concatenated_address": "4575 Klahanie Dr SE, Issaquah",
    "address": "4575 Klahanie Dr S.E., Issaquah"
  },
  {
    "id": 2508,
    "financing": "Federally subsidized",
    "building_name": "Highland Greens Senior Apartments",
    "latitude": 48.44744,
    "longitude": -122.298,
    "original_address": "3100 N 30th St",
    "building_number": 3100,
    "street": "N 30th St",
    "city": "Mount Vernon",
    "zip": 98273,
    "concatenated_address": "3100 N 30th St, Mount Vernon",
    "address": "3100 N. 30th St., Mount Vernon"
  },
  {
    "id": 2509,
    "financing": "Federally subsidized",
    "building_name": "Highlands East Apartments",
    "latitude": 47.764209,
    "longitude": -122.36576,
    "original_address": "700 Nw 185th St.",
    "building_number": 700,
    "street": "NW 185th St",
    "city": "Seattle",
    "zip": 98177,
    "concatenated_address": "700 NW 185th St, Seattle",
    "address": "700 N.W. 185th St., Seattle"
  },
  {
    "id": 2510,
    "financing": "Federally subsidized",
    "building_name": "Hillcrest Village",
    "latitude": 47.76302,
    "longitude": -118.71015,
    "original_address": "501 N.W. Armstrong",
    "building_number": 501,
    "street": "NW Armstrong Ave",
    "city": "Wilbur",
    "zip": 99185,
    "concatenated_address": "501 NW Armstrong Ave, Wilbur",
    "address": "501 N.W. Armstrong Ave., Wilbur"
  },
  {
    "id": 2511,
    "financing": "Federally subsidized",
    "building_name": "Hillside Garden Apartments",
    "latitude": 47.246157,
    "longitude": -122.44468,
    "original_address": "1708 South G Street",
    "building_number": 1708,
    "street": "S G St",
    "city": "Tacoma",
    "zip": 98405,
    "concatenated_address": "1708 S G St, Tacoma",
    "address": "1708 S. G St., Tacoma"
  },
  {
    "id": 2512,
    "financing": "Federally subsidized",
    "building_name": "Hillside Park",
    "latitude": 48.702413,
    "longitude": -119.43974,
    "original_address": "515 South Tonasket Ave.",
    "building_number": 515,
    "street": "S Tonasket Ave",
    "city": "Tonasket",
    "zip": 98855,
    "concatenated_address": "515 S Tonasket Ave, Tonasket",
    "address": "515 S. Tonasket Ave., Tonasket"
  },
  {
    "id": 2513,
    "financing": "Federally subsidized",
    "building_name": "Hillside Terrace",
    "latitude": 47.248238,
    "longitude": -122.44461,
    "original_address": "1507 South G St",
    "building_number": 1507,
    "street": "S G St",
    "city": "Tacoma",
    "zip": 98405,
    "concatenated_address": "1507 S G St, Tacoma",
    "address": "1507 S. G St., Tacoma"
  },
  {
    "id": 2514,
    "financing": "Federally subsidized",
    "building_name": "Hillside Terrace",
    "latitude": 47.248228,
    "longitude": -122.44444,
    "original_address": "1512 Court F",
    "building_number": 1512,
    "street": "Ct",
    "city": "Tacoma",
    "zip": 98402,
    "concatenated_address": "1512 Ct, Tacoma",
    "address": "1512 Ct, Tacoma"
  },
  {
    "id": 2515,
    "financing": "Federally subsidized",
    "building_name": "Hillside Terrace",
    "latitude": 47.239669,
    "longitude": -122.44323,
    "original_address": "2330 South G St",
    "building_number": 2330,
    "street": "S G St",
    "city": "Tacoma",
    "zip": 98405,
    "concatenated_address": "2330 S G St, Tacoma",
    "address": "2330 S. G St., Tacoma"
  },
  {
    "id": 2516,
    "financing": "Federally subsidized",
    "building_name": "Hilltop Apartments",
    "latitude": 47.401651,
    "longitude": -120.30219,
    "original_address": "1511 S. Mission St.",
    "building_number": 1511,
    "street": "S Mission St",
    "city": "Wenatchee",
    "zip": 98801,
    "concatenated_address": "1511 S Mission St, Wenatchee",
    "address": "1511 S. Mission St., Wenatchee"
  },
  {
    "id": 2517,
    "financing": "Federally subsidized",
    "building_name": "Hilltop House",
    "latitude": 47.604458,
    "longitude": -122.3217,
    "original_address": "1005 Terrace Street",
    "building_number": 1005,
    "street": "Terrace St",
    "city": "Seattle",
    "zip": 98104,
    "concatenated_address": "1005 Terrace St, Seattle",
    "address": "1005 Terrace St., Seattle"
  },
  {
    "id": 2518,
    "financing": "Federally subsidized",
    "building_name": "Hilltop House I & Ii",
    "latitude": 48.243791,
    "longitude": -122.34152,
    "original_address": "8001 272nd Street Nw",
    "building_number": 8001,
    "street": "272nd St NW",
    "city": "Stanwood",
    "zip": 98292,
    "concatenated_address": "8001 272nd St NW, Stanwood",
    "address": "8001 272nd St. N.W., Stanwood"
  },
  {
    "id": 2519,
    "financing": "Federally subsidized",
    "building_name": "Hilltop Ridge",
    "latitude": 48.1081,
    "longitude": -123.45572,
    "original_address": "1914 South Pine Street",
    "building_number": 1914,
    "street": "S Pine St",
    "city": "Port Angeles",
    "zip": "98362-2443",
    "concatenated_address": "1914 S Pine St, Port Angeles",
    "address": "1914 S. Pine St., Port Angeles"
  },
  {
    "id": 2520,
    "financing": "Federally subsidized",
    "building_name": "Hillyard Plaza",
    "latitude": 47.706504,
    "longitude": -117.3691,
    "original_address": "2808 E. Sanson Ave.",
    "building_number": 2808,
    "street": "E Sanson Ave",
    "city": "Spokane",
    "zip": 99217,
    "concatenated_address": "2808 E Sanson Ave, Spokane",
    "address": "2808 E. Sanson Ave., Spokane"
  },
  {
    "id": 2521,
    "financing": "Federally subsidized",
    "building_name": "Hirabayashi Place",
    "latitude": 47.600301,
    "longitude": -122.32855,
    "original_address": "442 South Main Street",
    "building_number": 442,
    "street": "S Main St",
    "city": "Seattle",
    "zip": 98104,
    "concatenated_address": "442 S Main St, Seattle",
    "address": "442 S. Main St., Seattle"
  },
  {
    "id": 2522,
    "financing": "Federally subsidized",
    "building_name": "Historic Cooper School",
    "latitude": 47.563794,
    "longitude": -122.36301,
    "original_address": "4408 Delridge Way Sw",
    "building_number": 4408,
    "street": "Delridge Way SW",
    "city": "Seattle",
    "zip": 98106,
    "concatenated_address": "4408 Delridge Way SW, Seattle",
    "address": "4408 Delridge Way S.W., Seattle"
  },
  {
    "id": 2523,
    "financing": "Federally subsidized",
    "building_name": "Hoa Mai Gardens",
    "latitude": 47.603709,
    "longitude": -122.31955,
    "original_address": "221 10th Avenue South",
    "building_number": 221,
    "street": "10th Ave",
    "city": "Seattle",
    "zip": 98122,
    "concatenated_address": "221 10th Ave, Seattle",
    "address": "221 10th Ave., Seattle"
  },
  {
    "id": 2524,
    "financing": "Federally subsidized",
    "building_name": "Holden Manor",
    "latitude": 47.533955,
    "longitude": -122.35139,
    "original_address": "1213 Sw Holden St",
    "building_number": 1213,
    "street": "SW Holden St",
    "city": "Seattle",
    "zip": 98106,
    "concatenated_address": "1213 SW Holden St, Seattle",
    "address": "1213 S.W. Holden St., Seattle"
  },
  {
    "id": 2525,
    "financing": "Federally subsidized",
    "building_name": "Holden Village I",
    "latitude": 47.534256,
    "longitude": -122.36287,
    "original_address": "7544 24th Avenue Sw",
    "building_number": 7544,
    "street": "24th Ave SW",
    "city": "Seattle",
    "zip": 98106,
    "concatenated_address": "7544 24th Ave SW, Seattle",
    "address": "7544 24th Ave. S.W., Seattle"
  },
  {
    "id": 2526,
    "financing": "Federally subsidized",
    "building_name": "Holden Village III",
    "latitude": 47.534431,
    "longitude": -122.36353,
    "original_address": "7535 24th Avenue Sw",
    "building_number": 7535,
    "street": "24th Ave SW",
    "city": "Seattle",
    "zip": 98106,
    "concatenated_address": "7535 24th Ave SW, Seattle",
    "address": "7535 24th Ave. S.W., Seattle"
  },
  {
    "id": 2527,
    "financing": "Federally subsidized",
    "building_name": "Holden Village III",
    "latitude": 47.535323,
    "longitude": -122.36353,
    "original_address": "7501 24th Avenue Sw",
    "building_number": 7501,
    "street": "24th Ave SW",
    "city": "Seattle",
    "zip": 98106,
    "concatenated_address": "7501 24th Ave SW, Seattle",
    "address": "7501 24th Ave. S.W., Seattle"
  },
  {
    "id": 2528,
    "financing": "Federally subsidized",
    "building_name": "Holden Vista Apartments",
    "latitude": 47.534461,
    "longitude": -122.35139,
    "original_address": "1212 Sw Holden Street",
    "building_number": 1212,
    "street": "SW Holden St",
    "city": "Seattle",
    "zip": 98106,
    "concatenated_address": "1212 SW Holden St, Seattle",
    "address": "1212 S.W. Holden St., Seattle"
  },
  {
    "id": 2529,
    "financing": "Federally subsidized",
    "building_name": "Holiday Apartments",
    "latitude": 47.619774,
    "longitude": -122.31918,
    "original_address": "1001 E John Street",
    "building_number": 1001,
    "street": "E John St",
    "city": "Seattle",
    "zip": 98102,
    "concatenated_address": "1001 E John St, Seattle",
    "address": "1001 E. John St., Seattle"
  },
  {
    "id": 2530,
    "financing": "Federally subsidized",
    "building_name": "Holly Park III",
    "latitude": 47.539797,
    "longitude": -122.29015,
    "original_address": "7001 32nd Avenue S",
    "building_number": 7001,
    "street": "32nd Ave S",
    "city": "Seattle",
    "zip": 98118,
    "concatenated_address": "7001 32nd Ave S, Seattle",
    "address": "7001 32nd Ave. S., Seattle"
  },
  {
    "id": 2531,
    "financing": "Federally subsidized",
    "building_name": "Holly Park Phase II",
    "latitude": 47.538662,
    "longitude": -122.28793,
    "original_address": "7083 Holly Park Drive South",
    "building_number": 7083,
    "street": "Holly Park Dr S",
    "city": "Seattle",
    "zip": 98118,
    "concatenated_address": "7083 Holly Park Dr S, Seattle",
    "address": "7083 Holly Park Dr S., Seattle"
  },
  {
    "id": 2532,
    "financing": "Federally subsidized",
    "building_name": "Homeworks Phase I",
    "latitude": 47.669656,
    "longitude": -122.38974,
    "original_address": "2445 Nw 57th St",
    "building_number": 2445,
    "street": "NW 57th St",
    "city": "Seattle",
    "zip": "98107-5330",
    "concatenated_address": "2445 NW 57th St, Seattle",
    "address": "2445 N.W. 57th St., Seattle"
  },
  {
    "id": 2533,
    "financing": "Federally subsidized",
    "building_name": "Honeysuckle Apartments",
    "latitude": 47.603528,
    "longitude": -122.30751,
    "original_address": "202 19th Avenue East",
    "building_number": 202,
    "street": "19th Ave",
    "city": "Seattle",
    "zip": 98122,
    "concatenated_address": "202 19th Ave, Seattle",
    "address": "202 19th Ave., Seattle"
  },
  {
    "id": 2534,
    "financing": "Federally subsidized",
    "building_name": "Hopesource Scattered Site Project",
    "latitude": 46.98727,
    "longitude": -120.54294,
    "original_address": "401 E Cherry Ln",
    "building_number": 401,
    "street": "E Cherry Ln",
    "city": "Ellensburg",
    "zip": 98926,
    "concatenated_address": "401 E Cherry Ln, Ellensburg",
    "address": "401 E. Cherry Lane, Ellensburg"
  },
  {
    "id": 2535,
    "financing": "Federally subsidized",
    "building_name": "Horning Project",
    "latitude": 47.538314,
    "longitude": -122.6266,
    "original_address": "1436 Dwight St",
    "building_number": 1436,
    "street": "Dwight St",
    "city": "Port Orchard",
    "zip": 98366,
    "concatenated_address": "1436 Dwight St, Port Orchard",
    "address": "1436 Dwight St., Port Orchard"
  },
  {
    "id": 2536,
    "financing": "Federally subsidized",
    "building_name": "Hostmark At Village Cove",
    "latitude": 47.733314,
    "longitude": -122.63966,
    "original_address": "703 Ne Hostmark Street",
    "building_number": 703,
    "street": "NE Hostmark St",
    "city": "Poulsbo",
    "zip": 98370,
    "concatenated_address": "703 NE Hostmark St, Poulsbo",
    "address": "703 N.E. Hostmark St., Poulsbo"
  },
  {
    "id": 2537,
    "financing": "Federally subsidized",
    "building_name": "Hotel Olympus Apartments",
    "latitude": 47.255904,
    "longitude": -122.43892,
    "original_address": "815 Pacific Avenue",
    "building_number": 815,
    "street": "Pacific Ave",
    "city": "Tacoma",
    "zip": 98402,
    "concatenated_address": "815 Pacific Ave, Tacoma",
    "address": "815 Pacific Ave., Tacoma"
  },
  {
    "id": 2538,
    "financing": "Federally subsidized",
    "building_name": "Housing Hope Village",
    "latitude": 47.945224,
    "longitude": -122.21672,
    "original_address": "5811 Fleming Street",
    "building_number": 5811,
    "street": "Fleming St",
    "city": "Everett",
    "zip": 98203,
    "concatenated_address": "5811 Fleming St, Everett",
    "address": "5811 Fleming St., Everett"
  },
  {
    "id": 2539,
    "financing": "Federally subsidized",
    "building_name": "Housing Hope Village Expansion",
    "latitude": 47.944502,
    "longitude": -122.2167,
    "original_address": "5902 Evergreen Way",
    "building_number": 5902,
    "street": "Evergreen Way",
    "city": "Everett",
    "zip": 98203,
    "concatenated_address": "5902 Evergreen Way, Everett",
    "address": "5902 Evergreen Way, Everett"
  },
  {
    "id": 2540,
    "financing": "Federally subsidized",
    "building_name": "Humphrey House",
    "latitude": 47.61595,
    "longitude": -122.35015,
    "original_address": "111 Cedar St.",
    "building_number": 111,
    "street": "Cedar St",
    "city": "Seattle",
    "zip": 98121,
    "concatenated_address": "111 Cedar St, Seattle",
    "address": "111 Cedar St., Seattle"
  },
  {
    "id": 2541,
    "financing": "Federally subsidized",
    "building_name": "Huntington Court Apartments",
    "latitude": 46.988209,
    "longitude": -120.54337,
    "original_address": "306 E. Manitoba Ave",
    "building_number": 306,
    "street": "E Manitoba Ave",
    "city": "Ellensburg",
    "zip": 98926,
    "concatenated_address": "306 E Manitoba Ave, Ellensburg",
    "address": "306 E. Manitoba Ave., Ellensburg"
  },
  {
    "id": 2542,
    "financing": "Federally subsidized",
    "building_name": "Hutchison House Apartments",
    "latitude": 47.529252,
    "longitude": -122.04128,
    "original_address": "105 Mountain Park Blvd Sw",
    "building_number": 105,
    "street": "Mountain Park Blvd SW",
    "city": "Issaquah",
    "zip": 98027,
    "concatenated_address": "105 Mountain Park Blvd SW, Issaquah",
    "address": "105 Mountain Park Blvd S.W., Issaquah"
  },
  {
    "id": 2543,
    "financing": "Federally subsidized",
    "building_name": "Imperial Apartments",
    "latitude": 47.613889,
    "longitude": -122.31304,
    "original_address": "1427 East Pike",
    "building_number": 1427,
    "street": "E Pike St",
    "city": "Seattle",
    "zip": 98122,
    "concatenated_address": "1427 E Pike St, Seattle",
    "address": "1427 E. Pike St., Seattle"
  },
  {
    "id": 2544,
    "financing": "Federally subsidized",
    "building_name": "Imperial House Apartments",
    "latitude": 47.600209,
    "longitude": -122.32672,
    "original_address": "520 South Main Street",
    "building_number": 520,
    "street": "S Main St",
    "city": "Seattle",
    "zip": 98104,
    "concatenated_address": "520 S Main St, Seattle",
    "address": "520 S. Main St., Seattle"
  },
  {
    "id": 2545,
    "financing": "Federally subsidized",
    "building_name": "Interbay Place",
    "latitude": 47.638925,
    "longitude": -122.37582,
    "original_address": "2208 15th Ave. W",
    "building_number": 2208,
    "street": "15th Ave W",
    "city": "Seattle",
    "zip": 98119,
    "concatenated_address": "2208 15th Ave W, Seattle",
    "address": "2208 15th Ave. W., Seattle"
  },
  {
    "id": 2546,
    "financing": "Federally subsidized",
    "building_name": "International House",
    "latitude": 47.597343,
    "longitude": -122.32527,
    "original_address": "607 Maynard Avenue S",
    "building_number": 607,
    "street": "Maynard Ave S",
    "city": "Seattle",
    "zip": 98104,
    "concatenated_address": "607 Maynard Ave S, Seattle",
    "address": "607 Maynard Ave. S., Seattle"
  },
  {
    "id": 2547,
    "financing": "Federally subsidized",
    "building_name": "International Place",
    "latitude": 47.217748,
    "longitude": -122.40645,
    "original_address": "1701 E 44th St",
    "building_number": 1701,
    "street": "E 44th St",
    "city": "Tacoma",
    "zip": 98404,
    "concatenated_address": "1701 E 44th St, Tacoma",
    "address": "1701 E. 44th St., Tacoma"
  },
  {
    "id": 2548,
    "financing": "Federally subsidized",
    "building_name": "Interurban Senior Living",
    "latitude": 47.730736,
    "longitude": -122.34723,
    "original_address": "14002 Linden Ave. N.",
    "building_number": 14002,
    "street": "Linden Ave N",
    "city": "Seattle",
    "zip": 98133,
    "concatenated_address": "14002 Linden Ave N, Seattle",
    "address": "14002 Linden Ave. N., Seattle"
  },
  {
    "id": 2549,
    "financing": "Federally subsidized",
    "building_name": "Isabella Court",
    "latitude": 45.644633,
    "longitude": -122.61033,
    "original_address": "3112 Ne 62nd Avenue",
    "building_number": 3112,
    "street": "NE 62nd Ave",
    "city": "Vancouver",
    "zip": 98661,
    "concatenated_address": "3112 NE 62nd Ave, Vancouver",
    "address": "3112 N.E. 62nd Ave., Vancouver"
  },
  {
    "id": 2550,
    "financing": "Federally subsidized",
    "building_name": "Island Meadows",
    "latitude": 48.537851,
    "longitude": -123.027,
    "original_address": "360 Carter Ave",
    "building_number": 360,
    "street": "Carter Ave",
    "city": "Friday Harbor",
    "zip": 98250,
    "concatenated_address": "360 Carter Ave, Friday Harbor",
    "address": "360 Carter Ave., Friday Harbor"
  },
  {
    "id": 2551,
    "financing": "Federally subsidized",
    "building_name": "Island Terrace",
    "latitude": 47.635611,
    "longitude": -122.51548,
    "original_address": "821 High School Road Ne",
    "building_number": 821,
    "street": "High School Rd NE",
    "city": "Bainbridge Island",
    "zip": 98110,
    "concatenated_address": "821 High School Rd NE, Bainbridge Island",
    "address": "821 High School Road N.E., Bainbridge Island"
  },
  {
    "id": 2552,
    "financing": "Federally subsidized",
    "building_name": "Island View",
    "latitude": 48.242722,
    "longitude": -122.34051,
    "original_address": "7930 272nd Street Nw",
    "building_number": 7930,
    "street": "272nd St NW",
    "city": "Stanwood",
    "zip": 98292,
    "concatenated_address": "7930 272nd St NW, Stanwood",
    "address": "7930 272nd St. N.W., Stanwood"
  },
  {
    "id": 2553,
    "financing": "Federally subsidized",
    "building_name": "Islewood",
    "latitude": 48.536087,
    "longitude": -123.02759,
    "original_address": "855 Guard Street",
    "building_number": 855,
    "street": "Guard St",
    "city": "Friday Harbor",
    "zip": 98250,
    "concatenated_address": "855 Guard St, Friday Harbor",
    "address": "855 Guard St., Friday Harbor"
  },
  {
    "id": 2554,
    "financing": "Federally subsidized",
    "building_name": "Islewood",
    "latitude": 48.536087,
    "longitude": -123.02759,
    "original_address": "855 Guard St",
    "building_number": 855,
    "street": "Guard St",
    "city": "Friday Harbor",
    "zip": 98250,
    "concatenated_address": "855 Guard St, Friday Harbor",
    "address": "855 Guard St., Friday Harbor"
  },
  {
    "id": 2555,
    "financing": "Federally subsidized",
    "building_name": "Issaquah Gardens",
    "latitude": 47.538937,
    "longitude": -122.04078,
    "original_address": "865 2nd Avenue Nw",
    "building_number": 865,
    "street": "2nd Ave NW",
    "city": "Issaquah",
    "zip": 98027,
    "concatenated_address": "865 2nd Ave NW, Issaquah",
    "address": "865 2nd Ave. N.W., Issaquah"
  },
  {
    "id": 2556,
    "financing": "Federally subsidized",
    "building_name": "Ives & Harrison Family Housing",
    "latitude": 46.740356,
    "longitude": -122.99548,
    "original_address": "3115 Ives Rd",
    "building_number": 3115,
    "street": "Ives Rd",
    "city": "Centralia",
    "zip": 98531,
    "concatenated_address": "3115 Ives Rd, Centralia",
    "address": "3115 Ives Road, Centralia"
  },
  {
    "id": 2557,
    "financing": "Federally subsidized",
    "building_name": "Jackson House At Pacific Crest",
    "latitude": 47.976441,
    "longitude": -122.20556,
    "original_address": "1818 Pacific Ave",
    "building_number": 1818,
    "street": "Pacific Ave",
    "city": "Everett",
    "zip": 98201,
    "concatenated_address": "1818 Pacific Ave, Everett",
    "address": "1818 Pacific Ave., Everett"
  },
  {
    "id": 2558,
    "financing": "Federally subsidized",
    "building_name": "Jardin De Rosas",
    "latitude": 46.903517,
    "longitude": -119.62801,
    "original_address": "400 Juniper Circle",
    "building_number": 400,
    "street": "Juniper Cir",
    "city": "Royal City",
    "zip": 99357,
    "concatenated_address": "400 Juniper Cir, Royal City",
    "address": "400 Juniper Cir, Royal City"
  },
  {
    "id": 2559,
    "financing": "Federally subsidized",
    "building_name": "Jefferson Apartments",
    "latitude": 47.606343,
    "longitude": -122.31639,
    "original_address": "1206 East Jefferson Street",
    "building_number": 1206,
    "street": "E Jefferson St",
    "city": "Seattle",
    "zip": 98122,
    "concatenated_address": "1206 E Jefferson St, Seattle",
    "address": "1206 E. Jefferson St., Seattle"
  },
  {
    "id": 2560,
    "financing": "Federally subsidized",
    "building_name": "Jensen Block",
    "latitude": 47.624395,
    "longitude": -122.32935,
    "original_address": "601 Eastlake Avenue E",
    "building_number": 601,
    "street": "Eastlake Ave E",
    "city": "Seattle",
    "zip": 98109,
    "concatenated_address": "601 Eastlake Ave E, Seattle",
    "address": "601 Eastlake Ave. E., Seattle"
  },
  {
    "id": 2561,
    "financing": "Federally subsidized",
    "building_name": "Joe Black Apartments",
    "latitude": 47.572849,
    "longitude": -122.29209,
    "original_address": "3333 Gale Place S.",
    "building_number": 3333,
    "street": "Gale Pl S",
    "city": "Seattle",
    "zip": 98144,
    "concatenated_address": "3333 Gale Pl S, Seattle",
    "address": "3333 Gale Pl S., Seattle"
  },
  {
    "id": 2562,
    "financing": "Federally subsidized",
    "building_name": "John Carney",
    "latitude": 47.616993,
    "longitude": -122.3531,
    "original_address": "2911 1st Avenue",
    "building_number": 2911,
    "street": "1st Ave",
    "city": "Seattle",
    "zip": 98121,
    "concatenated_address": "2911 1st Ave, Seattle",
    "address": "2911 1st Ave., Seattle"
  },
  {
    "id": 2563,
    "financing": "Federally subsidized",
    "building_name": "John Winthrop",
    "latitude": 47.610753,
    "longitude": -122.32689,
    "original_address": "1020 Seneca St",
    "building_number": 1020,
    "street": "Seneca St",
    "city": "Seattle",
    "zip": 98101,
    "concatenated_address": "1020 Seneca St, Seattle",
    "address": "1020 Seneca St., Seattle"
  },
  {
    "id": 2564,
    "financing": "Federally subsidized",
    "building_name": "Johnson Hill",
    "latitude": 47.528077,
    "longitude": -122.0411,
    "original_address": "280 Sw Clark St",
    "building_number": 280,
    "street": "SW Clark St",
    "city": "Issaquah",
    "zip": 98027,
    "concatenated_address": "280 SW Clark St, Issaquah",
    "address": "280 S.W. Clark St., Issaquah"
  },
  {
    "id": 2565,
    "financing": "Federally subsidized",
    "building_name": "Johnson Hill Apartments",
    "latitude": 47.528077,
    "longitude": -122.0411,
    "original_address": "280 Sw Clark St",
    "building_number": 280,
    "street": "SW Clark St",
    "city": "Issaquah",
    "zip": 98027,
    "concatenated_address": "280 SW Clark St, Issaquah",
    "address": "280 S.W. Clark St., Issaquah"
  },
  {
    "id": 2566,
    "financing": "Federally subsidized",
    "building_name": "Joseph Cove",
    "latitude": 48.013293,
    "longitude": -119.67892,
    "original_address": "700 Fairview Ave",
    "building_number": 700,
    "street": "Fairview Ave",
    "city": "Bridgeport",
    "zip": 98813,
    "concatenated_address": "700 Fairview Ave, Bridgeport",
    "address": "700 Fairview Ave., Bridgeport"
  },
  {
    "id": 2567,
    "financing": "Federally subsidized",
    "building_name": "Josephinum",
    "latitude": 47.611221,
    "longitude": -122.34052,
    "original_address": "1902 Second Ave",
    "building_number": 1902,
    "street": "2nd Ave",
    "city": "Seattle",
    "zip": 98101,
    "concatenated_address": "1902 2nd Ave, Seattle",
    "address": "1902 2nd Ave., Seattle"
  },
  {
    "id": 2568,
    "financing": "Federally subsidized",
    "building_name": "Juan Pablo Ii",
    "latitude": 46.244796,
    "longitude": -119.9028,
    "original_address": "129 Pleasant Ave",
    "building_number": 129,
    "street": "Pleasant Ave",
    "city": "Grandview",
    "zip": 98930,
    "concatenated_address": "129 Pleasant Ave, Grandview",
    "address": "129 Pleasant Ave., Grandview"
  },
  {
    "id": 2569,
    "financing": "Federally subsidized",
    "building_name": "Juanita View Apartments",
    "latitude": 47.705936,
    "longitude": -122.20638,
    "original_address": "11807 101st Place Ne # 54",
    "building_number": 11807,
    "street": "101st Pl NE",
    "city": "Kirkland",
    "zip": 98034,
    "concatenated_address": "11807 101st Pl NE, Kirkland",
    "address": "11807 101st Pl N.E., Kirkland"
  },
  {
    "id": 2570,
    "financing": "Federally subsidized",
    "building_name": "Judkins Park Apartments",
    "latitude": 47.592228,
    "longitude": -122.30295,
    "original_address": "1129 23rd Ave. South",
    "building_number": 1129,
    "street": "23rd Ave S",
    "city": "Seattle",
    "zip": 98144,
    "concatenated_address": "1129 23rd Ave S, Seattle",
    "address": "1129 23rd Ave. S., Seattle"
  },
  {
    "id": 2571,
    "financing": "Federally subsidized",
    "building_name": "Julie Apartments",
    "latitude": 47.616275,
    "longitude": -122.33513,
    "original_address": "1922 9th Avenue",
    "building_number": 1922,
    "street": "9th Ave",
    "city": "Seattle",
    "zip": 98101,
    "concatenated_address": "1922 9th Ave, Seattle",
    "address": "1922 9th Ave., Seattle"
  },
  {
    "id": 2572,
    "financing": "Federally subsidized",
    "building_name": "Juneau Townhomes",
    "latitude": 47.549536,
    "longitude": -122.28459,
    "original_address": "3801 S. Juneau",
    "building_number": 3801,
    "street": "S Juneau St",
    "city": "Seattle",
    "zip": 98122,
    "concatenated_address": "3801 S Juneau St, Seattle",
    "address": "3801 S. Juneau St., Seattle"
  },
  {
    "id": 2573,
    "financing": "Federally subsidized",
    "building_name": "Juniper Gardens Apartments",
    "latitude": 47.275757,
    "longitude": -122.51413,
    "original_address": "3018 N Highland St.",
    "building_number": 3018,
    "street": "N Highland St",
    "city": "Tacoma",
    "zip": 98407,
    "concatenated_address": "3018 N Highland St, Tacoma",
    "address": "3018 N. Highland St., Tacoma"
  },
  {
    "id": 2574,
    "financing": "Federally subsidized",
    "building_name": "Kamiakin Apartments",
    "latitude": 46.21948,
    "longitude": -119.1842,
    "original_address": "4711 W Metaline Ave",
    "building_number": 4711,
    "street": "W Metaline Ave",
    "city": "Kennewick",
    "zip": "99336-2175",
    "concatenated_address": "4711 W Metaline Ave, Kennewick",
    "address": "4711 W. Metaline Ave., Kennewick"
  },
  {
    "id": 2575,
    "financing": "Federally subsidized",
    "building_name": "Karen Lane",
    "latitude": 47.313628,
    "longitude": -119.54428,
    "original_address": "269 D Street Se",
    "building_number": 269,
    "street": "D St SE",
    "city": "Ephrata",
    "zip": 98823,
    "concatenated_address": "269 D St SE, Ephrata",
    "address": "269 D St. S.E., Ephrata"
  },
  {
    "id": 2576,
    "financing": "Federally subsidized",
    "building_name": "Karlstrom Apartments",
    "latitude": 47.600711,
    "longitude": -122.33527,
    "original_address": "65 South Washington",
    "building_number": 65,
    "street": "S Washington St",
    "city": "Seattle",
    "zip": 98109,
    "concatenated_address": "65 S Washington St, Seattle",
    "address": "65 S. Washington St., Seattle"
  },
  {
    "id": 2577,
    "financing": "Federally subsidized",
    "building_name": "Kateri Court",
    "latitude": 48.748426,
    "longitude": -122.48051,
    "original_address": "110 E Chestnut Street",
    "building_number": 110,
    "street": "E Chestnut St",
    "city": "Bellingham",
    "zip": 98225,
    "concatenated_address": "110 E Chestnut St, Bellingham",
    "address": "110 E. Chestnut St., Bellingham"
  },
  {
    "id": 2578,
    "financing": "Federally subsidized",
    "building_name": "Katharine's Place",
    "latitude": 47.55044,
    "longitude": -122.28815,
    "original_address": "3512 S Juneau St",
    "building_number": 3512,
    "street": "S Juneau St",
    "city": "Seattle",
    "zip": 98118,
    "concatenated_address": "3512 S Juneau St, Seattle",
    "address": "3512 S. Juneau St., Seattle"
  },
  {
    "id": 2579,
    "financing": "Federally subsidized",
    "building_name": "Kearney Street",
    "latitude": 48.113911,
    "longitude": -122.7729,
    "original_address": "809 Gaines Street",
    "building_number": 809,
    "street": "Gaines St",
    "city": "Port Townsend",
    "zip": 98368,
    "concatenated_address": "809 Gaines St, Port Townsend",
    "address": "809 Gaines St., Port Townsend"
  },
  {
    "id": 2580,
    "financing": "Federally subsidized",
    "building_name": "Kebero Court",
    "latitude": 47.602463,
    "longitude": -122.31771,
    "original_address": "1105 E Fir Street",
    "building_number": 1105,
    "street": "E Fir St",
    "city": "Seattle",
    "zip": 98122,
    "concatenated_address": "1105 E Fir St, Seattle",
    "address": "1105 E. Fir St., Seattle"
  },
  {
    "id": 2581,
    "financing": "Federally subsidized",
    "building_name": "Kennewick Garden Court Apartments",
    "latitude": 46.203237,
    "longitude": -119.13156,
    "original_address": "955 West 5th Avenue - Office",
    "building_number": 955,
    "street": "W 5th Ave",
    "city": "Kennewick",
    "zip": 99336,
    "concatenated_address": "955 W 5th Ave, Kennewick",
    "address": "955 W. 5th Ave., Kennewick"
  },
  {
    "id": 2582,
    "financing": "Federally subsidized",
    "building_name": "Kent Manor",
    "latitude": 46.203307,
    "longitude": -119.13216,
    "original_address": "1001 West 5th Ave",
    "building_number": 1001,
    "street": "W 5th Ave",
    "city": "Kennewick",
    "zip": "99336-7053",
    "concatenated_address": "1001 W 5th Ave, Kennewick",
    "address": "1001 W. 5th Ave., Kennewick"
  },
  {
    "id": 2583,
    "financing": "Federally subsidized",
    "building_name": "Kenwood Square Apartments",
    "latitude": 46.739222,
    "longitude": -117.17466,
    "original_address": "1225 Nw Nye Street",
    "building_number": 1225,
    "street": "NW Nye St",
    "city": "Pullman",
    "zip": 99163,
    "concatenated_address": "1225 NW Nye St, Pullman",
    "address": "1225 N.W. Nye St., Pullman"
  },
  {
    "id": 2584,
    "financing": "Federally subsidized",
    "building_name": "Kenyon House",
    "latitude": 47.155867,
    "longitude": -122.03022,
    "original_address": "530 S Division Street",
    "building_number": 530,
    "street": "S Division St",
    "city": "Buckley",
    "zip": 98321,
    "concatenated_address": "530 S Division St, Buckley",
    "address": "530 S. Division St., Buckley"
  },
  {
    "id": 2585,
    "financing": "Federally subsidized",
    "building_name": "Kenyon House",
    "latitude": 47.531729,
    "longitude": -122.28169,
    "original_address": "3936 S. Kenyon St",
    "building_number": 3936,
    "street": "S Kenyon St",
    "city": "Seattle",
    "zip": 98118,
    "concatenated_address": "3936 S Kenyon St, Seattle",
    "address": "3936 S. Kenyon St., Seattle"
  },
  {
    "id": 2586,
    "financing": "Federally subsidized",
    "building_name": "Kerner-Scott House",
    "latitude": 47.623534,
    "longitude": -122.33264,
    "original_address": "510 Minor Avenue N",
    "building_number": 510,
    "street": "Minor Ave N",
    "city": "Seattle",
    "zip": 98109,
    "concatenated_address": "510 Minor Ave N, Seattle",
    "address": "510 Minor Ave. N., Seattle"
  },
  {
    "id": 2587,
    "financing": "Federally subsidized",
    "building_name": "Killion Court",
    "latitude": 46.950424,
    "longitude": -122.61798,
    "original_address": "405 Killion Ct Nw",
    "building_number": 405,
    "street": "Killion Ct NW",
    "city": "Yelm",
    "zip": 98597,
    "concatenated_address": "405 Killion Ct NW, Yelm",
    "address": "405 Killion Ct N.W., Yelm"
  },
  {
    "id": 2588,
    "financing": "Federally subsidized",
    "building_name": "Kingston Ridge Apartments",
    "latitude": 47.804849,
    "longitude": -122.50771,
    "original_address": "26659 Ne Myrtle Ln",
    "building_number": 26659,
    "street": "Myrtle Ln",
    "city": "Kingston",
    "zip": 98346,
    "concatenated_address": "26659 Myrtle Ln, Kingston",
    "address": "26659 Myrtle Lane, Kingston"
  },
  {
    "id": 2589,
    "financing": "Federally subsidized",
    "building_name": "Kingway Apartments",
    "latitude": 47.548303,
    "longitude": -122.28544,
    "original_address": "5900 37th Ave. South",
    "building_number": 5900,
    "street": "37th Ave S",
    "city": "Seattle",
    "zip": 98118,
    "concatenated_address": "5900 37th Ave S, Seattle",
    "address": "5900 37th Ave. S., Seattle"
  },
  {
    "id": 2590,
    "financing": "Federally subsidized",
    "building_name": "Kirkland Heights",
    "latitude": 47.719977,
    "longitude": -122.16249,
    "original_address": "13310 Ne 133rd St",
    "building_number": 13310,
    "street": "NE 133rd St",
    "city": "Kirkland",
    "zip": 98034,
    "concatenated_address": "13310 NE 133rd St, Kirkland",
    "address": "13310 N.E. 133rd St., Kirkland"
  },
  {
    "id": 2591,
    "financing": "Federally subsidized",
    "building_name": "Kirkland Plaza",
    "latitude": 47.680045,
    "longitude": -122.20312,
    "original_address": "320 6th Avenue",
    "building_number": 320,
    "street": "6th Ave",
    "city": "Kirkland",
    "zip": 98033,
    "concatenated_address": "320 6th Ave, Kirkland",
    "address": "320 6th Ave., Kirkland"
  },
  {
    "id": 2592,
    "financing": "Federally subsidized",
    "building_name": "Kirkland Union Plaza",
    "latitude": 45.632402,
    "longitude": -122.68166,
    "original_address": "1414 Kauffman Avenue",
    "building_number": 1414,
    "street": "Kauffman Ave",
    "city": "Vancouver",
    "zip": 98660,
    "concatenated_address": "1414 Kauffman Ave, Vancouver",
    "address": "1414 Kauffman Ave., Vancouver"
  },
  {
    "id": 2593,
    "financing": "Federally subsidized",
    "building_name": "Kitts Corner",
    "latitude": 47.300393,
    "longitude": -122.31993,
    "original_address": "1201 S. 336th Street",
    "building_number": 1201,
    "street": "S 336th St",
    "city": "Federal Way",
    "zip": 98003,
    "concatenated_address": "1201 S 336th St, Federal Way",
    "address": "1201 S. 336th St., Federal Way"
  },
  {
    "id": 2594,
    "financing": "Federally subsidized",
    "building_name": "Kneeland Park",
    "latitude": 47.207875,
    "longitude": -123.10297,
    "original_address": "215 Turner Ave. Bldg A",
    "building_number": 215,
    "street": "Turner Ave",
    "city": "Shelton",
    "zip": 98584,
    "concatenated_address": "215 Turner Ave, Shelton",
    "address": "215 Turner Ave., Shelton"
  },
  {
    "id": 2595,
    "financing": "Federally subsidized",
    "building_name": "Knoblock Apartments",
    "latitude": 46.316975,
    "longitude": -117.9705,
    "original_address": "700 S 5th Street",
    "building_number": "",
    "street": "S 5th St",
    "city": "Dayton",
    "zip": 99328,
    "concatenated_address": "700 S 5th Street, Dayton",
    "address": "700 S. 5th St., Dayton"
  },
  {
    "id": 2596,
    "financing": "Federally subsidized",
    "building_name": "Kulshan Residences Apartments",
    "latitude": 48.433307,
    "longitude": -122.31212,
    "original_address": "2323 Kulshan View Drive",
    "building_number": 2323,
    "street": "Kulshan View Dr",
    "city": "Mount Vernon",
    "zip": 98273,
    "concatenated_address": "2323 Kulshan View Dr, Mount Vernon",
    "address": "2323 Kulshan View Drive, Mount Vernon"
  },
  {
    "id": 2597,
    "financing": "Federally subsidized",
    "building_name": "L & S Cedar Center/Chewelah Meadows",
    "latitude": 48.27286,
    "longitude": -117.71166,
    "original_address": "402 S Fifth Street E",
    "building_number": 402,
    "street": "E 5th St S",
    "city": "Chewelah",
    "zip": 99109,
    "concatenated_address": "402 E 5th St S, Chewelah",
    "address": "402 E. 5th St. S., Chewelah"
  },
  {
    "id": 2598,
    "financing": "Federally subsidized",
    "building_name": "L & S Fir Meadows",
    "latitude": 47.956776,
    "longitude": -117.48147,
    "original_address": "223 W Third St",
    "building_number": 223,
    "street": "W 3rd St",
    "city": "Deer Park",
    "zip": 99006,
    "concatenated_address": "223 W 3rd St, Deer Park",
    "address": "223 W. 3rd St., Deer Park"
  },
  {
    "id": 2599,
    "financing": "Federally subsidized",
    "building_name": "L & S Greenwood Village",
    "latitude": 48.186755,
    "longitude": -117.04495,
    "original_address": "427 W Willow St",
    "building_number": 427,
    "street": "W Willow St",
    "city": "Newport",
    "zip": 99156,
    "concatenated_address": "427 W Willow St, Newport",
    "address": "427 W. Willow St., Newport"
  },
  {
    "id": 2600,
    "financing": "Federally subsidized",
    "building_name": "L & S The Falls",
    "latitude": 48.605841,
    "longitude": -118.0485,
    "original_address": "550 E Eighth Ave",
    "building_number": 550,
    "street": "E 8th Ave",
    "city": "Kettle Falls",
    "zip": 99141,
    "concatenated_address": "550 E 8th Ave, Kettle Falls",
    "address": "550 E. 8th Ave., Kettle Falls"
  },
  {
    "id": 2601,
    "financing": "Federally subsidized",
    "building_name": "L & S The Highlands",
    "latitude": 48.539788,
    "longitude": -117.88846,
    "original_address": "542 S Summit St",
    "building_number": 542,
    "street": "S Summit St",
    "city": "Colville",
    "zip": 99114,
    "concatenated_address": "542 S Summit St, Colville",
    "address": "542 S. Summit St., Colville"
  },
  {
    "id": 2602,
    "financing": "Federally subsidized",
    "building_name": "L & S Valley Green",
    "latitude": 46.968743,
    "longitude": -119.03889,
    "original_address": "102 N Ash Ave",
    "building_number": 102,
    "street": "S Ash Ave",
    "city": "Warden",
    "zip": 98857,
    "concatenated_address": "102 S Ash Ave, Warden",
    "address": "102 S. Ash Ave., Warden"
  },
  {
    "id": 2603,
    "financing": "Federally subsidized",
    "building_name": "L & S Willow Glen",
    "latitude": 48.175832,
    "longitude": -117.06409,
    "original_address": "1600 W Seventh St",
    "building_number": 1600,
    "street": "W 7th St",
    "city": "Newport",
    "zip": 99156,
    "concatenated_address": "1600 W 7th St, Newport",
    "address": "1600 W. 7th St., Newport"
  },
  {
    "id": 2604,
    "financing": "Federally subsidized",
    "building_name": "La Amistad",
    "latitude": 46.961131,
    "longitude": -119.04524,
    "original_address": "912 South County Road",
    "building_number": 912,
    "street": "County Rd S",
    "city": "Warden",
    "zip": 98857,
    "concatenated_address": "912 County Rd S, Warden",
    "address": "912 County Road S., Warden"
  },
  {
    "id": 2605,
    "financing": "Federally subsidized",
    "building_name": "La Casa De La Familia Santa",
    "latitude": 46.736904,
    "longitude": -122.95489,
    "original_address": "1809 N Pearl Street",
    "building_number": 1809,
    "street": "N Pearl St",
    "city": "Centralia",
    "zip": "98531-5519",
    "concatenated_address": "1809 N Pearl St, Centralia",
    "address": "1809 N. Pearl St., Centralia"
  },
  {
    "id": 2606,
    "financing": "Federally subsidized",
    "building_name": "La Casa De San Jose",
    "latitude": 48.436358,
    "longitude": -122.32592,
    "original_address": "2419 Continental Pl",
    "building_number": 2419,
    "street": "Continental Pl",
    "city": "Mount Vernon",
    "zip": 98273,
    "concatenated_address": "2419 Continental Pl, Mount Vernon",
    "address": "2419 Continental Place, Mount Vernon"
  },
  {
    "id": 2607,
    "financing": "Federally subsidized",
    "building_name": "La Casa De San Juan Diego",
    "latitude": 45.896254,
    "longitude": -122.75276,
    "original_address": "125 S Pekin Road",
    "building_number": 125,
    "street": "S Pekin Rd",
    "city": "Woodland",
    "zip": 98674,
    "concatenated_address": "125 S Pekin Rd, Woodland",
    "address": "125 S. Pekin Road, Woodland"
  },
  {
    "id": 2608,
    "financing": "Federally subsidized",
    "building_name": "La Casa De Santa Rosa",
    "latitude": 48.50628,
    "longitude": -122.22566,
    "original_address": "565 South Township Street",
    "building_number": 565,
    "street": "Township St",
    "city": "Sedro-Woolley",
    "zip": 98273,
    "concatenated_address": "565 Township St, Sedro-Woolley",
    "address": "565 Township St., Sedro-Woolley"
  },
  {
    "id": 2609,
    "financing": "Federally subsidized",
    "building_name": "La Casa Del Padre Miguel",
    "latitude": 48.4242,
    "longitude": -122.31322,
    "original_address": "418 North Laventure Road",
    "building_number": 418,
    "street": "N Laventure Rd",
    "city": "Mount Vernon",
    "zip": "98273-3592",
    "concatenated_address": "418 N Laventure Rd, Mount Vernon",
    "address": "418 N. Laventure Road, Mount Vernon"
  },
  {
    "id": 2610,
    "financing": "Federally subsidized",
    "building_name": "La Madera Apartment Homes",
    "latitude": 47.345137,
    "longitude": -122.31095,
    "original_address": "28620 Pacific Highway South",
    "building_number": 28620,
    "street": "Pacific Hwy S",
    "city": "Federal Way",
    "zip": 98003,
    "concatenated_address": "28620 Pacific Hwy S, Federal Way",
    "address": "28620 Pacific Highway S., Federal Way"
  },
  {
    "id": 2611,
    "financing": "Federally subsidized",
    "building_name": "La Venture Workforce Housing",
    "latitude": 48.438044,
    "longitude": -122.31351,
    "original_address": "1917 North Laventure Rd",
    "building_number": 1917,
    "street": "N Laventure Rd",
    "city": "Mount Vernon",
    "zip": 98273,
    "concatenated_address": "1917 N Laventure Rd, Mount Vernon",
    "address": "1917 N. Laventure Road, Mount Vernon"
  },
  {
    "id": 2612,
    "financing": "Federally subsidized",
    "building_name": "Lacrosse Apartments",
    "latitude": 46.814159,
    "longitude": -117.87959,
    "original_address": "205 S Crystal",
    "building_number": 205,
    "street": "Crystal Ave",
    "city": "La Crosse",
    "zip": 99143,
    "concatenated_address": "205 Crystal Ave, La Crosse",
    "address": "205 Crystal Ave., La Crosse"
  },
  {
    "id": 2613,
    "financing": "Federally subsidized",
    "building_name": "Lake City Village Hope Redevelopment Phase Vi",
    "latitude": 47.720299,
    "longitude": -122.29182,
    "original_address": "12536 33rd Avenue Ne",
    "building_number": 12536,
    "street": "33rd Ave NE",
    "city": "Seattle",
    "zip": 98125,
    "concatenated_address": "12536 33rd Ave NE, Seattle",
    "address": "12536 33rd Ave. N.E., Seattle"
  },
  {
    "id": 2614,
    "financing": "Federally subsidized",
    "building_name": "Lake Stevens Manor",
    "latitude": 48.012462,
    "longitude": -122.05887,
    "original_address": "12703 16th Street Ne",
    "building_number": 12703,
    "street": "16th St NE",
    "city": "Lake Stevens",
    "zip": 98258,
    "concatenated_address": "12703 16th St NE, Lake Stevens",
    "address": "12703 16th St. N.E., Lake Stevens"
  },
  {
    "id": 2615,
    "financing": "Federally subsidized",
    "building_name": "Lake Village East",
    "latitude": 48.000557,
    "longitude": -122.10103,
    "original_address": "420 97th Dr. Ne",
    "building_number": 420,
    "street": "97th Dr NE",
    "city": "Lake Stevens",
    "zip": 98258,
    "concatenated_address": "420 97th Dr NE, Lake Stevens",
    "address": "420 97th Dr N.E., Lake Stevens"
  },
  {
    "id": 2616,
    "financing": "Federally subsidized",
    "building_name": "Lake Washington Apartments",
    "latitude": 47.522423,
    "longitude": -122.267,
    "original_address": "9061 Seward Park Avenue S",
    "building_number": 9061,
    "street": "Seward Park Ave S",
    "city": "Seattle",
    "zip": 98118,
    "concatenated_address": "9061 Seward Park Ave S, Seattle",
    "address": "9061 Seward Park Ave. S., Seattle"
  },
  {
    "id": 2617,
    "financing": "Federally subsidized",
    "building_name": "Lake Woods Senior Apartments Phase Ii",
    "latitude": 47.885329,
    "longitude": -122.25693,
    "original_address": "12404 19th Pl W",
    "building_number": 12404,
    "street": "19th Pl W",
    "city": "Everett",
    "zip": 98204,
    "concatenated_address": "12404 19th Pl W, Everett",
    "address": "12404 19th Pl W., Everett"
  },
  {
    "id": 2618,
    "financing": "Federally subsidized",
    "building_name": "Lakeland Pointe I & II",
    "latitude": 47.141883,
    "longitude": -119.28536,
    "original_address": "825 North Evelyn Drive",
    "building_number": 825,
    "street": "N Evelyn Dr",
    "city": "Moses Lake",
    "zip": "98837-1558",
    "concatenated_address": "825 N Evelyn Dr, Moses Lake",
    "address": "825 N. Evelyn Drive, Moses Lake"
  },
  {
    "id": 2619,
    "financing": "Federally subsidized",
    "building_name": "Lakeview Apartments",
    "latitude": 47.622218,
    "longitude": -122.33337,
    "original_address": "1170 Harrison",
    "building_number": 1170,
    "street": "Harrison St",
    "city": "Seattle",
    "zip": "98109-5439",
    "concatenated_address": "1170 Harrison St, Seattle",
    "address": "1170 Harrison St., Seattle"
  },
  {
    "id": 2620,
    "financing": "Federally subsidized",
    "building_name": "Lakeview Manor Apartments",
    "latitude": 47.127607,
    "longitude": -119.2787,
    "original_address": "423 Beech Street",
    "building_number": 423,
    "street": "S Beech St",
    "city": "Moses Lake",
    "zip": 98837,
    "concatenated_address": "423 S Beech St, Moses Lake",
    "address": "423 S. Beech St., Moses Lake"
  },
  {
    "id": 2621,
    "financing": "Federally subsidized",
    "building_name": "Lakewood Apartments",
    "latitude": 47.503077,
    "longitude": -122.35396,
    "original_address": "1500 Sw 112th Street",
    "building_number": 1500,
    "street": "SW 112th St",
    "city": "Seattle",
    "zip": 98146,
    "concatenated_address": "1500 SW 112th St, Seattle",
    "address": "1500 S.W. 112th St., Seattle"
  },
  {
    "id": 2622,
    "financing": "Federally subsidized",
    "building_name": "Lakewood Meadows Apartments",
    "latitude": 47.15545,
    "longitude": -122.50692,
    "original_address": "5228 - 112th Street Sw",
    "building_number": 5228,
    "street": "112th St SW",
    "city": "Lakewood",
    "zip": "98499-3072",
    "concatenated_address": "5228 112th St SW, Lakewood",
    "address": "5228 112th St. S.W., Lakewood"
  },
  {
    "id": 2623,
    "financing": "Federally subsidized",
    "building_name": "Larc @ Burien",
    "latitude": 47.498228,
    "longitude": -122.30821,
    "original_address": "11672 Des Moines Memorial Drive",
    "building_number": 11672,
    "street": "Des Moines Memorial Dr",
    "city": "Seattle",
    "zip": 98168,
    "concatenated_address": "11672 Des Moines Memorial Dr, Seattle",
    "address": "11672 Des Moines Memorial Drive, Seattle"
  },
  {
    "id": 2624,
    "financing": "Federally subsidized",
    "building_name": "Larc @ Kent",
    "latitude": 47.384583,
    "longitude": -122.23365,
    "original_address": "1st Avenue N",
    "building_number": "",
    "street": "1st Ave N",
    "city": "Kent",
    "zip": 98032,
    "concatenated_address": "1st Avenue N, Kent",
    "address": "1st Avenue N., Kent"
  },
  {
    "id": 2625,
    "financing": "Federally subsidized",
    "building_name": "Lariat Gardens",
    "latitude": 46.070123,
    "longitude": -118.33854,
    "original_address": "204 N. Spokane St",
    "building_number": 204,
    "street": "N Spokane St",
    "city": "Walla Walla",
    "zip": 99362,
    "concatenated_address": "204 N Spokane St, Walla Walla",
    "address": "204 N. Spokane St., Walla Walla"
  },
  {
    "id": 2626,
    "financing": "Federally subsidized",
    "building_name": "Larned Aparments",
    "latitude": 47.615819,
    "longitude": -122.3384,
    "original_address": "2030 Seventh Ave",
    "building_number": 2030,
    "street": "7th Ave",
    "city": "Seattle",
    "zip": 98121,
    "concatenated_address": "2030 7th Ave, Seattle",
    "address": "2030 7th Ave., Seattle"
  },
  {
    "id": 2627,
    "financing": "Federally subsidized",
    "building_name": "Lasalle Hotel",
    "latitude": 47.608208,
    "longitude": -122.34066,
    "original_address": "1426 Western Avenue",
    "building_number": 1426,
    "street": "Western Ave",
    "city": "Seattle",
    "zip": 98101,
    "concatenated_address": "1426 Western Ave, Seattle",
    "address": "1426 Western Ave., Seattle"
  },
  {
    "id": 2628,
    "financing": "Federally subsidized",
    "building_name": "Lasalle Senior Apartments",
    "latitude": 47.608329,
    "longitude": -122.34081,
    "original_address": "85 Pike Street",
    "building_number": 85,
    "street": "Pike St",
    "city": "Seattle",
    "zip": 98101,
    "concatenated_address": "85 Pike St, Seattle",
    "address": "85 Pike St., Seattle"
  },
  {
    "id": 2629,
    "financing": "Federally subsidized",
    "building_name": "Laube Hotel",
    "latitude": 48.747728,
    "longitude": -122.47777,
    "original_address": "1226 N State St",
    "building_number": 1226,
    "street": "N State St",
    "city": "Bellingham",
    "zip": 98225,
    "concatenated_address": "1226 N State St, Bellingham",
    "address": "1226 N. State St., Bellingham"
  },
  {
    "id": 2630,
    "financing": "Federally subsidized",
    "building_name": "Laurel Heights",
    "latitude": 48.114553,
    "longitude": -122.79625,
    "original_address": "1640 20th Street",
    "building_number": 1640,
    "street": "20th St",
    "city": "Port Townsend",
    "zip": 98368,
    "concatenated_address": "1640 20th St, Port Townsend",
    "address": "1640 20th St., Port Townsend"
  },
  {
    "id": 2631,
    "financing": "Federally subsidized",
    "building_name": "Laurel Village Apartments",
    "latitude": 48.745669,
    "longitude": -122.48257,
    "original_address": "206 E Laurel St",
    "building_number": 206,
    "street": "E Laurel St",
    "city": "Bellingham",
    "zip": 98225,
    "concatenated_address": "206 E Laurel St, Bellingham",
    "address": "206 E. Laurel St., Bellingham"
  },
  {
    "id": 2632,
    "financing": "Federally subsidized",
    "building_name": "Laurelwood Gardens",
    "latitude": 47.33721,
    "longitude": -122.30765,
    "original_address": "29505 21st Avenue South",
    "building_number": 29505,
    "street": "21st Ave S",
    "city": "Federal Way",
    "zip": 98003,
    "concatenated_address": "29505 21st Ave S, Federal Way",
    "address": "29505 21st Ave. S., Federal Way"
  },
  {
    "id": 2633,
    "financing": "Federally subsidized",
    "building_name": "Laurelwood Gardens (Gig Harbor)",
    "latitude": 47.320166,
    "longitude": -122.5851,
    "original_address": "3444 Erickson St",
    "building_number": 3444,
    "street": "Erickson St",
    "city": "Gig Harbor",
    "zip": 98335,
    "concatenated_address": "3444 Erickson St, Gig Harbor",
    "address": "3444 Erickson St., Gig Harbor"
  },
  {
    "id": 2634,
    "financing": "Federally subsidized",
    "building_name": "Lauren Heights Apartments",
    "latitude": 47.543971,
    "longitude": -121.99807,
    "original_address": "1660 24th Pl Ne",
    "building_number": 1660,
    "street": "24th Pl NE",
    "city": "Issaquah",
    "zip": 98029,
    "concatenated_address": "1660 24th Pl NE, Issaquah",
    "address": "1660 24th Pl N.E., Issaquah"
  },
  {
    "id": 2635,
    "financing": "Federally subsidized",
    "building_name": "Lauriston",
    "latitude": 47.260784,
    "longitude": -122.44596,
    "original_address": "235 Tacoma Avenue S",
    "building_number": 235,
    "street": "Tacoma Ave S",
    "city": "Tacoma",
    "zip": 98402,
    "concatenated_address": "235 Tacoma Ave S, Tacoma",
    "address": "235 Tacoma Ave. S., Tacoma"
  },
  {
    "id": 2636,
    "financing": "Federally subsidized",
    "building_name": "Lavender Hollow Apartments",
    "latitude": 48.698897,
    "longitude": -122.90933,
    "original_address": "38 Orion Ln",
    "building_number": 38,
    "street": "Orion Ln",
    "city": "Eastsound",
    "zip": 98245,
    "concatenated_address": "38 Orion Ln, Eastsound",
    "address": "38 Orion Lane, Eastsound"
  },
  {
    "id": 2637,
    "financing": "Federally subsidized",
    "building_name": "Laventure Village",
    "latitude": 48.42424,
    "longitude": -122.31322,
    "original_address": "422 N. Laventure Rd.",
    "building_number": 422,
    "street": "N Laventure Rd",
    "city": "Mount Vernon",
    "zip": 98273,
    "concatenated_address": "422 N Laventure Rd, Mount Vernon",
    "address": "422 N. Laventure Road, Mount Vernon"
  },
  {
    "id": 2638,
    "financing": "Federally subsidized",
    "building_name": "Lee Plaza",
    "latitude": 48.119018,
    "longitude": -123.43439,
    "original_address": "112 West First Street",
    "building_number": 112,
    "street": "W 1st St",
    "city": "Port Angeles",
    "zip": "98362-2603",
    "concatenated_address": "112 W 1st St, Port Angeles",
    "address": "112 W. 1st St., Port Angeles"
  },
  {
    "id": 2639,
    "financing": "Federally subsidized",
    "building_name": "Legacy Park Apartments",
    "latitude": 47.173422,
    "longitude": -122.48208,
    "original_address": "3502 92nd Street South",
    "building_number": 3502,
    "street": "92nd St S",
    "city": "Lakewood",
    "zip": "98499-9279",
    "concatenated_address": "3502 92nd St S, Lakewood",
    "address": "3502 92nd St. S., Lakewood"
  },
  {
    "id": 2640,
    "financing": "Federally subsidized",
    "building_name": "Lemon Projects",
    "latitude": 46.607183,
    "longitude": -120.51324,
    "original_address": "113 Cherry Ave",
    "building_number": 113,
    "street": "Cherry Ave",
    "city": "Yakima",
    "zip": 98902,
    "concatenated_address": "113 Cherry Ave, Yakima",
    "address": "113 Cherry Ave., Yakima"
  },
  {
    "id": 2641,
    "financing": "Federally subsidized",
    "building_name": "Lenora & Douglas",
    "latitude": 48.723614,
    "longitude": -122.48938,
    "original_address": "2150 Douglas Ave",
    "building_number": 2150,
    "street": "Douglas Ave",
    "city": "Bellingham",
    "zip": 98225,
    "concatenated_address": "2150 Douglas Ave, Bellingham",
    "address": "2150 Douglas Ave., Bellingham"
  },
  {
    "id": 2642,
    "financing": "Federally subsidized",
    "building_name": "Leschi House Redevelopment",
    "latitude": 47.597185,
    "longitude": -122.31894,
    "original_address": "1011 South Weller Street",
    "building_number": 1011,
    "street": "S Weller St",
    "city": "Seattle",
    "zip": 98104,
    "concatenated_address": "1011 S Weller St, Seattle",
    "address": "1011 S. Weller St., Seattle"
  },
  {
    "id": 2643,
    "financing": "Federally subsidized",
    "building_name": "Lewis & Clark Plaza",
    "latitude": 45.626188,
    "longitude": -122.67023,
    "original_address": "621 Broadway St",
    "building_number": 621,
    "street": "Broadway St",
    "city": "Vancouver",
    "zip": 98660,
    "concatenated_address": "621 Broadway St, Vancouver",
    "address": "621 Broadway St., Vancouver"
  },
  {
    "id": 2644,
    "financing": "Federally subsidized",
    "building_name": "Lewis Project",
    "latitude": 47.406754,
    "longitude": -122.21995,
    "original_address": "7802 88th Ave Sw",
    "building_number": "",
    "street": "88th Ave S",
    "city": "Kent",
    "zip": 98031,
    "concatenated_address": "7802 88th Ave Sw, Kent",
    "address": "7802 88th Ave. S.W., Kent"
  },
  {
    "id": 2645,
    "financing": "Federally subsidized",
    "building_name": "Lewiston Hotel",
    "latitude": 47.612536,
    "longitude": -122.34553,
    "original_address": "2201 First Avenue",
    "building_number": 2201,
    "street": "1st Ave",
    "city": "Seattle",
    "zip": 98121,
    "concatenated_address": "2201 1st Ave, Seattle",
    "address": "2201 1st Ave., Seattle"
  },
  {
    "id": 2646,
    "financing": "Federally subsidized",
    "building_name": "Lexy Manor",
    "latitude": 48.3043,
    "longitude": -122.6533,
    "original_address": "300 Ne 7th Ave",
    "building_number": 300,
    "street": "NE 7th Ave",
    "city": "Oak Harbor",
    "zip": 98277,
    "concatenated_address": "300 NE 7th Ave, Oak Harbor",
    "address": "300 N.E. 7th Ave., Oak Harbor"
  },
  {
    "id": 2647,
    "financing": "Federally subsidized",
    "building_name": "Liberty Bay Apartments",
    "latitude": 47.60118,
    "longitude": -122.62068,
    "original_address": "4010 Petersville Road",
    "building_number": 4010,
    "street": "Petersville Rd",
    "city": "Bremerton",
    "zip": 98310,
    "concatenated_address": "4010 Petersville Rd, Bremerton",
    "address": "4010 Petersville Road, Bremerton"
  },
  {
    "id": 2648,
    "financing": "Federally subsidized",
    "building_name": "Liberty Square Apartments",
    "latitude": 47.477406,
    "longitude": -122.207,
    "original_address": "415 Williams Avenue S",
    "building_number": 415,
    "street": "Williams Ave S",
    "city": "Renton",
    "zip": "98055-2748",
    "concatenated_address": "415 Williams Ave S, Renton",
    "address": "415 Williams Ave. S., Renton"
  },
  {
    "id": 2649,
    "financing": "Federally subsidized",
    "building_name": "Lilac Lodge Apartments",
    "latitude": 47.556088,
    "longitude": -122.28651,
    "original_address": "5033 37th Avenue South",
    "building_number": 5033,
    "street": "37th Ave S",
    "city": "Seattle",
    "zip": 98144,
    "concatenated_address": "5033 37th Ave S, Seattle",
    "address": "5033 37th Ave. S., Seattle"
  },
  {
    "id": 2650,
    "financing": "Federally subsidized",
    "building_name": "Lilac Place Apartments",
    "latitude": 45.909568,
    "longitude": -122.75076,
    "original_address": "1313 Glenwood Street",
    "building_number": 1309,
    "street": "Glenwood St",
    "city": "Woodland",
    "zip": 98674,
    "concatenated_address": "1309 Glenwood St, Woodland",
    "address": "1309 Glenwood St., Woodland"
  },
  {
    "id": 2651,
    "financing": "Federally subsidized",
    "building_name": "Lilac Plaza",
    "latitude": 47.721085,
    "longitude": -117.4042,
    "original_address": "7007 N. Wiscomb St.",
    "building_number": 7007,
    "street": "N Wiscomb St",
    "city": "Spokane",
    "zip": 99206,
    "concatenated_address": "7007 N Wiscomb St, Spokane",
    "address": "7007 N. Wiscomb St., Spokane"
  },
  {
    "id": 2652,
    "financing": "Federally subsidized",
    "building_name": "Lilac Terrace",
    "latitude": 47.721726,
    "longitude": -117.40422,
    "original_address": "7015 N Wiscomb St",
    "building_number": 7015,
    "street": "N Wiscomb St",
    "city": "Spokane",
    "zip": "99208-5429",
    "concatenated_address": "7015 N Wiscomb St, Spokane",
    "address": "7015 N. Wiscomb St., Spokane"
  },
  {
    "id": 2653,
    "financing": "Federally subsidized",
    "building_name": "Lincoln Commons Apartments",
    "latitude": 46.989255,
    "longitude": -123.88573,
    "original_address": "1001 Lincoln St",
    "building_number": 1001,
    "street": "Lincoln St",
    "city": "Hoquiam",
    "zip": 98550,
    "concatenated_address": "1001 Lincoln St, Hoquiam",
    "address": "1001 Lincoln St., Hoquiam"
  },
  {
    "id": 2654,
    "financing": "Federally subsidized",
    "building_name": "Lincoln Court",
    "latitude": 47.618948,
    "longitude": -122.31852,
    "original_address": "1020 E. Denny Way",
    "building_number": 1020,
    "street": "E Denny Way",
    "city": "Seattle",
    "zip": 98122,
    "concatenated_address": "1020 E Denny Way, Seattle",
    "address": "1020 E. Denny Way, Seattle"
  },
  {
    "id": 2655,
    "financing": "Federally subsidized",
    "building_name": "Lincoln Park Group Home",
    "latitude": 47.541358,
    "longitude": -122.3905,
    "original_address": "6935 Fauntleroy Way Sw",
    "building_number": 6935,
    "street": "Fauntleroy Way SW",
    "city": "Seattle",
    "zip": 98136,
    "concatenated_address": "6935 Fauntleroy Way SW, Seattle",
    "address": "6935 Fauntleroy Way S.W., Seattle"
  },
  {
    "id": 2656,
    "financing": "Federally subsidized",
    "building_name": "Lincoln Place",
    "latitude": 45.631693,
    "longitude": -122.68311,
    "original_address": "1351 Lincoln Avenue",
    "building_number": 1351,
    "street": "Lincoln Ave",
    "city": "Vancouver",
    "zip": 98660,
    "concatenated_address": "1351 Lincoln Ave, Vancouver",
    "address": "1351 Lincoln Ave., Vancouver"
  },
  {
    "id": 2657,
    "financing": "Federally subsidized",
    "building_name": "Lincoln School Senior Apartments",
    "latitude": 48.245689,
    "longitude": -122.33355,
    "original_address": "7336 276th Street Nw",
    "building_number": 7336,
    "street": "276th St NW",
    "city": "Stanwood",
    "zip": 98292,
    "concatenated_address": "7336 276th St NW, Stanwood",
    "address": "7336 276th St. N.W., Stanwood"
  },
  {
    "id": 2658,
    "financing": "Federally subsidized",
    "building_name": "Lincoln Way Apartments I & II",
    "latitude": 47.873587,
    "longitude": -122.27083,
    "original_address": "2721 Lincoln Way",
    "building_number": 2721,
    "street": "Lincoln Way",
    "city": "Lynnwood",
    "zip": 98087,
    "concatenated_address": "2721 Lincoln Way, Lynnwood",
    "address": "2721 Lincoln Way, Lynnwood"
  },
  {
    "id": 2659,
    "financing": "Federally subsidized",
    "building_name": "Liv Apartments",
    "latitude": 47.629516,
    "longitude": -122.13446,
    "original_address": "2170 Ne Bel-Red Road",
    "building_number": 2168,
    "street": "Bel Red Rd",
    "city": "Bellevue",
    "zip": 98007,
    "concatenated_address": "2168 Bel Red Rd, Bellevue",
    "address": "2168 Bel Red Road, Bellevue"
  },
  {
    "id": 2660,
    "financing": "Federally subsidized",
    "building_name": "Livingston Baker Apartments",
    "latitude": 47.610644,
    "longitude": -122.3425,
    "original_address": "1925 1st Avenue",
    "building_number": 1925,
    "street": "1st Ave",
    "city": "Seattle",
    "zip": 98101,
    "concatenated_address": "1925 1st Ave, Seattle",
    "address": "1925 1st Ave., Seattle"
  },
  {
    "id": 2661,
    "financing": "Federally subsidized",
    "building_name": "Logan Park",
    "latitude": 48.519781,
    "longitude": -122.22906,
    "original_address": "701 Sapp Road",
    "building_number": 701,
    "street": "Sapp Rd",
    "city": "Sedro-Woolley",
    "zip": 98284,
    "concatenated_address": "701 Sapp Rd, Sedro-Woolley",
    "address": "701 Sapp Road, Sedro-Woolley"
  },
  {
    "id": 2662,
    "financing": "Federally subsidized",
    "building_name": "Longfellow/Westwood Court Cooperative",
    "latitude": 47.519039,
    "longitude": -122.36753,
    "original_address": "9401 27th Avenue Sw",
    "building_number": 9401,
    "street": "27th Ave SW",
    "city": "Seattle",
    "zip": 98126,
    "concatenated_address": "9401 27th Ave SW, Seattle",
    "address": "9401 27th Ave. S.W., Seattle"
  },
  {
    "id": 2663,
    "financing": "Federally subsidized",
    "building_name": "Lower Elwha Homes I",
    "latitude": 48.055733,
    "longitude": -123.91784,
    "original_address": "60 Lilu Lane",
    "building_number": "",
    "street": "",
    "city": "Port Angeles",
    "zip": 98363,
    "concatenated_address": "60 Lilu Lane, Port Angeles",
    "address": "60 Lilu Lane, Port Angeles"
  },
  {
    "id": 2664,
    "financing": "Federally subsidized",
    "building_name": "Lower Elwha Homes II",
    "latitude": 48.055733,
    "longitude": -123.91784,
    "original_address": "20 Lilu Lane",
    "building_number": "",
    "street": "",
    "city": "Port Angeles",
    "zip": 98363,
    "concatenated_address": "20 Lilu Lane, Port Angeles",
    "address": "20 Lilu Lane, Port Angeles"
  },
  {
    "id": 2665,
    "financing": "Federally subsidized",
    "building_name": "Lowman Building",
    "latitude": 47.602568,
    "longitude": -122.33366,
    "original_address": "107 Cherry Street",
    "building_number": 107,
    "street": "Cherry St",
    "city": "Seattle",
    "zip": 98104,
    "concatenated_address": "107 Cherry St, Seattle",
    "address": "107 Cherry St., Seattle"
  },
  {
    "id": 2666,
    "financing": "Federally subsidized",
    "building_name": "Lowman Building",
    "latitude": 47.602568,
    "longitude": -122.33366,
    "original_address": "107 Cherry Street",
    "building_number": 107,
    "street": "Cherry St",
    "city": "Seattle",
    "zip": "98104-2223",
    "concatenated_address": "107 Cherry St, Seattle",
    "address": "107 Cherry St., Seattle"
  },
  {
    "id": 2667,
    "financing": "Federally subsidized",
    "building_name": "Loyal Heights Manor",
    "latitude": 47.684517,
    "longitude": -122.38792,
    "original_address": "7547 24th Avenue Nw",
    "building_number": 7547,
    "street": "24th Ave NW",
    "city": "Seattle",
    "zip": 98117,
    "concatenated_address": "7547 24th Ave NW, Seattle",
    "address": "7547 24th Ave. N.W., Seattle"
  },
  {
    "id": 2668,
    "financing": "Federally subsidized",
    "building_name": "Lummi Homes I",
    "latitude": 48.794045,
    "longitude": -122.63585,
    "original_address": "2828 Kwina Road",
    "building_number": 2828,
    "street": "Kwina Rd",
    "city": "Bellingham",
    "zip": 98226,
    "concatenated_address": "2828 Kwina Rd, Bellingham",
    "address": "2828 Kwina Road, Bellingham"
  },
  {
    "id": 2669,
    "financing": "Federally subsidized",
    "building_name": "Lund Pointe",
    "latitude": 47.519664,
    "longitude": -122.62633,
    "original_address": "3301 Valentine Lane Se",
    "building_number": 3301,
    "street": "Valentine Ln SE",
    "city": "Port Orchard",
    "zip": 98366,
    "concatenated_address": "3301 Valentine Ln SE, Port Orchard",
    "address": "3301 Valentine Lane S.E., Port Orchard"
  },
  {
    "id": 2670,
    "financing": "Federally subsidized",
    "building_name": "Lynnwood City Center Senior Living",
    "latitude": 47.821945,
    "longitude": -122.28655,
    "original_address": "19501 40th Avenue West",
    "building_number": 19501,
    "street": "40th Ave W",
    "city": "Lynnwood",
    "zip": 98036,
    "concatenated_address": "19501 40th Ave W, Lynnwood",
    "address": "19501 40th Ave. W., Lynnwood"
  },
  {
    "id": 2671,
    "financing": "Federally subsidized",
    "building_name": "Lyon Building",
    "latitude": 47.602907,
    "longitude": -122.33188,
    "original_address": "607 Third Avenue",
    "building_number": 607,
    "street": "3rd Ave",
    "city": "Seattle",
    "zip": 98104,
    "concatenated_address": "607 3rd Ave, Seattle",
    "address": "607 3rd Ave., Seattle"
  },
  {
    "id": 2672,
    "financing": "Federally subsidized",
    "building_name": "Mabel Swan Manor",
    "latitude": 46.598617,
    "longitude": -120.52031,
    "original_address": "10 South 8th Avenue",
    "building_number": 10,
    "street": "S 8th Ave",
    "city": "Yakima",
    "zip": 98902,
    "concatenated_address": "10 S 8th Ave, Yakima",
    "address": "10 S. 8th Ave., Yakima"
  },
  {
    "id": 2673,
    "financing": "Federally subsidized",
    "building_name": "Mabel Swan North",
    "latitude": 46.598891,
    "longitude": -120.52015,
    "original_address": "8 South 8th Avenue",
    "building_number": 8,
    "street": "S 8th Ave",
    "city": "Yakima",
    "zip": 98902,
    "concatenated_address": "8 S 8th Ave, Yakima",
    "address": "8 S. 8th Ave., Yakima"
  },
  {
    "id": 2674,
    "financing": "Federally subsidized",
    "building_name": "Mabton Garden Apartments",
    "latitude": 46.213789,
    "longitude": -119.99428,
    "original_address": "510 C Street",
    "building_number": 510,
    "street": "C St",
    "city": "Mabton",
    "zip": 98935,
    "concatenated_address": "510 C St, Mabton",
    "address": "510 C St., Mabton"
  },
  {
    "id": 2675,
    "financing": "Federally subsidized",
    "building_name": "Madison Apartments",
    "latitude": 47.608222,
    "longitude": -122.32747,
    "original_address": "823 Madison St",
    "building_number": 823,
    "street": "Madison St",
    "city": "Seattle",
    "zip": "98104-1251",
    "concatenated_address": "823 Madison St, Seattle",
    "address": "823 Madison St., Seattle"
  },
  {
    "id": 2676,
    "financing": "Federally subsidized",
    "building_name": "Madison Place",
    "latitude": 47.619629,
    "longitude": -122.3023,
    "original_address": "120 23rd Avenue E",
    "building_number": 120,
    "street": "23rd Ave E",
    "city": "Seattle",
    "zip": 98112,
    "concatenated_address": "120 23rd Ave E, Seattle",
    "address": "120 23rd Ave. E., Seattle"
  },
  {
    "id": 2677,
    "financing": "Federally subsidized",
    "building_name": "Madison Way Apartments",
    "latitude": 47.864603,
    "longitude": -122.25214,
    "original_address": "14709 Madison Way",
    "building_number": 14709,
    "street": "Madison Way",
    "city": "Lynnwood",
    "zip": 98092,
    "concatenated_address": "14709 Madison Way, Lynnwood",
    "address": "14709 Madison Way, Lynnwood"
  },
  {
    "id": 2678,
    "financing": "Federally subsidized",
    "building_name": "Madrona Manor",
    "latitude": 47.53106,
    "longitude": -122.59513,
    "original_address": "3900 Madrona Drive Nw",
    "building_number": 3900,
    "street": "Madrona Dr",
    "city": "Port Orchard",
    "zip": 98366,
    "concatenated_address": "3900 Madrona Dr, Port Orchard",
    "address": "3900 Madrona Drive, Port Orchard"
  },
  {
    "id": 2679,
    "financing": "Federally subsidized",
    "building_name": "Madrona Manor",
    "latitude": 48.28537,
    "longitude": -122.66904,
    "original_address": "890 Sw Kimball Dr",
    "building_number": 890,
    "street": "SW Kimball Dr",
    "city": "Oak Harbor",
    "zip": 98277,
    "concatenated_address": "890 SW Kimball Dr, Oak Harbor",
    "address": "890 S.W. Kimball Drive, Oak Harbor"
  },
  {
    "id": 2680,
    "financing": "Federally subsidized",
    "building_name": "Madrona Valley Apartments",
    "latitude": 48.21517,
    "longitude": -122.68626,
    "original_address": "204 N Main St",
    "building_number": 204,
    "street": "N Main St",
    "city": "Coupeville",
    "zip": 98239,
    "concatenated_address": "204 N Main St, Coupeville",
    "address": "204 N. Main St., Coupeville"
  },
  {
    "id": 2681,
    "financing": "Federally subsidized",
    "building_name": "Magnolia Square Apartments",
    "latitude": 45.777683,
    "longitude": -122.55688,
    "original_address": "407 Sw 20th Ave",
    "building_number": 407,
    "street": "SW 20th Ave",
    "city": "Battle Ground",
    "zip": 98604,
    "concatenated_address": "407 SW 20th Ave, Battle Ground",
    "address": "407 S.W. 20th Ave., Battle Ground"
  },
  {
    "id": 2682,
    "financing": "Federally subsidized",
    "building_name": "Magnolia Villa",
    "latitude": 47.032931,
    "longitude": -122.83593,
    "original_address": "1410 Magnolia Street Southeast",
    "building_number": 1410,
    "street": "Magnolia St SE",
    "city": "Lacey",
    "zip": 98503,
    "concatenated_address": "1410 Magnolia St SE, Lacey",
    "address": "1410 Magnolia St. S.E., Lacey"
  },
  {
    "id": 2683,
    "financing": "Federally subsidized",
    "building_name": "Manor Vale",
    "latitude": 47.659394,
    "longitude": -117.26899,
    "original_address": "10101 E Main Ave",
    "building_number": 10101,
    "street": "E Main Ave",
    "city": "Spokane",
    "zip": 99206,
    "concatenated_address": "10101 E Main Ave, Spokane",
    "address": "10101 E. Main Ave., Spokane"
  },
  {
    "id": 2684,
    "financing": "Federally subsidized",
    "building_name": "Mansard Estates",
    "latitude": 47.290337,
    "longitude": -122.20901,
    "original_address": "1501 21st St. Se",
    "building_number": 1501,
    "street": "21st St SE",
    "city": "Auburn",
    "zip": 98002,
    "concatenated_address": "1501 21st St SE, Auburn",
    "address": "1501 21st St. S.E., Auburn"
  },
  {
    "id": 2685,
    "financing": "Federally subsidized",
    "building_name": "Maple Crossing Apartments",
    "latitude": 47.391159,
    "longitude": -122.05127,
    "original_address": "21800 Se Wax Rd",
    "building_number": 21800,
    "street": "SE Wax Rd",
    "city": "Maple Valley",
    "zip": 98038,
    "concatenated_address": "21800 SE Wax Rd, Maple Valley",
    "address": "21800 S.E. Wax Road, Maple Valley"
  },
  {
    "id": 2686,
    "financing": "Federally subsidized",
    "building_name": "Maple Knoll",
    "latitude": 45.696827,
    "longitude": -122.65313,
    "original_address": "1800 Ne 104th Street",
    "building_number": 1800,
    "street": "NE 104th St",
    "city": "Vancouver",
    "zip": 98686,
    "concatenated_address": "1800 NE 104th St, Vancouver",
    "address": "1800 N.E. 104th St., Vancouver"
  },
  {
    "id": 2687,
    "financing": "Federally subsidized",
    "building_name": "Maple Lane Estates/ Maple Lane Court",
    "latitude": 47.364529,
    "longitude": -122.22634,
    "original_address": "1622 Maple Lane",
    "building_number": 1622,
    "street": "Maple Ln",
    "city": "Kent",
    "zip": 98030,
    "concatenated_address": "1622 Maple Ln, Kent",
    "address": "1622 Maple Lane, Kent"
  },
  {
    "id": 2688,
    "financing": "Federally subsidized",
    "building_name": "Maple Leaf Townhouses",
    "latitude": 46.617881,
    "longitude": -120.50996,
    "original_address": "1205 North Second Street",
    "building_number": 1205,
    "street": "N 2nd St",
    "city": "Yakima",
    "zip": "98901-1963",
    "concatenated_address": "1205 N 2nd St, Yakima",
    "address": "1205 N. 2nd St., Yakima"
  },
  {
    "id": 2689,
    "financing": "Federally subsidized",
    "building_name": "Maple Street",
    "latitude": 47.44223,
    "longitude": -120.33433,
    "original_address": "1325 Maple Street",
    "building_number": 1325,
    "street": "Maple St",
    "city": "Wenatchee",
    "zip": 98801,
    "concatenated_address": "1325 Maple St, Wenatchee",
    "address": "1325 Maple St., Wenatchee"
  },
  {
    "id": 2690,
    "financing": "Federally subsidized",
    "building_name": "Maple Street Apartments",
    "latitude": 47.44223,
    "longitude": -120.33433,
    "original_address": "1325 Maple Street",
    "building_number": 1325,
    "street": "Maple St",
    "city": "Wenatchee",
    "zip": 98801,
    "concatenated_address": "1325 Maple St, Wenatchee",
    "address": "1325 Maple St., Wenatchee"
  },
  {
    "id": 2691,
    "financing": "Federally subsidized",
    "building_name": "Marion Court Preservation Portfolio",
    "latitude": 47.56439,
    "longitude": -122.66243,
    "original_address": "3500 Marion Court",
    "building_number": 3500,
    "street": "Marion Ct",
    "city": "Bremerton",
    "zip": 98312,
    "concatenated_address": "3500 Marion Ct, Bremerton",
    "address": "3500 Marion Ct, Bremerton"
  },
  {
    "id": 2692,
    "financing": "Federally subsidized",
    "building_name": "Marion West",
    "latitude": 47.665736,
    "longitude": -122.31766,
    "original_address": "5019 Roosevelt Way Ne",
    "building_number": 5019,
    "street": "Roosevelt Way NE",
    "city": "Seattle",
    "zip": 98107,
    "concatenated_address": "5019 Roosevelt Way NE, Seattle",
    "address": "5019 Roosevelt Way N.E., Seattle"
  },
  {
    "id": 2693,
    "financing": "Federally subsidized",
    "building_name": "Mariposa Apartments",
    "latitude": 47.348297,
    "longitude": -122.31046,
    "original_address": "28120 18th Avenue S",
    "building_number": 28120,
    "street": "18th Ave S",
    "city": "Federal Way",
    "zip": "98003-3265",
    "concatenated_address": "28120 18th Ave S, Federal Way",
    "address": "28120 18th Ave. S., Federal Way"
  },
  {
    "id": 2694,
    "financing": "Federally subsidized",
    "building_name": "Mariposa Park",
    "latitude": 46.606435,
    "longitude": -120.51617,
    "original_address": "314 Cherry Avenue",
    "building_number": 314,
    "street": "Cherry Ave",
    "city": "Yakima",
    "zip": "98902-6601",
    "concatenated_address": "314 Cherry Ave, Yakima",
    "address": "314 Cherry Ave., Yakima"
  },
  {
    "id": 2695,
    "financing": "Federally subsidized",
    "building_name": "Marjorie Terrace",
    "latitude": 46.074959,
    "longitude": -118.33217,
    "original_address": "817 North Main Street",
    "building_number": 817,
    "street": "N Main St",
    "city": "Walla Walla",
    "zip": 99362,
    "concatenated_address": "817 N Main St, Walla Walla",
    "address": "817 N. Main St., Walla Walla"
  },
  {
    "id": 2696,
    "financing": "Federally subsidized",
    "building_name": "Market House",
    "latitude": 47.609525,
    "longitude": -122.34093,
    "original_address": "1531 1st Avenue",
    "building_number": 1531,
    "street": "1st Ave",
    "city": "Seattle",
    "zip": 98101,
    "concatenated_address": "1531 1st Ave, Seattle",
    "address": "1531 1st Ave., Seattle"
  },
  {
    "id": 2697,
    "financing": "Federally subsidized",
    "building_name": "Market Street Apartments",
    "latitude": 47.250479,
    "longitude": -122.44129,
    "original_address": "1314 Market Street",
    "building_number": 1314,
    "street": "Market St",
    "city": "Tacoma",
    "zip": 98402,
    "concatenated_address": "1314 Market St, Tacoma",
    "address": "1314 Market St., Tacoma"
  },
  {
    "id": 2698,
    "financing": "Federally subsidized",
    "building_name": "Market Terrace",
    "latitude": 47.66839,
    "longitude": -122.3715,
    "original_address": "1115 Nw Market St",
    "building_number": 1115,
    "street": "NW Market St",
    "city": "Seattle",
    "zip": 98107,
    "concatenated_address": "1115 NW Market St, Seattle",
    "address": "1115 N.W. Market St., Seattle"
  },
  {
    "id": 2699,
    "financing": "Federally subsidized",
    "building_name": "Marketplace Apartments",
    "latitude": 45.64163,
    "longitude": -122.62252,
    "original_address": "2900 General Anderson Road",
    "building_number": 2900,
    "street": "General Anderson Ave",
    "city": "Vancouver",
    "zip": "98661-6185",
    "concatenated_address": "2900 General Anderson Ave, Vancouver",
    "address": "2900 General Anderson Ave., Vancouver"
  },
  {
    "id": 2700,
    "financing": "Federally subsidized",
    "building_name": "Martin Court",
    "latitude": 47.545648,
    "longitude": -122.32902,
    "original_address": "6188 Fourth Avenue S",
    "building_number": 6188,
    "street": "4th Ave S",
    "city": "Seattle",
    "zip": 98108,
    "concatenated_address": "6188 4th Ave S, Seattle",
    "address": "6188 4th Ave. S., Seattle"
  },
  {
    "id": 2701,
    "financing": "Federally subsidized",
    "building_name": "Martin Luther King Apartments",
    "latitude": 47.530844,
    "longitude": -122.28114,
    "original_address": "7923 Martin Luther King Jr. Way South",
    "building_number": 7923,
    "street": "Martin Luther King Jr Way S",
    "city": "Seattle",
    "zip": 98118,
    "concatenated_address": "7923 Martin Luther King Jr Way S, Seattle",
    "address": "7923 Martin Luther King Jr Way S., Seattle"
  },
  {
    "id": 2702,
    "financing": "Federally subsidized",
    "building_name": "Marvin Gardens",
    "latitude": 47.614666,
    "longitude": -122.34518,
    "original_address": "2301 Third Ave",
    "building_number": 2301,
    "street": "3rd Ave",
    "city": "Seattle",
    "zip": 98121,
    "concatenated_address": "2301 3rd Ave, Seattle",
    "address": "2301 3rd Ave., Seattle"
  },
  {
    "id": 2703,
    "financing": "Federally subsidized",
    "building_name": "Mary Ruth Manor",
    "latitude": 47.618657,
    "longitude": -122.30572,
    "original_address": "100 20th Ave. East",
    "building_number": 100,
    "street": "20th Ave E",
    "city": "Seattle",
    "zip": 98112,
    "concatenated_address": "100 20th Ave E, Seattle",
    "address": "100 20th Ave. E., Seattle"
  },
  {
    "id": 2704,
    "financing": "Federally subsidized",
    "building_name": "Marysville Quilceda Meadows",
    "latitude": 48.070609,
    "longitude": -122.17003,
    "original_address": "4520 84th Street Ne",
    "building_number": 4520,
    "street": "84th St NE",
    "city": "Marysville",
    "zip": 98270,
    "concatenated_address": "4520 84th St NE, Marysville",
    "address": "4520 84th St. N.E., Marysville"
  },
  {
    "id": 2705,
    "financing": "Federally subsidized",
    "building_name": "Mason Avenue Apartments",
    "latitude": 47.223362,
    "longitude": -122.49471,
    "original_address": "3808 S. Mason Avenue",
    "building_number": 3808,
    "street": "S Mason Ave",
    "city": "Tacoma",
    "zip": 98409,
    "concatenated_address": "3808 S Mason Ave, Tacoma",
    "address": "3808 S. Mason Ave., Tacoma"
  },
  {
    "id": 2706,
    "financing": "Federally subsidized",
    "building_name": "Matsusaka Townhomes",
    "latitude": 47.249515,
    "longitude": -122.44698,
    "original_address": "801 S 14th St",
    "building_number": 801,
    "street": "S 14th St",
    "city": "Tacoma",
    "zip": 98405,
    "concatenated_address": "801 S 14th St, Tacoma",
    "address": "801 S. 14th St., Tacoma"
  },
  {
    "id": 2707,
    "financing": "Federally subsidized",
    "building_name": "Max Hale Center",
    "latitude": 47.566261,
    "longitude": -122.62636,
    "original_address": "285 5th Street",
    "building_number": 285,
    "street": "5th St",
    "city": "Bremerton",
    "zip": 98337,
    "concatenated_address": "285 5th St, Bremerton",
    "address": "285 5th St., Bremerton"
  },
  {
    "id": 2708,
    "financing": "Federally subsidized",
    "building_name": "Maxwell Apartments",
    "latitude": 47.621727,
    "longitude": -122.31757,
    "original_address": "318 11th Avenue E.",
    "building_number": 318,
    "street": "11th Ave E",
    "city": "Seattle",
    "zip": 98102,
    "concatenated_address": "318 11th Ave E, Seattle",
    "address": "318 11th Ave. E., Seattle"
  },
  {
    "id": 2709,
    "financing": "Federally subsidized",
    "building_name": "McCallister Village",
    "latitude": 45.648833,
    "longitude": -122.69339,
    "original_address": "2155 W Firestone Ln",
    "building_number": 2155,
    "street": "W Firestone Ln",
    "city": "Vancouver",
    "zip": 98660,
    "concatenated_address": "2155 W Firestone Ln, Vancouver",
    "address": "2155 W. Firestone Lane, Vancouver"
  },
  {
    "id": 2710,
    "financing": "Federally subsidized",
    "building_name": "McDermott Place",
    "latitude": 47.722421,
    "longitude": -122.29178,
    "original_address": "12740 33rd Avenue Ne",
    "building_number": 12740,
    "street": "33rd Ave NE",
    "city": "Seattle",
    "zip": 98125,
    "concatenated_address": "12740 33rd Ave NE, Seattle",
    "address": "12740 33rd Ave. N.E., Seattle"
  },
  {
    "id": 2711,
    "financing": "Federally subsidized",
    "building_name": "McDermott Place",
    "latitude": 47.722421,
    "longitude": -122.29178,
    "original_address": "12740 - 33rd Avenue Ne",
    "building_number": 12740,
    "street": "33rd Ave NE",
    "city": "Seattle",
    "zip": 98125,
    "concatenated_address": "12740 33rd Ave NE, Seattle",
    "address": "12740 33rd Ave. N.E., Seattle"
  },
  {
    "id": 2712,
    "financing": "Federally subsidized",
    "building_name": "McKinley Terrace",
    "latitude": 47.233016,
    "longitude": -122.42091,
    "original_address": "807 East Wright Ave",
    "building_number": 807,
    "street": "E Wright Ave",
    "city": "Tacoma",
    "zip": 98404,
    "concatenated_address": "807 E Wright Ave, Tacoma",
    "address": "807 E. Wright Ave., Tacoma"
  },
  {
    "id": 2713,
    "financing": "Federally subsidized",
    "building_name": "McKinney Manor Apartments",
    "latitude": 47.617269,
    "longitude": -122.30682,
    "original_address": "1916 East Madison Street",
    "building_number": 1916,
    "street": "E Madison St",
    "city": "Seattle",
    "zip": 98122,
    "concatenated_address": "1916 E Madison St, Seattle",
    "address": "1916 E. Madison St., Seattle"
  },
  {
    "id": 2714,
    "financing": "Federally subsidized",
    "building_name": "McMurray Park I & II",
    "latitude": 46.298981,
    "longitude": -119.27809,
    "original_address": "1780 Pike Ave",
    "building_number": 1780,
    "street": "Pike Ave",
    "city": "Richland",
    "zip": 99354,
    "concatenated_address": "1780 Pike Ave, Richland",
    "address": "1780 Pike Ave., Richland"
  },
  {
    "id": 2715,
    "financing": "Federally subsidized",
    "building_name": "Meadow Park Apartments",
    "latitude": 48.064351,
    "longitude": -122.16022,
    "original_address": "7527 51st Avenue Ne",
    "building_number": 7527,
    "street": "51st Ave NE",
    "city": "Marysville",
    "zip": 98270,
    "concatenated_address": "7527 51st Ave NE, Marysville",
    "address": "7527 51st Ave. N.E., Marysville"
  },
  {
    "id": 2716,
    "financing": "Federally subsidized",
    "building_name": "Meadow Park Apartments",
    "latitude": 46.205892,
    "longitude": -119.13239,
    "original_address": "1001 West 4th Ave",
    "building_number": 1001,
    "street": "W 4th Ave",
    "city": "Kennewick",
    "zip": 99336,
    "concatenated_address": "1001 W 4th Ave, Kennewick",
    "address": "1001 W. 4th Ave., Kennewick"
  },
  {
    "id": 2717,
    "financing": "Federally subsidized",
    "building_name": "Meadow Park Garden Court",
    "latitude": 47.205587,
    "longitude": -122.50786,
    "original_address": "5712 Hannah Pierce Road West",
    "building_number": 5712,
    "street": "Hannah Pierce Rd W",
    "city": "University Place",
    "zip": 98467,
    "concatenated_address": "5712 Hannah Pierce Rd W, University Place",
    "address": "5712 Hannah Pierce Road W., University Place"
  },
  {
    "id": 2718,
    "financing": "Federally subsidized",
    "building_name": "Meadow Wood Townhomes",
    "latitude": 48.793046,
    "longitude": -122.50699,
    "original_address": "939 Mahogany Ave",
    "building_number": 939,
    "street": "Mahogany Ave",
    "city": "Bellingham",
    "zip": 98226,
    "concatenated_address": "939 Mahogany Ave, Bellingham",
    "address": "939 Mahogany Ave., Bellingham"
  },
  {
    "id": 2719,
    "financing": "Federally subsidized",
    "building_name": "Meadow Wood Townhomes II",
    "latitude": 48.792583,
    "longitude": -122.50576,
    "original_address": "931 Mahogany Ave",
    "building_number": 931,
    "street": "Mahogany Ave",
    "city": "Bellingham",
    "zip": "98226-8409",
    "concatenated_address": "931 Mahogany Ave, Bellingham",
    "address": "931 Mahogany Ave., Bellingham"
  },
  {
    "id": 2720,
    "financing": "Federally subsidized",
    "building_name": "Meadowbrook View",
    "latitude": 47.709315,
    "longitude": -122.3006,
    "original_address": "11032 Lake City Way Ne",
    "building_number": 11032,
    "street": "Lake City Way NE",
    "city": "Seattle",
    "zip": 98125,
    "concatenated_address": "11032 Lake City Way NE, Seattle",
    "address": "11032 Lake City Way N.E., Seattle"
  },
  {
    "id": 2721,
    "financing": "Federally subsidized",
    "building_name": "Meadowland Apartments",
    "latitude": 45.817151,
    "longitude": -120.81738,
    "original_address": "801 S Schuster St",
    "building_number": 801,
    "street": "S Schuster Ave",
    "city": "Goldendale",
    "zip": 98620,
    "concatenated_address": "801 S Schuster Ave, Goldendale",
    "address": "801 S. Schuster Ave., Goldendale"
  },
  {
    "id": 2722,
    "financing": "Federally subsidized",
    "building_name": "Meadows",
    "latitude": 46.596673,
    "longitude": -120.53385,
    "original_address": "718 S Sixth Ave",
    "building_number": "",
    "street": "",
    "city": "Yakima",
    "zip": 98902,
    "concatenated_address": "718 S Sixth Ave, Yakima",
    "address": "718 S. Sixth Ave., Yakima"
  },
  {
    "id": 2723,
    "financing": "Federally subsidized",
    "building_name": "Meadows Annex",
    "latitude": 46.590509,
    "longitude": -120.49048,
    "original_address": "1010 S 9th Street",
    "building_number": 1010,
    "street": "S 9th St",
    "city": "Yakima",
    "zip": 98901,
    "concatenated_address": "1010 S 9th St, Yakima",
    "address": "1010 S. 9th St., Yakima"
  },
  {
    "id": 2724,
    "financing": "Federally subsidized",
    "building_name": "Meadows Senior Apartments I & II",
    "latitude": 48.002747,
    "longitude": -122.19787,
    "original_address": "1115 Rainier Ave",
    "building_number": 1115,
    "street": "Rainier Ave",
    "city": "Everett",
    "zip": 98201,
    "concatenated_address": "1115 Rainier Ave, Everett",
    "address": "1115 Rainier Ave., Everett"
  },
  {
    "id": 2725,
    "financing": "Federally subsidized",
    "building_name": "Melrose Apartments",
    "latitude": 47.614682,
    "longitude": -122.32759,
    "original_address": "1520 Melrose Avenue",
    "building_number": 1520,
    "street": "Melrose Ave",
    "city": "Seattle",
    "zip": 98122,
    "concatenated_address": "1520 Melrose Ave, Seattle",
    "address": "1520 Melrose Ave., Seattle"
  },
  {
    "id": 2726,
    "financing": "Federally subsidized",
    "building_name": "Melrose Place",
    "latitude": 46.078427,
    "longitude": -118.31062,
    "original_address": "1960 Melrose Street",
    "building_number": 1960,
    "street": "Melrose St",
    "city": "Walla Walla",
    "zip": 99362,
    "concatenated_address": "1960 Melrose St, Walla Walla",
    "address": "1960 Melrose St., Walla Walla"
  },
  {
    "id": 2727,
    "financing": "Federally subsidized",
    "building_name": "Melvin A & B",
    "latitude": 47.938944,
    "longitude": -122.19812,
    "original_address": "2515 Melvin Ave",
    "building_number": 2515,
    "street": "Melvin Ave",
    "city": "Everett",
    "zip": 98203,
    "concatenated_address": "2515 Melvin Ave, Everett",
    "address": "2515 Melvin Ave., Everett"
  },
  {
    "id": 2728,
    "financing": "Federally subsidized",
    "building_name": "Mercer Court",
    "latitude": 47.623983,
    "longitude": -122.31709,
    "original_address": "527 12th Avenue E",
    "building_number": 527,
    "street": "12th Ave E",
    "city": "Seattle",
    "zip": 98102,
    "concatenated_address": "527 12th Ave E, Seattle",
    "address": "527 12th Ave. E., Seattle"
  },
  {
    "id": 2729,
    "financing": "Federally subsidized",
    "building_name": "Mercer Court",
    "latitude": 47.721085,
    "longitude": -117.4042,
    "original_address": "7007 N. Wiscomb St.",
    "building_number": 7007,
    "street": "N Wiscomb St",
    "city": "Spokane",
    "zip": 99206,
    "concatenated_address": "7007 N Wiscomb St, Spokane",
    "address": "7007 N. Wiscomb St., Spokane"
  },
  {
    "id": 2730,
    "financing": "Federally subsidized",
    "building_name": "Mercy Othello Plaza East & West",
    "latitude": 47.539869,
    "longitude": -122.28202,
    "original_address": "6940 Martin Luther King Jr Way S",
    "building_number": 6940,
    "street": "Martin Luther King Jr Way S",
    "city": "Seattle",
    "zip": 98118,
    "concatenated_address": "6940 Martin Luther King Jr Way S, Seattle",
    "address": "6940 Martin Luther King Jr Way S., Seattle"
  },
  {
    "id": 2731,
    "financing": "Federally subsidized",
    "building_name": "Meridian Court Apartments",
    "latitude": 47.322136,
    "longitude": -122.30396,
    "original_address": "31400 23rd Avenue South",
    "building_number": 31400,
    "street": "23rd Ave S",
    "city": "Federal Way",
    "zip": "98003-5548",
    "concatenated_address": "31400 23rd Ave S, Federal Way",
    "address": "31400 23rd Ave. S., Federal Way"
  },
  {
    "id": 2732,
    "financing": "Federally subsidized",
    "building_name": "Meridian Manor",
    "latitude": 47.704454,
    "longitude": -122.33459,
    "original_address": "10345 Meridian Avenue N",
    "building_number": 10345,
    "street": "Meridian Ave N",
    "city": "Seattle",
    "zip": 98133,
    "concatenated_address": "10345 Meridian Ave N, Seattle",
    "address": "10345 Meridian Ave. N., Seattle"
  },
  {
    "id": 2733,
    "financing": "Federally subsidized",
    "building_name": "Mews At Cascadia Village",
    "latitude": 45.67512,
    "longitude": -122.57571,
    "original_address": "9500 Ne 73rd Street",
    "building_number": 9500,
    "street": "NE 73rd St",
    "city": "Vancouver",
    "zip": 98662,
    "concatenated_address": "9500 NE 73rd St, Vancouver",
    "address": "9500 N.E. 73rd St., Vancouver"
  },
  {
    "id": 2734,
    "financing": "Federally subsidized",
    "building_name": "Mike Foye /Garden Court",
    "latitude": 46.063711,
    "longitude": -118.34495,
    "original_address": "420 W Alder St",
    "building_number": 420,
    "street": "W Alder St",
    "city": "Walla Walla",
    "zip": 99362,
    "concatenated_address": "420 W Alder St, Walla Walla",
    "address": "420 W. Alder St., Walla Walla"
  },
  {
    "id": 2735,
    "financing": "Federally subsidized",
    "building_name": "Mill Creek Apartments",
    "latitude": 45.785083,
    "longitude": -122.54892,
    "original_address": "518 Nw 12th Ave",
    "building_number": 518,
    "street": "NW 12th Ave",
    "city": "Battle Ground",
    "zip": 98604,
    "concatenated_address": "518 NW 12th Ave, Battle Ground",
    "address": "518 N.W. 12th Ave., Battle Ground"
  },
  {
    "id": 2736,
    "financing": "Federally subsidized",
    "building_name": "Mill Pointe Apartments",
    "latitude": 47.878226,
    "longitude": -122.19227,
    "original_address": "3029 132nd Street Se",
    "building_number": 3011,
    "street": "132nd St SE",
    "city": "Everett",
    "zip": "98208-6136",
    "concatenated_address": "3011 132nd St SE, Everett",
    "address": "3011 132nd St. S.E., Everett"
  },
  {
    "id": 2737,
    "financing": "Federally subsidized",
    "building_name": "Miller Park Apartments",
    "latitude": 47.620448,
    "longitude": -122.30166,
    "original_address": "2312 E. John Street",
    "building_number": 2312,
    "street": "E John St",
    "city": "Seattle",
    "zip": 98112,
    "concatenated_address": "2312 E John St, Seattle",
    "address": "2312 E. John St., Seattle"
  },
  {
    "id": 2738,
    "financing": "Federally subsidized",
    "building_name": "Milwaukee Park Apartments",
    "latitude": 48.414911,
    "longitude": -122.33741,
    "original_address": "209 Milwaukee St",
    "building_number": 209,
    "street": "Milwaukee St",
    "city": "Mount Vernon",
    "zip": 98273,
    "concatenated_address": "209 Milwaukee St, Mount Vernon",
    "address": "209 Milwaukee St., Mount Vernon"
  },
  {
    "id": 2739,
    "financing": "Federally subsidized",
    "building_name": "Mine Hill Apartments",
    "latitude": 47.527503,
    "longitude": -122.04145,
    "original_address": "245 Sw Clark St",
    "building_number": 245,
    "street": "SW Clark St",
    "city": "Issaquah",
    "zip": 98027,
    "concatenated_address": "245 SW Clark St, Issaquah",
    "address": "245 S.W. Clark St., Issaquah"
  },
  {
    "id": 2740,
    "financing": "Federally subsidized",
    "building_name": "Mitchell Place Senior Residence",
    "latitude": 47.300234,
    "longitude": -122.32107,
    "original_address": "1001 S. 336th St.",
    "building_number": 1001,
    "street": "S 336th St",
    "city": "Federal Way",
    "zip": 98003,
    "concatenated_address": "1001 S 336th St, Federal Way",
    "address": "1001 S. 336th St., Federal Way"
  },
  {
    "id": 2741,
    "financing": "Federally subsidized",
    "building_name": "MLK New Look Senior Housing",
    "latitude": 47.251845,
    "longitude": -122.4519,
    "original_address": "1102 South 11th Street",
    "building_number": 1102,
    "street": "S 11th St",
    "city": "Tacoma",
    "zip": 98405,
    "concatenated_address": "1102 S 11th St, Tacoma",
    "address": "1102 S. 11th St., Tacoma"
  },
  {
    "id": 2742,
    "financing": "Federally subsidized",
    "building_name": "Monica's Village Place I",
    "latitude": 47.600616,
    "longitude": -122.30174,
    "original_address": "140 23rd Avenue South",
    "building_number": 140,
    "street": "23rd Ave S",
    "city": "Seattle",
    "zip": 98144,
    "concatenated_address": "140 23rd Ave S, Seattle",
    "address": "140 23rd Ave. S., Seattle"
  },
  {
    "id": 2743,
    "financing": "Federally subsidized",
    "building_name": "Monroe Family Village",
    "latitude": 47.849532,
    "longitude": -121.99633,
    "original_address": "17428 W. Main Street",
    "building_number": 17428,
    "street": "W Main St",
    "city": "Monroe",
    "zip": 98272,
    "concatenated_address": "17428 W Main St, Monroe",
    "address": "17428 W. Main St., Monroe"
  },
  {
    "id": 2744,
    "financing": "Federally subsidized",
    "building_name": "Monroe Villa",
    "latitude": 47.858394,
    "longitude": -121.97811,
    "original_address": "601 W Elizabeth",
    "building_number": 601,
    "street": "W Elizabeth St",
    "city": "Monroe",
    "zip": 98272,
    "concatenated_address": "601 W Elizabeth St, Monroe",
    "address": "601 W. Elizabeth St., Monroe"
  },
  {
    "id": 2745,
    "financing": "Federally subsidized",
    "building_name": "Montclair Apartments",
    "latitude": 48.077545,
    "longitude": -121.96581,
    "original_address": "605 S. Kentucky Ave",
    "building_number": 605,
    "street": "S Kentucky Ave",
    "city": "Granite Falls",
    "zip": "98252-8722",
    "concatenated_address": "605 S Kentucky Ave, Granite Falls",
    "address": "605 S. Kentucky Ave., Granite Falls"
  },
  {
    "id": 2746,
    "financing": "Federally subsidized",
    "building_name": "Monte Cristo Hotel",
    "latitude": 47.978879,
    "longitude": -122.20988,
    "original_address": "2929 Hoyt Avenue",
    "building_number": 2929,
    "street": "Hoyt Ave",
    "city": "Everett",
    "zip": 98201,
    "concatenated_address": "2929 Hoyt Ave, Everett",
    "address": "2929 Hoyt Ave., Everett"
  },
  {
    "id": 2747,
    "financing": "Federally subsidized",
    "building_name": "Montesano Harbor Annex Apartments.",
    "latitude": 46.982142,
    "longitude": -123.59972,
    "original_address": "141 S River St",
    "building_number": 141,
    "street": "N River St",
    "city": "Montesano",
    "zip": 98563,
    "concatenated_address": "141 N River St, Montesano",
    "address": "141 N. River St., Montesano"
  },
  {
    "id": 2748,
    "financing": "Federally subsidized",
    "building_name": "Montesano Harbor Apartments.",
    "latitude": 46.980199,
    "longitude": -123.60094,
    "original_address": "114 E Marcy Ave",
    "building_number": 114,
    "street": "W Marcy Ave",
    "city": "Montesano",
    "zip": 98563,
    "concatenated_address": "114 W Marcy Ave, Montesano",
    "address": "114 W. Marcy Ave., Montesano"
  },
  {
    "id": 2749,
    "financing": "Federally subsidized",
    "building_name": "Morning Calm",
    "latitude": 47.857065,
    "longitude": -122.29043,
    "original_address": "4208 156th St. Sw",
    "building_number": 4208,
    "street": "156th St SW",
    "city": "Lynnwood",
    "zip": 98087,
    "concatenated_address": "4208 156th St SW, Lynnwood",
    "address": "4208 156th St. S.W., Lynnwood"
  },
  {
    "id": 2750,
    "financing": "Federally subsidized",
    "building_name": "Morning Sun Park",
    "latitude": 47.884228,
    "longitude": -120.14175,
    "original_address": "345 Madeline Road",
    "building_number": 345,
    "street": "N Madeline Rd",
    "city": "Manson",
    "zip": 98831,
    "concatenated_address": "345 N Madeline Rd, Manson",
    "address": "345 N. Madeline Road, Manson"
  },
  {
    "id": 2751,
    "financing": "Federally subsidized",
    "building_name": "Morningside Senior Apartments",
    "latitude": 48.418621,
    "longitude": -119.51144,
    "original_address": "703 Quince Street",
    "building_number": 703,
    "street": "Quince St",
    "city": "Omak",
    "zip": 98841,
    "concatenated_address": "703 Quince St, Omak",
    "address": "703 Quince St., Omak"
  },
  {
    "id": 2752,
    "financing": "Federally subsidized",
    "building_name": "Morrison Hotel",
    "latitude": 47.602259,
    "longitude": -122.33135,
    "original_address": "509 Third Ave",
    "building_number": 509,
    "street": "3rd Ave",
    "city": "Seattle",
    "zip": "98104-2304",
    "concatenated_address": "509 3rd Ave, Seattle",
    "address": "509 3rd Ave., Seattle"
  },
  {
    "id": 2753,
    "financing": "Federally subsidized",
    "building_name": "Moses Lake Estates",
    "latitude": 47.120807,
    "longitude": -119.26525,
    "original_address": "845 E Hill Avenue",
    "building_number": 845,
    "street": "E Hill Ave",
    "city": "Moses Lake",
    "zip": 98837,
    "concatenated_address": "845 E Hill Ave, Moses Lake",
    "address": "845 E. Hill Ave., Moses Lake"
  },
  {
    "id": 2754,
    "financing": "Federally subsidized",
    "building_name": "Moses Lake Meadows",
    "latitude": 47.113766,
    "longitude": -119.26704,
    "original_address": "1501 Monroe Street",
    "building_number": 1501,
    "street": "S Monroe St",
    "city": "Moses Lake",
    "zip": 98837,
    "concatenated_address": "1501 S Monroe St, Moses Lake",
    "address": "1501 S. Monroe St., Moses Lake"
  },
  {
    "id": 2755,
    "financing": "Federally subsidized",
    "building_name": "Mother Joseph Villa",
    "latitude": 46.343668,
    "longitude": -120.1883,
    "original_address": "301 E Ave",
    "building_number": 301,
    "street": "E Ave",
    "city": "Granger",
    "zip": 98932,
    "concatenated_address": "301 E Ave, Granger",
    "address": "301 E. Ave., Granger"
  },
  {
    "id": 2756,
    "financing": "Federally subsidized",
    "building_name": "Mount Baker Apartments",
    "latitude": 48.752006,
    "longitude": -122.48014,
    "original_address": "308 West Champion",
    "building_number": 308,
    "street": "W Champion St",
    "city": "Bellingham",
    "zip": "98225-4341",
    "concatenated_address": "308 W Champion St, Bellingham",
    "address": "308 W. Champion St., Bellingham"
  },
  {
    "id": 2757,
    "financing": "Federally subsidized",
    "building_name": "Mountain View",
    "latitude": 47.475536,
    "longitude": -122.28587,
    "original_address": "14210 37th Ave. S.",
    "building_number": 14210,
    "street": "37th Ave S",
    "city": "Seattle",
    "zip": 98168,
    "concatenated_address": "14210 37th Ave S, Seattle",
    "address": "14210 37th Ave. S., Seattle"
  },
  {
    "id": 2758,
    "financing": "Federally subsidized",
    "building_name": "Mountain View Apartments",
    "latitude": 47.311797,
    "longitude": -122.21238,
    "original_address": "401 No. Spokane Ave.",
    "building_number": 401,
    "street": "N St NE",
    "city": "Auburn",
    "zip": 99156,
    "concatenated_address": "401 N St NE, Auburn",
    "address": "401 N. St. N.E., Auburn"
  },
  {
    "id": 2759,
    "financing": "Federally subsidized",
    "building_name": "Mountain View Apartments",
    "latitude": 47.475824,
    "longitude": -122.28586,
    "original_address": "14200 37th Avenue South",
    "building_number": 14200,
    "street": "37th Ave S",
    "city": "Seattle",
    "zip": 98168,
    "concatenated_address": "14200 37th Ave S, Seattle",
    "address": "14200 37th Ave. S., Seattle"
  },
  {
    "id": 2760,
    "financing": "Federally subsidized",
    "building_name": "Mountain View Court Apartments",
    "latitude": 48.077407,
    "longitude": -123.11465,
    "original_address": "303 S 5th Ave",
    "building_number": 303,
    "street": "S 5th Ave",
    "city": "Sequim",
    "zip": "98382-3735",
    "concatenated_address": "303 S 5th Ave, Sequim",
    "address": "303 S. 5th Ave., Sequim"
  },
  {
    "id": 2761,
    "financing": "Federally subsidized",
    "building_name": "Mountlake Senior Living",
    "latitude": 47.777641,
    "longitude": -122.30508,
    "original_address": "5525 244th Street Sw",
    "building_number": "",
    "street": "244th St SW",
    "city": "Mountlake Terrace",
    "zip": 98043,
    "concatenated_address": "5525 244th Street Sw, Mountlake Terrace",
    "address": "5525 244th St. S.W., Mountlake Terrace"
  },
  {
    "id": 2762,
    "financing": "Federally subsidized",
    "building_name": "Mt. Baker",
    "latitude": 47.578542,
    "longitude": -122.29488,
    "original_address": "2580 29th Avenue S",
    "building_number": 2580,
    "street": "29th Ave S",
    "city": "Seattle",
    "zip": 98144,
    "concatenated_address": "2580 29th Ave S, Seattle",
    "address": "2580 29th Ave. S., Seattle"
  },
  {
    "id": 2763,
    "financing": "Federally subsidized",
    "building_name": "Mt. Baker Village Apartments",
    "latitude": 47.578495,
    "longitude": -122.29485,
    "original_address": "2900 S. Mcclellan Street",
    "building_number": 2900,
    "street": "S McClellan St",
    "city": "Seattle",
    "zip": 98144,
    "concatenated_address": "2900 S McClellan St, Seattle",
    "address": "2900 S. McClellan St., Seattle"
  },
  {
    "id": 2764,
    "financing": "Federally subsidized",
    "building_name": "Murdock Court Apartments",
    "latitude": 48.511648,
    "longitude": -122.23611,
    "original_address": "123 N Murdock St",
    "building_number": 123,
    "street": "N Murdock St",
    "city": "Sedro-Woolley",
    "zip": 98284,
    "concatenated_address": "123 N Murdock St, Sedro-Woolley",
    "address": "123 N. Murdock St., Sedro-Woolley"
  },
  {
    "id": 2765,
    "financing": "Federally subsidized",
    "building_name": "Nativity House",
    "latitude": 47.249284,
    "longitude": -122.44652,
    "original_address": "1411 South Yakima Avenue",
    "building_number": 1411,
    "street": "S Yakima Ave",
    "city": "Tacoma",
    "zip": 98405,
    "concatenated_address": "1411 S Yakima Ave, Tacoma",
    "address": "1411 S. Yakima Ave., Tacoma"
  },
  {
    "id": 2766,
    "financing": "Federally subsidized",
    "building_name": "New Century Village",
    "latitude": 47.937814,
    "longitude": -122.19896,
    "original_address": "2507 Howard",
    "building_number": 2507,
    "street": "Howard Ave",
    "city": "Everett",
    "zip": 98203,
    "concatenated_address": "2507 Howard Ave, Everett",
    "address": "2507 Howard Ave., Everett"
  },
  {
    "id": 2767,
    "financing": "Federally subsidized",
    "building_name": "New Haven Apartments",
    "latitude": 47.723729,
    "longitude": -122.34753,
    "original_address": "13000 Linden Avenue N",
    "building_number": 13000,
    "street": "Linden Ave N",
    "city": "Seattle",
    "zip": 98133,
    "concatenated_address": "13000 Linden Ave N, Seattle",
    "address": "13000 Linden Ave. N., Seattle"
  },
  {
    "id": 2768,
    "financing": "Federally subsidized",
    "building_name": "New Life Villa",
    "latitude": 46.213934,
    "longitude": -119.99154,
    "original_address": "708 Washington Street",
    "building_number": 708,
    "street": "Washington St",
    "city": "Mabton",
    "zip": 98935,
    "concatenated_address": "708 Washington St, Mabton",
    "address": "708 Washington St., Mabton"
  },
  {
    "id": 2769,
    "financing": "Federally subsidized",
    "building_name": "New Tacoma Senior Apartments",
    "latitude": 47.246019,
    "longitude": -122.44414,
    "original_address": "1709 South G Street",
    "building_number": 1709,
    "street": "S G St",
    "city": "Tacoma",
    "zip": 98405,
    "concatenated_address": "1709 S G St, Tacoma",
    "address": "1709 S. G St., Tacoma"
  },
  {
    "id": 2770,
    "financing": "Federally subsidized",
    "building_name": "New Westside Terrace",
    "latitude": 46.136716,
    "longitude": -122.93977,
    "original_address": "1200 17th Ave",
    "building_number": 1200,
    "street": "17th Ave",
    "city": "Longview",
    "zip": 98632,
    "concatenated_address": "1200 17th Ave, Longview",
    "address": "1200 17th Ave., Longview"
  },
  {
    "id": 2771,
    "financing": "Federally subsidized",
    "building_name": "Newholly Phase I",
    "latitude": 47.536854,
    "longitude": -122.28405,
    "original_address": "3815 S Othello Street, #103",
    "building_number": 3815,
    "street": "S Othello St",
    "city": "Seattle",
    "zip": 98108,
    "concatenated_address": "3815 S Othello St, Seattle",
    "address": "3815 S. Othello St., Seattle"
  },
  {
    "id": 2772,
    "financing": "Federally subsidized",
    "building_name": "Newport Apartments",
    "latitude": 48.300449,
    "longitude": -122.64612,
    "original_address": "280 Ne Izett Street",
    "building_number": 280,
    "street": "NE Izett St",
    "city": "Oak Harbor",
    "zip": 98277,
    "concatenated_address": "280 NE Izett St, Oak Harbor",
    "address": "280 N.E. Izett St., Oak Harbor"
  },
  {
    "id": 2773,
    "financing": "Federally subsidized",
    "building_name": "Nia Apartments",
    "latitude": 47.51424,
    "longitude": -122.34568,
    "original_address": "9935 8th Ave. Sw",
    "building_number": 9935,
    "street": "8th Ave SW",
    "city": "Seattle",
    "zip": 98106,
    "concatenated_address": "9935 8th Ave SW, Seattle",
    "address": "9935 8th Ave. S.W., Seattle"
  },
  {
    "id": 2774,
    "financing": "Federally subsidized",
    "building_name": "Nihonmachi Terrace",
    "latitude": 47.599862,
    "longitude": -122.32463,
    "original_address": "651 South Main St",
    "building_number": 651,
    "street": "S Main St",
    "city": "Seattle",
    "zip": 98104,
    "concatenated_address": "651 S Main St, Seattle",
    "address": "651 S. Main St., Seattle"
  },
  {
    "id": 2775,
    "financing": "Federally subsidized",
    "building_name": "Nooksack Homes I",
    "latitude": 48.885257,
    "longitude": -122.35113,
    "original_address": "2582 Sulwhanon Drive",
    "building_number": 2582,
    "street": "Sulwhanon Dr",
    "city": "Everson",
    "zip": 98247,
    "concatenated_address": "2582 Sulwhanon Dr, Everson",
    "address": "2582 Sulwhanon Drive, Everson"
  },
  {
    "id": 2776,
    "financing": "Federally subsidized",
    "building_name": "Nooksack Homes II",
    "latitude": 48.812776,
    "longitude": -122.17511,
    "original_address": "5912 Edith Dr",
    "building_number": 5912,
    "street": "Edith Dr",
    "city": "Deming",
    "zip": 98244,
    "concatenated_address": "5912 Edith Dr, Deming",
    "address": "5912 Edith Drive, Deming"
  },
  {
    "id": 2777,
    "financing": "Federally subsidized",
    "building_name": "Nooksack Homes III",
    "latitude": 48.812706,
    "longitude": -122.17447,
    "original_address": "4749 False Creek Ln",
    "building_number": 4749,
    "street": "False Creek Ln",
    "city": "Deming",
    "zip": 98244,
    "concatenated_address": "4749 False Creek Ln, Deming",
    "address": "4749 False Creek Lane, Deming"
  },
  {
    "id": 2778,
    "financing": "Federally subsidized",
    "building_name": "Nooksack Homes IV",
    "latitude": 48.898178,
    "longitude": -122.34871,
    "original_address": "2572 George Court",
    "building_number": 2572,
    "street": "George Ct",
    "city": "Everson",
    "zip": 98244,
    "concatenated_address": "2572 George Ct, Everson",
    "address": "2572 George Ct, Everson"
  },
  {
    "id": 2779,
    "financing": "Federally subsidized",
    "building_name": "Nor'West Village",
    "latitude": 48.113819,
    "longitude": -122.79393,
    "original_address": "1921 Sherman St",
    "building_number": 1921,
    "street": "Sherman St",
    "city": "Port Townsend",
    "zip": 98360,
    "concatenated_address": "1921 Sherman St, Port Townsend",
    "address": "1921 Sherman St., Port Townsend"
  },
  {
    "id": 2780,
    "financing": "Federally subsidized",
    "building_name": "Norman Mitchell Manor/Alma Gamble",
    "latitude": 47.601139,
    "longitude": -122.31428,
    "original_address": "165 14th Avenue South",
    "building_number": 165,
    "street": "14th Ave S",
    "city": "Seattle",
    "zip": 98144,
    "concatenated_address": "165 14th Ave S, Seattle",
    "address": "165 14th Ave. S., Seattle"
  },
  {
    "id": 2781,
    "financing": "Federally subsidized",
    "building_name": "Norris Place",
    "latitude": 48.473669,
    "longitude": -122.34085,
    "original_address": "486 Norris Pl",
    "building_number": 486,
    "street": "S Norris St",
    "city": "Burlington",
    "zip": 98233,
    "concatenated_address": "486 S Norris St, Burlington",
    "address": "486 S. Norris St., Burlington"
  },
  {
    "id": 2782,
    "financing": "Federally subsidized",
    "building_name": "North River",
    "latitude": 47.411944,
    "longitude": -120.28686,
    "original_address": "245 5th Street Ne",
    "building_number": 245,
    "street": "5th St NE",
    "city": "East Wenatchee",
    "zip": 98802,
    "concatenated_address": "245 5th St NE, East Wenatchee",
    "address": "245 5th St. N.E., East Wenatchee"
  },
  {
    "id": 2783,
    "financing": "Federally subsidized",
    "building_name": "North River Apartments",
    "latitude": 47.411944,
    "longitude": -120.28686,
    "original_address": "245 - 5th Street Ne",
    "building_number": 245,
    "street": "5th St NE",
    "city": "East Wenatchee",
    "zip": 98802,
    "concatenated_address": "245 5th St NE, East Wenatchee",
    "address": "245 5th St. N.E., East Wenatchee"
  },
  {
    "id": 2784,
    "financing": "Federally subsidized",
    "building_name": "North Valley Apartments",
    "latitude": 48.415512,
    "longitude": -119.51384,
    "original_address": "572 N. Pine Street",
    "building_number": 572,
    "street": "Pine St",
    "city": "Omak",
    "zip": 98841,
    "concatenated_address": "572 Pine St, Omak",
    "address": "572 Pine St., Omak"
  },
  {
    "id": 2785,
    "financing": "Federally subsidized",
    "building_name": "North Valley II",
    "latitude": 48.41519,
    "longitude": -119.51397,
    "original_address": "700 Elderberry Ave",
    "building_number": 700,
    "street": "Elderberry Ave",
    "city": "Omak",
    "zip": 98840,
    "concatenated_address": "700 Elderberry Ave, Omak",
    "address": "700 Elderberry Ave., Omak"
  },
  {
    "id": 2786,
    "financing": "Federally subsidized",
    "building_name": "Northbrook Place",
    "latitude": 48.78378,
    "longitude": -122.5202,
    "original_address": "3615 Bennett Drive",
    "building_number": 3615,
    "street": "Bennett Dr",
    "city": "Bellingham",
    "zip": 98225,
    "concatenated_address": "3615 Bennett Dr, Bellingham",
    "address": "3615 Bennett Drive, Bellingham"
  },
  {
    "id": 2787,
    "financing": "Federally subsidized",
    "building_name": "Northcliff Terrace Apartments",
    "latitude": 47.689235,
    "longitude": -117.42449,
    "original_address": "840 W Cora Avenue",
    "building_number": 840,
    "street": "W Cora Ave",
    "city": "Spokane",
    "zip": 99205,
    "concatenated_address": "840 W Cora Ave, Spokane",
    "address": "840 W. Cora Ave., Spokane"
  },
  {
    "id": 2788,
    "financing": "Federally subsidized",
    "building_name": "Northlake Grove Coop Apartments",
    "latitude": 47.764718,
    "longitude": -122.25036,
    "original_address": "18725 68th Ave. Ne",
    "building_number": 18725,
    "street": "68th Ave NE",
    "city": "Kenmore",
    "zip": 98028,
    "concatenated_address": "18725 68th Ave NE, Kenmore",
    "address": "18725 68th Ave. N.E., Kenmore"
  },
  {
    "id": 2789,
    "financing": "Federally subsidized",
    "building_name": "Northlake Grove Cooperative",
    "latitude": 47.764718,
    "longitude": -122.25036,
    "original_address": "18725 68th Ave. Ne",
    "building_number": 18725,
    "street": "68th Ave NE",
    "city": "Kenmore",
    "zip": 98028,
    "concatenated_address": "18725 68th Ave NE, Kenmore",
    "address": "18725 68th Ave. N.E., Kenmore"
  },
  {
    "id": 2790,
    "financing": "Federally subsidized",
    "building_name": "Northpoint At Creekside",
    "latitude": 47.28206,
    "longitude": -122.5131,
    "original_address": "5601 N 37th St",
    "building_number": 5601,
    "street": "N 37th St",
    "city": "Tacoma",
    "zip": 98407,
    "concatenated_address": "5601 N 37th St, Tacoma",
    "address": "5601 N. 37th St., Tacoma"
  },
  {
    "id": 2791,
    "financing": "Federally subsidized",
    "building_name": "Northridge Apartments",
    "latitude": 46.404279,
    "longitude": -120.26085,
    "original_address": "705 Westwind Dr",
    "building_number": 705,
    "street": "Westwind Dr",
    "city": "Zillah",
    "zip": 98953,
    "concatenated_address": "705 Westwind Dr, Zillah",
    "address": "705 Westwind Drive, Zillah"
  },
  {
    "id": 2792,
    "financing": "Federally subsidized",
    "building_name": "Northwest Corner Affordable Housing",
    "latitude": 48.995913,
    "longitude": -122.74179,
    "original_address": "767 F St",
    "building_number": 767,
    "street": "F St",
    "city": "Blaine",
    "zip": 98230,
    "concatenated_address": "767 F St, Blaine",
    "address": "767 F St., Blaine"
  },
  {
    "id": 2793,
    "financing": "Federally subsidized",
    "building_name": "Northwest Estates I",
    "latitude": 47.177439,
    "longitude": -119.32702,
    "original_address": "1033 Northwest Lane",
    "building_number": 1033,
    "street": "Northwest Ln",
    "city": "Moses Lake",
    "zip": 98837,
    "concatenated_address": "1033 Northwest Ln, Moses Lake",
    "address": "1033 Northwest Lane, Moses Lake"
  },
  {
    "id": 2794,
    "financing": "Federally subsidized",
    "building_name": "Northwest Estates II",
    "latitude": 47.180684,
    "longitude": -119.29898,
    "original_address": "1447 West Sunrise Drive",
    "building_number": "",
    "street": "",
    "city": "Moses Lake",
    "zip": 98837,
    "concatenated_address": "1447 West Sunrise Drive, Moses Lake",
    "address": "1447 West Sunrise Drive, Moses Lake"
  },
  {
    "id": 2795,
    "financing": "Federally subsidized",
    "building_name": "Northwood Manor",
    "latitude": 46.744451,
    "longitude": -117.14753,
    "original_address": "1590 Ne Northwood Drive",
    "building_number": 1590,
    "street": "Northwood Dr",
    "city": "Pullman",
    "zip": 99163,
    "concatenated_address": "1590 Northwood Dr, Pullman",
    "address": "1590 Northwood Drive, Pullman"
  },
  {
    "id": 2796,
    "financing": "Federally subsidized",
    "building_name": "Norwegian Wood Apartments",
    "latitude": 47.321503,
    "longitude": -122.58483,
    "original_address": "3405 Erickson Road",
    "building_number": 3405,
    "street": "Erickson St",
    "city": "Gig Harbor",
    "zip": 98335,
    "concatenated_address": "3405 Erickson St, Gig Harbor",
    "address": "3405 Erickson St., Gig Harbor"
  },
  {
    "id": 2797,
    "financing": "Federally subsidized",
    "building_name": "NP Hotel",
    "latitude": 47.601884,
    "longitude": -122.32946,
    "original_address": "306 Sixth Avenue S",
    "building_number": "",
    "street": "",
    "city": "Seattle",
    "zip": 98104,
    "concatenated_address": "306 Sixth Avenue S, Seattle",
    "address": "306 Sixth Avenue S., Seattle"
  },
  {
    "id": 2798,
    "financing": "Federally subsidized",
    "building_name": "Nueva Vista",
    "latitude": 46.213037,
    "longitude": -119.17981,
    "original_address": "360 N. Union Street",
    "building_number": 360,
    "street": "N Union St",
    "city": "Kennewick",
    "zip": 99336,
    "concatenated_address": "360 N Union St, Kennewick",
    "address": "360 N. Union St., Kennewick"
  },
  {
    "id": 2799,
    "financing": "Federally subsidized",
    "building_name": "Nyer Urness House",
    "latitude": 47.66923,
    "longitude": -122.38125,
    "original_address": "1753 Nw 56th St",
    "building_number": 1753,
    "street": "NW 56th St",
    "city": "Seattle",
    "zip": 98107,
    "concatenated_address": "1753 NW 56th St, Seattle",
    "address": "1753 N.W. 56th St., Seattle"
  },
  {
    "id": 2800,
    "financing": "Federally subsidized",
    "building_name": "Oak Bay Station",
    "latitude": 48.299737,
    "longitude": -122.65637,
    "original_address": "135 N.E. Barron",
    "building_number": 135,
    "street": "NE Barron St",
    "city": "Oak Harbor",
    "zip": 98277,
    "concatenated_address": "135 NE Barron St, Oak Harbor",
    "address": "135 N.E. Barron St., Oak Harbor"
  },
  {
    "id": 2801,
    "financing": "Federally subsidized",
    "building_name": "Oak Bay Station",
    "latitude": 48.299984,
    "longitude": -122.65571,
    "original_address": "116 Barron Drive",
    "building_number": 116,
    "street": "NE Barron Dr",
    "city": "Oak Harbor",
    "zip": 98277,
    "concatenated_address": "116 NE Barron Dr, Oak Harbor",
    "address": "116 N.E. Barron Drive, Oak Harbor"
  },
  {
    "id": 2802,
    "financing": "Federally subsidized",
    "building_name": "Oak Harbor Estates",
    "latitude": 48.299925,
    "longitude": -122.65377,
    "original_address": "191 Ne Ernst Street",
    "building_number": 191,
    "street": "NE Ernst St",
    "city": "Oak Harbor",
    "zip": 98277,
    "concatenated_address": "191 NE Ernst St, Oak Harbor",
    "address": "191 N.E. Ernst St., Oak Harbor"
  },
  {
    "id": 2803,
    "financing": "Federally subsidized",
    "building_name": "Oak Trace",
    "latitude": 47.189673,
    "longitude": -122.49703,
    "original_address": "7419 S Verde",
    "building_number": 7419,
    "street": "S Verde St",
    "city": "Tacoma",
    "zip": 98409,
    "concatenated_address": "7419 S Verde St, Tacoma",
    "address": "7419 S. Verde St., Tacoma"
  },
  {
    "id": 2804,
    "financing": "Federally subsidized",
    "building_name": "Oakes Avenue Commons Cooperative",
    "latitude": 47.975607,
    "longitude": -122.20385,
    "original_address": "3125 Oakes Avenue",
    "building_number": 3125,
    "street": "Oakes Ave",
    "city": "Everett",
    "zip": "98201-4405",
    "concatenated_address": "3125 Oakes Ave, Everett",
    "address": "3125 Oakes Ave., Everett"
  },
  {
    "id": 2805,
    "financing": "Federally subsidized",
    "building_name": "Oakland Apartments",
    "latitude": 48.751763,
    "longitude": -122.48163,
    "original_address": "401 W Champion St",
    "building_number": 401,
    "street": "W Champion St",
    "city": "Bellingham",
    "zip": 98225,
    "concatenated_address": "401 W Champion St, Bellingham",
    "address": "401 W. Champion St., Bellingham"
  },
  {
    "id": 2806,
    "financing": "Federally subsidized",
    "building_name": "Oasis Apartments",
    "latitude": 46.818832,
    "longitude": -119.16297,
    "original_address": "830 E Ash",
    "building_number": 830,
    "street": "E Ash St",
    "city": "Othello",
    "zip": 99344,
    "concatenated_address": "830 E Ash St, Othello",
    "address": "830 E. Ash St., Othello"
  },
  {
    "id": 2807,
    "financing": "Federally subsidized",
    "building_name": "OK Hotel",
    "latitude": 47.600388,
    "longitude": -122.33507,
    "original_address": "212 Alaskan Way South",
    "building_number": 212,
    "street": "Alaskan Way S",
    "city": "Seattle",
    "zip": 98104,
    "concatenated_address": "212 Alaskan Way S, Seattle",
    "address": "212 Alaskan Way S., Seattle"
  },
  {
    "id": 2808,
    "financing": "Federally subsidized",
    "building_name": "Okanogan Gardens",
    "latitude": 48.361478,
    "longitude": -119.58664,
    "original_address": "633 4th Street S.",
    "building_number": 633,
    "street": "4th Ave S",
    "city": "Okanogan",
    "zip": 98840,
    "concatenated_address": "633 4th Ave S, Okanogan",
    "address": "633 4th Ave. S., Okanogan"
  },
  {
    "id": 2809,
    "financing": "Federally subsidized",
    "building_name": "Oleta Apartments",
    "latitude": 47.618337,
    "longitude": -122.32641,
    "original_address": "1816 Bellevue Avenue",
    "building_number": 1816,
    "street": "Bellevue Ave",
    "city": "Seattle",
    "zip": 98122,
    "concatenated_address": "1816 Bellevue Ave, Seattle",
    "address": "1816 Bellevue Ave., Seattle"
  },
  {
    "id": 2810,
    "financing": "Federally subsidized",
    "building_name": "Olive Tower",
    "latitude": 47.615268,
    "longitude": -122.33012,
    "original_address": "1624 Boren Ave",
    "building_number": 1624,
    "street": "Boren Ave",
    "city": "Seattle",
    "zip": 98101,
    "concatenated_address": "1624 Boren Ave, Seattle",
    "address": "1624 Boren Ave., Seattle"
  },
  {
    "id": 2811,
    "financing": "Federally subsidized",
    "building_name": "Olympia Vista Apartments",
    "latitude": 47.03823,
    "longitude": -122.94803,
    "original_address": "3600 Forestbrooke Way Sw",
    "building_number": 3600,
    "street": "Forestbrooke Way SW",
    "city": "Olympia",
    "zip": 98502,
    "concatenated_address": "3600 Forestbrooke Way SW, Olympia",
    "address": "3600 Forestbrooke Way S.W., Olympia"
  },
  {
    "id": 2812,
    "financing": "Federally subsidized",
    "building_name": "Olympic Apartments",
    "latitude": 48.432705,
    "longitude": -122.31993,
    "original_address": "1315 No. 18th Street",
    "building_number": 1315,
    "street": "N 18th St",
    "city": "Mount Vernon",
    "zip": 98273,
    "concatenated_address": "1315 N 18th St, Mount Vernon",
    "address": "1315 N. 18th St., Mount Vernon"
  },
  {
    "id": 2813,
    "financing": "Federally subsidized",
    "building_name": "Olympic Heights",
    "latitude": 47.047622,
    "longitude": -122.9317,
    "original_address": "300 Kenyon Street Nw",
    "building_number": 300,
    "street": "Kenyon St NW",
    "city": "Olympia",
    "zip": 98502,
    "concatenated_address": "300 Kenyon St NW, Olympia",
    "address": "300 Kenyon St. N.W., Olympia"
  },
  {
    "id": 2814,
    "financing": "Federally subsidized",
    "building_name": "Olympic Pointe I & II",
    "latitude": 47.537305,
    "longitude": -122.60699,
    "original_address": "3100 Se Orlando St",
    "building_number": 3100,
    "street": "SE Orlando St",
    "city": "Port Orchard",
    "zip": 98366,
    "concatenated_address": "3100 SE Orlando St, Port Orchard",
    "address": "3100 S.E. Orlando St., Port Orchard"
  },
  {
    "id": 2815,
    "financing": "Federally subsidized",
    "building_name": "Olympic View & Sound View Apartments",
    "latitude": 47.80626,
    "longitude": -122.37952,
    "original_address": "303 Howell Way + 417 - 3rd Avenue",
    "building_number": 303,
    "street": "Howell Way",
    "city": "Edmonds",
    "zip": "98020-4113",
    "concatenated_address": "303 Howell Way, Edmonds",
    "address": "303 Howell Way, Edmonds"
  },
  {
    "id": 2816,
    "financing": "Federally subsidized",
    "building_name": "Olympus Hotel",
    "latitude": 47.255904,
    "longitude": -122.43892,
    "original_address": "815 Pacific Avenue",
    "building_number": 815,
    "street": "Pacific Ave",
    "city": "Tacoma",
    "zip": "98402-5209",
    "concatenated_address": "815 Pacific Ave, Tacoma",
    "address": "815 Pacific Ave., Tacoma"
  },
  {
    "id": 2817,
    "financing": "Federally subsidized",
    "building_name": "Omak Park",
    "latitude": 48.413188,
    "longitude": -119.52623,
    "original_address": "122 North Juniper",
    "building_number": 122,
    "street": "Juniper Pl",
    "city": "Omak",
    "zip": 98841,
    "concatenated_address": "122 Juniper Pl, Omak",
    "address": "122 Juniper Place, Omak"
  },
  {
    "id": 2818,
    "financing": "Federally subsidized",
    "building_name": "Omak Pioneer Gardens",
    "latitude": 48.412288,
    "longitude": -119.52675,
    "original_address": "114 N Juniper",
    "building_number": 114,
    "street": "Juniper St N",
    "city": "Omak",
    "zip": 98841,
    "concatenated_address": "114 Juniper St N, Omak",
    "address": "114 Juniper St. N., Omak"
  },
  {
    "id": 2819,
    "financing": "Federally subsidized",
    "building_name": "One Community Commons",
    "latitude": 47.544262,
    "longitude": -122.37612,
    "original_address": "6512 35th Avenue Sw",
    "building_number": 6512,
    "street": "35th Ave SW",
    "city": "Seattle",
    "zip": 98126,
    "concatenated_address": "6512 35th Ave SW, Seattle",
    "address": "6512 35th Ave. S.W., Seattle"
  },
  {
    "id": 2820,
    "financing": "Federally subsidized",
    "building_name": "Orcas Longhouse",
    "latitude": 48.696292,
    "longitude": -122.90533,
    "original_address": "236 Prune Alley",
    "building_number": 236,
    "street": "Prune Aly",
    "city": "Eastsound",
    "zip": 98245,
    "concatenated_address": "236 Prune Aly, Eastsound",
    "address": "236 Prune Aly, Eastsound"
  },
  {
    "id": 2821,
    "financing": "Federally subsidized",
    "building_name": "Orchard Glen",
    "latitude": 45.663446,
    "longitude": -122.56747,
    "original_address": "5701 Ne 102nd Avenue",
    "building_number": 5701,
    "street": "NE 102nd Ave",
    "city": "Vancouver",
    "zip": 98662,
    "concatenated_address": "5701 NE 102nd Ave, Vancouver",
    "address": "5701 N.E. 102nd Ave., Vancouver"
  },
  {
    "id": 2822,
    "financing": "Federally subsidized",
    "building_name": "Orchard Heights",
    "latitude": 47.207759,
    "longitude": -122.50222,
    "original_address": "4901 S 56th St",
    "building_number": 4901,
    "street": "S 56th St",
    "city": "Tacoma",
    "zip": 98409,
    "concatenated_address": "4901 S 56th St, Tacoma",
    "address": "4901 S. 56th St., Tacoma"
  },
  {
    "id": 2823,
    "financing": "Federally subsidized",
    "building_name": "Orchard Hills Apartments",
    "latitude": 46.226057,
    "longitude": -119.26536,
    "original_address": "1845 Leslie Rd.",
    "building_number": 1845,
    "street": "Leslie Rd",
    "city": "Richland",
    "zip": 99352,
    "concatenated_address": "1845 Leslie Rd, Richland",
    "address": "1845 Leslie Road, Richland"
  },
  {
    "id": 2824,
    "financing": "Federally subsidized",
    "building_name": "Orchard Hills Apartments",
    "latitude": 47.206177,
    "longitude": -122.50489,
    "original_address": "5701 Orchard Street W",
    "building_number": 5701,
    "street": "Orchard St W",
    "city": "University Place",
    "zip": 98467,
    "concatenated_address": "5701 Orchard St W, University Place",
    "address": "5701 Orchard St. W., University Place"
  },
  {
    "id": 2825,
    "financing": "Federally subsidized",
    "building_name": "Orchard Lane Apartments",
    "latitude": 46.706308,
    "longitude": -120.75303,
    "original_address": "501 Orchard Lane",
    "building_number": 501,
    "street": "Orchard Ln",
    "city": "Tieton",
    "zip": 98947,
    "concatenated_address": "501 Orchard Ln, Tieton",
    "address": "501 Orchard Lane, Tieton"
  },
  {
    "id": 2826,
    "financing": "Federally subsidized",
    "building_name": "Orchard West",
    "latitude": 47.213144,
    "longitude": -122.50455,
    "original_address": "4866 S 48th Street",
    "building_number": 4866,
    "street": "S 48th St",
    "city": "Tacoma",
    "zip": 98409,
    "concatenated_address": "4866 S 48th St, Tacoma",
    "address": "4866 S. 48th St., Tacoma"
  },
  {
    "id": 2827,
    "financing": "Federally subsidized",
    "building_name": "Oregon Apartments",
    "latitude": 47.613456,
    "longitude": -122.34697,
    "original_address": "2305 First Ave",
    "building_number": 2305,
    "street": "1st Ave",
    "city": "Seattle",
    "zip": 98122,
    "concatenated_address": "2305 1st Ave, Seattle",
    "address": "2305 1st Ave., Seattle"
  },
  {
    "id": 2828,
    "financing": "Federally subsidized",
    "building_name": "Oregon Place Apartments",
    "latitude": 47.563048,
    "longitude": -122.2864,
    "original_address": "3600 South Oregon Street",
    "building_number": 3600,
    "street": "S Oregon St",
    "city": "Seattle",
    "zip": "98118-1669",
    "concatenated_address": "3600 S Oregon St, Seattle",
    "address": "3600 S. Oregon St., Seattle"
  },
  {
    "id": 2829,
    "financing": "Federally subsidized",
    "building_name": "Orleans Place",
    "latitude": 48.77481,
    "longitude": -122.45706,
    "original_address": "3220 Orleans St",
    "building_number": 3220,
    "street": "Orleans St",
    "city": "Bellingham",
    "zip": 98226,
    "concatenated_address": "3220 Orleans St, Bellingham",
    "address": "3220 Orleans St., Bellingham"
  },
  {
    "id": 2830,
    "financing": "Federally subsidized",
    "building_name": "Oroville Gardens",
    "latitude": 48.939122,
    "longitude": -119.43386,
    "original_address": "1522 Golden Street",
    "building_number": 1522,
    "street": "Golden St",
    "city": "Oroville",
    "zip": 98844,
    "concatenated_address": "1522 Golden St, Oroville",
    "address": "1522 Golden St., Oroville"
  },
  {
    "id": 2831,
    "financing": "Federally subsidized",
    "building_name": "Oxbow Apartments",
    "latitude": 47.950689,
    "longitude": -124.37536,
    "original_address": "821 E Division St.",
    "building_number": 821,
    "street": "E Division St",
    "city": "Forks",
    "zip": 98331,
    "concatenated_address": "821 E Division St, Forks",
    "address": "821 E. Division St., Forks"
  },
  {
    "id": 2832,
    "financing": "Federally subsidized",
    "building_name": "Oxford Square",
    "latitude": 47.817924,
    "longitude": -122.29914,
    "original_address": "4807 200th Street Sw",
    "building_number": 4807,
    "street": "200th St SW",
    "city": "Lynnwood",
    "zip": 98036,
    "concatenated_address": "4807 200th St SW, Lynnwood",
    "address": "4807 200th St. S.W., Lynnwood"
  },
  {
    "id": 2833,
    "financing": "Federally subsidized",
    "building_name": "Pacific Crest Apartments",
    "latitude": 47.230051,
    "longitude": -122.43382,
    "original_address": "3401 Pacific Ave",
    "building_number": 3401,
    "street": "Pacific Ave",
    "city": "Tacoma",
    "zip": 98408,
    "concatenated_address": "3401 Pacific Ave, Tacoma",
    "address": "3401 Pacific Ave., Tacoma"
  },
  {
    "id": 2834,
    "financing": "Federally subsidized",
    "building_name": "Pacific Hotel",
    "latitude": 47.605111,
    "longitude": -122.33241,
    "original_address": "317 Marion St",
    "building_number": 317,
    "street": "Marion St",
    "city": "Seattle",
    "zip": 98104,
    "concatenated_address": "317 Marion St, Seattle",
    "address": "317 Marion St., Seattle"
  },
  {
    "id": 2835,
    "financing": "Federally subsidized",
    "building_name": "Pacific Inn Apartments",
    "latitude": 47.612721,
    "longitude": -122.1914,
    "original_address": "225 112th Avenue Ne",
    "building_number": 225,
    "street": "112th Ave NE",
    "city": "Bellevue",
    "zip": "98004-5816",
    "concatenated_address": "225 112th Ave NE, Bellevue",
    "address": "225 112th Ave. N.E., Bellevue"
  },
  {
    "id": 2836,
    "financing": "Federally subsidized",
    "building_name": "Pacific Place Apartments",
    "latitude": 46.665571,
    "longitude": -123.81346,
    "original_address": "208 Central Ave.",
    "building_number": 208,
    "street": "Central Ave",
    "city": "South Bend",
    "zip": 98586,
    "concatenated_address": "208 Central Ave, South Bend",
    "address": "208 Central Ave., South Bend"
  },
  {
    "id": 2837,
    "financing": "Federally subsidized",
    "building_name": "Pacific Rim Apartments",
    "latitude": 48.805062,
    "longitude": -122.50146,
    "original_address": "978 Pacific Rim Lane",
    "building_number": 978,
    "street": "Pacific Rim Ln",
    "city": "Bellingham",
    "zip": 98226,
    "concatenated_address": "978 Pacific Rim Ln, Bellingham",
    "address": "978 Pacific Rim Lane, Bellingham"
  },
  {
    "id": 2838,
    "financing": "Federally subsidized",
    "building_name": "Pacific Sands Apartments",
    "latitude": 46.359989,
    "longitude": -124.05102,
    "original_address": "1300 North Washington Ave.",
    "building_number": 1300,
    "street": "Washington Ave N",
    "city": "Long Beach",
    "zip": 98631,
    "concatenated_address": "1300 Washington Ave N, Long Beach",
    "address": "1300 Washington Ave. N., Long Beach"
  },
  {
    "id": 2839,
    "financing": "Federally subsidized",
    "building_name": "Palouse Cove",
    "latitude": 46.893777,
    "longitude": -117.07402,
    "original_address": "721 Palouse Cove Road",
    "building_number": "",
    "street": "Palouse Cove Rd",
    "city": "Palouse",
    "zip": 99161,
    "concatenated_address": "721 Palouse Cove Road, Palouse",
    "address": "721 Palouse Cove Road, Palouse"
  },
  {
    "id": 2840,
    "financing": "Federally subsidized",
    "building_name": "Palouse Trace",
    "latitude": 46.746409,
    "longitude": -117.16845,
    "original_address": "375 N.E. Terre View, Bldg. A",
    "building_number": 375,
    "street": "NE Terre View Dr",
    "city": "Pullman",
    "zip": 99163,
    "concatenated_address": "375 NE Terre View Dr, Pullman",
    "address": "375 N.E. Terre View Drive, Pullman"
  },
  {
    "id": 2841,
    "financing": "Federally subsidized",
    "building_name": "Palouse Trails Apartments",
    "latitude": 47.608264,
    "longitude": -117.36167,
    "original_address": "5000 S. Palouse Hwy",
    "building_number": 5000,
    "street": "S Palouse Hwy",
    "city": "Spokane",
    "zip": 99223,
    "concatenated_address": "5000 S Palouse Hwy, Spokane",
    "address": "5000 S. Palouse Highway, Spokane"
  },
  {
    "id": 2842,
    "financing": "Federally subsidized",
    "building_name": "Pantages Apartments",
    "latitude": 47.618448,
    "longitude": -122.32178,
    "original_address": "803 E Denny Way",
    "building_number": 803,
    "street": "E Denny Way",
    "city": "Seattle",
    "zip": 98122,
    "concatenated_address": "803 E Denny Way, Seattle",
    "address": "803 E. Denny Way, Seattle"
  },
  {
    "id": 2843,
    "financing": "Federally subsidized",
    "building_name": "Paragon",
    "latitude": 46.314639,
    "longitude": -120.00536,
    "original_address": "1320 S. 11th Street",
    "building_number": 1320,
    "street": "S 11th St",
    "city": "Sunnyside",
    "zip": 98944,
    "concatenated_address": "1320 S 11th St, Sunnyside",
    "address": "1320 S. 11th St., Sunnyside"
  },
  {
    "id": 2844,
    "financing": "Federally subsidized",
    "building_name": "Pardee Townhouses",
    "latitude": 47.616133,
    "longitude": -122.31378,
    "original_address": "1630 14th Ave",
    "building_number": 1630,
    "street": "14th Ave",
    "city": "Seattle",
    "zip": 98122,
    "concatenated_address": "1630 14th Ave, Seattle",
    "address": "1630 14th Ave., Seattle"
  },
  {
    "id": 2845,
    "financing": "Federally subsidized",
    "building_name": "Park 16",
    "latitude": 47.281535,
    "longitude": -122.31416,
    "original_address": "35703 16th Avenue South",
    "building_number": 35703,
    "street": "16th Ave S",
    "city": "Federal Way",
    "zip": 98093,
    "concatenated_address": "35703 16th Ave S, Federal Way",
    "address": "35703 16th Ave. S., Federal Way"
  },
  {
    "id": 2846,
    "financing": "Federally subsidized",
    "building_name": "Park Court Apartments",
    "latitude": 47.381774,
    "longitude": -122.25274,
    "original_address": "24510 64th Avenue S",
    "building_number": 24510,
    "street": "64th Ave S",
    "city": "Kent",
    "zip": 98032,
    "concatenated_address": "24510 64th Ave S, Kent",
    "address": "24510 64th Ave. S., Kent"
  },
  {
    "id": 2847,
    "financing": "Federally subsidized",
    "building_name": "Park Hill",
    "latitude": 47.613113,
    "longitude": -122.31523,
    "original_address": "1300 E. Union Street",
    "building_number": 1300,
    "street": "E Union St",
    "city": "Seattle",
    "zip": 98122,
    "concatenated_address": "1300 E Union St, Seattle",
    "address": "1300 E. Union St., Seattle"
  },
  {
    "id": 2848,
    "financing": "Federally subsidized",
    "building_name": "Park Hill Apartments",
    "latitude": 47.489754,
    "longitude": -122.24835,
    "original_address": "12511 69th Avenue S",
    "building_number": 12511,
    "street": "69th Ave S",
    "city": "Seattle",
    "zip": "98178-4111",
    "concatenated_address": "12511 69th Ave S, Seattle",
    "address": "12511 69th Ave. S., Seattle"
  },
  {
    "id": 2849,
    "financing": "Federally subsidized",
    "building_name": "Park Lake Homes II - Zephyr",
    "latitude": 47.500536,
    "longitude": -122.33945,
    "original_address": "11464 4th Pl Sw",
    "building_number": 11464,
    "street": "4th Pl SW",
    "city": "Seattle",
    "zip": 98106,
    "concatenated_address": "11464 4th Pl SW, Seattle",
    "address": "11464 4th Pl S.W., Seattle"
  },
  {
    "id": 2850,
    "financing": "Federally subsidized",
    "building_name": "Park Place",
    "latitude": 46.578315,
    "longitude": -122.90197,
    "original_address": "105 Haywire Road",
    "building_number": "",
    "street": "",
    "city": "Napavine",
    "zip": 98565,
    "concatenated_address": "105 Haywire Road, Napavine",
    "address": "105 Haywire Road, Napavine"
  },
  {
    "id": 2851,
    "financing": "Federally subsidized",
    "building_name": "Park Place (Kent)",
    "latitude": 47.366823,
    "longitude": -122.22629,
    "original_address": "1406 Maple Ln",
    "building_number": 1406,
    "street": "Maple Ln",
    "city": "Kent",
    "zip": 98030,
    "concatenated_address": "1406 Maple Ln, Kent",
    "address": "1406 Maple Lane, Kent"
  },
  {
    "id": 2852,
    "financing": "Federally subsidized",
    "building_name": "Park Place Apartments",
    "latitude": 47.630951,
    "longitude": -122.64775,
    "original_address": "110 Ne Brookdale Ln Ne",
    "building_number": 110,
    "street": "NE Brookdale Ln",
    "city": "Bremerton",
    "zip": 98311,
    "concatenated_address": "110 NE Brookdale Ln, Bremerton",
    "address": "110 N.E. Brookdale Lane, Bremerton"
  },
  {
    "id": 2853,
    "financing": "Federally subsidized",
    "building_name": "Park Place Apartments",
    "latitude": 47.366823,
    "longitude": -122.22629,
    "original_address": "1406 Maple Lane South",
    "building_number": 1406,
    "street": "Maple Ln",
    "city": "Kent",
    "zip": 98032,
    "concatenated_address": "1406 Maple Ln, Kent",
    "address": "1406 Maple Lane, Kent"
  },
  {
    "id": 2854,
    "financing": "Federally subsidized",
    "building_name": "Park Place Apartments",
    "latitude": 47.630951,
    "longitude": -122.64775,
    "original_address": "110 Ne Brookdale Lane",
    "building_number": 110,
    "street": "NE Brookdale Ln",
    "city": "Bremerton",
    "zip": "98311-9192",
    "concatenated_address": "110 NE Brookdale Ln, Bremerton",
    "address": "110 N.E. Brookdale Lane, Bremerton"
  },
  {
    "id": 2855,
    "financing": "Federally subsidized",
    "building_name": "Park View Apartments",
    "latitude": 47.241755,
    "longitude": -119.8451,
    "original_address": "500 E Street Northeast",
    "building_number": 500,
    "street": "E St NE",
    "city": "Quincy",
    "zip": 98848,
    "concatenated_address": "500 E St NE, Quincy",
    "address": "500 E. St. N.E., Quincy"
  },
  {
    "id": 2856,
    "financing": "Federally subsidized",
    "building_name": "Park Village",
    "latitude": 46.645965,
    "longitude": -120.53727,
    "original_address": "554 S Fifth St",
    "building_number": 554,
    "street": "S 5th St",
    "city": "Selah",
    "zip": 98942,
    "concatenated_address": "554 S 5th St, Selah",
    "address": "554 S. 5th St., Selah"
  },
  {
    "id": 2857,
    "financing": "Federally subsidized",
    "building_name": "Park Village I",
    "latitude": 46.645965,
    "longitude": -120.53727,
    "original_address": "554 S. 5th St.",
    "building_number": 554,
    "street": "S 5th St",
    "city": "Selah",
    "zip": 98942,
    "concatenated_address": "554 S 5th St, Selah",
    "address": "554 S. 5th St., Selah"
  },
  {
    "id": 2858,
    "financing": "Federally subsidized",
    "building_name": "Park Village II",
    "latitude": 46.646537,
    "longitude": -120.5375,
    "original_address": "502 S. 5th St",
    "building_number": 502,
    "street": "S 5th St",
    "city": "Selah",
    "zip": 98942,
    "concatenated_address": "502 S 5th St, Selah",
    "address": "502 S. 5th St., Selah"
  },
  {
    "id": 2859,
    "financing": "Federally subsidized",
    "building_name": "Parker Apartments",
    "latitude": 47.644318,
    "longitude": -122.36122,
    "original_address": "2701 3rd Avenue W",
    "building_number": 2701,
    "street": "3rd Ave W",
    "city": "Seattle",
    "zip": 98119,
    "concatenated_address": "2701 3rd Ave W, Seattle",
    "address": "2701 3rd Ave. W., Seattle"
  },
  {
    "id": 2860,
    "financing": "Federally subsidized",
    "building_name": "Parkland Manor",
    "latitude": 47.161129,
    "longitude": -122.45979,
    "original_address": "1756 106th Street S",
    "building_number": 1756,
    "street": "106th St S",
    "city": "Tacoma",
    "zip": 98444,
    "concatenated_address": "1756 106th St S, Tacoma",
    "address": "1756 106th St. S., Tacoma"
  },
  {
    "id": 2861,
    "financing": "Federally subsidized",
    "building_name": "Parkland Terrace Apartments",
    "latitude": 46.145938,
    "longitude": -122.96568,
    "original_address": "3133 Maryland St",
    "building_number": 3133,
    "street": "Maryland St",
    "city": "Longview",
    "zip": 98632,
    "concatenated_address": "3133 Maryland St, Longview",
    "address": "3133 Maryland St., Longview"
  },
  {
    "id": 2862,
    "financing": "Federally subsidized",
    "building_name": "Parklane Apartments",
    "latitude": 45.69564,
    "longitude": -122.66473,
    "original_address": "10223 Ne Notchlog Drive",
    "building_number": 10223,
    "street": "NE Notchlog Dr",
    "city": "Vancouver",
    "zip": 98685,
    "concatenated_address": "10223 NE Notchlog Dr, Vancouver",
    "address": "10223 N.E. Notchlog Drive, Vancouver"
  },
  {
    "id": 2863,
    "financing": "Federally subsidized",
    "building_name": "Parkside Apartments",
    "latitude": 47.919944,
    "longitude": -122.24679,
    "original_address": "900 West Casino Road",
    "building_number": 900,
    "street": "W Casino Rd",
    "city": "Everett",
    "zip": "98204-1628",
    "concatenated_address": "900 W Casino Rd, Everett",
    "address": "900 W. Casino Road, Everett"
  },
  {
    "id": 2864,
    "financing": "Federally subsidized",
    "building_name": "Parkside At Mirabeau",
    "latitude": 47.683466,
    "longitude": -117.23876,
    "original_address": "2820 North Cherry Street",
    "building_number": 2820,
    "street": "N Cherry St",
    "city": "Spokane",
    "zip": "99216-5001",
    "concatenated_address": "2820 N Cherry St, Spokane",
    "address": "2820 N. Cherry St., Spokane"
  },
  {
    "id": 2865,
    "financing": "Federally subsidized",
    "building_name": "Parkview",
    "latitude": 47.241755,
    "longitude": -119.8451,
    "original_address": "500 E Street Ne",
    "building_number": 500,
    "street": "E St NE",
    "city": "Quincy",
    "zip": 98848,
    "concatenated_address": "500 E St NE, Quincy",
    "address": "500 E. St. N.E., Quincy"
  },
  {
    "id": 2866,
    "financing": "Federally subsidized",
    "building_name": "Parkview Apartments",
    "latitude": 46.198671,
    "longitude": -119.13387,
    "original_address": "1138 W 10th Ave",
    "building_number": 1138,
    "street": "W 10th Ave",
    "city": "Kennewick",
    "zip": 99336,
    "concatenated_address": "1138 W 10th Ave, Kennewick",
    "address": "1138 W. 10th Ave., Kennewick"
  },
  {
    "id": 2867,
    "financing": "Federally subsidized",
    "building_name": "Parkview Apartments",
    "latitude": 47.649479,
    "longitude": -117.38889,
    "original_address": "1413 E 7th Ave",
    "building_number": 1413,
    "street": "E 7th Ave",
    "city": "Spokane",
    "zip": 99202,
    "concatenated_address": "1413 E 7th Ave, Spokane",
    "address": "1413 E. 7th Ave., Spokane"
  },
  {
    "id": 2868,
    "financing": "Federally subsidized",
    "building_name": "Parkway Apartments",
    "latitude": 47.302027,
    "longitude": -122.36222,
    "original_address": "2206 Sw 334th Place",
    "building_number": 2206,
    "street": "SW 334th Pl",
    "city": "Federal Way",
    "zip": "98023-2842",
    "concatenated_address": "2206 SW 334th Pl, Federal Way",
    "address": "2206 S.W. 334th Place, Federal Way"
  },
  {
    "id": 2869,
    "financing": "Federally subsidized",
    "building_name": "Parkwood Twinhomes",
    "latitude": 46.332561,
    "longitude": -120.00856,
    "original_address": "508 Cemetery Road",
    "building_number": 508,
    "street": "Cemetery Rd",
    "city": "Sunnyside",
    "zip": 98944,
    "concatenated_address": "508 Cemetery Rd, Sunnyside",
    "address": "508 Cemetery Road, Sunnyside"
  },
  {
    "id": 2870,
    "financing": "Federally subsidized",
    "building_name": "Parsons Apartments",
    "latitude": 47.656216,
    "longitude": -117.42976,
    "original_address": "108 S Jefferson Street",
    "building_number": 108,
    "street": "S Jefferson St",
    "city": "Spokane",
    "zip": 99201,
    "concatenated_address": "108 S Jefferson St, Spokane",
    "address": "108 S. Jefferson St., Spokane"
  },
  {
    "id": 2871,
    "financing": "Federally subsidized",
    "building_name": "Passage Point -Rehabilitation",
    "latitude": 47.459857,
    "longitude": -122.03789,
    "original_address": "15900 - 227th Avenue Se",
    "building_number": 15900,
    "street": "227th Ave SE",
    "city": "Maple Valley",
    "zip": 98038,
    "concatenated_address": "15900 227th Ave SE, Maple Valley",
    "address": "15900 227th Ave. S.E., Maple Valley"
  },
  {
    "id": 2872,
    "financing": "Federally subsidized",
    "building_name": "Pateros Gardens",
    "latitude": 48.054305,
    "longitude": -119.89841,
    "original_address": "249 South Dawson Street",
    "building_number": 249,
    "street": "S Dawson",
    "city": "Pateros",
    "zip": 98846,
    "concatenated_address": "249 S Dawson, Pateros",
    "address": "249 S. Dawson, Pateros"
  },
  {
    "id": 2873,
    "financing": "Federally subsidized",
    "building_name": "Patrick Place Apartments",
    "latitude": 47.658978,
    "longitude": -122.34768,
    "original_address": "4251 Aurora Avenue North",
    "building_number": 4251,
    "street": "Aurora Ave N",
    "city": "Seattle",
    "zip": 98103,
    "concatenated_address": "4251 Aurora Ave N, Seattle",
    "address": "4251 Aurora Ave. N., Seattle"
  },
  {
    "id": 2874,
    "financing": "Federally subsidized",
    "building_name": "Peachtree Place",
    "latitude": 48.096009,
    "longitude": -119.78237,
    "original_address": "507 W Griggs Ave",
    "building_number": 507,
    "street": "W Griggs Ave",
    "city": "Brewster",
    "zip": "",
    "concatenated_address": "507 W Griggs Ave, Brewster",
    "address": "507 W. Griggs Ave., Brewster"
  },
  {
    "id": 2875,
    "financing": "Federally subsidized",
    "building_name": "Pear Tree Place",
    "latitude": 46.607647,
    "longitude": -120.54951,
    "original_address": "2900 Powerhouse Rd",
    "building_number": 2900,
    "street": "Powerhouse Rd",
    "city": "Yakima",
    "zip": 98902,
    "concatenated_address": "2900 Powerhouse Rd, Yakima",
    "address": "2900 Powerhouse Road, Yakima"
  },
  {
    "id": 2876,
    "financing": "Federally subsidized",
    "building_name": "Pearl On Adams",
    "latitude": 47.654769,
    "longitude": -117.4309,
    "original_address": "173 S Adams St",
    "building_number": 173,
    "street": "S Adams St",
    "city": "Spokane",
    "zip": 99201,
    "concatenated_address": "173 S Adams St, Spokane",
    "address": "173 S. Adams St., Spokane"
  },
  {
    "id": 2877,
    "financing": "Federally subsidized",
    "building_name": "Pearl On Oyster Bay",
    "latitude": 47.566785,
    "longitude": -122.67525,
    "original_address": "550 Russell Road",
    "building_number": 550,
    "street": "Russell Rd",
    "city": "Bremerton",
    "zip": 98312,
    "concatenated_address": "550 Russell Rd, Bremerton",
    "address": "550 Russell Road, Bremerton"
  },
  {
    "id": 2878,
    "financing": "Federally subsidized",
    "building_name": "Pelican Horn Apartments",
    "latitude": 47.126238,
    "longitude": -119.27738,
    "original_address": "303 West 6th Ave",
    "building_number": 303,
    "street": "W 6th Ave",
    "city": "Moses Lake",
    "zip": 98837,
    "concatenated_address": "303 W 6th Ave, Moses Lake",
    "address": "303 W. 6th Ave., Moses Lake"
  },
  {
    "id": 2879,
    "financing": "Federally subsidized",
    "building_name": "Pelican Place",
    "latitude": 47.127783,
    "longitude": -119.27244,
    "original_address": "211 E Seventh Avenue",
    "building_number": 211,
    "street": "E 7th Ave",
    "city": "Moses Lake",
    "zip": 98837,
    "concatenated_address": "211 E 7th Ave, Moses Lake",
    "address": "211 E. 7th Ave., Moses Lake"
  },
  {
    "id": 2880,
    "financing": "Federally subsidized",
    "building_name": "Pend Oreille West",
    "latitude": 47.307462,
    "longitude": -122.21139,
    "original_address": "100 No. Spokane West",
    "building_number": 100,
    "street": "N St SE",
    "city": "Auburn",
    "zip": 99156,
    "concatenated_address": "100 N St SE, Auburn",
    "address": "100 N. St. S.E., Auburn"
  },
  {
    "id": 2881,
    "financing": "Federally subsidized",
    "building_name": "Penn Hall Apartments",
    "latitude": 47.619484,
    "longitude": -122.30696,
    "original_address": "1907 East John Street",
    "building_number": 1907,
    "street": "E John St",
    "city": "Seattle",
    "zip": 98112,
    "concatenated_address": "1907 E John St, Seattle",
    "address": "1907 E. John St., Seattle"
  },
  {
    "id": 2882,
    "financing": "Federally subsidized",
    "building_name": "Pennsylvania Place Apartments",
    "latitude": 47.223408,
    "longitude": -120.99279,
    "original_address": "103 E. Pennsylvania Ave.",
    "building_number": 103,
    "street": "E Pennsylvania Ave",
    "city": "Roslyn",
    "zip": 98941,
    "concatenated_address": "103 E Pennsylvania Ave, Roslyn",
    "address": "103 E. Pennsylvania Ave., Roslyn"
  },
  {
    "id": 2883,
    "financing": "Federally subsidized",
    "building_name": "Pepperwood Senior Apartments",
    "latitude": 47.817842,
    "longitude": -122.31459,
    "original_address": "19924 Scriber Lake Road",
    "building_number": 19924,
    "street": "Scriber Lake Rd",
    "city": "Lynnwood",
    "zip": 98036,
    "concatenated_address": "19924 Scriber Lake Rd, Lynnwood",
    "address": "19924 Scriber Lake Road, Lynnwood"
  },
  {
    "id": 2884,
    "financing": "Federally subsidized",
    "building_name": "Pershing Apartments",
    "latitude": 47.174305,
    "longitude": -119.32425,
    "original_address": "1239 Adair Drive",
    "building_number": 1239,
    "street": "Adair St",
    "city": "Moses Lake",
    "zip": 98837,
    "concatenated_address": "1239 Adair St, Moses Lake",
    "address": "1239 Adair St., Moses Lake"
  },
  {
    "id": 2885,
    "financing": "Federally subsidized",
    "building_name": "Pheasant Hill Apartments",
    "latitude": 46.378958,
    "longitude": -120.32527,
    "original_address": "606 S. Juniper Street.",
    "building_number": 606,
    "street": "S Juniper St",
    "city": "Toppenish",
    "zip": "98948-1043",
    "concatenated_address": "606 S Juniper St, Toppenish",
    "address": "606 S. Juniper St., Toppenish"
  },
  {
    "id": 2886,
    "financing": "Federally subsidized",
    "building_name": "Pheasant Run",
    "latitude": 46.813289,
    "longitude": -119.16766,
    "original_address": "1130 Shady Ln Pl",
    "building_number": 1130,
    "street": "Shady Lane Pl",
    "city": "Othello",
    "zip": 99344,
    "concatenated_address": "1130 Shady Lane Pl, Othello",
    "address": "1130 Shady Lane Place, Othello"
  },
  {
    "id": 2887,
    "financing": "Federally subsidized",
    "building_name": "Phyllis Gutierrez Kenney Place & Brettler Family Place 3",
    "latitude": 47.678183,
    "longitude": -122.26144,
    "original_address": "6818 62nd Avenue Ne",
    "building_number": 6818,
    "street": "62nd Ave NE",
    "city": "Seattle",
    "zip": 98115,
    "concatenated_address": "6818 62nd Ave NE, Seattle",
    "address": "6818 62nd Ave. N.E., Seattle"
  },
  {
    "id": 2888,
    "financing": "Federally subsidized",
    "building_name": "Pilchuck I & II",
    "latitude": 48.060048,
    "longitude": -122.17079,
    "original_address": "1724 Grove Street",
    "building_number": 1724,
    "street": "Grove St",
    "city": "Marysville",
    "zip": 98270,
    "concatenated_address": "1724 Grove St, Marysville",
    "address": "1724 Grove St., Marysville"
  },
  {
    "id": 2889,
    "financing": "Federally subsidized",
    "building_name": "Pilchuck Ridge",
    "latitude": 47.918936,
    "longitude": -122.08494,
    "original_address": "226 Sixth St",
    "building_number": 226,
    "street": "Sixth St",
    "city": "Snohomish",
    "zip": 98290,
    "concatenated_address": "226 Sixth St, Snohomish",
    "address": "226 Sixth St., Snohomish"
  },
  {
    "id": 2890,
    "financing": "Federally subsidized",
    "building_name": "Pine Meadows Senior Housing",
    "latitude": 48.416912,
    "longitude": -119.51394,
    "original_address": "620 Pine Street",
    "building_number": 620,
    "street": "Pine St",
    "city": "Omak",
    "zip": 98841,
    "concatenated_address": "620 Pine St, Omak",
    "address": "620 Pine St., Omak"
  },
  {
    "id": 2891,
    "financing": "Federally subsidized",
    "building_name": "Pine Ridge Apartment Homes",
    "latitude": 47.441198,
    "longitude": -122.28573,
    "original_address": "3725 South 180th Street",
    "building_number": 3725,
    "street": "S 180th St",
    "city": "Seattle",
    "zip": 98188,
    "concatenated_address": "3725 S 180th St, Seattle",
    "address": "3725 S. 180th St., Seattle"
  },
  {
    "id": 2892,
    "financing": "Federally subsidized",
    "building_name": "Pine Road Village",
    "latitude": 48.108732,
    "longitude": -123.4557,
    "original_address": "528 W Lauridsen Blvd",
    "building_number": 528,
    "street": "W Lauridsen Blvd",
    "city": "Port Angeles",
    "zip": 98362,
    "concatenated_address": "528 W Lauridsen Blvd, Port Angeles",
    "address": "528 W. Lauridsen Blvd., Port Angeles"
  },
  {
    "id": 2893,
    "financing": "Federally subsidized",
    "building_name": "Pine Rock Apartments",
    "latitude": 47.604898,
    "longitude": -117.36504,
    "original_address": "3211 E 55th Ave",
    "building_number": 3211,
    "street": "E 55th Ave",
    "city": "Spokane",
    "zip": 99223,
    "concatenated_address": "3211 E 55th Ave, Spokane",
    "address": "3211 E. 55th Ave., Spokane"
  },
  {
    "id": 2894,
    "financing": "Federally subsidized",
    "building_name": "Pine Terrace",
    "latitude": 47.199371,
    "longitude": -120.95686,
    "original_address": "906 W. 2nd St.",
    "building_number": 906,
    "street": "W 2nd St",
    "city": "Cle Elum",
    "zip": 98922,
    "concatenated_address": "906 W 2nd St, Cle Elum",
    "address": "906 W. 2nd St., Cle Elum"
  },
  {
    "id": 2895,
    "financing": "Federally subsidized",
    "building_name": "Pine Tree Harbor Apartments",
    "latitude": 47.238,
    "longitude": -122.44232,
    "original_address": "2501 South G Street",
    "building_number": 2501,
    "street": "S G St",
    "city": "Tacoma",
    "zip": 98405,
    "concatenated_address": "2501 S G St, Tacoma",
    "address": "2501 S. G St., Tacoma"
  },
  {
    "id": 2896,
    "financing": "Federally subsidized",
    "building_name": "Pinecrest Apartments",
    "latitude": 46.247948,
    "longitude": -119.12185,
    "original_address": "2315 W Jay St",
    "building_number": 2315,
    "street": "W Jay St",
    "city": "Pasco",
    "zip": 99301,
    "concatenated_address": "2315 W Jay St, Pasco",
    "address": "2315 W. Jay St., Pasco"
  },
  {
    "id": 2897,
    "financing": "Federally subsidized",
    "building_name": "Pinecrest Apartments",
    "latitude": 47.348612,
    "longitude": -122.30819,
    "original_address": "28118 19th Pl S",
    "building_number": 28118,
    "street": "19th Pl S",
    "city": "Federal Way",
    "zip": 98003,
    "concatenated_address": "28118 19th Pl S, Federal Way",
    "address": "28118 19th Pl S., Federal Way"
  },
  {
    "id": 2898,
    "financing": "Federally subsidized",
    "building_name": "Pineridge Court II",
    "latitude": 47.735982,
    "longitude": -117.41017,
    "original_address": "40 E Pineridge Ct",
    "building_number": 40,
    "street": "E Pineridge Ct",
    "city": "Spokane",
    "zip": 99208,
    "concatenated_address": "40 E Pineridge Ct, Spokane",
    "address": "40 E. Pineridge Ct, Spokane"
  },
  {
    "id": 2899,
    "financing": "Federally subsidized",
    "building_name": "Pioneer Lane Apartments",
    "latitude": 48.423532,
    "longitude": -119.51062,
    "original_address": "806 Shumway Rd",
    "building_number": 806,
    "street": "Shumway Rd",
    "city": "Omak",
    "zip": 98841,
    "concatenated_address": "806 Shumway Rd, Omak",
    "address": "806 Shumway Road, Omak"
  },
  {
    "id": 2900,
    "financing": "Federally subsidized",
    "building_name": "Pioneer Lane I Apartments",
    "latitude": 48.423532,
    "longitude": -119.51062,
    "original_address": "806 Shumway Road",
    "building_number": 806,
    "street": "Shumway Rd",
    "city": "Omak",
    "zip": 98841,
    "concatenated_address": "806 Shumway Rd, Omak",
    "address": "806 Shumway Road, Omak"
  },
  {
    "id": 2901,
    "financing": "Federally subsidized",
    "building_name": "Pioneer Lane II Apartments",
    "latitude": 48.423685,
    "longitude": -119.50579,
    "original_address": "906 Shumway Road",
    "building_number": 906,
    "street": "Shumway Rd",
    "city": "Omak",
    "zip": 98841,
    "concatenated_address": "906 Shumway Rd, Omak",
    "address": "906 Shumway Road, Omak"
  },
  {
    "id": 2902,
    "financing": "Federally subsidized",
    "building_name": "Pioneer Park",
    "latitude": 46.655536,
    "longitude": -118.8566,
    "original_address": "401 E Elm",
    "building_number": 401,
    "street": "E Elm Rd",
    "city": "Connell",
    "zip": 99326,
    "concatenated_address": "401 E Elm Rd, Connell",
    "address": "401 E. Elm Road, Connell"
  },
  {
    "id": 2903,
    "financing": "Federally subsidized",
    "building_name": "Pioneer Park",
    "latitude": 46.655536,
    "longitude": -118.8566,
    "original_address": "401 East Elm",
    "building_number": 401,
    "street": "E Elm Rd",
    "city": "Connell",
    "zip": 99326,
    "concatenated_address": "401 E Elm Rd, Connell",
    "address": "401 E. Elm Road, Connell"
  },
  {
    "id": 2904,
    "financing": "Federally subsidized",
    "building_name": "Pioneer Park",
    "latitude": 47.319581,
    "longitude": -122.21732,
    "original_address": "950 14th Street Northeast",
    "building_number": 950,
    "street": "14th St NE",
    "city": "Auburn",
    "zip": 98002,
    "concatenated_address": "950 14th St NE, Auburn",
    "address": "950 14th St. N.E., Auburn"
  },
  {
    "id": 2905,
    "financing": "Federally subsidized",
    "building_name": "Pioneer Park Place",
    "latitude": 47.649555,
    "longitude": -117.41898,
    "original_address": "424 West 7th Avenue",
    "building_number": 424,
    "street": "W 7th Ave",
    "city": "Spokane",
    "zip": 99204,
    "concatenated_address": "424 W 7th Ave, Spokane",
    "address": "424 W. 7th Ave., Spokane"
  },
  {
    "id": 2906,
    "financing": "Federally subsidized",
    "building_name": "Pioneer Square Apartments",
    "latitude": 46.728763,
    "longitude": -117.18013,
    "original_address": "220 Se Kamiaken St.",
    "building_number": 220,
    "street": "SE Kamiaken St",
    "city": "Pullman",
    "zip": 99163,
    "concatenated_address": "220 SE Kamiaken St, Pullman",
    "address": "220 S.E. Kamiaken St., Pullman"
  },
  {
    "id": 2907,
    "financing": "Federally subsidized",
    "building_name": "Pioneer Village Apartments",
    "latitude": 46.373381,
    "longitude": -120.32059,
    "original_address": "719 West Third",
    "building_number": 719,
    "street": "W 3rd Ave",
    "city": "Toppenish",
    "zip": 98948,
    "concatenated_address": "719 W 3rd Ave, Toppenish",
    "address": "719 W. 3rd Ave., Toppenish"
  },
  {
    "id": 2908,
    "financing": "Federally subsidized",
    "building_name": "Pioneer Village Retirement Community",
    "latitude": 47.113229,
    "longitude": -119.26415,
    "original_address": "816 E Sharon Ave",
    "building_number": 816,
    "street": "E Sharon Ave",
    "city": "Moses Lake",
    "zip": "98837-2442",
    "concatenated_address": "816 E Sharon Ave, Moses Lake",
    "address": "816 E. Sharon Ave., Moses Lake"
  },
  {
    "id": 2909,
    "financing": "Federally subsidized",
    "building_name": "Pivotal Point Apartments",
    "latitude": 48.002235,
    "longitude": -122.19861,
    "original_address": "1120 Rainier Avenue",
    "building_number": 1120,
    "street": "Rainier Ave",
    "city": "Everett",
    "zip": 98201,
    "concatenated_address": "1120 Rainier Ave, Everett",
    "address": "1120 Rainier Ave., Everett"
  },
  {
    "id": 2910,
    "financing": "Federally subsidized",
    "building_name": "Plaza Roberto Maestas",
    "latitude": 47.579725,
    "longitude": -122.31182,
    "original_address": "2602 16th Avenue South",
    "building_number": 2602,
    "street": "16th Ave S",
    "city": "Seattle",
    "zip": 98144,
    "concatenated_address": "2602 16th Ave S, Seattle",
    "address": "2602 16th Ave. S., Seattle"
  },
  {
    "id": 2911,
    "financing": "Federally subsidized",
    "building_name": "Plum Court Apartments",
    "latitude": 47.672574,
    "longitude": -122.19968,
    "original_address": "451 4th Avenue South",
    "building_number": 451,
    "street": "4th Ave S",
    "city": "Kirkland",
    "zip": 98033,
    "concatenated_address": "451 4th Ave S, Kirkland",
    "address": "451 4th Ave. S., Kirkland"
  },
  {
    "id": 2912,
    "financing": "Federally subsidized",
    "building_name": "Plum Court Family Apartments",
    "latitude": 47.672574,
    "longitude": -122.19968,
    "original_address": "451 4th Avenue South",
    "building_number": 451,
    "street": "4th Ave S",
    "city": "Kirkland",
    "zip": 98033,
    "concatenated_address": "451 4th Ave S, Kirkland",
    "address": "451 4th Ave. S., Kirkland"
  },
  {
    "id": 2913,
    "financing": "Federally subsidized",
    "building_name": "Plum Meadows Apartments",
    "latitude": 45.645391,
    "longitude": -122.69146,
    "original_address": "1919 W 34th Street",
    "building_number": 1919,
    "street": "W 34th St",
    "city": "Vancouver",
    "zip": 98660,
    "concatenated_address": "1919 W 34th St, Vancouver",
    "address": "1919 W. 34th St., Vancouver"
  },
  {
    "id": 2914,
    "financing": "Federally subsidized",
    "building_name": "Plymouth On First Hill",
    "latitude": 47.605621,
    "longitude": -122.32742,
    "original_address": "710 Cherry Street",
    "building_number": 710,
    "street": "Cherry St",
    "city": "Seattle",
    "zip": 98104,
    "concatenated_address": "710 Cherry St, Seattle",
    "address": "710 Cherry St., Seattle"
  },
  {
    "id": 2915,
    "financing": "Federally subsidized",
    "building_name": "Plymouth On Stewart",
    "latitude": 47.610849,
    "longitude": -122.34087,
    "original_address": "116 Stewart Street",
    "building_number": 116,
    "street": "Stewart St",
    "city": "Seattle",
    "zip": 98101,
    "concatenated_address": "116 Stewart St, Seattle",
    "address": "116 Stewart St., Seattle"
  },
  {
    "id": 2916,
    "financing": "Federally subsidized",
    "building_name": "Plymouth Place",
    "latitude": 47.618327,
    "longitude": -122.35556,
    "original_address": "94 Bay Street",
    "building_number": 94,
    "street": "Bay St",
    "city": "Seattle",
    "zip": 98121,
    "concatenated_address": "94 Bay St, Seattle",
    "address": "94 Bay St., Seattle"
  },
  {
    "id": 2917,
    "financing": "Federally subsidized",
    "building_name": "Polaris Apartments",
    "latitude": 47.755918,
    "longitude": -122.31599,
    "original_address": "1220 Ne 175th Street",
    "building_number": 1220,
    "street": "NE 175th St",
    "city": "Seattle",
    "zip": 98155,
    "concatenated_address": "1220 NE 175th St, Seattle",
    "address": "1220 N.E. 175th St., Seattle"
  },
  {
    "id": 2918,
    "financing": "Federally subsidized",
    "building_name": "Polaris At Covington",
    "latitude": 47.355291,
    "longitude": -122.11431,
    "original_address": "17110 Se 276th Street",
    "building_number": 17110,
    "street": "SE 276th St",
    "city": "Kent",
    "zip": 98042,
    "concatenated_address": "17110 SE 276th St, Kent",
    "address": "17110 S.E. 276th St., Kent"
  },
  {
    "id": 2919,
    "financing": "Federally subsidized",
    "building_name": "Ponderosa Apartments",
    "latitude": 47.615526,
    "longitude": -122.30853,
    "original_address": "1602 18th Avenue",
    "building_number": 1602,
    "street": "18th Ave",
    "city": "Seattle",
    "zip": 98122,
    "concatenated_address": "1602 18th Ave, Seattle",
    "address": "1602 18th Ave., Seattle"
  },
  {
    "id": 2920,
    "financing": "Federally subsidized",
    "building_name": "Pope Francis Haven",
    "latitude": 47.656105,
    "longitude": -117.1844,
    "original_address": "16412 Sprague Avenue",
    "building_number": 16412,
    "street": "E Sprague Ave",
    "city": "Veradale",
    "zip": 99037,
    "concatenated_address": "16412 E Sprague Ave, Veradale",
    "address": "16412 E. Sprague Ave., Veradale"
  },
  {
    "id": 2921,
    "financing": "Federally subsidized",
    "building_name": "Port Hadlock Garden Court Apartments",
    "latitude": 48.031078,
    "longitude": -122.76264,
    "original_address": "61 Garden Court Road",
    "building_number": 61,
    "street": "Garden Ct",
    "city": "Port Hadlock",
    "zip": 98339,
    "concatenated_address": "61 Garden Ct, Port Hadlock",
    "address": "61 Garden Ct, Port Hadlock"
  },
  {
    "id": 2922,
    "financing": "Federally subsidized",
    "building_name": "Port Orchard Vista",
    "latitude": 47.535334,
    "longitude": -122.62593,
    "original_address": "900 Mitchell Ave",
    "building_number": 900,
    "street": "Mitchell Ave",
    "city": "Port Orchard",
    "zip": 98366,
    "concatenated_address": "900 Mitchell Ave, Port Orchard",
    "address": "900 Mitchell Ave., Port Orchard"
  },
  {
    "id": 2923,
    "financing": "Federally subsidized",
    "building_name": "Post Alley Court",
    "latitude": 47.607762,
    "longitude": -122.34008,
    "original_address": "1406 Western Ave",
    "building_number": 1406,
    "street": "Western Ave",
    "city": "Seattle",
    "zip": 98101,
    "concatenated_address": "1406 Western Ave, Seattle",
    "address": "1406 Western Ave., Seattle"
  },
  {
    "id": 2924,
    "financing": "Federally subsidized",
    "building_name": "Prabucki Project",
    "latitude": 47.591862,
    "longitude": -122.29643,
    "original_address": "2727 S Judkins St",
    "building_number": 2727,
    "street": "S Judkins St",
    "city": "Seattle",
    "zip": 98144,
    "concatenated_address": "2727 S Judkins St, Seattle",
    "address": "2727 S. Judkins St., Seattle"
  },
  {
    "id": 2925,
    "financing": "Federally subsidized",
    "building_name": "Prairie Run Apartments",
    "latitude": 46.952219,
    "longitude": -122.62321,
    "original_address": "205 Mountain View Rd Se",
    "building_number": 205,
    "street": "Mountain View Rd SE",
    "city": "Yelm",
    "zip": 98597,
    "concatenated_address": "205 Mountain View Rd SE, Yelm",
    "address": "205 Mountain View Road S.E., Yelm"
  },
  {
    "id": 2926,
    "financing": "Federally subsidized",
    "building_name": "Prairie View Apartment Homes",
    "latitude": 45.692465,
    "longitude": -122.54191,
    "original_address": "12611 Ne 99th St",
    "building_number": 12611,
    "street": "NE 99th St",
    "city": "Vancouver",
    "zip": "98682-2431",
    "concatenated_address": "12611 NE 99th St, Vancouver",
    "address": "12611 N.E. 99th St., Vancouver"
  },
  {
    "id": 2927,
    "financing": "Federally subsidized",
    "building_name": "Priest Rapids Apartments",
    "latitude": 46.734248,
    "longitude": -119.8949,
    "original_address": "850 3rd Place",
    "building_number": 850,
    "street": "3rd Pl",
    "city": "Mattawa",
    "zip": 99349,
    "concatenated_address": "850 3rd Pl, Mattawa",
    "address": "850 3rd Place, Mattawa"
  },
  {
    "id": 2928,
    "financing": "Federally subsidized",
    "building_name": "Prince Court Apartments",
    "latitude": 48.791861,
    "longitude": -122.4795,
    "original_address": "214 Prince Ave",
    "building_number": 214,
    "street": "Prince Ave",
    "city": "Bellingham",
    "zip": 98226,
    "concatenated_address": "214 Prince Ave, Bellingham",
    "address": "214 Prince Ave., Bellingham"
  },
  {
    "id": 2929,
    "financing": "Federally subsidized",
    "building_name": "Promenade Apartments",
    "latitude": 47.322424,
    "longitude": -122.16959,
    "original_address": "31021 129th Avenue Se",
    "building_number": 31021,
    "street": "129th Ave SE",
    "city": "Auburn",
    "zip": 98092,
    "concatenated_address": "31021 129th Ave SE, Auburn",
    "address": "31021 129th Ave. S.E., Auburn"
  },
  {
    "id": 2930,
    "financing": "Federally subsidized",
    "building_name": "Prosser Gardens Apartments",
    "latitude": 46.206094,
    "longitude": -119.75189,
    "original_address": "900 Alexander Court",
    "building_number": 900,
    "street": "Alexander Ct",
    "city": "Prosser",
    "zip": 99350,
    "concatenated_address": "900 Alexander Ct, Prosser",
    "address": "900 Alexander Ct, Prosser"
  },
  {
    "id": 2931,
    "financing": "Federally subsidized",
    "building_name": "Prosser Manor",
    "latitude": 46.206985,
    "longitude": -119.76688,
    "original_address": "1403 Meade Ave.",
    "building_number": 1403,
    "street": "Meade Ave",
    "city": "Prosser",
    "zip": 99350,
    "concatenated_address": "1403 Meade Ave, Prosser",
    "address": "1403 Meade Ave., Prosser"
  },
  {
    "id": 2932,
    "financing": "Federally subsidized",
    "building_name": "Providence Elizabeth House",
    "latitude": 47.546428,
    "longitude": -122.37373,
    "original_address": "3201 Sw Graham",
    "building_number": 3201,
    "street": "SW Graham St",
    "city": "Seattle",
    "zip": 98126,
    "concatenated_address": "3201 SW Graham St, Seattle",
    "address": "3201 S.W. Graham St., Seattle"
  },
  {
    "id": 2933,
    "financing": "Federally subsidized",
    "building_name": "Providence Gamelin House",
    "latitude": 47.562227,
    "longitude": -122.29471,
    "original_address": "4515 Martin Luther King Jr. Way S",
    "building_number": 4515,
    "street": "Martin Luther King Jr Way S",
    "city": "Seattle",
    "zip": 98108,
    "concatenated_address": "4515 Martin Luther King Jr Way S, Seattle",
    "address": "4515 Martin Luther King Jr Way S., Seattle"
  },
  {
    "id": 2934,
    "financing": "Federally subsidized",
    "building_name": "Providence John Gabriel House",
    "latitude": 47.679666,
    "longitude": -122.1272,
    "original_address": "8632 160th Avenue Ne",
    "building_number": 8632,
    "street": "160th Ave NE",
    "city": "Redmond",
    "zip": 98052,
    "concatenated_address": "8632 160th Ave NE, Redmond",
    "address": "8632 160th Ave. N.E., Redmond"
  },
  {
    "id": 2935,
    "financing": "Federally subsidized",
    "building_name": "Providence Joseph House",
    "latitude": 47.502773,
    "longitude": -122.34113,
    "original_address": "11215 5th Avenue Sw",
    "building_number": 11215,
    "street": "5th Ave SW",
    "city": "Seattle",
    "zip": 98146,
    "concatenated_address": "11215 5th Ave SW, Seattle",
    "address": "11215 5th Ave. S.W., Seattle"
  },
  {
    "id": 2936,
    "financing": "Federally subsidized",
    "building_name": "Providence Peter Claver House",
    "latitude": 47.538714,
    "longitude": -122.28511,
    "original_address": "7101 38th Avenue South",
    "building_number": 7101,
    "street": "38th Ave S",
    "city": "Seattle",
    "zip": 98118,
    "concatenated_address": "7101 38th Ave S, Seattle",
    "address": "7101 38th Ave. S., Seattle"
  },
  {
    "id": 2937,
    "financing": "Federally subsidized",
    "building_name": "Pueblo Del Rio",
    "latitude": 45.742008,
    "longitude": -120.21811,
    "original_address": "306 Chinook Avenue",
    "building_number": 306,
    "street": "Chinook Ave",
    "city": "Roosevelt",
    "zip": 99356,
    "concatenated_address": "306 Chinook Ave, Roosevelt",
    "address": "306 Chinook Ave., Roosevelt"
  },
  {
    "id": 2938,
    "financing": "Federally subsidized",
    "building_name": "Puget Street",
    "latitude": 48.746174,
    "longitude": -122.45626,
    "original_address": "1337 Puget St",
    "building_number": 1337,
    "street": "Puget St",
    "city": "Bellingham",
    "zip": 98229,
    "concatenated_address": "1337 Puget St, Bellingham",
    "address": "1337 Puget St., Bellingham"
  },
  {
    "id": 2939,
    "financing": "Federally subsidized",
    "building_name": "Purple Sage Apartments Ephrata",
    "latitude": 47.308068,
    "longitude": -119.54886,
    "original_address": "693 Hilltop Drive",
    "building_number": 693,
    "street": "Hilltop Dr",
    "city": "Ephrata",
    "zip": 98823,
    "concatenated_address": "693 Hilltop Dr, Ephrata",
    "address": "693 Hilltop Drive, Ephrata"
  },
  {
    "id": 2940,
    "financing": "Federally subsidized",
    "building_name": "Purple Sage Apartments Quincy",
    "latitude": 47.229132,
    "longitude": -119.85462,
    "original_address": "1112 1st Avenue Sw",
    "building_number": 1112,
    "street": "1st Ave SW",
    "city": "Quincy",
    "zip": 98848,
    "concatenated_address": "1112 1st Ave SW, Quincy",
    "address": "1112 1st Ave. S.W., Quincy"
  },
  {
    "id": 2941,
    "financing": "Federally subsidized",
    "building_name": "Quail Ridge Apartments",
    "latitude": 46.19864,
    "longitude": -119.13192,
    "original_address": "1026 West 10th Ave.",
    "building_number": 1026,
    "street": "W 10th Ave",
    "city": "Kennewick",
    "zip": 99336,
    "concatenated_address": "1026 W 10th Ave, Kennewick",
    "address": "1026 W. 10th Ave., Kennewick"
  },
  {
    "id": 2942,
    "financing": "Federally subsidized",
    "building_name": "Quail Run Apartments",
    "latitude": 45.615469,
    "longitude": -122.52886,
    "original_address": "701 Se 139th Ave",
    "building_number": 701,
    "street": "SE 139th Ave",
    "city": "Vancouver",
    "zip": "98684-3556",
    "concatenated_address": "701 SE 139th Ave, Vancouver",
    "address": "701 S.E. 139th Ave., Vancouver"
  },
  {
    "id": 2943,
    "financing": "Federally subsidized",
    "building_name": "Quail Run Apartments (Vancouver)",
    "latitude": 45.615469,
    "longitude": -122.52886,
    "original_address": "701 Se 139th Ave",
    "building_number": 701,
    "street": "SE 139th Ave",
    "city": "Vancouver",
    "zip": 98683,
    "concatenated_address": "701 SE 139th Ave, Vancouver",
    "address": "701 S.E. 139th Ave., Vancouver"
  },
  {
    "id": 2944,
    "financing": "Federally subsidized",
    "building_name": "Quail Run I & II Apartments",
    "latitude": 47.234662,
    "longitude": -119.84838,
    "original_address": "215 D St. Se",
    "building_number": 215,
    "street": "D St SE",
    "city": "Quincy",
    "zip": 98848,
    "concatenated_address": "215 D St SE, Quincy",
    "address": "215 D St. S.E., Quincy"
  },
  {
    "id": 2945,
    "financing": "Federally subsidized",
    "building_name": "Queen Anne Gardens",
    "latitude": 47.631194,
    "longitude": -122.34728,
    "original_address": "1250 Fifth Avenue N",
    "building_number": 1250,
    "street": "5th Ave N",
    "city": "Seattle",
    "zip": 98109,
    "concatenated_address": "1250 5th Ave N, Seattle",
    "address": "1250 5th Ave. N., Seattle"
  },
  {
    "id": 2946,
    "financing": "Federally subsidized",
    "building_name": "Qui Nai Elt Homes I",
    "latitude": 47.25521,
    "longitude": -124.19248,
    "original_address": "112 Qui Nai Elt Village Drive",
    "building_number": 112,
    "street": "Quinaielt Village Dr",
    "city": "Taholah",
    "zip": 98587,
    "concatenated_address": "112 Quinaielt Village Dr, Taholah",
    "address": "112 Quinaielt Village Drive, Taholah"
  },
  {
    "id": 2947,
    "financing": "Federally subsidized",
    "building_name": "Quilceda Creek Apartments",
    "latitude": 48.103369,
    "longitude": -122.17589,
    "original_address": "11923 Smokey Point Blvd",
    "building_number": 11923,
    "street": "Smokey Point Blvd",
    "city": "Marysville",
    "zip": 98271,
    "concatenated_address": "11923 Smokey Point Blvd, Marysville",
    "address": "11923 Smokey Point Blvd., Marysville"
  },
  {
    "id": 2948,
    "financing": "Federally subsidized",
    "building_name": "Quincy Manor",
    "latitude": 47.234216,
    "longitude": -119.85832,
    "original_address": "201 D Street Sw",
    "building_number": 201,
    "street": "D St SW",
    "city": "Quincy",
    "zip": 98848,
    "concatenated_address": "201 D St SW, Quincy",
    "address": "201 D St. S.W., Quincy"
  },
  {
    "id": 2949,
    "financing": "Federally subsidized",
    "building_name": "Quincy Vista Apartments",
    "latitude": 47.234633,
    "longitude": -119.85146,
    "original_address": "119 D Street Se",
    "building_number": 119,
    "street": "D St SE",
    "city": "Quincy",
    "zip": 98848,
    "concatenated_address": "119 D St SE, Quincy",
    "address": "119 D St. S.E., Quincy"
  },
  {
    "id": 2950,
    "financing": "Federally subsidized",
    "building_name": "Quintessa Apartments",
    "latitude": 47.601605,
    "longitude": -122.33134,
    "original_address": "201 Yesler Way",
    "building_number": 201,
    "street": "Yesler Way",
    "city": "Seattle",
    "zip": 98104,
    "concatenated_address": "201 Yesler Way, Seattle",
    "address": "201 Yesler Way, Seattle"
  },
  {
    "id": 2951,
    "financing": "Federally subsidized",
    "building_name": "Radcliffe Place",
    "latitude": 47.359223,
    "longitude": -122.16051,
    "original_address": "13510 Se 272nd St",
    "building_number": 13510,
    "street": "SE 272nd St",
    "city": "Kent",
    "zip": 98042,
    "concatenated_address": "13510 SE 272nd St, Kent",
    "address": "13510 S.E. 272nd St., Kent"
  },
  {
    "id": 2952,
    "financing": "Federally subsidized",
    "building_name": "Rainbow Park",
    "latitude": 47.072903,
    "longitude": -123.26861,
    "original_address": "140 N. Summit Rd.",
    "building_number": 140,
    "street": "N Summit Rd",
    "city": "McCleary",
    "zip": 98557,
    "concatenated_address": "140 N Summit Rd, McCleary",
    "address": "140 N. Summit Road, McCleary"
  },
  {
    "id": 2953,
    "financing": "Federally subsidized",
    "building_name": "Rainier Apartments",
    "latitude": 46.942137,
    "longitude": -122.60945,
    "original_address": "202 Edwards Street Sw",
    "building_number": 202,
    "street": "Edwards St SW",
    "city": "Yelm",
    "zip": 98597,
    "concatenated_address": "202 Edwards St SW, Yelm",
    "address": "202 Edwards St. S.W., Yelm"
  },
  {
    "id": 2954,
    "financing": "Federally subsidized",
    "building_name": "Rainier Glen Apartments",
    "latitude": 47.197038,
    "longitude": -121.97714,
    "original_address": "739 N Watson St",
    "building_number": 739,
    "street": "Watson St N",
    "city": "Enumclaw",
    "zip": 98022,
    "concatenated_address": "739 Watson St N, Enumclaw",
    "address": "739 Watson St. N., Enumclaw"
  },
  {
    "id": 2955,
    "financing": "Federally subsidized",
    "building_name": "Rainier House",
    "latitude": 47.554353,
    "longitude": -122.28119,
    "original_address": "5270 Rainier Avenue S",
    "building_number": 5270,
    "street": "Rainier Ave S",
    "city": "Seattle",
    "zip": 98124,
    "concatenated_address": "5270 Rainier Ave S, Seattle",
    "address": "5270 Rainier Ave. S., Seattle"
  },
  {
    "id": 2956,
    "financing": "Federally subsidized",
    "building_name": "Rainier Park",
    "latitude": 46.327139,
    "longitude": -120.0021,
    "original_address": "120 South 13Th St.",
    "building_number": 120,
    "street": "S 13th St",
    "city": "Sunnyside",
    "zip": 98944,
    "concatenated_address": "120 S 13th St, Sunnyside",
    "address": "120 S. 13th St., Sunnyside"
  },
  {
    "id": 2957,
    "financing": "Federally subsidized",
    "building_name": "Rainier View Apartments",
    "latitude": 47.18806,
    "longitude": -122.28896,
    "original_address": "400 4th Avenue Southeast",
    "building_number": 400,
    "street": "4th Ave SE",
    "city": "Puyallup",
    "zip": 98372,
    "concatenated_address": "400 4th Ave SE, Puyallup",
    "address": "400 4th Ave. S.E., Puyallup"
  },
  {
    "id": 2958,
    "financing": "Federally subsidized",
    "building_name": "Rainier View Senior Apartments",
    "latitude": 47.243621,
    "longitude": -122.34832,
    "original_address": "1410 62nd Avenue E",
    "building_number": 1410,
    "street": "62nd Ave E",
    "city": "Tacoma",
    "zip": 98424,
    "concatenated_address": "1410 62nd Ave E, Tacoma",
    "address": "1410 62nd Ave. E., Tacoma"
  },
  {
    "id": 2959,
    "financing": "Federally subsidized",
    "building_name": "Rainier Views I, II & Si View",
    "latitude": 47.192183,
    "longitude": -122.00437,
    "original_address": "2745 Warner Ave",
    "building_number": 2745,
    "street": "Warner Ave",
    "city": "Enumclaw",
    "zip": 98022,
    "concatenated_address": "2745 Warner Ave, Enumclaw",
    "address": "2745 Warner Ave., Enumclaw"
  },
  {
    "id": 2960,
    "financing": "Federally subsidized",
    "building_name": "Rainier Vista Northeast",
    "latitude": 47.56598,
    "longitude": -122.29631,
    "original_address": "4112 Martin Luther King, Jr. Way South",
    "building_number": 4112,
    "street": "Martin Luther King Jr Way S",
    "city": "Seattle",
    "zip": 98108,
    "concatenated_address": "4112 Martin Luther King Jr Way S, Seattle",
    "address": "4112 Martin Luther King Jr Way S., Seattle"
  },
  {
    "id": 2961,
    "financing": "Federally subsidized",
    "building_name": "Rainier Vista Phase I",
    "latitude": 47.534862,
    "longitude": -122.30579,
    "original_address": "2917 So Snoqualmie St., Suite 103",
    "building_number": "",
    "street": "",
    "city": "Seattle",
    "zip": 98108,
    "concatenated_address": "2917 So Snoqualmie St., Suite 103, Seattle",
    "address": "2917 So Snoqualmie St., Suite 103, Seattle"
  },
  {
    "id": 2962,
    "financing": "Federally subsidized",
    "building_name": "Rainier Vista Senior Apartments",
    "latitude": 47.263452,
    "longitude": -122.24756,
    "original_address": "134 Third Avenue Se",
    "building_number": 134,
    "street": "3rd Ave SE",
    "city": "Pacific",
    "zip": "98092-3127",
    "concatenated_address": "134 3rd Ave SE, Pacific",
    "address": "134 3rd Ave. S.E., Pacific"
  },
  {
    "id": 2963,
    "financing": "Federally subsidized",
    "building_name": "Raspberry Ridge",
    "latitude": 48.47504,
    "longitude": -122.30483,
    "original_address": "20340 Sanchez Lane",
    "building_number": 20340,
    "street": "Sanchez Ln",
    "city": "Burlington",
    "zip": 98233,
    "concatenated_address": "20340 Sanchez Ln, Burlington",
    "address": "20340 Sanchez Lane, Burlington"
  },
  {
    "id": 2964,
    "financing": "Federally subsidized",
    "building_name": "Raspberry Ridge II",
    "latitude": 48.478172,
    "longitude": -122.3035,
    "original_address": "20282 Lafayette Rd",
    "building_number": 20282,
    "street": "Lafayette Rd",
    "city": "Burlington",
    "zip": 98233,
    "concatenated_address": "20282 Lafayette Rd, Burlington",
    "address": "20282 Lafayette Road, Burlington"
  },
  {
    "id": 2965,
    "financing": "Federally subsidized",
    "building_name": "Raven Terrace",
    "latitude": 47.601958,
    "longitude": -122.32205,
    "original_address": "820 Yesler Way",
    "building_number": 820,
    "street": "Yesler Way",
    "city": "Seattle",
    "zip": 98122,
    "concatenated_address": "820 Yesler Way, Seattle",
    "address": "820 Yesler Way, Seattle"
  },
  {
    "id": 2966,
    "financing": "Federally subsidized",
    "building_name": "Ravenna School",
    "latitude": 47.677269,
    "longitude": -122.30448,
    "original_address": "6545 Ravenna Avenue Ne",
    "building_number": 6545,
    "street": "Ravenna Ave NE",
    "city": "Seattle",
    "zip": "98115-7095",
    "concatenated_address": "6545 Ravenna Ave NE, Seattle",
    "address": "6545 Ravenna Ave. N.E., Seattle"
  },
  {
    "id": 2967,
    "financing": "Federally subsidized",
    "building_name": "Raymond House Apartments",
    "latitude": 46.686407,
    "longitude": -123.73542,
    "original_address": "331 First Street",
    "building_number": 331,
    "street": "1st St",
    "city": "Raymond",
    "zip": 98577,
    "concatenated_address": "331 1st St, Raymond",
    "address": "331 1st St., Raymond"
  },
  {
    "id": 2968,
    "financing": "Federally subsidized",
    "building_name": "Raymond Manor",
    "latitude": 46.687416,
    "longitude": -123.72994,
    "original_address": "434 6th Street",
    "building_number": 434,
    "street": "6th St",
    "city": "Raymond",
    "zip": 98577,
    "concatenated_address": "434 6th St, Raymond",
    "address": "434 6th St., Raymond"
  },
  {
    "id": 2969,
    "financing": "Federally subsidized",
    "building_name": "Redwood Juniper Apartments",
    "latitude": 47.276109,
    "longitude": -122.51471,
    "original_address": "3015 N Pearl Street",
    "building_number": 3015,
    "street": "N Pearl St",
    "city": "Tacoma",
    "zip": 98407,
    "concatenated_address": "3015 N Pearl St, Tacoma",
    "address": "3015 N. Pearl St., Tacoma"
  },
  {
    "id": 2970,
    "financing": "Federally subsidized",
    "building_name": "Regal Arms",
    "latitude": 47.695257,
    "longitude": -117.36773,
    "original_address": "4102 N. Regal Street",
    "building_number": 4102,
    "street": "N Regal St",
    "city": "Spokane",
    "zip": 99207,
    "concatenated_address": "4102 N Regal St, Spokane",
    "address": "4102 N. Regal St., Spokane"
  },
  {
    "id": 2971,
    "financing": "Federally subsidized",
    "building_name": "Regency Park",
    "latitude": 48.751504,
    "longitude": -122.44916,
    "original_address": "2050 Fraser Street",
    "building_number": 2050,
    "street": "Fraser St",
    "city": "Bellingham",
    "zip": "98226-3796",
    "concatenated_address": "2050 Fraser St, Bellingham",
    "address": "2050 Fraser St., Bellingham"
  },
  {
    "id": 2972,
    "financing": "Federally subsidized",
    "building_name": "Reino Del Cielo",
    "latitude": 46.903134,
    "longitude": -119.6203,
    "original_address": "440 Cherry Street Northeast",
    "building_number": 440,
    "street": "Cherry St NE",
    "city": "Royal City",
    "zip": 99357,
    "concatenated_address": "440 Cherry St NE, Royal City",
    "address": "440 Cherry St. N.E., Royal City"
  },
  {
    "id": 2973,
    "financing": "Federally subsidized",
    "building_name": "Reliable Homes",
    "latitude": 46.741089,
    "longitude": -122.99572,
    "original_address": "2207 Harrison Avenue",
    "building_number": 2207,
    "street": "Harrison Ave",
    "city": "Centralia",
    "zip": 98531,
    "concatenated_address": "2207 Harrison Ave, Centralia",
    "address": "2207 Harrison Ave., Centralia"
  },
  {
    "id": 2974,
    "financing": "Federally subsidized",
    "building_name": "Rembrandt",
    "latitude": 47.261525,
    "longitude": -122.445,
    "original_address": "219 Street Helens Ave",
    "building_number": 219,
    "street": "St Helens Ave",
    "city": "Tacoma",
    "zip": 98402,
    "concatenated_address": "219 St Helens Ave, Tacoma",
    "address": "219 St. Helens Ave., Tacoma"
  },
  {
    "id": 2975,
    "financing": "Federally subsidized",
    "building_name": "Renton Family Housing",
    "latitude": 47.500191,
    "longitude": -122.17853,
    "original_address": "1000 Jefferson Avenue Ne",
    "building_number": 1000,
    "street": "Jefferson Ave NE",
    "city": "Renton",
    "zip": 98055,
    "concatenated_address": "1000 Jefferson Ave NE, Renton",
    "address": "1000 Jefferson Ave. N.E., Renton"
  },
  {
    "id": 2976,
    "financing": "Federally subsidized",
    "building_name": "Republic Gardens",
    "latitude": 48.647621,
    "longitude": -118.73241,
    "original_address": "627 South Madison Ave",
    "building_number": 627,
    "street": "S Madison Ave",
    "city": "Republic",
    "zip": 99166,
    "concatenated_address": "627 S Madison Ave, Republic",
    "address": "627 S. Madison Ave., Republic"
  },
  {
    "id": 2977,
    "financing": "Federally subsidized",
    "building_name": "Rhodena Apartments",
    "latitude": 48.542584,
    "longitude": -117.90735,
    "original_address": "230 S Wynne Street",
    "building_number": 230,
    "street": "S Wynne St",
    "city": "Colville",
    "zip": 99114,
    "concatenated_address": "230 S Wynne St, Colville",
    "address": "230 S. Wynne St., Colville"
  },
  {
    "id": 2978,
    "financing": "Federally subsidized",
    "building_name": "Rhododendron Apartments",
    "latitude": 47.635627,
    "longitude": -122.52293,
    "original_address": "235 High School Road Nw",
    "building_number": 235,
    "street": "High School Rd NW",
    "city": "Bainbridge Island",
    "zip": 98110,
    "concatenated_address": "235 High School Rd NW, Bainbridge Island",
    "address": "235 High School Road N.W., Bainbridge Island"
  },
  {
    "id": 2979,
    "financing": "Federally subsidized",
    "building_name": "Ridgeview Terrace",
    "latitude": 48.432493,
    "longitude": -122.32253,
    "original_address": "1500 William Way",
    "building_number": 1500,
    "street": "Williams Way",
    "city": "Mount Vernon",
    "zip": 98273,
    "concatenated_address": "1500 Williams Way, Mount Vernon",
    "address": "1500 Williams Way, Mount Vernon"
  },
  {
    "id": 2980,
    "financing": "Federally subsidized",
    "building_name": "Rio De Vida",
    "latitude": 46.207755,
    "longitude": -119.78231,
    "original_address": "480 North River Road",
    "building_number": 480,
    "street": "W North River Rd",
    "city": "Prosser",
    "zip": 99350,
    "concatenated_address": "480 W North River Rd, Prosser",
    "address": "480 W. North River Road, Prosser"
  },
  {
    "id": 2981,
    "financing": "Federally subsidized",
    "building_name": "Ritz Apartments, The",
    "latitude": 47.601797,
    "longitude": -122.31473,
    "original_address": "1302 East Yesler Way",
    "building_number": 1302,
    "street": "E Yesler Way",
    "city": "Seattle",
    "zip": 98122,
    "concatenated_address": "1302 E Yesler Way, Seattle",
    "address": "1302 E. Yesler Way, Seattle"
  },
  {
    "id": 2982,
    "financing": "Federally subsidized",
    "building_name": "Rivard Apartments",
    "latitude": 46.552772,
    "longitude": -120.38709,
    "original_address": "306 S. Rivard Road",
    "building_number": 306,
    "street": "S Rivard Rd",
    "city": "Moxee",
    "zip": 98936,
    "concatenated_address": "306 S Rivard Rd, Moxee",
    "address": "306 S. Rivard Road, Moxee"
  },
  {
    "id": 2983,
    "financing": "Federally subsidized",
    "building_name": "Rivard Central Apartments",
    "latitude": 46.587,
    "longitude": -120.50961,
    "original_address": "1004 South 3rd Ave",
    "building_number": 1004,
    "street": "S 3rd Ave",
    "city": "Yakima",
    "zip": 98902,
    "concatenated_address": "1004 S 3rd Ave, Yakima",
    "address": "1004 S. 3rd Ave., Yakima"
  },
  {
    "id": 2984,
    "financing": "Federally subsidized",
    "building_name": "River House Apartments",
    "latitude": 48.935418,
    "longitude": -122.47591,
    "original_address": "101 Kok Road",
    "building_number": "",
    "street": "Kok Rd",
    "city": "Lynden",
    "zip": 98264,
    "concatenated_address": "101 Kok Road, Lynden",
    "address": "101 Kok Road, Lynden"
  },
  {
    "id": 2985,
    "financing": "Federally subsidized",
    "building_name": "River Vista I & II",
    "latitude": 48.200066,
    "longitude": -122.12665,
    "original_address": "106 E Burke Ave",
    "building_number": 106,
    "street": "E Burke Ave",
    "city": "Arlington",
    "zip": 98223,
    "concatenated_address": "106 E Burke Ave, Arlington",
    "address": "106 E. Burke Ave., Arlington"
  },
  {
    "id": 2986,
    "financing": "Federally subsidized",
    "building_name": "Riverbend Village",
    "latitude": 48.174904,
    "longitude": -117.06604,
    "original_address": "1701 West 7th",
    "building_number": 1701,
    "street": "W 7th",
    "city": "Newport",
    "zip": 99156,
    "concatenated_address": "1701 W 7th, Newport",
    "address": "1701 W. 7th, Newport"
  },
  {
    "id": 2987,
    "financing": "Federally subsidized",
    "building_name": "Riverdale Heights",
    "latitude": 46.69553,
    "longitude": -123.74337,
    "original_address": "1220 Willapa St",
    "building_number": 1220,
    "street": "Willapa St",
    "city": "Raymond",
    "zip": 98577,
    "concatenated_address": "1220 Willapa St, Raymond",
    "address": "1220 Willapa St., Raymond"
  },
  {
    "id": 2988,
    "financing": "Federally subsidized",
    "building_name": "Rivergrove Apartments",
    "latitude": 45.777555,
    "longitude": -122.53088,
    "original_address": "617 Se 4th Street.",
    "building_number": 617,
    "street": "SE 4th St",
    "city": "Battle Ground",
    "zip": "98604-8395",
    "concatenated_address": "617 SE 4th St, Battle Ground",
    "address": "617 S.E. 4th St., Battle Ground"
  },
  {
    "id": 2989,
    "financing": "Federally subsidized",
    "building_name": "Riverhouse Senior Apartments",
    "latitude": 48.932328,
    "longitude": -122.43625,
    "original_address": "100 Riverhouse Rd",
    "building_number": "",
    "street": "",
    "city": "Lynden",
    "zip": 98264,
    "concatenated_address": "100 Riverhouse Rd, Lynden",
    "address": "100 Riverhouse Road, Lynden"
  },
  {
    "id": 2990,
    "financing": "Federally subsidized",
    "building_name": "Riverside Landing Apartments",
    "latitude": 47.756934,
    "longitude": -122.20451,
    "original_address": "10130 W Riverside Drive",
    "building_number": 10130,
    "street": "W Riverside Dr",
    "city": "Bothell",
    "zip": "98011-3754",
    "concatenated_address": "10130 W Riverside Dr, Bothell",
    "address": "10130 W. Riverside Drive, Bothell"
  },
  {
    "id": 2991,
    "financing": "Federally subsidized",
    "building_name": "Riverview",
    "latitude": 47.908901,
    "longitude": -122.08821,
    "original_address": "101 Alder Ave",
    "building_number": 101,
    "street": "Alder Ave",
    "city": "Snohomish",
    "zip": 98290,
    "concatenated_address": "101 Alder Ave, Snohomish",
    "address": "101 Alder Ave., Snohomish"
  },
  {
    "id": 2992,
    "financing": "Federally subsidized",
    "building_name": "Riverview Apartments",
    "latitude": 48.365042,
    "longitude": -120.11906,
    "original_address": "401 E. 2nd Ave",
    "building_number": 401,
    "street": "W 2nd Ave",
    "city": "Twisp",
    "zip": 98856,
    "concatenated_address": "401 W 2nd Ave, Twisp",
    "address": "401 W. 2nd Ave., Twisp"
  },
  {
    "id": 2993,
    "financing": "Federally subsidized",
    "building_name": "Riverwalk Point I",
    "latitude": 47.681089,
    "longitude": -117.33653,
    "original_address": "5008 E Buckeye",
    "building_number": 5008,
    "street": "E Buckeye Ave",
    "city": "Spokane",
    "zip": 99217,
    "concatenated_address": "5008 E Buckeye Ave, Spokane",
    "address": "5008 E. Buckeye Ave., Spokane"
  },
  {
    "id": 2994,
    "financing": "Federally subsidized",
    "building_name": "Riverwalk Point II",
    "latitude": 47.681609,
    "longitude": -117.33749,
    "original_address": "4912 E. Buckeye",
    "building_number": 4912,
    "street": "E Buckeye Ave",
    "city": "Spokane",
    "zip": 99217,
    "concatenated_address": "4912 E Buckeye Ave, Spokane",
    "address": "4912 E. Buckeye Ave., Spokane"
  },
  {
    "id": 2995,
    "financing": "Federally subsidized",
    "building_name": "Rivoli Apartments",
    "latitude": 47.612907,
    "longitude": -122.34417,
    "original_address": "2127 Second Ave",
    "building_number": 2127,
    "street": "2nd Ave",
    "city": "Seattle",
    "zip": 98121,
    "concatenated_address": "2127 2nd Ave, Seattle",
    "address": "2127 2nd Ave., Seattle"
  },
  {
    "id": 2996,
    "financing": "Federally subsidized",
    "building_name": "Rock Creek Terrace Apartments",
    "latitude": 45.69313,
    "longitude": -121.88938,
    "original_address": "501 Rock Creek Dr Sw",
    "building_number": 501,
    "street": "Rock Creek Dr",
    "city": "Stevenson",
    "zip": 98648,
    "concatenated_address": "501 Rock Creek Dr, Stevenson",
    "address": "501 Rock Creek Drive, Stevenson"
  },
  {
    "id": 2997,
    "financing": "Federally subsidized",
    "building_name": "Rockwood Terrace",
    "latitude": 45.580573,
    "longitude": -122.37034,
    "original_address": "535 \"C\" Street",
    "building_number": 535,
    "street": "C St",
    "city": "Washougal",
    "zip": "98671-2159",
    "concatenated_address": "535 C St, Washougal",
    "address": "535 C St., Washougal"
  },
  {
    "id": 2998,
    "financing": "Federally subsidized",
    "building_name": "Rose Crest At Talus",
    "latitude": 47.534897,
    "longitude": -122.07241,
    "original_address": "341 Shangri La Way Nw",
    "building_number": 341,
    "street": "Shangri La Way NW",
    "city": "Issaquah",
    "zip": 98027,
    "concatenated_address": "341 Shangri La Way NW, Issaquah",
    "address": "341 Shangri La Way N.W., Issaquah"
  },
  {
    "id": 2999,
    "financing": "Federally subsidized",
    "building_name": "Rose Garden",
    "latitude": 47.308567,
    "longitude": -119.55339,
    "original_address": "1206 Yakima Street Se",
    "building_number": 1206,
    "street": "Yakima St SE",
    "city": "Ephrata",
    "zip": 98823,
    "concatenated_address": "1206 Yakima St SE, Ephrata",
    "address": "1206 Yakima St. S.E., Ephrata"
  },
  {
    "id": 3000,
    "financing": "Federally subsidized",
    "building_name": "Rose Of Mary Terrace",
    "latitude": 46.595083,
    "longitude": -120.58109,
    "original_address": "5401 W. Walnut Street",
    "building_number": 5401,
    "street": "W Walnut St",
    "city": "Yakima",
    "zip": 98908,
    "concatenated_address": "5401 W Walnut St, Yakima",
    "address": "5401 W. Walnut St., Yakima"
  },
  {
    "id": 3001,
    "financing": "Federally subsidized",
    "building_name": "Rose Street Apartments",
    "latitude": 47.529929,
    "longitude": -122.2695,
    "original_address": "8124 Rainier Avenue South",
    "building_number": 8124,
    "street": "Rainier Ave S",
    "city": "Seattle",
    "zip": 98118,
    "concatenated_address": "8124 Rainier Ave S, Seattle",
    "address": "8124 Rainier Ave. S., Seattle"
  },
  {
    "id": 3002,
    "financing": "Federally subsidized",
    "building_name": "Rosehaven Cottages",
    "latitude": 46.059447,
    "longitude": -118.36717,
    "original_address": "1423 Drumheller Street",
    "building_number": 1423,
    "street": "Drumheller St",
    "city": "Walla Walla",
    "zip": 99362,
    "concatenated_address": "1423 Drumheller St, Walla Walla",
    "address": "1423 Drumheller St., Walla Walla"
  },
  {
    "id": 3003,
    "financing": "Federally subsidized",
    "building_name": "Rosewood Apartments",
    "latitude": 48.540906,
    "longitude": -123.02182,
    "original_address": "525 Perry Place",
    "building_number": 525,
    "street": "Perry Pl",
    "city": "Friday Harbor",
    "zip": "98250-7952",
    "concatenated_address": "525 Perry Pl, Friday Harbor",
    "address": "525 Perry Place, Friday Harbor"
  },
  {
    "id": 3004,
    "financing": "Federally subsidized",
    "building_name": "Row Or Townhouse (Multi-Family)",
    "latitude": 47.562762,
    "longitude": -122.29696,
    "original_address": "2831 S Genesee St",
    "building_number": 2831,
    "street": "S Genesee St",
    "city": "Seattle",
    "zip": 98108,
    "concatenated_address": "2831 S Genesee St, Seattle",
    "address": "2831 S. Genesee St., Seattle"
  },
  {
    "id": 3005,
    "financing": "Federally subsidized",
    "building_name": "Royal Crest Apartments",
    "latitude": 46.90821,
    "longitude": -119.62623,
    "original_address": "502 Ahlers Avenue Ne",
    "building_number": 502,
    "street": "Ahlers",
    "city": "Royal City",
    "zip": 99357,
    "concatenated_address": "502 Ahlers, Royal City",
    "address": "502 Ahlers, Royal City"
  },
  {
    "id": 3006,
    "financing": "Federally subsidized",
    "building_name": "Royal Hills Apartments",
    "latitude": 47.468763,
    "longitude": -122.17657,
    "original_address": "3000 Se Royal Hills Drive",
    "building_number": 3000,
    "street": "SE Royal Hills Dr",
    "city": "Renton",
    "zip": 98058,
    "concatenated_address": "3000 SE Royal Hills Dr, Renton",
    "address": "3000 S.E. Royal Hills Drive, Renton"
  },
  {
    "id": 3007,
    "financing": "Federally subsidized",
    "building_name": "Royal Vista",
    "latitude": 47.619524,
    "longitude": -122.30143,
    "original_address": "115 24th Avenue E",
    "building_number": 115,
    "street": "24th Ave E",
    "city": "Seattle",
    "zip": 98112,
    "concatenated_address": "115 24th Ave E, Seattle",
    "address": "115 24th Ave. E., Seattle"
  },
  {
    "id": 3008,
    "financing": "Federally subsidized",
    "building_name": "Russell Road I & II Apartments",
    "latitude": 46.730595,
    "longitude": -122.98836,
    "original_address": "2802 Russell Road",
    "building_number": 2802,
    "street": "Russell Rd",
    "city": "Centralia",
    "zip": 98531,
    "concatenated_address": "2802 Russell Rd, Centralia",
    "address": "2802 Russell Road, Centralia"
  },
  {
    "id": 3009,
    "financing": "Federally subsidized",
    "building_name": "Rutland Woodstock",
    "latitude": 47.263219,
    "longitude": -122.44964,
    "original_address": "711 N First St",
    "building_number": 711,
    "street": "N 1st St",
    "city": "Tacoma",
    "zip": 98403,
    "concatenated_address": "711 N 1st St, Tacoma",
    "address": "711 N. 1st St., Tacoma"
  },
  {
    "id": 3010,
    "financing": "Federally subsidized",
    "building_name": "Sagewood Apartments",
    "latitude": 46.596893,
    "longitude": -120.48111,
    "original_address": "1618 E. Beech Street",
    "building_number": 1618,
    "street": "E Beech St",
    "city": "Yakima",
    "zip": 98901,
    "concatenated_address": "1618 E Beech St, Yakima",
    "address": "1618 E. Beech St., Yakima"
  },
  {
    "id": 3011,
    "financing": "Federally subsidized",
    "building_name": "Sagewood Apartments",
    "latitude": 46.597856,
    "longitude": -120.48172,
    "original_address": "1604 E Beech St",
    "building_number": 1604,
    "street": "E Beech St",
    "city": "Yakima",
    "zip": 98901,
    "concatenated_address": "1604 E Beech St, Yakima",
    "address": "1604 E. Beech St., Yakima"
  },
  {
    "id": 3012,
    "financing": "Federally subsidized",
    "building_name": "Sail River Longhouse",
    "latitude": 48.327961,
    "longitude": -124.61505,
    "original_address": "181 Sail River Heights Dr.",
    "building_number": "",
    "street": "",
    "city": "Neah Bay",
    "zip": 98357,
    "concatenated_address": "181 Sail River Heights Dr., Neah Bay",
    "address": "181 Sail River Heights Dr., Neah Bay"
  },
  {
    "id": 3013,
    "financing": "Federally subsidized",
    "building_name": "Saint Anthony",
    "latitude": 46.148328,
    "longitude": -119.55967,
    "original_address": "415 W. Petra Ave",
    "building_number": "",
    "street": "",
    "city": "Prosser",
    "zip": 99350,
    "concatenated_address": "415 W. Petra Ave, Prosser",
    "address": "415 W. Petra Ave., Prosser"
  },
  {
    "id": 3014,
    "financing": "Federally subsidized",
    "building_name": "Salem Village",
    "latitude": 48.435248,
    "longitude": -122.20818,
    "original_address": "2619 North La Venture Road",
    "building_number": "",
    "street": "",
    "city": "Mount Vernon",
    "zip": "98273-9492",
    "concatenated_address": "2619 North La Venture Road, Mount Vernon",
    "address": "2619 North La Venture Road, Mount Vernon"
  },
  {
    "id": 3015,
    "financing": "Federally subsidized",
    "building_name": "Salishan I-V",
    "latitude": 47.216712,
    "longitude": -122.40428,
    "original_address": "1728 East 44th St",
    "building_number": 1728,
    "street": "E 44th St",
    "city": "Tacoma",
    "zip": 98404,
    "concatenated_address": "1728 E 44th St, Tacoma",
    "address": "1728 E. 44th St., Tacoma"
  },
  {
    "id": 3016,
    "financing": "Federally subsidized",
    "building_name": "Salmon Run Apartments",
    "latitude": 46.933036,
    "longitude": -122.59381,
    "original_address": "10720 Vancil Road S",
    "building_number": 10720,
    "street": "Vancil Rd SE",
    "city": "Yelm",
    "zip": 98597,
    "concatenated_address": "10720 Vancil Rd SE, Yelm",
    "address": "10720 Vancil Road S.E., Yelm"
  },
  {
    "id": 3017,
    "financing": "Federally subsidized",
    "building_name": "Salvatore Court",
    "latitude": 47.523738,
    "longitude": -122.36079,
    "original_address": "8831 Delridge Way Sw",
    "building_number": 8831,
    "street": "Delridge Way SW",
    "city": "Seattle",
    "zip": 98106,
    "concatenated_address": "8831 Delridge Way SW, Seattle",
    "address": "8831 Delridge Way S.W., Seattle"
  },
  {
    "id": 3018,
    "financing": "Federally subsidized",
    "building_name": "Samaki Commons",
    "latitude": 47.531676,
    "longitude": -122.28319,
    "original_address": "3900 South Kenyon St",
    "building_number": 3900,
    "street": "S Kenyon St",
    "city": "Seattle",
    "zip": 98118,
    "concatenated_address": "3900 S Kenyon St, Seattle",
    "address": "3900 S. Kenyon St., Seattle"
  },
  {
    "id": 3019,
    "financing": "Federally subsidized",
    "building_name": "San Isidoro Plaza",
    "latitude": 46.338554,
    "longitude": -120.18995,
    "original_address": "409 D Street",
    "building_number": 409,
    "street": "D St",
    "city": "Granger",
    "zip": 98932,
    "concatenated_address": "409 D St, Granger",
    "address": "409 D St., Granger"
  },
  {
    "id": 3020,
    "financing": "Federally subsidized",
    "building_name": "San Juan Commons",
    "latitude": 48.124485,
    "longitude": -122.77763,
    "original_address": "3300 San Juan Avenue",
    "building_number": 3300,
    "street": "San Juan Ave",
    "city": "Port Townsend",
    "zip": 98368,
    "concatenated_address": "3300 San Juan Ave, Port Townsend",
    "address": "3300 San Juan Ave., Port Townsend"
  },
  {
    "id": 3021,
    "financing": "Federally subsidized",
    "building_name": "San Poil Plaza",
    "latitude": 48.652686,
    "longitude": -118.73195,
    "original_address": "466 Thornton Drive",
    "building_number": 466,
    "street": "Thornton Dr",
    "city": "Republic",
    "zip": 99166,
    "concatenated_address": "466 Thornton Dr, Republic",
    "address": "466 Thornton Drive, Republic"
  },
  {
    "id": 3022,
    "financing": "Federally subsidized",
    "building_name": "Sand Point Family Housing",
    "latitude": 47.678654,
    "longitude": -122.26294,
    "original_address": "6831 62nd Avenue Ne",
    "building_number": 6831,
    "street": "62nd Ave NE",
    "city": "Seattle",
    "zip": 98115,
    "concatenated_address": "6831 62nd Ave NE, Seattle",
    "address": "6831 62nd Ave. N.E., Seattle"
  },
  {
    "id": 3023,
    "financing": "Federally subsidized",
    "building_name": "Sand Point Family Housing",
    "latitude": 48.475033,
    "longitude": -122.33798,
    "original_address": "115 Hulbush Lane",
    "building_number": 115,
    "street": "Hulbush Ln",
    "city": "Burlington",
    "zip": 98233,
    "concatenated_address": "115 Hulbush Ln, Burlington",
    "address": "115 Hulbush Lane, Burlington"
  },
  {
    "id": 3024,
    "financing": "Federally subsidized",
    "building_name": "Sandalwood Apartments",
    "latitude": 46.378334,
    "longitude": -120.32285,
    "original_address": "819 Guyette Lane",
    "building_number": 819,
    "street": "Guyette Ln",
    "city": "Toppenish",
    "zip": 98948,
    "concatenated_address": "819 Guyette Ln, Toppenish",
    "address": "819 Guyette Lane, Toppenish"
  },
  {
    "id": 3025,
    "financing": "Federally subsidized",
    "building_name": "Sandstone Apartments",
    "latitude": 46.198693,
    "longitude": -119.13498,
    "original_address": "1212 W 10th Ave",
    "building_number": 1212,
    "street": "W 10th Ave",
    "city": "Kennewick",
    "zip": 99336,
    "concatenated_address": "1212 W 10th Ave, Kennewick",
    "address": "1212 W. 10th Ave., Kennewick"
  },
  {
    "id": 3026,
    "financing": "Federally subsidized",
    "building_name": "Sanitary Market",
    "latitude": 47.609164,
    "longitude": -122.34083,
    "original_address": "1522 Post Alley",
    "building_number": 1522,
    "street": "Post Aly",
    "city": "Seattle",
    "zip": 98101,
    "concatenated_address": "1522 Post Aly, Seattle",
    "address": "1522 Post Aly, Seattle"
  },
  {
    "id": 3027,
    "financing": "Federally subsidized",
    "building_name": "Santa Teresita Del Nino Jesus",
    "latitude": 47.533429,
    "longitude": -122.36442,
    "original_address": "2427 Sw Holden St",
    "building_number": 2427,
    "street": "SW Holden St",
    "city": "Seattle",
    "zip": "98126-1725",
    "concatenated_address": "2427 SW Holden St, Seattle",
    "address": "2427 S.W. Holden St., Seattle"
  },
  {
    "id": 3028,
    "financing": "Federally subsidized",
    "building_name": "Santos Place",
    "latitude": 47.679282,
    "longitude": -122.26177,
    "original_address": "6940 62nd Avenue Ne",
    "building_number": 6940,
    "street": "62nd Ave NE",
    "city": "Seattle",
    "zip": 98115,
    "concatenated_address": "6940 62nd Ave NE, Seattle",
    "address": "6940 62nd Ave. N.E., Seattle"
  },
  {
    "id": 3029,
    "financing": "Federally subsidized",
    "building_name": "Santos Place/Sand Point Family",
    "latitude": 47.685746,
    "longitude": -122.28159,
    "original_address": "6801, 6831 And 6940 62nd Avenue Ne",
    "building_number": "",
    "street": "",
    "city": "Seattle",
    "zip": "98115-5004",
    "concatenated_address": "6801, 6831 And 6940 62nd Avenue Ne, Seattle",
    "address": "6801, 6831 And 6940 62nd Avenue Ne, Seattle"
  },
  {
    "id": 3030,
    "financing": "Federally subsidized",
    "building_name": "Saratoga Springs",
    "latitude": 47.220735,
    "longitude": -123.11195,
    "original_address": "1100 N. 12th. St.",
    "building_number": 1100,
    "street": "N 12th St",
    "city": "Shelton",
    "zip": 98584,
    "concatenated_address": "1100 N 12th St, Shelton",
    "address": "1100 N. 12th St., Shelton"
  },
  {
    "id": 3031,
    "financing": "Federally subsidized",
    "building_name": "Saratoga Terrace Apartments",
    "latitude": 48.033087,
    "longitude": -122.40181,
    "original_address": "350 Manchester Way.",
    "building_number": 350,
    "street": "Manchester Way",
    "city": "Langley",
    "zip": "98260-9290",
    "concatenated_address": "350 Manchester Way, Langley",
    "address": "350 Manchester Way, Langley"
  },
  {
    "id": 3032,
    "financing": "Federally subsidized",
    "building_name": "Scandia Village",
    "latitude": 48.246587,
    "longitude": -122.34704,
    "original_address": "8401 Henning Dr.",
    "building_number": 8401,
    "street": "Hennings Dr",
    "city": "Stanwood",
    "zip": 98292,
    "concatenated_address": "8401 Hennings Dr, Stanwood",
    "address": "8401 Hennings Drive, Stanwood"
  },
  {
    "id": 3033,
    "financing": "Federally subsidized",
    "building_name": "Scenic Pines Apartments",
    "latitude": 47.206177,
    "longitude": -122.50489,
    "original_address": "5701 Orchard Street W",
    "building_number": 5701,
    "street": "Orchard St W",
    "city": "University Place",
    "zip": 98467,
    "concatenated_address": "5701 Orchard St W, University Place",
    "address": "5701 Orchard St. W., University Place"
  },
  {
    "id": 3034,
    "financing": "Federally subsidized",
    "building_name": "Scenic Vista Senior Apartments",
    "latitude": 47.364708,
    "longitude": -122.20161,
    "original_address": "26404 104th Avenue Se",
    "building_number": 26404,
    "street": "104th Ave SE",
    "city": "Kent",
    "zip": 98030,
    "concatenated_address": "26404 104th Ave SE, Kent",
    "address": "26404 104th Ave. S.E., Kent"
  },
  {
    "id": 3035,
    "financing": "Federally subsidized",
    "building_name": "Scriber Creek",
    "latitude": 47.80847,
    "longitude": -122.29094,
    "original_address": "20917 44th Avenue West",
    "building_number": 20917,
    "street": "44th Ave W",
    "city": "Lynnwood",
    "zip": 98036,
    "concatenated_address": "20917 44th Ave W, Lynnwood",
    "address": "20917 44th Ave. W., Lynnwood"
  },
  {
    "id": 3036,
    "financing": "Federally subsidized",
    "building_name": "Sea Breeze Apartments",
    "latitude": 48.071747,
    "longitude": -123.11398,
    "original_address": "525 W. Mccurdy Rd",
    "building_number": 525,
    "street": "W McCurdy Rd",
    "city": "Sequim",
    "zip": 98382,
    "concatenated_address": "525 W McCurdy Rd, Sequim",
    "address": "525 W. McCurdy Road, Sequim"
  },
  {
    "id": 3037,
    "financing": "Federally subsidized",
    "building_name": "Seabreeze Townhomes",
    "latitude": 48.995913,
    "longitude": -122.74245,
    "original_address": "717 F St",
    "building_number": 717,
    "street": "F St",
    "city": "Blaine",
    "zip": 98230,
    "concatenated_address": "717 F St, Blaine",
    "address": "717 F St., Blaine"
  },
  {
    "id": 3038,
    "financing": "Federally subsidized",
    "building_name": "Seabreeze Townhouses",
    "latitude": 48.995848,
    "longitude": -122.74072,
    "original_address": "763 F St",
    "building_number": 763,
    "street": "F St",
    "city": "Blaine",
    "zip": 98230,
    "concatenated_address": "763 F St, Blaine",
    "address": "763 F St., Blaine"
  },
  {
    "id": 3039,
    "financing": "Federally subsidized",
    "building_name": "Seasons",
    "latitude": 47.32348,
    "longitude": -122.17324,
    "original_address": "12722 Se 312th St.",
    "building_number": 12722,
    "street": "SE 312th St",
    "city": "Auburn",
    "zip": "98002-3145",
    "concatenated_address": "12722 SE 312th St, Auburn",
    "address": "12722 S.E. 312th St., Auburn"
  },
  {
    "id": 3040,
    "financing": "Federally subsidized",
    "building_name": "Seattle High Rise Rehabilitation Phase Ii",
    "latitude": 47.545479,
    "longitude": -122.38676,
    "original_address": "6420 California Avenue Sw",
    "building_number": 6420,
    "street": "California Ave SW",
    "city": "Seattle",
    "zip": 98136,
    "concatenated_address": "6420 California Ave SW, Seattle",
    "address": "6420 California Ave. S.W., Seattle"
  },
  {
    "id": 3041,
    "financing": "Federally subsidized",
    "building_name": "Seattle High Rise Rehabilitation Phase Ii",
    "latitude": 47.545479,
    "longitude": -122.38676,
    "original_address": "6420 California Avenue Sw",
    "building_number": 6420,
    "street": "California Ave SW",
    "city": "Seattle",
    "zip": "98136-1883",
    "concatenated_address": "6420 California Ave SW, Seattle",
    "address": "6420 California Ave. S.W., Seattle"
  },
  {
    "id": 3042,
    "financing": "Federally subsidized",
    "building_name": "Seattle High Rise Rehabilitation Phase Iii",
    "latitude": 47.520523,
    "longitude": -122.27058,
    "original_address": "9201 Rainier Avenue S",
    "building_number": 9201,
    "street": "Rainier Ave S",
    "city": "Seattle",
    "zip": "98118-5500",
    "concatenated_address": "9201 Rainier Ave S, Seattle",
    "address": "9201 Rainier Ave. S., Seattle"
  },
  {
    "id": 3043,
    "financing": "Federally subsidized",
    "building_name": "Seaview Apartments",
    "latitude": 47.397058,
    "longitude": -122.29752,
    "original_address": "22800 28th Avenue South",
    "building_number": 22800,
    "street": "28th Ave S",
    "city": "Seattle",
    "zip": "98198-4439",
    "concatenated_address": "22800 28th Ave S, Seattle",
    "address": "22800 28th Ave. S., Seattle"
  },
  {
    "id": 3044,
    "financing": "Federally subsidized",
    "building_name": "Second + Pine",
    "latitude": 47.610292,
    "longitude": -122.33932,
    "original_address": "211 Pine St",
    "building_number": 211,
    "street": "Pine St",
    "city": "Seattle",
    "zip": 98101,
    "concatenated_address": "211 Pine St, Seattle",
    "address": "211 Pine St., Seattle"
  },
  {
    "id": 3045,
    "financing": "Federally subsidized",
    "building_name": "Second And Pine",
    "latitude": 48.433323,
    "longitude": -122.31224,
    "original_address": "2315 Kulshan View Drive",
    "building_number": 2315,
    "street": "Kulshan View Dr",
    "city": "Mount Vernon",
    "zip": "98273-2734",
    "concatenated_address": "2315 Kulshan View Dr, Mount Vernon",
    "address": "2315 Kulshan View Drive, Mount Vernon"
  },
  {
    "id": 3046,
    "financing": "Federally subsidized",
    "building_name": "Security House Apartments",
    "latitude": 47.615081,
    "longitude": -122.34407,
    "original_address": "2225 4th Ave",
    "building_number": 2225,
    "street": "4th Ave",
    "city": "Seattle",
    "zip": 98121,
    "concatenated_address": "2225 4th Ave, Seattle",
    "address": "2225 4th Ave., Seattle"
  },
  {
    "id": 3047,
    "financing": "Federally subsidized",
    "building_name": "Sedro Villa Apartments",
    "latitude": 48.503787,
    "longitude": -122.23366,
    "original_address": "829 Reed Street",
    "building_number": 829,
    "street": "Reed St",
    "city": "Sedro-Woolley",
    "zip": 98284,
    "concatenated_address": "829 Reed St, Sedro-Woolley",
    "address": "829 Reed St., Sedro-Woolley"
  },
  {
    "id": 3048,
    "financing": "Federally subsidized",
    "building_name": "Selah Square",
    "latitude": 46.657363,
    "longitude": -120.52514,
    "original_address": "303 N. Wenas",
    "building_number": 303,
    "street": "N Wenas Rd",
    "city": "Selah",
    "zip": 98942,
    "concatenated_address": "303 N Wenas Rd, Selah",
    "address": "303 N. Wenas Road, Selah"
  },
  {
    "id": 3049,
    "financing": "Federally subsidized",
    "building_name": "Seneca Apartments",
    "latitude": 47.612664,
    "longitude": -122.3232,
    "original_address": "1214 Boylston Avenue",
    "building_number": 1214,
    "street": "Boylston Ave",
    "city": "Seattle",
    "zip": 98101,
    "concatenated_address": "1214 Boylston Ave, Seattle",
    "address": "1214 Boylston Ave., Seattle"
  },
  {
    "id": 3050,
    "financing": "Federally subsidized",
    "building_name": "Senior City",
    "latitude": 47.318181,
    "longitude": -122.3044,
    "original_address": "31635 - 23rd Avenue South",
    "building_number": 31635,
    "street": "23rd Ave S",
    "city": "Federal Way",
    "zip": "98003-5046",
    "concatenated_address": "31635 23rd Ave S, Federal Way",
    "address": "31635 23rd Ave. S., Federal Way"
  },
  {
    "id": 3051,
    "financing": "Federally subsidized",
    "building_name": "Shag Affordable Senior Living Communities",
    "latitude": 47.261616,
    "longitude": -122.44747,
    "original_address": "203 South G Street",
    "building_number": 203,
    "street": "S G St",
    "city": "Tacoma",
    "zip": 98405,
    "concatenated_address": "203 S G St, Tacoma",
    "address": "203 S. G St., Tacoma"
  },
  {
    "id": 3052,
    "financing": "Federally subsidized",
    "building_name": "Si View Apartments",
    "latitude": 47.491081,
    "longitude": -121.78569,
    "original_address": "424 Healy Avenue S. #100",
    "building_number": 424,
    "street": "Healy Ave S",
    "city": "North Bend",
    "zip": 98045,
    "concatenated_address": "424 Healy Ave S, North Bend",
    "address": "424 Healy Ave. S., North Bend"
  },
  {
    "id": 3053,
    "financing": "Federally subsidized",
    "building_name": "Silver Creek Apartments",
    "latitude": 46.271862,
    "longitude": -119.2136,
    "original_address": "9315 Chapel Hill Blvd",
    "building_number": 9315,
    "street": "Chapel Hill Blvd",
    "city": "Pasco",
    "zip": "99301-8266",
    "concatenated_address": "9315 Chapel Hill Blvd, Pasco",
    "address": "9315 Chapel Hill Blvd., Pasco"
  },
  {
    "id": 3054,
    "financing": "Federally subsidized",
    "building_name": "Silver Creek Apartments",
    "latitude": 46.271862,
    "longitude": -119.2136,
    "original_address": "9315 Chapel Hill Blvd",
    "building_number": 9315,
    "street": "Chapel Hill Blvd",
    "city": "Pasco",
    "zip": 99301,
    "concatenated_address": "9315 Chapel Hill Blvd, Pasco",
    "address": "9315 Chapel Hill Blvd., Pasco"
  },
  {
    "id": 3055,
    "financing": "Federally subsidized",
    "building_name": "Silver Springs Apartments",
    "latitude": 47.399646,
    "longitude": -122.22079,
    "original_address": "22416 88th Avenue South",
    "building_number": 22416,
    "street": "88th Ave S",
    "city": "Kent",
    "zip": "98031-2480",
    "concatenated_address": "22416 88th Ave S, Kent",
    "address": "22416 88th Ave. S., Kent"
  },
  {
    "id": 3056,
    "financing": "Federally subsidized",
    "building_name": "Silvercrest Apartments",
    "latitude": 47.652041,
    "longitude": -122.69753,
    "original_address": "9725 Danwood Lane Nw",
    "building_number": 9725,
    "street": "Danwood Ln NW",
    "city": "Silverdale",
    "zip": 98383,
    "concatenated_address": "9725 Danwood Ln NW, Silverdale",
    "address": "9725 Danwood Lane N.W., Silverdale"
  },
  {
    "id": 3057,
    "financing": "Federally subsidized",
    "building_name": "Silverwood",
    "latitude": 48.498332,
    "longitude": -122.61478,
    "original_address": "1103 - 29th St",
    "building_number": 1103,
    "street": "29th St",
    "city": "Anacortes",
    "zip": 98221,
    "concatenated_address": "1103 29th St, Anacortes",
    "address": "1103 29th St., Anacortes"
  },
  {
    "id": 3058,
    "financing": "Federally subsidized",
    "building_name": "Silverwood Park Apartments",
    "latitude": 47.395651,
    "longitude": -122.29304,
    "original_address": "23006 30th Ave. South",
    "building_number": 23006,
    "street": "30th Ave S",
    "city": "Seattle",
    "zip": "98198-7229",
    "concatenated_address": "23006 30th Ave S, Seattle",
    "address": "23006 30th Ave. S., Seattle"
  },
  {
    "id": 3059,
    "financing": "Federally subsidized",
    "building_name": "Silvian Apartments",
    "latitude": 47.622148,
    "longitude": -122.32023,
    "original_address": "914 E Harrison St",
    "building_number": 914,
    "street": "E Harrison St",
    "city": "Seattle",
    "zip": 98102,
    "concatenated_address": "914 E Harrison St, Seattle",
    "address": "914 E. Harrison St., Seattle"
  },
  {
    "id": 3060,
    "financing": "Federally subsidized",
    "building_name": "Similkameen Park",
    "latitude": 48.926935,
    "longitude": -119.43509,
    "original_address": "301 Golden Street",
    "building_number": 301,
    "street": "Golden St",
    "city": "Oroville",
    "zip": 98844,
    "concatenated_address": "301 Golden St, Oroville",
    "address": "301 Golden St., Oroville"
  },
  {
    "id": 3061,
    "financing": "Federally subsidized",
    "building_name": "Simons Senior Apartments",
    "latitude": 47.613377,
    "longitude": -122.34315,
    "original_address": "2119 3rd Ave",
    "building_number": 2119,
    "street": "3rd Ave",
    "city": "Seattle",
    "zip": 98121,
    "concatenated_address": "2119 3rd Ave, Seattle",
    "address": "2119 3rd Ave., Seattle"
  },
  {
    "id": 3062,
    "financing": "Federally subsidized",
    "building_name": "Single Family Detached",
    "latitude": 47.535233,
    "longitude": -122.28136,
    "original_address": "4013 S Webster St",
    "building_number": 4013,
    "street": "S Webster St",
    "city": "Seattle",
    "zip": 98118,
    "concatenated_address": "4013 S Webster St, Seattle",
    "address": "4013 S. Webster St., Seattle"
  },
  {
    "id": 3063,
    "financing": "Federally subsidized",
    "building_name": "Sixth Place Apartments",
    "latitude": 47.515315,
    "longitude": -122.34295,
    "original_address": "9800 - 6th Place",
    "building_number": 9806,
    "street": "6th Pl SW",
    "city": "Seattle",
    "zip": 98106,
    "concatenated_address": "9806 6th Pl SW, Seattle",
    "address": "9806 6th Pl S.W., Seattle"
  },
  {
    "id": 3064,
    "financing": "Federally subsidized",
    "building_name": "Skagit Village",
    "latitude": 48.435248,
    "longitude": -122.20818,
    "original_address": "2107 No. Laventure Road",
    "building_number": "",
    "street": "",
    "city": "Mount Vernon",
    "zip": 98273,
    "concatenated_address": "2107 No. Laventure Road, Mount Vernon",
    "address": "2107 N. Laventure Road, Mount Vernon"
  },
  {
    "id": 3065,
    "financing": "Federally subsidized",
    "building_name": "Skyline Crest Apartments",
    "latitude": 45.624078,
    "longitude": -122.60411,
    "original_address": "500 Omaha Way",
    "building_number": 500,
    "street": "Omaha Way",
    "city": "Vancouver",
    "zip": 98661,
    "concatenated_address": "500 Omaha Way, Vancouver",
    "address": "500 Omaha Way, Vancouver"
  },
  {
    "id": 3066,
    "financing": "Federally subsidized",
    "building_name": "Smith Tower",
    "latitude": 45.625435,
    "longitude": -122.67242,
    "original_address": "515 Washington Street",
    "building_number": 515,
    "street": "Washington St",
    "city": "Vancouver",
    "zip": 98660,
    "concatenated_address": "515 Washington St, Vancouver",
    "address": "515 Washington St., Vancouver"
  },
  {
    "id": 3067,
    "financing": "Federally subsidized",
    "building_name": "Sno Ridge Senior Apartments",
    "latitude": 47.491696,
    "longitude": -121.78661,
    "original_address": "401 Stow Avenue S",
    "building_number": 401,
    "street": "Stow Ave S",
    "city": "North Bend",
    "zip": 98045,
    "concatenated_address": "401 Stow Ave S, North Bend",
    "address": "401 Stow Ave. S., North Bend"
  },
  {
    "id": 3068,
    "financing": "Federally subsidized",
    "building_name": "Soap Lake Gardens",
    "latitude": 47.386041,
    "longitude": -119.49119,
    "original_address": "327 Division Street S",
    "building_number": 327,
    "street": "Division St S",
    "city": "Soap Lake",
    "zip": 98851,
    "concatenated_address": "327 Division St S, Soap Lake",
    "address": "327 Division St. S., Soap Lake"
  },
  {
    "id": 3069,
    "financing": "Federally subsidized",
    "building_name": "Somerset Gardens East",
    "latitude": 47.636471,
    "longitude": -122.14479,
    "original_address": "14700 Northeast 29th Place",
    "building_number": 14700,
    "street": "NE 29th Pl",
    "city": "Bellevue",
    "zip": 98007,
    "concatenated_address": "14700 NE 29th Pl, Bellevue",
    "address": "14700 N.E. 29th Place, Bellevue"
  },
  {
    "id": 3070,
    "financing": "Federally subsidized",
    "building_name": "Somerset Gardens West",
    "latitude": 47.636496,
    "longitude": -122.14713,
    "original_address": "14500 Ne 29th Place",
    "building_number": 14500,
    "street": "NE 29th Pl",
    "city": "Bellevue",
    "zip": 98007,
    "concatenated_address": "14500 NE 29th Pl, Bellevue",
    "address": "14500 N.E. 29th Place, Bellevue"
  },
  {
    "id": 3071,
    "financing": "Federally subsidized",
    "building_name": "Sor Juana Ines Court",
    "latitude": 46.242259,
    "longitude": -119.91383,
    "original_address": "1200 Carriage Court",
    "building_number": 1200,
    "street": "Carriage Ct",
    "city": "Grandview",
    "zip": 98930,
    "concatenated_address": "1200 Carriage Ct, Grandview",
    "address": "1200 Carriage Ct, Grandview"
  },
  {
    "id": 3072,
    "financing": "Federally subsidized",
    "building_name": "South Hill Apartments",
    "latitude": 46.309475,
    "longitude": -120.02681,
    "original_address": "410 South Hill Road",
    "building_number": 410,
    "street": "S Hill Rd",
    "city": "Sunnyside",
    "zip": 98944,
    "concatenated_address": "410 S Hill Rd, Sunnyside",
    "address": "410 S. Hill Road, Sunnyside"
  },
  {
    "id": 3073,
    "financing": "Federally subsidized",
    "building_name": "South Hill Apartments",
    "latitude": 47.127903,
    "longitude": -122.29322,
    "original_address": "14104 Meridian Avenue East",
    "building_number": 14104,
    "street": "State Rte 161",
    "city": "Puyallup",
    "zip": 98373,
    "concatenated_address": "14104 State Rte 161, Puyallup",
    "address": "14104 State Route 161, Puyallup"
  },
  {
    "id": 3074,
    "financing": "Federally subsidized",
    "building_name": "South Hill Commons",
    "latitude": 47.621092,
    "longitude": -117.36415,
    "original_address": "3141 East 37th Avenue",
    "building_number": 3141,
    "street": "E 37th Ave",
    "city": "Spokane",
    "zip": "99223-4557",
    "concatenated_address": "3141 E 37th Ave, Spokane",
    "address": "3141 E. 37th Ave., Spokane"
  },
  {
    "id": 3075,
    "financing": "Federally subsidized",
    "building_name": "South Hill II Apartments",
    "latitude": 46.31066,
    "longitude": -120.02606,
    "original_address": "420 W South Hill Road",
    "building_number": 420,
    "street": "W South Hill Rd",
    "city": "Sunnyside",
    "zip": 98944,
    "concatenated_address": "420 W South Hill Rd, Sunnyside",
    "address": "420 W. South Hill Road, Sunnyside"
  },
  {
    "id": 3076,
    "financing": "Federally subsidized",
    "building_name": "South Shore Court",
    "latitude": 47.523098,
    "longitude": -122.27226,
    "original_address": "4811 South Henderson",
    "building_number": 4811,
    "street": "S Henderson St",
    "city": "Seattle",
    "zip": "98118-4952",
    "concatenated_address": "4811 S Henderson St, Seattle",
    "address": "4811 S. Henderson St., Seattle"
  },
  {
    "id": 3077,
    "financing": "Federally subsidized",
    "building_name": "Southcreek Apartments I & II",
    "latitude": 46.709731,
    "longitude": -122.99691,
    "original_address": "1101 Scammon Creek Rd",
    "building_number": 1101,
    "street": "Scammon Creek Rd",
    "city": "Centralia",
    "zip": 98531,
    "concatenated_address": "1101 Scammon Creek Rd, Centralia",
    "address": "1101 Scammon Creek Road, Centralia"
  },
  {
    "id": 3078,
    "financing": "Federally subsidized",
    "building_name": "Southern Pines",
    "latitude": 47.182719,
    "longitude": -122.47456,
    "original_address": "8212 29th Avenue Ct S",
    "building_number": 8212,
    "street": "29th Ave Ct S",
    "city": "Lakewood",
    "zip": 98499,
    "concatenated_address": "8212 29th Ave Ct S, Lakewood",
    "address": "8212 29th Ave. Ct S., Lakewood"
  },
  {
    "id": 3079,
    "financing": "Federally subsidized",
    "building_name": "Southwood Square Apartments",
    "latitude": 47.367008,
    "longitude": -122.19924,
    "original_address": "26212 106th Pl Se",
    "building_number": 26212,
    "street": "106th Pl SE",
    "city": "Kent",
    "zip": "98031-6705",
    "concatenated_address": "26212 106th Pl SE, Kent",
    "address": "26212 106th Pl S.E., Kent"
  },
  {
    "id": 3080,
    "financing": "Federally subsidized",
    "building_name": "Southwynd Park Apartments",
    "latitude": 47.307713,
    "longitude": -122.31577,
    "original_address": "1831 So. 310th",
    "building_number": "",
    "street": "",
    "city": "Federal Way",
    "zip": 98003,
    "concatenated_address": "1831 So. 310th, Federal Way",
    "address": "1831 S. 310th, Federal Way"
  },
  {
    "id": 3081,
    "financing": "Federally subsidized",
    "building_name": "Spencer Court Apartments",
    "latitude": 47.478429,
    "longitude": -122.205,
    "original_address": "334 Wells Avenue S",
    "building_number": 334,
    "street": "Wells Ave S",
    "city": "Renton",
    "zip": 98055,
    "concatenated_address": "334 Wells Ave S, Renton",
    "address": "334 Wells Ave. S., Renton"
  },
  {
    "id": 3082,
    "financing": "Federally subsidized",
    "building_name": "Spiritwood Manor",
    "latitude": 47.597501,
    "longitude": -122.14148,
    "original_address": "1424 148th Avenue Se",
    "building_number": 1424,
    "street": "148th Ave SE",
    "city": "Bellevue",
    "zip": 98007,
    "concatenated_address": "1424 148th Ave SE, Bellevue",
    "address": "1424 148th Ave. S.E., Bellevue"
  },
  {
    "id": 3083,
    "financing": "Federally subsidized",
    "building_name": "Spokane At Rainier Court",
    "latitude": 47.571023,
    "longitude": -122.28966,
    "original_address": "3616 34th Avenue South",
    "building_number": 3616,
    "street": "34th Ave S",
    "city": "Seattle",
    "zip": 98144,
    "concatenated_address": "3616 34th Ave S, Seattle",
    "address": "3616 34th Ave. S., Seattle"
  },
  {
    "id": 3084,
    "financing": "Federally subsidized",
    "building_name": "Spokane Tribal Homes I",
    "latitude": 47.913372,
    "longitude": -117.79745,
    "original_address": "5095 Tshimakin Loop Way",
    "building_number": "",
    "street": "",
    "city": "Ford",
    "zip": 99013,
    "concatenated_address": "5095 Tshimakin Loop Way, Ford",
    "address": "5095 Tshimakin Loop Way, Ford"
  },
  {
    "id": 3085,
    "financing": "Federally subsidized",
    "building_name": "Spokane Tribal Homes II",
    "latitude": 47.958217,
    "longitude": -118.22932,
    "original_address": "6433 L Molly Court",
    "building_number": 6433,
    "street": "Molly Ct",
    "city": "Fruitland",
    "zip": 99129,
    "concatenated_address": "6433 Molly Ct, Fruitland",
    "address": "6433 Molly Ct, Fruitland"
  },
  {
    "id": 3086,
    "financing": "Federally subsidized",
    "building_name": "Sprague Crossing",
    "latitude": 47.658078,
    "longitude": -117.21216,
    "original_address": "14303 E Sprague Avenue",
    "building_number": 14303,
    "street": "E Sprague Ave",
    "city": "Spokane",
    "zip": "99216-3171",
    "concatenated_address": "14303 E Sprague Ave, Spokane",
    "address": "14303 E. Sprague Ave., Spokane"
  },
  {
    "id": 3087,
    "financing": "Federally subsidized",
    "building_name": "Sprague Crossing II",
    "latitude": 47.658078,
    "longitude": -117.21216,
    "original_address": "14303 E Sprague Ave",
    "building_number": 14303,
    "street": "E Sprague Ave",
    "city": "Spokane",
    "zip": 99216,
    "concatenated_address": "14303 E Sprague Ave, Spokane",
    "address": "14303 E. Sprague Ave., Spokane"
  },
  {
    "id": 3088,
    "financing": "Federally subsidized",
    "building_name": "Spring Canyon Apartments",
    "latitude": 47.937173,
    "longitude": -119.00018,
    "original_address": "106 Hill Avenue",
    "building_number": 106,
    "street": "Hill Ave",
    "city": "Grand Coulee",
    "zip": 99133,
    "concatenated_address": "106 Hill Ave, Grand Coulee",
    "address": "106 Hill Ave., Grand Coulee"
  },
  {
    "id": 3089,
    "financing": "Federally subsidized",
    "building_name": "Springfield Meadows",
    "latitude": 45.653826,
    "longitude": -122.6033,
    "original_address": "4317 Ne 66th Ave",
    "building_number": 4317,
    "street": "NE 66th Ave",
    "city": "Vancouver",
    "zip": 98661,
    "concatenated_address": "4317 NE 66th Ave, Vancouver",
    "address": "4317 N.E. 66th Ave., Vancouver"
  },
  {
    "id": 3090,
    "financing": "Federally subsidized",
    "building_name": "Springfield Meadows (Federal Way)",
    "latitude": 47.349015,
    "longitude": -122.31188,
    "original_address": "1711 S 281st Pl",
    "building_number": 1711,
    "street": "S 281st Pl",
    "city": "Federal Way",
    "zip": 98003,
    "concatenated_address": "1711 S 281st Pl, Federal Way",
    "address": "1711 S. 281st Place, Federal Way"
  },
  {
    "id": 3091,
    "financing": "Federally subsidized",
    "building_name": "Spruce Street I Apartments",
    "latitude": 46.602194,
    "longitude": -120.48804,
    "original_address": "1112 E Spruce Street",
    "building_number": 1112,
    "street": "E Spruce St",
    "city": "Yakima",
    "zip": 98901,
    "concatenated_address": "1112 E Spruce St, Yakima",
    "address": "1112 E. Spruce St., Yakima"
  },
  {
    "id": 3092,
    "financing": "Federally subsidized",
    "building_name": "Spruce Street II Apartments",
    "latitude": 46.601834,
    "longitude": -120.48577,
    "original_address": "1302 E. Spruce St",
    "building_number": 1302,
    "street": "E Spruce St",
    "city": "Yakima",
    "zip": 98901,
    "concatenated_address": "1302 E Spruce St, Yakima",
    "address": "1302 E. Spruce St., Yakima"
  },
  {
    "id": 3093,
    "financing": "Federally subsidized",
    "building_name": "SRO Housing For Homeless",
    "latitude": 47.257382,
    "longitude": -122.44837,
    "original_address": "621 South Yakima",
    "building_number": 621,
    "street": "S Yakima Ave",
    "city": "Tacoma",
    "zip": 98402,
    "concatenated_address": "621 S Yakima Ave, Tacoma",
    "address": "621 S. Yakima Ave., Tacoma"
  },
  {
    "id": 3094,
    "financing": "Federally subsidized",
    "building_name": "St Charles Apartments",
    "latitude": 47.603206,
    "longitude": -122.33208,
    "original_address": "619 Third Ave",
    "building_number": 619,
    "street": "3rd Ave",
    "city": "Seattle",
    "zip": 98104,
    "concatenated_address": "619 3rd Ave, Seattle",
    "address": "619 3rd Ave., Seattle"
  },
  {
    "id": 3095,
    "financing": "Federally subsidized",
    "building_name": "St Martins On Westlake",
    "latitude": 47.615455,
    "longitude": -122.33761,
    "original_address": "2008 Westlake Ave",
    "building_number": 2008,
    "street": "Westlake Ave",
    "city": "Seattle",
    "zip": 98121,
    "concatenated_address": "2008 Westlake Ave, Seattle",
    "address": "2008 Westlake Ave., Seattle"
  },
  {
    "id": 3096,
    "financing": "Federally subsidized",
    "building_name": "St. Charles Apartments",
    "latitude": 47.603206,
    "longitude": -122.33208,
    "original_address": "619 Third Ave",
    "building_number": 619,
    "street": "3rd Ave",
    "city": "Seattle",
    "zip": 98104,
    "concatenated_address": "619 3rd Ave, Seattle",
    "address": "619 3rd Ave., Seattle"
  },
  {
    "id": 3097,
    "financing": "Federally subsidized",
    "building_name": "St. Charles Place",
    "latitude": 48.927204,
    "longitude": -119.43646,
    "original_address": "207 Main Street",
    "building_number": 207,
    "street": "Main St",
    "city": "Oroville",
    "zip": 98844,
    "concatenated_address": "207 Main St, Oroville",
    "address": "207 Main St., Oroville"
  },
  {
    "id": 3098,
    "financing": "Federally subsidized",
    "building_name": "St. Martha Plaza",
    "latitude": 47.077685,
    "longitude": -119.86006,
    "original_address": "125 E Deacon Ave",
    "building_number": "",
    "street": "Deacon Ave",
    "city": "George",
    "zip": 98824,
    "concatenated_address": "125 E Deacon Ave, George",
    "address": "125 E. Deacon Ave., George"
  },
  {
    "id": 3099,
    "financing": "Federally subsidized",
    "building_name": "St. Michaels The Archangel Haven",
    "latitude": 46.051891,
    "longitude": -118.35732,
    "original_address": "1360 Parade Loop",
    "building_number": 1360,
    "street": "Parade Loop",
    "city": "Walla Walla",
    "zip": 99362,
    "concatenated_address": "1360 Parade Loop, Walla Walla",
    "address": "1360 Parade Loop, Walla Walla"
  },
  {
    "id": 3100,
    "financing": "Federally subsidized",
    "building_name": "Starliter Apartments",
    "latitude": 47.524813,
    "longitude": -122.26961,
    "original_address": "8708 Rainier Ave. South",
    "building_number": 8708,
    "street": "Rainier Ave S",
    "city": "Seattle",
    "zip": 98118,
    "concatenated_address": "8708 Rainier Ave S, Seattle",
    "address": "8708 Rainier Ave. S., Seattle"
  },
  {
    "id": 3101,
    "financing": "Federally subsidized",
    "building_name": "Steeple Chase Apartments",
    "latitude": 45.655105,
    "longitude": -122.63585,
    "original_address": "4617 Ne St. Johns Road",
    "building_number": 4617,
    "street": "NE St Johns Rd",
    "city": "Vancouver",
    "zip": 98661,
    "concatenated_address": "4617 NE St Johns Rd, Vancouver",
    "address": "4617 N.E. St. Johns Road, Vancouver"
  },
  {
    "id": 3102,
    "financing": "Federally subsidized",
    "building_name": "Sterling Meadows",
    "latitude": 48.785538,
    "longitude": -122.49759,
    "original_address": "512 Sterling Drive",
    "building_number": 512,
    "street": "Sterling Dr",
    "city": "Bellingham",
    "zip": 98226,
    "concatenated_address": "512 Sterling Dr, Bellingham",
    "address": "512 Sterling Drive, Bellingham"
  },
  {
    "id": 3103,
    "financing": "Federally subsidized",
    "building_name": "Sterling Meadows Apartments",
    "latitude": 48.784622,
    "longitude": -122.49723,
    "original_address": "500 Sterling Drive",
    "building_number": 500,
    "street": "Sterling Dr",
    "city": "Bellingham",
    "zip": 98226,
    "concatenated_address": "500 Sterling Dr, Bellingham",
    "address": "500 Sterling Drive, Bellingham"
  },
  {
    "id": 3104,
    "financing": "Federally subsidized",
    "building_name": "Sterling Senior Housing",
    "latitude": 48.784578,
    "longitude": -122.49819,
    "original_address": "528 Sterling Drive",
    "building_number": 528,
    "street": "Sterling Dr",
    "city": "Bellingham",
    "zip": 98226,
    "concatenated_address": "528 Sterling Dr, Bellingham",
    "address": "528 Sterling Drive, Bellingham"
  },
  {
    "id": 3105,
    "financing": "Federally subsidized",
    "building_name": "Stewart Court Apartments",
    "latitude": 47.614428,
    "longitude": -122.33499,
    "original_address": "1831 8th Avenue",
    "building_number": 1831,
    "street": "8th Ave",
    "city": "Seattle",
    "zip": 98101,
    "concatenated_address": "1831 8th Ave, Seattle",
    "address": "1831 8th Ave., Seattle"
  },
  {
    "id": 3106,
    "financing": "Federally subsidized",
    "building_name": "Stewart House",
    "latitude": 47.609901,
    "longitude": -122.34204,
    "original_address": "80 Stewart Street",
    "building_number": 80,
    "street": "Stewart St",
    "city": "Seattle",
    "zip": 98101,
    "concatenated_address": "80 Stewart St, Seattle",
    "address": "80 Stewart St., Seattle"
  },
  {
    "id": 3107,
    "financing": "Federally subsidized",
    "building_name": "Stillaguamish Gardens",
    "latitude": 48.162582,
    "longitude": -122.18689,
    "original_address": "18318 Smokey Point Blvd.",
    "building_number": 18318,
    "street": "Smokey Point Blvd",
    "city": "Arlington",
    "zip": 98223,
    "concatenated_address": "18318 Smokey Point Blvd, Arlington",
    "address": "18318 Smokey Point Blvd., Arlington"
  },
  {
    "id": 3108,
    "financing": "Federally subsidized",
    "building_name": "Stillaguamish I Apartments",
    "latitude": 48.163075,
    "longitude": -122.18541,
    "original_address": "18326 Smokey Point Blvd.",
    "building_number": 18326,
    "street": "Smokey Point Blvd",
    "city": "Arlington",
    "zip": 98223,
    "concatenated_address": "18326 Smokey Point Blvd, Arlington",
    "address": "18326 Smokey Point Blvd., Arlington"
  },
  {
    "id": 3109,
    "financing": "Federally subsidized",
    "building_name": "Stillaguamish II Apartments",
    "latitude": 48.163543,
    "longitude": -122.183,
    "original_address": "18324 Smokey Point Blvd.",
    "building_number": 18324,
    "street": "Smokey Point Blvd",
    "city": "Arlington",
    "zip": 98223,
    "concatenated_address": "18324 Smokey Point Blvd, Arlington",
    "address": "18324 Smokey Point Blvd., Arlington"
  },
  {
    "id": 3110,
    "financing": "Federally subsidized",
    "building_name": "Stillaguamish Pointe",
    "latitude": 48.163147,
    "longitude": -122.18661,
    "original_address": "18330 Smokey Point Blvd",
    "building_number": 18330,
    "street": "Smokey Point Blvd",
    "city": "Arlington",
    "zip": 98223,
    "concatenated_address": "18330 Smokey Point Blvd, Arlington",
    "address": "18330 Smokey Point Blvd., Arlington"
  },
  {
    "id": 3111,
    "financing": "Federally subsidized",
    "building_name": "Stone Way Apartments",
    "latitude": 47.661196,
    "longitude": -122.34313,
    "original_address": "1215 North 45th St",
    "building_number": 1215,
    "street": "N 45th St",
    "city": "Seattle",
    "zip": "98108-6678",
    "concatenated_address": "1215 N 45th St, Seattle",
    "address": "1215 N. 45th St., Seattle"
  },
  {
    "id": 3112,
    "financing": "Federally subsidized",
    "building_name": "Stonebrook Apartments",
    "latitude": 47.445787,
    "longitude": -122.17789,
    "original_address": "12210 Se Petrovitsky Rd",
    "building_number": 12210,
    "street": "SE Petrovitsky Rd",
    "city": "Renton",
    "zip": "98058-6630",
    "concatenated_address": "12210 SE Petrovitsky Rd, Renton",
    "address": "12210 S.E. Petrovitsky Road, Renton"
  },
  {
    "id": 3113,
    "financing": "Federally subsidized",
    "building_name": "Stonegate",
    "latitude": 46.282814,
    "longitude": -119.19012,
    "original_address": "6102 Road 68",
    "building_number": 6102,
    "street": "Road 68",
    "city": "Pasco",
    "zip": "99301-9100",
    "concatenated_address": "6102 Road 68, Pasco",
    "address": "6102 Road 68, Pasco"
  },
  {
    "id": 3114,
    "financing": "Federally subsidized",
    "building_name": "Stuart Place",
    "latitude": 47.043504,
    "longitude": -122.901,
    "original_address": "110 Legion Way Se",
    "building_number": 110,
    "street": "Legion Way SE",
    "city": "Olympia",
    "zip": 98501,
    "concatenated_address": "110 Legion Way SE, Olympia",
    "address": "110 Legion Way S.E., Olympia"
  },
  {
    "id": 3115,
    "financing": "Federally subsidized",
    "building_name": "Stuart Place",
    "latitude": 47.760223,
    "longitude": -122.24519,
    "original_address": "7025 Ne 182nd Street",
    "building_number": 7025,
    "street": "NE 182nd St",
    "city": "Kenmore",
    "zip": 98028,
    "concatenated_address": "7025 NE 182nd St, Kenmore",
    "address": "7025 N.E. 182nd St., Kenmore"
  },
  {
    "id": 3116,
    "financing": "Federally subsidized",
    "building_name": "Summerfield Apartment Homes",
    "latitude": 47.611359,
    "longitude": -122.14392,
    "original_address": "14720 Ne 1st Place",
    "building_number": 14720,
    "street": "NE 1st Pl",
    "city": "Bellevue",
    "zip": 98007,
    "concatenated_address": "14720 NE 1st Pl, Bellevue",
    "address": "14720 N.E. 1st Place, Bellevue"
  },
  {
    "id": 3117,
    "financing": "Federally subsidized",
    "building_name": "Summerglen",
    "latitude": 48.432789,
    "longitude": -122.30784,
    "original_address": "1630 N 26th St",
    "building_number": 1630,
    "street": "N 26th St",
    "city": "Mount Vernon",
    "zip": "98273-2727",
    "concatenated_address": "1630 N 26th St, Mount Vernon",
    "address": "1630 N. 26th St., Mount Vernon"
  },
  {
    "id": 3118,
    "financing": "Federally subsidized",
    "building_name": "Summerwind Apartments",
    "latitude": 47.325532,
    "longitude": -119.54295,
    "original_address": "340 E Street Ne",
    "building_number": 340,
    "street": "E St NE",
    "city": "Ephrata",
    "zip": 98823,
    "concatenated_address": "340 E St NE, Ephrata",
    "address": "340 E. St. N.E., Ephrata"
  },
  {
    "id": 3119,
    "financing": "Federally subsidized",
    "building_name": "Summerwood Apartments",
    "latitude": 47.688131,
    "longitude": -122.09478,
    "original_address": "9805 Avondale Road Ne",
    "building_number": 9805,
    "street": "Avondale Rd NE",
    "city": "Redmond",
    "zip": 98052,
    "concatenated_address": "9805 Avondale Rd NE, Redmond",
    "address": "9805 Avondale Road N.E., Redmond"
  },
  {
    "id": 3120,
    "financing": "Federally subsidized",
    "building_name": "Summit Apartments",
    "latitude": 47.156167,
    "longitude": -122.38923,
    "original_address": "11016 Waller Road East",
    "building_number": 11016,
    "street": "Waller Rd E",
    "city": "Tacoma",
    "zip": "98466-2249",
    "concatenated_address": "11016 Waller Rd E, Tacoma",
    "address": "11016 Waller Road E., Tacoma"
  },
  {
    "id": 3121,
    "financing": "Federally subsidized",
    "building_name": "Summit At Bay Vista",
    "latitude": 47.565118,
    "longitude": -122.67816,
    "original_address": "4650 Bay Vista Blvd.",
    "building_number": 4650,
    "street": "Bay Vista Blvd",
    "city": "Bremerton",
    "zip": 98312,
    "concatenated_address": "4650 Bay Vista Blvd, Bremerton",
    "address": "4650 Bay Vista Blvd., Bremerton"
  },
  {
    "id": 3122,
    "financing": "Federally subsidized",
    "building_name": "Summit Ridge Apartments",
    "latitude": 47.604878,
    "longitude": -117.36305,
    "original_address": "3307 E 55th Avenue",
    "building_number": 3307,
    "street": "E 55th Ave",
    "city": "Spokane",
    "zip": 99223,
    "concatenated_address": "3307 E 55th Ave, Spokane",
    "address": "3307 E. 55th Ave., Spokane"
  },
  {
    "id": 3123,
    "financing": "Federally subsidized",
    "building_name": "Summit View Apartments",
    "latitude": 47.664901,
    "longitude": -117.45431,
    "original_address": "820 N. Summit Blvd",
    "building_number": 820,
    "street": "N Summit Blvd",
    "city": "Spokane",
    "zip": 99201,
    "concatenated_address": "820 N Summit Blvd, Spokane",
    "address": "820 N. Summit Blvd., Spokane"
  },
  {
    "id": 3124,
    "financing": "Federally subsidized",
    "building_name": "Summit Village",
    "latitude": 47.006622,
    "longitude": -123.39656,
    "original_address": "212 North F Street",
    "building_number": 212,
    "street": "N F St",
    "city": "Elma",
    "zip": 98541,
    "concatenated_address": "212 N F St, Elma",
    "address": "212 N. F St., Elma"
  },
  {
    "id": 3125,
    "financing": "Federally subsidized",
    "building_name": "Sumner Commons Senior Housing",
    "latitude": 47.201091,
    "longitude": -122.2268,
    "original_address": "15406 62nd Street Ct E",
    "building_number": 15406,
    "street": "62nd Street Ct E",
    "city": "Sumner",
    "zip": 98390,
    "concatenated_address": "15406 62nd Street Ct E, Sumner",
    "address": "15406 62nd St. Ct E., Sumner"
  },
  {
    "id": 3126,
    "financing": "Federally subsidized",
    "building_name": "Sun Tower",
    "latitude": 46.604623,
    "longitude": -120.49919,
    "original_address": "6 N. 6th Street",
    "building_number": 6,
    "street": "N 6th St",
    "city": "Yakima",
    "zip": 98901,
    "concatenated_address": "6 N 6th St, Yakima",
    "address": "6 N. 6th St., Yakima"
  },
  {
    "id": 3127,
    "financing": "Federally subsidized",
    "building_name": "Suncrest I",
    "latitude": 48.076462,
    "longitude": -123.09946,
    "original_address": "201 E. Prairie",
    "building_number": 201,
    "street": "E Prairie St",
    "city": "Sequim",
    "zip": 98382,
    "concatenated_address": "201 E Prairie St, Sequim",
    "address": "201 E. Prairie St., Sequim"
  },
  {
    "id": 3128,
    "financing": "Federally subsidized",
    "building_name": "Suncrest Village",
    "latitude": 48.078312,
    "longitude": -123.11397,
    "original_address": "251 S 5th Ave",
    "building_number": 251,
    "street": "S 5th Ave",
    "city": "Sequim",
    "zip": 98382,
    "concatenated_address": "251 S 5th Ave, Sequim",
    "address": "251 S. 5th Ave., Sequim"
  },
  {
    "id": 3129,
    "financing": "Federally subsidized",
    "building_name": "Sunny Acres Senior Housing",
    "latitude": 48.273905,
    "longitude": -117.71152,
    "original_address": "401 South 5th St. East",
    "building_number": 401,
    "street": "E 5th St S",
    "city": "Chewelah",
    "zip": 99109,
    "concatenated_address": "401 E 5th St S, Chewelah",
    "address": "401 E. 5th St. S., Chewelah"
  },
  {
    "id": 3130,
    "financing": "Federally subsidized",
    "building_name": "Sunny View Village",
    "latitude": 48.005336,
    "longitude": -122.52533,
    "original_address": "1667 Scenic Avenue",
    "building_number": 1667,
    "street": "Scenic Ave",
    "city": "Freeland",
    "zip": 98277,
    "concatenated_address": "1667 Scenic Ave, Freeland",
    "address": "1667 Scenic Ave., Freeland"
  },
  {
    "id": 3131,
    "financing": "Federally subsidized",
    "building_name": "Sunnyside Manor I",
    "latitude": 46.319428,
    "longitude": -120.01523,
    "original_address": "808 South Fourth Street",
    "building_number": 808,
    "street": "S 4th St",
    "city": "Sunnyside",
    "zip": 98944,
    "concatenated_address": "808 S 4th St, Sunnyside",
    "address": "808 S. 4th St., Sunnyside"
  },
  {
    "id": 3132,
    "financing": "Federally subsidized",
    "building_name": "Sunnyside Manor II",
    "latitude": 46.318694,
    "longitude": -120.01526,
    "original_address": "906 S Fourth St",
    "building_number": 906,
    "street": "S 4th St",
    "city": "Sunnyside",
    "zip": 98944,
    "concatenated_address": "906 S 4th St, Sunnyside",
    "address": "906 S. 4th St., Sunnyside"
  },
  {
    "id": 3133,
    "financing": "Federally subsidized",
    "building_name": "Sunnyview Apartments",
    "latitude": 46.331595,
    "longitude": -120.0027,
    "original_address": "1314 North Avenue",
    "building_number": 1314,
    "street": "North Ave",
    "city": "Sunnyside",
    "zip": 98944,
    "concatenated_address": "1314 North Ave, Sunnyside",
    "address": "1314 North Ave., Sunnyside"
  },
  {
    "id": 3134,
    "financing": "Federally subsidized",
    "building_name": "Sunridge Apartments",
    "latitude": 46.333548,
    "longitude": -120.00357,
    "original_address": "700 Bagley Drive",
    "building_number": 700,
    "street": "Bagley Dr",
    "city": "Sunnyside",
    "zip": 98944,
    "concatenated_address": "700 Bagley Dr, Sunnyside",
    "address": "700 Bagley Drive, Sunnyside"
  },
  {
    "id": 3135,
    "financing": "Federally subsidized",
    "building_name": "Sunset Court Apartments",
    "latitude": 48.748055,
    "longitude": -122.48012,
    "original_address": "1133 Railroad Ave",
    "building_number": 1133,
    "street": "Railroad Ave",
    "city": "Bellingham",
    "zip": 98225,
    "concatenated_address": "1133 Railroad Ave, Bellingham",
    "address": "1133 Railroad Ave., Bellingham"
  },
  {
    "id": 3136,
    "financing": "Federally subsidized",
    "building_name": "Sunset Garden Apartments",
    "latitude": 47.166384,
    "longitude": -122.2904,
    "original_address": "201 27th Avenue Se",
    "building_number": 201,
    "street": "27th Ave SE",
    "city": "Puyallup",
    "zip": 98374,
    "concatenated_address": "201 27th Ave SE, Puyallup",
    "address": "201 27th Ave. S.E., Puyallup"
  },
  {
    "id": 3137,
    "financing": "Federally subsidized",
    "building_name": "Sunset Meadows Family Housing",
    "latitude": 47.250639,
    "longitude": -122.3021,
    "original_address": "2390 Milton Way",
    "building_number": 2390,
    "street": "Milton Way",
    "city": "Milton",
    "zip": 98354,
    "concatenated_address": "2390 Milton Way, Milton",
    "address": "2390 Milton Way, Milton"
  },
  {
    "id": 3138,
    "financing": "Federally subsidized",
    "building_name": "Sunset Pointe Apartments",
    "latitude": 47.487417,
    "longitude": -122.19167,
    "original_address": "330 Vuemont Place Ne",
    "building_number": 330,
    "street": "Vuemont Pl NE",
    "city": "Renton",
    "zip": "98056-3602",
    "concatenated_address": "330 Vuemont Pl NE, Renton",
    "address": "330 Vuemont Pl N.E., Renton"
  },
  {
    "id": 3139,
    "financing": "Federally subsidized",
    "building_name": "Sunset Ridge Apartments",
    "latitude": 47.433594,
    "longitude": -120.2958,
    "original_address": "1800 Aurora Avenue",
    "building_number": 1800,
    "street": "N Aurora Ave",
    "city": "East Wenatchee",
    "zip": 98802,
    "concatenated_address": "1800 N Aurora Ave, East Wenatchee",
    "address": "1800 N. Aurora Ave., East Wenatchee"
  },
  {
    "id": 3140,
    "financing": "Federally subsidized",
    "building_name": "Surf Pines Apartments",
    "latitude": 46.310273,
    "longitude": -124.04395,
    "original_address": "141 1st Ave. N.",
    "building_number": 141,
    "street": "1st Ave N",
    "city": "Ilwaco",
    "zip": 98624,
    "concatenated_address": "141 1st Ave N, Ilwaco",
    "address": "141 1st Ave. N., Ilwaco"
  },
  {
    "id": 3141,
    "financing": "Federally subsidized",
    "building_name": "Surina Meadows",
    "latitude": 48.531433,
    "longitude": -123.01278,
    "original_address": "535 S. Linder St",
    "building_number": 535,
    "street": "Linder St",
    "city": "Friday Harbor",
    "zip": 98250,
    "concatenated_address": "535 Linder St, Friday Harbor",
    "address": "535 Linder St., Friday Harbor"
  },
  {
    "id": 3142,
    "financing": "Federally subsidized",
    "building_name": "Swifty Creek",
    "latitude": 47.920683,
    "longitude": -122.09326,
    "original_address": "707 Avenue A",
    "building_number": 707,
    "street": "Ave A",
    "city": "Snohomish",
    "zip": 98290,
    "concatenated_address": "707 Ave A, Snohomish",
    "address": "707 Ave. A, Snohomish"
  },
  {
    "id": 3143,
    "financing": "Federally subsidized",
    "building_name": "Sylvia Odom'S Place",
    "latitude": 47.612558,
    "longitude": -122.34158,
    "original_address": "2013 3rd Avenue",
    "building_number": 2013,
    "street": "3rd Ave",
    "city": "Seattle",
    "zip": 98121,
    "concatenated_address": "2013 3rd Ave, Seattle",
    "address": "2013 3rd Ave., Seattle"
  },
  {
    "id": 3144,
    "financing": "Federally subsidized",
    "building_name": "Tahoma View",
    "latitude": 47.154659,
    "longitude": -122.43048,
    "original_address": "11212 1st Avenue Court East",
    "building_number": 11212,
    "street": "1st Ave Ct E",
    "city": "Tacoma",
    "zip": 98444,
    "concatenated_address": "11212 1st Ave Ct E, Tacoma",
    "address": "11212 1st Ave. Ct E., Tacoma"
  },
  {
    "id": 3145,
    "financing": "Federally subsidized",
    "building_name": "Talon Hills Seniors",
    "latitude": 47.683485,
    "longitude": -117.06917,
    "original_address": "24950 Hawkstone Loop",
    "building_number": 24950,
    "street": "E Hawkstone Loop",
    "city": "Liberty Lake",
    "zip": "99019-5007",
    "concatenated_address": "24950 E Hawkstone Loop, Liberty Lake",
    "address": "24950 E. Hawkstone Loop, Liberty Lake"
  },
  {
    "id": 3146,
    "financing": "Federally subsidized",
    "building_name": "Tamarack Place",
    "latitude": 47.561579,
    "longitude": -122.29339,
    "original_address": "4626 Martin Luther King Jr. Way S.",
    "building_number": 4626,
    "street": "Martin Luther King Jr Way S",
    "city": "Seattle",
    "zip": 98108,
    "concatenated_address": "4626 Martin Luther King Jr Way S, Seattle",
    "address": "4626 Martin Luther King Jr Way S., Seattle"
  },
  {
    "id": 3147,
    "financing": "Federally subsidized",
    "building_name": "Tashiro Kaplan Artist Lofts",
    "latitude": 47.601284,
    "longitude": -122.32969,
    "original_address": "115 Prefontaine Place South",
    "building_number": 115,
    "street": "Prefontaine Pl S",
    "city": "Seattle",
    "zip": 98104,
    "concatenated_address": "115 Prefontaine Pl S, Seattle",
    "address": "115 Prefontaine Pl S., Seattle"
  },
  {
    "id": 3148,
    "financing": "Federally subsidized",
    "building_name": "Tate Mason",
    "latitude": 47.611146,
    "longitude": -122.3249,
    "original_address": "1100 Minor Avenue",
    "building_number": 1100,
    "street": "Minor Ave",
    "city": "Seattle",
    "zip": 98122,
    "concatenated_address": "1100 Minor Ave, Seattle",
    "address": "1100 Minor Ave., Seattle"
  },
  {
    "id": 3149,
    "financing": "Federally subsidized",
    "building_name": "Tate Mason House",
    "latitude": 47.611146,
    "longitude": -122.3249,
    "original_address": "1100 Minor Avenue",
    "building_number": 1100,
    "street": "Minor Ave",
    "city": "Seattle",
    "zip": 98101,
    "concatenated_address": "1100 Minor Ave, Seattle",
    "address": "1100 Minor Ave., Seattle"
  },
  {
    "id": 3150,
    "financing": "Federally subsidized",
    "building_name": "Teal Pointe Apartments",
    "latitude": 45.696018,
    "longitude": -122.66233,
    "original_address": "10405 Ne 9th Ave",
    "building_number": 10405,
    "street": "NE 9th Ave",
    "city": "Vancouver",
    "zip": 98686,
    "concatenated_address": "10405 NE 9th Ave, Vancouver",
    "address": "10405 N.E. 9th Ave., Vancouver"
  },
  {
    "id": 3151,
    "financing": "Federally subsidized",
    "building_name": "Tekoa Retirement Apartments",
    "latitude": 47.230521,
    "longitude": -117.08334,
    "original_address": "540 N. Madison",
    "building_number": 540,
    "street": "Madison St",
    "city": "Tekoa",
    "zip": 99033,
    "concatenated_address": "540 Madison St, Tekoa",
    "address": "540 Madison St., Tekoa"
  },
  {
    "id": 3152,
    "financing": "Federally subsidized",
    "building_name": "Tepeyac Haven",
    "latitude": 46.236663,
    "longitude": -119.11938,
    "original_address": "801 N 22nd Ave",
    "building_number": 801,
    "street": "N 22nd Ave",
    "city": "Pasco",
    "zip": 99301,
    "concatenated_address": "801 N 22nd Ave, Pasco",
    "address": "801 N. 22nd Ave., Pasco"
  },
  {
    "id": 3153,
    "financing": "Federally subsidized",
    "building_name": "Terrace Apartments",
    "latitude": 47.398629,
    "longitude": -122.29751,
    "original_address": "22620 28th Avenue S",
    "building_number": 22620,
    "street": "28th Ave S",
    "city": "Seattle",
    "zip": "98198-4409",
    "concatenated_address": "22620 28th Ave S, Seattle",
    "address": "22620 28th Ave. S., Seattle"
  },
  {
    "id": 3154,
    "financing": "Federally subsidized",
    "building_name": "Terrace Hill Apartments",
    "latitude": 47.680871,
    "longitude": -122.12055,
    "original_address": "8704 164th Avenue Ne",
    "building_number": 8704,
    "street": "164th Ave NE",
    "city": "Redmond",
    "zip": 98052,
    "concatenated_address": "8704 164th Ave NE, Redmond",
    "address": "8704 164th Ave. N.E., Redmond"
  },
  {
    "id": 3155,
    "financing": "Federally subsidized",
    "building_name": "Terrace Manor",
    "latitude": 47.41406,
    "longitude": -120.28911,
    "original_address": "657 N Baker Ave",
    "building_number": 657,
    "street": "N Baker Ave",
    "city": "East Wenatchee",
    "zip": 98802,
    "concatenated_address": "657 N Baker Ave, East Wenatchee",
    "address": "657 N. Baker Ave., East Wenatchee"
  },
  {
    "id": 3156,
    "financing": "Federally subsidized",
    "building_name": "Terre View Apartments",
    "latitude": 46.747513,
    "longitude": -117.16932,
    "original_address": "555 Ne Terre View Dr",
    "building_number": 555,
    "street": "NE Terre View Dr",
    "city": "Pullman",
    "zip": 99163,
    "concatenated_address": "555 NE Terre View Dr, Pullman",
    "address": "555 N.E. Terre View Drive, Pullman"
  },
  {
    "id": 3157,
    "financing": "Federally subsidized",
    "building_name": "Texada Apartments",
    "latitude": 47.612406,
    "longitude": -122.3151,
    "original_address": "1128 13Th Avenue",
    "building_number": 1128,
    "street": "13th Ave",
    "city": "Seattle",
    "zip": 98122,
    "concatenated_address": "1128 13th Ave, Seattle",
    "address": "1128 13th Ave., Seattle"
  },
  {
    "id": 3158,
    "financing": "Federally subsidized",
    "building_name": "The Annobee Apartments",
    "latitude": 47.263221,
    "longitude": -122.45408,
    "original_address": "319 North \"I\" Street",
    "building_number": 319,
    "street": "N I St",
    "city": "Tacoma",
    "zip": 98403,
    "concatenated_address": "319 N I St, Tacoma",
    "address": "319 N. I St., Tacoma"
  },
  {
    "id": 3159,
    "financing": "Federally subsidized",
    "building_name": "The Claremont",
    "latitude": 47.573182,
    "longitude": -122.29454,
    "original_address": "3333 Rainier Avenue South",
    "building_number": 3333,
    "street": "Rainier Ave S",
    "city": "Seattle",
    "zip": 98144,
    "concatenated_address": "3333 Rainier Ave S, Seattle",
    "address": "3333 Rainier Ave. S., Seattle"
  },
  {
    "id": 3160,
    "financing": "Federally subsidized",
    "building_name": "The Commons Apartments",
    "latitude": 46.251638,
    "longitude": -119.90762,
    "original_address": "501 W. 5th Street",
    "building_number": 501,
    "street": "W 5th St",
    "city": "Grandview",
    "zip": 98930,
    "concatenated_address": "501 W 5th St, Grandview",
    "address": "501 W. 5th St., Grandview"
  },
  {
    "id": 3161,
    "financing": "Federally subsidized",
    "building_name": "The Dakota At Rainier Court",
    "latitude": 47.570292,
    "longitude": -122.29024,
    "original_address": "3651 34th Avenue S",
    "building_number": 3651,
    "street": "34th Ave S",
    "city": "Seattle",
    "zip": 98144,
    "concatenated_address": "3651 34th Ave S, Seattle",
    "address": "3651 34th Ave. S., Seattle"
  },
  {
    "id": 3162,
    "financing": "Federally subsidized",
    "building_name": "The Delaney Apartments",
    "latitude": 47.658176,
    "longitude": -117.41515,
    "original_address": "242 W Riverside Avenue",
    "building_number": 242,
    "street": "W Riverside Ave",
    "city": "Spokane",
    "zip": 99201,
    "concatenated_address": "242 W Riverside Ave, Spokane",
    "address": "242 W. Riverside Ave., Spokane"
  },
  {
    "id": 3163,
    "financing": "Federally subsidized",
    "building_name": "The District",
    "latitude": 47.836463,
    "longitude": -122.21407,
    "original_address": "17716 Bothell Everett Highway",
    "building_number": 17716,
    "street": "Bothell Everett Hwy",
    "city": "Bothell",
    "zip": 98012,
    "concatenated_address": "17716 Bothell Everett Hwy, Bothell",
    "address": "17716 Bothell Everett Highway, Bothell"
  },
  {
    "id": 3164,
    "financing": "Federally subsidized",
    "building_name": "The District",
    "latitude": 47.836463,
    "longitude": -122.21407,
    "original_address": "17716 Bothell Everett Hwy",
    "building_number": 17716,
    "street": "Bothell Everett Hwy",
    "city": "Bothell",
    "zip": 98012,
    "concatenated_address": "17716 Bothell Everett Hwy, Bothell",
    "address": "17716 Bothell Everett Highway, Bothell"
  },
  {
    "id": 3165,
    "financing": "Federally subsidized",
    "building_name": "The Douglas",
    "latitude": 47.810334,
    "longitude": -122.30084,
    "original_address": "5031 208th Street Sw",
    "building_number": 5031,
    "street": "208th St SW",
    "city": "Lynnwood",
    "zip": 98036,
    "concatenated_address": "5031 208th St SW, Lynnwood",
    "address": "5031 208th St. S.W., Lynnwood"
  },
  {
    "id": 3166,
    "financing": "Federally subsidized",
    "building_name": "The Eagles",
    "latitude": 47.610885,
    "longitude": -122.33225,
    "original_address": "706 Union Street",
    "building_number": 706,
    "street": "Union St",
    "city": "Seattle",
    "zip": 98101,
    "concatenated_address": "706 Union St, Seattle",
    "address": "706 Union St., Seattle"
  },
  {
    "id": 3167,
    "financing": "Federally subsidized",
    "building_name": "The Estates At Hillside Gardens",
    "latitude": 47.291139,
    "longitude": -122.20981,
    "original_address": "1919 Howard Road",
    "building_number": 1919,
    "street": "Howard Rd",
    "city": "Auburn",
    "zip": 98002,
    "concatenated_address": "1919 Howard Rd, Auburn",
    "address": "1919 Howard Road, Auburn"
  },
  {
    "id": 3168,
    "financing": "Federally subsidized",
    "building_name": "The Falls",
    "latitude": 48.605841,
    "longitude": -118.0485,
    "original_address": "550 East 8th Avenue",
    "building_number": 550,
    "street": "E 8th Ave",
    "city": "Kettle Falls",
    "zip": 99141,
    "concatenated_address": "550 E 8th Ave, Kettle Falls",
    "address": "550 E. 8th Ave., Kettle Falls"
  },
  {
    "id": 3169,
    "financing": "Federally subsidized",
    "building_name": "The Grand Hotel",
    "latitude": 46.602856,
    "longitude": -120.50239,
    "original_address": "308 E Yakima Ave",
    "building_number": 308,
    "street": "E Yakima Ave",
    "city": "Yakima",
    "zip": 98901,
    "concatenated_address": "308 E Yakima Ave, Yakima",
    "address": "308 E. Yakima Ave., Yakima"
  },
  {
    "id": 3170,
    "financing": "Federally subsidized",
    "building_name": "The Highlands",
    "latitude": 48.539788,
    "longitude": -117.88846,
    "original_address": "542 South Summit",
    "building_number": 542,
    "street": "S Summit St",
    "city": "Colville",
    "zip": 99114,
    "concatenated_address": "542 S Summit St, Colville",
    "address": "542 S. Summit St., Colville"
  },
  {
    "id": 3171,
    "financing": "Federally subsidized",
    "building_name": "The Jefferson",
    "latitude": 47.606343,
    "longitude": -122.31639,
    "original_address": "1206 E. Jefferson St.",
    "building_number": 1206,
    "street": "E Jefferson St",
    "city": "Seattle",
    "zip": 98122,
    "concatenated_address": "1206 E Jefferson St, Seattle",
    "address": "1206 E. Jefferson St., Seattle"
  },
  {
    "id": 3172,
    "financing": "Federally subsidized",
    "building_name": "The Marilee",
    "latitude": 47.654386,
    "longitude": -117.41511,
    "original_address": "217-233 2nd Avenue",
    "building_number": 217,
    "street": "W 2nd Ave",
    "city": "Spokane",
    "zip": 99201,
    "concatenated_address": "217 W 2nd Ave, Spokane",
    "address": "217 W. 2nd Ave., Spokane"
  },
  {
    "id": 3173,
    "financing": "Federally subsidized",
    "building_name": "The Meadows",
    "latitude": 48.809013,
    "longitude": -122.50021,
    "original_address": "355 Meadowbrook Court",
    "building_number": 355,
    "street": "Meadowbrook Ct",
    "city": "Bellingham",
    "zip": "98226-7368",
    "concatenated_address": "355 Meadowbrook Ct, Bellingham",
    "address": "355 Meadowbrook Ct, Bellingham"
  },
  {
    "id": 3174,
    "financing": "Federally subsidized",
    "building_name": "The Meadows On Lea Hill",
    "latitude": 47.321996,
    "longitude": -122.17431,
    "original_address": "12525 Se 312th Street",
    "building_number": 12525,
    "street": "SE 312th St",
    "city": "Auburn",
    "zip": "98092-3306",
    "concatenated_address": "12525 SE 312th St, Auburn",
    "address": "12525 S.E. 312th St., Auburn"
  },
  {
    "id": 3175,
    "financing": "Federally subsidized",
    "building_name": "The O'Malley Apartments",
    "latitude": 47.67211,
    "longitude": -117.39875,
    "original_address": "707 E. Mission",
    "building_number": 707,
    "street": "E Mission Ave",
    "city": "Spokane",
    "zip": 99202,
    "concatenated_address": "707 E Mission Ave, Spokane",
    "address": "707 E. Mission Ave., Spokane"
  },
  {
    "id": 3176,
    "financing": "Federally subsidized",
    "building_name": "The Oleta Apartments",
    "latitude": 47.618337,
    "longitude": -122.32641,
    "original_address": "1816 Bellevue Avenue",
    "building_number": 1816,
    "street": "Bellevue Ave",
    "city": "Seattle",
    "zip": 98122,
    "concatenated_address": "1816 Bellevue Ave, Seattle",
    "address": "1816 Bellevue Ave., Seattle"
  },
  {
    "id": 3177,
    "financing": "Federally subsidized",
    "building_name": "The Outlook",
    "latitude": 46.733484,
    "longitude": -117.17638,
    "original_address": "620 Ne Kamiaken St.",
    "building_number": 620,
    "street": "NE Kamiaken St",
    "city": "Pullman",
    "zip": 99163,
    "concatenated_address": "620 NE Kamiaken St, Pullman",
    "address": "620 N.E. Kamiaken St., Pullman"
  },
  {
    "id": 3178,
    "financing": "Federally subsidized",
    "building_name": "The Parker",
    "latitude": 47.644318,
    "longitude": -122.36122,
    "original_address": "2701 3rd Avenue W",
    "building_number": 2701,
    "street": "3rd Ave W",
    "city": "Seattle",
    "zip": 98119,
    "concatenated_address": "2701 3rd Ave W, Seattle",
    "address": "2701 3rd Ave. W., Seattle"
  },
  {
    "id": 3179,
    "financing": "Federally subsidized",
    "building_name": "The Reserve At Everett",
    "latitude": 47.917749,
    "longitude": -122.23345,
    "original_address": "8920 Evergreen Way",
    "building_number": 8920,
    "street": "Evergree Way",
    "city": "Everett",
    "zip": 98208,
    "concatenated_address": "8920 Evergree Way, Everett",
    "address": "8920 Evergree Way, Everett"
  },
  {
    "id": 3180,
    "financing": "Federally subsidized",
    "building_name": "The Reserve At Renton",
    "latitude": 47.489215,
    "longitude": -122.21807,
    "original_address": "325 Rainier Avenue S",
    "building_number": 325,
    "street": "Rainier Ave S",
    "city": "Renton",
    "zip": 98057,
    "concatenated_address": "325 Rainier Ave S, Renton",
    "address": "325 Rainier Ave. S., Renton"
  },
  {
    "id": 3181,
    "financing": "Federally subsidized",
    "building_name": "The Reserve At Seatac",
    "latitude": 47.425222,
    "longitude": -122.29666,
    "original_address": "19707 International Blvd",
    "building_number": 19707,
    "street": "International Blvd",
    "city": "Seattle",
    "zip": 98188,
    "concatenated_address": "19707 International Blvd, Seattle",
    "address": "19707 International Blvd., Seattle"
  },
  {
    "id": 3182,
    "financing": "Federally subsidized",
    "building_name": "The Timbers",
    "latitude": 48.186664,
    "longitude": -122.11428,
    "original_address": "8510 212th Street Ne",
    "building_number": 8510,
    "street": "212th St NE",
    "city": "Arlington",
    "zip": "98223-4611",
    "concatenated_address": "8510 212th St NE, Arlington",
    "address": "8510 212th St. N.E., Arlington"
  },
  {
    "id": 3183,
    "financing": "Federally subsidized",
    "building_name": "The Villas Of Bridge Creek",
    "latitude": 45.636483,
    "longitude": -122.63007,
    "original_address": "2011 Brandt Road",
    "building_number": 2011,
    "street": "Brandt Rd",
    "city": "Vancouver",
    "zip": "98661-5764",
    "concatenated_address": "2011 Brandt Rd, Vancouver",
    "address": "2011 Brandt Road, Vancouver"
  },
  {
    "id": 3184,
    "financing": "Federally subsidized",
    "building_name": "The Vineyard Apartments",
    "latitude": 46.734544,
    "longitude": -119.89522,
    "original_address": "825 Third Pl",
    "building_number": 825,
    "street": "3rd Pl",
    "city": "Mattawa",
    "zip": "",
    "concatenated_address": "825 3rd Pl, Mattawa",
    "address": "825 3rd Place, Mattawa"
  },
  {
    "id": 3185,
    "financing": "Federally subsidized",
    "building_name": "The Winthrop",
    "latitude": 47.25598,
    "longitude": -122.44018,
    "original_address": "776 Commerce Street",
    "building_number": 776,
    "street": "Commerce St",
    "city": "Tacoma",
    "zip": 98402,
    "concatenated_address": "776 Commerce St, Tacoma",
    "address": "776 Commerce St., Tacoma"
  },
  {
    "id": 3186,
    "financing": "Federally subsidized",
    "building_name": "Third & Virginia",
    "latitude": 47.612558,
    "longitude": -122.34158,
    "original_address": "2013 Third Ave",
    "building_number": 2013,
    "street": "3rd Ave",
    "city": "Seattle",
    "zip": 98121,
    "concatenated_address": "2013 3rd Ave, Seattle",
    "address": "2013 3rd Ave., Seattle"
  },
  {
    "id": 3187,
    "financing": "Federally subsidized",
    "building_name": "Third Avenue",
    "latitude": 47.241778,
    "longitude": -119.84696,
    "original_address": "300 E Street Ne",
    "building_number": 300,
    "street": "E St NE",
    "city": "Quincy",
    "zip": 98848,
    "concatenated_address": "300 E St NE, Quincy",
    "address": "300 E. St. N.E., Quincy"
  },
  {
    "id": 3188,
    "financing": "Federally subsidized",
    "building_name": "Thompson Homes",
    "latitude": 47.309419,
    "longitude": -122.23071,
    "original_address": "210 A Street Nw",
    "building_number": 210,
    "street": "A St NW",
    "city": "Auburn",
    "zip": 98001,
    "concatenated_address": "210 A St NW, Auburn",
    "address": "210 A St. N.W., Auburn"
  },
  {
    "id": 3189,
    "financing": "Federally subsidized",
    "building_name": "Three Mountain Village",
    "latitude": 45.819482,
    "longitude": -120.83204,
    "original_address": "613 W. Colllins",
    "building_number": 613,
    "street": "W Collins St",
    "city": "Goldendale",
    "zip": 98620,
    "concatenated_address": "613 W Collins St, Goldendale",
    "address": "613 W. Collins St., Goldendale"
  },
  {
    "id": 3190,
    "financing": "Federally subsidized",
    "building_name": "Three Plex",
    "latitude": 47.546145,
    "longitude": -122.30151,
    "original_address": "2417 S Graham St",
    "building_number": 2417,
    "street": "S Graham St",
    "city": "Seattle",
    "zip": 98108,
    "concatenated_address": "2417 S Graham St, Seattle",
    "address": "2417 S. Graham St., Seattle"
  },
  {
    "id": 3191,
    "financing": "Federally subsidized",
    "building_name": "Three Rivers Village",
    "latitude": 46.29974,
    "longitude": -119.27948,
    "original_address": "651 Mcmurray Street",
    "building_number": 651,
    "street": "McMurray St",
    "city": "Richland",
    "zip": 99354,
    "concatenated_address": "651 McMurray St, Richland",
    "address": "651 McMurray St., Richland"
  },
  {
    "id": 3192,
    "financing": "Federally subsidized",
    "building_name": "Ticino",
    "latitude": 47.601884,
    "longitude": -122.32946,
    "original_address": "100 Sixth Avenue S",
    "building_number": "",
    "street": "",
    "city": "Seattle",
    "zip": 98104,
    "concatenated_address": "100 Sixth Avenue S, Seattle",
    "address": "100 Sixth Avenue S., Seattle"
  },
  {
    "id": 3193,
    "financing": "Federally subsidized",
    "building_name": "Tilton River Court",
    "latitude": 46.555779,
    "longitude": -122.27384,
    "original_address": "302 First Street",
    "building_number": 302,
    "street": "1st St",
    "city": "Morton",
    "zip": 98356,
    "concatenated_address": "302 1st St, Morton",
    "address": "302 1st St., Morton"
  },
  {
    "id": 3194,
    "financing": "Federally subsidized",
    "building_name": "Time Square",
    "latitude": 47.800618,
    "longitude": -122.49684,
    "original_address": "26234 Illinois Avenue Ne",
    "building_number": 26234,
    "street": "Illinois Ave NE",
    "city": "Kingston",
    "zip": 98346,
    "concatenated_address": "26234 Illinois Ave NE, Kingston",
    "address": "26234 Illinois Ave. N.E., Kingston"
  },
  {
    "id": 3195,
    "financing": "Federally subsidized",
    "building_name": "Titus Court Apartments",
    "latitude": 47.380073,
    "longitude": -122.23917,
    "original_address": "233 Fifth Avenue S",
    "building_number": 233,
    "street": "5th Ave S",
    "city": "Kent",
    "zip": 98032,
    "concatenated_address": "233 5th Ave S, Kent",
    "address": "233 5th Ave. S., Kent"
  },
  {
    "id": 3196,
    "financing": "Federally subsidized",
    "building_name": "Titusville Station",
    "latitude": 47.380695,
    "longitude": -122.23388,
    "original_address": "205 1/2 First Avenue S",
    "building_number": 205,
    "street": "1st Ave S",
    "city": "Kent",
    "zip": 98032,
    "concatenated_address": "205 1st Ave S, Kent",
    "address": "205 1st Ave. S., Kent"
  },
  {
    "id": 3197,
    "financing": "Federally subsidized",
    "building_name": "Tolmie Cove",
    "latitude": 47.076561,
    "longitude": -122.78335,
    "original_address": "7245 32nd Ave",
    "building_number": 7245,
    "street": "32nd Ave NE",
    "city": "Olympia",
    "zip": 98516,
    "concatenated_address": "7245 32nd Ave NE, Olympia",
    "address": "7245 32nd Ave. N.E., Olympia"
  },
  {
    "id": 3198,
    "financing": "Federally subsidized",
    "building_name": "Tomason Place",
    "latitude": 46.730331,
    "longitude": -117.21803,
    "original_address": "550 Ne Terreview Dr",
    "building_number": "",
    "street": "",
    "city": "Pullman",
    "zip": 99163,
    "concatenated_address": "550 Ne Terreview Dr, Pullman",
    "address": "550 Ne Terreview Drive, Pullman"
  },
  {
    "id": 3199,
    "financing": "Federally subsidized",
    "building_name": "Tomason Place Ii",
    "latitude": 46.751714,
    "longitude": -117.18551,
    "original_address": "755 Ne Terre View Dr",
    "building_number": 755,
    "street": "NW Terre View Dr",
    "city": "Pullman",
    "zip": 99163,
    "concatenated_address": "755 NW Terre View Dr, Pullman",
    "address": "755 N.W. Terre View Drive, Pullman"
  },
  {
    "id": 3200,
    "financing": "Federally subsidized",
    "building_name": "Tonasket Gardens",
    "latitude": 48.700874,
    "longitude": -119.4397,
    "original_address": "706 S Antwine Ave",
    "building_number": 706,
    "street": "S Antwine Ave",
    "city": "Tonasket",
    "zip": 98855,
    "concatenated_address": "706 S Antwine Ave, Tonasket",
    "address": "706 S. Antwine Ave., Tonasket"
  },
  {
    "id": 3201,
    "financing": "Federally subsidized",
    "building_name": "Tony Lee",
    "latitude": 47.721114,
    "longitude": -122.29649,
    "original_address": "12705 30th Avenue Ne",
    "building_number": 12705,
    "street": "30th Ave NE",
    "city": "Seattle",
    "zip": 98125,
    "concatenated_address": "12705 30th Ave NE, Seattle",
    "address": "12705 30th Ave. N.E., Seattle"
  },
  {
    "id": 3202,
    "financing": "Federally subsidized",
    "building_name": "Toppenish Family Housing",
    "latitude": 46.37753,
    "longitude": -120.32213,
    "original_address": "800-828 Guyette Avenue",
    "building_number": 800,
    "street": "Guyette Ln",
    "city": "Toppenish",
    "zip": 98948,
    "concatenated_address": "800 Guyette Ln, Toppenish",
    "address": "800 Guyette Lane, Toppenish"
  },
  {
    "id": 3203,
    "financing": "Federally subsidized",
    "building_name": "Towne Square Apartments",
    "latitude": 45.581549,
    "longitude": -122.33985,
    "original_address": "2900 H Street",
    "building_number": 2900,
    "street": "H St",
    "city": "Washougal",
    "zip": 98671,
    "concatenated_address": "2900 H St, Washougal",
    "address": "2900 H St., Washougal"
  },
  {
    "id": 3204,
    "financing": "Federally subsidized",
    "building_name": "Trailside Village",
    "latitude": 47.907271,
    "longitude": -122.21859,
    "original_address": "1300 100th Pl Se",
    "building_number": 1300,
    "street": "100th St SE",
    "city": "Everett",
    "zip": 98208,
    "concatenated_address": "1300 100th St SE, Everett",
    "address": "1300 100th St. S.E., Everett"
  },
  {
    "id": 3205,
    "financing": "Federally subsidized",
    "building_name": "Traugott Terrace",
    "latitude": 47.614765,
    "longitude": -122.34563,
    "original_address": "2317 Third Avenue",
    "building_number": 2317,
    "street": "3rd Ave",
    "city": "Seattle",
    "zip": 98121,
    "concatenated_address": "2317 3rd Ave, Seattle",
    "address": "2317 3rd Ave., Seattle"
  },
  {
    "id": 3206,
    "financing": "Federally subsidized",
    "building_name": "Tressa Apartments",
    "latitude": 47.732008,
    "longitude": -122.34747,
    "original_address": "14200 Linden Avenue N",
    "building_number": 14200,
    "street": "Linden Ave N",
    "city": "Seattle",
    "zip": 98133,
    "concatenated_address": "14200 Linden Ave N, Seattle",
    "address": "14200 Linden Ave. N., Seattle"
  },
  {
    "id": 3207,
    "financing": "Federally subsidized",
    "building_name": "Tri-Court Senior Apartments",
    "latitude": 47.38246,
    "longitude": -122.25284,
    "original_address": "24420 64th Avenue S",
    "building_number": 24420,
    "street": "64th Ave S",
    "city": "Kent",
    "zip": 98032,
    "concatenated_address": "24420 64th Ave S, Kent",
    "address": "24420 64th Ave. S., Kent"
  },
  {
    "id": 3208,
    "financing": "Federally subsidized",
    "building_name": "Tri-Park Residential",
    "latitude": 47.159726,
    "longitude": -122.43241,
    "original_address": "10708 A Street S",
    "building_number": 10708,
    "street": "A St S",
    "city": "Tacoma",
    "zip": 98444,
    "concatenated_address": "10708 A St S, Tacoma",
    "address": "10708 A St. S., Tacoma"
  },
  {
    "id": 3209,
    "financing": "Federally subsidized",
    "building_name": "True Vine Senior Citizen Center",
    "latitude": 47.247871,
    "longitude": -122.47279,
    "original_address": "1819 So. Mason",
    "building_number": "",
    "street": "",
    "city": "Tacoma",
    "zip": 98405,
    "concatenated_address": "1819 So. Mason, Tacoma",
    "address": "1819 So. Mason, Tacoma"
  },
  {
    "id": 3210,
    "financing": "Federally subsidized",
    "building_name": "Tschirley Crossing",
    "latitude": 47.655209,
    "longitude": -117.16783,
    "original_address": "111 South Tschirley Rd",
    "building_number": 111,
    "street": "S Tschirley Rd",
    "city": "Greenacres",
    "zip": "99016-9342",
    "concatenated_address": "111 S Tschirley Rd, Greenacres",
    "address": "111 S. Tschirley Road, Greenacres"
  },
  {
    "id": 3211,
    "financing": "Federally subsidized",
    "building_name": "Tschirley Crossing - Phase II",
    "latitude": 47.655658,
    "longitude": -117.16941,
    "original_address": "107 S Tschirley Rd",
    "building_number": 107,
    "street": "S Tschirley Rd",
    "city": "Greenacres",
    "zip": 99016,
    "concatenated_address": "107 S Tschirley Rd, Greenacres",
    "address": "107 S. Tschirley Road, Greenacres"
  },
  {
    "id": 3212,
    "financing": "Federally subsidized",
    "building_name": "Tukwila Village Phase I Senior Living",
    "latitude": 47.474227,
    "longitude": -122.28439,
    "original_address": "14400 Tukwila International Blvd And 4450 South 144th Street",
    "building_number": "",
    "street": "S 144th St",
    "city": "Seattle",
    "zip": 98168,
    "concatenated_address": "14400 Tukwila International Blvd And 4450 South 144th Street, Seattle",
    "address": "14400 Tukwila International Blvd And 4450 South 144th St., Seattle"
  },
  {
    "id": 3213,
    "financing": "Federally subsidized",
    "building_name": "Tulalip Homes I",
    "latitude": 48.131063,
    "longitude": -122.25491,
    "original_address": "8205 16th Avenue Nw",
    "building_number": "",
    "street": "16th Ave NW",
    "city": "Marysville",
    "zip": 98271,
    "concatenated_address": "8205 16th Avenue Nw, Marysville",
    "address": "8205 16th Avenue N.W., Marysville"
  },
  {
    "id": 3214,
    "financing": "Federally subsidized",
    "building_name": "Tulalip Homes II",
    "latitude": 48.063701,
    "longitude": -122.27385,
    "original_address": "7412 Larry Price Loop Rd",
    "building_number": 7412,
    "street": "Larry Price Loop Rd",
    "city": "Marysville",
    "zip": 98271,
    "concatenated_address": "7412 Larry Price Loop Rd, Marysville",
    "address": "7412 Larry Price Loop Road, Marysville"
  },
  {
    "id": 3215,
    "financing": "Federally subsidized",
    "building_name": "Tulalip Homes III",
    "latitude": 48.07033,
    "longitude": -122.25507,
    "original_address": "1729 - 83rd Street Nw",
    "building_number": 1710,
    "street": "83rd St NW",
    "city": "Marysville",
    "zip": 98271,
    "concatenated_address": "1710 83rd St NW, Marysville",
    "address": "1710 83rd St. N.W., Marysville"
  },
  {
    "id": 3216,
    "financing": "Federally subsidized",
    "building_name": "Twin Lakes Landing",
    "latitude": 48.079149,
    "longitude": -122.23417,
    "original_address": "164th Street Ne",
    "building_number": "",
    "street": "",
    "city": "Marysville",
    "zip": 98271,
    "concatenated_address": "164th Street Ne, Marysville",
    "address": "164th St. Ne, Marysville"
  },
  {
    "id": 3217,
    "financing": "Federally subsidized",
    "building_name": "Twisp Gardens",
    "latitude": 48.365357,
    "longitude": -120.11841,
    "original_address": "500 East Second Ave",
    "building_number": 500,
    "street": "W 2nd Ave",
    "city": "Twisp",
    "zip": 98856,
    "concatenated_address": "500 W 2nd Ave, Twisp",
    "address": "500 W. 2nd Ave., Twisp"
  },
  {
    "id": 3218,
    "financing": "Federally subsidized",
    "building_name": "Tyree Scott Apartments",
    "latitude": 47.567761,
    "longitude": -122.29661,
    "original_address": "4000 Martin Luther King Jr Way S",
    "building_number": 4000,
    "street": "Martin Luther King Jr Way S",
    "city": "Seattle",
    "zip": 98108,
    "concatenated_address": "4000 Martin Luther King Jr Way S, Seattle",
    "address": "4000 Martin Luther King Jr Way S., Seattle"
  },
  {
    "id": 3219,
    "financing": "Federally subsidized",
    "building_name": "Union Hotel",
    "latitude": 47.600676,
    "longitude": -122.32984,
    "original_address": "204 Third Avenue S",
    "building_number": 204,
    "street": "3rd Ave S",
    "city": "Seattle",
    "zip": 98104,
    "concatenated_address": "204 3rd Ave S, Seattle",
    "address": "204 3rd Ave. S., Seattle"
  },
  {
    "id": 3220,
    "financing": "Federally subsidized",
    "building_name": "Union James",
    "latitude": 47.612708,
    "longitude": -122.30663,
    "original_address": "981 20th Ave",
    "building_number": 981,
    "street": "20th Ave",
    "city": "Seattle",
    "zip": 98122,
    "concatenated_address": "981 20th Ave, Seattle",
    "address": "981 20th Ave., Seattle"
  },
  {
    "id": 3221,
    "financing": "Federally subsidized",
    "building_name": "Union James Apartments",
    "latitude": 47.606929,
    "longitude": -122.30469,
    "original_address": "2101 E. James St.",
    "building_number": 2101,
    "street": "E James St",
    "city": "Seattle",
    "zip": 98122,
    "concatenated_address": "2101 E James St, Seattle",
    "address": "2101 E. James St., Seattle"
  },
  {
    "id": 3222,
    "financing": "Federally subsidized",
    "building_name": "Unity Village At White Center",
    "latitude": 47.51419,
    "longitude": -122.35161,
    "original_address": "1318 Sw 100th Street",
    "building_number": 1318,
    "street": "SW 100th St",
    "city": "Seattle",
    "zip": 98146,
    "concatenated_address": "1318 SW 100th St, Seattle",
    "address": "1318 S.W. 100th St., Seattle"
  },
  {
    "id": 3223,
    "financing": "Federally subsidized",
    "building_name": "Uptown Square",
    "latitude": 47.316106,
    "longitude": -122.31813,
    "original_address": "1066 South 320th Street",
    "building_number": 1066,
    "street": "S 320th St",
    "city": "Federal Way",
    "zip": 98003,
    "concatenated_address": "1066 S 320th St, Federal Way",
    "address": "1066 S. 320th St., Federal Way"
  },
  {
    "id": 3224,
    "financing": "Federally subsidized",
    "building_name": "Uptown/Bettmen House",
    "latitude": 47.041057,
    "longitude": -122.89908,
    "original_address": "216 Ninth Avenue Se",
    "building_number": 216,
    "street": "SE 9th Ave",
    "city": "Olympia",
    "zip": 98501,
    "concatenated_address": "216 SE 9th Ave, Olympia",
    "address": "216 S.E. 9th Ave., Olympia"
  },
  {
    "id": 3225,
    "financing": "Federally subsidized",
    "building_name": "Urban Center Apartments (Ash Way)",
    "latitude": 47.853837,
    "longitude": -122.25675,
    "original_address": "16001 Ash Way",
    "building_number": 16001,
    "street": "Ash Way",
    "city": "Lynnwood",
    "zip": 98087,
    "concatenated_address": "16001 Ash Way, Lynnwood",
    "address": "16001 Ash Way, Lynnwood"
  },
  {
    "id": 3226,
    "financing": "Federally subsidized",
    "building_name": "Urban League Village",
    "latitude": 47.588996,
    "longitude": -122.30176,
    "original_address": "2300 S. Massachusetts",
    "building_number": 2300,
    "street": "S Massachusetts St",
    "city": "Seattle",
    "zip": 98144,
    "concatenated_address": "2300 S Massachusetts St, Seattle",
    "address": "2300 S. Massachusetts St., Seattle"
  },
  {
    "id": 3227,
    "financing": "Federally subsidized",
    "building_name": "Valle Lindo One",
    "latitude": 46.011653,
    "longitude": -118.39786,
    "original_address": "165 Labor Camp Rd",
    "building_number": 165,
    "street": "Labor Camp Rd",
    "city": "Walla Walla",
    "zip": 99362,
    "concatenated_address": "165 Labor Camp Rd, Walla Walla",
    "address": "165 Labor Camp Road, Walla Walla"
  },
  {
    "id": 3228,
    "financing": "Federally subsidized",
    "building_name": "Valley Commons Apartments",
    "latitude": 47.52827,
    "longitude": -122.26955,
    "original_address": "8340 Rainier Avenue South",
    "building_number": 8340,
    "street": "Rainier Ave S",
    "city": "Seattle",
    "zip": 98118,
    "concatenated_address": "8340 Rainier Ave S, Seattle",
    "address": "8340 Rainier Ave. S., Seattle"
  },
  {
    "id": 3229,
    "financing": "Federally subsidized",
    "building_name": "Valley Commons I & II",
    "latitude": 46.334041,
    "longitude": -120.00236,
    "original_address": "725 Mcclain Dr.",
    "building_number": 725,
    "street": "McClain Dr",
    "city": "Sunnyside",
    "zip": 98944,
    "concatenated_address": "725 McClain Dr, Sunnyside",
    "address": "725 McClain Drive, Sunnyside"
  },
  {
    "id": 3230,
    "financing": "Federally subsidized",
    "building_name": "Valley Green",
    "latitude": 46.970287,
    "longitude": -119.03857,
    "original_address": "116 Ash Street South",
    "building_number": 116,
    "street": "Ash St N",
    "city": "Warden",
    "zip": 98857,
    "concatenated_address": "116 Ash St N, Warden",
    "address": "116 Ash St. N., Warden"
  },
  {
    "id": 3231,
    "financing": "Federally subsidized",
    "building_name": "Valley Manor Apartments",
    "latitude": 47.415227,
    "longitude": -120.28915,
    "original_address": "815 N Baker Ave",
    "building_number": 815,
    "street": "N Baker Ave",
    "city": "East Wenatchee",
    "zip": 98802,
    "concatenated_address": "815 N Baker Ave, East Wenatchee",
    "address": "815 N. Baker Ave., East Wenatchee"
  },
  {
    "id": 3232,
    "financing": "Federally subsidized",
    "building_name": "Valley Park East + West",
    "latitude": 47.299168,
    "longitude": -122.22663,
    "original_address": "920 B Street Se",
    "building_number": 920,
    "street": "B St SE",
    "city": "Auburn",
    "zip": 98002,
    "concatenated_address": "920 B St SE, Auburn",
    "address": "920 B St. S.E., Auburn"
  },
  {
    "id": 3233,
    "financing": "Federally subsidized",
    "building_name": "Valley View Apartments",
    "latitude": 47.204663,
    "longitude": -122.5093,
    "original_address": "5406 57th Street Ct W",
    "building_number": 5406,
    "street": "57th St Ct W",
    "city": "University Place",
    "zip": 98467,
    "concatenated_address": "5406 57th St Ct W, University Place",
    "address": "5406 57th St. Ct W., University Place"
  },
  {
    "id": 3234,
    "financing": "Federally subsidized",
    "building_name": "Valleywood Apartments",
    "latitude": 47.315335,
    "longitude": -122.2186,
    "original_address": "801 I Street Ne",
    "building_number": 801,
    "street": "I St NE",
    "city": "Auburn",
    "zip": 98002,
    "concatenated_address": "801 I St NE, Auburn",
    "address": "801 I St. N.E., Auburn"
  },
  {
    "id": 3235,
    "financing": "Federally subsidized",
    "building_name": "Vantage Apartments",
    "latitude": 47.881293,
    "longitude": -122.27758,
    "original_address": "12909 Mukilteo Speedway",
    "building_number": 12909,
    "street": "Mukilteo Speedway",
    "city": "Lynnwood",
    "zip": 98037,
    "concatenated_address": "12909 Mukilteo Speedway, Lynnwood",
    "address": "12909 Mukilteo Speedway, Lynnwood"
  },
  {
    "id": 3236,
    "financing": "Federally subsidized",
    "building_name": "Vantage Point Apartments",
    "latitude": 47.441521,
    "longitude": -122.20067,
    "original_address": "17901 105th Place Se",
    "building_number": 17901,
    "street": "105th Pl SE",
    "city": "Renton",
    "zip": 98055,
    "concatenated_address": "17901 105th Pl SE, Renton",
    "address": "17901 105th Pl S.E., Renton"
  },
  {
    "id": 3237,
    "financing": "Federally subsidized",
    "building_name": "Varney Court",
    "latitude": 46.24438,
    "longitude": -119.09364,
    "original_address": "318 Pearl St",
    "building_number": 318,
    "street": "W Pearl St",
    "city": "Pasco",
    "zip": 99301,
    "concatenated_address": "318 W Pearl St, Pasco",
    "address": "318 W. Pearl St., Pasco"
  },
  {
    "id": 3238,
    "financing": "Federally subsidized",
    "building_name": "Varsity Village",
    "latitude": 48.71873,
    "longitude": -122.48599,
    "original_address": "2400 Mckenzie Ave",
    "building_number": 2400,
    "street": "McKenzie Ave",
    "city": "Bellingham",
    "zip": 98225,
    "concatenated_address": "2400 McKenzie Ave, Bellingham",
    "address": "2400 McKenzie Ave., Bellingham"
  },
  {
    "id": 3239,
    "financing": "Federally subsidized",
    "building_name": "Vasa Creek Woods Apartments",
    "latitude": 47.570447,
    "longitude": -122.13461,
    "original_address": "15406 Se Newport Way",
    "building_number": 15406,
    "street": "SE Newport Way",
    "city": "Bellevue",
    "zip": 98006,
    "concatenated_address": "15406 SE Newport Way, Bellevue",
    "address": "15406 S.E. Newport Way, Bellevue"
  },
  {
    "id": 3240,
    "financing": "Federally subsidized",
    "building_name": "Vashon Manor Apartments",
    "latitude": 47.450877,
    "longitude": -122.45896,
    "original_address": "17200 97th Place Sw",
    "building_number": 17200,
    "street": "97th Pl SW",
    "city": "Vashon",
    "zip": 98070,
    "concatenated_address": "17200 97th Pl SW, Vashon",
    "address": "17200 97th Pl S.W., Vashon"
  },
  {
    "id": 3241,
    "financing": "Federally subsidized",
    "building_name": "Velocity Apartments",
    "latitude": 47.643799,
    "longitude": -122.19724,
    "original_address": "10711 Ne 37th Court",
    "building_number": 10711,
    "street": "NE 37th Ct",
    "city": "Kirkland",
    "zip": 98033,
    "concatenated_address": "10711 NE 37th Ct, Kirkland",
    "address": "10711 N.E. 37th Ct, Kirkland"
  },
  {
    "id": 3242,
    "financing": "Federally subsidized",
    "building_name": "Ventana Apartments",
    "latitude": 47.38452,
    "longitude": -122.2512,
    "original_address": "329 Ridgeview Dr",
    "building_number": 329,
    "street": "Ridgeview Dr",
    "city": "Kent",
    "zip": "98032-4397",
    "concatenated_address": "329 Ridgeview Dr, Kent",
    "address": "329 Ridgeview Drive, Kent"
  },
  {
    "id": 3243,
    "financing": "Federally subsidized",
    "building_name": "Veranda Green",
    "latitude": 47.501464,
    "longitude": -122.29916,
    "original_address": "11302 26th Avenue South",
    "building_number": 11302,
    "street": "26th Ave S",
    "city": "Seattle",
    "zip": "98168-1846",
    "concatenated_address": "11302 26th Ave S, Seattle",
    "address": "11302 26th Ave. S., Seattle"
  },
  {
    "id": 3244,
    "financing": "Federally subsidized",
    "building_name": "Vermont Inn",
    "latitude": 47.617976,
    "longitude": -122.34875,
    "original_address": "2721 Fourth Avenue",
    "building_number": 2721,
    "street": "4th Ave",
    "city": "Seattle",
    "zip": 98121,
    "concatenated_address": "2721 4th Ave, Seattle",
    "address": "2721 4th Ave., Seattle"
  },
  {
    "id": 3245,
    "financing": "Federally subsidized",
    "building_name": "Victoria House",
    "latitude": 47.618657,
    "longitude": -122.31406,
    "original_address": "1832 14th Ave",
    "building_number": 1832,
    "street": "14th Ave",
    "city": "Seattle",
    "zip": 98122,
    "concatenated_address": "1832 14th Ave, Seattle",
    "address": "1832 14th Ave., Seattle"
  },
  {
    "id": 3246,
    "financing": "Federally subsidized",
    "building_name": "Victoria Park Apartments",
    "latitude": 47.728703,
    "longitude": -122.29181,
    "original_address": "13716 Lake City Way Ne",
    "building_number": 13716,
    "street": "Lake City Way NE",
    "city": "Seattle",
    "zip": "98125-3616",
    "concatenated_address": "13716 Lake City Way NE, Seattle",
    "address": "13716 Lake City Way N.E., Seattle"
  },
  {
    "id": 3247,
    "financing": "Federally subsidized",
    "building_name": "Victorian Place II",
    "latitude": 47.381546,
    "longitude": -122.2999,
    "original_address": "24517 26th Pl. S.",
    "building_number": 24517,
    "street": "26th Pl S",
    "city": "Seattle",
    "zip": 98198,
    "concatenated_address": "24517 26th Pl S, Seattle",
    "address": "24517 26th Pl S., Seattle"
  },
  {
    "id": 3248,
    "financing": "Federally subsidized",
    "building_name": "Victorian Row Apartments",
    "latitude": 47.598482,
    "longitude": -122.31558,
    "original_address": "1238 S King St",
    "building_number": 1238,
    "street": "S King St",
    "city": "Seattle",
    "zip": 98144,
    "concatenated_address": "1238 S King St, Seattle",
    "address": "1238 S. King St., Seattle"
  },
  {
    "id": 3249,
    "financing": "Federally subsidized",
    "building_name": "Victorian Village",
    "latitude": 48.310946,
    "longitude": -122.63921,
    "original_address": "33345 State Route 20",
    "building_number": 33345,
    "street": "State Rte 20",
    "city": "Oak Harbor",
    "zip": 98277,
    "concatenated_address": "33345 State Rte 20, Oak Harbor",
    "address": "33345 State Rte 20, Oak Harbor"
  },
  {
    "id": 3250,
    "financing": "Federally subsidized",
    "building_name": "Viewcrest Village Apartments",
    "latitude": 47.595861,
    "longitude": -122.62779,
    "original_address": "3401 Spruce Ave",
    "building_number": 3401,
    "street": "Spruce Ave",
    "city": "Bremerton",
    "zip": "98310-3552",
    "concatenated_address": "3401 Spruce Ave, Bremerton",
    "address": "3401 Spruce Ave., Bremerton"
  },
  {
    "id": 3251,
    "financing": "Federally subsidized",
    "building_name": "Viewmont East",
    "latitude": 47.530955,
    "longitude": -122.61784,
    "original_address": "1900 Pioneer Lane Se",
    "building_number": 1900,
    "street": "Pioneer Ln SE",
    "city": "Port Orchard",
    "zip": 98366,
    "concatenated_address": "1900 Pioneer Ln SE, Port Orchard",
    "address": "1900 Pioneer Lane S.E., Port Orchard"
  },
  {
    "id": 3252,
    "financing": "Federally subsidized",
    "building_name": "Views At Madison",
    "latitude": 47.615983,
    "longitude": -122.30769,
    "original_address": "1615 19th Ave",
    "building_number": 1615,
    "street": "19th Ave",
    "city": "Seattle",
    "zip": 98122,
    "concatenated_address": "1615 19th Ave, Seattle",
    "address": "1615 19th Ave., Seattle"
  },
  {
    "id": 3253,
    "financing": "Federally subsidized",
    "building_name": "Views At Madison Phase I",
    "latitude": 47.615983,
    "longitude": -122.30769,
    "original_address": "1615 19th Avenue",
    "building_number": 1615,
    "street": "19th Ave",
    "city": "Seattle",
    "zip": 98122,
    "concatenated_address": "1615 19th Ave, Seattle",
    "address": "1615 19th Ave., Seattle"
  },
  {
    "id": 3254,
    "financing": "Federally subsidized",
    "building_name": "Views At Madison Phase II",
    "latitude": 47.61617,
    "longitude": -122.30813,
    "original_address": "1823 East Madison",
    "building_number": 1823,
    "street": "E Madison St",
    "city": "Seattle",
    "zip": 98122,
    "concatenated_address": "1823 E Madison St, Seattle",
    "address": "1823 E. Madison St., Seattle"
  },
  {
    "id": 3255,
    "financing": "Federally subsidized",
    "building_name": "Villa Apartments",
    "latitude": 47.613717,
    "longitude": -122.32876,
    "original_address": "1106 Pike St",
    "building_number": 1106,
    "street": "Pike St",
    "city": "Seattle",
    "zip": 98101,
    "concatenated_address": "1106 Pike St, Seattle",
    "address": "1106 Pike St., Seattle"
  },
  {
    "id": 3256,
    "financing": "Federally subsidized",
    "building_name": "Villa Capri",
    "latitude": 47.34425,
    "longitude": -122.30053,
    "original_address": "28621 25th Place South",
    "building_number": 28621,
    "street": "25th Pl S",
    "city": "Federal Way",
    "zip": 98003,
    "concatenated_address": "28621 25th Pl S, Federal Way",
    "address": "28621 25th Pl S., Federal Way"
  },
  {
    "id": 3257,
    "financing": "Federally subsidized",
    "building_name": "Villa Esperanza Apartments",
    "latitude": 47.31879,
    "longitude": -122.29723,
    "original_address": "31524 - 28th Avenue S",
    "building_number": 31524,
    "street": "28th Ave S",
    "city": "Federal Way",
    "zip": 98003,
    "concatenated_address": "31524 28th Ave S, Federal Way",
    "address": "31524 28th Ave. S., Federal Way"
  },
  {
    "id": 3258,
    "financing": "Federally subsidized",
    "building_name": "Villa Kathleen, Evergreen Manor and Fircrest Apartments",
    "latitude": 48.478985,
    "longitude": -122.32642,
    "original_address": "535 N Pine St",
    "building_number": 535,
    "street": "N Pine St",
    "city": "Burlington",
    "zip": 98233,
    "concatenated_address": "535 N Pine St, Burlington",
    "address": "535 N. Pine St., Burlington"
  },
  {
    "id": 3259,
    "financing": "Federally subsidized",
    "building_name": "Villa San Isidro Apartments",
    "latitude": 48.435248,
    "longitude": -122.20818,
    "original_address": "1917 N. La Venture Rd",
    "building_number": "",
    "street": "",
    "city": "Mount Vernon",
    "zip": 98273,
    "concatenated_address": "1917 N. La Venture Rd, Mount Vernon",
    "address": "1917 N. La Venture Road, Mount Vernon"
  },
  {
    "id": 3260,
    "financing": "Federally subsidized",
    "building_name": "Villa San Juan Bautista",
    "latitude": 46.715419,
    "longitude": -122.99896,
    "original_address": "2613 Cooks Hill Rd",
    "building_number": 2613,
    "street": "Cooks Hill Rd",
    "city": "Centralia",
    "zip": "98531-5519",
    "concatenated_address": "2613 Cooks Hill Rd, Centralia",
    "address": "2613 Cooks Hill Road, Centralia"
  },
  {
    "id": 3261,
    "financing": "Federally subsidized",
    "building_name": "Villa San Martin",
    "latitude": 46.145071,
    "longitude": -122.8781,
    "original_address": "2611 Abbotsford Loop",
    "building_number": 2611,
    "street": "Abbotsford Loop",
    "city": "Kelso",
    "zip": 98626,
    "concatenated_address": "2611 Abbotsford Loop, Kelso",
    "address": "2611 Abbotsford Loop, Kelso"
  },
  {
    "id": 3262,
    "financing": "Federally subsidized",
    "building_name": "Villa Santa Fe",
    "latitude": 48.789848,
    "longitude": -122.50603,
    "original_address": "760-842 West Bakerview Rd.",
    "building_number": 760,
    "street": "W Bakerview Rd",
    "city": "Bellingham",
    "zip": 98226,
    "concatenated_address": "760 W Bakerview Rd, Bellingham",
    "address": "760 W. Bakerview Road, Bellingham"
  },
  {
    "id": 3263,
    "financing": "Federally subsidized",
    "building_name": "Villa Santa Maria",
    "latitude": 46.735617,
    "longitude": -119.91131,
    "original_address": "56 2nd Street",
    "building_number": 56,
    "street": "2nd St",
    "city": "Mattawa",
    "zip": 99349,
    "concatenated_address": "56 2nd St, Mattawa",
    "address": "56 2nd St., Mattawa"
  },
  {
    "id": 3264,
    "financing": "Federally subsidized",
    "building_name": "Villa Santa Maria - Mattawa",
    "latitude": 46.736153,
    "longitude": -119.90548,
    "original_address": "55 2nd St",
    "building_number": 55,
    "street": "2nd St",
    "city": "Mattawa",
    "zip": 99349,
    "concatenated_address": "55 2nd St, Mattawa",
    "address": "55 2nd St., Mattawa"
  },
  {
    "id": 3265,
    "financing": "Federally subsidized",
    "building_name": "Villa Santa Maria - Mount Vernon",
    "latitude": 48.434527,
    "longitude": -122.29358,
    "original_address": "3700 East College Way",
    "building_number": 3700,
    "street": "E College Way",
    "city": "Mount Vernon",
    "zip": 98273,
    "concatenated_address": "3700 E College Way, Mount Vernon",
    "address": "3700 E. College Way, Mount Vernon"
  },
  {
    "id": 3266,
    "financing": "Federally subsidized",
    "building_name": "Village Apartments",
    "latitude": 47.629296,
    "longitude": -117.25466,
    "original_address": "9717 East Sixth Avenue",
    "building_number": "",
    "street": "",
    "city": "Spokane Valley",
    "zip": "99206-3593",
    "concatenated_address": "9717 East Sixth Avenue, Spokane Valley",
    "address": "9717 East Sixth Avenue, Spokane Valley"
  },
  {
    "id": 3267,
    "financing": "Federally subsidized",
    "building_name": "Village At Overlake Station",
    "latitude": 47.6329,
    "longitude": -122.13569,
    "original_address": "2576 152nd Avenue Ne",
    "building_number": 2576,
    "street": "152nd Ave NE",
    "city": "Redmond",
    "zip": 98052,
    "concatenated_address": "2576 152nd Ave NE, Redmond",
    "address": "2576 152nd Ave. N.E., Redmond"
  },
  {
    "id": 3268,
    "financing": "Federally subsidized",
    "building_name": "Village At Overlake Station (Federal Way)",
    "latitude": 47.349264,
    "longitude": -122.30988,
    "original_address": "1808 S 281st Pl",
    "building_number": 1808,
    "street": "S 281st Pl",
    "city": "Federal Way",
    "zip": 98003,
    "concatenated_address": "1808 S 281st Pl, Federal Way",
    "address": "1808 S. 281st Place, Federal Way"
  },
  {
    "id": 3269,
    "financing": "Federally subsidized",
    "building_name": "Village Green Apartments",
    "latitude": 47.530506,
    "longitude": -122.59369,
    "original_address": "3888 Madrona Dr Se",
    "building_number": 3888,
    "street": "Madrona Dr SE",
    "city": "Port Orchard",
    "zip": 98366,
    "concatenated_address": "3888 Madrona Dr SE, Port Orchard",
    "address": "3888 Madrona Dr S.E., Port Orchard"
  },
  {
    "id": 3270,
    "financing": "Federally subsidized",
    "building_name": "Village Green Senior Apartments",
    "latitude": 47.799182,
    "longitude": -122.50156,
    "original_address": "26150 Dulay Road Ne",
    "building_number": 26150,
    "street": "Dulay Rd",
    "city": "Kingston",
    "zip": 98346,
    "concatenated_address": "26150 Dulay Rd, Kingston",
    "address": "26150 Dulay Road, Kingston"
  },
  {
    "id": 3271,
    "financing": "Federally subsidized",
    "building_name": "Villas At Lakewood",
    "latitude": 48.079149,
    "longitude": -122.23417,
    "original_address": "16800 27th Avenue Ne",
    "building_number": "",
    "street": "",
    "city": "Marysville",
    "zip": 98271,
    "concatenated_address": "16800 27th Avenue Ne, Marysville",
    "address": "16800 27th Avenue Ne, Marysville"
  },
  {
    "id": 3272,
    "financing": "Federally subsidized",
    "building_name": "Vincent Village",
    "latitude": 46.198033,
    "longitude": -119.11111,
    "original_address": "402 E Tenth Ave",
    "building_number": 402,
    "street": "E 10th Ave",
    "city": "Kennewick",
    "zip": 99336,
    "concatenated_address": "402 E 10th Ave, Kennewick",
    "address": "402 E. 10th Ave., Kennewick"
  },
  {
    "id": 3273,
    "financing": "Federally subsidized",
    "building_name": "Vine Court Apartments",
    "latitude": 47.615407,
    "longitude": -122.3492,
    "original_address": "103 Vine Street",
    "building_number": 103,
    "street": "Vine St",
    "city": "Seattle",
    "zip": 98121,
    "concatenated_address": "103 Vine St, Seattle",
    "address": "103 Vine St., Seattle"
  },
  {
    "id": 3274,
    "financing": "Federally subsidized",
    "building_name": "Vineyard Apartments",
    "latitude": 46.734544,
    "longitude": -119.89522,
    "original_address": "825 3rd Place",
    "building_number": 825,
    "street": "3rd Pl",
    "city": "Mattawa",
    "zip": 99349,
    "concatenated_address": "825 3rd Pl, Mattawa",
    "address": "825 3rd Place, Mattawa"
  },
  {
    "id": 3275,
    "financing": "Federally subsidized",
    "building_name": "Vineyard I Apartments",
    "latitude": 46.246693,
    "longitude": -119.90625,
    "original_address": "405 Nicka Rd.",
    "building_number": 405,
    "street": "Nicka Rd",
    "city": "Grandview",
    "zip": 98930,
    "concatenated_address": "405 Nicka Rd, Grandview",
    "address": "405 Nicka Road, Grandview"
  },
  {
    "id": 3276,
    "financing": "Federally subsidized",
    "building_name": "Vineyard II Apartments",
    "latitude": 46.247256,
    "longitude": -119.90556,
    "original_address": "810 Grandridge Road",
    "building_number": 810,
    "street": "Grandridge Rd",
    "city": "Grandview",
    "zip": 98930,
    "concatenated_address": "810 Grandridge Rd, Grandview",
    "address": "810 Grandridge Road, Grandview"
  },
  {
    "id": 3277,
    "financing": "Federally subsidized",
    "building_name": "Vineyards, The",
    "latitude": 46.248006,
    "longitude": -119.12265,
    "original_address": "2407 W. Jay Street",
    "building_number": 2407,
    "street": "W Jay St",
    "city": "Pasco",
    "zip": 99301,
    "concatenated_address": "2407 W Jay St, Pasco",
    "address": "2407 W. Jay St., Pasco"
  },
  {
    "id": 3278,
    "financing": "Federally subsidized",
    "building_name": "Vintage At Arlington",
    "latitude": 48.186664,
    "longitude": -122.11428,
    "original_address": "8510 - 212th Street Ne",
    "building_number": 8510,
    "street": "212th St NE",
    "city": "Arlington",
    "zip": "98223-4611",
    "concatenated_address": "8510 212th St NE, Arlington",
    "address": "8510 212th St. N.E., Arlington"
  },
  {
    "id": 3279,
    "financing": "Federally subsidized",
    "building_name": "Vintage At Bellingham",
    "latitude": 48.808511,
    "longitude": -122.4985,
    "original_address": "4625 Cordata Parkway",
    "building_number": 4625,
    "street": "Cordata Pkwy",
    "city": "Bellingham",
    "zip": "98226-8041",
    "concatenated_address": "4625 Cordata Pkwy, Bellingham",
    "address": "4625 Cordata Pkwy, Bellingham"
  },
  {
    "id": 3280,
    "financing": "Federally subsidized",
    "building_name": "Vintage At Bremerton Senior Living",
    "latitude": 47.587975,
    "longitude": -122.61977,
    "original_address": "1717 Sheridan Road",
    "building_number": 1717,
    "street": "Sheridan Rd",
    "city": "Bremerton",
    "zip": "98310-4659",
    "concatenated_address": "1717 Sheridan Rd, Bremerton",
    "address": "1717 Sheridan Road, Bremerton"
  },
  {
    "id": 3281,
    "financing": "Federally subsidized",
    "building_name": "Vintage At Burien",
    "latitude": 47.477823,
    "longitude": -122.33562,
    "original_address": "149 140th Street South",
    "building_number": 149,
    "street": "SW 140th St",
    "city": "Seattle",
    "zip": "98166-3435",
    "concatenated_address": "149 SW 140th St, Seattle",
    "address": "149 S.W. 140th St., Seattle"
  },
  {
    "id": 3282,
    "financing": "Federally subsidized",
    "building_name": "Vintage At Chehalis",
    "latitude": 46.67459,
    "longitude": -122.96722,
    "original_address": "1590 National Ave",
    "building_number": 1590,
    "street": "N National Ave",
    "city": "Chehalis",
    "zip": "98532-2203",
    "concatenated_address": "1590 N National Ave, Chehalis",
    "address": "1590 N. National Ave., Chehalis"
  },
  {
    "id": 3283,
    "financing": "Federally subsidized",
    "building_name": "Vintage At Everett",
    "latitude": 48.003644,
    "longitude": -122.18813,
    "original_address": "1001 East Marine View Dr",
    "building_number": 1001,
    "street": "E Marine View Dr",
    "city": "Everett",
    "zip": "98201-2171",
    "concatenated_address": "1001 E Marine View Dr, Everett",
    "address": "1001 E. Marine View Drive, Everett"
  },
  {
    "id": 3284,
    "financing": "Federally subsidized",
    "building_name": "Vintage At Holly Village",
    "latitude": 47.910224,
    "longitude": -122.24137,
    "original_address": "9615 Holly Drive",
    "building_number": 9615,
    "street": "Holly Dr",
    "city": "Everett",
    "zip": "98204-2608",
    "concatenated_address": "9615 Holly Dr, Everett",
    "address": "9615 Holly Drive, Everett"
  },
  {
    "id": 3285,
    "financing": "Federally subsidized",
    "building_name": "Vintage At Lakewood Apartments",
    "latitude": 48.152079,
    "longitude": -122.19924,
    "original_address": "2131 172nd Street Ne",
    "building_number": 2131,
    "street": "State Rte 531",
    "city": "Marysville",
    "zip": 98271,
    "concatenated_address": "2131 State Rte 531, Marysville",
    "address": "2131 State Rte 531, Marysville"
  },
  {
    "id": 3286,
    "financing": "Federally subsidized",
    "building_name": "Vintage At Mt. Vernon",
    "latitude": 48.440337,
    "longitude": -122.3323,
    "original_address": "2110 Urban Avenue",
    "building_number": 2110,
    "street": "Urban Ave",
    "city": "Mount Vernon",
    "zip": "98273-5502",
    "concatenated_address": "2110 Urban Ave, Mount Vernon",
    "address": "2110 Urban Ave., Mount Vernon"
  },
  {
    "id": 3287,
    "financing": "Federally subsidized",
    "building_name": "Vintage At Richland",
    "latitude": 46.226354,
    "longitude": -119.24945,
    "original_address": "1950 Bellerive Dr",
    "building_number": 1950,
    "street": "Bellerive Dr",
    "city": "Richland",
    "zip": 99336,
    "concatenated_address": "1950 Bellerive Dr, Richland",
    "address": "1950 Bellerive Drive, Richland"
  },
  {
    "id": 3288,
    "financing": "Federally subsidized",
    "building_name": "Vintage At Sequim",
    "latitude": 48.079259,
    "longitude": -123.12599,
    "original_address": "1009 Brackett Road",
    "building_number": 1009,
    "street": "Brackett Rd",
    "city": "Sequim",
    "zip": "98382-3245",
    "concatenated_address": "1009 Brackett Rd, Sequim",
    "address": "1009 Brackett Road, Sequim"
  },
  {
    "id": 3289,
    "financing": "Federally subsidized",
    "building_name": "Vintage At Silverdale",
    "latitude": 47.658874,
    "longitude": -122.69722,
    "original_address": "3291 Nw Teds Farm Street (3291 Mount Vintage Way)",
    "building_number": 3291,
    "street": "NW Teds Farm St",
    "city": "Silverdale",
    "zip": 98383,
    "concatenated_address": "3291 NW Teds Farm St, Silverdale",
    "address": "3291 N.W. Teds Farm St., Silverdale"
  },
  {
    "id": 3290,
    "financing": "Federally subsidized",
    "building_name": "Vintage At Spokane",
    "latitude": 47.723234,
    "longitude": -117.40925,
    "original_address": "43 East Weile Ave",
    "building_number": 43,
    "street": "E Weile Ave",
    "city": "Spokane",
    "zip": "99217-6537",
    "concatenated_address": "43 E Weile Ave, Spokane",
    "address": "43 E. Weile Ave., Spokane"
  },
  {
    "id": 3291,
    "financing": "Federally subsidized",
    "building_name": "Vintage At Tacoma",
    "latitude": 47.219559,
    "longitude": -122.47961,
    "original_address": "4028 S. Lawrence St",
    "building_number": 4028,
    "street": "S Lawrence St",
    "city": "Tacoma",
    "zip": 98409,
    "concatenated_address": "4028 S Lawrence St, Tacoma",
    "address": "4028 S. Lawrence St., Tacoma"
  },
  {
    "id": 3292,
    "financing": "Federally subsidized",
    "building_name": "Vintage At Vancouver",
    "latitude": 45.661002,
    "longitude": -122.58145,
    "original_address": "9001 Ne 54th Street",
    "building_number": 9001,
    "street": "NE 54th St",
    "city": "Vancouver",
    "zip": "98662-6001",
    "concatenated_address": "9001 NE 54th St, Vancouver",
    "address": "9001 N.E. 54th St., Vancouver"
  },
  {
    "id": 3293,
    "financing": "Federally subsidized",
    "building_name": "Viola Apartments",
    "latitude": 46.582373,
    "longitude": -120.48618,
    "original_address": "1121 East Viola Ave",
    "building_number": 1121,
    "street": "E Viola Ave",
    "city": "Yakima",
    "zip": 98901,
    "concatenated_address": "1121 E Viola Ave, Yakima",
    "address": "1121 E. Viola Ave., Yakima"
  },
  {
    "id": 3294,
    "financing": "Federally subsidized",
    "building_name": "Virgina Villa",
    "latitude": 47.635911,
    "longitude": -122.52009,
    "original_address": "200 High School Rd Ne",
    "building_number": 200,
    "street": "High School Rd NE",
    "city": "Bainbridge Island",
    "zip": 98110,
    "concatenated_address": "200 High School Rd NE, Bainbridge Island",
    "address": "200 High School Road N.E., Bainbridge Island"
  },
  {
    "id": 3295,
    "financing": "Federally subsidized",
    "building_name": "Virginia Station Apartments",
    "latitude": 46.737575,
    "longitude": -122.95489,
    "original_address": "111 Virginia Drive",
    "building_number": 111,
    "street": "Virginia Dr",
    "city": "Centralia",
    "zip": 98531,
    "concatenated_address": "111 Virginia Dr, Centralia",
    "address": "111 Virginia Drive, Centralia"
  },
  {
    "id": 3296,
    "financing": "Federally subsidized",
    "building_name": "Virginia Villa Apartments",
    "latitude": 47.635911,
    "longitude": -122.52009,
    "original_address": "200 High School Rd. Ne,",
    "building_number": 200,
    "street": "High School Rd NE",
    "city": "Bainbridge Island",
    "zip": 98110,
    "concatenated_address": "200 High School Rd NE, Bainbridge Island",
    "address": "200 High School Road N.E., Bainbridge Island"
  },
  {
    "id": 3297,
    "financing": "Federally subsidized",
    "building_name": "Vista Court",
    "latitude": 45.631848,
    "longitude": -122.6755,
    "original_address": "1405 Esther St",
    "building_number": 1405,
    "street": "Esther St",
    "city": "Vancouver",
    "zip": 98660,
    "concatenated_address": "1405 Esther St, Vancouver",
    "address": "1405 Esther St., Vancouver"
  },
  {
    "id": 3298,
    "financing": "Federally subsidized",
    "building_name": "Vista Park Homes",
    "latitude": 48.094876,
    "longitude": -119.78244,
    "original_address": "509 South 4th Street",
    "building_number": 509,
    "street": "S 4th St",
    "city": "Brewster",
    "zip": 98812,
    "concatenated_address": "509 S 4th St, Brewster",
    "address": "509 S. 4th St., Brewster"
  },
  {
    "id": 3299,
    "financing": "Federally subsidized",
    "building_name": "Vista Park Village",
    "latitude": 46.962107,
    "longitude": -119.04655,
    "original_address": "800 S County Rd",
    "building_number": 800,
    "street": "County Rd S",
    "city": "Warden",
    "zip": 98857,
    "concatenated_address": "800 County Rd S, Warden",
    "address": "800 County Road S., Warden"
  },
  {
    "id": 3300,
    "financing": "Federally subsidized",
    "building_name": "Vista View Apartments",
    "latitude": 48.39751,
    "longitude": -119.54457,
    "original_address": "715 Jasmine Street",
    "building_number": 715,
    "street": "Jasmine St",
    "city": "Omak",
    "zip": 98841,
    "concatenated_address": "715 Jasmine St, Omak",
    "address": "715 Jasmine St., Omak"
  },
  {
    "id": 3301,
    "financing": "Federally subsidized",
    "building_name": "Vivian Mclean Place",
    "latitude": 47.553062,
    "longitude": -122.36347,
    "original_address": "5425 Delridge Way Sw",
    "building_number": 5425,
    "street": "Delridge Way SW",
    "city": "Seattle",
    "zip": 98106,
    "concatenated_address": "5425 Delridge Way SW, Seattle",
    "address": "5425 Delridge Way S.W., Seattle"
  },
  {
    "id": 3302,
    "financing": "Federally subsidized",
    "building_name": "WA-02-00302",
    "latitude": 47.612396,
    "longitude": -122.31447,
    "original_address": "1319 E Union St",
    "building_number": 1319,
    "street": "E Union St",
    "city": "Seattle",
    "zip": 98122,
    "concatenated_address": "1319 E Union St, Seattle",
    "address": "1319 E. Union St., Seattle"
  },
  {
    "id": 3303,
    "financing": "Federally subsidized",
    "building_name": "WA-09-00110",
    "latitude": 47.565118,
    "longitude": -122.67816,
    "original_address": "4650 Bay Vista Blvd",
    "building_number": 4650,
    "street": "Bay Vista Blvd",
    "city": "Bremerton",
    "zip": 98312,
    "concatenated_address": "4650 Bay Vista Blvd, Bremerton",
    "address": "4650 Bay Vista Blvd., Bremerton"
  },
  {
    "id": 3304,
    "financing": "Federally subsidized",
    "building_name": "Wahluke Slope Apartments",
    "latitude": 46.73598,
    "longitude": -119.91344,
    "original_address": "301 Brian Avenue",
    "building_number": 301,
    "street": "Brian Ave",
    "city": "Mattawa",
    "zip": 99349,
    "concatenated_address": "301 Brian Ave, Mattawa",
    "address": "301 Brian Ave., Mattawa"
  },
  {
    "id": 3305,
    "financing": "Federally subsidized",
    "building_name": "Walla Walla Scattered Site Properties",
    "latitude": 46.1341,
    "longitude": -118.29141,
    "original_address": "Scattered Site",
    "building_number": "",
    "street": "",
    "city": "Walla Walla",
    "zip": 99362,
    "concatenated_address": "Scattered Site, Walla Walla",
    "address": "Scattered Site, Walla Walla"
  },
  {
    "id": 3306,
    "financing": "Federally subsidized",
    "building_name": "Walla Walla VA Housing",
    "latitude": 46.053534,
    "longitude": -118.35581,
    "original_address": "77 Wainwright Dr",
    "building_number": 77,
    "street": "Wainwright Dr",
    "city": "Walla Walla",
    "zip": 99362,
    "concatenated_address": "77 Wainwright Dr, Walla Walla",
    "address": "77 Wainwright Drive, Walla Walla"
  },
  {
    "id": 3307,
    "financing": "Federally subsidized",
    "building_name": "Walnut Corners",
    "latitude": 47.664206,
    "longitude": -117.43364,
    "original_address": "1423 West Broadway",
    "building_number": 1423,
    "street": "W Broadway Ave",
    "city": "Spokane",
    "zip": 99201,
    "concatenated_address": "1423 W Broadway Ave, Spokane",
    "address": "1423 W. Broadway Ave., Spokane"
  },
  {
    "id": 3308,
    "financing": "Federally subsidized",
    "building_name": "Walton Phase I",
    "latitude": 48.751154,
    "longitude": -122.47342,
    "original_address": "1511 North State St",
    "building_number": 1511,
    "street": "N State St",
    "city": "Bellingham",
    "zip": 98225,
    "concatenated_address": "1511 N State St, Bellingham",
    "address": "1511 N. State St., Bellingham"
  },
  {
    "id": 3309,
    "financing": "Federally subsidized",
    "building_name": "Walton Place",
    "latitude": 48.751154,
    "longitude": -122.47342,
    "original_address": "1511 N State St.",
    "building_number": 1511,
    "street": "N State St",
    "city": "Bellingham",
    "zip": 98225,
    "concatenated_address": "1511 N State St, Bellingham",
    "address": "1511 N. State St., Bellingham"
  },
  {
    "id": 3310,
    "financing": "Federally subsidized",
    "building_name": "Walton Place Two",
    "latitude": 48.75083,
    "longitude": -122.47388,
    "original_address": "1505 North State St",
    "building_number": 1505,
    "street": "N State St",
    "city": "Bellingham",
    "zip": "98225-4514",
    "concatenated_address": "1505 N State St, Bellingham",
    "address": "1505 N. State St., Bellingham"
  },
  {
    "id": 3311,
    "financing": "Federally subsidized",
    "building_name": "Wanity Park Apartments - Phase I",
    "latitude": 46.328522,
    "longitude": -120.37026,
    "original_address": "101 Wanity Park Dr",
    "building_number": "",
    "street": "",
    "city": "Toppenish",
    "zip": "98948-0502",
    "concatenated_address": "101 Wanity Park Dr, Toppenish",
    "address": "101 Wanity Park Drive, Toppenish"
  },
  {
    "id": 3312,
    "financing": "Federally subsidized",
    "building_name": "Wanity Park Apartments Phase II",
    "latitude": 47.500536,
    "longitude": -122.33945,
    "original_address": "11464 Fourth Pl Sw",
    "building_number": 11464,
    "street": "4th Pl SW",
    "city": "Seattle",
    "zip": 98146,
    "concatenated_address": "11464 4th Pl SW, Seattle",
    "address": "11464 4th Pl S.W., Seattle"
  },
  {
    "id": 3313,
    "financing": "Federally subsidized",
    "building_name": "Wapato Garden Apartments",
    "latitude": 46.450924,
    "longitude": -120.4153,
    "original_address": "509 Donald Road #25",
    "building_number": 509,
    "street": "Donald Rd",
    "city": "Wapato",
    "zip": 98951,
    "concatenated_address": "509 Donald Rd, Wapato",
    "address": "509 Donald Road, Wapato"
  },
  {
    "id": 3314,
    "financing": "Federally subsidized",
    "building_name": "Warner Crest",
    "latitude": 47.259216,
    "longitude": -122.50924,
    "original_address": "3320 Sixth Ave",
    "building_number": "",
    "street": "",
    "city": "Tacoma",
    "zip": 98406,
    "concatenated_address": "3320 Sixth Ave, Tacoma",
    "address": "3320 Sixth Ave., Tacoma"
  },
  {
    "id": 3315,
    "financing": "Federally subsidized",
    "building_name": "Wasatch Hills",
    "latitude": 47.475565,
    "longitude": -122.2229,
    "original_address": "510 Stevens Avenue Sw",
    "building_number": 510,
    "street": "Stevens Ave SW",
    "city": "Renton",
    "zip": 98057,
    "concatenated_address": "510 Stevens Ave SW, Renton",
    "address": "510 Stevens Ave. S.W., Renton"
  },
  {
    "id": 3316,
    "financing": "Federally subsidized",
    "building_name": "Washington School Apartments",
    "latitude": 46.068042,
    "longitude": -118.35178,
    "original_address": "517 Cayuse Street",
    "building_number": 517,
    "street": "Cayuse St",
    "city": "Walla Walla",
    "zip": 99362,
    "concatenated_address": "517 Cayuse St, Walla Walla",
    "address": "517 Cayuse St., Walla Walla"
  },
  {
    "id": 3317,
    "financing": "Federally subsidized",
    "building_name": "Washington Square",
    "latitude": 46.814058,
    "longitude": -119.16991,
    "original_address": "1065 S 4th Avenue",
    "building_number": 1065,
    "street": "S 4th Ave",
    "city": "Othello",
    "zip": 98344,
    "concatenated_address": "1065 S 4th Ave, Othello",
    "address": "1065 S. 4th Ave., Othello"
  },
  {
    "id": 3318,
    "financing": "Federally subsidized",
    "building_name": "Washington Terrace",
    "latitude": 47.601491,
    "longitude": -122.32587,
    "original_address": "609 Yesler Way",
    "building_number": 609,
    "street": "Yesler Way",
    "city": "Seattle",
    "zip": 98104,
    "concatenated_address": "609 Yesler Way, Seattle",
    "address": "609 Yesler Way, Seattle"
  },
  {
    "id": 3319,
    "financing": "Federally subsidized",
    "building_name": "Wauna Homes",
    "latitude": 47.379236,
    "longitude": -122.6708,
    "original_address": "13313 97th Avenue Nw",
    "building_number": 13313,
    "street": "97th Ave NW",
    "city": "Gig Harbor",
    "zip": 98329,
    "concatenated_address": "13313 97th Ave NW, Gig Harbor",
    "address": "13313 97th Ave. N.W., Gig Harbor"
  },
  {
    "id": 3320,
    "financing": "Federally subsidized",
    "building_name": "Webster Court",
    "latitude": 47.379381,
    "longitude": -122.23929,
    "original_address": "309 5th Avenue S",
    "building_number": 309,
    "street": "5th Ave S",
    "city": "Kent",
    "zip": 98032,
    "concatenated_address": "309 5th Ave S, Kent",
    "address": "309 5th Ave. S., Kent"
  },
  {
    "id": 3321,
    "financing": "Federally subsidized",
    "building_name": "Webster Court Apartments",
    "latitude": 47.379381,
    "longitude": -122.23929,
    "original_address": "309 Fifth Avenue S",
    "building_number": 309,
    "street": "5th Ave S",
    "city": "Kent",
    "zip": 98032,
    "concatenated_address": "309 5th Ave S, Kent",
    "address": "309 5th Ave. S., Kent"
  },
  {
    "id": 3322,
    "financing": "Federally subsidized",
    "building_name": "Weller Apartments",
    "latitude": 47.59769,
    "longitude": -122.31036,
    "original_address": "1632 S Weller Street",
    "building_number": 1632,
    "street": "S Weller St",
    "city": "Seattle",
    "zip": 98144,
    "concatenated_address": "1632 S Weller St, Seattle",
    "address": "1632 S. Weller St., Seattle"
  },
  {
    "id": 3323,
    "financing": "Federally subsidized",
    "building_name": "Wellington Apartments Family Project",
    "latitude": 48.073292,
    "longitude": -122.1726,
    "original_address": "4239 84th Street Ne",
    "building_number": 4239,
    "street": "84th St NE",
    "city": "Marysville",
    "zip": 98270,
    "concatenated_address": "4239 84th St NE, Marysville",
    "address": "4239 84th St. N.E., Marysville"
  },
  {
    "id": 3324,
    "financing": "Federally subsidized",
    "building_name": "Wellington Apartments Senior Project",
    "latitude": 48.074117,
    "longitude": -122.17241,
    "original_address": "4300 88th Street Ne",
    "building_number": 4300,
    "street": "88th St NE",
    "city": "Marysville",
    "zip": 98270,
    "concatenated_address": "4300 88th St NE, Marysville",
    "address": "4300 88th St. N.E., Marysville"
  },
  {
    "id": 3325,
    "financing": "Federally subsidized",
    "building_name": "Wellington Arms",
    "latitude": 46.078422,
    "longitude": -118.31007,
    "original_address": "1970 Melrose Street",
    "building_number": 1970,
    "street": "Melrose St",
    "city": "Walla Walla",
    "zip": 99362,
    "concatenated_address": "1970 Melrose St, Walla Walla",
    "address": "1970 Melrose St., Walla Walla"
  },
  {
    "id": 3326,
    "financing": "Federally subsidized",
    "building_name": "Wescott Apartments",
    "latitude": 46.319464,
    "longitude": -120.01417,
    "original_address": "421 E Harrison Ave",
    "building_number": 421,
    "street": "E Harrison Ave",
    "city": "Sunnyside",
    "zip": 98944,
    "concatenated_address": "421 E Harrison Ave, Sunnyside",
    "address": "421 E. Harrison Ave., Sunnyside"
  },
  {
    "id": 3327,
    "financing": "Federally subsidized",
    "building_name": "Wescott, The",
    "latitude": 46.319464,
    "longitude": -120.01417,
    "original_address": "421 E Harrison Ave",
    "building_number": 421,
    "street": "E Harrison Ave",
    "city": "Sunnyside",
    "zip": 98944,
    "concatenated_address": "421 E Harrison Ave, Sunnyside",
    "address": "421 E. Harrison Ave., Sunnyside"
  },
  {
    "id": 3328,
    "financing": "Federally subsidized",
    "building_name": "Wesley Point",
    "latitude": 48.187236,
    "longitude": -122.11724,
    "original_address": "1033 Wesley St.",
    "building_number": 1033,
    "street": "Wesley St",
    "city": "Arlington",
    "zip": 98223,
    "concatenated_address": "1033 Wesley St, Arlington",
    "address": "1033 Wesley St., Arlington"
  },
  {
    "id": 3329,
    "financing": "Federally subsidized",
    "building_name": "West 315",
    "latitude": 47.671299,
    "longitude": -117.41678,
    "original_address": "315 W. Mission Ave.",
    "building_number": 315,
    "street": "W Mission Ave",
    "city": "Spokane",
    "zip": 99201,
    "concatenated_address": "315 W Mission Ave, Spokane",
    "address": "315 W. Mission Ave., Spokane"
  },
  {
    "id": 3330,
    "financing": "Federally subsidized",
    "building_name": "Westend Apartments",
    "latitude": 48.066501,
    "longitude": -122.17863,
    "original_address": "1350 Cedar Ave",
    "building_number": 1350,
    "street": "Cedar Ave",
    "city": "Marysville",
    "zip": "98270-3680",
    "concatenated_address": "1350 Cedar Ave, Marysville",
    "address": "1350 Cedar Ave., Marysville"
  },
  {
    "id": 3331,
    "financing": "Federally subsidized",
    "building_name": "Western Avenue Senior Housing",
    "latitude": 47.609472,
    "longitude": -122.34286,
    "original_address": "1901 Western Avenue",
    "building_number": 1901,
    "street": "Western Ave",
    "city": "Seattle",
    "zip": 98101,
    "concatenated_address": "1901 Western Ave, Seattle",
    "address": "1901 Western Ave., Seattle"
  },
  {
    "id": 3332,
    "financing": "Federally subsidized",
    "building_name": "Westfall Village Apartments",
    "latitude": 47.691658,
    "longitude": -117.37331,
    "original_address": "3724 North Cook",
    "building_number": 3724,
    "street": "N Cook St",
    "city": "Spokane",
    "zip": 99207,
    "concatenated_address": "3724 N Cook St, Spokane",
    "address": "3724 N. Cook St., Spokane"
  },
  {
    "id": 3333,
    "financing": "Federally subsidized",
    "building_name": "Westgate Terrace Apartments",
    "latitude": 46.146417,
    "longitude": -122.96728,
    "original_address": "2024 Tibbetts Dr",
    "building_number": 2024,
    "street": "Tibbetts Dr",
    "city": "Longview",
    "zip": 98632,
    "concatenated_address": "2024 Tibbetts Dr, Longview",
    "address": "2024 Tibbetts Drive, Longview"
  },
  {
    "id": 3334,
    "financing": "Federally subsidized",
    "building_name": "Westlake Apartments",
    "latitude": 47.391722,
    "longitude": -122.04903,
    "original_address": "21900 Se Wax Rd.",
    "building_number": 21900,
    "street": "SE Wax Rd",
    "city": "Maple Valley",
    "zip": 98038,
    "concatenated_address": "21900 SE Wax Rd, Maple Valley",
    "address": "21900 S.E. Wax Road, Maple Valley"
  },
  {
    "id": 3335,
    "financing": "Federally subsidized",
    "building_name": "Westside Estates",
    "latitude": 47.259163,
    "longitude": -122.51753,
    "original_address": "922 N Pearl",
    "building_number": 922,
    "street": "N Pearl St",
    "city": "Tacoma",
    "zip": 98406,
    "concatenated_address": "922 N Pearl St, Tacoma",
    "address": "922 N. Pearl St., Tacoma"
  },
  {
    "id": 3336,
    "financing": "Federally subsidized",
    "building_name": "Westview Apartments",
    "latitude": 48.54293,
    "longitude": -122.9114,
    "original_address": "452 Lopez Rd",
    "building_number": 452,
    "street": "Lopez Rd",
    "city": "Lopez",
    "zip": 98261,
    "concatenated_address": "452 Lopez Rd, Lopez",
    "address": "452 Lopez Road, Lopez"
  },
  {
    "id": 3337,
    "financing": "Federally subsidized",
    "building_name": "Westview Villa",
    "latitude": 47.200556,
    "longitude": -120.95719,
    "original_address": "400 Denny Ave",
    "building_number": 400,
    "street": "Denny Ave",
    "city": "Cle Elum",
    "zip": 98922,
    "concatenated_address": "400 Denny Ave, Cle Elum",
    "address": "400 Denny Ave., Cle Elum"
  },
  {
    "id": 3338,
    "financing": "Federally subsidized",
    "building_name": "Westwind Manor",
    "latitude": 46.34573,
    "longitude": -124.05701,
    "original_address": "301 Sid Snyder Dr. W.",
    "building_number": 301,
    "street": "Sid Snyder Dr W",
    "city": "Long Beach",
    "zip": 98631,
    "concatenated_address": "301 Sid Snyder Dr W, Long Beach",
    "address": "301 Sid Snyder Dr W., Long Beach"
  },
  {
    "id": 3339,
    "financing": "Federally subsidized",
    "building_name": "Westwood Heights East",
    "latitude": 47.518023,
    "longitude": -122.36698,
    "original_address": "9440 27th Avenue Sw",
    "building_number": 9440,
    "street": "27th Ave SW",
    "city": "Seattle",
    "zip": 98126,
    "concatenated_address": "9440 27th Ave SW, Seattle",
    "address": "9440 27th Ave. S.W., Seattle"
  },
  {
    "id": 3340,
    "financing": "Federally subsidized",
    "building_name": "Wheatland Apartments",
    "latitude": 47.227679,
    "longitude": -117.0698,
    "original_address": "320 E Alder",
    "building_number": 320,
    "street": "Alder St",
    "city": "Tekoa",
    "zip": 99033,
    "concatenated_address": "320 Alder St, Tekoa",
    "address": "320 Alder St., Tekoa"
  },
  {
    "id": 3341,
    "financing": "Federally subsidized",
    "building_name": "Wheatlands",
    "latitude": 46.654821,
    "longitude": -118.85914,
    "original_address": "661 S Burke Ave.",
    "building_number": 661,
    "street": "S Burke Ave",
    "city": "Connell",
    "zip": 99326,
    "concatenated_address": "661 S Burke Ave, Connell",
    "address": "661 S. Burke Ave., Connell"
  },
  {
    "id": 3342,
    "financing": "Federally subsidized",
    "building_name": "Whispering Pines Apartments",
    "latitude": 47.834325,
    "longitude": -122.30337,
    "original_address": "18201 52nd Avenue W",
    "building_number": 18201,
    "street": "52nd Ave W",
    "city": "Lynnwood",
    "zip": 98037,
    "concatenated_address": "18201 52nd Ave W, Lynnwood",
    "address": "18201 52nd Ave. W., Lynnwood"
  },
  {
    "id": 3343,
    "financing": "Federally subsidized",
    "building_name": "Whispering Rivers Apartments",
    "latitude": 48.362462,
    "longitude": -120.11813,
    "original_address": "209 Canyon St",
    "building_number": 209,
    "street": "Canyon St",
    "city": "Twisp",
    "zip": 98856,
    "concatenated_address": "209 Canyon St, Twisp",
    "address": "209 Canyon St., Twisp"
  },
  {
    "id": 3344,
    "financing": "Federally subsidized",
    "building_name": "Whisperwood Apartments",
    "latitude": 47.495902,
    "longitude": -122.29706,
    "original_address": "11844 26th Avenue S",
    "building_number": 11844,
    "street": "26th Ave S",
    "city": "Seattle",
    "zip": "98168-5208",
    "concatenated_address": "11844 26th Ave S, Seattle",
    "address": "11844 26th Ave. S., Seattle"
  },
  {
    "id": 3345,
    "financing": "Federally subsidized",
    "building_name": "White River Apartments",
    "latitude": 47.280942,
    "longitude": -122.21137,
    "original_address": "1301 31st Street Se",
    "building_number": 1301,
    "street": "31st St SE",
    "city": "Auburn",
    "zip": 98002,
    "concatenated_address": "1301 31st St SE, Auburn",
    "address": "1301 31st St. S.E., Auburn"
  },
  {
    "id": 3346,
    "financing": "Federally subsidized",
    "building_name": "White River Garden",
    "latitude": 47.307677,
    "longitude": -122.22648,
    "original_address": "205 East Main Street",
    "building_number": 205,
    "street": "E Main St",
    "city": "Auburn",
    "zip": 98002,
    "concatenated_address": "205 E Main St, Auburn",
    "address": "205 E. Main St., Auburn"
  },
  {
    "id": 3347,
    "financing": "Federally subsidized",
    "building_name": "White River Senior Housing",
    "latitude": 47.157716,
    "longitude": -122.02495,
    "original_address": "420 Spiketon Road",
    "building_number": 420,
    "street": "Spiketon Rd",
    "city": "Buckley",
    "zip": 98321,
    "concatenated_address": "420 Spiketon Rd, Buckley",
    "address": "420 Spiketon Road, Buckley"
  },
  {
    "id": 3348,
    "financing": "Federally subsidized",
    "building_name": "Whitehorse Apartments",
    "latitude": 48.246924,
    "longitude": -121.60108,
    "original_address": "555 Elwell Ave",
    "building_number": 555,
    "street": "Elwell Ave",
    "city": "Darrington",
    "zip": 98241,
    "concatenated_address": "555 Elwell Ave, Darrington",
    "address": "555 Elwell Ave., Darrington"
  },
  {
    "id": 3349,
    "financing": "Federally subsidized",
    "building_name": "Whitman Court",
    "latitude": 46.075657,
    "longitude": -118.30841,
    "original_address": "305 Ash Street",
    "building_number": 305,
    "street": "Ash St",
    "city": "Walla Walla",
    "zip": 99362,
    "concatenated_address": "305 Ash St, Walla Walla",
    "address": "305 Ash St., Walla Walla"
  },
  {
    "id": 3350,
    "financing": "Federally subsidized",
    "building_name": "Whitman Street",
    "latitude": 46.061126,
    "longitude": -118.33268,
    "original_address": "104 Whitman Street",
    "building_number": 104,
    "street": "Whitman St",
    "city": "Walla Walla",
    "zip": 99362,
    "concatenated_address": "104 Whitman St, Walla Walla",
    "address": "104 Whitman St., Walla Walla"
  },
  {
    "id": 3351,
    "financing": "Federally subsidized",
    "building_name": "Wiggums Park Place",
    "latitude": 48.001502,
    "longitude": -122.19452,
    "original_address": "2703 12th Street",
    "building_number": 2703,
    "street": "12th St",
    "city": "Everett",
    "zip": 98201,
    "concatenated_address": "2703 12th St, Everett",
    "address": "2703 12th St., Everett"
  },
  {
    "id": 3352,
    "financing": "Federally subsidized",
    "building_name": "Wilbur Manor",
    "latitude": 46.070007,
    "longitude": -118.30409,
    "original_address": "135 S Wilbur Ave",
    "building_number": 135,
    "street": "S Wilbur Ave",
    "city": "Walla Walla",
    "zip": 99362,
    "concatenated_address": "135 S Wilbur Ave, Walla Walla",
    "address": "135 S. Wilbur Ave., Walla Walla"
  },
  {
    "id": 3353,
    "financing": "Federally subsidized",
    "building_name": "Wildwood Court",
    "latitude": 47.605159,
    "longitude": -122.20296,
    "original_address": "436 102nd Avenue Se",
    "building_number": 436,
    "street": "102nd Ave SE",
    "city": "Bellevue",
    "zip": 98004,
    "concatenated_address": "436 102nd Ave SE, Bellevue",
    "address": "436 102nd Ave. S.E., Bellevue"
  },
  {
    "id": 3354,
    "financing": "Federally subsidized",
    "building_name": "Willamette Court Apartments",
    "latitude": 47.319085,
    "longitude": -122.30339,
    "original_address": "31580 23rd Avenue S",
    "building_number": 31580,
    "street": "23rd Ave S",
    "city": "Federal Way",
    "zip": 98003,
    "concatenated_address": "31580 23rd Ave S, Federal Way",
    "address": "31580 23rd Ave. S., Federal Way"
  },
  {
    "id": 3355,
    "financing": "Federally subsidized",
    "building_name": "Willapa Landing Apartments",
    "latitude": 46.663178,
    "longitude": -123.81615,
    "original_address": "506 Willapa Avenue",
    "building_number": 506,
    "street": "Willapa Ave",
    "city": "South Bend",
    "zip": 98586,
    "concatenated_address": "506 Willapa Ave, South Bend",
    "address": "506 Willapa Ave., South Bend"
  },
  {
    "id": 3356,
    "financing": "Federally subsidized",
    "building_name": "William J. Wood Veterans House",
    "latitude": 47.338423,
    "longitude": -122.31181,
    "original_address": "29404 Pacific Highway South",
    "building_number": 29404,
    "street": "Pacific Hwy S",
    "city": "Federal Way",
    "zip": 98003,
    "concatenated_address": "29404 Pacific Hwy S, Federal Way",
    "address": "29404 Pacific Highway S., Federal Way"
  },
  {
    "id": 3357,
    "financing": "Federally subsidized",
    "building_name": "Williams Apartments",
    "latitude": 47.619922,
    "longitude": -122.33185,
    "original_address": "223 Pontius Avenue N",
    "building_number": 223,
    "street": "Pontius Ave N",
    "city": "Seattle",
    "zip": 98109,
    "concatenated_address": "223 Pontius Ave N, Seattle",
    "address": "223 Pontius Ave. N., Seattle"
  },
  {
    "id": 3358,
    "financing": "Federally subsidized",
    "building_name": "Willow Creek Apartments",
    "latitude": 48.751676,
    "longitude": -122.46147,
    "original_address": "1040 Fraser St",
    "building_number": 1040,
    "street": "Fraser St",
    "city": "Bellingham",
    "zip": 98229,
    "concatenated_address": "1040 Fraser St, Bellingham",
    "address": "1040 Fraser St., Bellingham"
  },
  {
    "id": 3359,
    "financing": "Federally subsidized",
    "building_name": "Willow Glen",
    "latitude": 48.175832,
    "longitude": -117.06409,
    "original_address": "1600 W. 7th St.",
    "building_number": 1600,
    "street": "W 7th St",
    "city": "Newport",
    "zip": 99156,
    "concatenated_address": "1600 W 7th St, Newport",
    "address": "1600 W. 7th St., Newport"
  },
  {
    "id": 3360,
    "financing": "Federally subsidized",
    "building_name": "Willow Glen Senior Apartments",
    "latitude": 47.156616,
    "longitude": -122.03268,
    "original_address": "380 Ryan Road #21",
    "building_number": 380,
    "street": "Ryan Rd",
    "city": "Buckley",
    "zip": 98321,
    "concatenated_address": "380 Ryan Rd, Buckley",
    "address": "380 Ryan Road, Buckley"
  },
  {
    "id": 3361,
    "financing": "Federally subsidized",
    "building_name": "Willow Park",
    "latitude": 46.31451,
    "longitude": -120.00893,
    "original_address": "1328 Saul Rd.",
    "building_number": 1328,
    "street": "Saul Rd",
    "city": "Sunnyside",
    "zip": 98944,
    "concatenated_address": "1328 Saul Rd, Sunnyside",
    "address": "1328 Saul Road, Sunnyside"
  },
  {
    "id": 3362,
    "financing": "Federally subsidized",
    "building_name": "Willow Tree Grove",
    "latitude": 47.810739,
    "longitude": -122.2047,
    "original_address": "2129 Maltby Rd",
    "building_number": 2129,
    "street": "Maltby Rd",
    "city": "Bothell",
    "zip": 98012,
    "concatenated_address": "2129 Maltby Rd, Bothell",
    "address": "2129 Maltby Road, Bothell"
  },
  {
    "id": 3363,
    "financing": "Federally subsidized",
    "building_name": "Willow Tree Grove",
    "latitude": 47.599866,
    "longitude": -122.32875,
    "original_address": "308 Fourth Avenue South",
    "building_number": 308,
    "street": "4th Ave S",
    "city": "Seattle",
    "zip": 98104,
    "concatenated_address": "308 4th Ave S, Seattle",
    "address": "308 4th Ave. S., Seattle"
  },
  {
    "id": 3364,
    "financing": "Federally subsidized",
    "building_name": "Willows",
    "latitude": 46.596673,
    "longitude": -120.53385,
    "original_address": "718 N Sixth Ave",
    "building_number": "",
    "street": "",
    "city": "Yakima",
    "zip": 98902,
    "concatenated_address": "718 N Sixth Ave, Yakima",
    "address": "718 N. Sixth Ave., Yakima"
  },
  {
    "id": 3365,
    "financing": "Federally subsidized",
    "building_name": "Willows Annex",
    "latitude": 46.610386,
    "longitude": -120.51955,
    "original_address": "608 Willow Street",
    "building_number": 608,
    "street": "Willow St",
    "city": "Yakima",
    "zip": "98902-6913",
    "concatenated_address": "608 Willow St, Yakima",
    "address": "608 Willow St., Yakima"
  },
  {
    "id": 3366,
    "financing": "Federally subsidized",
    "building_name": "Wilson Hotel Housing",
    "latitude": 48.5151,
    "longitude": -122.6127,
    "original_address": "806 Commercial Avenue",
    "building_number": 806,
    "street": "Commercial Ave",
    "city": "Anacortes",
    "zip": 98221,
    "concatenated_address": "806 Commercial Ave, Anacortes",
    "address": "806 Commercial Ave., Anacortes"
  },
  {
    "id": 3367,
    "financing": "Federally subsidized",
    "building_name": "Windham Apartments",
    "latitude": 47.615135,
    "longitude": -122.34223,
    "original_address": "420 Blanchard St",
    "building_number": 420,
    "street": "Blanchard St",
    "city": "Seattle",
    "zip": 98121,
    "concatenated_address": "420 Blanchard St, Seattle",
    "address": "420 Blanchard St., Seattle"
  },
  {
    "id": 3368,
    "financing": "Federally subsidized",
    "building_name": "Windsong Apartments",
    "latitude": 47.74332,
    "longitude": -122.65393,
    "original_address": "19880 3rd Avenue Nw",
    "building_number": 19880,
    "street": "3rd Ave NW",
    "city": "Poulsbo",
    "zip": 98370,
    "concatenated_address": "19880 3rd Ave NW, Poulsbo",
    "address": "19880 3rd Ave. N.W., Poulsbo"
  },
  {
    "id": 3369,
    "financing": "Federally subsidized",
    "building_name": "Windsor Heights",
    "latitude": 47.448519,
    "longitude": -122.29231,
    "original_address": "17223 32nd Avenue South",
    "building_number": 17223,
    "street": "32nd Ave S",
    "city": "Seattle",
    "zip": "98188-4409",
    "concatenated_address": "17223 32nd Ave S, Seattle",
    "address": "17223 32nd Ave. S., Seattle"
  },
  {
    "id": 3370,
    "financing": "Federally subsidized",
    "building_name": "Windsor Park Apartments",
    "latitude": 46.98727,
    "longitude": -120.54294,
    "original_address": "401 E Cherry Lane",
    "building_number": 401,
    "street": "E Cherry Ln",
    "city": "Ellensburg",
    "zip": 98926,
    "concatenated_address": "401 E Cherry Ln, Ellensburg",
    "address": "401 E. Cherry Lane, Ellensburg"
  },
  {
    "id": 3371,
    "financing": "Federally subsidized",
    "building_name": "Windsor Square Senior",
    "latitude": 48.085162,
    "longitude": -122.16691,
    "original_address": "9912 48th Dr Ne",
    "building_number": 9912,
    "street": "48th Dr NE",
    "city": "Marysville",
    "zip": 98270,
    "concatenated_address": "9912 48th Dr NE, Marysville",
    "address": "9912 48th Dr N.E., Marysville"
  },
  {
    "id": 3372,
    "financing": "Federally subsidized",
    "building_name": "Windstone Apartments",
    "latitude": 47.882531,
    "longitude": -122.24766,
    "original_address": "1011 128th Street Sw",
    "building_number": 1011,
    "street": "128th St SW",
    "city": "Everett",
    "zip": "98204-6377",
    "concatenated_address": "1011 128th St SW, Everett",
    "address": "1011 128th St. S.W., Everett"
  },
  {
    "id": 3373,
    "financing": "Federally subsidized",
    "building_name": "Winterhill Apartments",
    "latitude": 48.05306,
    "longitude": -122.147,
    "original_address": "6110 64th Street",
    "building_number": 6110,
    "street": "64th St",
    "city": "Marysville",
    "zip": "98270-4833",
    "concatenated_address": "6110 64th St, Marysville",
    "address": "6110 64th St., Marysville"
  },
  {
    "id": 3374,
    "financing": "Federally subsidized",
    "building_name": "Winton Woods I",
    "latitude": 47.745223,
    "longitude": -122.65874,
    "original_address": "20043 Winton Lane Nw",
    "building_number": 20043,
    "street": "Winton Ln NW",
    "city": "Poulsbo",
    "zip": 98370,
    "concatenated_address": "20043 Winton Ln NW, Poulsbo",
    "address": "20043 Winton Lane N.W., Poulsbo"
  },
  {
    "id": 3375,
    "financing": "Federally subsidized",
    "building_name": "Winton Woods Phase Ii",
    "latitude": 47.745749,
    "longitude": -122.65818,
    "original_address": "890 Winton Lane Nw",
    "building_number": 890,
    "street": "Winton Ln NW",
    "city": "Poulsbo",
    "zip": 98370,
    "concatenated_address": "890 Winton Ln NW, Poulsbo",
    "address": "890 Winton Lane N.W., Poulsbo"
  },
  {
    "id": 3376,
    "financing": "Federally subsidized",
    "building_name": "Wintonia Hotel",
    "latitude": 47.613605,
    "longitude": -122.32785,
    "original_address": "1431 Minor Ave",
    "building_number": 1431,
    "street": "Minor Ave",
    "city": "Seattle",
    "zip": 98101,
    "concatenated_address": "1431 Minor Ave, Seattle",
    "address": "1431 Minor Ave., Seattle"
  },
  {
    "id": 3377,
    "financing": "Federally subsidized",
    "building_name": "Wintonia Hotel",
    "latitude": 47.366823,
    "longitude": -122.22629,
    "original_address": "1406 Maple Lane South",
    "building_number": 1406,
    "street": "Maple Ln",
    "city": "Kent",
    "zip": 98032,
    "concatenated_address": "1406 Maple Ln, Kent",
    "address": "1406 Maple Lane, Kent"
  },
  {
    "id": 3378,
    "financing": "Federally subsidized",
    "building_name": "Wishing Well I Apartments",
    "latitude": 48.074117,
    "longitude": -122.17241,
    "original_address": "4300 88th Street Ne",
    "building_number": 4300,
    "street": "88th St NE",
    "city": "Marysville",
    "zip": 98270,
    "concatenated_address": "4300 88th St NE, Marysville",
    "address": "4300 88th St. N.E., Marysville"
  },
  {
    "id": 3379,
    "financing": "Federally subsidized",
    "building_name": "Wisteria Manor",
    "latitude": 45.615558,
    "longitude": -122.50855,
    "original_address": "15911 Se Mill Plain Boulevard",
    "building_number": 15911,
    "street": "SE Mill Plain Blvd",
    "city": "Vancouver",
    "zip": 98684,
    "concatenated_address": "15911 SE Mill Plain Blvd, Vancouver",
    "address": "15911 S.E. Mill Plain Blvd., Vancouver"
  },
  {
    "id": 3380,
    "financing": "Federally subsidized",
    "building_name": "Wisteria Walk Apartments",
    "latitude": 47.157322,
    "longitude": -122.48517,
    "original_address": "3615 - 112th Street Sw",
    "building_number": 3615,
    "street": "112th St SW",
    "city": "Lakewood",
    "zip": "98499-4657",
    "concatenated_address": "3615 112th St SW, Lakewood",
    "address": "3615 112th St. S.W., Lakewood"
  },
  {
    "id": 3381,
    "financing": "Federally subsidized",
    "building_name": "Woodgate Apartments",
    "latitude": 48.472189,
    "longitude": -122.33949,
    "original_address": "308 Woodgate Place",
    "building_number": 308,
    "street": "Woodgate Pl",
    "city": "Burlington",
    "zip": 98233,
    "concatenated_address": "308 Woodgate Pl, Burlington",
    "address": "308 Woodgate Place, Burlington"
  },
  {
    "id": 3382,
    "financing": "Federally subsidized",
    "building_name": "Woodhaven",
    "latitude": 48.607344,
    "longitude": -118.06174,
    "original_address": "465 West 6th Ave",
    "building_number": 465,
    "street": "W 6th Ave",
    "city": "Kettle Falls",
    "zip": 99141,
    "concatenated_address": "465 W 6th Ave, Kettle Falls",
    "address": "465 W. 6th Ave., Kettle Falls"
  },
  {
    "id": 3383,
    "financing": "Federally subsidized",
    "building_name": "Woodhaven Apartments",
    "latitude": 47.769537,
    "longitude": -117.4231,
    "original_address": "12424 N Fairwood Dr",
    "building_number": 12424,
    "street": "N Fairwood Dr",
    "city": "Spokane",
    "zip": 99218,
    "concatenated_address": "12424 N Fairwood Dr, Spokane",
    "address": "12424 N. Fairwood Drive, Spokane"
  },
  {
    "id": 3384,
    "financing": "Federally subsidized",
    "building_name": "Woodlake Apartments",
    "latitude": 47.927675,
    "longitude": -122.09564,
    "original_address": "1120 13Th Street",
    "building_number": 1120,
    "street": "13th St",
    "city": "Snohomish",
    "zip": 98290,
    "concatenated_address": "1120 13th St, Snohomish",
    "address": "1120 13th St., Snohomish"
  },
  {
    "id": 3385,
    "financing": "Federally subsidized",
    "building_name": "Woodlake Manor Apartments",
    "latitude": 47.71248,
    "longitude": -122.34181,
    "original_address": "11500 Stone Avenue N",
    "building_number": 11500,
    "street": "Stone Ave N",
    "city": "Seattle",
    "zip": 98133,
    "concatenated_address": "11500 Stone Ave N, Seattle",
    "address": "11500 Stone Ave. N., Seattle"
  },
  {
    "id": 3386,
    "financing": "Federally subsidized",
    "building_name": "Woodlake Manor I & II",
    "latitude": 47.928433,
    "longitude": -122.09436,
    "original_address": "1018 13Th Street",
    "building_number": 1018,
    "street": "13th St",
    "city": "Snohomish",
    "zip": 98290,
    "concatenated_address": "1018 13th St, Snohomish",
    "address": "1018 13th St., Snohomish"
  },
  {
    "id": 3387,
    "financing": "Federally subsidized",
    "building_name": "Woodland Greens",
    "latitude": 47.819668,
    "longitude": -122.29915,
    "original_address": "19801 50th Ave. W",
    "building_number": 19801,
    "street": "50th Ave W",
    "city": "Lynnwood",
    "zip": "98036-6416",
    "concatenated_address": "19801 50th Ave W, Lynnwood",
    "address": "19801 50th Ave. W., Lynnwood"
  },
  {
    "id": 3388,
    "financing": "Federally subsidized",
    "building_name": "Woodland II Family Housing",
    "latitude": 45.896425,
    "longitude": -122.75383,
    "original_address": "133-139 S Pekin Rd",
    "building_number": 133,
    "street": "S Pekin Rd",
    "city": "Woodland",
    "zip": 98674,
    "concatenated_address": "133 S Pekin Rd, Woodland",
    "address": "133 S. Pekin Road, Woodland"
  },
  {
    "id": 3389,
    "financing": "Federally subsidized",
    "building_name": "Woodland Meadows",
    "latitude": 45.91758,
    "longitude": -122.73856,
    "original_address": "130 Hillshire Street",
    "building_number": "",
    "street": "Hillshire Dr",
    "city": "Woodland",
    "zip": 98674,
    "concatenated_address": "130 Hillshire Street, Woodland",
    "address": "130 Hillshire St., Woodland"
  },
  {
    "id": 3390,
    "financing": "Federally subsidized",
    "building_name": "Woodlands At Forbes Lake",
    "latitude": 47.684285,
    "longitude": -122.1821,
    "original_address": "9224 Slater Avenue Ne",
    "building_number": 9224,
    "street": "Slater Ave NE",
    "city": "Kirkland",
    "zip": "98033-5824",
    "concatenated_address": "9224 Slater Ave NE, Kirkland",
    "address": "9224 Slater Ave. N.E., Kirkland"
  },
  {
    "id": 3391,
    "financing": "Federally subsidized",
    "building_name": "Woodmark Apartments",
    "latitude": 47.171357,
    "longitude": -122.46886,
    "original_address": "2425 South 96th St",
    "building_number": 2425,
    "street": "96th St S",
    "city": "Tacoma",
    "zip": 98444,
    "concatenated_address": "2425 96th St S, Tacoma",
    "address": "2425 96th St. S., Tacoma"
  },
  {
    "id": 3392,
    "financing": "Federally subsidized",
    "building_name": "Woodridge Park",
    "latitude": 47.492627,
    "longitude": -122.29592,
    "original_address": "12400 28th Ave. S.",
    "building_number": 12400,
    "street": "28th Ave S",
    "city": "Seattle",
    "zip": 98168,
    "concatenated_address": "12400 28th Ave S, Seattle",
    "address": "12400 28th Ave. S., Seattle"
  },
  {
    "id": 3393,
    "financing": "Federally subsidized",
    "building_name": "Woodrose Apartments",
    "latitude": 48.775653,
    "longitude": -122.45385,
    "original_address": "3303-3353 Racine Street",
    "building_number": 3353,
    "street": "Racine St",
    "city": "Bellingham",
    "zip": "98226-6615",
    "concatenated_address": "3353 Racine St, Bellingham",
    "address": "3353 Racine St., Bellingham"
  },
  {
    "id": 3394,
    "financing": "Federally subsidized",
    "building_name": "Woodruff Heights Phase I",
    "latitude": 47.629296,
    "longitude": -117.25466,
    "original_address": "9815 E Sixth Ave",
    "building_number": "",
    "street": "",
    "city": "Spokane Valley",
    "zip": 99206,
    "concatenated_address": "9815 E Sixth Ave, Spokane Valley",
    "address": "9815 E. Sixth Ave., Spokane Valley"
  },
  {
    "id": 3395,
    "financing": "Federally subsidized",
    "building_name": "Woodsvilla Apartments",
    "latitude": 47.008868,
    "longitude": -123.39002,
    "original_address": "1015 Oakhurst Drive",
    "building_number": 1015,
    "street": "Oakhurst Dr",
    "city": "Elma",
    "zip": 98541,
    "concatenated_address": "1015 Oakhurst Dr, Elma",
    "address": "1015 Oakhurst Drive, Elma"
  },
  {
    "id": 3396,
    "financing": "Federally subsidized",
    "building_name": "Wright Park House",
    "latitude": 47.25962,
    "longitude": -122.44709,
    "original_address": "401 South G Street",
    "building_number": 401,
    "street": "S G St",
    "city": "Tacoma",
    "zip": 98405,
    "concatenated_address": "401 S G St, Tacoma",
    "address": "401 S. G St., Tacoma"
  },
  {
    "id": 3397,
    "financing": "Federally subsidized",
    "building_name": "Yakima Affordable Housing",
    "latitude": 46.597918,
    "longitude": -120.55795,
    "original_address": "15 North 37th Ave",
    "building_number": 15,
    "street": "N 37th Ave",
    "city": "Yakima",
    "zip": "98902-2774",
    "concatenated_address": "15 N 37th Ave, Yakima",
    "address": "15 N. 37th Ave., Yakima"
  },
  {
    "id": 3398,
    "financing": "Federally subsidized",
    "building_name": "Yakima Family Housing",
    "latitude": 46.587921,
    "longitude": -120.49041,
    "original_address": "1212 S 9th St",
    "building_number": 1212,
    "street": "S 9th St",
    "city": "Yakima",
    "zip": 98901,
    "concatenated_address": "1212 S 9th St, Yakima",
    "address": "1212 S. 9th St., Yakima"
  },
  {
    "id": 3399,
    "financing": "Federally subsidized",
    "building_name": "YMCA Building Project",
    "latitude": 47.60546,
    "longitude": -122.33279,
    "original_address": "909 Fourth Avenue",
    "building_number": 909,
    "street": "4th Ave",
    "city": "Seattle",
    "zip": 98104,
    "concatenated_address": "909 4th Ave, Seattle",
    "address": "909 4th Ave., Seattle"
  },
  {
    "id": 3400,
    "financing": "Federally subsidized",
    "building_name": "YNHA Tax Credit 1R",
    "latitude": 46.522398,
    "longitude": -120.50844,
    "original_address": "109 Adamsview",
    "building_number": "",
    "street": "",
    "city": "Wapato",
    "zip": 98951,
    "concatenated_address": "109 Adamsview, Wapato",
    "address": "109 Adamsview, Wapato"
  },
  {
    "id": 3401,
    "financing": "Federally subsidized",
    "building_name": "YNHA Tax Credit 2R",
    "latitude": 46.522398,
    "longitude": -120.50844,
    "original_address": "3 Marty S Lane",
    "building_number": "",
    "street": "",
    "city": "Wapato",
    "zip": 98951,
    "concatenated_address": "3 Marty S Lane, Wapato",
    "address": "3 Marty S. Drive, Wapato"
  },
  {
    "id": 3402,
    "financing": "Federally subsidized",
    "building_name": "YNHA Tax Credit 6",
    "latitude": 46.443733,
    "longitude": -120.41584,
    "original_address": "Larena Lane And S Camas Ave",
    "building_number": "",
    "street": "Larena Ln",
    "city": "Wapato",
    "zip": 98951,
    "concatenated_address": "Larena Lane And S Camas Ave, Wapato",
    "address": "Larena Lane and S. Camas Ave., Wapato"
  },
  {
    "id": 3403,
    "financing": "Federally subsidized",
    "building_name": "YWCA Family Village",
    "latitude": 47.674707,
    "longitude": -122.1187,
    "original_address": "16601 Ne 80th St.",
    "building_number": 16601,
    "street": "NE 80th St",
    "city": "Redmond",
    "zip": 98052,
    "concatenated_address": "16601 NE 80th St, Redmond",
    "address": "16601 N.E. 80th St., Redmond"
  },
  {
    "id": 3404,
    "financing": "Federally subsidized",
    "building_name": "YWCA Family Village At Issaquah - Phase I",
    "latitude": 47.544758,
    "longitude": -122.01863,
    "original_address": "930 Ne High Street",
    "building_number": 930,
    "street": "NE High St",
    "city": "Issaquah",
    "zip": 98027,
    "concatenated_address": "930 NE High St, Issaquah",
    "address": "930 N.E. High St., Issaquah"
  },
  {
    "id": 3405,
    "financing": "Federally subsidized",
    "building_name": "YWCA Family Village At Issaquah - Phase II",
    "latitude": 47.545131,
    "longitude": -122.01752,
    "original_address": "967 Ne Ingram Way",
    "building_number": 967,
    "street": "NE Ingram Way",
    "city": "Issaquah",
    "zip": 98027,
    "concatenated_address": "967 NE Ingram Way, Issaquah",
    "address": "967 N.E. Ingram Way, Issaquah"
  },
  {
    "id": 3406,
    "financing": "Federally subsidized",
    "building_name": "YWCA Opportunity Place",
    "latitude": 47.613149,
    "longitude": -122.34153,
    "original_address": "2024 Third Ave",
    "building_number": 2024,
    "street": "3rd Ave",
    "city": "Seattle",
    "zip": 98121,
    "concatenated_address": "2024 3rd Ave, Seattle",
    "address": "2024 3rd Ave., Seattle"
  },
  {
    "id": 3407,
    "financing": "Federally subsidized",
    "building_name": "YWCA Snohomish Portfolio",
    "latitude": 47.819948,
    "longitude": -122.32421,
    "original_address": "19703 68th Avenue W",
    "building_number": 19703,
    "street": "68th Ave W",
    "city": "Lynnwood",
    "zip": 98036,
    "concatenated_address": "19703 68th Ave W, Lynnwood",
    "address": "19703 68th Ave. W., Lynnwood"
  }
]